var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0f70"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0f70"] = parcelRequire;
}
parcelRequire.register("kw0CW", function(module, exports) {

module.exports = import("./" + (parcelRequire("ji6vK")).resolve("4tGuq")).then(()=>parcelRequire("eNVta"));

});

// This file is the browser's entry point for the JS bundle
// reflect-metadata allows for runtime reflection of types in JavaScript.
// It is needed for class-transformer to work and is imported as a side effect.
// The library replaces the Reflect API on the window to support more features.
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $af3c45bd2500a6a9$exports = {};
// shim for using process in browser
var $af3c45bd2500a6a9$var$process = $af3c45bd2500a6a9$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $af3c45bd2500a6a9$var$cachedSetTimeout;
var $af3c45bd2500a6a9$var$cachedClearTimeout;
function $af3c45bd2500a6a9$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $af3c45bd2500a6a9$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $af3c45bd2500a6a9$var$cachedSetTimeout = setTimeout;
        else $af3c45bd2500a6a9$var$cachedSetTimeout = $af3c45bd2500a6a9$var$defaultSetTimout;
    } catch (e) {
        $af3c45bd2500a6a9$var$cachedSetTimeout = $af3c45bd2500a6a9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $af3c45bd2500a6a9$var$cachedClearTimeout = clearTimeout;
        else $af3c45bd2500a6a9$var$cachedClearTimeout = $af3c45bd2500a6a9$var$defaultClearTimeout;
    } catch (e) {
        $af3c45bd2500a6a9$var$cachedClearTimeout = $af3c45bd2500a6a9$var$defaultClearTimeout;
    }
})();
function $af3c45bd2500a6a9$var$runTimeout(fun) {
    if ($af3c45bd2500a6a9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($af3c45bd2500a6a9$var$cachedSetTimeout === $af3c45bd2500a6a9$var$defaultSetTimout || !$af3c45bd2500a6a9$var$cachedSetTimeout) && setTimeout) {
        $af3c45bd2500a6a9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $af3c45bd2500a6a9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $af3c45bd2500a6a9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $af3c45bd2500a6a9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $af3c45bd2500a6a9$var$runClearTimeout(marker) {
    if ($af3c45bd2500a6a9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($af3c45bd2500a6a9$var$cachedClearTimeout === $af3c45bd2500a6a9$var$defaultClearTimeout || !$af3c45bd2500a6a9$var$cachedClearTimeout) && clearTimeout) {
        $af3c45bd2500a6a9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $af3c45bd2500a6a9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $af3c45bd2500a6a9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $af3c45bd2500a6a9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $af3c45bd2500a6a9$var$queue = [];
var $af3c45bd2500a6a9$var$draining = false;
var $af3c45bd2500a6a9$var$currentQueue;
var $af3c45bd2500a6a9$var$queueIndex = -1;
function $af3c45bd2500a6a9$var$cleanUpNextTick() {
    if (!$af3c45bd2500a6a9$var$draining || !$af3c45bd2500a6a9$var$currentQueue) return;
    $af3c45bd2500a6a9$var$draining = false;
    if ($af3c45bd2500a6a9$var$currentQueue.length) $af3c45bd2500a6a9$var$queue = $af3c45bd2500a6a9$var$currentQueue.concat($af3c45bd2500a6a9$var$queue);
    else $af3c45bd2500a6a9$var$queueIndex = -1;
    if ($af3c45bd2500a6a9$var$queue.length) $af3c45bd2500a6a9$var$drainQueue();
}
function $af3c45bd2500a6a9$var$drainQueue() {
    if ($af3c45bd2500a6a9$var$draining) return;
    var timeout = $af3c45bd2500a6a9$var$runTimeout($af3c45bd2500a6a9$var$cleanUpNextTick);
    $af3c45bd2500a6a9$var$draining = true;
    var len = $af3c45bd2500a6a9$var$queue.length;
    while(len){
        $af3c45bd2500a6a9$var$currentQueue = $af3c45bd2500a6a9$var$queue;
        $af3c45bd2500a6a9$var$queue = [];
        while(++$af3c45bd2500a6a9$var$queueIndex < len)if ($af3c45bd2500a6a9$var$currentQueue) $af3c45bd2500a6a9$var$currentQueue[$af3c45bd2500a6a9$var$queueIndex].run();
        $af3c45bd2500a6a9$var$queueIndex = -1;
        len = $af3c45bd2500a6a9$var$queue.length;
    }
    $af3c45bd2500a6a9$var$currentQueue = null;
    $af3c45bd2500a6a9$var$draining = false;
    $af3c45bd2500a6a9$var$runClearTimeout(timeout);
}
$af3c45bd2500a6a9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $af3c45bd2500a6a9$var$queue.push(new $af3c45bd2500a6a9$var$Item(fun, args));
    if ($af3c45bd2500a6a9$var$queue.length === 1 && !$af3c45bd2500a6a9$var$draining) $af3c45bd2500a6a9$var$runTimeout($af3c45bd2500a6a9$var$drainQueue);
};
// v8 likes predictible objects
function $af3c45bd2500a6a9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$af3c45bd2500a6a9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$af3c45bd2500a6a9$var$process.title = "browser";
$af3c45bd2500a6a9$var$process.browser = true;
$af3c45bd2500a6a9$var$process.env = {};
$af3c45bd2500a6a9$var$process.argv = [];
$af3c45bd2500a6a9$var$process.version = ""; // empty string to avoid regexp issues
$af3c45bd2500a6a9$var$process.versions = {};
function $af3c45bd2500a6a9$var$noop() {}
$af3c45bd2500a6a9$var$process.on = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.addListener = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.once = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.off = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.removeListener = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.removeAllListeners = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.emit = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.prependListener = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.prependOnceListener = $af3c45bd2500a6a9$var$noop;
$af3c45bd2500a6a9$var$process.listeners = function(name) {
    return [];
};
$af3c45bd2500a6a9$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$af3c45bd2500a6a9$var$process.cwd = function() {
    return "/";
};
$af3c45bd2500a6a9$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$af3c45bd2500a6a9$var$process.umask = function() {
    return 0;
};


var $1ff370830ab8cf83$var$Reflect;
(function(Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function(factory) {
        var root = typeof $parcel$global === "object" ? $parcel$global : typeof self === "object" ? self : typeof this === "object" ? this : Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") root.Reflect = Reflect;
        else exporter = makeExporter(root.Reflect, exporter);
        factory(exporter);
        function makeExporter(target, previous) {
            return function(key, value) {
                if (typeof target[key] !== "function") Object.defineProperty(target, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                if (previous) previous(key, value);
            };
        }
    })(function(exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = ({
            __proto__: []
        }) instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate ? function() {
                return MakeDictionary(Object.create(null));
            } : supportsProto ? function() {
                return MakeDictionary({
                    __proto__: null
                });
            } : function() {
                return MakeDictionary({});
            },
            has: downLevel ? function(map, key) {
                return hasOwn.call(map, key);
            } : function(map, key) {
                return key in map;
            },
            get: downLevel ? function(map, key) {
                return hasOwn.call(map, key) ? map[key] : undefined;
            } : function(map, key) {
                return map[key];
            }
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof $af3c45bd2500a6a9$exports === "object" && $af3c45bd2500a6a9$exports.env && false;
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */ function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsObject(target)) throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes)) throw new TypeError();
                if (IsNull(attributes)) attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            } else {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsConstructor(target)) throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */ function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target)) throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey)) throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */ function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */ function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */ function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap)) return false;
            if (!metadataMap.delete(metadataKey)) return false;
            if (metadataMap.size > 0) return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0) return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated)) throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated)) throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create) return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create) return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null) return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0) return ownKeys;
            if (ownKeys.length <= 0) return parentKeys;
            var set = new _Set();
            var keys = [];
            for(var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++){
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for(var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++){
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while(true){
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                } catch (e) {
                    try {
                        IteratorClose(iterator);
                    } finally{
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null) return 1 /* Null */ ;
            switch(typeof x){
                case "undefined":
                    return 0 /* Undefined */ ;
                case "boolean":
                    return 2 /* Boolean */ ;
                case "string":
                    return 3 /* String */ ;
                case "symbol":
                    return 4 /* Symbol */ ;
                case "number":
                    return 5 /* Number */ ;
                case "object":
                    return x === null ? 1 /* Null */  : 6 /* Object */ ;
                default:
                    return 6 /* Object */ ;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch(Type(input)){
                case 0 /* Undefined */ :
                    return input;
                case 1 /* Null */ :
                    return input;
                case 2 /* Boolean */ :
                    return input;
                case 3 /* String */ :
                    return input;
                case 4 /* Symbol */ :
                    return input;
                case 5 /* Number */ :
                    return input;
            }
            var hint = PreferredType === 3 /* String */  ? "string" : PreferredType === 5 /* Number */  ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result)) throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result)) return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
            } else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result)) return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */ );
            if (IsSymbol(key)) return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch(Type(argument)){
                case 3 /* String */ :
                    return true;
                case 4 /* Symbol */ :
                    return true;
                default:
                    return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null) return undefined;
            if (!IsCallable(func)) throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method)) throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator)) throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f) f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype) return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype) return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype) return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function") return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O) return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ function() {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function() {
                    return this;
                };
                MapIterator.prototype[iteratorSymbol] = function() {
                    return this;
                };
                MapIterator.prototype.next = function() {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        } else this._index++;
                        return {
                            value: result,
                            done: false
                        };
                    }
                    return {
                        value: undefined,
                        done: true
                    };
                };
                MapIterator.prototype.throw = function(error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function(value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return {
                        value: value,
                        done: true
                    };
                };
                return MapIterator;
            }();
            return /** @class */ function() {
                function Map1() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map1.prototype, "size", {
                    get: function() {
                        return this._keys.length;
                    },
                    enumerable: true,
                    configurable: true
                });
                Map1.prototype.has = function(key) {
                    return this._find(key, /*insert*/ false) >= 0;
                };
                Map1.prototype.get = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map1.prototype.set = function(key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map1.prototype.delete = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for(var i = index + 1; i < size; i++){
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map1.prototype.clear = function() {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map1.prototype.keys = function() {
                    return new MapIterator(this._keys, this._values, getKey);
                };
                Map1.prototype.values = function() {
                    return new MapIterator(this._keys, this._values, getValue);
                };
                Map1.prototype.entries = function() {
                    return new MapIterator(this._keys, this._values, getEntry);
                };
                Map1.prototype["@@iterator"] = function() {
                    return this.entries();
                };
                Map1.prototype[iteratorSymbol] = function() {
                    return this.entries();
                };
                Map1.prototype._find = function(key, insert) {
                    if (this._cacheKey !== key) this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map1;
            }();
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [
                    key,
                    value
                ];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ function() {
                function Set1() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set1.prototype, "size", {
                    get: function() {
                        return this._map.size;
                    },
                    enumerable: true,
                    configurable: true
                });
                Set1.prototype.has = function(value) {
                    return this._map.has(value);
                };
                Set1.prototype.add = function(value) {
                    return this._map.set(value, value), this;
                };
                Set1.prototype.delete = function(value) {
                    return this._map.delete(value);
                };
                Set1.prototype.clear = function() {
                    this._map.clear();
                };
                Set1.prototype.keys = function() {
                    return this._map.keys();
                };
                Set1.prototype.values = function() {
                    return this._map.values();
                };
                Set1.prototype.entries = function() {
                    return this._map.entries();
                };
                Set1.prototype["@@iterator"] = function() {
                    return this.keys();
                };
                Set1.prototype[iteratorSymbol] = function() {
                    return this.keys();
                };
                return Set1;
            }();
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ function() {
                function WeakMap1() {
                    this._key = CreateUniqueKey();
                }
                WeakMap1.prototype.has = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap1.prototype.get = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap1.prototype.set = function(target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap1.prototype.delete = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap1.prototype.clear = function() {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap1;
            }();
            function CreateUniqueKey() {
                var key;
                do key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create) return undefined;
                    Object.defineProperty(target, rootKey, {
                        value: HashMap.create()
                    });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for(var i = 0; i < size; ++i)buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined") return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined") return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for(var offset = 0; offset < UUID_SIZE; ++offset){
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8) result += "-";
                    if (byte < 16) result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})($1ff370830ab8cf83$var$Reflect || ($1ff370830ab8cf83$var$Reflect = {}));


/* src/App.svelte generated by Svelte v3.58.0 */ function $1eb80e36873dc327$export$8793edee2d425525() {}
const $1eb80e36873dc327$export$f0954fd7d5368655 = (x)=>x;
function $1eb80e36873dc327$export$e6e34fd1f2686227(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return tar;
}
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function $1eb80e36873dc327$export$7666b03abe8479da(value) {
    return !!value && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
function $1eb80e36873dc327$export$8d162c0ddfac72(element, file, line, column, char) {
    element.__svelte_meta = {
        loc: {
            file: file,
            line: line,
            column: column,
            char: char
        }
    };
}
function $1eb80e36873dc327$export$889ea624f2cb2c57(fn) {
    return fn();
}
function $1eb80e36873dc327$export$31092919e374e43c() {
    return Object.create(null);
}
function $1eb80e36873dc327$export$3f1fcd837f99a9ab(fns) {
    fns.forEach($1eb80e36873dc327$export$889ea624f2cb2c57);
}
function $1eb80e36873dc327$export$b451353ebd749597(thing) {
    return typeof thing === "function";
}
function $1eb80e36873dc327$export$170eaf694b129a16(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === "object" || typeof a === "function";
}
let $1eb80e36873dc327$var$src_url_equal_anchor;
function $1eb80e36873dc327$export$49b3f9828235af7b(element_src, url) {
    if (!$1eb80e36873dc327$var$src_url_equal_anchor) $1eb80e36873dc327$var$src_url_equal_anchor = document.createElement("a");
    $1eb80e36873dc327$var$src_url_equal_anchor.href = url;
    return element_src === $1eb80e36873dc327$var$src_url_equal_anchor.href;
}
function $1eb80e36873dc327$export$22fbbf144bff5d00(a, b) {
    return a != a ? b == b : a !== b;
}
function $1eb80e36873dc327$export$cc2e736493e359e2(obj) {
    return Object.keys(obj).length === 0;
}
function $1eb80e36873dc327$export$e3d0b9f4796b296b(store, name) {
    if (store != null && typeof store.subscribe !== "function") throw new Error(`'${name}' is not a store with a 'subscribe' method`);
}
function $1eb80e36873dc327$export$ec068583843480e7(store, ...callbacks) {
    if (store == null) return $1eb80e36873dc327$export$8793edee2d425525;
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? ()=>unsub.unsubscribe() : unsub;
}
function $1eb80e36873dc327$export$def9168ec19d7707(store) {
    let value;
    $1eb80e36873dc327$export$ec068583843480e7(store, (_)=>value = _)();
    return value;
}
function $1eb80e36873dc327$export$e9b69a2eee9b6cbe(component, store, callback) {
    component.$$.on_destroy.push($1eb80e36873dc327$export$ec068583843480e7(store, callback));
}
function $1eb80e36873dc327$export$2d30ef90c9114b44(definition, ctx, $$scope, fn) {
    if (definition) {
        const slot_ctx = $1eb80e36873dc327$var$get_slot_context(definition, ctx, $$scope, fn);
        return definition[0](slot_ctx);
    }
}
function $1eb80e36873dc327$var$get_slot_context(definition, ctx, $$scope, fn) {
    return definition[1] && fn ? $1eb80e36873dc327$export$e6e34fd1f2686227($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function $1eb80e36873dc327$export$37743db7f61eb37b(definition, $$scope, dirty, fn) {
    if (definition[2] && fn) {
        const lets = definition[2](fn(dirty));
        if ($$scope.dirty === undefined) return lets;
        if (typeof lets === "object") {
            const merged = [];
            const len = Math.max($$scope.dirty.length, lets.length);
            for(let i = 0; i < len; i += 1)merged[i] = $$scope.dirty[i] | lets[i];
            return merged;
        }
        return $$scope.dirty | lets;
    }
    return $$scope.dirty;
}
function $1eb80e36873dc327$export$320f2dc7816567d9(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
    if (slot_changes) {
        const slot_context = $1eb80e36873dc327$var$get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
        slot.p(slot_context, slot_changes);
    }
}
function $1eb80e36873dc327$export$6f5c611fd589b77(slot, slot_definition, ctx, $$scope, dirty, get_slot_changes_fn, get_slot_context_fn) {
    const slot_changes = $1eb80e36873dc327$export$37743db7f61eb37b(slot_definition, $$scope, dirty, get_slot_changes_fn);
    $1eb80e36873dc327$export$320f2dc7816567d9(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn);
}
function $1eb80e36873dc327$export$a15c6a804dce25b7($$scope) {
    if ($$scope.ctx.length > 32) {
        const dirty = [];
        const length = $$scope.ctx.length / 32;
        for(let i = 0; i < length; i++)dirty[i] = -1;
        return dirty;
    }
    return -1;
}
function $1eb80e36873dc327$export$1b59c714eb8e4c9f(props) {
    const result = {};
    for(const k in props)if (k[0] !== "$") result[k] = props[k];
    return result;
}
function $1eb80e36873dc327$export$3086903c15858881(props, keys) {
    const rest = {};
    keys = new Set(keys);
    for(const k in props)if (!keys.has(k) && k[0] !== "$") rest[k] = props[k];
    return rest;
}
function $1eb80e36873dc327$export$3001519f1cb535ea(slots) {
    const result = {};
    for(const key in slots)result[key] = true;
    return result;
}
function $1eb80e36873dc327$export$d2de3aaeafa91619(fn) {
    let ran = false;
    return function(...args) {
        if (ran) return;
        ran = true;
        fn.call(this, ...args);
    };
}
function $1eb80e36873dc327$export$1a9d7733e079fbfa(value) {
    return value == null ? "" : value;
}
function $1eb80e36873dc327$export$ef3da5b70290de1(store, ret, value) {
    store.set(value);
    return ret;
}
const $1eb80e36873dc327$export$90ea246e00657977 = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
function $1eb80e36873dc327$export$44ef7a4ea2170a07(action_result) {
    return action_result && $1eb80e36873dc327$export$b451353ebd749597(action_result.destroy) ? action_result.destroy : $1eb80e36873dc327$export$8793edee2d425525;
}
function $1eb80e36873dc327$export$fde6ca7e0b92f8ff(value) {
    const split = typeof value === "string" && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [
        parseFloat(split[1]),
        split[2] || "px"
    ] : [
        value,
        "px"
    ];
}
const $1eb80e36873dc327$export$e3d839ffa95f7481 = [
    "",
    true,
    1,
    "true",
    "contenteditable"
];
const $1eb80e36873dc327$export$63e5d6c42bc01b79 = typeof window !== "undefined";
let $1eb80e36873dc327$export$461939dd4422153 = $1eb80e36873dc327$export$63e5d6c42bc01b79 ? ()=>window.performance.now() : ()=>Date.now();
let $1eb80e36873dc327$export$27f233d61a9e2fa4 = $1eb80e36873dc327$export$63e5d6c42bc01b79 ? (cb)=>requestAnimationFrame(cb) : $1eb80e36873dc327$export$8793edee2d425525;
// used internally for testing
function $1eb80e36873dc327$export$50265a0ed747f6de(fn) {
    $1eb80e36873dc327$export$461939dd4422153 = fn;
}
function $1eb80e36873dc327$export$43be9c1bea1fd56(fn) {
    $1eb80e36873dc327$export$27f233d61a9e2fa4 = fn;
}
const $1eb80e36873dc327$var$tasks = new Set();
function $1eb80e36873dc327$var$run_tasks(now) {
    $1eb80e36873dc327$var$tasks.forEach((task)=>{
        if (!task.c(now)) {
            $1eb80e36873dc327$var$tasks.delete(task);
            task.f();
        }
    });
    if ($1eb80e36873dc327$var$tasks.size !== 0) $1eb80e36873dc327$export$27f233d61a9e2fa4($1eb80e36873dc327$var$run_tasks);
}
/**
 * For testing purposes only!
 */ function $1eb80e36873dc327$export$36ce6b87b73ae3() {
    $1eb80e36873dc327$var$tasks.clear();
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */ function $1eb80e36873dc327$export$f9ef67375ddc185(callback) {
    let task;
    if ($1eb80e36873dc327$var$tasks.size === 0) $1eb80e36873dc327$export$27f233d61a9e2fa4($1eb80e36873dc327$var$run_tasks);
    return {
        promise: new Promise((fulfill)=>{
            $1eb80e36873dc327$var$tasks.add(task = {
                c: callback,
                f: fulfill
            });
        }),
        abort () {
            $1eb80e36873dc327$var$tasks.delete(task);
        }
    };
}
// Track which nodes are claimed during hydration. Unclaimed nodes can then be removed from the DOM
// at the end of hydration without touching the remaining nodes.
let $1eb80e36873dc327$var$is_hydrating = false;
function $1eb80e36873dc327$export$237ef195d41ae60c() {
    $1eb80e36873dc327$var$is_hydrating = true;
}
function $1eb80e36873dc327$export$4b42d81e6a3b0cd2() {
    $1eb80e36873dc327$var$is_hydrating = false;
}
function $1eb80e36873dc327$var$upper_bound(low, high, key, value) {
    // Return first index of value larger than input value in the range [low, high)
    while(low < high){
        const mid = low + (high - low >> 1);
        if (key(mid) <= value) low = mid + 1;
        else high = mid;
    }
    return low;
}
function $1eb80e36873dc327$var$init_hydrate(target) {
    if (target.hydrate_init) return;
    target.hydrate_init = true;
    // We know that all children have claim_order values since the unclaimed have been detached if target is not <head>
    let children = target.childNodes;
    // If target is <head>, there may be children without claim_order
    if (target.nodeName === "HEAD") {
        const myChildren = [];
        for(let i = 0; i < children.length; i++){
            const node = children[i];
            if (node.claim_order !== undefined) myChildren.push(node);
        }
        children = myChildren;
    }
    /*
    * Reorder claimed children optimally.
    * We can reorder claimed children optimally by finding the longest subsequence of
    * nodes that are already claimed in order and only moving the rest. The longest
    * subsequence of nodes that are claimed in order can be found by
    * computing the longest increasing subsequence of .claim_order values.
    *
    * This algorithm is optimal in generating the least amount of reorder operations
    * possible.
    *
    * Proof:
    * We know that, given a set of reordering operations, the nodes that do not move
    * always form an increasing subsequence, since they do not move among each other
    * meaning that they must be already ordered among each other. Thus, the maximal
    * set of nodes that do not move form a longest increasing subsequence.
    */ // Compute longest increasing subsequence
    // m: subsequence length j => index k of smallest value that ends an increasing subsequence of length j
    const m = new Int32Array(children.length + 1);
    // Predecessor indices + 1
    const p = new Int32Array(children.length);
    m[0] = -1;
    let longest = 0;
    for(let i = 0; i < children.length; i++){
        const current = children[i].claim_order;
        // Find the largest subsequence length such that it ends in a value less than our current value
        // upper_bound returns first greater value, so we subtract one
        // with fast path for when we are on the current longest subsequence
        const seqLen = (longest > 0 && children[m[longest]].claim_order <= current ? longest + 1 : $1eb80e36873dc327$var$upper_bound(1, longest, (idx)=>children[m[idx]].claim_order, current)) - 1;
        p[i] = m[seqLen] + 1;
        const newLen = seqLen + 1;
        // We can guarantee that current is the smallest value. Otherwise, we would have generated a longer sequence.
        m[newLen] = i;
        longest = Math.max(newLen, longest);
    }
    // The longest increasing subsequence of nodes (initially reversed)
    const lis = [];
    // The rest of the nodes, nodes that will be moved
    const toMove = [];
    let last = children.length - 1;
    for(let cur = m[longest] + 1; cur != 0; cur = p[cur - 1]){
        lis.push(children[cur - 1]);
        for(; last >= cur; last--)toMove.push(children[last]);
        last--;
    }
    for(; last >= 0; last--)toMove.push(children[last]);
    lis.reverse();
    // We sort the nodes being moved to guarantee that their insertion order matches the claim order
    toMove.sort((a, b)=>a.claim_order - b.claim_order);
    // Finally, we move the nodes
    for(let i = 0, j = 0; i < toMove.length; i++){
        while(j < lis.length && toMove[i].claim_order >= lis[j].claim_order)j++;
        const anchor = j < lis.length ? lis[j] : null;
        target.insertBefore(toMove[i], anchor);
    }
}
function $1eb80e36873dc327$export$10d8903dec122b9d(target, node) {
    target.appendChild(node);
}
function $1eb80e36873dc327$export$79c6991e22869eb0(target, style_sheet_id, styles) {
    const append_styles_to = $1eb80e36873dc327$export$e6f325d87fe70439(target);
    if (!append_styles_to.getElementById(style_sheet_id)) {
        const style = $1eb80e36873dc327$export$8454457683f90105("style");
        style.id = style_sheet_id;
        style.textContent = styles;
        $1eb80e36873dc327$var$append_stylesheet(append_styles_to, style);
    }
}
function $1eb80e36873dc327$export$e6f325d87fe70439(node) {
    if (!node) return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) return root;
    return node.ownerDocument;
}
function $1eb80e36873dc327$export$98a01cd5b3256c7(node) {
    const style_element = $1eb80e36873dc327$export$8454457683f90105("style");
    $1eb80e36873dc327$var$append_stylesheet($1eb80e36873dc327$export$e6f325d87fe70439(node), style_element);
    return style_element.sheet;
}
function $1eb80e36873dc327$var$append_stylesheet(node, style) {
    $1eb80e36873dc327$export$10d8903dec122b9d(node.head || node, style);
    return style.sheet;
}
function $1eb80e36873dc327$export$172bc581f7520fb7(target, node) {
    if ($1eb80e36873dc327$var$is_hydrating) {
        $1eb80e36873dc327$var$init_hydrate(target);
        if (target.actual_end_child === undefined || target.actual_end_child !== null && target.actual_end_child.parentNode !== target) target.actual_end_child = target.firstChild;
        // Skip nodes of undefined ordering
        while(target.actual_end_child !== null && target.actual_end_child.claim_order === undefined)target.actual_end_child = target.actual_end_child.nextSibling;
        if (node !== target.actual_end_child) // We only insert if the ordering of this node should be modified or the parent node is not target
        {
            if (node.claim_order !== undefined || node.parentNode !== target) target.insertBefore(node, target.actual_end_child);
        } else target.actual_end_child = node.nextSibling;
    } else if (node.parentNode !== target || node.nextSibling !== null) target.appendChild(node);
}
function $1eb80e36873dc327$export$21a5ca8aa77d35ff(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function $1eb80e36873dc327$export$f7a8880e5fbca7f8(target, node, anchor) {
    if ($1eb80e36873dc327$var$is_hydrating && !anchor) $1eb80e36873dc327$export$172bc581f7520fb7(target, node);
    else if (node.parentNode !== target || node.nextSibling != anchor) target.insertBefore(node, anchor || null);
}
function $1eb80e36873dc327$export$3f780019ff766da6(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
function $1eb80e36873dc327$export$7ddc7a4fd25b2662(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
function $1eb80e36873dc327$export$8454457683f90105(name) {
    return document.createElement(name);
}
function $1eb80e36873dc327$export$6b474b18510bcd0a(name, is) {
    return document.createElement(name, {
        is: is
    });
}
function $1eb80e36873dc327$export$9fd581e6a5ec01ab(obj, exclude) {
    const target = {};
    for(const k in obj)if ($1eb80e36873dc327$export$90ea246e00657977(obj, k) && exclude.indexOf(k) === -1) // @ts-ignore
    target[k] = obj[k];
    return target;
}
function $1eb80e36873dc327$export$3967a3bb66708d71(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $1eb80e36873dc327$export$6f093cfa640b7166(data) {
    return document.createTextNode(data);
}
function $1eb80e36873dc327$export$a941ed4b947d12f8() {
    return $1eb80e36873dc327$export$6f093cfa640b7166(" ");
}
function $1eb80e36873dc327$export$6e22c362a0406a2c() {
    return $1eb80e36873dc327$export$6f093cfa640b7166("");
}
function $1eb80e36873dc327$export$4a34f930e789283c(content) {
    return document.createComment(content);
}
function $1eb80e36873dc327$export$63174c828edd6ff8(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
function $1eb80e36873dc327$export$87efb90f285c3ace(fn) {
    return function(event) {
        event.preventDefault();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $1eb80e36873dc327$export$52770bb39e602159(fn) {
    return function(event) {
        event.stopPropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $1eb80e36873dc327$export$11e2a029189b1fe4(fn) {
    return function(event) {
        event.stopImmediatePropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $1eb80e36873dc327$export$82c2e460fb230c2a(fn) {
    return function(event) {
        // @ts-ignore
        if (event.target === this) fn.call(this, event);
    };
}
function $1eb80e36873dc327$export$3db9a96880fcbbea(fn) {
    return function(event) {
        // @ts-ignore
        if (event.isTrusted) fn.call(this, event);
    };
}
function $1eb80e36873dc327$export$7aabe8b3a840d2fd(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
function $1eb80e36873dc327$export$d7952e694819cff8(node, attributes) {
    // @ts-ignore
    const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
    for(const key in attributes){
        if (attributes[key] == null) node.removeAttribute(key);
        else if (key === "style") node.style.cssText = attributes[key];
        else if (key === "__value") node.value = node[key] = attributes[key];
        else if (descriptors[key] && descriptors[key].set) node[key] = attributes[key];
        else $1eb80e36873dc327$export$7aabe8b3a840d2fd(node, key, attributes[key]);
    }
}
function $1eb80e36873dc327$export$368e7860cfb63d61(node, attributes) {
    for(const key in attributes)$1eb80e36873dc327$export$7aabe8b3a840d2fd(node, key, attributes[key]);
}
function $1eb80e36873dc327$export$98353888655e5db6(node, data_map) {
    Object.keys(data_map).forEach((key)=>{
        $1eb80e36873dc327$export$ebd6c566d63faf17(node, key, data_map[key]);
    });
}
function $1eb80e36873dc327$export$ebd6c566d63faf17(node, prop, value) {
    if (prop in node) node[prop] = typeof node[prop] === "boolean" && value === "" ? true : value;
    else $1eb80e36873dc327$export$7aabe8b3a840d2fd(node, prop, value);
}
function $1eb80e36873dc327$export$e796c4bd7c66dc3b(tag) {
    return /-/.test(tag) ? $1eb80e36873dc327$export$98353888655e5db6 : $1eb80e36873dc327$export$d7952e694819cff8;
}
function $1eb80e36873dc327$export$f27475e5487b56e(node, attribute, value) {
    node.setAttributeNS("http://www.w3.org/1999/xlink", attribute, value);
}
function $1eb80e36873dc327$export$e362e436917dc36e(group, __value, checked) {
    const value = new Set();
    for(let i = 0; i < group.length; i += 1)if (group[i].checked) value.add(group[i].__value);
    if (!checked) value.delete(__value);
    return Array.from(value);
}
function $1eb80e36873dc327$export$c9db880d5988ec92(group) {
    let _inputs;
    return {
        /* push */ p (...inputs) {
            _inputs = inputs;
            _inputs.forEach((input)=>group.push(input));
        },
        /* remove */ r () {
            _inputs.forEach((input)=>group.splice(group.indexOf(input), 1));
        }
    };
}
function $1eb80e36873dc327$export$e81314ce0988e002(group, indexes) {
    let _group = get_binding_group(group);
    let _inputs;
    function get_binding_group(group) {
        for(let i = 0; i < indexes.length; i++)group = group[indexes[i]] = group[indexes[i]] || [];
        return group;
    }
    function push() {
        _inputs.forEach((input)=>_group.push(input));
    }
    function remove() {
        _inputs.forEach((input)=>_group.splice(_group.indexOf(input), 1));
    }
    return {
        /* update */ u (new_indexes) {
            indexes = new_indexes;
            const new_group = get_binding_group(group);
            if (new_group !== _group) {
                remove();
                _group = new_group;
                push();
            }
        },
        /* push */ p (...inputs) {
            _inputs = inputs;
            push();
        },
        /* remove */ r: remove
    };
}
function $1eb80e36873dc327$export$5ba91aa2ee2bd813(value) {
    return value === "" ? null : +value;
}
function $1eb80e36873dc327$export$fea0a9609a381cb7(ranges) {
    const array = [];
    for(let i = 0; i < ranges.length; i += 1)array.push({
        start: ranges.start(i),
        end: ranges.end(i)
    });
    return array;
}
function $1eb80e36873dc327$export$bacb5cc5a11aef16(element) {
    return Array.from(element.childNodes);
}
function $1eb80e36873dc327$var$init_claim_info(nodes) {
    if (nodes.claim_info === undefined) nodes.claim_info = {
        last_index: 0,
        total_claimed: 0
    };
}
function $1eb80e36873dc327$var$claim_node(nodes, predicate, processNode, createNode, dontUpdateLastIndex = false) {
    // Try to find nodes in an order such that we lengthen the longest increasing subsequence
    $1eb80e36873dc327$var$init_claim_info(nodes);
    const resultNode = (()=>{
        // We first try to find an element after the previous one
        for(let i = nodes.claim_info.last_index; i < nodes.length; i++){
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) nodes.splice(i, 1);
                else nodes[i] = replacement;
                if (!dontUpdateLastIndex) nodes.claim_info.last_index = i;
                return node;
            }
        }
        // Otherwise, we try to find one before
        // We iterate in reverse so that we don't go too far back
        for(let i = nodes.claim_info.last_index - 1; i >= 0; i--){
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) nodes.splice(i, 1);
                else nodes[i] = replacement;
                if (!dontUpdateLastIndex) nodes.claim_info.last_index = i;
                else if (replacement === undefined) // Since we spliced before the last_index, we decrease it
                nodes.claim_info.last_index--;
                return node;
            }
        }
        // If we can't find any matching node, we create a new one
        return createNode();
    })();
    resultNode.claim_order = nodes.claim_info.total_claimed;
    nodes.claim_info.total_claimed += 1;
    return resultNode;
}
function $1eb80e36873dc327$var$claim_element_base(nodes, name, attributes, create_element) {
    return $1eb80e36873dc327$var$claim_node(nodes, (node)=>node.nodeName === name, (node)=>{
        const remove = [];
        for(let j = 0; j < node.attributes.length; j++){
            const attribute = node.attributes[j];
            if (!attributes[attribute.name]) remove.push(attribute.name);
        }
        remove.forEach((v)=>node.removeAttribute(v));
        return undefined;
    }, ()=>create_element(name));
}
function $1eb80e36873dc327$export$e4d2dfbfb60b531(nodes, name, attributes) {
    return $1eb80e36873dc327$var$claim_element_base(nodes, name, attributes, $1eb80e36873dc327$export$8454457683f90105);
}
function $1eb80e36873dc327$export$565c8233a6bb82a5(nodes, name, attributes) {
    return $1eb80e36873dc327$var$claim_element_base(nodes, name, attributes, $1eb80e36873dc327$export$3967a3bb66708d71);
}
function $1eb80e36873dc327$export$2fada5bb0438cbc3(nodes, data) {
    return $1eb80e36873dc327$var$claim_node(nodes, (node)=>node.nodeType === 3, (node)=>{
        const dataStr = "" + data;
        if (node.data.startsWith(dataStr)) {
            if (node.data.length !== dataStr.length) return node.splitText(dataStr.length);
        } else node.data = dataStr;
    }, ()=>$1eb80e36873dc327$export$6f093cfa640b7166(data), true // Text nodes should not update last index since it is likely not worth it to eliminate an increasing subsequence of actual elements
    );
}
function $1eb80e36873dc327$export$2466e42bcfb45299(nodes) {
    return $1eb80e36873dc327$export$2fada5bb0438cbc3(nodes, " ");
}
function $1eb80e36873dc327$export$193ad9a257f71537(nodes, data) {
    return $1eb80e36873dc327$var$claim_node(nodes, (node)=>node.nodeType === 8, (node)=>{
        node.data = "" + data;
        return undefined;
    }, ()=>$1eb80e36873dc327$export$4a34f930e789283c(data), true);
}
function $1eb80e36873dc327$var$find_comment(nodes, text, start) {
    for(let i = start; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.nodeType === 8 /* comment node */  && node.textContent.trim() === text) return i;
    }
    return nodes.length;
}
function $1eb80e36873dc327$export$5d5909c037ed7d6(nodes, is_svg) {
    // find html opening tag
    const start_index = $1eb80e36873dc327$var$find_comment(nodes, "HTML_TAG_START", 0);
    const end_index = $1eb80e36873dc327$var$find_comment(nodes, "HTML_TAG_END", start_index);
    if (start_index === end_index) return new $1eb80e36873dc327$export$7cdd9a1105a7b19d(undefined, is_svg);
    $1eb80e36873dc327$var$init_claim_info(nodes);
    const html_tag_nodes = nodes.splice(start_index, end_index - start_index + 1);
    $1eb80e36873dc327$export$3f780019ff766da6(html_tag_nodes[0]);
    $1eb80e36873dc327$export$3f780019ff766da6(html_tag_nodes[html_tag_nodes.length - 1]);
    const claimed_nodes = html_tag_nodes.slice(1, html_tag_nodes.length - 1);
    for (const n of claimed_nodes){
        n.claim_order = nodes.claim_info.total_claimed;
        nodes.claim_info.total_claimed += 1;
    }
    return new $1eb80e36873dc327$export$7cdd9a1105a7b19d(claimed_nodes, is_svg);
}
function $1eb80e36873dc327$export$c31d24e2793e6a58(text, data) {
    data = "" + data;
    if (text.data === data) return;
    text.data = data;
}
function $1eb80e36873dc327$export$3216f7a4c630e86(text, data) {
    data = "" + data;
    if (text.wholeText === data) return;
    text.data = data;
}
function $1eb80e36873dc327$export$81784c858f228282(text, data, attr_value) {
    if (~$1eb80e36873dc327$export$e3d839ffa95f7481.indexOf(attr_value)) $1eb80e36873dc327$export$3216f7a4c630e86(text, data);
    else $1eb80e36873dc327$export$c31d24e2793e6a58(text, data);
}
function $1eb80e36873dc327$export$aee788c6eadfac08(input, value) {
    input.value = value == null ? "" : value;
}
function $1eb80e36873dc327$export$b4858aaf125f1c5a(input, type) {
    try {
        input.type = type;
    } catch (e) {
    // do nothing
    }
}
function $1eb80e36873dc327$export$4bb9c9f436517f16(node, key, value, important) {
    if (value === null) node.style.removeProperty(key);
    else node.style.setProperty(key, value, important ? "important" : "");
}
function $1eb80e36873dc327$export$5bf9f186a0379f12(select, value, mounting) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        if (option.__value === value) {
            option.selected = true;
            return;
        }
    }
    if (!mounting || value !== undefined) select.selectedIndex = -1; // no option should be selected
}
function $1eb80e36873dc327$export$336810584d2bdfc9(select, value) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        option.selected = ~value.indexOf(option.__value);
    }
}
function $1eb80e36873dc327$export$10e6f38ae1549a20(select) {
    const selected_option = select.querySelector(":checked");
    return selected_option && selected_option.__value;
}
function $1eb80e36873dc327$export$4dde2acae9a7963a(select) {
    return [].map.call(select.querySelectorAll(":checked"), (option)=>option.__value);
}
// unfortunately this can't be a constant as that wouldn't be tree-shakeable
// so we cache the result instead
let $1eb80e36873dc327$var$crossorigin;
function $1eb80e36873dc327$export$1d584e6276e92aaf() {
    if ($1eb80e36873dc327$var$crossorigin === undefined) {
        $1eb80e36873dc327$var$crossorigin = false;
        try {
            if (typeof window !== "undefined" && window.parent) window.parent.document;
        } catch (error) {
            $1eb80e36873dc327$var$crossorigin = true;
        }
    }
    return $1eb80e36873dc327$var$crossorigin;
}
function $1eb80e36873dc327$export$6868b67c0af74ebc(node, fn) {
    const computed_style = getComputedStyle(node);
    if (computed_style.position === "static") node.style.position = "relative";
    const iframe = $1eb80e36873dc327$export$8454457683f90105("iframe");
    iframe.setAttribute("style", "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;");
    iframe.setAttribute("aria-hidden", "true");
    iframe.tabIndex = -1;
    const crossorigin = $1eb80e36873dc327$export$1d584e6276e92aaf();
    let unsubscribe;
    if (crossorigin) {
        iframe.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}</script>";
        unsubscribe = $1eb80e36873dc327$export$63174c828edd6ff8(window, "message", (event)=>{
            if (event.source === iframe.contentWindow) fn();
        });
    } else {
        iframe.src = "about:blank";
        iframe.onload = ()=>{
            unsubscribe = $1eb80e36873dc327$export$63174c828edd6ff8(iframe.contentWindow, "resize", fn);
            // make sure an initial resize event is fired _after_ the iframe is loaded (which is asynchronous)
            // see https://github.com/sveltejs/svelte/issues/4233
            fn();
        };
    }
    $1eb80e36873dc327$export$10d8903dec122b9d(node, iframe);
    return ()=>{
        if (crossorigin) unsubscribe();
        else if (unsubscribe && iframe.contentWindow) unsubscribe();
        $1eb80e36873dc327$export$3f780019ff766da6(iframe);
    };
}
function $1eb80e36873dc327$export$d546e2fde02d30d6(element, name, toggle) {
    element.classList[toggle ? "add" : "remove"](name);
}
function $1eb80e36873dc327$export$da00493480283d6b(type, detail, { bubbles: bubbles = false, cancelable: cancelable = false } = {}) {
    const e = document.createEvent("CustomEvent");
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
function $1eb80e36873dc327$export$b06f083696d24824(selector, parent = document.body) {
    return Array.from(parent.querySelectorAll(selector));
}
function $1eb80e36873dc327$export$6a512dd14a7df6a(nodeId, head) {
    const result = [];
    let started = 0;
    for (const node of head.childNodes){
        if (node.nodeType === 8 /* comment node */ ) {
            const comment = node.textContent.trim();
            if (comment === `HEAD_${nodeId}_END`) {
                started -= 1;
                result.push(node);
            } else if (comment === `HEAD_${nodeId}_START`) {
                started += 1;
                result.push(node);
            }
        } else if (started > 0) result.push(node);
    }
    return result;
}
class $1eb80e36873dc327$export$5b2cf11349dd7485 {
    constructor(is_svg = false){
        this.is_svg = false;
        this.is_svg = is_svg;
        this.e = this.n = null;
    }
    c(html) {
        this.h(html);
    }
    m(html, target, anchor = null) {
        if (!this.e) {
            if (this.is_svg) this.e = $1eb80e36873dc327$export$3967a3bb66708d71(target.nodeName);
            else this.e = $1eb80e36873dc327$export$8454457683f90105(target.nodeType === 11 ? "TEMPLATE" : target.nodeName);
            this.t = target.tagName !== "TEMPLATE" ? target : target.content;
            this.c(html);
        }
        this.i(anchor);
    }
    h(html) {
        this.e.innerHTML = html;
        this.n = Array.from(this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$1eb80e36873dc327$export$21a5ca8aa77d35ff(this.t, this.n[i], anchor);
    }
    p(html) {
        this.d();
        this.h(html);
        this.i(this.a);
    }
    d() {
        this.n.forEach($1eb80e36873dc327$export$3f780019ff766da6);
    }
}
class $1eb80e36873dc327$export$7cdd9a1105a7b19d extends $1eb80e36873dc327$export$5b2cf11349dd7485 {
    constructor(claimed_nodes, is_svg = false){
        super(is_svg);
        this.e = this.n = null;
        this.l = claimed_nodes;
    }
    c(html) {
        if (this.l) this.n = this.l;
        else super.c(html);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$1eb80e36873dc327$export$f7a8880e5fbca7f8(this.t, this.n[i], anchor);
    }
}
function $1eb80e36873dc327$export$110c642b3fe80ed5(attributes) {
    const result = {};
    for (const attribute of attributes)result[attribute.name] = attribute.value;
    return result;
}
function $1eb80e36873dc327$export$58283a1df1431097(element) {
    const result = {};
    element.childNodes.forEach((node)=>{
        result[node.slot || "default"] = true;
    });
    return result;
}
function $1eb80e36873dc327$export$203be6b617b8723(component, props) {
    return new component(props);
}
// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const $1eb80e36873dc327$var$managed_styles = new Map();
let $1eb80e36873dc327$var$active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function $1eb80e36873dc327$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i--)hash = (hash << 5) - hash ^ str.charCodeAt(i);
    return hash >>> 0;
}
function $1eb80e36873dc327$var$create_style_information(doc, node) {
    const info = {
        stylesheet: $1eb80e36873dc327$export$98a01cd5b3256c7(node),
        rules: {}
    };
    $1eb80e36873dc327$var$managed_styles.set(doc, info);
    return info;
}
function $1eb80e36873dc327$var$create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = "{\n";
    for(let p = 0; p <= 1; p += step){
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${$1eb80e36873dc327$var$hash(rule)}_${uid}`;
    const doc = $1eb80e36873dc327$export$e6f325d87fe70439(node);
    const { stylesheet: stylesheet, rules: rules } = $1eb80e36873dc327$var$managed_styles.get(doc) || $1eb80e36873dc327$var$create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || "";
    node.style.animation = `${animation ? `${animation}, ` : ""}${name} ${duration}ms linear ${delay}ms 1 both`;
    $1eb80e36873dc327$var$active += 1;
    return name;
}
function $1eb80e36873dc327$var$delete_rule(node, name) {
    const previous = (node.style.animation || "").split(", ");
    const next = previous.filter(name ? (anim)=>anim.indexOf(name) < 0 // remove specific animation
     : (anim)=>anim.indexOf("__svelte") === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(", ");
        $1eb80e36873dc327$var$active -= deleted;
        if (!$1eb80e36873dc327$var$active) $1eb80e36873dc327$var$clear_rules();
    }
}
function $1eb80e36873dc327$var$clear_rules() {
    $1eb80e36873dc327$export$27f233d61a9e2fa4(()=>{
        if ($1eb80e36873dc327$var$active) return;
        $1eb80e36873dc327$var$managed_styles.forEach((info)=>{
            const { ownerNode: ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode) $1eb80e36873dc327$export$3f780019ff766da6(ownerNode);
        });
        $1eb80e36873dc327$var$managed_styles.clear();
    });
}
function $1eb80e36873dc327$export$39b5174d4b79e190(node, from, fn, params) {
    if (!from) return $1eb80e36873dc327$export$8793edee2d425525;
    const to = node.getBoundingClientRect();
    if (from.left === to.left && from.right === to.right && from.top === to.top && from.bottom === to.bottom) return $1eb80e36873dc327$export$8793edee2d425525;
    const { delay: delay = 0, duration: duration = 300, easing: easing = $1eb80e36873dc327$export$f0954fd7d5368655, // @ts-ignore todo: should this be separated from destructuring? Or start/end added to public api and documentation?
    start: start_time = $1eb80e36873dc327$export$461939dd4422153() + delay, end: // @ts-ignore todo:
    end = start_time + duration, tick: tick = $1eb80e36873dc327$export$8793edee2d425525, css: css } = fn(node, {
        from: from,
        to: to
    }, params);
    let running = true;
    let started = false;
    let name;
    function start() {
        if (css) name = $1eb80e36873dc327$var$create_rule(node, 0, 1, duration, delay, easing, css);
        if (!delay) started = true;
    }
    function stop() {
        if (css) $1eb80e36873dc327$var$delete_rule(node, name);
        running = false;
    }
    $1eb80e36873dc327$export$f9ef67375ddc185((now)=>{
        if (!started && now >= start_time) started = true;
        if (started && now >= end) {
            tick(1, 0);
            stop();
        }
        if (!running) return false;
        if (started) {
            const p = now - start_time;
            const t = 0 + 1 * easing(p / duration);
            tick(t, 1 - t);
        }
        return true;
    });
    start();
    tick(0, 1);
    return stop;
}
function $1eb80e36873dc327$export$b3559b6401c8ae16(node) {
    const style = getComputedStyle(node);
    if (style.position !== "absolute" && style.position !== "fixed") {
        const { width: width, height: height } = style;
        const a = node.getBoundingClientRect();
        node.style.position = "absolute";
        node.style.width = width;
        node.style.height = height;
        $1eb80e36873dc327$export$e05da6b8aaec7de(node, a);
    }
}
function $1eb80e36873dc327$export$e05da6b8aaec7de(node, a) {
    const b = node.getBoundingClientRect();
    if (a.left !== b.left || a.top !== b.top) {
        const style = getComputedStyle(node);
        const transform = style.transform === "none" ? "" : style.transform;
        node.style.transform = `${transform} translate(${a.left - b.left}px, ${a.top - b.top}px)`;
    }
}
let $1eb80e36873dc327$export$3ec7acbf47bb7c71;
function $1eb80e36873dc327$export$e72a4c53a1d11dfc(component) {
    $1eb80e36873dc327$export$3ec7acbf47bb7c71 = component;
}
function $1eb80e36873dc327$export$d19094f0a5fb37fa() {
    if (!$1eb80e36873dc327$export$3ec7acbf47bb7c71) throw new Error("Function called outside component initialization");
    return $1eb80e36873dc327$export$3ec7acbf47bb7c71;
}
/**
 * Schedules a callback to run immediately before the component is updated after any state change.
 *
 * The first time the callback runs will be before the initial `onMount`
 *
 * https://svelte.dev/docs#run-time-svelte-beforeupdate
 */ function $1eb80e36873dc327$export$4b797776fd97928f(fn) {
    $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.before_update.push(fn);
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */ function $1eb80e36873dc327$export$1e848a9e87980bd5(fn) {
    $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */ function $1eb80e36873dc327$export$f956f39b9a12cea8(fn) {
    $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs#run-time-svelte-ondestroy
 */ function $1eb80e36873dc327$export$f1238fd06ad9b453(fn) {
    $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.on_destroy.push(fn);
}
/**
 * Creates an event dispatcher that can be used to dispatch [component events](/docs#template-syntax-component-directives-on-eventname).
 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
 *
 * Component events created with `createEventDispatcher` create a
 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
 * property and can contain any type of data.
 *
 * https://svelte.dev/docs#run-time-svelte-createeventdispatcher
 */ function $1eb80e36873dc327$export$2a380c922b2bd2b3() {
    const component = $1eb80e36873dc327$export$d19094f0a5fb37fa();
    return (type, detail, { cancelable: cancelable = false } = {})=>{
        const callbacks = component.$$.callbacks[type];
        if (callbacks) {
            // TODO are there situations where events could be dispatched
            // in a server (non-DOM) environment?
            const event = $1eb80e36873dc327$export$da00493480283d6b(type, detail, {
                cancelable: cancelable
            });
            callbacks.slice().forEach((fn)=>{
                fn.call(component, event);
            });
            return !event.defaultPrevented;
        }
        return true;
    };
}
/**
 * Associates an arbitrary `context` object with the current component and the specified `key`
 * and returns that object. The context is then available to children of the component
 * (including slotted content) with `getContext`.
 *
 * Like lifecycle functions, this must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-setcontext
 */ function $1eb80e36873dc327$export$2f04de43fe27971a(key, context) {
    $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.context.set(key, context);
    return context;
}
/**
 * Retrieves the context that belongs to the closest parent component with the specified `key`.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-getcontext
 */ function $1eb80e36873dc327$export$31553aaa555c1514(key) {
    return $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.context.get(key);
}
/**
 * Retrieves the whole context map that belongs to the closest parent component.
 * Must be called during component initialisation. Useful, for example, if you
 * programmatically create a component and want to pass the existing context to it.
 *
 * https://svelte.dev/docs#run-time-svelte-getallcontexts
 */ function $1eb80e36873dc327$export$58bb8454a8b39484() {
    return $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.context;
}
/**
 * Checks whether a given `key` has been set in the context of a parent component.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-hascontext
 */ function $1eb80e36873dc327$export$1fda64d8edbe0e8d(key) {
    return $1eb80e36873dc327$export$d19094f0a5fb37fa().$$.context.has(key);
}
// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function $1eb80e36873dc327$export$f5dbf5ce556e97fb(component, event) {
    const callbacks = component.$$.callbacks[event.type];
    if (callbacks) // @ts-ignore
    callbacks.slice().forEach((fn)=>fn.call(this, event));
}
const $1eb80e36873dc327$export$befe60e985bb3cce = [];
const $1eb80e36873dc327$export$eec97e1bbe9a59bc = {
    enabled: false
};
const $1eb80e36873dc327$export$de8cb20e97391842 = [];
let $1eb80e36873dc327$var$render_callbacks = [];
const $1eb80e36873dc327$var$flush_callbacks = [];
const $1eb80e36873dc327$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $1eb80e36873dc327$var$update_scheduled = false;
function $1eb80e36873dc327$export$c3d55cc721051d24() {
    if (!$1eb80e36873dc327$var$update_scheduled) {
        $1eb80e36873dc327$var$update_scheduled = true;
        $1eb80e36873dc327$var$resolved_promise.then($1eb80e36873dc327$export$4909b86c8034bf73);
    }
}
function $1eb80e36873dc327$export$55d7f61db91b7b70() {
    $1eb80e36873dc327$export$c3d55cc721051d24();
    return $1eb80e36873dc327$var$resolved_promise;
}
function $1eb80e36873dc327$export$8851747095d022df(fn) {
    $1eb80e36873dc327$var$render_callbacks.push(fn);
}
function $1eb80e36873dc327$export$53b4f9f742189b3b(fn) {
    $1eb80e36873dc327$var$flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $1eb80e36873dc327$var$seen_callbacks = new Set();
let $1eb80e36873dc327$var$flushidx = 0; // Do *not* move this inside the flush() function
function $1eb80e36873dc327$export$4909b86c8034bf73() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($1eb80e36873dc327$var$flushidx !== 0) return;
    const saved_component = $1eb80e36873dc327$export$3ec7acbf47bb7c71;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($1eb80e36873dc327$var$flushidx < $1eb80e36873dc327$export$befe60e985bb3cce.length){
                const component = $1eb80e36873dc327$export$befe60e985bb3cce[$1eb80e36873dc327$var$flushidx];
                $1eb80e36873dc327$var$flushidx++;
                $1eb80e36873dc327$export$e72a4c53a1d11dfc(component);
                $1eb80e36873dc327$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $1eb80e36873dc327$export$befe60e985bb3cce.length = 0;
            $1eb80e36873dc327$var$flushidx = 0;
            throw e;
        }
        $1eb80e36873dc327$export$e72a4c53a1d11dfc(null);
        $1eb80e36873dc327$export$befe60e985bb3cce.length = 0;
        $1eb80e36873dc327$var$flushidx = 0;
        while($1eb80e36873dc327$export$de8cb20e97391842.length)$1eb80e36873dc327$export$de8cb20e97391842.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $1eb80e36873dc327$var$render_callbacks.length; i += 1){
            const callback = $1eb80e36873dc327$var$render_callbacks[i];
            if (!$1eb80e36873dc327$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $1eb80e36873dc327$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $1eb80e36873dc327$var$render_callbacks.length = 0;
    }while ($1eb80e36873dc327$export$befe60e985bb3cce.length);
    while($1eb80e36873dc327$var$flush_callbacks.length)$1eb80e36873dc327$var$flush_callbacks.pop()();
    $1eb80e36873dc327$var$update_scheduled = false;
    $1eb80e36873dc327$var$seen_callbacks.clear();
    $1eb80e36873dc327$export$e72a4c53a1d11dfc(saved_component);
}
function $1eb80e36873dc327$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $1eb80e36873dc327$export$3f1fcd837f99a9ab($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($1eb80e36873dc327$export$8851747095d022df);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */ function $1eb80e36873dc327$export$99d0f1b00233da03(fns) {
    const filtered = [];
    const targets = [];
    $1eb80e36873dc327$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $1eb80e36873dc327$var$render_callbacks = filtered;
}
let $1eb80e36873dc327$var$promise;
function $1eb80e36873dc327$var$wait() {
    if (!$1eb80e36873dc327$var$promise) {
        $1eb80e36873dc327$var$promise = Promise.resolve();
        $1eb80e36873dc327$var$promise.then(()=>{
            $1eb80e36873dc327$var$promise = null;
        });
    }
    return $1eb80e36873dc327$var$promise;
}
function $1eb80e36873dc327$var$dispatch(node, direction, kind) {
    node.dispatchEvent($1eb80e36873dc327$export$da00493480283d6b(`${direction ? "intro" : "outro"}${kind}`));
}
const $1eb80e36873dc327$var$outroing = new Set();
let $1eb80e36873dc327$var$outros;
function $1eb80e36873dc327$export$b074532eec6b252c() {
    $1eb80e36873dc327$var$outros = {
        r: 0,
        c: [],
        p: $1eb80e36873dc327$var$outros // parent group
    };
}
function $1eb80e36873dc327$export$e7d251cf909c6ab9() {
    if (!$1eb80e36873dc327$var$outros.r) $1eb80e36873dc327$export$3f1fcd837f99a9ab($1eb80e36873dc327$var$outros.c);
    $1eb80e36873dc327$var$outros = $1eb80e36873dc327$var$outros.p;
}
function $1eb80e36873dc327$export$9e951caa2db2b1da(block, local) {
    if (block && block.i) {
        $1eb80e36873dc327$var$outroing.delete(block);
        block.i(local);
    }
}
function $1eb80e36873dc327$export$fdd20dba65b2c00e(block, local, detach, callback) {
    if (block && block.o) {
        if ($1eb80e36873dc327$var$outroing.has(block)) return;
        $1eb80e36873dc327$var$outroing.add(block);
        $1eb80e36873dc327$var$outros.c.push(()=>{
            $1eb80e36873dc327$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
const $1eb80e36873dc327$var$null_transition = {
    duration: 0
};
function $1eb80e36873dc327$export$60774c4a339e0bce(node, fn, params) {
    const options = {
        direction: "in"
    };
    let config = fn(node, params, options);
    let running = false;
    let animation_name;
    let task;
    let uid = 0;
    function cleanup() {
        if (animation_name) $1eb80e36873dc327$var$delete_rule(node, animation_name);
    }
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $1eb80e36873dc327$export$f0954fd7d5368655, tick: tick = $1eb80e36873dc327$export$8793edee2d425525, css: css } = config || $1eb80e36873dc327$var$null_transition;
        if (css) animation_name = $1eb80e36873dc327$var$create_rule(node, 0, 1, duration, delay, easing, css, uid++);
        tick(0, 1);
        const start_time = $1eb80e36873dc327$export$461939dd4422153() + delay;
        const end_time = start_time + duration;
        if (task) task.abort();
        running = true;
        $1eb80e36873dc327$export$8851747095d022df(()=>$1eb80e36873dc327$var$dispatch(node, true, "start"));
        task = $1eb80e36873dc327$export$f9ef67375ddc185((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(1, 0);
                    $1eb80e36873dc327$var$dispatch(node, true, "end");
                    cleanup();
                    return running = false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(t, 1 - t);
                }
            }
            return running;
        });
    }
    let started = false;
    return {
        start () {
            if (started) return;
            started = true;
            $1eb80e36873dc327$var$delete_rule(node);
            if ($1eb80e36873dc327$export$b451353ebd749597(config)) {
                config = config(options);
                $1eb80e36873dc327$var$wait().then(go);
            } else go();
        },
        invalidate () {
            started = false;
        },
        end () {
            if (running) {
                cleanup();
                running = false;
            }
        }
    };
}
function $1eb80e36873dc327$export$f77bfa1b5f956ef9(node, fn, params) {
    const options = {
        direction: "out"
    };
    let config = fn(node, params, options);
    let running = true;
    let animation_name;
    const group = $1eb80e36873dc327$var$outros;
    group.r += 1;
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $1eb80e36873dc327$export$f0954fd7d5368655, tick: tick = $1eb80e36873dc327$export$8793edee2d425525, css: css } = config || $1eb80e36873dc327$var$null_transition;
        if (css) animation_name = $1eb80e36873dc327$var$create_rule(node, 1, 0, duration, delay, easing, css);
        const start_time = $1eb80e36873dc327$export$461939dd4422153() + delay;
        const end_time = start_time + duration;
        $1eb80e36873dc327$export$8851747095d022df(()=>$1eb80e36873dc327$var$dispatch(node, false, "start"));
        $1eb80e36873dc327$export$f9ef67375ddc185((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(0, 1);
                    $1eb80e36873dc327$var$dispatch(node, false, "end");
                    if (!--group.r) // this will result in `end()` being called,
                    // so we don't need to clean up here
                    $1eb80e36873dc327$export$3f1fcd837f99a9ab(group.c);
                    return false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(1 - t, t);
                }
            }
            return running;
        });
    }
    if ($1eb80e36873dc327$export$b451353ebd749597(config)) $1eb80e36873dc327$var$wait().then(()=>{
        // @ts-ignore
        config = config(options);
        go();
    });
    else go();
    return {
        end (reset) {
            if (reset && config.tick) config.tick(1, 0);
            if (running) {
                if (animation_name) $1eb80e36873dc327$var$delete_rule(node, animation_name);
                running = false;
            }
        }
    };
}
function $1eb80e36873dc327$export$20b54ee3658479fb(node, fn, params, intro) {
    const options = {
        direction: "both"
    };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name) $1eb80e36873dc327$var$delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = program.b - t;
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d: d,
            duration: duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $1eb80e36873dc327$export$f0954fd7d5368655, tick: tick = $1eb80e36873dc327$export$8793edee2d425525, css: css } = config || $1eb80e36873dc327$var$null_transition;
        const program = {
            start: $1eb80e36873dc327$export$461939dd4422153() + delay,
            b: b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = $1eb80e36873dc327$var$outros;
            $1eb80e36873dc327$var$outros.r += 1;
        }
        if (running_program || pending_program) pending_program = program;
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = $1eb80e36873dc327$var$create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b) tick(0, 1);
            running_program = init(program, duration);
            $1eb80e36873dc327$export$8851747095d022df(()=>$1eb80e36873dc327$var$dispatch(node, b, "start"));
            $1eb80e36873dc327$export$f9ef67375ddc185((now)=>{
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    $1eb80e36873dc327$var$dispatch(node, running_program.b, "start");
                    if (css) {
                        clear_animation();
                        animation_name = $1eb80e36873dc327$var$create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        $1eb80e36873dc327$var$dispatch(node, running_program.b, "end");
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) // intro — we can tidy up immediately
                            clear_animation();
                            else // outro — needs to be coordinated
                            if (!--running_program.group.r) $1eb80e36873dc327$export$3f1fcd837f99a9ab(running_program.group.c);
                        }
                        running_program = null;
                    } else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run (b) {
            if ($1eb80e36873dc327$export$b451353ebd749597(config)) $1eb80e36873dc327$var$wait().then(()=>{
                // @ts-ignore
                config = config(options);
                go(b);
            });
            else go(b);
        },
        end () {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}
function $1eb80e36873dc327$export$784d33b211c10e0c(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token) return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) info.blocks.forEach((block, i)=>{
                if (i !== index && block) {
                    $1eb80e36873dc327$export$b074532eec6b252c();
                    $1eb80e36873dc327$export$fdd20dba65b2c00e(block, 1, 1, ()=>{
                        if (info.blocks[i] === block) info.blocks[i] = null;
                    });
                    $1eb80e36873dc327$export$e7d251cf909c6ab9();
                }
            });
            else info.block.d(1);
            block.c();
            $1eb80e36873dc327$export$9e951caa2db2b1da(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks) info.blocks[index] = block;
        if (needs_flush) $1eb80e36873dc327$export$4909b86c8034bf73();
    }
    if ($1eb80e36873dc327$export$7666b03abe8479da(promise)) {
        const current_component = $1eb80e36873dc327$export$d19094f0a5fb37fa();
        promise.then((value)=>{
            $1eb80e36873dc327$export$e72a4c53a1d11dfc(current_component);
            update(info.then, 1, info.value, value);
            $1eb80e36873dc327$export$e72a4c53a1d11dfc(null);
        }, (error)=>{
            $1eb80e36873dc327$export$e72a4c53a1d11dfc(current_component);
            update(info.catch, 2, info.error, error);
            $1eb80e36873dc327$export$e72a4c53a1d11dfc(null);
            if (!info.hasCatch) throw error;
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    } else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function $1eb80e36873dc327$export$69ebd9d202167ab4(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved: resolved } = info;
    if (info.current === info.then) child_ctx[info.value] = resolved;
    if (info.current === info.catch) child_ctx[info.error] = resolved;
    info.block.p(child_ctx, dirty);
}
const $1eb80e36873dc327$export$816be348776d53c1 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : $parcel$global;
function $1eb80e36873dc327$export$75442db144d4e64e(block, lookup) {
    block.d(1);
    lookup.delete(block.key);
}
function $1eb80e36873dc327$export$34db5f5dc4992cab(block, lookup) {
    $1eb80e36873dc327$export$fdd20dba65b2c00e(block, 1, 1, ()=>{
        lookup.delete(block.key);
    });
}
function $1eb80e36873dc327$export$ba06fda9300662d1(block, lookup) {
    block.f();
    $1eb80e36873dc327$export$75442db144d4e64e(block, lookup);
}
function $1eb80e36873dc327$export$6fdc494652858fb8(block, lookup) {
    block.f();
    $1eb80e36873dc327$export$34db5f5dc4992cab(block, lookup);
}
function $1eb80e36873dc327$export$1c17fe0cd58c4da7(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while(i--)old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while(i--){
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        } else if (dynamic) // defer updates until all the DOM shuffling is done
        updates.push(()=>block.p(child_ctx, dirty));
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        $1eb80e36873dc327$export$9e951caa2db2b1da(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while(o && n){
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        } else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        } else if (!lookup.has(new_key) || will_move.has(new_key)) insert(new_block);
        else if (did_move.has(old_key)) o--;
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        } else {
            will_move.add(old_key);
            o--;
        }
    }
    while(o--){
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
    }
    while(n)insert(new_blocks[n - 1]);
    $1eb80e36873dc327$export$3f1fcd837f99a9ab(updates);
    return new_blocks;
}
function $1eb80e36873dc327$export$7a64eb7bd69e8d3f(ctx, list, get_context, get_key) {
    const keys = new Set();
    for(let i = 0; i < list.length; i++){
        const key = get_key(get_context(ctx, list, i));
        if (keys.has(key)) throw new Error("Cannot have duplicate keys in a keyed each");
        keys.add(key);
    }
}
function $1eb80e36873dc327$export$eea1060726e9ab6(levels, updates) {
    const update = {};
    const to_null_out = {};
    const accounted_for = {
        $$scope: 1
    };
    let i = levels.length;
    while(i--){
        const o = levels[i];
        const n = updates[i];
        if (n) {
            for(const key in o)if (!(key in n)) to_null_out[key] = 1;
            for(const key in n)if (!accounted_for[key]) {
                update[key] = n[key];
                accounted_for[key] = 1;
            }
            levels[i] = n;
        } else for(const key in o)accounted_for[key] = 1;
    }
    for(const key in to_null_out)if (!(key in update)) update[key] = undefined;
    return update;
}
function $1eb80e36873dc327$export$19fac21209f8779d(spread_props) {
    return typeof spread_props === "object" && spread_props !== null ? spread_props : {};
}
const $1eb80e36873dc327$var$_boolean_attributes = [
    "allowfullscreen",
    "allowpaymentrequest",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "hidden",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected"
];
/**
 * List of HTML boolean attributes (e.g. `<input disabled>`).
 * Source: https://html.spec.whatwg.org/multipage/indices.html
 */ const $1eb80e36873dc327$var$boolean_attributes = new Set([
    ...$1eb80e36873dc327$var$_boolean_attributes
]);
/** regex of all html void element names */ const $1eb80e36873dc327$var$void_element_names = /^(?:area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/;
function $1eb80e36873dc327$export$66cf70365c175aee(name) {
    return $1eb80e36873dc327$var$void_element_names.test(name) || name.toLowerCase() === "!doctype";
}
const $1eb80e36873dc327$export$44426fed7d33cfd0 = /[\s'">/=\u{FDD0}-\u{FDEF}\u{FFFE}\u{FFFF}\u{1FFFE}\u{1FFFF}\u{2FFFE}\u{2FFFF}\u{3FFFE}\u{3FFFF}\u{4FFFE}\u{4FFFF}\u{5FFFE}\u{5FFFF}\u{6FFFE}\u{6FFFF}\u{7FFFE}\u{7FFFF}\u{8FFFE}\u{8FFFF}\u{9FFFE}\u{9FFFF}\u{AFFFE}\u{AFFFF}\u{BFFFE}\u{BFFFF}\u{CFFFE}\u{CFFFF}\u{DFFFE}\u{DFFFF}\u{EFFFE}\u{EFFFF}\u{FFFFE}\u{FFFFF}\u{10FFFE}\u{10FFFF}]/u;
// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
// https://infra.spec.whatwg.org/#noncharacter
function $1eb80e36873dc327$export$3ae0fd4797ed47c8(args, attrs_to_add) {
    const attributes = Object.assign({}, ...args);
    if (attrs_to_add) {
        const classes_to_add = attrs_to_add.classes;
        const styles_to_add = attrs_to_add.styles;
        if (classes_to_add) {
            if (attributes.class == null) attributes.class = classes_to_add;
            else attributes.class += " " + classes_to_add;
        }
        if (styles_to_add) {
            if (attributes.style == null) attributes.style = $1eb80e36873dc327$var$style_object_to_string(styles_to_add);
            else attributes.style = $1eb80e36873dc327$var$style_object_to_string($1eb80e36873dc327$export$59f1d5f66ae7e219(attributes.style, styles_to_add));
        }
    }
    let str = "";
    Object.keys(attributes).forEach((name)=>{
        if ($1eb80e36873dc327$export$44426fed7d33cfd0.test(name)) return;
        const value = attributes[name];
        if (value === true) str += " " + name;
        else if ($1eb80e36873dc327$var$boolean_attributes.has(name.toLowerCase())) {
            if (value) str += " " + name;
        } else if (value != null) str += ` ${name}="${value}"`;
    });
    return str;
}
function $1eb80e36873dc327$export$59f1d5f66ae7e219(style_attribute, style_directive) {
    const style_object = {};
    for (const individual_style of style_attribute.split(";")){
        const colon_index = individual_style.indexOf(":");
        const name = individual_style.slice(0, colon_index).trim();
        const value = individual_style.slice(colon_index + 1).trim();
        if (!name) continue;
        style_object[name] = value;
    }
    for(const name in style_directive){
        const value = style_directive[name];
        if (value) style_object[name] = value;
        else delete style_object[name];
    }
    return style_object;
}
const $1eb80e36873dc327$var$ATTR_REGEX = /[&"]/g;
const $1eb80e36873dc327$var$CONTENT_REGEX = /[&<]/g;
/**
 * Note: this method is performance sensitive and has been optimized
 * https://github.com/sveltejs/svelte/pull/5701
 */ function $1eb80e36873dc327$export$4e7f196112fea3c5(value, is_attr = false) {
    const str = String(value);
    const pattern = is_attr ? $1eb80e36873dc327$var$ATTR_REGEX : $1eb80e36873dc327$var$CONTENT_REGEX;
    pattern.lastIndex = 0;
    let escaped = "";
    let last = 0;
    while(pattern.test(str)){
        const i = pattern.lastIndex - 1;
        const ch = str[i];
        escaped += str.substring(last, i) + (ch === "&" ? "&amp;" : ch === '"' ? "&quot;" : "&lt;");
        last = i + 1;
    }
    return escaped + str.substring(last);
}
function $1eb80e36873dc327$export$7997b567c4bb0bed(value) {
    // keep booleans, null, and undefined for the sake of `spread`
    const should_escape = typeof value === "string" || value && typeof value === "object";
    return should_escape ? $1eb80e36873dc327$export$4e7f196112fea3c5(value, true) : value;
}
function $1eb80e36873dc327$export$9a9efab655aeaa3(obj) {
    const result = {};
    for(const key in obj)result[key] = $1eb80e36873dc327$export$7997b567c4bb0bed(obj[key]);
    return result;
}
function $1eb80e36873dc327$export$79b2f7037acddd43(items, fn) {
    let str = "";
    for(let i = 0; i < items.length; i += 1)str += fn(items[i], i);
    return str;
}
const $1eb80e36873dc327$export$84983a965b218545 = {
    $$render: ()=>""
};
function $1eb80e36873dc327$export$930da2a45a215472(component, name) {
    if (!component || !component.$$render) {
        if (name === "svelte:component") name += " this={...}";
        throw new Error(`<${name}> is not a valid SSR component. You may need to review your build config to ensure that dependencies are compiled, rather than imported as pre-compiled modules. Otherwise you may need to fix a <${name}>.`);
    }
    return component;
}
function $1eb80e36873dc327$export$1c9f709888824e05(file, line, column, values) {
    console.log(`{@debug} ${file ? file + " " : ""}(${line}:${column})`); // eslint-disable-line no-console
    console.log(values); // eslint-disable-line no-console
    return "";
}
let $1eb80e36873dc327$var$on_destroy;
function $1eb80e36873dc327$export$caab6e78cc1ff033(fn) {
    function $$render(result, props, bindings, slots, context) {
        const parent_component = $1eb80e36873dc327$export$3ec7acbf47bb7c71;
        const $$ = {
            on_destroy: $1eb80e36873dc327$var$on_destroy,
            context: new Map(context || (parent_component ? parent_component.$$.context : [])),
            // these will be immediately discarded
            on_mount: [],
            before_update: [],
            after_update: [],
            callbacks: $1eb80e36873dc327$export$31092919e374e43c()
        };
        $1eb80e36873dc327$export$e72a4c53a1d11dfc({
            $$: $$
        });
        const html = fn(result, props, bindings, slots);
        $1eb80e36873dc327$export$e72a4c53a1d11dfc(parent_component);
        return html;
    }
    return {
        render: (props = {}, { $$slots: $$slots = {}, context: context = new Map() } = {})=>{
            $1eb80e36873dc327$var$on_destroy = [];
            const result = {
                title: "",
                head: "",
                css: new Set()
            };
            const html = $$render(result, props, {}, $$slots, context);
            $1eb80e36873dc327$export$3f1fcd837f99a9ab($1eb80e36873dc327$var$on_destroy);
            return {
                html: html,
                css: {
                    code: Array.from(result.css).map((css)=>css.code).join("\n"),
                    map: null // TODO
                },
                head: result.title + result.head
            };
        },
        $$render: $$render
    };
}
function $1eb80e36873dc327$export$b442e23403500748(name, value, boolean) {
    if (value == null || boolean && !value) return "";
    const assignment = boolean && value === true ? "" : `="${$1eb80e36873dc327$export$4e7f196112fea3c5(value, true)}"`;
    return ` ${name}${assignment}`;
}
function $1eb80e36873dc327$export$b377786ff5e86c4c(classes) {
    return classes ? ` class="${classes}"` : "";
}
function $1eb80e36873dc327$var$style_object_to_string(style_object) {
    return Object.keys(style_object).filter((key)=>style_object[key]).map((key)=>`${key}: ${$1eb80e36873dc327$export$7997b567c4bb0bed(style_object[key])};`).join(" ");
}
function $1eb80e36873dc327$export$97f189f545ba14e6(style_object) {
    const styles = $1eb80e36873dc327$var$style_object_to_string(style_object);
    return styles ? ` style="${styles}"` : "";
}
function $1eb80e36873dc327$export$2385a24977818dd0(component, name, callback) {
    const index = component.$$.props[name];
    if (index !== undefined) {
        component.$$.bound[index] = callback;
        callback(component.$$.ctx[index]);
    }
}
function $1eb80e36873dc327$export$3dac9ce53bfc6012(block) {
    block && block.c();
}
function $1eb80e36873dc327$export$a73b5a5296efe9fc(block, parent_nodes) {
    block && block.l(parent_nodes);
}
function $1eb80e36873dc327$export$18b26e9aca35251(component, target, anchor, customElement) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) // onMount happens before the initial afterUpdate
    $1eb80e36873dc327$export$8851747095d022df(()=>{
        const new_on_destroy = component.$$.on_mount.map($1eb80e36873dc327$export$889ea624f2cb2c57).filter($1eb80e36873dc327$export$b451353ebd749597);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $1eb80e36873dc327$export$3f1fcd837f99a9ab(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($1eb80e36873dc327$export$8851747095d022df);
}
function $1eb80e36873dc327$export$ddd2890b29e5aebe(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $1eb80e36873dc327$export$99d0f1b00233da03($$.after_update);
        $1eb80e36873dc327$export$3f1fcd837f99a9ab($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function $1eb80e36873dc327$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $1eb80e36873dc327$export$befe60e985bb3cce.push(component);
        $1eb80e36873dc327$export$c3d55cc721051d24();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function $1eb80e36873dc327$export$2cd8252107eb640b(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [
    -1
]) {
    const parent_component = $1eb80e36873dc327$export$3ec7acbf47bb7c71;
    $1eb80e36873dc327$export$e72a4c53a1d11dfc(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $1eb80e36873dc327$export$8793edee2d425525,
        not_equal: not_equal,
        bound: $1eb80e36873dc327$export$31092919e374e43c(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $1eb80e36873dc327$export$31092919e374e43c(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $1eb80e36873dc327$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $1eb80e36873dc327$export$3f1fcd837f99a9ab($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            $1eb80e36873dc327$export$237ef195d41ae60c();
            const nodes = $1eb80e36873dc327$export$bacb5cc5a11aef16(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($1eb80e36873dc327$export$3f780019ff766da6);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $1eb80e36873dc327$export$9e951caa2db2b1da(component.$$.fragment);
        $1eb80e36873dc327$export$18b26e9aca35251(component, options.target, options.anchor, options.customElement);
        $1eb80e36873dc327$export$4b42d81e6a3b0cd2();
        $1eb80e36873dc327$export$4909b86c8034bf73();
    }
    $1eb80e36873dc327$export$e72a4c53a1d11dfc(parent_component);
}
let $1eb80e36873dc327$export$1add084de80b788;
if (typeof HTMLElement === "function") $1eb80e36873dc327$export$1add084de80b788 = class extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        const { on_mount: on_mount } = this.$$;
        this.$$.on_disconnect = on_mount.map($1eb80e36873dc327$export$889ea624f2cb2c57).filter($1eb80e36873dc327$export$b451353ebd749597);
        // @ts-ignore todo: improve typings
        for(const key in this.$$.slotted)// @ts-ignore todo: improve typings
        this.appendChild(this.$$.slotted[key]);
    }
    attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
    }
    disconnectedCallback() {
        $1eb80e36873dc327$export$3f1fcd837f99a9ab(this.$$.on_disconnect);
    }
    $destroy() {
        $1eb80e36873dc327$export$ddd2890b29e5aebe(this, 1);
        this.$destroy = $1eb80e36873dc327$export$8793edee2d425525;
    }
    $on(type, callback) {
        // TODO should this delegate to addEventListener?
        if (!$1eb80e36873dc327$export$b451353ebd749597(callback)) return $1eb80e36873dc327$export$8793edee2d425525;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$1eb80e36873dc327$export$cc2e736493e359e2($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
};
/**
 * Base class for Svelte components. Used when dev=false.
 */ class $1eb80e36873dc327$export$a9dbe146ce5e8823 {
    $destroy() {
        $1eb80e36873dc327$export$ddd2890b29e5aebe(this, 1);
        this.$destroy = $1eb80e36873dc327$export$8793edee2d425525;
    }
    $on(type, callback) {
        if (!$1eb80e36873dc327$export$b451353ebd749597(callback)) return $1eb80e36873dc327$export$8793edee2d425525;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$1eb80e36873dc327$export$cc2e736493e359e2($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}
function $1eb80e36873dc327$export$bf18b7db1b422af6(type, detail) {
    document.dispatchEvent($1eb80e36873dc327$export$da00493480283d6b(type, Object.assign({
        version: "3.58.0"
    }, detail), {
        bubbles: true
    }));
}
function $1eb80e36873dc327$export$e914ea5e9eb9f312(target, node) {
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node
    });
    $1eb80e36873dc327$export$10d8903dec122b9d(target, node);
}
function $1eb80e36873dc327$export$3d7d958f073d996a(target, node) {
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node
    });
    $1eb80e36873dc327$export$172bc581f7520fb7(target, node);
}
function $1eb80e36873dc327$export$f6e687e9f4e253bb(target, node, anchor) {
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node,
        anchor: anchor
    });
    $1eb80e36873dc327$export$21a5ca8aa77d35ff(target, node, anchor);
}
function $1eb80e36873dc327$export$b7da215dbd2db801(target, node, anchor) {
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node,
        anchor: anchor
    });
    $1eb80e36873dc327$export$f7a8880e5fbca7f8(target, node, anchor);
}
function $1eb80e36873dc327$export$9e710e34d240cc7b(node) {
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMRemove", {
        node: node
    });
    $1eb80e36873dc327$export$3f780019ff766da6(node);
}
function $1eb80e36873dc327$export$a21682f9877e0498(before, after) {
    while(before.nextSibling && before.nextSibling !== after)$1eb80e36873dc327$export$9e710e34d240cc7b(before.nextSibling);
}
function $1eb80e36873dc327$export$75f8da77d42fcb5(after) {
    while(after.previousSibling)$1eb80e36873dc327$export$9e710e34d240cc7b(after.previousSibling);
}
function $1eb80e36873dc327$export$c97ff19765ca3394(before) {
    while(before.nextSibling)$1eb80e36873dc327$export$9e710e34d240cc7b(before.nextSibling);
}
function $1eb80e36873dc327$export$995228cbf38b380f(node, event, handler, options, has_prevent_default, has_stop_propagation, has_stop_immediate_propagation) {
    const modifiers = options === true ? [
        "capture"
    ] : options ? Array.from(Object.keys(options)) : [];
    if (has_prevent_default) modifiers.push("preventDefault");
    if (has_stop_propagation) modifiers.push("stopPropagation");
    if (has_stop_immediate_propagation) modifiers.push("stopImmediatePropagation");
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMAddEventListener", {
        node: node,
        event: event,
        handler: handler,
        modifiers: modifiers
    });
    const dispose = $1eb80e36873dc327$export$63174c828edd6ff8(node, event, handler, options);
    return ()=>{
        $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMRemoveEventListener", {
            node: node,
            event: event,
            handler: handler,
            modifiers: modifiers
        });
        dispose();
    };
}
function $1eb80e36873dc327$export$a99ae29e763a6619(node, attribute, value) {
    $1eb80e36873dc327$export$7aabe8b3a840d2fd(node, attribute, value);
    if (value == null) $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMRemoveAttribute", {
        node: node,
        attribute: attribute
    });
    else $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMSetAttribute", {
        node: node,
        attribute: attribute,
        value: value
    });
}
function $1eb80e36873dc327$export$1a8b8000a5a2f955(node, property, value) {
    node[property] = value;
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMSetProperty", {
        node: node,
        property: property,
        value: value
    });
}
function $1eb80e36873dc327$export$9bdcf8c0c1039da5(node, property, value) {
    node.dataset[property] = value;
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMSetDataset", {
        node: node,
        property: property,
        value: value
    });
}
function $1eb80e36873dc327$export$df702e4649e15993(text, data) {
    data = "" + data;
    if (text.data === data) return;
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMSetData", {
        node: text,
        data: data
    });
    text.data = data;
}
function $1eb80e36873dc327$export$3eb5e573cac73e07(text, data) {
    data = "" + data;
    if (text.wholeText === data) return;
    $1eb80e36873dc327$export$bf18b7db1b422af6("SvelteDOMSetData", {
        node: text,
        data: data
    });
    text.data = data;
}
function $1eb80e36873dc327$export$3e6e8a2bfe41f53c(text, data, attr_value) {
    if (~$1eb80e36873dc327$export$e3d839ffa95f7481.indexOf(attr_value)) $1eb80e36873dc327$export$3eb5e573cac73e07(text, data);
    else $1eb80e36873dc327$export$df702e4649e15993(text, data);
}
function $1eb80e36873dc327$export$dc082ae212b9df(arg) {
    if (typeof arg !== "string" && !(arg && typeof arg === "object" && "length" in arg)) {
        let msg = "{#each} only iterates over array-like objects.";
        if (typeof Symbol === "function" && arg && Symbol.iterator in arg) msg += " You can use a spread to convert this iterable into an array.";
        throw new Error(msg);
    }
}
function $1eb80e36873dc327$export$d0e654d7c8c8b385(name, slot, keys) {
    for (const slot_key of Object.keys(slot))if (!~keys.indexOf(slot_key)) console.warn(`<${name}> received an unexpected slot "${slot_key}".`);
}
function $1eb80e36873dc327$export$3bfb1dac7720acdf(tag) {
    const is_string = typeof tag === "string";
    if (tag && !is_string) throw new Error('<svelte:element> expects "this" attribute to be a string.');
}
function $1eb80e36873dc327$export$604f774bac268e5a(tag) {
    if (tag && $1eb80e36873dc327$export$66cf70365c175aee(tag)) console.warn(`<svelte:element this="${tag}"> is self-closing and cannot have content.`);
}
function $1eb80e36873dc327$export$12b4fecd7d9ee1e9(component, props) {
    const error_message = "this={...} of <svelte:component> should specify a Svelte component.";
    try {
        const instance = new component(props);
        if (!instance.$$ || !instance.$set || !instance.$on || !instance.$destroy) throw new Error(error_message);
        return instance;
    } catch (err) {
        const { message: message } = err;
        if (typeof message === "string" && message.indexOf("is not a constructor") !== -1) throw new Error(error_message);
        else throw err;
    }
}
/**
 * Base class for Svelte components with some minor dev-enhancements. Used when dev=true.
 */ class $1eb80e36873dc327$export$5a58a898d1ca0447 extends $1eb80e36873dc327$export$a9dbe146ce5e8823 {
    constructor(options){
        if (!options || !options.target && !options.$$inline) throw new Error("'target' is a required option");
        super();
    }
    $destroy() {
        super.$destroy();
        this.$destroy = ()=>{
            console.warn("Component was already destroyed"); // eslint-disable-line no-console
        };
    }
    $capture_state() {}
    $inject_state() {}
}
/**
 * Base class to create strongly typed Svelte components.
 * This only exists for typing purposes and should be used in `.d.ts` files.
 *
 * ### Example:
 *
 * You have component library on npm called `component-library`, from which
 * you export a component called `MyComponent`. For Svelte+TypeScript users,
 * you want to provide typings. Therefore you create a `index.d.ts`:
 * ```ts
 * import { SvelteComponentTyped } from "svelte";
 * export class MyComponent extends SvelteComponentTyped<{foo: string}> {}
 * ```
 * Typing this makes it possible for IDEs like VS Code with the Svelte extension
 * to provide intellisense and to use the component like this in a Svelte file
 * with TypeScript:
 * ```svelte
 * <script lang="ts">
 * 	import { MyComponent } from "component-library";
 * </script>
 * <MyComponent foo={'bar'} />
 * ```
 *
 * #### Why not make this part of `SvelteComponent(Dev)`?
 * Because
 * ```ts
 * class ASubclassOfSvelteComponent extends SvelteComponent<{foo: string}> {}
 * const component: typeof SvelteComponent = ASubclassOfSvelteComponent;
 * ```
 * will throw a type error, so we need to separate the more strictly typed class.
 */ class $1eb80e36873dc327$export$3364bb23ce325405 extends $1eb80e36873dc327$export$5a58a898d1ca0447 {
    constructor(options){
        super(options);
    }
}
function $1eb80e36873dc327$export$3fad216b09e0538b(timeout) {
    const start = Date.now();
    return ()=>{
        if (Date.now() - start > timeout) throw new Error("Infinite loop detected");
    };
}






var $c4fef850b754c7a3$exports = {};

$parcel$export($c4fef850b754c7a3$exports, "ClassTransformer", function () { return $c4fef850b754c7a3$export$a2913a430ed25873; });
var $71bf10fcd5307205$exports = {};

$parcel$export($71bf10fcd5307205$exports, "TransformOperationExecutor", function () { return $71bf10fcd5307205$export$21072316a7d73376; });
var $44e00c213ade0164$export$db472314407d6190;
(function(TransformationType) {
    TransformationType[TransformationType["PLAIN_TO_CLASS"] = 0] = "PLAIN_TO_CLASS";
    TransformationType[TransformationType["CLASS_TO_PLAIN"] = 1] = "CLASS_TO_PLAIN";
    TransformationType[TransformationType["CLASS_TO_CLASS"] = 2] = "CLASS_TO_CLASS";
})($44e00c213ade0164$export$db472314407d6190 || ($44e00c213ade0164$export$db472314407d6190 = {}));


/**
 * Storage all library metadata.
 */ var $498e3063a2ef33f4$export$d69bf929479c4eff = /** @class */ function() {
    function MetadataStorage() {
        // -------------------------------------------------------------------------
        // Properties
        // -------------------------------------------------------------------------
        this._typeMetadatas = new Map();
        this._transformMetadatas = new Map();
        this._exposeMetadatas = new Map();
        this._excludeMetadatas = new Map();
        this._ancestorsMap = new Map();
    }
    // -------------------------------------------------------------------------
    // Adder Methods
    // -------------------------------------------------------------------------
    MetadataStorage.prototype.addTypeMetadata = function(metadata) {
        if (!this._typeMetadatas.has(metadata.target)) this._typeMetadatas.set(metadata.target, new Map());
        this._typeMetadatas.get(metadata.target).set(metadata.propertyName, metadata);
    };
    MetadataStorage.prototype.addTransformMetadata = function(metadata) {
        if (!this._transformMetadatas.has(metadata.target)) this._transformMetadatas.set(metadata.target, new Map());
        if (!this._transformMetadatas.get(metadata.target).has(metadata.propertyName)) this._transformMetadatas.get(metadata.target).set(metadata.propertyName, []);
        this._transformMetadatas.get(metadata.target).get(metadata.propertyName).push(metadata);
    };
    MetadataStorage.prototype.addExposeMetadata = function(metadata) {
        if (!this._exposeMetadatas.has(metadata.target)) this._exposeMetadatas.set(metadata.target, new Map());
        this._exposeMetadatas.get(metadata.target).set(metadata.propertyName, metadata);
    };
    MetadataStorage.prototype.addExcludeMetadata = function(metadata) {
        if (!this._excludeMetadatas.has(metadata.target)) this._excludeMetadatas.set(metadata.target, new Map());
        this._excludeMetadatas.get(metadata.target).set(metadata.propertyName, metadata);
    };
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    MetadataStorage.prototype.findTransformMetadatas = function(target, propertyName, transformationType) {
        return this.findMetadatas(this._transformMetadatas, target, propertyName).filter(function(metadata) {
            if (!metadata.options) return true;
            if (metadata.options.toClassOnly === true && metadata.options.toPlainOnly === true) return true;
            if (metadata.options.toClassOnly === true) return transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS || transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS;
            if (metadata.options.toPlainOnly === true) return transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN;
            return true;
        });
    };
    MetadataStorage.prototype.findExcludeMetadata = function(target, propertyName) {
        return this.findMetadata(this._excludeMetadatas, target, propertyName);
    };
    MetadataStorage.prototype.findExposeMetadata = function(target, propertyName) {
        return this.findMetadata(this._exposeMetadatas, target, propertyName);
    };
    MetadataStorage.prototype.findExposeMetadataByCustomName = function(target, name) {
        return this.getExposedMetadatas(target).find(function(metadata) {
            return metadata.options && metadata.options.name === name;
        });
    };
    MetadataStorage.prototype.findTypeMetadata = function(target, propertyName) {
        return this.findMetadata(this._typeMetadatas, target, propertyName);
    };
    MetadataStorage.prototype.getStrategy = function(target) {
        var excludeMap = this._excludeMetadatas.get(target);
        var exclude = excludeMap && excludeMap.get(undefined);
        var exposeMap = this._exposeMetadatas.get(target);
        var expose = exposeMap && exposeMap.get(undefined);
        if (exclude && expose || !exclude && !expose) return "none";
        return exclude ? "excludeAll" : "exposeAll";
    };
    MetadataStorage.prototype.getExposedMetadatas = function(target) {
        return this.getMetadata(this._exposeMetadatas, target);
    };
    MetadataStorage.prototype.getExcludedMetadatas = function(target) {
        return this.getMetadata(this._excludeMetadatas, target);
    };
    MetadataStorage.prototype.getExposedProperties = function(target, transformationType) {
        return this.getExposedMetadatas(target).filter(function(metadata) {
            if (!metadata.options) return true;
            if (metadata.options.toClassOnly === true && metadata.options.toPlainOnly === true) return true;
            if (metadata.options.toClassOnly === true) return transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS || transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS;
            if (metadata.options.toPlainOnly === true) return transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN;
            return true;
        }).map(function(metadata) {
            return metadata.propertyName;
        });
    };
    MetadataStorage.prototype.getExcludedProperties = function(target, transformationType) {
        return this.getExcludedMetadatas(target).filter(function(metadata) {
            if (!metadata.options) return true;
            if (metadata.options.toClassOnly === true && metadata.options.toPlainOnly === true) return true;
            if (metadata.options.toClassOnly === true) return transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS || transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS;
            if (metadata.options.toPlainOnly === true) return transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN;
            return true;
        }).map(function(metadata) {
            return metadata.propertyName;
        });
    };
    MetadataStorage.prototype.clear = function() {
        this._typeMetadatas.clear();
        this._exposeMetadatas.clear();
        this._excludeMetadatas.clear();
        this._ancestorsMap.clear();
    };
    // -------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------
    MetadataStorage.prototype.getMetadata = function(metadatas, target) {
        var metadataFromTargetMap = metadatas.get(target);
        var metadataFromTarget;
        if (metadataFromTargetMap) metadataFromTarget = Array.from(metadataFromTargetMap.values()).filter(function(meta) {
            return meta.propertyName !== undefined;
        });
        var metadataFromAncestors = [];
        for(var _i = 0, _a = this.getAncestors(target); _i < _a.length; _i++){
            var ancestor = _a[_i];
            var ancestorMetadataMap = metadatas.get(ancestor);
            if (ancestorMetadataMap) {
                var metadataFromAncestor = Array.from(ancestorMetadataMap.values()).filter(function(meta) {
                    return meta.propertyName !== undefined;
                });
                metadataFromAncestors.push.apply(metadataFromAncestors, metadataFromAncestor);
            }
        }
        return metadataFromAncestors.concat(metadataFromTarget || []);
    };
    MetadataStorage.prototype.findMetadata = function(metadatas, target, propertyName) {
        var metadataFromTargetMap = metadatas.get(target);
        if (metadataFromTargetMap) {
            var metadataFromTarget = metadataFromTargetMap.get(propertyName);
            if (metadataFromTarget) return metadataFromTarget;
        }
        for(var _i = 0, _a = this.getAncestors(target); _i < _a.length; _i++){
            var ancestor = _a[_i];
            var ancestorMetadataMap = metadatas.get(ancestor);
            if (ancestorMetadataMap) {
                var ancestorResult = ancestorMetadataMap.get(propertyName);
                if (ancestorResult) return ancestorResult;
            }
        }
        return undefined;
    };
    MetadataStorage.prototype.findMetadatas = function(metadatas, target, propertyName) {
        var metadataFromTargetMap = metadatas.get(target);
        var metadataFromTarget;
        if (metadataFromTargetMap) metadataFromTarget = metadataFromTargetMap.get(propertyName);
        var metadataFromAncestorsTarget = [];
        for(var _i = 0, _a = this.getAncestors(target); _i < _a.length; _i++){
            var ancestor = _a[_i];
            var ancestorMetadataMap = metadatas.get(ancestor);
            if (ancestorMetadataMap) {
                if (ancestorMetadataMap.has(propertyName)) metadataFromAncestorsTarget.push.apply(metadataFromAncestorsTarget, ancestorMetadataMap.get(propertyName));
            }
        }
        return metadataFromAncestorsTarget.slice().reverse().concat((metadataFromTarget || []).slice().reverse());
    };
    MetadataStorage.prototype.getAncestors = function(target) {
        if (!target) return [];
        if (!this._ancestorsMap.has(target)) {
            var ancestors = [];
            for(var baseClass = Object.getPrototypeOf(target.prototype.constructor); typeof baseClass.prototype !== "undefined"; baseClass = Object.getPrototypeOf(baseClass.prototype.constructor))ancestors.push(baseClass);
            this._ancestorsMap.set(target, ancestors);
        }
        return this._ancestorsMap.get(target);
    };
    return MetadataStorage;
}();


var $e27954f872b4904a$export$1bf9ee49bb479962 = new (0, $498e3063a2ef33f4$export$d69bf929479c4eff)();



/**
 * This function returns the global object across Node and browsers.
 *
 * Note: `globalThis` is the standardized approach however it has been added to
 * Node.js in version 12. We need to include this snippet until Node 12 EOL.
 */ function $f358ca8705790871$export$a4e55266d2135a7f() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Cannot find name 'window'.
    if (typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Cannot find name 'window'.
    return window;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Cannot find name 'self'.
    if (typeof self !== "undefined") // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Cannot find name 'self'.
    return self;
}

function $df4b79576d25ea3b$export$4369c812aac99591(p) {
    return p !== null && typeof p === "object" && typeof p.then === "function";
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c053ce2433579b42$export$a143d493d941bafc;
var $c053ce2433579b42$export$e4cf37d7f6fb9e0a;
var $c053ce2433579b42$export$f99ded8fe4b79145;
var $c053ce2433579b42$export$599f31c3813fae4d;
"use strict";
var $7fdbc86ce70f3613$export$a48f0734ac7c2329;
var $7fdbc86ce70f3613$export$d622b2ad8d90c771;
var $7fdbc86ce70f3613$export$6100ba28696e12de;
"use strict";
$7fdbc86ce70f3613$export$a48f0734ac7c2329 = $7fdbc86ce70f3613$var$byteLength;
$7fdbc86ce70f3613$export$d622b2ad8d90c771 = $7fdbc86ce70f3613$var$toByteArray;
$7fdbc86ce70f3613$export$6100ba28696e12de = $7fdbc86ce70f3613$var$fromByteArray;
var $7fdbc86ce70f3613$var$lookup = [];
var $7fdbc86ce70f3613$var$revLookup = [];
var $7fdbc86ce70f3613$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $7fdbc86ce70f3613$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $7fdbc86ce70f3613$var$i = 0, $7fdbc86ce70f3613$var$len = $7fdbc86ce70f3613$var$code.length; $7fdbc86ce70f3613$var$i < $7fdbc86ce70f3613$var$len; ++$7fdbc86ce70f3613$var$i){
    $7fdbc86ce70f3613$var$lookup[$7fdbc86ce70f3613$var$i] = $7fdbc86ce70f3613$var$code[$7fdbc86ce70f3613$var$i];
    $7fdbc86ce70f3613$var$revLookup[$7fdbc86ce70f3613$var$code.charCodeAt($7fdbc86ce70f3613$var$i)] = $7fdbc86ce70f3613$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7fdbc86ce70f3613$var$revLookup["-".charCodeAt(0)] = 62;
$7fdbc86ce70f3613$var$revLookup["_".charCodeAt(0)] = 63;
function $7fdbc86ce70f3613$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7fdbc86ce70f3613$var$byteLength(b64) {
    var lens = $7fdbc86ce70f3613$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7fdbc86ce70f3613$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7fdbc86ce70f3613$var$toByteArray(b64) {
    var tmp;
    var lens = $7fdbc86ce70f3613$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7fdbc86ce70f3613$var$Arr($7fdbc86ce70f3613$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i)] << 18 | $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i)] << 2 | $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i)] << 10 | $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7fdbc86ce70f3613$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7fdbc86ce70f3613$var$tripletToBase64(num) {
    return $7fdbc86ce70f3613$var$lookup[num >> 18 & 0x3F] + $7fdbc86ce70f3613$var$lookup[num >> 12 & 0x3F] + $7fdbc86ce70f3613$var$lookup[num >> 6 & 0x3F] + $7fdbc86ce70f3613$var$lookup[num & 0x3F];
}
function $7fdbc86ce70f3613$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7fdbc86ce70f3613$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $7fdbc86ce70f3613$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7fdbc86ce70f3613$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7fdbc86ce70f3613$var$lookup[tmp >> 2] + $7fdbc86ce70f3613$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7fdbc86ce70f3613$var$lookup[tmp >> 10] + $7fdbc86ce70f3613$var$lookup[tmp >> 4 & 0x3F] + $7fdbc86ce70f3613$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $1a44eb3d99c71080$export$aafa59e2e03f2942;
var $1a44eb3d99c71080$export$68d8715fc104d294;
$1a44eb3d99c71080$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$1a44eb3d99c71080$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $c053ce2433579b42$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c053ce2433579b42$export$a143d493d941bafc = $c053ce2433579b42$var$Buffer;
$c053ce2433579b42$export$e4cf37d7f6fb9e0a = $c053ce2433579b42$var$SlowBuffer;
$c053ce2433579b42$export$f99ded8fe4b79145 = 50;
var $c053ce2433579b42$var$K_MAX_LENGTH = 0x7fffffff;
$c053ce2433579b42$export$599f31c3813fae4d = $c053ce2433579b42$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c053ce2433579b42$var$Buffer.TYPED_ARRAY_SUPPORT = $c053ce2433579b42$var$typedArraySupport();
if (!$c053ce2433579b42$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c053ce2433579b42$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c053ce2433579b42$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c053ce2433579b42$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c053ce2433579b42$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c053ce2433579b42$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c053ce2433579b42$var$createBuffer(length) {
    if (length > $c053ce2433579b42$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c053ce2433579b42$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c053ce2433579b42$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c053ce2433579b42$var$allocUnsafe(arg);
    }
    return $c053ce2433579b42$var$from(arg, encodingOrOffset, length);
}
$c053ce2433579b42$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c053ce2433579b42$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c053ce2433579b42$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c053ce2433579b42$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c053ce2433579b42$var$isInstance(value, ArrayBuffer) || value && $c053ce2433579b42$var$isInstance(value.buffer, ArrayBuffer)) return $c053ce2433579b42$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c053ce2433579b42$var$isInstance(value, SharedArrayBuffer) || value && $c053ce2433579b42$var$isInstance(value.buffer, SharedArrayBuffer))) return $c053ce2433579b42$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c053ce2433579b42$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c053ce2433579b42$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c053ce2433579b42$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c053ce2433579b42$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c053ce2433579b42$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c053ce2433579b42$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c053ce2433579b42$var$Buffer, Uint8Array);
function $c053ce2433579b42$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c053ce2433579b42$var$alloc(size, fill, encoding) {
    $c053ce2433579b42$var$assertSize(size);
    if (size <= 0) return $c053ce2433579b42$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c053ce2433579b42$var$createBuffer(size).fill(fill, encoding) : $c053ce2433579b42$var$createBuffer(size).fill(fill);
    return $c053ce2433579b42$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c053ce2433579b42$var$Buffer.alloc = function(size, fill, encoding) {
    return $c053ce2433579b42$var$alloc(size, fill, encoding);
};
function $c053ce2433579b42$var$allocUnsafe(size) {
    $c053ce2433579b42$var$assertSize(size);
    return $c053ce2433579b42$var$createBuffer(size < 0 ? 0 : $c053ce2433579b42$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c053ce2433579b42$var$Buffer.allocUnsafe = function(size) {
    return $c053ce2433579b42$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c053ce2433579b42$var$Buffer.allocUnsafeSlow = function(size) {
    return $c053ce2433579b42$var$allocUnsafe(size);
};
function $c053ce2433579b42$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c053ce2433579b42$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $c053ce2433579b42$var$byteLength(string, encoding) | 0;
    var buf = $c053ce2433579b42$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c053ce2433579b42$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c053ce2433579b42$var$checked(array.length) | 0;
    var buf = $c053ce2433579b42$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c053ce2433579b42$var$fromArrayView(arrayView) {
    if ($c053ce2433579b42$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c053ce2433579b42$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c053ce2433579b42$var$fromArrayLike(arrayView);
}
function $c053ce2433579b42$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c053ce2433579b42$var$Buffer.prototype);
    return buf;
}
function $c053ce2433579b42$var$fromObject(obj) {
    if ($c053ce2433579b42$var$Buffer.isBuffer(obj)) {
        var len = $c053ce2433579b42$var$checked(obj.length) | 0;
        var buf = $c053ce2433579b42$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c053ce2433579b42$var$numberIsNaN(obj.length)) return $c053ce2433579b42$var$createBuffer(0);
        return $c053ce2433579b42$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c053ce2433579b42$var$fromArrayLike(obj.data);
}
function $c053ce2433579b42$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c053ce2433579b42$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c053ce2433579b42$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c053ce2433579b42$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c053ce2433579b42$var$Buffer.alloc(+length);
}
$c053ce2433579b42$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c053ce2433579b42$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c053ce2433579b42$var$Buffer.compare = function compare(a, b) {
    if ($c053ce2433579b42$var$isInstance(a, Uint8Array)) a = $c053ce2433579b42$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c053ce2433579b42$var$isInstance(b, Uint8Array)) b = $c053ce2433579b42$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c053ce2433579b42$var$Buffer.isBuffer(a) || !$c053ce2433579b42$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c053ce2433579b42$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c053ce2433579b42$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c053ce2433579b42$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c053ce2433579b42$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c053ce2433579b42$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $c053ce2433579b42$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c053ce2433579b42$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c053ce2433579b42$var$byteLength(string, encoding) {
    if ($c053ce2433579b42$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c053ce2433579b42$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c053ce2433579b42$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c053ce2433579b42$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c053ce2433579b42$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c053ce2433579b42$var$Buffer.byteLength = $c053ce2433579b42$var$byteLength;
function $c053ce2433579b42$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c053ce2433579b42$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c053ce2433579b42$var$utf8Slice(this, start, end);
        case "ascii":
            return $c053ce2433579b42$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c053ce2433579b42$var$latin1Slice(this, start, end);
        case "base64":
            return $c053ce2433579b42$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c053ce2433579b42$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c053ce2433579b42$var$Buffer.prototype._isBuffer = true;
function $c053ce2433579b42$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c053ce2433579b42$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$c053ce2433579b42$var$swap(this, i, i + 1);
    return this;
};
$c053ce2433579b42$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $c053ce2433579b42$var$swap(this, i, i + 3);
        $c053ce2433579b42$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c053ce2433579b42$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $c053ce2433579b42$var$swap(this, i, i + 7);
        $c053ce2433579b42$var$swap(this, i + 1, i + 6);
        $c053ce2433579b42$var$swap(this, i + 2, i + 5);
        $c053ce2433579b42$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c053ce2433579b42$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c053ce2433579b42$var$utf8Slice(this, 0, length);
    return $c053ce2433579b42$var$slowToString.apply(this, arguments);
};
$c053ce2433579b42$var$Buffer.prototype.toLocaleString = $c053ce2433579b42$var$Buffer.prototype.toString;
$c053ce2433579b42$var$Buffer.prototype.equals = function equals(b) {
    if (!$c053ce2433579b42$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c053ce2433579b42$var$Buffer.compare(this, b) === 0;
};
$c053ce2433579b42$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $c053ce2433579b42$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c053ce2433579b42$var$customInspectSymbol) $c053ce2433579b42$var$Buffer.prototype[$c053ce2433579b42$var$customInspectSymbol] = $c053ce2433579b42$var$Buffer.prototype.inspect;
$c053ce2433579b42$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c053ce2433579b42$var$isInstance(target, Uint8Array)) target = $c053ce2433579b42$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c053ce2433579b42$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c053ce2433579b42$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c053ce2433579b42$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c053ce2433579b42$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c053ce2433579b42$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c053ce2433579b42$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c053ce2433579b42$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c053ce2433579b42$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c053ce2433579b42$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c053ce2433579b42$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c053ce2433579b42$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c053ce2433579b42$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c053ce2433579b42$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c053ce2433579b42$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c053ce2433579b42$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c053ce2433579b42$var$utf8Write(buf, string, offset, length) {
    return $c053ce2433579b42$var$blitBuffer($c053ce2433579b42$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c053ce2433579b42$var$asciiWrite(buf, string, offset, length) {
    return $c053ce2433579b42$var$blitBuffer($c053ce2433579b42$var$asciiToBytes(string), buf, offset, length);
}
function $c053ce2433579b42$var$base64Write(buf, string, offset, length) {
    return $c053ce2433579b42$var$blitBuffer($c053ce2433579b42$var$base64ToBytes(string), buf, offset, length);
}
function $c053ce2433579b42$var$ucs2Write(buf, string, offset, length) {
    return $c053ce2433579b42$var$blitBuffer($c053ce2433579b42$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c053ce2433579b42$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c053ce2433579b42$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c053ce2433579b42$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c053ce2433579b42$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c053ce2433579b42$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c053ce2433579b42$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c053ce2433579b42$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c053ce2433579b42$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7fdbc86ce70f3613$export$6100ba28696e12de(buf);
    else return $7fdbc86ce70f3613$export$6100ba28696e12de(buf.slice(start, end));
}
function $c053ce2433579b42$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c053ce2433579b42$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c053ce2433579b42$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c053ce2433579b42$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c053ce2433579b42$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c053ce2433579b42$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c053ce2433579b42$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c053ce2433579b42$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c053ce2433579b42$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $c053ce2433579b42$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c053ce2433579b42$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c053ce2433579b42$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c053ce2433579b42$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c053ce2433579b42$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c053ce2433579b42$var$Buffer.prototype.readUintLE = $c053ce2433579b42$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c053ce2433579b42$var$Buffer.prototype.readUintBE = $c053ce2433579b42$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c053ce2433579b42$var$Buffer.prototype.readUint8 = $c053ce2433579b42$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c053ce2433579b42$var$Buffer.prototype.readUint16LE = $c053ce2433579b42$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c053ce2433579b42$var$Buffer.prototype.readUint16BE = $c053ce2433579b42$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c053ce2433579b42$var$Buffer.prototype.readUint32LE = $c053ce2433579b42$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c053ce2433579b42$var$Buffer.prototype.readUint32BE = $c053ce2433579b42$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c053ce2433579b42$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c053ce2433579b42$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c053ce2433579b42$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c053ce2433579b42$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c053ce2433579b42$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c053ce2433579b42$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c053ce2433579b42$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c053ce2433579b42$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 4, this.length);
    return $1a44eb3d99c71080$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c053ce2433579b42$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 4, this.length);
    return $1a44eb3d99c71080$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c053ce2433579b42$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 8, this.length);
    return $1a44eb3d99c71080$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c053ce2433579b42$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkOffset(offset, 8, this.length);
    return $1a44eb3d99c71080$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c053ce2433579b42$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c053ce2433579b42$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c053ce2433579b42$var$Buffer.prototype.writeUintLE = $c053ce2433579b42$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c053ce2433579b42$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c053ce2433579b42$var$Buffer.prototype.writeUintBE = $c053ce2433579b42$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c053ce2433579b42$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c053ce2433579b42$var$Buffer.prototype.writeUint8 = $c053ce2433579b42$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c053ce2433579b42$var$Buffer.prototype.writeUint16LE = $c053ce2433579b42$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c053ce2433579b42$var$Buffer.prototype.writeUint16BE = $c053ce2433579b42$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c053ce2433579b42$var$Buffer.prototype.writeUint32LE = $c053ce2433579b42$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c053ce2433579b42$var$Buffer.prototype.writeUint32BE = $c053ce2433579b42$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c053ce2433579b42$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c053ce2433579b42$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c053ce2433579b42$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c053ce2433579b42$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c053ce2433579b42$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c053ce2433579b42$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c053ce2433579b42$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c053ce2433579b42$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c053ce2433579b42$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c053ce2433579b42$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c053ce2433579b42$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1a44eb3d99c71080$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c053ce2433579b42$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c053ce2433579b42$var$writeFloat(this, value, offset, true, noAssert);
};
$c053ce2433579b42$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c053ce2433579b42$var$writeFloat(this, value, offset, false, noAssert);
};
function $c053ce2433579b42$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c053ce2433579b42$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1a44eb3d99c71080$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c053ce2433579b42$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c053ce2433579b42$var$writeDouble(this, value, offset, true, noAssert);
};
$c053ce2433579b42$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c053ce2433579b42$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c053ce2433579b42$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c053ce2433579b42$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c053ce2433579b42$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c053ce2433579b42$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c053ce2433579b42$var$Buffer.isBuffer(val) ? val : $c053ce2433579b42$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $c053ce2433579b42$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c053ce2433579b42$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c053ce2433579b42$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c053ce2433579b42$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c053ce2433579b42$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c053ce2433579b42$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c053ce2433579b42$var$base64ToBytes(str) {
    return $7fdbc86ce70f3613$export$d622b2ad8d90c771($c053ce2433579b42$var$base64clean(str));
}
function $c053ce2433579b42$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c053ce2433579b42$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c053ce2433579b42$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c053ce2433579b42$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $71bf10fcd5307205$require$Buffer = $c053ce2433579b42$export$a143d493d941bafc;
var $71bf10fcd5307205$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $71bf10fcd5307205$var$instantiateArrayType(arrayType) {
    var array = new arrayType();
    if (!(array instanceof Set) && !("push" in array)) return [];
    return array;
}
var $71bf10fcd5307205$export$21072316a7d73376 = /** @class */ function() {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    function TransformOperationExecutor(transformationType, options) {
        this.transformationType = transformationType;
        this.options = options;
        // -------------------------------------------------------------------------
        // Private Properties
        // -------------------------------------------------------------------------
        this.recursionStack = new Set();
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    TransformOperationExecutor.prototype.transform = function(source, value, targetType, arrayType, isMap, level) {
        var _this = this;
        if (level === void 0) level = 0;
        if (Array.isArray(value) || value instanceof Set) {
            var newValue_1 = arrayType && this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS ? $71bf10fcd5307205$var$instantiateArrayType(arrayType) : [];
            value.forEach(function(subValue, index) {
                var subSource = source ? source[index] : undefined;
                if (!_this.options.enableCircularCheck || !_this.isCircular(subValue)) {
                    var realTargetType = void 0;
                    if (typeof targetType !== "function" && targetType && targetType.options && targetType.options.discriminator && targetType.options.discriminator.property && targetType.options.discriminator.subTypes) {
                        if (_this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS) {
                            realTargetType = targetType.options.discriminator.subTypes.find(function(subType) {
                                return subType.name === subValue[targetType.options.discriminator.property];
                            });
                            var options = {
                                newObject: newValue_1,
                                object: subValue,
                                property: undefined
                            };
                            var newType = targetType.typeFunction(options);
                            realTargetType === undefined ? realTargetType = newType : realTargetType = realTargetType.value;
                            if (!targetType.options.keepDiscriminatorProperty) delete subValue[targetType.options.discriminator.property];
                        }
                        if (_this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS) realTargetType = subValue.constructor;
                        if (_this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN) subValue[targetType.options.discriminator.property] = targetType.options.discriminator.subTypes.find(function(subType) {
                            return subType.value === subValue.constructor;
                        }).name;
                    } else realTargetType = targetType;
                    var value_1 = _this.transform(subSource, subValue, realTargetType, undefined, subValue instanceof Map, level + 1);
                    if (newValue_1 instanceof Set) newValue_1.add(value_1);
                    else newValue_1.push(value_1);
                } else if (_this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS) {
                    if (newValue_1 instanceof Set) newValue_1.add(subValue);
                    else newValue_1.push(subValue);
                }
            });
            return newValue_1;
        } else if (targetType === String && !isMap) {
            if (value === null || value === undefined) return value;
            return String(value);
        } else if (targetType === Number && !isMap) {
            if (value === null || value === undefined) return value;
            return Number(value);
        } else if (targetType === Boolean && !isMap) {
            if (value === null || value === undefined) return value;
            return Boolean(value);
        } else if ((targetType === Date || value instanceof Date) && !isMap) {
            if (value instanceof Date) return new Date(value.valueOf());
            if (value === null || value === undefined) return value;
            return new Date(value);
        } else if (!!(0, $f358ca8705790871$export$a4e55266d2135a7f)().Buffer && (targetType === $71bf10fcd5307205$require$Buffer || value instanceof $71bf10fcd5307205$require$Buffer) && !isMap) {
            if (value === null || value === undefined) return value;
            return $71bf10fcd5307205$require$Buffer.from(value);
        } else if ((0, $df4b79576d25ea3b$export$4369c812aac99591)(value) && !isMap) return new Promise(function(resolve, reject) {
            value.then(function(data) {
                return resolve(_this.transform(undefined, data, targetType, undefined, undefined, level + 1));
            }, reject);
        });
        else if (!isMap && value !== null && typeof value === "object" && typeof value.then === "function") // Note: We should not enter this, as promise has been handled above
        // This option simply returns the Promise preventing a JS error from happening and should be an inaccessible path.
        return value; // skip promise transformation
        else if (typeof value === "object" && value !== null) {
            // try to guess the type
            if (!targetType && value.constructor !== Object /* && TransformationType === TransformationType.CLASS_TO_PLAIN*/ ) {
                if (!Array.isArray(value) && value.constructor === Array) ;
                else // We are good we can use the built-in constructor
                targetType = value.constructor;
            }
            if (!targetType && source) targetType = source.constructor;
            if (this.options.enableCircularCheck) // add transformed type to prevent circular references
            this.recursionStack.add(value);
            var keys = this.getKeys(targetType, value, isMap);
            var newValue = source ? source : {};
            if (!source && (this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS || this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS)) {
                if (isMap) newValue = new Map();
                else if (targetType) newValue = new targetType();
                else newValue = {};
            }
            var _loop_1 = function(key) {
                if (key === "__proto__" || key === "constructor") return "continue";
                var valueKey = key;
                var newValueKey = key, propertyName = key;
                if (!this_1.options.ignoreDecorators && targetType) {
                    if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS) {
                        var exposeMetadata = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findExposeMetadataByCustomName(targetType, key);
                        if (exposeMetadata) {
                            propertyName = exposeMetadata.propertyName;
                            newValueKey = exposeMetadata.propertyName;
                        }
                    } else if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN || this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS) {
                        var exposeMetadata = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findExposeMetadata(targetType, key);
                        if (exposeMetadata && exposeMetadata.options && exposeMetadata.options.name) newValueKey = exposeMetadata.options.name;
                    }
                }
                // get a subvalue
                var subValue = undefined;
                if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS) /**
                     * This section is added for the following report:
                     * https://github.com/typestack/class-transformer/issues/596
                     *
                     * We should not call functions or constructors when transforming to class.
                     */ subValue = value[valueKey];
                else {
                    if (value instanceof Map) subValue = value.get(valueKey);
                    else if (value[valueKey] instanceof Function) subValue = value[valueKey]();
                    else subValue = value[valueKey];
                }
                // determine a type
                var type = undefined, isSubValueMap = subValue instanceof Map;
                if (targetType && isMap) type = targetType;
                else if (targetType) {
                    var metadata_1 = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findTypeMetadata(targetType, propertyName);
                    if (metadata_1) {
                        var options = {
                            newObject: newValue,
                            object: value,
                            property: propertyName
                        };
                        var newType = metadata_1.typeFunction ? metadata_1.typeFunction(options) : metadata_1.reflectedType;
                        if (metadata_1.options && metadata_1.options.discriminator && metadata_1.options.discriminator.property && metadata_1.options.discriminator.subTypes) {
                            if (!(value[valueKey] instanceof Array)) {
                                if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS) {
                                    type = metadata_1.options.discriminator.subTypes.find(function(subType) {
                                        if (subValue && subValue instanceof Object && metadata_1.options.discriminator.property in subValue) return subType.name === subValue[metadata_1.options.discriminator.property];
                                    });
                                    type === undefined ? type = newType : type = type.value;
                                    if (!metadata_1.options.keepDiscriminatorProperty) {
                                        if (subValue && subValue instanceof Object && metadata_1.options.discriminator.property in subValue) delete subValue[metadata_1.options.discriminator.property];
                                    }
                                }
                                if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS) type = subValue.constructor;
                                if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN) {
                                    if (subValue) subValue[metadata_1.options.discriminator.property] = metadata_1.options.discriminator.subTypes.find(function(subType) {
                                        return subType.value === subValue.constructor;
                                    }).name;
                                }
                            } else type = metadata_1;
                        } else type = newType;
                        isSubValueMap = isSubValueMap || metadata_1.reflectedType === Map;
                    } else if (this_1.options.targetMaps) // try to find a type in target maps
                    this_1.options.targetMaps.filter(function(map) {
                        return map.target === targetType && !!map.properties[propertyName];
                    }).forEach(function(map) {
                        return type = map.properties[propertyName];
                    });
                    else if (this_1.options.enableImplicitConversion && this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS) {
                        // if we have no registererd type via the @Type() decorator then we check if we have any
                        // type declarations in reflect-metadata (type declaration is emited only if some decorator is added to the property.)
                        var reflectedType = Reflect.getMetadata("design:type", targetType.prototype, propertyName);
                        if (reflectedType) type = reflectedType;
                    }
                }
                // if value is an array try to get its custom array type
                var arrayType_1 = Array.isArray(value[valueKey]) ? this_1.getReflectedType(targetType, propertyName) : undefined;
                // const subValueKey = TransformationType === TransformationType.PLAIN_TO_CLASS && newKeyName ? newKeyName : key;
                var subSource = source ? source[valueKey] : undefined;
                // if its deserialization then type if required
                // if we uncomment this types like string[] will not work
                // if (this.transformationType === TransformationType.PLAIN_TO_CLASS && !type && subValue instanceof Object && !(subValue instanceof Date))
                //     throw new Error(`Cannot determine type for ${(targetType as any).name }.${propertyName}, did you forget to specify a @Type?`);
                // if newValue is a source object that has method that match newKeyName then skip it
                if (newValue.constructor.prototype) {
                    var descriptor = Object.getOwnPropertyDescriptor(newValue.constructor.prototype, newValueKey);
                    if ((this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS || this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS) && // eslint-disable-next-line @typescript-eslint/unbound-method
                    (descriptor && !descriptor.set || newValue[newValueKey] instanceof Function)) return "continue";
                }
                if (!this_1.options.enableCircularCheck || !this_1.isCircular(subValue)) {
                    var transformKey = this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS ? newValueKey : key;
                    var finalValue = void 0;
                    if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN) {
                        // Get original value
                        finalValue = value[transformKey];
                        // Apply custom transformation
                        finalValue = this_1.applyCustomTransformations(finalValue, targetType, transformKey, value, this_1.transformationType);
                        // If nothing change, it means no custom transformation was applied, so use the subValue.
                        finalValue = value[transformKey] === finalValue ? subValue : finalValue;
                        // Apply the default transformation
                        finalValue = this_1.transform(subSource, finalValue, type, arrayType_1, isSubValueMap, level + 1);
                    } else if (subValue === undefined && this_1.options.exposeDefaultValues) // Set default value if nothing provided
                    finalValue = newValue[newValueKey];
                    else {
                        finalValue = this_1.transform(subSource, subValue, type, arrayType_1, isSubValueMap, level + 1);
                        finalValue = this_1.applyCustomTransformations(finalValue, targetType, transformKey, value, this_1.transformationType);
                    }
                    if (finalValue !== undefined || this_1.options.exposeUnsetFields) {
                        if (newValue instanceof Map) newValue.set(newValueKey, finalValue);
                        else newValue[newValueKey] = finalValue;
                    }
                } else if (this_1.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS) {
                    var finalValue = subValue;
                    finalValue = this_1.applyCustomTransformations(finalValue, targetType, key, value, this_1.transformationType);
                    if (finalValue !== undefined || this_1.options.exposeUnsetFields) {
                        if (newValue instanceof Map) newValue.set(newValueKey, finalValue);
                        else newValue[newValueKey] = finalValue;
                    }
                }
            };
            var this_1 = this;
            // traverse over keys
            for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                var key = keys_1[_i];
                _loop_1(key);
            }
            if (this.options.enableCircularCheck) this.recursionStack.delete(value);
            return newValue;
        } else return value;
    };
    TransformOperationExecutor.prototype.applyCustomTransformations = function(value, target, key, obj, transformationType) {
        var _this = this;
        var metadatas = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findTransformMetadatas(target, key, this.transformationType);
        // apply versioning options
        if (this.options.version !== undefined) metadatas = metadatas.filter(function(metadata) {
            if (!metadata.options) return true;
            return _this.checkVersion(metadata.options.since, metadata.options.until);
        });
        // apply grouping options
        if (this.options.groups && this.options.groups.length) metadatas = metadatas.filter(function(metadata) {
            if (!metadata.options) return true;
            return _this.checkGroups(metadata.options.groups);
        });
        else metadatas = metadatas.filter(function(metadata) {
            return !metadata.options || !metadata.options.groups || !metadata.options.groups.length;
        });
        metadatas.forEach(function(metadata) {
            value = metadata.transformFn({
                value: value,
                key: key,
                obj: obj,
                type: transformationType,
                options: _this.options
            });
        });
        return value;
    };
    // preventing circular references
    TransformOperationExecutor.prototype.isCircular = function(object) {
        return this.recursionStack.has(object);
    };
    TransformOperationExecutor.prototype.getReflectedType = function(target, propertyName) {
        if (!target) return undefined;
        var meta = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findTypeMetadata(target, propertyName);
        return meta ? meta.reflectedType : undefined;
    };
    TransformOperationExecutor.prototype.getKeys = function(target, object, isMap) {
        var _this = this;
        // determine exclusion strategy
        var strategy = (0, $e27954f872b4904a$export$1bf9ee49bb479962).getStrategy(target);
        if (strategy === "none") strategy = this.options.strategy || "exposeAll"; // exposeAll is default strategy
        // get all keys that need to expose
        var keys = [];
        if (strategy === "exposeAll" || isMap) {
            if (object instanceof Map) keys = Array.from(object.keys());
            else keys = Object.keys(object);
        }
        if (isMap) // expose & exclude do not apply for map keys only to fields
        return keys;
        /**
         * If decorators are ignored but we don't want the extraneous values, then we use the
         * metadata to decide which property is needed, but doesn't apply the decorator effect.
         */ if (this.options.ignoreDecorators && this.options.excludeExtraneousValues && target) {
            var exposedProperties = (0, $e27954f872b4904a$export$1bf9ee49bb479962).getExposedProperties(target, this.transformationType);
            var excludedProperties = (0, $e27954f872b4904a$export$1bf9ee49bb479962).getExcludedProperties(target, this.transformationType);
            keys = $71bf10fcd5307205$var$__spreadArray($71bf10fcd5307205$var$__spreadArray([], exposedProperties, true), excludedProperties, true);
        }
        if (!this.options.ignoreDecorators && target) {
            // add all exposed to list of keys
            var exposedProperties = (0, $e27954f872b4904a$export$1bf9ee49bb479962).getExposedProperties(target, this.transformationType);
            if (this.transformationType === (0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS) exposedProperties = exposedProperties.map(function(key) {
                var exposeMetadata = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findExposeMetadata(target, key);
                if (exposeMetadata && exposeMetadata.options && exposeMetadata.options.name) return exposeMetadata.options.name;
                return key;
            });
            if (this.options.excludeExtraneousValues) keys = exposedProperties;
            else keys = keys.concat(exposedProperties);
            // exclude excluded properties
            var excludedProperties_1 = (0, $e27954f872b4904a$export$1bf9ee49bb479962).getExcludedProperties(target, this.transformationType);
            if (excludedProperties_1.length > 0) keys = keys.filter(function(key) {
                return !excludedProperties_1.includes(key);
            });
            // apply versioning options
            if (this.options.version !== undefined) keys = keys.filter(function(key) {
                var exposeMetadata = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findExposeMetadata(target, key);
                if (!exposeMetadata || !exposeMetadata.options) return true;
                return _this.checkVersion(exposeMetadata.options.since, exposeMetadata.options.until);
            });
            // apply grouping options
            if (this.options.groups && this.options.groups.length) keys = keys.filter(function(key) {
                var exposeMetadata = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findExposeMetadata(target, key);
                if (!exposeMetadata || !exposeMetadata.options) return true;
                return _this.checkGroups(exposeMetadata.options.groups);
            });
            else keys = keys.filter(function(key) {
                var exposeMetadata = (0, $e27954f872b4904a$export$1bf9ee49bb479962).findExposeMetadata(target, key);
                return !exposeMetadata || !exposeMetadata.options || !exposeMetadata.options.groups || !exposeMetadata.options.groups.length;
            });
        }
        // exclude prefixed properties
        if (this.options.excludePrefixes && this.options.excludePrefixes.length) keys = keys.filter(function(key) {
            return _this.options.excludePrefixes.every(function(prefix) {
                return key.substr(0, prefix.length) !== prefix;
            });
        });
        // make sure we have unique keys
        keys = keys.filter(function(key, index, self) {
            return self.indexOf(key) === index;
        });
        return keys;
    };
    TransformOperationExecutor.prototype.checkVersion = function(since, until) {
        var decision = true;
        if (decision && since) decision = this.options.version >= since;
        if (decision && until) decision = this.options.version < until;
        return decision;
    };
    TransformOperationExecutor.prototype.checkGroups = function(groups) {
        if (!groups) return true;
        return this.options.groups.some(function(optionGroup) {
            return groups.includes(optionGroup);
        });
    };
    return TransformOperationExecutor;
}();



/**
 * These are the default options used by any transformation operation.
 */ var $ea9f3018ee70513e$export$ba43bf67f3d48107 = {
    enableCircularCheck: false,
    enableImplicitConversion: false,
    excludeExtraneousValues: false,
    excludePrefixes: undefined,
    exposeDefaultValues: false,
    exposeUnsetFields: true,
    groups: undefined,
    ignoreDecorators: false,
    strategy: undefined,
    targetMaps: undefined,
    version: undefined
};


var $c4fef850b754c7a3$var$__assign = undefined && undefined.__assign || function() {
    $c4fef850b754c7a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4fef850b754c7a3$var$__assign.apply(this, arguments);
};
var $c4fef850b754c7a3$export$a2913a430ed25873 = /** @class */ function() {
    function ClassTransformer() {}
    ClassTransformer.prototype.instanceToPlain = function(object, options) {
        var executor = new (0, $71bf10fcd5307205$exports.TransformOperationExecutor)((0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN, $c4fef850b754c7a3$var$__assign($c4fef850b754c7a3$var$__assign({}, (0, $ea9f3018ee70513e$export$ba43bf67f3d48107)), options));
        return executor.transform(undefined, object, undefined, undefined, undefined, undefined);
    };
    ClassTransformer.prototype.classToPlainFromExist = function(object, plainObject, options) {
        var executor = new (0, $71bf10fcd5307205$exports.TransformOperationExecutor)((0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_PLAIN, $c4fef850b754c7a3$var$__assign($c4fef850b754c7a3$var$__assign({}, (0, $ea9f3018ee70513e$export$ba43bf67f3d48107)), options));
        return executor.transform(plainObject, object, undefined, undefined, undefined, undefined);
    };
    ClassTransformer.prototype.plainToInstance = function(cls, plain, options) {
        var executor = new (0, $71bf10fcd5307205$exports.TransformOperationExecutor)((0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS, $c4fef850b754c7a3$var$__assign($c4fef850b754c7a3$var$__assign({}, (0, $ea9f3018ee70513e$export$ba43bf67f3d48107)), options));
        return executor.transform(undefined, plain, cls, undefined, undefined, undefined);
    };
    ClassTransformer.prototype.plainToClassFromExist = function(clsObject, plain, options) {
        var executor = new (0, $71bf10fcd5307205$exports.TransformOperationExecutor)((0, $44e00c213ade0164$export$db472314407d6190).PLAIN_TO_CLASS, $c4fef850b754c7a3$var$__assign($c4fef850b754c7a3$var$__assign({}, (0, $ea9f3018ee70513e$export$ba43bf67f3d48107)), options));
        return executor.transform(clsObject, plain, undefined, undefined, undefined, undefined);
    };
    ClassTransformer.prototype.instanceToInstance = function(object, options) {
        var executor = new (0, $71bf10fcd5307205$exports.TransformOperationExecutor)((0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS, $c4fef850b754c7a3$var$__assign($c4fef850b754c7a3$var$__assign({}, (0, $ea9f3018ee70513e$export$ba43bf67f3d48107)), options));
        return executor.transform(undefined, object, undefined, undefined, undefined, undefined);
    };
    ClassTransformer.prototype.classToClassFromExist = function(object, fromObject, options) {
        var executor = new (0, $71bf10fcd5307205$exports.TransformOperationExecutor)((0, $44e00c213ade0164$export$db472314407d6190).CLASS_TO_CLASS, $c4fef850b754c7a3$var$__assign($c4fef850b754c7a3$var$__assign({}, (0, $ea9f3018ee70513e$export$ba43bf67f3d48107)), options));
        return executor.transform(fromObject, object, undefined, undefined, undefined, undefined);
    };
    ClassTransformer.prototype.serialize = function(object, options) {
        return JSON.stringify(this.instanceToPlain(object, options));
    };
    /**
     * Deserializes given JSON string to a object of the given class.
     */ ClassTransformer.prototype.deserialize = function(cls, json, options) {
        var jsonObject = JSON.parse(json);
        return this.plainToInstance(cls, jsonObject, options);
    };
    /**
     * Deserializes given JSON string to an array of objects of the given class.
     */ ClassTransformer.prototype.deserializeArray = function(cls, json, options) {
        var jsonObject = JSON.parse(json);
        return this.plainToInstance(cls, jsonObject, options);
    };
    return ClassTransformer;
}();



function $7e515c5f4e7e3cdd$export$563a914cafbdc389(transformFn, options) {
    if (options === void 0) options = {};
    return function(target, propertyName) {
        (0, $e27954f872b4904a$export$1bf9ee49bb479962).addTransformMetadata({
            target: target.constructor,
            propertyName: propertyName,
            transformFn: transformFn,
            options: options
        });
    };
}


function $a103c2228265f155$export$92738401e1603719(typeFunction, options) {
    if (options === void 0) options = {};
    return function(target, propertyName) {
        var reflectedType = Reflect.getMetadata("design:type", target, propertyName);
        (0, $e27954f872b4904a$export$1bf9ee49bb479962).addTypeMetadata({
            target: target.constructor,
            propertyName: propertyName,
            reflectedType: reflectedType,
            typeFunction: typeFunction,
            options: options
        });
    };
}




var $6d317adb194b0de5$var$classTransformer = new (0, $c4fef850b754c7a3$exports.ClassTransformer)();
function $6d317adb194b0de5$export$4404afd12f8b01ac(object, options) {
    return $6d317adb194b0de5$var$classTransformer.instanceToPlain(object, options);
}
function $6d317adb194b0de5$export$bf4c715146ed33b6(object, options) {
    return $6d317adb194b0de5$var$classTransformer.instanceToPlain(object, options);
}
function $6d317adb194b0de5$export$3887fe02f0c0c7dc(object, plainObject, options) {
    return $6d317adb194b0de5$var$classTransformer.classToPlainFromExist(object, plainObject, options);
}
function $6d317adb194b0de5$export$17c9a758d9b227cc(cls, plain, options) {
    return $6d317adb194b0de5$var$classTransformer.plainToInstance(cls, plain, options);
}
function $6d317adb194b0de5$export$83ef3e1b7e38cec(cls, plain, options) {
    return $6d317adb194b0de5$var$classTransformer.plainToInstance(cls, plain, options);
}
function $6d317adb194b0de5$export$a8bb27f4ae53aaea(clsObject, plain, options) {
    return $6d317adb194b0de5$var$classTransformer.plainToClassFromExist(clsObject, plain, options);
}
function $6d317adb194b0de5$export$b0a5a1c015f6e251(object, options) {
    return $6d317adb194b0de5$var$classTransformer.instanceToInstance(object, options);
}
function $6d317adb194b0de5$export$c9c25ad296d2134c(object, fromObject, options) {
    return $6d317adb194b0de5$var$classTransformer.classToClassFromExist(object, fromObject, options);
}
function $6d317adb194b0de5$export$dfdc1655ccc5b9cb(object, options) {
    return $6d317adb194b0de5$var$classTransformer.serialize(object, options);
}
function $6d317adb194b0de5$export$efcd34ab6248d3cd(cls, json, options) {
    return $6d317adb194b0de5$var$classTransformer.deserialize(cls, json, options);
}
function $6d317adb194b0de5$export$1ae6f97231beb96e(cls, json, options) {
    return $6d317adb194b0de5$var$classTransformer.deserializeArray(cls, json, options);
}


/* eslint-disable max-classes-per-file */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6566db17cd455ee5$var$extendStatics = function(d, b) {
    $6566db17cd455ee5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6566db17cd455ee5$var$extendStatics(d, b);
};
function $6566db17cd455ee5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6566db17cd455ee5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6566db17cd455ee5$export$18ce0697a983be9b = function() {
    $6566db17cd455ee5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6566db17cd455ee5$export$18ce0697a983be9b.apply(this, arguments);
};
function $6566db17cd455ee5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6566db17cd455ee5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6566db17cd455ee5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6566db17cd455ee5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6566db17cd455ee5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6566db17cd455ee5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $6566db17cd455ee5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6566db17cd455ee5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6566db17cd455ee5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6566db17cd455ee5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6566db17cd455ee5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6566db17cd455ee5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6566db17cd455ee5$export$45d3717a4c69092e(o, m, p);
}
function $6566db17cd455ee5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6566db17cd455ee5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6566db17cd455ee5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6566db17cd455ee5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6566db17cd455ee5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6566db17cd455ee5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6566db17cd455ee5$export$10c90e4f7922046c(v) {
    return this instanceof $6566db17cd455ee5$export$10c90e4f7922046c ? (this.v = v, this) : new $6566db17cd455ee5$export$10c90e4f7922046c(v);
}
function $6566db17cd455ee5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6566db17cd455ee5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6566db17cd455ee5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6566db17cd455ee5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6566db17cd455ee5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6566db17cd455ee5$export$19a8beecd37a4c45 === "function" ? $6566db17cd455ee5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6566db17cd455ee5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6566db17cd455ee5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $6566db17cd455ee5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6566db17cd455ee5$export$45d3717a4c69092e(result, mod, k);
    }
    $6566db17cd455ee5$var$__setModuleDefault(result, mod);
    return result;
}
function $6566db17cd455ee5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6566db17cd455ee5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6566db17cd455ee5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6566db17cd455ee5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}



class $f7aa31b9879f1252$export$b69770a2e06e330a {
    static #_ = (()=>{
        // The marker provides a way to check if an object is a sub-class constructor for a jsMessage.
        this.jsMessageMarker = true;
    })();
}
const $f7aa31b9879f1252$var$TupleToVec2 = (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value === undefined ? undefined : {
        x: value[0],
        y: value[1]
    });
const $f7aa31b9879f1252$var$BigIntTupleToVec2 = (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value === undefined ? undefined : {
        x: Number(value[0]),
        y: Number(value[1])
    });
class $f7aa31b9879f1252$export$25559ab104f9af0b extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$9949a4a86373c6dd)
], $f7aa31b9879f1252$export$25559ab104f9af0b.prototype, "nodes", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$5496f55c0ad451e1)
], $f7aa31b9879f1252$export$25559ab104f9af0b.prototype, "links", void 0);
class $f7aa31b9879f1252$export$82d84f4230431c53 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$9949a4a86373c6dd)
], $f7aa31b9879f1252$export$82d84f4230431c53.prototype, "nodeTypes", void 0);
class $f7aa31b9879f1252$export$a82de4785f98f0ee extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$a0a41f40ae7c5072 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>BigInt)
], $f7aa31b9879f1252$export$a0a41f40ae7c5072.prototype, "selected", void 0);
class $f7aa31b9879f1252$export$bc1038db4c84c3e2 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$c2cc185bb0f962b1)
], $f7aa31b9879f1252$export$bc1038db4c84c3e2.prototype, "openDocuments", void 0);
class $f7aa31b9879f1252$export$962e54e8f7bd1786 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$c09bc12f7cb7646b {
    get displayName() {
        return `${this.name}${this.isSaved ? "" : "*"}`;
    }
}
class $f7aa31b9879f1252$export$c2cc185bb0f962b1 extends $f7aa31b9879f1252$export$c09bc12f7cb7646b {
}
class $f7aa31b9879f1252$export$346cd885b64c0208 {
}
class $f7aa31b9879f1252$export$ab2e70fdc0a4fca1 {
}
class $f7aa31b9879f1252$export$9949a4a86373c6dd {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    $f7aa31b9879f1252$var$TupleToVec2
], $f7aa31b9879f1252$export$9949a4a86373c6dd.prototype, "position", void 0);
class $f7aa31b9879f1252$export$5496f55c0ad451e1 {
}
class $f7aa31b9879f1252$export$ea009986769f1b30 {
}
class $f7aa31b9879f1252$export$9d34c8cc8b8a3bd7 extends $f7aa31b9879f1252$export$c09bc12f7cb7646b {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value.toString())
], $f7aa31b9879f1252$export$9d34c8cc8b8a3bd7.prototype, "id", void 0);
class $f7aa31b9879f1252$export$6ee046007579e816 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$9d34c8cc8b8a3bd7)
], $f7aa31b9879f1252$export$6ee046007579e816.prototype, "details", void 0);
class $f7aa31b9879f1252$export$e49bdefb21e4ee79 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value.toString())
], $f7aa31b9879f1252$export$e49bdefb21e4ee79.prototype, "documentId", void 0);
class $f7aa31b9879f1252$export$d1502aedd976985f extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$68e0500631cbc355)
], $f7aa31b9879f1252$export$d1502aedd976985f.prototype, "hintData", void 0);
class $f7aa31b9879f1252$export$68e0500631cbc355 {
}
class $f7aa31b9879f1252$export$892596cec99bc70e {
    constructor(firstArg, green, blue, alpha){
        // Empty constructor
        if (firstArg === undefined) {
            this.red = 0;
            this.green = 0;
            this.blue = 0;
            this.alpha = 1;
            this.none = false;
        } else if (firstArg === "none") {
            this.red = 0;
            this.green = 0;
            this.blue = 0;
            this.alpha = 1;
            this.none = true;
        } else if (typeof firstArg === "object" && green === undefined && blue === undefined && alpha === undefined) {
            const { h: h, s: s, v: v } = firstArg;
            const convert = (n)=>{
                const k = (n + h * 6) % 6;
                return v - v * s * Math.max(Math.min(...[
                    k,
                    4 - k,
                    1
                ]), 0);
            };
            this.red = convert(5);
            this.green = convert(3);
            this.blue = convert(1);
            this.alpha = firstArg.a;
            this.none = false;
        } else if (typeof firstArg === "number" && typeof green === "number" && typeof blue === "number" && typeof alpha === "number") {
            this.red = firstArg;
            this.green = green;
            this.blue = blue;
            this.alpha = alpha;
            this.none = false;
        }
    }
    static fromCSS(colorCode) {
        // Allow single-digit hex value inputs
        let colorValue = colorCode.trim();
        if (colorValue.length === 2 && colorValue.charAt(0) === "#" && /[0-9a-f]/i.test(colorValue.charAt(1))) {
            const digit = colorValue.charAt(1);
            colorValue = `#${digit}${digit}${digit}`;
        }
        const canvas = document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        const context = canvas.getContext("2d");
        if (!context) return undefined;
        context.clearRect(0, 0, 1, 1);
        context.fillStyle = "black";
        context.fillStyle = colorValue;
        const comparisonA = context.fillStyle;
        context.fillStyle = "white";
        context.fillStyle = colorValue;
        const comparisonB = context.fillStyle;
        // Invalid color
        if (comparisonA !== comparisonB) {
            // If this color code didn't start with a #, add it and try again
            if (colorValue.trim().charAt(0) !== "#") return $f7aa31b9879f1252$export$892596cec99bc70e.fromCSS(`#${colorValue.trim()}`);
            return undefined;
        }
        context.fillRect(0, 0, 1, 1);
        const [r, g, b, a] = [
            ...context.getImageData(0, 0, 1, 1).data
        ];
        return new $f7aa31b9879f1252$export$892596cec99bc70e(r / 255, g / 255, b / 255, a / 255);
    }
    toHexNoAlpha() {
        if (this.none) return undefined;
        const r = Math.round(this.red * 255).toString(16).padStart(2, "0");
        const g = Math.round(this.green * 255).toString(16).padStart(2, "0");
        const b = Math.round(this.blue * 255).toString(16).padStart(2, "0");
        return `#${r}${g}${b}`;
    }
    toHexOptionalAlpha() {
        if (this.none) return undefined;
        const hex = this.toHexNoAlpha();
        const a = Math.round(this.alpha * 255).toString(16).padStart(2, "0");
        return a === "ff" ? hex : `${hex}${a}`;
    }
    toRgb255() {
        if (this.none) return undefined;
        return {
            r: Math.round(this.red * 255),
            g: Math.round(this.green * 255),
            b: Math.round(this.blue * 255)
        };
    }
    toRgba255() {
        if (this.none) return undefined;
        return {
            r: Math.round(this.red * 255),
            g: Math.round(this.green * 255),
            b: Math.round(this.blue * 255),
            a: Math.round(this.alpha * 255)
        };
    }
    toRgbCSS() {
        const rgba = this.toRgba255();
        if (!rgba) return undefined;
        return `rgb(${rgba.r}, ${rgba.g}, ${rgba.b})`;
    }
    toRgbaCSS() {
        const rgba = this.toRgba255();
        if (!rgba) return undefined;
        return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
    }
    toHSV() {
        const hsva = this.toHSVA();
        if (!hsva) return undefined;
        return {
            h: hsva.h,
            s: hsva.s,
            v: hsva.v
        };
    }
    toHSVA() {
        if (this.none) return undefined;
        const { red: r, green: g, blue: b, alpha: a } = this;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const d = max - min;
        const s = max === 0 ? 0 : d / max;
        const v = max;
        let h = 0;
        if (max !== min) {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
                default:
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v,
            a: a
        };
    }
    toHsvDegreesAndPercent() {
        const hsva = this.toHSVA();
        if (!hsva) return undefined;
        return {
            h: hsva.h * 360,
            s: hsva.s * 100,
            v: hsva.v * 100
        };
    }
    toHsvaDegreesAndPercent() {
        const hsva = this.toHSVA();
        if (!hsva) return undefined;
        return {
            h: hsva.h * 360,
            s: hsva.s * 100,
            v: hsva.v * 100,
            a: hsva.a * 100
        };
    }
    opaque() {
        if (this.none) return undefined;
        return new $f7aa31b9879f1252$export$892596cec99bc70e(this.red, this.green, this.blue, 1);
    }
    contrastingColor() {
        if (this.none) return "black";
        // Convert alpha into white
        const r = this.red * this.alpha + (1 - this.alpha);
        const g = this.green * this.alpha + (1 - this.alpha);
        const b = this.blue * this.alpha + (1 - this.alpha);
        // https://stackoverflow.com/a/3943023/775283
        const linearR = r <= 0.04045 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4;
        const linearG = g <= 0.04045 ? g / 12.92 : ((g + 0.055) / 1.055) ** 2.4;
        const linearB = b <= 0.04045 ? b / 12.92 : ((b + 0.055) / 1.055) ** 2.4;
        const linear = linearR * 0.2126 + linearG * 0.7152 + linearB * 0.0722;
        return linear > Math.sqrt(1.05 * 0.05) - 0.05 ? "black" : "white";
    }
}
class $f7aa31b9879f1252$export$3d6efe341ed16f extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$b1e8b5daf8396760 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$90fee3ac057e6e0c extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$e6b230c6603d5a10 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$bfe3aaa687983ce0 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$49d0c233dd75cf0f extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$ff5df6c5561f8a9f extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$afb8aa162f5c524d extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    $f7aa31b9879f1252$var$TupleToVec2
], $f7aa31b9879f1252$export$afb8aa162f5c524d.prototype, "position", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    $f7aa31b9879f1252$var$TupleToVec2
], $f7aa31b9879f1252$export$afb8aa162f5c524d.prototype, "size", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    $f7aa31b9879f1252$var$TupleToVec2
], $f7aa31b9879f1252$export$afb8aa162f5c524d.prototype, "multiplier", void 0);
class $f7aa31b9879f1252$export$67e326410c009161 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    $f7aa31b9879f1252$var$TupleToVec2
], $f7aa31b9879f1252$export$67e326410c009161.prototype, "origin", void 0);
class $f7aa31b9879f1252$export$905b4e85a33f6d2b extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    $f7aa31b9879f1252$var$TupleToVec2
], $f7aa31b9879f1252$export$905b4e85a33f6d2b.prototype, "mousePosition", void 0);
const $f7aa31b9879f1252$var$mouseCursorIconCSSNames = {
    Default: "default",
    None: "none",
    ZoomIn: "zoom-in",
    ZoomOut: "zoom-out",
    Grabbing: "grabbing",
    Crosshair: "crosshair",
    Text: "text",
    Move: "move",
    NSResize: "ns-resize",
    EWResize: "ew-resize",
    NESWResize: "nesw-resize",
    NWSEResize: "nwse-resize",
    Rotate: "custom-rotate"
};
class $f7aa31b9879f1252$export$71833d69925d8667 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>$f7aa31b9879f1252$var$mouseCursorIconCSSNames[value] || "alias")
], $f7aa31b9879f1252$export$71833d69925d8667.prototype, "cursor", void 0);
class $f7aa31b9879f1252$export$e4645b5e9b7c4232 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$f4cdd9700ca2a131 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$c53869e99500f3ff extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$f25eb5c81205b7fa extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$53f77d4489bb1c34 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$ad0333232682cac extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$fb8722a4b873b954 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$28c7d626096abc12 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$53c1006fe0e4f258 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    $f7aa31b9879f1252$var$TupleToVec2
], $f7aa31b9879f1252$export$53c1006fe0e4f258.prototype, "size", void 0);
class $f7aa31b9879f1252$export$1e88bf4b8e1e0d8a extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$38b20bcd8aa2ec66 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$4f5fda2bd70beb59 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$d2750cee179259b extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$7ab3967777b94c66 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$b219b425fe99e483 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$2a896f077f253590 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
    constructor(layerId, children){
        super();
        this.layerId = layerId;
        this.children = children;
    }
}
function $f7aa31b9879f1252$export$48cc004592ceffdb(input, wasm) {
    const pointerNum = Number(input.dataBuffer.pointer);
    const lengthNum = Number(input.dataBuffer.length);
    const wasmMemoryBuffer = wasm.buffer;
    // Decode the folder structure encoding
    const encoding = new DataView(wasmMemoryBuffer, pointerNum, lengthNum);
    // The structure section indicates how to read through the upcoming layer list and assign depths to each layer
    const structureSectionLength = Number(encoding.getBigUint64(0, true));
    const structureSectionMsbSigned = new DataView(wasmMemoryBuffer, pointerNum + 8, structureSectionLength * 8);
    // The layer IDs section lists each layer ID sequentially in the tree, as it will show up in the panel
    const layerIdsSection = new DataView(wasmMemoryBuffer, pointerNum + 8 + structureSectionLength * 8);
    let layersEncountered = 0;
    let currentFolder = new $f7aa31b9879f1252$export$2a896f077f253590(BigInt(-1), []);
    const currentFolderStack = [
        currentFolder
    ];
    for(let i = 0; i < structureSectionLength; i += 1){
        const msbSigned = structureSectionMsbSigned.getBigUint64(i * 8, true);
        const msbMask = BigInt(1) << BigInt(63);
        // Set the MSB to 0 to clear the sign and then read the number as usual
        const numberOfLayersAtThisDepth = msbSigned & ~msbMask;
        // Store child folders in the current folder (until we are interrupted by an indent)
        for(let j = 0; j < numberOfLayersAtThisDepth; j += 1){
            const layerId = layerIdsSection.getBigUint64(layersEncountered * 8, true);
            layersEncountered += 1;
            const childLayer = new $f7aa31b9879f1252$export$2a896f077f253590(layerId, []);
            currentFolder.children.push(childLayer);
        }
        // Check the sign of the MSB, where a 1 is a negative (outward) indent
        const subsequentDirectionOfDepthChange = (msbSigned & msbMask) === BigInt(0);
        // Inward
        if (subsequentDirectionOfDepthChange) {
            currentFolderStack.push(currentFolder);
            currentFolder = currentFolder.children[currentFolder.children.length - 1];
        } else {
            const popped = currentFolderStack.pop();
            if (!popped) throw Error("Too many negative indents in the folder structure");
            if (popped) currentFolder = popped;
        }
    }
    return currentFolder;
}
class $f7aa31b9879f1252$export$a56dab01700fb7e1 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$892596cec99bc70e)
], $f7aa31b9879f1252$export$a56dab01700fb7e1.prototype, "color", void 0);
class $f7aa31b9879f1252$export$eac219e540e468b8 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$200c3286d72cacb8 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$45e1529a9591b9dd)
], $f7aa31b9879f1252$export$200c3286d72cacb8.prototype, "imageData", void 0);
class $f7aa31b9879f1252$export$98edad53d4312d93 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$52bcad66918d81d4 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$16ae030b1db6823d)
], $f7aa31b9879f1252$export$52bcad66918d81d4.prototype, "data", void 0);
class $f7aa31b9879f1252$export$16ae030b1db6823d {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$16ae030b1db6823d.prototype, "tooltip", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>new BigUint64Array(value))
], $f7aa31b9879f1252$export$16ae030b1db6823d.prototype, "path", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$eee4fc3f92b6ba52)
], $f7aa31b9879f1252$export$16ae030b1db6823d.prototype, "layerMetadata", void 0);
class $f7aa31b9879f1252$export$eee4fc3f92b6ba52 {
}
class $f7aa31b9879f1252$export$45e1529a9591b9dd {
}
class $f7aa31b9879f1252$export$acbb728739bb7d83 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$89abf52a030e56ee {
}
class $f7aa31b9879f1252$export$d22f34b01e740bcc extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$89abf52a030e56ee)
], $f7aa31b9879f1252$export$d22f34b01e740bcc.prototype, "font", void 0);
class $f7aa31b9879f1252$export$90cfb375d35400f3 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$bf0452fe411c5aac extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$8d7c81ea685522cb extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$7cba8a2f1a0b6724 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$db2a8420355239c0 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$2208223fe002fa87 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
class $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
class $f7aa31b9879f1252$export$d4e232ca161ccdd3 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$d4e232ca161ccdd3.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$5a1d7ca0a925d9c2 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value === undefined ? new $f7aa31b9879f1252$export$892596cec99bc70e("none") : new $f7aa31b9879f1252$export$892596cec99bc70e(value.red, value.green, value.blue, value.alpha))
], $f7aa31b9879f1252$export$5a1d7ca0a925d9c2.prototype, "value", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$5a1d7ca0a925d9c2.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$7bf4ef853ecab4dc {
}
class $f7aa31b9879f1252$export$b0e83c3ef8d2db1 {
}
class $f7aa31b9879f1252$export$2b38b489ad247e73 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$2b38b489ad247e73.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$7a40489edcbfb3a1 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$7a40489edcbfb3a1.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$4a6f1e325ee86912 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$4a6f1e325ee86912.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$c25acd513dcc8062 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$c25acd513dcc8062.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$e793e4bf2f36dbbb extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$e793e4bf2f36dbbb.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$f28de59ee811cc44 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$f28de59ee811cc44.prototype, "width", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$f28de59ee811cc44.prototype, "height", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$f28de59ee811cc44.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$5fada21ce902a23d extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value ? String(value) : undefined)
], $f7aa31b9879f1252$export$5fada21ce902a23d.prototype, "value", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$5fada21ce902a23d.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$6bf0cd3a219bbade extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$6bf0cd3a219bbade.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$cae15f9e2fc89cc6 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$cae15f9e2fc89cc6.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$c71dc08a6f474856 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$c71dc08a6f474856.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$83a1b8e4fcf0dd8e extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
class $f7aa31b9879f1252$export$1ff3c3f08ae963c0 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
class $f7aa31b9879f1252$export$38d79c881c6aaba0 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$892596cec99bc70e)
], $f7aa31b9879f1252$export$38d79c881c6aaba0.prototype, "primary", void 0);
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$892596cec99bc70e)
], $f7aa31b9879f1252$export$38d79c881c6aaba0.prototype, "secondary", void 0);
class $f7aa31b9879f1252$export$ce9b1cc0c34506d0 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$ce9b1cc0c34506d0.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$cf88f1f8cfcd92ff extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$cf88f1f8cfcd92ff.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$652b5b0d951b8801 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$652b5b0d951b8801.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$5b486245ebebf1d5 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$5b486245ebebf1d5.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$c86715117507e8e5 extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$c86715117507e8e5.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$2d7625488064842b extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>value || undefined)
], $f7aa31b9879f1252$export$2d7625488064842b.prototype, "tooltip", void 0);
class $f7aa31b9879f1252$export$87c6d513ab5059ee extends $f7aa31b9879f1252$export$8a6996413e31cb10 {
}
// WIDGET
const $f7aa31b9879f1252$var$widgetSubTypes = [
    {
        value: $f7aa31b9879f1252$export$5b486245ebebf1d5,
        name: "BreadcrumbTrailButtons"
    },
    {
        value: $f7aa31b9879f1252$export$d4e232ca161ccdd3,
        name: "CheckboxInput"
    },
    {
        value: $f7aa31b9879f1252$export$5a1d7ca0a925d9c2,
        name: "ColorInput"
    },
    {
        value: $f7aa31b9879f1252$export$2b38b489ad247e73,
        name: "CurveInput"
    },
    {
        value: $f7aa31b9879f1252$export$7a40489edcbfb3a1,
        name: "DropdownInput"
    },
    {
        value: $f7aa31b9879f1252$export$4a6f1e325ee86912,
        name: "FontInput"
    },
    {
        value: $f7aa31b9879f1252$export$c25acd513dcc8062,
        name: "IconButton"
    },
    {
        value: $f7aa31b9879f1252$export$e793e4bf2f36dbbb,
        name: "IconLabel"
    },
    {
        value: $f7aa31b9879f1252$export$f28de59ee811cc44,
        name: "ImageLabel"
    },
    {
        value: $f7aa31b9879f1252$export$5fada21ce902a23d,
        name: "LayerReferenceInput"
    },
    {
        value: $f7aa31b9879f1252$export$6bf0cd3a219bbade,
        name: "NumberInput"
    },
    {
        value: $f7aa31b9879f1252$export$cae15f9e2fc89cc6,
        name: "OptionalInput"
    },
    {
        value: $f7aa31b9879f1252$export$cf88f1f8cfcd92ff,
        name: "ParameterExposeButton"
    },
    {
        value: $f7aa31b9879f1252$export$87c6d513ab5059ee,
        name: "PivotAssist"
    },
    {
        value: $f7aa31b9879f1252$export$c71dc08a6f474856,
        name: "PopoverButton"
    },
    {
        value: $f7aa31b9879f1252$export$83a1b8e4fcf0dd8e,
        name: "RadioInput"
    },
    {
        value: $f7aa31b9879f1252$export$1ff3c3f08ae963c0,
        name: "Separator"
    },
    {
        value: $f7aa31b9879f1252$export$38d79c881c6aaba0,
        name: "SwatchPairInput"
    },
    {
        value: $f7aa31b9879f1252$export$ce9b1cc0c34506d0,
        name: "TextAreaInput"
    },
    {
        value: $f7aa31b9879f1252$export$652b5b0d951b8801,
        name: "TextButton"
    },
    {
        value: $f7aa31b9879f1252$export$c86715117507e8e5,
        name: "TextInput"
    },
    {
        value: $f7aa31b9879f1252$export$2d7625488064842b,
        name: "TextLabel"
    }
];
function $f7aa31b9879f1252$export$6cb27e51251341c5(props, kind) {
    if (props.kind === kind) return props;
    else return undefined;
}
class $f7aa31b9879f1252$export$a829527ff4e4114a {
    constructor(props, widgetId){
        this.props = props;
        this.widgetId = widgetId;
    }
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $a103c2228265f155$export$92738401e1603719)(()=>$f7aa31b9879f1252$export$8a6996413e31cb10, {
        discriminator: {
            property: "kind",
            subTypes: [
                ...$f7aa31b9879f1252$var$widgetSubTypes
            ]
        },
        keepDiscriminatorProperty: true
    })
], $f7aa31b9879f1252$export$a829527ff4e4114a.prototype, "props", void 0);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7aa31b9879f1252$var$hoistWidgetHolder(widgetHolder) {
    const kind = Object.keys(widgetHolder.widget)[0];
    const props = widgetHolder.widget[kind];
    props.kind = kind;
    if (kind === "PopoverButton") props.optionsWidget = props.optionsWidget.map($f7aa31b9879f1252$var$createLayoutGroup);
    const { widgetId: widgetId } = widgetHolder;
    return (0, $6d317adb194b0de5$export$17c9a758d9b227cc)($f7aa31b9879f1252$export$a829527ff4e4114a, {
        props: props,
        widgetId: widgetId
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7aa31b9879f1252$var$hoistWidgetHolders(widgetHolders) {
    return widgetHolders.map($f7aa31b9879f1252$var$hoistWidgetHolder);
}
class $f7aa31b9879f1252$export$7c1bee691e939425 extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>$f7aa31b9879f1252$var$createWidgetDiff(value))
], $f7aa31b9879f1252$export$7c1bee691e939425.prototype, "diff", void 0);
function $f7aa31b9879f1252$export$16fc69c1586bf13b() {
    return {
        layoutTarget: undefined,
        layout: []
    };
}
function $f7aa31b9879f1252$export$34fe634dd7362991(layout, updates) {
    layout.layoutTarget = updates.layoutTarget;
    updates.diff.forEach((update)=>{
        // Find the object where the diff applies to
        const diffObject = update.widgetPath.reduce((targetLayout, index)=>{
            if ("columnWidgets" in targetLayout) return targetLayout.columnWidgets[index];
            if ("rowWidgets" in targetLayout) return targetLayout.rowWidgets[index];
            if ("layout" in targetLayout) return targetLayout.layout[index];
            if (targetLayout instanceof $f7aa31b9879f1252$export$a829527ff4e4114a) {
                if (targetLayout.props.kind === "PopoverButton" && targetLayout.props instanceof $f7aa31b9879f1252$export$c71dc08a6f474856 && targetLayout.props.optionsWidget) return targetLayout.props.optionsWidget[index];
                // eslint-disable-next-line no-console
                console.error("Tried to index widget");
                return targetLayout;
            }
            // This is a path traversal so we can assume from the backend that it exists
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if ("action" in targetLayout) return targetLayout.children[index];
            return targetLayout[index];
        }, layout.layout);
        // If this is a list with a length, then set the length to 0 to clear the list
        if ("length" in diffObject) diffObject.length = 0;
        // Remove all of the keys from the old object
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.keys(diffObject).forEach((key)=>delete diffObject[key]);
        // Assign keys to the new object
        // `Object.assign` works but `diffObject = update.newValue;` doesn't.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
        Object.assign(diffObject, update.newValue);
    });
}
function $f7aa31b9879f1252$export$b6705411aec0409b(layoutColumn) {
    return Boolean(layoutColumn.columnWidgets);
}
function $f7aa31b9879f1252$export$377d9cd95e2858ff(layoutRow) {
    return Boolean(layoutRow.rowWidgets);
}
function $f7aa31b9879f1252$export$aaa5b87bdb9bc054(layoutRow) {
    return Boolean(layoutRow.layout);
}
// Unpacking rust types to more usable type in the frontend
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7aa31b9879f1252$var$createWidgetDiff(diffs) {
    return diffs.map((diff)=>{
        const { widgetPath: widgetPath, newValue: newValue } = diff;
        if (newValue.subLayout) return {
            widgetPath: widgetPath,
            newValue: newValue.subLayout.map($f7aa31b9879f1252$var$createLayoutGroup)
        };
        if (newValue.layoutGroup) return {
            widgetPath: widgetPath,
            newValue: $f7aa31b9879f1252$var$createLayoutGroup(newValue.layoutGroup)
        };
        if (newValue.widget) return {
            widgetPath: widgetPath,
            newValue: $f7aa31b9879f1252$var$hoistWidgetHolder(newValue.widget)
        };
        // This code should be unreachable
        throw new Error("DiffUpdate invalid");
    });
}
// Unpacking a layout group
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7aa31b9879f1252$var$createLayoutGroup(layoutGroup) {
    if (layoutGroup.column) {
        const columnWidgets = $f7aa31b9879f1252$var$hoistWidgetHolders(layoutGroup.column.columnWidgets);
        const result = {
            columnWidgets: columnWidgets
        };
        return result;
    }
    if (layoutGroup.row) {
        const result = {
            rowWidgets: $f7aa31b9879f1252$var$hoistWidgetHolders(layoutGroup.row.rowWidgets)
        };
        return result;
    }
    if (layoutGroup.section) {
        const result = {
            name: layoutGroup.section.name,
            layout: layoutGroup.section.layout.map($f7aa31b9879f1252$var$createLayoutGroup)
        };
        return result;
    }
    throw new Error("Layout row type does not exist");
}
class $f7aa31b9879f1252$export$dcf9c80e827f7972 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$f49a73e53ce910a9 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$686f75900abec9c9 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$6ecaa6f86c30f346 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$6ae1afef0ec15637 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$b43a1237b2186276 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$d18082b89eeb3cd extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$b93b090e7b2f51fd extends $f7aa31b9879f1252$export$b69770a2e06e330a {
}
(0, $6566db17cd455ee5$export$29e00dfd3077644b)([
    (0, $7e515c5f4e7e3cdd$export$563a914cafbdc389)(({ value: value })=>$f7aa31b9879f1252$var$createMenuLayout(value))
], $f7aa31b9879f1252$export$b93b090e7b2f51fd.prototype, "layout", void 0);
class $f7aa31b9879f1252$export$d839cb726a3e3994 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$3032c74f2970310c extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$256d73496980c381 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$a7c75961eb53f4c9 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$870f7044c5c3c3e3 extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
class $f7aa31b9879f1252$export$831638e45dba82dc extends $f7aa31b9879f1252$export$7c1bee691e939425 {
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7aa31b9879f1252$var$createMenuLayout(menuBarEntry) {
    return menuBarEntry.map((entry)=>({
            ...entry,
            children: $f7aa31b9879f1252$var$createMenuLayoutRecursive(entry.children)
        }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7aa31b9879f1252$var$createMenuLayoutRecursive(children) {
    return children.map((groups)=>groups.map((entry)=>({
                ...entry,
                action: $f7aa31b9879f1252$var$hoistWidgetHolders([
                    entry.action
                ])[0],
                children: entry.children ? $f7aa31b9879f1252$var$createMenuLayoutRecursive(entry.children) : undefined,
                disabled: entry.disabled ?? false
            })));
}
const $f7aa31b9879f1252$export$202cdf6e0cd09416 = {
    DisplayDialog: $f7aa31b9879f1252$export$90fee3ac057e6e0c,
    DisplayDialogDismiss: $f7aa31b9879f1252$export$acbb728739bb7d83,
    DisplayDialogPanic: $f7aa31b9879f1252$export$b1e8b5daf8396760,
    DisplayEditableTextbox: $f7aa31b9879f1252$export$a56dab01700fb7e1,
    DisplayEditableTextboxTransform: $f7aa31b9879f1252$export$eac219e540e468b8,
    DisplayRemoveEditableTextbox: $f7aa31b9879f1252$export$98edad53d4312d93,
    TriggerAboutGraphiteLocalizedCommitDate: $f7aa31b9879f1252$export$db2a8420355239c0,
    TriggerCopyToClipboardBlobUrl: $f7aa31b9879f1252$export$fb8722a4b873b954,
    TriggerFetchAndOpenDocument: $f7aa31b9879f1252$export$c53869e99500f3ff,
    TriggerDownloadBlobUrl: $f7aa31b9879f1252$export$28c7d626096abc12,
    TriggerDownloadRaster: $f7aa31b9879f1252$export$53c1006fe0e4f258,
    TriggerDownloadTextFile: $f7aa31b9879f1252$export$1e88bf4b8e1e0d8a,
    TriggerFontLoad: $f7aa31b9879f1252$export$d22f34b01e740bcc,
    TriggerGraphViewOverlay: $f7aa31b9879f1252$export$90cfb375d35400f3,
    TriggerImport: $f7aa31b9879f1252$export$53f77d4489bb1c34,
    TriggerIndexedDbRemoveDocument: $f7aa31b9879f1252$export$e49bdefb21e4ee79,
    TriggerIndexedDbWriteDocument: $f7aa31b9879f1252$export$6ee046007579e816,
    TriggerLoadAutoSaveDocuments: $f7aa31b9879f1252$export$e4645b5e9b7c4232,
    TriggerLoadPreferences: $f7aa31b9879f1252$export$f4cdd9700ca2a131,
    TriggerOpenDocument: $f7aa31b9879f1252$export$f25eb5c81205b7fa,
    TriggerPaste: $f7aa31b9879f1252$export$ad0333232682cac,
    TriggerRasterizeRegionBelowLayer: $f7aa31b9879f1252$export$38b20bcd8aa2ec66,
    TriggerRefreshBoundsOfViewports: $f7aa31b9879f1252$export$4f5fda2bd70beb59,
    TriggerRevokeBlobUrl: $f7aa31b9879f1252$export$d2750cee179259b,
    TriggerSavePreferences: $f7aa31b9879f1252$export$7ab3967777b94c66,
    TriggerTextCommit: $f7aa31b9879f1252$export$8d7c81ea685522cb,
    TriggerTextCopy: $f7aa31b9879f1252$export$7cba8a2f1a0b6724,
    TriggerViewportResize: $f7aa31b9879f1252$export$2208223fe002fa87,
    TriggerVisitLink: $f7aa31b9879f1252$export$bf0452fe411c5aac,
    UpdateActiveDocument: $f7aa31b9879f1252$export$3d6efe341ed16f,
    UpdateDialogButtons: $f7aa31b9879f1252$export$dcf9c80e827f7972,
    UpdateDialogColumn1: $f7aa31b9879f1252$export$f49a73e53ce910a9,
    UpdateDialogColumn2: $f7aa31b9879f1252$export$686f75900abec9c9,
    UpdateDocumentArtboards: $f7aa31b9879f1252$export$49d0c233dd75cf0f,
    UpdateDocumentArtwork: $f7aa31b9879f1252$export$e6b230c6603d5a10,
    UpdateDocumentBarLayout: $f7aa31b9879f1252$export$6ecaa6f86c30f346,
    UpdateDocumentLayerDetails: $f7aa31b9879f1252$export$52bcad66918d81d4,
    UpdateDocumentLayerTreeStructureJs: $f7aa31b9879f1252$export$48cc004592ceffdb,
    UpdateDocumentModeLayout: $f7aa31b9879f1252$export$6ae1afef0ec15637,
    UpdateDocumentNodeRender: $f7aa31b9879f1252$export$ff5df6c5561f8a9f,
    UpdateDocumentOverlays: $f7aa31b9879f1252$export$bfe3aaa687983ce0,
    UpdateDocumentRulers: $f7aa31b9879f1252$export$67e326410c009161,
    UpdateDocumentScrollbars: $f7aa31b9879f1252$export$afb8aa162f5c524d,
    UpdateEyedropperSamplingState: $f7aa31b9879f1252$export$905b4e85a33f6d2b,
    UpdateGraphViewOverlayButtonLayout: $f7aa31b9879f1252$export$b43a1237b2186276,
    UpdateImageData: $f7aa31b9879f1252$export$200c3286d72cacb8,
    UpdateInputHints: $f7aa31b9879f1252$export$d1502aedd976985f,
    UpdateLayerTreeOptionsLayout: $f7aa31b9879f1252$export$d18082b89eeb3cd,
    UpdateMenuBarLayout: $f7aa31b9879f1252$export$b93b090e7b2f51fd,
    UpdateMouseCursor: $f7aa31b9879f1252$export$71833d69925d8667,
    UpdateNodeGraph: $f7aa31b9879f1252$export$25559ab104f9af0b,
    UpdateNodeGraphBarLayout: $f7aa31b9879f1252$export$d839cb726a3e3994,
    UpdateNodeGraphSelection: $f7aa31b9879f1252$export$a0a41f40ae7c5072,
    UpdateNodeThumbnail: $f7aa31b9879f1252$export$a82de4785f98f0ee,
    UpdateNodeTypes: $f7aa31b9879f1252$export$82d84f4230431c53,
    UpdateOpenDocumentsList: $f7aa31b9879f1252$export$bc1038db4c84c3e2,
    UpdatePropertyPanelOptionsLayout: $f7aa31b9879f1252$export$3032c74f2970310c,
    UpdatePropertyPanelSectionsLayout: $f7aa31b9879f1252$export$256d73496980c381,
    UpdateToolOptionsLayout: $f7aa31b9879f1252$export$a7c75961eb53f4c9,
    UpdateToolShelfLayout: $f7aa31b9879f1252$export$870f7044c5c3c3e3,
    UpdateWorkingColorsLayout: $f7aa31b9879f1252$export$831638e45dba82dc,
    UpdateZoomWithScroll: $f7aa31b9879f1252$export$962e54e8f7bd1786
};


function $942f35ac0a63ea85$export$6d9e7d27694a253a() {
    const subscriptions = {};
    const subscribeJsMessage = (messageType, callback)=>{
        subscriptions[messageType.name] = callback;
    };
    const handleJsMessage = (messageType, messageData, wasm, instance)=>{
        // Find the message maker for the message type, which can either be a JS class constructor or a function that returns an instance of the JS class
        const messageMaker = (0, $f7aa31b9879f1252$export$202cdf6e0cd09416)[messageType];
        if (!messageMaker) {
            // eslint-disable-next-line no-console
            console.error(`Received a frontend message of type "${messageType}" but was not able to parse the data. ` + "(Perhaps this message parser isn't exported in `messageMakers` at the bottom of `messages.ts`.)");
            return;
        }
        // Checks if the provided `messageMaker` is a class extending `JsMessage`. All classes inheriting from `JsMessage` will have a static readonly `jsMessageMarker` which is `true`.
        const isJsMessageMaker = (fn)=>"jsMessageMarker" in fn;
        const messageIsClass = isJsMessageMaker(messageMaker);
        // Messages with non-empty data are provided by wasm-bindgen as an object with one key as the message name, like: { NameOfThisMessage: { ... } }
        // Messages with empty data are provided by wasm-bindgen as a string with the message name, like: "NameOfThisMessage"
        // Here we extract the payload object or use an empty object depending on the situation.
        const unwrappedMessageData = messageData[messageType] || {};
        // Converts to a `JsMessage` object by turning the JSON message data into an instance of the message class, either automatically or by calling the function that builds it.
        // If the `messageMaker` is a `JsMessage` class then we use the class-transformer library's `plainToInstance` function in order to convert the JSON data into the destination class.
        // If it is not a `JsMessage` then it should be a custom function that creates a JsMessage from a JSON, so we call the function itself with the raw JSON as an argument.
        // The resulting `message` is an instance of a class that extends `JsMessage`.
        const message = messageIsClass ? (0, $6d317adb194b0de5$export$83ef3e1b7e38cec)(messageMaker, unwrappedMessageData) : messageMaker(unwrappedMessageData, wasm, instance);
        // It is ok to use constructor.name even with minification since it is used consistently with registerHandler
        const callback = subscriptions[message.constructor.name];
        // If we have constructed a valid message, then we try and execute the callback that the frontend has associated with this message.
        // The frontend should always have a callback for all messages, and so we display an error if one was not found.
        if (message) {
            if (callback) callback(message);
            else console.error(`Received a frontend message of type "${messageType}" but no handler was registered for it from the client.`);
        }
    };
    return {
        subscribeJsMessage: subscribeJsMessage,
        handleJsMessage: handleJsMessage
    };
}


// `wasmImport` starts uninitialized because its initialization needs to occur asynchronously, and thus needs to occur by manually calling and awaiting `initWasm()`
let $e7d4b7b9b3ba44f6$var$wasmImport;
async function $e7d4b7b9b3ba44f6$export$d2445f1399d5a873(path, nodeId, mime, imageData, transform, documentId) {
    const blob = new Blob([
        imageData
    ], {
        type: mime
    });
    const blobURL = URL.createObjectURL(blob);
    // Pre-decode the image so it is ready to be drawn instantly once it's placed into the viewport SVG
    const image = new Image();
    image.src = blobURL;
    await image.decode();
    window["editorInstance"]?.setImageBlobURL(documentId, path, nodeId, blobURL, image.naturalWidth, image.naturalHeight, transform);
}
async function $e7d4b7b9b3ba44f6$export$260f1342281499a4(path, nodeId, mime, documentId, url) {
    const data = await fetch(url);
    const blob = await data.blob();
    const blobURL = URL.createObjectURL(blob);
    // Pre-decode the image so it is ready to be drawn instantly once it's placed into the viewport SVG
    const image = new Image();
    image.src = blobURL;
    await image.decode();
    window["editorInstance"]?.setImageBlobURL(documentId, path, nodeId, blobURL, image.naturalWidth, image.naturalHeight, undefined);
}

const $e7d4b7b9b3ba44f6$var$tauri = "__TAURI_METADATA__" in window && (parcelRequire("kw0CW"));
async function $e7d4b7b9b3ba44f6$export$be6de309127183b5(message) {
    if (!$e7d4b7b9b3ba44f6$var$tauri) return;
    try {
        const response = await (await $e7d4b7b9b3ba44f6$var$tauri).invoke("handle_message", {
            message: message
        });
        window["editorInstance"]?.tauriResponse(response);
    } catch  {
        // eslint-disable-next-line no-console
        console.error("Failed to dispatch Tauri message");
    }
}
async function $e7d4b7b9b3ba44f6$export$3b24329f2e9107b6() {
    // Skip if the WASM module is already initialized
    if ($e7d4b7b9b3ba44f6$var$wasmImport !== undefined) return;
    // Import the WASM module JS bindings and wrap them in the panic proxy
    // eslint-disable-next-line import/no-cycle
    await (0, $1078ca955870c324$export$2e2bcd8739ae039)();
    $e7d4b7b9b3ba44f6$var$wasmImport = await (0, $1078ca955870c324$export$6aca68b176279447)();
    window["imageCanvases"] = {};
    // Provide a random starter seed which must occur after initializing the WASM module, since WASM can't generate its own random numbers
    const randomSeedFloat = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    const randomSeed = BigInt(randomSeedFloat);
    (0, $1078ca955870c324$export$74d4fed657706d5a)(randomSeed);
    if (!$e7d4b7b9b3ba44f6$var$tauri) return;
    await (await $e7d4b7b9b3ba44f6$var$tauri).invoke("set_random_seed", {
        seed: randomSeedFloat
    });
}
function $e7d4b7b9b3ba44f6$export$eb02d1ee0d3cac30() {
    // Raw: Object containing several callable functions from `editor_api.rs` defined directly on the WASM module, not the editor instance (generated by wasm-bindgen)
    if (!$e7d4b7b9b3ba44f6$var$wasmImport) throw new Error("Editor WASM backend was not initialized at application startup");
    const raw = $e7d4b7b9b3ba44f6$var$wasmImport;
    // Instance: Object containing many functions from `editor_api.rs` that are part of the editor instance (generated by wasm-bindgen)
    const instance = new (0, $1078ca955870c324$export$7fc39e9d04ca6232)((messageType, messageData)=>{
        // This callback is called by WASM when a FrontendMessage is received from the WASM wrapper editor instance
        // We pass along the first two arguments then add our own `raw` and `instance` context for the last two arguments
        subscriptions.handleJsMessage(messageType, messageData, raw, instance);
    });
    window["editorInstance"] = instance;
    // Subscriptions: Allows subscribing to messages in JS that are sent from the WASM backend
    const subscriptions = (0, $942f35ac0a63ea85$export$6d9e7d27694a253a)();
    // Check if the URL hash fragment has any demo artwork to be loaded
    (async ()=>{
        const demoArtwork = window.location.hash.trim().match(/#demo\/(.*)/)?.[1];
        if (!demoArtwork) return;
        try {
            const url = new URL(`https://raw.githubusercontent.com/GraphiteEditor/Graphite/master/demo-artwork/${demoArtwork}.graphite`);
            const data = await fetch(url);
            const filename = url.pathname.split("/").pop() || "Untitled";
            const content = await data.text();
            instance.openDocumentFile(filename, content);
            // Remove the hash fragment from the URL
            history.replaceState("", "", `${window.location.pathname}${window.location.search}`);
        } catch  {}
    })();
    return {
        raw: raw,
        instance: instance,
        subscriptions: subscriptions
    };
}
function $e7d4b7b9b3ba44f6$export$6efc75f6eb6c74f9() {
    window["editorInstance"]?.injectImaginatePollServerStatus();
}


var $d23ab19b459a5cef$exports = {};

$parcel$export($d23ab19b459a5cef$exports, "updateImage", function () { return $d23ab19b459a5cef$export$d2445f1399d5a873; });
$parcel$export($d23ab19b459a5cef$exports, "fetchImage", function () { return $d23ab19b459a5cef$export$260f1342281499a4; });
$parcel$export($d23ab19b459a5cef$exports, "dispatchTauri", function () { return $d23ab19b459a5cef$export$be6de309127183b5; });
$parcel$export($d23ab19b459a5cef$exports, "initWasm", function () { return $d23ab19b459a5cef$export$3b24329f2e9107b6; });
$parcel$export($d23ab19b459a5cef$exports, "createEditor", function () { return $d23ab19b459a5cef$export$eb02d1ee0d3cac30; });
$parcel$export($d23ab19b459a5cef$exports, "injectImaginatePollServerStatus", function () { return $d23ab19b459a5cef$export$6efc75f6eb6c74f9; });


// `wasmImport` starts uninitialized because its initialization needs to occur asynchronously, and thus needs to occur by manually calling and awaiting `initWasm()`
let $d23ab19b459a5cef$var$wasmImport;
async function $d23ab19b459a5cef$export$d2445f1399d5a873(path, nodeId, mime, imageData, transform, documentId) {
    const blob = new Blob([
        imageData
    ], {
        type: mime
    });
    const blobURL = URL.createObjectURL(blob);
    // Pre-decode the image so it is ready to be drawn instantly once it's placed into the viewport SVG
    const image = new Image();
    image.src = blobURL;
    await image.decode();
    window["editorInstance"]?.setImageBlobURL(documentId, path, nodeId, blobURL, image.naturalWidth, image.naturalHeight, transform);
}
async function $d23ab19b459a5cef$export$260f1342281499a4(path, nodeId, mime, documentId, url) {
    const data = await fetch(url);
    const blob = await data.blob();
    const blobURL = URL.createObjectURL(blob);
    // Pre-decode the image so it is ready to be drawn instantly once it's placed into the viewport SVG
    const image = new Image();
    image.src = blobURL;
    await image.decode();
    window["editorInstance"]?.setImageBlobURL(documentId, path, nodeId, blobURL, image.naturalWidth, image.naturalHeight, undefined);
}

const $d23ab19b459a5cef$var$tauri = "__TAURI_METADATA__" in window && (parcelRequire("kw0CW"));
async function $d23ab19b459a5cef$export$be6de309127183b5(message) {
    if (!$d23ab19b459a5cef$var$tauri) return;
    try {
        const response = await (await $d23ab19b459a5cef$var$tauri).invoke("handle_message", {
            message: message
        });
        window["editorInstance"]?.tauriResponse(response);
    } catch  {
        // eslint-disable-next-line no-console
        console.error("Failed to dispatch Tauri message");
    }
}
async function $d23ab19b459a5cef$export$3b24329f2e9107b6() {
    // Skip if the WASM module is already initialized
    if ($d23ab19b459a5cef$var$wasmImport !== undefined) return;
    // Import the WASM module JS bindings and wrap them in the panic proxy
    // eslint-disable-next-line import/no-cycle
    await (0, $1078ca955870c324$export$2e2bcd8739ae039)();
    $d23ab19b459a5cef$var$wasmImport = await (0, $1078ca955870c324$export$6aca68b176279447)();
    window["imageCanvases"] = {};
    // Provide a random starter seed which must occur after initializing the WASM module, since WASM can't generate its own random numbers
    const randomSeedFloat = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    const randomSeed = BigInt(randomSeedFloat);
    (0, $1078ca955870c324$export$74d4fed657706d5a)(randomSeed);
    if (!$d23ab19b459a5cef$var$tauri) return;
    await (await $d23ab19b459a5cef$var$tauri).invoke("set_random_seed", {
        seed: randomSeedFloat
    });
}
function $d23ab19b459a5cef$export$eb02d1ee0d3cac30() {
    // Raw: Object containing several callable functions from `editor_api.rs` defined directly on the WASM module, not the editor instance (generated by wasm-bindgen)
    if (!$d23ab19b459a5cef$var$wasmImport) throw new Error("Editor WASM backend was not initialized at application startup");
    const raw = $d23ab19b459a5cef$var$wasmImport;
    // Instance: Object containing many functions from `editor_api.rs` that are part of the editor instance (generated by wasm-bindgen)
    const instance = new (0, $1078ca955870c324$export$7fc39e9d04ca6232)((messageType, messageData)=>{
        // This callback is called by WASM when a FrontendMessage is received from the WASM wrapper editor instance
        // We pass along the first two arguments then add our own `raw` and `instance` context for the last two arguments
        subscriptions.handleJsMessage(messageType, messageData, raw, instance);
    });
    window["editorInstance"] = instance;
    // Subscriptions: Allows subscribing to messages in JS that are sent from the WASM backend
    const subscriptions = (0, $942f35ac0a63ea85$export$6d9e7d27694a253a)();
    // Check if the URL hash fragment has any demo artwork to be loaded
    (async ()=>{
        const demoArtwork = window.location.hash.trim().match(/#demo\/(.*)/)?.[1];
        if (!demoArtwork) return;
        try {
            const url = new URL(`https://raw.githubusercontent.com/GraphiteEditor/Graphite/master/demo-artwork/${demoArtwork}.graphite`);
            const data = await fetch(url);
            const filename = url.pathname.split("/").pop() || "Untitled";
            const content = await data.text();
            instance.openDocumentFile(filename, content);
            // Remove the hash fragment from the URL
            history.replaceState("", "", `${window.location.pathname}${window.location.search}`);
        } catch  {}
    })();
    return {
        raw: raw,
        instance: instance,
        subscriptions: subscriptions
    };
}
function $d23ab19b459a5cef$export$6efc75f6eb6c74f9() {
    window["editorInstance"]?.injectImaginatePollServerStatus();
}


let $1078ca955870c324$var$wasm;
const $1078ca955870c324$var$heap = new Array(128).fill(undefined);
$1078ca955870c324$var$heap.push(undefined, null, true, false);
function $1078ca955870c324$var$getObject(idx) {
    return $1078ca955870c324$var$heap[idx];
}
let $1078ca955870c324$var$heap_next = $1078ca955870c324$var$heap.length;
function $1078ca955870c324$var$dropObject(idx) {
    if (idx < 132) return;
    $1078ca955870c324$var$heap[idx] = $1078ca955870c324$var$heap_next;
    $1078ca955870c324$var$heap_next = idx;
}
function $1078ca955870c324$var$takeObject(idx) {
    const ret = $1078ca955870c324$var$getObject(idx);
    $1078ca955870c324$var$dropObject(idx);
    return ret;
}
const $1078ca955870c324$var$cachedTextDecoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-8", {
    ignoreBOM: true,
    fatal: true
}) : {
    decode: ()=>{
        throw Error("TextDecoder not available");
    }
};
if (typeof TextDecoder !== "undefined") $1078ca955870c324$var$cachedTextDecoder.decode();
let $1078ca955870c324$var$cachedUint8Memory0 = null;
function $1078ca955870c324$var$getUint8Memory0() {
    if ($1078ca955870c324$var$cachedUint8Memory0 === null || $1078ca955870c324$var$cachedUint8Memory0.byteLength === 0) $1078ca955870c324$var$cachedUint8Memory0 = new Uint8Array($1078ca955870c324$var$wasm.memory.buffer);
    return $1078ca955870c324$var$cachedUint8Memory0;
}
function $1078ca955870c324$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $1078ca955870c324$var$cachedTextDecoder.decode($1078ca955870c324$var$getUint8Memory0().subarray(ptr, ptr + len));
}
function $1078ca955870c324$var$addHeapObject(obj) {
    if ($1078ca955870c324$var$heap_next === $1078ca955870c324$var$heap.length) $1078ca955870c324$var$heap.push($1078ca955870c324$var$heap.length + 1);
    const idx = $1078ca955870c324$var$heap_next;
    $1078ca955870c324$var$heap_next = $1078ca955870c324$var$heap[idx];
    $1078ca955870c324$var$heap[idx] = obj;
    return idx;
}
let $1078ca955870c324$var$WASM_VECTOR_LEN = 0;
const $1078ca955870c324$var$cachedTextEncoder = typeof TextEncoder !== "undefined" ? new TextEncoder("utf-8") : {
    encode: ()=>{
        throw Error("TextEncoder not available");
    }
};
const $1078ca955870c324$var$encodeString = typeof $1078ca955870c324$var$cachedTextEncoder.encodeInto === "function" ? function(arg, view) {
    return $1078ca955870c324$var$cachedTextEncoder.encodeInto(arg, view);
} : function(arg, view) {
    const buf = $1078ca955870c324$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
function $1078ca955870c324$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $1078ca955870c324$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $1078ca955870c324$var$getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        $1078ca955870c324$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $1078ca955870c324$var$getUint8Memory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $1078ca955870c324$var$getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = $1078ca955870c324$var$encodeString(arg, view);
        offset += ret.written;
    }
    $1078ca955870c324$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
function $1078ca955870c324$var$isLikeNone(x) {
    return x === undefined || x === null;
}
let $1078ca955870c324$var$cachedInt32Memory0 = null;
function $1078ca955870c324$var$getInt32Memory0() {
    if ($1078ca955870c324$var$cachedInt32Memory0 === null || $1078ca955870c324$var$cachedInt32Memory0.byteLength === 0) $1078ca955870c324$var$cachedInt32Memory0 = new Int32Array($1078ca955870c324$var$wasm.memory.buffer);
    return $1078ca955870c324$var$cachedInt32Memory0;
}
let $1078ca955870c324$var$cachedFloat64Memory0 = null;
function $1078ca955870c324$var$getFloat64Memory0() {
    if ($1078ca955870c324$var$cachedFloat64Memory0 === null || $1078ca955870c324$var$cachedFloat64Memory0.byteLength === 0) $1078ca955870c324$var$cachedFloat64Memory0 = new Float64Array($1078ca955870c324$var$wasm.memory.buffer);
    return $1078ca955870c324$var$cachedFloat64Memory0;
}
let $1078ca955870c324$var$cachedBigInt64Memory0 = null;
function $1078ca955870c324$var$getBigInt64Memory0() {
    if ($1078ca955870c324$var$cachedBigInt64Memory0 === null || $1078ca955870c324$var$cachedBigInt64Memory0.byteLength === 0) $1078ca955870c324$var$cachedBigInt64Memory0 = new BigInt64Array($1078ca955870c324$var$wasm.memory.buffer);
    return $1078ca955870c324$var$cachedBigInt64Memory0;
}
function $1078ca955870c324$var$debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == "number" || type == "boolean" || val == null) return `${val}`;
    if (type == "string") return `"${val}"`;
    if (type == "symbol") {
        const description = val.description;
        if (description == null) return "Symbol";
        else return `Symbol(${description})`;
    }
    if (type == "function") {
        const name = val.name;
        if (typeof name == "string" && name.length > 0) return `Function(${name})`;
        else return "Function";
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = "[";
        if (length > 0) debug += $1078ca955870c324$var$debugString(val[0]);
        for(let i = 1; i < length; i++)debug += ", " + $1078ca955870c324$var$debugString(val[i]);
        debug += "]";
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) className = builtInMatches[1];
    else // Failed to match the standard '[object ClassName]'
    return toString.call(val);
    if (className == "Object") // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
        return "Object(" + JSON.stringify(val) + ")";
    } catch (_) {
        return "Object";
    }
    // errors
    if (val instanceof Error) return `${val.name}: ${val.message}\n${val.stack}`;
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}
function $1078ca955870c324$var$makeMutClosure(arg0, arg1, dtor, f) {
    const state = {
        a: arg0,
        b: arg1,
        cnt: 1,
        dtor: dtor
    };
    const real = (...args)=>{
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally{
            if (--state.cnt === 0) $1078ca955870c324$var$wasm.__wbindgen_export_2.get(state.dtor)(a, state.b);
            else state.a = a;
        }
    };
    real.original = state;
    return real;
}
function $1078ca955870c324$var$__wbg_adapter_48(arg0, arg1) {
    $1078ca955870c324$var$wasm._ZN12wasm_bindgen7convert8closures11invoke0_mut17h082d5ea7eb37f16aE(arg0, arg1);
}
function $1078ca955870c324$var$__wbg_adapter_51(arg0, arg1, arg2) {
    $1078ca955870c324$var$wasm._ZN12wasm_bindgen7convert8closures11invoke1_mut17h57cf84ef9e0f433cE(arg0, arg1, $1078ca955870c324$var$addHeapObject(arg2));
}
function $1078ca955870c324$var$__wbg_adapter_56(arg0, arg1, arg2) {
    $1078ca955870c324$var$wasm._ZN136__LT_dyn_u20_core__ops__function__FnMut_LT__LP_A_C__RP__GT__u2b_Output_u20__u3d__u20_R_u20_as_u20_wasm_bindgen__closure__WasmClosure_GT_8describe6invoke17h5b4b528234282e49E(arg0, arg1, $1078ca955870c324$var$addHeapObject(arg2));
}
function $1078ca955870c324$export$74d4fed657706d5a(seed) {
    $1078ca955870c324$var$wasm.setRandomSeed(seed);
}
let $1078ca955870c324$var$cachedBigUint64Memory0 = null;
function $1078ca955870c324$var$getBigUint64Memory0() {
    if ($1078ca955870c324$var$cachedBigUint64Memory0 === null || $1078ca955870c324$var$cachedBigUint64Memory0.byteLength === 0) $1078ca955870c324$var$cachedBigUint64Memory0 = new BigUint64Array($1078ca955870c324$var$wasm.memory.buffer);
    return $1078ca955870c324$var$cachedBigUint64Memory0;
}
function $1078ca955870c324$var$getArrayU64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $1078ca955870c324$var$getBigUint64Memory0().subarray(ptr / 8, ptr / 8 + len);
}
function $1078ca955870c324$var$getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $1078ca955870c324$var$getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}
function $1078ca955870c324$export$6aca68b176279447() {
    const ret = $1078ca955870c324$var$wasm.wasmMemory();
    return $1078ca955870c324$var$takeObject(ret);
}
function $1078ca955870c324$var$passArrayF64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    $1078ca955870c324$var$getFloat64Memory0().set(arg, ptr / 8);
    $1078ca955870c324$var$WASM_VECTOR_LEN = arg.length;
    return ptr;
}
function $1078ca955870c324$var$passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    $1078ca955870c324$var$getUint8Memory0().set(arg, ptr / 1);
    $1078ca955870c324$var$WASM_VECTOR_LEN = arg.length;
    return ptr;
}
function $1078ca955870c324$var$passArray64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    $1078ca955870c324$var$getBigUint64Memory0().set(arg, ptr / 8);
    $1078ca955870c324$var$WASM_VECTOR_LEN = arg.length;
    return ptr;
}
function $1078ca955870c324$export$370f494eccd8554e() {
    $1078ca955870c324$var$wasm.init_graphite();
}
function $1078ca955870c324$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        $1078ca955870c324$var$wasm.__wbindgen_exn_store($1078ca955870c324$var$addHeapObject(e));
    }
}
let $1078ca955870c324$var$cachedUint32Memory0 = null;
function $1078ca955870c324$var$getUint32Memory0() {
    if ($1078ca955870c324$var$cachedUint32Memory0 === null || $1078ca955870c324$var$cachedUint32Memory0.byteLength === 0) $1078ca955870c324$var$cachedUint32Memory0 = new Uint32Array($1078ca955870c324$var$wasm.memory.buffer);
    return $1078ca955870c324$var$cachedUint32Memory0;
}
function $1078ca955870c324$var$getArrayU32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $1078ca955870c324$var$getUint32Memory0().subarray(ptr / 4, ptr / 4 + len);
}
let $1078ca955870c324$var$cachedUint8ClampedMemory0 = null;
function $1078ca955870c324$var$getUint8ClampedMemory0() {
    if ($1078ca955870c324$var$cachedUint8ClampedMemory0 === null || $1078ca955870c324$var$cachedUint8ClampedMemory0.byteLength === 0) $1078ca955870c324$var$cachedUint8ClampedMemory0 = new Uint8ClampedArray($1078ca955870c324$var$wasm.memory.buffer);
    return $1078ca955870c324$var$cachedUint8ClampedMemory0;
}
function $1078ca955870c324$var$getClampedArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $1078ca955870c324$var$getUint8ClampedMemory0().subarray(ptr / 1, ptr / 1 + len);
}
class $1078ca955870c324$export$7fc39e9d04ca6232 {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create($1078ca955870c324$export$7fc39e9d04ca6232.prototype);
        obj.__wbg_ptr = ptr;
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $1078ca955870c324$var$wasm.__wbg_jseditorhandle_free(ptr);
    }
    /**
    * @param {Function} frontend_message_handler_callback
    */ constructor(frontend_message_handler_callback){
        const ret = $1078ca955870c324$var$wasm.jseditorhandle_new($1078ca955870c324$var$addHeapObject(frontend_message_handler_callback));
        return $1078ca955870c324$export$7fc39e9d04ca6232.__wrap(ret);
    }
    /**
    * @param {string} platform
    */ initAfterFrontendReady(platform) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(platform, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_initAfterFrontendReady(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @param {any} _message
    */ tauriResponse(_message) {
        $1078ca955870c324$var$wasm.jseditorhandle_tauriResponse(this.__wbg_ptr, $1078ca955870c324$var$addHeapObject(_message));
    }
    /**
    * Displays a dialog with an error message
    * @param {string} title
    * @param {string} description
    */ errorDialog(title, description) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(title, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(description, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_errorDialog(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
    * Answer whether or not the editor has crashed
    * @returns {boolean}
    */ hasCrashed() {
        const ret = $1078ca955870c324$var$wasm.jseditorhandle_hasCrashed(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * Answer whether or not the editor is in development mode
    * @returns {boolean}
    */ inDevelopmentMode() {
        const ret = $1078ca955870c324$var$wasm.jseditorhandle_inDevelopmentMode(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * Get the constant `FILE_SAVE_SUFFIX`
    * @returns {string}
    */ fileSaveSuffix() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            $1078ca955870c324$var$wasm.jseditorhandle_fileSaveSuffix(retptr, this.__wbg_ptr);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return $1078ca955870c324$var$getStringFromWasm0(r0, r1);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
            $1078ca955870c324$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * Get the constant `GRAPHITE_DOCUMENT_VERSION`
    * @returns {string}
    */ graphiteDocumentVersion() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            $1078ca955870c324$var$wasm.jseditorhandle_graphiteDocumentVersion(retptr, this.__wbg_ptr);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return $1078ca955870c324$var$getStringFromWasm0(r0, r1);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
            $1078ca955870c324$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * Update layout of a given UI
    * @param {any} layout_target
    * @param {bigint} widget_id
    * @param {any} value
    */ updateLayout(layout_target, widget_id, value) {
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            $1078ca955870c324$var$wasm.jseditorhandle_updateLayout(retptr, this.__wbg_ptr, $1078ca955870c324$var$addHeapObject(layout_target), widget_id, $1078ca955870c324$var$addHeapObject(value));
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            if (r1) throw $1078ca955870c324$var$takeObject(r0);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} preferences
    */ loadPreferences(preferences) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(preferences, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_loadPreferences(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @param {bigint} document_id
    */ selectDocument(document_id) {
        $1078ca955870c324$var$wasm.jseditorhandle_selectDocument(this.__wbg_ptr, document_id);
    }
    /**
    */ newDocumentDialog() {
        $1078ca955870c324$var$wasm.jseditorhandle_newDocumentDialog(this.__wbg_ptr);
    }
    /**
    */ openDocument() {
        $1078ca955870c324$var$wasm.jseditorhandle_openDocument(this.__wbg_ptr);
    }
    /**
    */ demoArtworkDialog() {
        $1078ca955870c324$var$wasm.jseditorhandle_demoArtworkDialog(this.__wbg_ptr);
    }
    /**
    * @param {string} document_name
    * @param {string} document_serialized_content
    */ openDocumentFile(document_name, document_serialized_content) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(document_name, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(document_serialized_content, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_openDocumentFile(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
    * @param {bigint} document_id
    * @param {string} document_name
    * @param {boolean} document_is_saved
    * @param {string} document_serialized_content
    */ openAutoSavedDocument(document_id, document_name, document_is_saved, document_serialized_content) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(document_name, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(document_serialized_content, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_openAutoSavedDocument(this.__wbg_ptr, document_id, ptr0, len0, document_is_saved, ptr1, len1);
    }
    /**
    * @param {bigint} document_id
    */ triggerAutoSave(document_id) {
        $1078ca955870c324$var$wasm.jseditorhandle_triggerAutoSave(this.__wbg_ptr, document_id);
    }
    /**
    * @param {bigint} document_id
    */ closeDocumentWithConfirmation(document_id) {
        $1078ca955870c324$var$wasm.jseditorhandle_closeDocumentWithConfirmation(this.__wbg_ptr, document_id);
    }
    /**
    * @param {string} localized_commit_date
    * @param {string} localized_commit_year
    */ requestAboutGraphiteDialogWithLocalizedCommitDate(localized_commit_date, localized_commit_year) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(localized_commit_date, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(localized_commit_year, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_requestAboutGraphiteDialogWithLocalizedCommitDate(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
    * Send new bounds when document panel viewports get resized or moved within the editor
    * [left, top, right, bottom]...
    * @param {Float64Array} bounds_of_viewports
    */ boundsOfViewports(bounds_of_viewports) {
        const ptr0 = $1078ca955870c324$var$passArrayF64ToWasm0(bounds_of_viewports, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_boundsOfViewports(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * Mouse movement within the screenspace bounds of the viewport
    * @param {number} x
    * @param {number} y
    * @param {number} mouse_keys
    * @param {number} modifiers
    */ onMouseMove(x, y, mouse_keys, modifiers) {
        $1078ca955870c324$var$wasm.jseditorhandle_onMouseMove(this.__wbg_ptr, x, y, mouse_keys, modifiers);
    }
    /**
    * Mouse scrolling within the screenspace bounds of the viewport
    * @param {number} x
    * @param {number} y
    * @param {number} mouse_keys
    * @param {number} wheel_delta_x
    * @param {number} wheel_delta_y
    * @param {number} wheel_delta_z
    * @param {number} modifiers
    */ onWheelScroll(x, y, mouse_keys, wheel_delta_x, wheel_delta_y, wheel_delta_z, modifiers) {
        $1078ca955870c324$var$wasm.jseditorhandle_onWheelScroll(this.__wbg_ptr, x, y, mouse_keys, wheel_delta_x, wheel_delta_y, wheel_delta_z, modifiers);
    }
    /**
    * A mouse button depressed within screenspace the bounds of the viewport
    * @param {number} x
    * @param {number} y
    * @param {number} mouse_keys
    * @param {number} modifiers
    */ onMouseDown(x, y, mouse_keys, modifiers) {
        $1078ca955870c324$var$wasm.jseditorhandle_onMouseDown(this.__wbg_ptr, x, y, mouse_keys, modifiers);
    }
    /**
    * A mouse button released
    * @param {number} x
    * @param {number} y
    * @param {number} mouse_keys
    * @param {number} modifiers
    */ onMouseUp(x, y, mouse_keys, modifiers) {
        $1078ca955870c324$var$wasm.jseditorhandle_onMouseUp(this.__wbg_ptr, x, y, mouse_keys, modifiers);
    }
    /**
    * Mouse double clicked
    * @param {number} x
    * @param {number} y
    * @param {number} mouse_keys
    * @param {number} modifiers
    */ onDoubleClick(x, y, mouse_keys, modifiers) {
        $1078ca955870c324$var$wasm.jseditorhandle_onDoubleClick(this.__wbg_ptr, x, y, mouse_keys, modifiers);
    }
    /**
    * A keyboard button depressed within screenspace the bounds of the viewport
    * @param {string} name
    * @param {number} modifiers
    * @param {boolean} key_repeat
    */ onKeyDown(name, modifiers, key_repeat) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(name, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_onKeyDown(this.__wbg_ptr, ptr0, len0, modifiers, key_repeat);
    }
    /**
    * A keyboard button released
    * @param {string} name
    * @param {number} modifiers
    * @param {boolean} key_repeat
    */ onKeyUp(name, modifiers, key_repeat) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(name, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_onKeyUp(this.__wbg_ptr, ptr0, len0, modifiers, key_repeat);
    }
    /**
    * A text box was committed
    * @param {string} new_text
    */ onChangeText(new_text) {
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = $1078ca955870c324$var$passStringToWasm0(new_text, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
            const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
            $1078ca955870c324$var$wasm.jseditorhandle_onChangeText(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            if (r1) throw $1078ca955870c324$var$takeObject(r0);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * A font has been downloaded
    * @param {string} font_family
    * @param {string} font_style
    * @param {string} preview_url
    * @param {Uint8Array} data
    * @param {boolean} is_default
    */ onFontLoad(font_family, font_style, preview_url, data, is_default) {
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = $1078ca955870c324$var$passStringToWasm0(font_family, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
            const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
            const ptr1 = $1078ca955870c324$var$passStringToWasm0(font_style, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
            const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
            const ptr2 = $1078ca955870c324$var$passStringToWasm0(preview_url, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
            const len2 = $1078ca955870c324$var$WASM_VECTOR_LEN;
            const ptr3 = $1078ca955870c324$var$passArray8ToWasm0(data, $1078ca955870c324$var$wasm.__wbindgen_malloc);
            const len3 = $1078ca955870c324$var$WASM_VECTOR_LEN;
            $1078ca955870c324$var$wasm.jseditorhandle_onFontLoad(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, is_default);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            if (r1) throw $1078ca955870c324$var$takeObject(r0);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * A text box was changed
    * @param {string} new_text
    */ updateBounds(new_text) {
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = $1078ca955870c324$var$passStringToWasm0(new_text, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
            const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
            $1078ca955870c324$var$wasm.jseditorhandle_updateBounds(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            if (r1) throw $1078ca955870c324$var$takeObject(r0);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Begin sampling a pixel color from the document by entering eyedropper sampling mode
    */ eyedropperSampleForColorPicker() {
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            $1078ca955870c324$var$wasm.jseditorhandle_eyedropperSampleForColorPicker(retptr, this.__wbg_ptr);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            if (r1) throw $1078ca955870c324$var$takeObject(r0);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Update primary color with values on a scale from 0 to 1.
    * @param {number} red
    * @param {number} green
    * @param {number} blue
    * @param {number} alpha
    */ updatePrimaryColor(red, green, blue, alpha) {
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            $1078ca955870c324$var$wasm.jseditorhandle_updatePrimaryColor(retptr, this.__wbg_ptr, red, green, blue, alpha);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            if (r1) throw $1078ca955870c324$var$takeObject(r0);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Update secondary color with values on a scale from 0 to 1.
    * @param {number} red
    * @param {number} green
    * @param {number} blue
    * @param {number} alpha
    */ updateSecondaryColor(red, green, blue, alpha) {
        try {
            const retptr = $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(-16);
            $1078ca955870c324$var$wasm.jseditorhandle_updateSecondaryColor(retptr, this.__wbg_ptr, red, green, blue, alpha);
            var r0 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 0];
            var r1 = $1078ca955870c324$var$getInt32Memory0()[retptr / 4 + 1];
            if (r1) throw $1078ca955870c324$var$takeObject(r0);
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Paste layers from a serialized json representation
    * @param {string} data
    */ pasteSerializedData(data) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(data, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_pasteSerializedData(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * Modify the layer selection based on the layer which is clicked while holding down the <kbd>Ctrl</kbd> and/or <kbd>Shift</kbd> modifier keys used for range selection behavior
    * @param {BigUint64Array} layer_path
    * @param {boolean} ctrl
    * @param {boolean} shift
    */ selectLayer(layer_path, ctrl, shift) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(layer_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_selectLayer(this.__wbg_ptr, ptr0, len0, ctrl, shift);
    }
    /**
    * Deselect all layers
    */ deselectAllLayers() {
        $1078ca955870c324$var$wasm.jseditorhandle_deselectAllLayers(this.__wbg_ptr);
    }
    /**
    * Move a layer to be next to the specified neighbor
    * @param {BigUint64Array} folder_path
    * @param {number} insert_index
    */ moveLayerInTree(folder_path, insert_index) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(folder_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_moveLayerInTree(this.__wbg_ptr, ptr0, len0, insert_index);
    }
    /**
    * Set the name for the layer
    * @param {BigUint64Array} layer_path
    * @param {string} name
    */ setLayerName(layer_path, name) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(layer_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(name, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_setLayerName(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
    * Translates document (in viewport coords)
    * @param {number} delta_x
    * @param {number} delta_y
    */ translateCanvas(delta_x, delta_y) {
        $1078ca955870c324$var$wasm.jseditorhandle_translateCanvas(this.__wbg_ptr, delta_x, delta_y);
    }
    /**
    * Translates document (in viewport coords)
    * @param {number} delta_x
    * @param {number} delta_y
    */ translateCanvasByFraction(delta_x, delta_y) {
        $1078ca955870c324$var$wasm.jseditorhandle_translateCanvasByFraction(this.__wbg_ptr, delta_x, delta_y);
    }
    /**
    * Sends the blob URL generated by JS to the Image layer
    * @param {bigint} document_id
    * @param {BigUint64Array} layer_path
    * @param {bigint | undefined} node_id
    * @param {string} blob_url
    * @param {number} width
    * @param {number} height
    * @param {Float64Array | undefined} transform
    */ setImageBlobURL(document_id, layer_path, node_id, blob_url, width, height, transform) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(layer_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(blob_url, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_setImageBlobURL(this.__wbg_ptr, document_id, ptr0, len0, !$1078ca955870c324$var$isLikeNone(node_id), $1078ca955870c324$var$isLikeNone(node_id) ? BigInt(0) : node_id, ptr1, len1, width, height, $1078ca955870c324$var$isLikeNone(transform) ? 0 : $1078ca955870c324$var$addHeapObject(transform));
    }
    /**
    * Sends the blob URL generated by JS to the Imaginate layer in the respective document
    * @param {bigint} document_id
    * @param {BigUint64Array} layer_path
    * @param {Uint8Array} _input_image_data
    * @param {number} _width
    * @param {number} _height
    */ renderGraphUsingRasterizedRegionBelowLayer(document_id, layer_path, _input_image_data, _width, _height) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(layer_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passArray8ToWasm0(_input_image_data, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_renderGraphUsingRasterizedRegionBelowLayer(this.__wbg_ptr, document_id, ptr0, len0, ptr1, len1, _width, _height);
    }
    /**
    * Notifies the backend that the user connected a node's primary output to one of another node's inputs
    * @param {bigint} output_node
    * @param {number} output_node_connector_index
    * @param {bigint} input_node
    * @param {number} input_node_connector_index
    */ connectNodesByLink(output_node, output_node_connector_index, input_node, input_node_connector_index) {
        $1078ca955870c324$var$wasm.jseditorhandle_connectNodesByLink(this.__wbg_ptr, output_node, output_node_connector_index, input_node, input_node_connector_index);
    }
    /**
    * Shifts the node and its children to stop nodes going on top of each other
    * @param {bigint} node_id
    */ shiftNode(node_id) {
        $1078ca955870c324$var$wasm.jseditorhandle_shiftNode(this.__wbg_ptr, node_id);
    }
    /**
    * Notifies the backend that the user disconnected a node
    * @param {bigint} node_id
    * @param {number} input_index
    */ disconnectNodes(node_id, input_index) {
        $1078ca955870c324$var$wasm.jseditorhandle_disconnectNodes(this.__wbg_ptr, node_id, input_index);
    }
    /**
    * Check for intersections between the curve and a rectangle defined by opposite corners
    * @param {Float64Array} bezier_x
    * @param {Float64Array} bezier_y
    * @param {number} top
    * @param {number} left
    * @param {number} bottom
    * @param {number} right
    * @returns {boolean}
    */ rectangleIntersects(bezier_x, bezier_y, top, left, bottom, right) {
        const ptr0 = $1078ca955870c324$var$passArrayF64ToWasm0(bezier_x, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ptr1 = $1078ca955870c324$var$passArrayF64ToWasm0(bezier_y, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ret = $1078ca955870c324$var$wasm.jseditorhandle_rectangleIntersects(this.__wbg_ptr, ptr0, len0, ptr1, len1, top, left, bottom, right);
        return ret !== 0;
    }
    /**
    * Creates a new document node in the node graph
    * @param {string} node_type
    * @param {number} x
    * @param {number} y
    * @returns {bigint}
    */ createNode(node_type, x, y) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(node_type, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ret = $1078ca955870c324$var$wasm.jseditorhandle_createNode(this.__wbg_ptr, ptr0, len0, x, y);
        return BigInt.asUintN(64, ret);
    }
    /**
    * Notifies the backend that the user selected a node in the node graph
    * @param {BigUint64Array | undefined} nodes
    */ selectNodes(nodes) {
        var ptr0 = $1078ca955870c324$var$isLikeNone(nodes) ? 0 : $1078ca955870c324$var$passArray64ToWasm0(nodes, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        var len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_selectNodes(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * Pastes the nodes based on serialized data
    * @param {string} serialized_nodes
    */ pasteSerializedNodes(serialized_nodes) {
        const ptr0 = $1078ca955870c324$var$passStringToWasm0(serialized_nodes, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_pasteSerializedNodes(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * Notifies the backend that the user double clicked a node
    * @param {bigint} node
    */ doubleClickNode(node) {
        $1078ca955870c324$var$wasm.jseditorhandle_doubleClickNode(this.__wbg_ptr, node);
    }
    /**
    * Notifies the backend that the selected nodes have been moved
    * @param {number} displacement_x
    * @param {number} displacement_y
    */ moveSelectedNodes(displacement_x, displacement_y) {
        $1078ca955870c324$var$wasm.jseditorhandle_moveSelectedNodes(this.__wbg_ptr, displacement_x, displacement_y);
    }
    /**
    * Toggle preview on node
    * @param {bigint} node_id
    */ togglePreview(node_id) {
        $1078ca955870c324$var$wasm.jseditorhandle_togglePreview(this.__wbg_ptr, node_id);
    }
    /**
    * Pastes an image
    * @param {Uint8Array} image_data
    * @param {number} width
    * @param {number} height
    * @param {number | undefined} mouse_x
    * @param {number | undefined} mouse_y
    */ pasteImage(image_data, width, height, mouse_x, mouse_y) {
        const ptr0 = $1078ca955870c324$var$passArray8ToWasm0(image_data, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_pasteImage(this.__wbg_ptr, ptr0, len0, width, height, !$1078ca955870c324$var$isLikeNone(mouse_x), $1078ca955870c324$var$isLikeNone(mouse_x) ? 0 : mouse_x, !$1078ca955870c324$var$isLikeNone(mouse_y), $1078ca955870c324$var$isLikeNone(mouse_y) ? 0 : mouse_y);
    }
    /**
    * Toggle visibility of a layer from the layer list
    * @param {BigUint64Array} layer_path
    */ toggleLayerVisibility(layer_path) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(layer_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_toggleLayerVisibility(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * Toggle expansions state of a layer from the layer list
    * @param {BigUint64Array} layer_path
    */ toggleLayerExpansion(layer_path) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(layer_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$wasm.jseditorhandle_toggleLayerExpansion(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * Returns the string representation of the nodes contents
    * @param {BigUint64Array} node_path
    * @returns {any}
    */ introspectNode(node_path) {
        const ptr0 = $1078ca955870c324$var$passArray64ToWasm0(node_path, $1078ca955870c324$var$wasm.__wbindgen_malloc);
        const len0 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        const ret = $1078ca955870c324$var$wasm.jseditorhandle_introspectNode(this.__wbg_ptr, ptr0, len0);
        return $1078ca955870c324$var$takeObject(ret);
    }
    /**
    */ injectImaginatePollServerStatus() {
        $1078ca955870c324$var$wasm.jseditorhandle_injectImaginatePollServerStatus(this.__wbg_ptr);
    }
}
async function $1078ca955870c324$var$__wbg_load(module, imports) {
    if (typeof Response === "function" && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === "function") try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            if (module.headers.get("Content-Type") != "application/wasm") console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
}
function $1078ca955870c324$var$__wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        $1078ca955870c324$var$takeObject(arg0);
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getStringFromWasm0(arg0, arg1);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_function = function(arg0) {
        const ret = typeof $1078ca955870c324$var$getObject(arg0) === "function";
        return ret;
    };
    imports.wbg.__wbindgen_cb_drop = function(arg0) {
        const obj = $1078ca955870c324$var$takeObject(arg0).original;
        if (obj.cnt-- == 1) {
            obj.a = 0;
            return true;
        }
        const ret = false;
        return ret;
    };
    imports.wbg.__wbindgen_object_clone_ref = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_updateImage_93062302d8eb86ed = function(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
        let deferred1_0;
        let deferred1_1;
        try {
            var v0 = $1078ca955870c324$var$getArrayU64FromWasm0(arg0, arg1).slice();
            $1078ca955870c324$var$wasm.__wbindgen_free(arg0, arg1 * 8);
            deferred1_0 = arg4;
            deferred1_1 = arg5;
            (0, $e7d4b7b9b3ba44f6$export$d2445f1399d5a873)(v0, arg2 === 0 ? undefined : BigInt.asUintN(64, arg3), $1078ca955870c324$var$getStringFromWasm0(arg4, arg5), $1078ca955870c324$var$getArrayU8FromWasm0(arg6, arg7), $1078ca955870c324$var$takeObject(arg8), BigInt.asUintN(64, arg9));
        } finally{
            $1078ca955870c324$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    };
    imports.wbg.__wbg_new_ac5f45e4f431c14c = function(arg0, arg1) {
        const ret = new Error($1078ca955870c324$var$getStringFromWasm0(arg0, arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_log_803f1852656bbb3f = function(arg0, arg1, arg2, arg3) {
        console.log($1078ca955870c324$var$getStringFromWasm0(arg0, arg1), $1078ca955870c324$var$getStringFromWasm0(arg2, arg3));
    };
    imports.wbg.__wbg_info_9b1bb36bfe4549ac = function(arg0, arg1, arg2, arg3) {
        console.info($1078ca955870c324$var$getStringFromWasm0(arg0, arg1), $1078ca955870c324$var$getStringFromWasm0(arg2, arg3));
    };
    imports.wbg.__wbg_warn_df92a82289810fb2 = function(arg0, arg1, arg2, arg3) {
        console.warn($1078ca955870c324$var$getStringFromWasm0(arg0, arg1), $1078ca955870c324$var$getStringFromWasm0(arg2, arg3));
    };
    imports.wbg.__wbg_error_7e5e83a91bb6b43a = function(arg0, arg1, arg2, arg3) {
        console.error($1078ca955870c324$var$getStringFromWasm0(arg0, arg1), $1078ca955870c324$var$getStringFromWasm0(arg2, arg3));
    };
    imports.wbg.__wbindgen_error_new = function(arg0, arg1) {
        const ret = new Error($1078ca955870c324$var$getStringFromWasm0(arg0, arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = $1078ca955870c324$var$getObject(arg1);
        const ret = typeof obj === "string" ? obj : undefined;
        var ptr1 = $1078ca955870c324$var$isLikeNone(ret) ? 0 : $1078ca955870c324$var$passStringToWasm0(ret, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        var len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 1] = len1;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbindgen_boolean_get = function(arg0) {
        const v = $1078ca955870c324$var$getObject(arg0);
        const ret = typeof v === "boolean" ? v ? 1 : 0 : 2;
        return ret;
    };
    imports.wbg.__wbindgen_is_bigint = function(arg0) {
        const ret = typeof $1078ca955870c324$var$getObject(arg0) === "bigint";
        return ret;
    };
    imports.wbg.__wbindgen_bigint_from_i64 = function(arg0) {
        const ret = arg0;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_jsval_eq = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0) === $1078ca955870c324$var$getObject(arg1);
        return ret;
    };
    imports.wbg.__wbindgen_bigint_from_u64 = function(arg0) {
        const ret = BigInt.asUintN(64, arg0);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_number_get = function(arg0, arg1) {
        const obj = $1078ca955870c324$var$getObject(arg1);
        const ret = typeof obj === "number" ? obj : undefined;
        $1078ca955870c324$var$getFloat64Memory0()[arg0 / 8 + 1] = $1078ca955870c324$var$isLikeNone(ret) ? 0 : ret;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 0] = !$1078ca955870c324$var$isLikeNone(ret);
    };
    imports.wbg.__wbindgen_is_object = function(arg0) {
        const val = $1078ca955870c324$var$getObject(arg0);
        const ret = typeof val === "object" && val !== null;
        return ret;
    };
    imports.wbg.__wbindgen_in = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0) in $1078ca955870c324$var$getObject(arg1);
        return ret;
    };
    imports.wbg.__wbindgen_is_string = function(arg0) {
        const ret = typeof $1078ca955870c324$var$getObject(arg0) === "string";
        return ret;
    };
    imports.wbg.__wbindgen_jsval_loose_eq = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0) == $1078ca955870c324$var$getObject(arg1);
        return ret;
    };
    imports.wbg.__wbindgen_number_new = function(arg0) {
        const ret = arg0;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_set_841ac57cff3d672b = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0)[$1078ca955870c324$var$takeObject(arg1)] = $1078ca955870c324$var$takeObject(arg2);
    };
    imports.wbg.__wbg_fetch_00bb9f58d5ca4758 = function(arg0) {
        const ret = fetch($1078ca955870c324$var$getObject(arg0));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_Window_17fd8eee712535f9 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).Window;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0) === undefined;
        return ret;
    };
    imports.wbg.__wbg_WorkerGlobalScope_f93b9996824ad878 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).WorkerGlobalScope;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_instanceof_Window_9029196b662bc42a = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof Window;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_document_f7ace2b956f30a4f = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).document;
        return $1078ca955870c324$var$isLikeNone(ret) ? 0 : $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_navigator_7c9103698acde322 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).navigator;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_requestAnimationFrame_d082200514b6674d = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1) {
            const ret = $1078ca955870c324$var$getObject(arg0).requestAnimationFrame($1078ca955870c324$var$getObject(arg1));
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_createElement_4891554b28d3388b = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2) {
            const ret = $1078ca955870c324$var$getObject(arg0).createElement($1078ca955870c324$var$getStringFromWasm0(arg1, arg2));
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_querySelectorAll_c03e8664a5a0f0c5 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2) {
            const ret = $1078ca955870c324$var$getObject(arg0).querySelectorAll($1078ca955870c324$var$getStringFromWasm0(arg1, arg2));
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_signal_4bd18fb489af2d4c = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).signal;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_new_55c9955722952374 = function() {
        return $1078ca955870c324$var$handleError(function() {
            const ret = new AbortController();
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_abort_654b796176d117aa = function(arg0) {
        $1078ca955870c324$var$getObject(arg0).abort();
    };
    imports.wbg.__wbg_maxTextureDimension1D_4d1ddb46ed9dc470 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxTextureDimension1D;
        return ret;
    };
    imports.wbg.__wbg_maxTextureDimension2D_37a46e61490c8297 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxTextureDimension2D;
        return ret;
    };
    imports.wbg.__wbg_maxTextureDimension3D_7e3a97204d211743 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxTextureDimension3D;
        return ret;
    };
    imports.wbg.__wbg_maxTextureArrayLayers_fee4db585706a5eb = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxTextureArrayLayers;
        return ret;
    };
    imports.wbg.__wbg_maxBindGroups_dc8a5f97ba653c91 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxBindGroups;
        return ret;
    };
    imports.wbg.__wbg_maxBindingsPerBindGroup_3d5ab311420be5df = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxBindingsPerBindGroup;
        return ret;
    };
    imports.wbg.__wbg_maxDynamicUniformBuffersPerPipelineLayout_6b839b7dc97f34f0 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxDynamicUniformBuffersPerPipelineLayout;
        return ret;
    };
    imports.wbg.__wbg_maxDynamicStorageBuffersPerPipelineLayout_5328cd2b9d884831 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxDynamicStorageBuffersPerPipelineLayout;
        return ret;
    };
    imports.wbg.__wbg_maxSampledTexturesPerShaderStage_ac006b00cf776b4a = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxSampledTexturesPerShaderStage;
        return ret;
    };
    imports.wbg.__wbg_maxSamplersPerShaderStage_dc092d6a272be20a = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxSamplersPerShaderStage;
        return ret;
    };
    imports.wbg.__wbg_maxStorageBuffersPerShaderStage_dc5b58734b9ab932 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxStorageBuffersPerShaderStage;
        return ret;
    };
    imports.wbg.__wbg_maxStorageTexturesPerShaderStage_2fec939cb0d5bbfd = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxStorageTexturesPerShaderStage;
        return ret;
    };
    imports.wbg.__wbg_maxUniformBuffersPerShaderStage_b30d53cbf89caeae = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxUniformBuffersPerShaderStage;
        return ret;
    };
    imports.wbg.__wbg_maxUniformBufferBindingSize_eec576e1342504b5 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxUniformBufferBindingSize;
        return ret;
    };
    imports.wbg.__wbg_maxStorageBufferBindingSize_1ef0cc5e43dad09b = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxStorageBufferBindingSize;
        return ret;
    };
    imports.wbg.__wbg_maxVertexBuffers_b4d31be9e3f93990 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxVertexBuffers;
        return ret;
    };
    imports.wbg.__wbg_maxVertexAttributes_904c5eb19a6f6c65 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxVertexAttributes;
        return ret;
    };
    imports.wbg.__wbg_maxVertexBufferArrayStride_6800975c373d83bc = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).maxVertexBufferArrayStride;
        return ret;
    };
    imports.wbg.__wbg_message_c934153af8567cdb = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg1).message;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(ret, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 1] = len1;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_features_dfb2178c91fa1dd7 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).features;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_queue_f2aeb5c277e56f93 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).queue;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_setonuncapturederror_b3c814f611d5e585 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).onuncapturederror = $1078ca955870c324$var$getObject(arg1);
    };
    imports.wbg.__wbg_createBindGroup_fa5515d52f9c6a69 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createBindGroup($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createBindGroupLayout_af3b9d9ee0a1f5f9 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createBindGroupLayout($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createBuffer_36e159f52cc644a7 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createBuffer($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createCommandEncoder_a50a1dab2b499b95 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createCommandEncoder($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createComputePipeline_89131452dfd12672 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createComputePipeline($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createPipelineLayout_1e10c8281fb85c01 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createPipelineLayout($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createQuerySet_ccb746122176f8e5 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createQuerySet($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createRenderBundleEncoder_ad2d0237f581427b = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createRenderBundleEncoder($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createRenderPipeline_745f00bcb1ca6edf = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createRenderPipeline($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createSampler_09cd36835c9befb3 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createSampler($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createShaderModule_59bbf537b8b5cf7c = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createShaderModule($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_createTexture_dbd00b550944125c = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createTexture($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_popErrorScope_19075fb98a08b740 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).popErrorScope();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_pushErrorScope_0728aae3f2d3ed48 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).pushErrorScope($1078ca955870c324$var$takeObject(arg1));
    };
    imports.wbg.__wbg_setwidth_15266a5e81f43cf0 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).width = arg1 >>> 0;
    };
    imports.wbg.__wbg_setheight_2e9bab573f1775a6 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).height = arg1 >>> 0;
    };
    imports.wbg.__wbg_navigator_41bd88b80ed4685e = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).navigator;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_fetch_8eaf01857a5bb21f = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).fetch($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_instanceof_GpuCanvasContext_7a77e275c38d41d8 = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof GPUCanvasContext;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_configure_93a57a4e5e0f8bcf = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).configure($1078ca955870c324$var$getObject(arg1));
    };
    imports.wbg.__wbg_getCurrentTexture_ecedc4f6f71990d2 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).getCurrentTexture();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_getBindGroupLayout_dfc1b97f78c04beb = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).getBindGroupLayout(arg1 >>> 0);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_has_8720889cf3ad610c = function(arg0, arg1, arg2) {
        const ret = $1078ca955870c324$var$getObject(arg0).has($1078ca955870c324$var$getStringFromWasm0(arg1, arg2));
        return ret;
    };
    imports.wbg.__wbg_gpu_24536c9523d924b1 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).gpu;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_instanceof_HtmlCanvasElement_da5f9efa0688cf6d = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof HTMLCanvasElement;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_setwidth_a667a942dba6656e = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).width = arg1 >>> 0;
    };
    imports.wbg.__wbg_setheight_a747d440760fe5aa = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).height = arg1 >>> 0;
    };
    imports.wbg.__wbg_getContext_7c5944ea807bf5d3 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2) {
            const ret = $1078ca955870c324$var$getObject(arg0).getContext($1078ca955870c324$var$getStringFromWasm0(arg1, arg2));
            return $1078ca955870c324$var$isLikeNone(ret) ? 0 : $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_gpu_1678673f109c8aeb = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).gpu;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_instanceof_CanvasRenderingContext2d_bc0a6635c96eca9b = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof CanvasRenderingContext2D;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_putImageData_f157d52a70a206d5 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2, arg3) {
            $1078ca955870c324$var$getObject(arg0).putImageData($1078ca955870c324$var$getObject(arg1), arg2, arg3);
        }, arguments);
    };
    imports.wbg.__wbg_finish_863657abae52896e = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).finish();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_finish_e580ef236d53f04b = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).finish($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_setBindGroup_6bc8944422dbb3cd = function(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
        $1078ca955870c324$var$getObject(arg0).setBindGroup(arg1 >>> 0, $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getArrayU32FromWasm0(arg3, arg4), arg5, arg6 >>> 0);
    };
    imports.wbg.__wbg_draw_3958097471a10642 = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).draw(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4 >>> 0);
    };
    imports.wbg.__wbg_drawIndexed_8856cc4ccffa3498 = function(arg0, arg1, arg2, arg3, arg4, arg5) {
        $1078ca955870c324$var$getObject(arg0).drawIndexed(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4, arg5 >>> 0);
    };
    imports.wbg.__wbg_drawIndexedIndirect_0404fa6cb9a6db25 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).drawIndexedIndirect($1078ca955870c324$var$getObject(arg1), arg2);
    };
    imports.wbg.__wbg_drawIndirect_95c6eb1494a44d06 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).drawIndirect($1078ca955870c324$var$getObject(arg1), arg2);
    };
    imports.wbg.__wbg_setIndexBuffer_4dc5432dc348458d = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).setIndexBuffer($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$takeObject(arg2), arg3);
    };
    imports.wbg.__wbg_setIndexBuffer_f3bae4da9e407eaf = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).setIndexBuffer($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$takeObject(arg2), arg3, arg4);
    };
    imports.wbg.__wbg_setPipeline_66f1e900256fc946 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).setPipeline($1078ca955870c324$var$getObject(arg1));
    };
    imports.wbg.__wbg_setVertexBuffer_c782d133fd439184 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).setVertexBuffer(arg1 >>> 0, $1078ca955870c324$var$getObject(arg2), arg3);
    };
    imports.wbg.__wbg_setVertexBuffer_4da0a96267ce82db = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).setVertexBuffer(arg1 >>> 0, $1078ca955870c324$var$getObject(arg2), arg3, arg4);
    };
    imports.wbg.__wbg_end_bdfb66792e0c59a2 = function(arg0) {
        $1078ca955870c324$var$getObject(arg0).end();
    };
    imports.wbg.__wbg_executeBundles_0a1fdfd83c1a3e57 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).executeBundles($1078ca955870c324$var$getObject(arg1));
    };
    imports.wbg.__wbg_setBlendConstant_e89574db5137b2f6 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).setBlendConstant($1078ca955870c324$var$getObject(arg1));
    };
    imports.wbg.__wbg_setScissorRect_0af8c89e90a6e89c = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).setScissorRect(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4 >>> 0);
    };
    imports.wbg.__wbg_setStencilReference_71be0db67db2f7ab = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).setStencilReference(arg1 >>> 0);
    };
    imports.wbg.__wbg_setViewport_9c5fb686baf1cf4f = function(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
        $1078ca955870c324$var$getObject(arg0).setViewport(arg1, arg2, arg3, arg4, arg5, arg6);
    };
    imports.wbg.__wbg_setBindGroup_ce4432036922cd83 = function(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
        $1078ca955870c324$var$getObject(arg0).setBindGroup(arg1 >>> 0, $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getArrayU32FromWasm0(arg3, arg4), arg5, arg6 >>> 0);
    };
    imports.wbg.__wbg_draw_6357a5fbc8a6b097 = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).draw(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4 >>> 0);
    };
    imports.wbg.__wbg_drawIndexed_5d1dd89d7375148c = function(arg0, arg1, arg2, arg3, arg4, arg5) {
        $1078ca955870c324$var$getObject(arg0).drawIndexed(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4, arg5 >>> 0);
    };
    imports.wbg.__wbg_drawIndexedIndirect_526599171cfbbee5 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).drawIndexedIndirect($1078ca955870c324$var$getObject(arg1), arg2);
    };
    imports.wbg.__wbg_drawIndirect_8dd595dc622e21ac = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).drawIndirect($1078ca955870c324$var$getObject(arg1), arg2);
    };
    imports.wbg.__wbg_setIndexBuffer_1f4a86d1cc8c16d9 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).setIndexBuffer($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$takeObject(arg2), arg3);
    };
    imports.wbg.__wbg_setIndexBuffer_9f8493460611f96b = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).setIndexBuffer($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$takeObject(arg2), arg3, arg4);
    };
    imports.wbg.__wbg_setPipeline_18ce556bdea62cc5 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).setPipeline($1078ca955870c324$var$getObject(arg1));
    };
    imports.wbg.__wbg_setVertexBuffer_2a2c84d65c1063f9 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).setVertexBuffer(arg1 >>> 0, $1078ca955870c324$var$getObject(arg2), arg3);
    };
    imports.wbg.__wbg_setVertexBuffer_176c2dff823c42c1 = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).setVertexBuffer(arg1 >>> 0, $1078ca955870c324$var$getObject(arg2), arg3, arg4);
    };
    imports.wbg.__wbg_createView_3e46af1f54fdcd1f = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).createView($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_destroy_728f676d96e34538 = function(arg0) {
        $1078ca955870c324$var$getObject(arg0).destroy();
    };
    imports.wbg.__wbg_instanceof_GpuValidationError_af2aa2e306669317 = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof GPUValidationError;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_GpuAdapter_c0a5a310603ba618 = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof GPUAdapter;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_features_88901f43932fb28e = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).features;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_limits_a7f3fbf58768b61f = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).limits;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_requestDevice_068e794820eb88eb = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).requestDevice($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_instanceof_GpuOutOfMemoryError_45166ef4e2774fbe = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof GPUOutOfMemoryError;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_new_1eead62f64ca15ce = function() {
        return $1078ca955870c324$var$handleError(function() {
            const ret = new Headers();
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_append_fda9e3432e3e88da = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2, arg3, arg4) {
            $1078ca955870c324$var$getObject(arg0).append($1078ca955870c324$var$getStringFromWasm0(arg1, arg2), $1078ca955870c324$var$getStringFromWasm0(arg3, arg4));
        }, arguments);
    };
    imports.wbg.__wbg_getPreferredCanvasFormat_1f6c9ef810196b92 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).getPreferredCanvasFormat();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_requestAdapter_d8298d7a27a391f0 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).requestAdapter($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_size_6540ddb49e0d7120 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).size;
        return ret;
    };
    imports.wbg.__wbg_usage_f5b34f3e0170424b = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).usage;
        return ret;
    };
    imports.wbg.__wbg_destroy_9b5398e5b148e210 = function(arg0) {
        $1078ca955870c324$var$getObject(arg0).destroy();
    };
    imports.wbg.__wbg_getMappedRange_becef7e3d9dc5489 = function(arg0, arg1, arg2) {
        const ret = $1078ca955870c324$var$getObject(arg0).getMappedRange(arg1, arg2);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_mapAsync_91acdcf41b7ae21d = function(arg0, arg1, arg2, arg3) {
        const ret = $1078ca955870c324$var$getObject(arg0).mapAsync(arg1 >>> 0, arg2, arg3);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_unmap_1677c09514e08e64 = function(arg0) {
        $1078ca955870c324$var$getObject(arg0).unmap();
    };
    imports.wbg.__wbg_getBindGroupLayout_20dc45d52b96fa42 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).getBindGroupLayout(arg1 >>> 0);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithu8clampedarrayandsh_e2b3fce567acd708 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2, arg3) {
            const ret = new ImageData($1078ca955870c324$var$getClampedArrayU8FromWasm0(arg0, arg1), arg2 >>> 0, arg3 >>> 0);
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_dispatchWorkgroups_c484cd3530a3801d = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).dispatchWorkgroups(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0);
    };
    imports.wbg.__wbg_dispatchWorkgroupsIndirect_2b89ee1731fab5f8 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).dispatchWorkgroupsIndirect($1078ca955870c324$var$getObject(arg1), arg2);
    };
    imports.wbg.__wbg_end_dab719019df5969c = function(arg0) {
        $1078ca955870c324$var$getObject(arg0).end();
    };
    imports.wbg.__wbg_setPipeline_598117fdeb73cf8f = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).setPipeline($1078ca955870c324$var$getObject(arg1));
    };
    imports.wbg.__wbg_setBindGroup_dffce83253968cdd = function(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
        $1078ca955870c324$var$getObject(arg0).setBindGroup(arg1 >>> 0, $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getArrayU32FromWasm0(arg3, arg4), arg5, arg6 >>> 0);
    };
    imports.wbg.__wbg_error_f85e77a2651e41dc = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).error;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_get_c77649dd3862b63a = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0)[arg1 >>> 0];
        return $1078ca955870c324$var$isLikeNone(ret) ? 0 : $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithstrandinit_cad5cd6038c7ff5d = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2) {
            const ret = new Request($1078ca955870c324$var$getStringFromWasm0(arg0, arg1), $1078ca955870c324$var$getObject(arg2));
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_instanceof_Response_fc4327dbfcdf5ced = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof Response;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_url_8503de97f69da463 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg1).url;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(ret, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 1] = len1;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_status_ac85a3142a84caa2 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).status;
        return ret;
    };
    imports.wbg.__wbg_headers_b70de86b8e989bc0 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).headers;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_arrayBuffer_288fb3538806e85c = function() {
        return $1078ca955870c324$var$handleError(function(arg0) {
            const ret = $1078ca955870c324$var$getObject(arg0).arrayBuffer();
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_label_c7970304720cf8b0 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg1).label;
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(ret, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 1] = len1;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_beginComputePass_579a2563c561da68 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).beginComputePass($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_beginRenderPass_d04327f7231bd5af = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).beginRenderPass($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_clearBuffer_c370e7adb8398388 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).clearBuffer($1078ca955870c324$var$getObject(arg1), arg2);
    };
    imports.wbg.__wbg_clearBuffer_b8e6751290709d43 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).clearBuffer($1078ca955870c324$var$getObject(arg1), arg2, arg3);
    };
    imports.wbg.__wbg_copyBufferToBuffer_79ac12f409453cf0 = function(arg0, arg1, arg2, arg3, arg4, arg5) {
        $1078ca955870c324$var$getObject(arg0).copyBufferToBuffer($1078ca955870c324$var$getObject(arg1), arg2, $1078ca955870c324$var$getObject(arg3), arg4, arg5);
    };
    imports.wbg.__wbg_copyBufferToTexture_ac956e6d47c24e73 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).copyBufferToTexture($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getObject(arg3));
    };
    imports.wbg.__wbg_copyTextureToBuffer_787ec8d8c4c216f1 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).copyTextureToBuffer($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getObject(arg3));
    };
    imports.wbg.__wbg_copyTextureToTexture_a86e849469b0ef38 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).copyTextureToTexture($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getObject(arg3));
    };
    imports.wbg.__wbg_finish_5153789564a5eee5 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).finish();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_finish_d1049a13335e8326 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).finish($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_resolveQuerySet_8ac49c71e15cdf6a = function(arg0, arg1, arg2, arg3, arg4, arg5) {
        $1078ca955870c324$var$getObject(arg0).resolveQuerySet($1078ca955870c324$var$getObject(arg1), arg2 >>> 0, arg3 >>> 0, $1078ca955870c324$var$getObject(arg4), arg5 >>> 0);
    };
    imports.wbg.__wbg_writeTimestamp_107647519ce52436 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).writeTimestamp($1078ca955870c324$var$getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_copyExternalImageToTexture_819ec294d299f624 = function(arg0, arg1, arg2, arg3) {
        $1078ca955870c324$var$getObject(arg0).copyExternalImageToTexture($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getObject(arg3));
    };
    imports.wbg.__wbg_submit_3104e9b014f75846 = function(arg0, arg1) {
        $1078ca955870c324$var$getObject(arg0).submit($1078ca955870c324$var$getObject(arg1));
    };
    imports.wbg.__wbg_writeBuffer_becf0c8f0323ffd7 = function(arg0, arg1, arg2, arg3, arg4, arg5) {
        $1078ca955870c324$var$getObject(arg0).writeBuffer($1078ca955870c324$var$getObject(arg1), arg2, $1078ca955870c324$var$getObject(arg3), arg4, arg5);
    };
    imports.wbg.__wbg_writeTexture_465ecc6146e5052c = function(arg0, arg1, arg2, arg3, arg4) {
        $1078ca955870c324$var$getObject(arg0).writeTexture($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getObject(arg3), $1078ca955870c324$var$getObject(arg4));
    };
    imports.wbg.__wbg_get_44be0491f933a435 = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0)[arg1 >>> 0];
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_length_fff51ee6522a1a18 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_new_898a68150f225f2e = function() {
        const ret = new Array();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_newnoargs_581967eacc0e2604 = function(arg0, arg1) {
        const ret = new Function($1078ca955870c324$var$getStringFromWasm0(arg0, arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_next_526fc47e980da008 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).next;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_next_ddb3312ca1c4e32a = function() {
        return $1078ca955870c324$var$handleError(function(arg0) {
            const ret = $1078ca955870c324$var$getObject(arg0).next();
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_done_5c1f01fb660d73b5 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).done;
        return ret;
    };
    imports.wbg.__wbg_value_1695675138684bd5 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).value;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_iterator_97f0c81209c6c35a = function() {
        const ret = Symbol.iterator;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_get_97b561fb56f034b5 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1) {
            const ret = Reflect.get($1078ca955870c324$var$getObject(arg0), $1078ca955870c324$var$getObject(arg1));
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_call_cb65541d95d71282 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1) {
            const ret = $1078ca955870c324$var$getObject(arg0).call($1078ca955870c324$var$getObject(arg1));
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_new_b51585de1b234aff = function() {
        const ret = new Object();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_self_1ff1d729e9aae938 = function() {
        return $1078ca955870c324$var$handleError(function() {
            const ret = self.self;
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_window_5f4faef6c12b79ec = function() {
        return $1078ca955870c324$var$handleError(function() {
            const ret = window.window;
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_globalThis_1d39714405582d3c = function() {
        return $1078ca955870c324$var$handleError(function() {
            const ret = globalThis.globalThis;
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_global_651f05c6a0944d1c = function() {
        return $1078ca955870c324$var$handleError(function() {
            const ret = $parcel$global.global;
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_set_502d29070ea18557 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0)[arg1 >>> 0] = $1078ca955870c324$var$takeObject(arg2);
    };
    imports.wbg.__wbg_isArray_4c24b343cb13cfb1 = function(arg0) {
        const ret = Array.isArray($1078ca955870c324$var$getObject(arg0));
        return ret;
    };
    imports.wbg.__wbg_push_ca1c26067ef907ac = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).push($1078ca955870c324$var$getObject(arg1));
        return ret;
    };
    imports.wbg.__wbg_instanceof_ArrayBuffer_39ac22089b74fddb = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof ArrayBuffer;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_call_4c92f6aec1e1d6e6 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2, arg3) {
            const ret = $1078ca955870c324$var$getObject(arg0).call($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2), $1078ca955870c324$var$getObject(arg3));
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_isSafeInteger_bb8e18dd21c97288 = function(arg0) {
        const ret = Number.isSafeInteger($1078ca955870c324$var$getObject(arg0));
        return ret;
    };
    imports.wbg.__wbg_instanceof_Object_3daa8298c86298be = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof Object;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_entries_e51f29c7bba0c054 = function(arg0) {
        const ret = Object.entries($1078ca955870c324$var$getObject(arg0));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_valueOf_cefb0eb7807e83fb = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).valueOf();
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_resolve_53698b95aaf7fcf8 = function(arg0) {
        const ret = Promise.resolve($1078ca955870c324$var$getObject(arg0));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_then_f7e06ee3c11698eb = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$getObject(arg0).then($1078ca955870c324$var$getObject(arg1));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_then_b2267541e2a73865 = function(arg0, arg1, arg2) {
        const ret = $1078ca955870c324$var$getObject(arg0).then($1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_buffer_085ec1f694018c4f = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).buffer;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithbyteoffsetandlength_6da8e527659b86aa = function(arg0, arg1, arg2) {
        const ret = new Uint8Array($1078ca955870c324$var$getObject(arg0), arg1 >>> 0, arg2 >>> 0);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_new_8125e318e6245eed = function(arg0) {
        const ret = new Uint8Array($1078ca955870c324$var$getObject(arg0));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_set_5cf90238115182c3 = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).set($1078ca955870c324$var$getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_length_72e2208bbc0efc61 = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_newwithbyteoffsetandlength_b8047c68e84e60be = function(arg0, arg1, arg2) {
        const ret = new Float64Array($1078ca955870c324$var$getObject(arg0), arg1 >>> 0, arg2 >>> 0);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_new_c13cb67c90ba8a3b = function(arg0) {
        const ret = new Float64Array($1078ca955870c324$var$getObject(arg0));
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_set_b20a627e8989efba = function(arg0, arg1, arg2) {
        $1078ca955870c324$var$getObject(arg0).set($1078ca955870c324$var$getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_length_03bae01bc9263bac = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Uint8Array_d8d9cb2b8e8ac1d4 = function(arg0) {
        let result;
        try {
            result = $1078ca955870c324$var$getObject(arg0) instanceof Uint8Array;
        } catch  {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_buffer_f5b7059c439f330d = function(arg0) {
        const ret = $1078ca955870c324$var$getObject(arg0).buffer;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithlength_d198efa3b8e5d4ab = function(arg0) {
        const ret = new Float64Array(arg0 >>> 0);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbg_stringify_e25465938f3f611f = function() {
        return $1078ca955870c324$var$handleError(function(arg0) {
            const ret = JSON.stringify($1078ca955870c324$var$getObject(arg0));
            return $1078ca955870c324$var$addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_deleteProperty_568c26e52bc57565 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1) {
            const ret = Reflect.deleteProperty($1078ca955870c324$var$getObject(arg0), $1078ca955870c324$var$getObject(arg1));
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_has_c5fcd020291e56b8 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1) {
            const ret = Reflect.has($1078ca955870c324$var$getObject(arg0), $1078ca955870c324$var$getObject(arg1));
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_set_092e06b0f9d71865 = function() {
        return $1078ca955870c324$var$handleError(function(arg0, arg1, arg2) {
            const ret = Reflect.set($1078ca955870c324$var$getObject(arg0), $1078ca955870c324$var$getObject(arg1), $1078ca955870c324$var$getObject(arg2));
            return ret;
        }, arguments);
    };
    imports.wbg.__wbindgen_bigint_get_as_i64 = function(arg0, arg1) {
        const v = $1078ca955870c324$var$getObject(arg1);
        const ret = typeof v === "bigint" ? v : undefined;
        $1078ca955870c324$var$getBigInt64Memory0()[arg0 / 8 + 1] = $1078ca955870c324$var$isLikeNone(ret) ? BigInt(0) : ret;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 0] = !$1078ca955870c324$var$isLikeNone(ret);
    };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        const ret = $1078ca955870c324$var$debugString($1078ca955870c324$var$getObject(arg1));
        const ptr1 = $1078ca955870c324$var$passStringToWasm0(ret, $1078ca955870c324$var$wasm.__wbindgen_malloc, $1078ca955870c324$var$wasm.__wbindgen_realloc);
        const len1 = $1078ca955870c324$var$WASM_VECTOR_LEN;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 1] = len1;
        $1078ca955870c324$var$getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error($1078ca955870c324$var$getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_memory = function() {
        const ret = $1078ca955870c324$var$wasm.memory;
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper607 = function(arg0, arg1, arg2) {
        const ret = $1078ca955870c324$var$makeMutClosure(arg0, arg1, 45, $1078ca955870c324$var$__wbg_adapter_48);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper8973 = function(arg0, arg1, arg2) {
        const ret = $1078ca955870c324$var$makeMutClosure(arg0, arg1, 4509, $1078ca955870c324$var$__wbg_adapter_51);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper8975 = function(arg0, arg1, arg2) {
        const ret = $1078ca955870c324$var$makeMutClosure(arg0, arg1, 4509, $1078ca955870c324$var$__wbg_adapter_51);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper9041 = function(arg0, arg1, arg2) {
        const ret = $1078ca955870c324$var$makeMutClosure(arg0, arg1, 4528, $1078ca955870c324$var$__wbg_adapter_56);
        return $1078ca955870c324$var$addHeapObject(ret);
    };
    imports["./snippets/graphite-editor-22867c2a72952586/../frontend/src/wasm-communication/editor.ts"] = $d23ab19b459a5cef$exports;
    return imports;
}
function $1078ca955870c324$var$__wbg_init_memory(imports, maybe_memory) {}
function $1078ca955870c324$var$__wbg_finalize_init(instance, module) {
    $1078ca955870c324$var$wasm = instance.exports;
    $1078ca955870c324$var$__wbg_init.__wbindgen_wasm_module = module;
    $1078ca955870c324$var$cachedBigInt64Memory0 = null;
    $1078ca955870c324$var$cachedBigUint64Memory0 = null;
    $1078ca955870c324$var$cachedFloat64Memory0 = null;
    $1078ca955870c324$var$cachedInt32Memory0 = null;
    $1078ca955870c324$var$cachedUint32Memory0 = null;
    $1078ca955870c324$var$cachedUint8Memory0 = null;
    $1078ca955870c324$var$cachedUint8ClampedMemory0 = null;
    $1078ca955870c324$var$wasm.__wbindgen_start();
    return $1078ca955870c324$var$wasm;
}
function $1078ca955870c324$export$2ec80ee76a9348bf(module) {
    if ($1078ca955870c324$var$wasm !== undefined) return $1078ca955870c324$var$wasm;
    const imports = $1078ca955870c324$var$__wbg_get_imports();
    $1078ca955870c324$var$__wbg_init_memory(imports);
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $1078ca955870c324$var$__wbg_finalize_init(instance, module);
}
var $cced66dbe3f9aa57$exports = {};

$cced66dbe3f9aa57$exports = new URL((parcelRequire("ji6vK")).resolve("c2yYl"), import.meta.url).toString();


async function $1078ca955870c324$var$__wbg_init(input) {
    if ($1078ca955870c324$var$wasm !== undefined) return $1078ca955870c324$var$wasm;
    if (typeof input === "undefined") input = new URL($cced66dbe3f9aa57$exports);
    const imports = $1078ca955870c324$var$__wbg_get_imports();
    if (typeof input === "string" || typeof Request === "function" && input instanceof Request || typeof URL === "function" && input instanceof URL) input = fetch(input);
    $1078ca955870c324$var$__wbg_init_memory(imports);
    const { instance: instance, module: module } = await $1078ca955870c324$var$__wbg_load(await input, imports);
    return $1078ca955870c324$var$__wbg_finalize_init(instance, module);
}
var $1078ca955870c324$export$2e2bcd8739ae039 = $1078ca955870c324$var$__wbg_init;



// `wasmImport` starts uninitialized because its initialization needs to occur asynchronously, and thus needs to occur by manually calling and awaiting `initWasm()`
let $2b6974fc18d331b1$var$wasmImport;
async function $2b6974fc18d331b1$export$d2445f1399d5a873(path, nodeId, mime, imageData, transform, documentId) {
    const blob = new Blob([
        imageData
    ], {
        type: mime
    });
    const blobURL = URL.createObjectURL(blob);
    // Pre-decode the image so it is ready to be drawn instantly once it's placed into the viewport SVG
    const image = new Image();
    image.src = blobURL;
    await image.decode();
    window["editorInstance"]?.setImageBlobURL(documentId, path, nodeId, blobURL, image.naturalWidth, image.naturalHeight, transform);
}
async function $2b6974fc18d331b1$export$260f1342281499a4(path, nodeId, mime, documentId, url) {
    const data = await fetch(url);
    const blob = await data.blob();
    const blobURL = URL.createObjectURL(blob);
    // Pre-decode the image so it is ready to be drawn instantly once it's placed into the viewport SVG
    const image = new Image();
    image.src = blobURL;
    await image.decode();
    window["editorInstance"]?.setImageBlobURL(documentId, path, nodeId, blobURL, image.naturalWidth, image.naturalHeight, undefined);
}

const $2b6974fc18d331b1$var$tauri = "__TAURI_METADATA__" in window && (parcelRequire("kw0CW"));
async function $2b6974fc18d331b1$export$be6de309127183b5(message) {
    if (!$2b6974fc18d331b1$var$tauri) return;
    try {
        const response = await (await $2b6974fc18d331b1$var$tauri).invoke("handle_message", {
            message: message
        });
        window["editorInstance"]?.tauriResponse(response);
    } catch  {
        // eslint-disable-next-line no-console
        console.error("Failed to dispatch Tauri message");
    }
}
async function $2b6974fc18d331b1$export$3b24329f2e9107b6() {
    // Skip if the WASM module is already initialized
    if ($2b6974fc18d331b1$var$wasmImport !== undefined) return;
    // Import the WASM module JS bindings and wrap them in the panic proxy
    // eslint-disable-next-line import/no-cycle
    await (0, $1078ca955870c324$export$2e2bcd8739ae039)();
    $2b6974fc18d331b1$var$wasmImport = await (0, $1078ca955870c324$export$6aca68b176279447)();
    window["imageCanvases"] = {};
    // Provide a random starter seed which must occur after initializing the WASM module, since WASM can't generate its own random numbers
    const randomSeedFloat = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    const randomSeed = BigInt(randomSeedFloat);
    (0, $1078ca955870c324$export$74d4fed657706d5a)(randomSeed);
    if (!$2b6974fc18d331b1$var$tauri) return;
    await (await $2b6974fc18d331b1$var$tauri).invoke("set_random_seed", {
        seed: randomSeedFloat
    });
}
function $2b6974fc18d331b1$export$eb02d1ee0d3cac30() {
    // Raw: Object containing several callable functions from `editor_api.rs` defined directly on the WASM module, not the editor instance (generated by wasm-bindgen)
    if (!$2b6974fc18d331b1$var$wasmImport) throw new Error("Editor WASM backend was not initialized at application startup");
    const raw = $2b6974fc18d331b1$var$wasmImport;
    // Instance: Object containing many functions from `editor_api.rs` that are part of the editor instance (generated by wasm-bindgen)
    const instance = new (0, $1078ca955870c324$export$7fc39e9d04ca6232)((messageType, messageData)=>{
        // This callback is called by WASM when a FrontendMessage is received from the WASM wrapper editor instance
        // We pass along the first two arguments then add our own `raw` and `instance` context for the last two arguments
        subscriptions.handleJsMessage(messageType, messageData, raw, instance);
    });
    window["editorInstance"] = instance;
    // Subscriptions: Allows subscribing to messages in JS that are sent from the WASM backend
    const subscriptions = (0, $942f35ac0a63ea85$export$6d9e7d27694a253a)();
    // Check if the URL hash fragment has any demo artwork to be loaded
    (async ()=>{
        const demoArtwork = window.location.hash.trim().match(/#demo\/(.*)/)?.[1];
        if (!demoArtwork) return;
        try {
            const url = new URL(`https://raw.githubusercontent.com/GraphiteEditor/Graphite/master/demo-artwork/${demoArtwork}.graphite`);
            const data = await fetch(url);
            const filename = url.pathname.split("/").pop() || "Untitled";
            const content = await data.text();
            instance.openDocumentFile(filename, content);
            // Remove the hash fragment from the URL
            history.replaceState("", "", `${window.location.pathname}${window.location.search}`);
        } catch  {}
    })();
    return {
        raw: raw,
        instance: instance,
        subscriptions: subscriptions
    };
}
function $2b6974fc18d331b1$export$6efc75f6eb6c74f9() {
    window["editorInstance"]?.injectImaginatePollServerStatus();
}


/* src/components/Editor.svelte generated by Svelte v3.58.0 */ 

function $7ed52b8c7c886783$export$61e3782b541bd28e() {
    const agent = window.navigator.userAgent;
    let match = agent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(match[1])) {
        const browser = /\brv[ :]+(\d+)/g.exec(agent) || [];
        return `IE ${browser[1] || ""}`.trim();
    }
    if (match[1] === "Chrome") {
        let browser = agent.match(/\bEdg\/(\d+)/) || undefined;
        if (browser !== undefined) return `Edge (Chromium) ${browser[1]}`;
        browser = agent.match(/\bOPR\/(\d+)/) || undefined;
        if (browser !== undefined) return `Opera ${browser[1]}`;
    }
    match = match[2] ? [
        match[1],
        match[2]
    ] : [
        navigator.appName,
        navigator.appVersion,
        "-?"
    ];
    const browser = agent.match(/version\/(\d+)/i) || undefined;
    if (browser !== undefined) match.splice(1, 1, browser[1]);
    return `${match[0]} ${match[1]}`;
}
function $7ed52b8c7c886783$export$2dc6e2a3a552baa5(detailed = false) {
    const osTableDetailed = {
        "Windows NT 10": "Windows 10 or 11",
        "Windows NT 6.3": "Windows 8.1",
        "Windows NT 6.2": "Windows 8",
        "Windows NT 6.1": "Windows 7",
        "Windows NT 6.0": "Windows Vista",
        "Windows NT 5.1": "Windows XP",
        "Windows NT 5.0": "Windows 2000",
        Mac: "Mac",
        X11: "Unix",
        Linux: "Linux",
        Unknown: "Unknown"
    };
    const osTableSimple = {
        Windows: "Windows",
        Mac: "Mac",
        Linux: "Linux",
        Unknown: "Unknown"
    };
    const osTable = detailed ? osTableDetailed : osTableSimple;
    const userAgentOS = Object.keys(osTable).find((key)=>window.navigator.userAgent.includes(key));
    return osTable[userAgentOS || "Unknown"];
}
function $7ed52b8c7c886783$export$f205d53822e9a9a9() {
    return $7ed52b8c7c886783$export$2dc6e2a3a552baa5() === "Mac";
}
function $7ed52b8c7c886783$export$83c7bfedfc35d3c2(eventName) {
    const onEventName = `on${eventName}`;
    let tag = "div";
    if ([
        "select",
        "change"
    ].includes(eventName)) tag = "select";
    if ([
        "submit",
        "reset"
    ].includes(eventName)) tag = "form";
    if ([
        "error",
        "load",
        "abort"
    ].includes(eventName)) tag = "img";
    const element = document.createElement(tag);
    if (onEventName in element) return true;
    // Check if "return;" gets converted into a function, meaning the event is supported
    element.setAttribute(eventName, "return;");
    return typeof element[onEventName] === "function";
}



function $161093e588a77f28$export$7d467599c561703c(filename, url) {
    const element = document.createElement("a");
    element.href = url;
    element.setAttribute("download", filename);
    element.click();
}
function $161093e588a77f28$export$439bad7921a8b6c8(filename, blob) {
    const url = URL.createObjectURL(blob);
    $161093e588a77f28$export$7d467599c561703c(filename, url);
    URL.revokeObjectURL(url);
}
function $161093e588a77f28$export$46bb9181f1d89c32(filename, text) {
    const type = filename.endsWith(".svg") ? "image/svg+xml;charset=utf-8" : "text/plain;charset=utf-8";
    const blob = new Blob([
        text
    ], {
        type: type
    });
    $161093e588a77f28$export$439bad7921a8b6c8(filename, blob);
}
async function $161093e588a77f28$export$a3c8e1472dc2ed84(acceptedExtensions, textOrData) {
    return new Promise((resolve, _)=>{
        const element = document.createElement("input");
        element.type = "file";
        element.accept = acceptedExtensions;
        element.addEventListener("change", async ()=>{
            if (element.files?.length) {
                const file = element.files[0];
                const filename = file.name;
                const type = file.type;
                const content = textOrData === "text" ? await file.text() : new Uint8Array(await file.arrayBuffer());
                resolve({
                    filename: filename,
                    type: type,
                    content: content
                });
            }
        }, {
            capture: false,
            once: true
        });
        element.click();
    // Once `element` goes out of scope, it has no references so it gets garbage collected along with its event listener, so `removeEventListener` is not needed
    });
}
function $161093e588a77f28$export$47a328b4cabd57cc(blob) {
    return new Promise((resolve)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(typeof reader.result === "string" ? reader.result : "");
        reader.readAsDataURL(blob);
    });
}
async function $161093e588a77f28$export$8fe022561f7fb77d(svg) {
    const splitByBlobs = svg.split(/("blob:.*?")/);
    const onlyBlobs = splitByBlobs.filter((_, i)=>i % 2 === 1);
    const onlyBlobsConverted = onlyBlobs.map(async (blobURL)=>{
        const urlWithoutQuotes = blobURL.slice(1, -1);
        const data = await fetch(urlWithoutQuotes);
        const dataBlob = await data.blob();
        return $161093e588a77f28$export$47a328b4cabd57cc(dataBlob);
    });
    const base64Images = await Promise.all(onlyBlobsConverted);
    const substituted = splitByBlobs.map((segment, i)=>{
        if (i % 2 === 0) return segment;
        const blobsIndex = Math.floor(i / 2);
        return `"${base64Images[blobsIndex]}"`;
    });
    return substituted.join("");
}


async function $a169f2d3602aed86$export$c3955ecdb816704b(svg, width, height, backgroundColor) {
    // A canvas to render our SVG to in order to get a raster image
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    if (!context) throw new Error("Can't create 2D context from canvas during SVG rasterization");
    // Apply a background fill color if one is given
    if (backgroundColor) {
        context.fillStyle = backgroundColor;
        context.fillRect(0, 0, width, height);
    }
    // This SVG rasterization scheme has the limitation that it cannot access blob URLs, so they must be inlined to base64 URLs
    const svgWithBase64Images = await (0, $161093e588a77f28$export$8fe022561f7fb77d)(svg);
    // Create a blob URL for our SVG
    const svgBlob = new Blob([
        svgWithBase64Images
    ], {
        type: "image/svg+xml;charset=utf-8"
    });
    const url = URL.createObjectURL(svgBlob);
    // Load the Image from the URL and wait until it's done
    const image = new Image();
    image.src = url;
    await new Promise((resolve)=>{
        image.onload = ()=>resolve();
    });
    // Draw our SVG to the canvas
    context?.drawImage(image, 0, 0, width, height);
    // Clean up the SVG blob URL (once the URL is revoked, the SVG blob data itself is garbage collected after `svgBlob` goes out of scope)
    URL.revokeObjectURL(url);
    return canvas;
}
async function $a169f2d3602aed86$export$429b8f6aca987a21(svg, width, height, mime, backgroundColor) {
    if (!width || !height) throw new Error("Width and height must be nonzero when given to rasterizeSVG()");
    const canvas = await $a169f2d3602aed86$export$c3955ecdb816704b(svg, width, height, backgroundColor);
    // Convert the canvas to an image of the correct MIME type
    const blob = await new Promise((resolve)=>{
        canvas.toBlob((blob)=>{
            resolve(blob || undefined);
        }, mime);
    });
    if (!blob) throw new Error("Converting canvas to blob data failed in rasterizeSVG()");
    return blob;
}
async function $a169f2d3602aed86$export$6bd5bcc5a8099e6(imageData) {
    const canvasContext = await $a169f2d3602aed86$export$7cc4dec774eaffa(imageData);
    const width = canvasContext.canvas.width;
    const height = canvasContext.canvas.height;
    return canvasContext.getImageData(0, 0, width, height);
}
async function $a169f2d3602aed86$export$32a51639b9f2083f(imageData) {
    const canvasContext = await $a169f2d3602aed86$export$7cc4dec774eaffa(imageData);
    return new Promise((resolve, reject)=>{
        canvasContext.canvas.toBlob((pngBlob)=>{
            if (pngBlob) resolve(pngBlob);
            else reject("Converting canvas to blob data failed in imageToPNG()");
        }, "image/png");
    });
}
async function $a169f2d3602aed86$export$7cc4dec774eaffa(imageData) {
    // Special handling to rasterize an SVG file
    let svgImageData;
    if (imageData instanceof File && imageData.type === "image/svg+xml") {
        const svgSource = await imageData.text();
        const svgElement = new DOMParser().parseFromString(svgSource, "image/svg+xml").querySelector("svg");
        if (!svgElement) throw new Error("Error reading SVG file");
        let bounds = svgElement.viewBox.baseVal;
        // If the bounds are zero (which will happen if the `viewBox` is not provided), set bounds to the artwork's bounding box
        if (bounds.width === 0 || bounds.height === 0) {
            // It's necessary to measure while the element is in the DOM, otherwise the dimensions are zero
            const toRemove = document.body.insertAdjacentElement("beforeend", svgElement);
            bounds = svgElement.getBBox();
            toRemove?.remove();
        }
        svgImageData = await $a169f2d3602aed86$export$c3955ecdb816704b(svgSource, bounds.width, bounds.height);
    }
    // Decode the image file binary data
    const image = await createImageBitmap(svgImageData || imageData);
    let { width: width, height: height } = image;
    width = Math.floor(width);
    height = Math.floor(height);
    // Render image to canvas
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Could not create canvas context");
    context.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
    return context;
}


function $5878622efbf463d1$export$a99063a3de5d2240(editor) {
    // Subscribe to process backend event
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$7cba8a2f1a0b6724), (triggerTextCopy)=>{
        // If the Clipboard API is supported in the browser, copy text to the clipboard
        navigator.clipboard?.writeText?.(triggerTextCopy.copyText);
    });
}
async function $5878622efbf463d1$export$8356caa654c4fd79(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    // TODO: Remove this if/when we end up returning PNG directly from the backend
    const pngBlob = await (0, $a169f2d3602aed86$export$32a51639b9f2083f)(blob);
    const clipboardItem = {};
    clipboardItem[pngBlob.type] = pngBlob;
    const data = [
        new ClipboardItem(clipboardItem)
    ];
    // Note: if this image has transparency, it will be lost and appear as black due to limitations of the way browsers handle copying transparent images
    // This even happens if you just open a regular transparent PNG file in a browser tab, right click > copy, and paste it somewhere (the transparency will show up as black)
    // This is true, at least, on Windows (it's worth checking on other OSs though)
    navigator.clipboard.write(data);
}


let $b6b56b6b4021e3fb$var$draggingElement;
function $b6b56b6b4021e3fb$export$7905c3a9e557239e() {
    const clearDraggingElement = ()=>{
        $b6b56b6b4021e3fb$var$draggingElement = undefined;
    };
    // Add the event listener
    document.addEventListener("drop", clearDraggingElement);
    // Return the destructor
    return ()=>{
        // We use setTimeout to sequence this drop after any potential users in the current call stack progression, since this will begin in an entirely new call stack later
        setTimeout(()=>{
            document.removeEventListener("drop", clearDraggingElement);
        }, 0);
    };
}
function $b6b56b6b4021e3fb$export$915caa8a10b5a3da(element) {
    $b6b56b6b4021e3fb$var$draggingElement = element;
}
function $b6b56b6b4021e3fb$export$aa4e4c5c63297384() {
    return $b6b56b6b4021e3fb$var$draggingElement;
}



function $dbf29c43aa374ccc$export$61ac97ad36b72342(editor) {
    // Subscribe to process backend event
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$bf0452fe411c5aac), async (triggerOpenLink)=>{
        window.open(triggerOpenLink.url, "_blank");
    });
}



const $6c2f3afb15ad1449$var$subscriber_queue = [];
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier}start start and stop notifications for subscriptions
 */ function $6c2f3afb15ad1449$export$1e3fc3ecfda8b1c3(value, start) {
    return {
        subscribe: $6c2f3afb15ad1449$export$e6d3eada50a007b1(value, start).subscribe
    };
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */ function $6c2f3afb15ad1449$export$e6d3eada50a007b1(value, start = (0, $1eb80e36873dc327$export$8793edee2d425525)) {
    let stop;
    const subscribers = new Set();
    function set(new_value) {
        if ((0, $1eb80e36873dc327$export$170eaf694b129a16)(value, new_value)) {
            value = new_value;
            if (stop) {
                const run_queue = !$6c2f3afb15ad1449$var$subscriber_queue.length;
                for (const subscriber of subscribers){
                    subscriber[1]();
                    $6c2f3afb15ad1449$var$subscriber_queue.push(subscriber, value);
                }
                if (run_queue) {
                    for(let i = 0; i < $6c2f3afb15ad1449$var$subscriber_queue.length; i += 2)$6c2f3afb15ad1449$var$subscriber_queue[i][0]($6c2f3afb15ad1449$var$subscriber_queue[i + 1]);
                    $6c2f3afb15ad1449$var$subscriber_queue.length = 0;
                }
            }
        }
    }
    function update(fn) {
        set(fn(value));
    }
    function subscribe(run, invalidate = (0, $1eb80e36873dc327$export$8793edee2d425525)) {
        const subscriber = [
            run,
            invalidate
        ];
        subscribers.add(subscriber);
        if (subscribers.size === 1) stop = start(set) || (0, $1eb80e36873dc327$export$8793edee2d425525);
        run(value);
        return ()=>{
            subscribers.delete(subscriber);
            if (subscribers.size === 0 && stop) {
                stop();
                stop = null;
            }
        };
    }
    return {
        set: set,
        update: update,
        subscribe: subscribe
    };
}
function $6c2f3afb15ad1449$export$90b0b54dab0a340a(stores, fn, initial_value) {
    const single = !Array.isArray(stores);
    const stores_array = single ? [
        stores
    ] : stores;
    const auto = fn.length < 2;
    return $6c2f3afb15ad1449$export$1e3fc3ecfda8b1c3(initial_value, (set)=>{
        let started = false;
        const values = [];
        let pending = 0;
        let cleanup = (0, $1eb80e36873dc327$export$8793edee2d425525);
        const sync = ()=>{
            if (pending) return;
            cleanup();
            const result = fn(single ? values[0] : values, set);
            if (auto) set(result);
            else cleanup = (0, $1eb80e36873dc327$export$b451353ebd749597)(result) ? result : (0, $1eb80e36873dc327$export$8793edee2d425525);
        };
        const unsubscribers = stores_array.map((store, i)=>(0, $1eb80e36873dc327$export$ec068583843480e7)(store, (value)=>{
                values[i] = value;
                pending &= ~(1 << i);
                if (started) sync();
            }, ()=>{
                pending |= 1 << i;
            }));
        started = true;
        sync();
        return function stop() {
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(unsubscribers);
            cleanup();
            // We need to set this to false because callbacks can still happen despite having unsubscribed:
            // Callbacks might already be placed in the queue which doesn't know it should no longer
            // invoke this derived store.
            started = false;
        };
    });
}
/**
 * Takes a store and returns a new one derived from the old one that is readable.
 *
 * @param store - store to make readonly
 */ function $6c2f3afb15ad1449$export$6ec456bd5b7b3c51(store) {
    return {
        subscribe: store.subscribe.bind(store)
    };
}


function $f03b4dcefd1c1439$export$ec5c813343f1cfd4(e) {
    return(// Shift (all platforms)
    Number(e.shiftKey) << 0 | // Alt (all platforms, also called Option on Mac)
    Number(e.altKey) << 1 | // Control (all platforms)
    Number(e.ctrlKey) << 2 | // Meta (Windows/Linux) or Command (Mac)
    Number(e.metaKey) << 3);
}
function $f03b4dcefd1c1439$export$6efdc3ca96c7aae5(text) {
    if (text[text.length - 1] === "\n") return text.slice(0, -1);
    return text;
}
async function $f03b4dcefd1c1439$export$a614615e232c88d5(e) {
    const keyText = e.key;
    const scanCode = e.code;
    // Use the key code directly if it isn't one that changes per locale (i.e. isn't a writing system key or one of the other few exceptions)
    const scanCodeNotLocaleSpecific = !$f03b4dcefd1c1439$var$LOCALE_SPECIFIC_KEY_CODES.includes(scanCode);
    if (scanCodeNotLocaleSpecific) return scanCode;
    // Use the key directly if it's one of the exceptions that usually don't change, but sometimes do in a predictable way
    if ($f03b4dcefd1c1439$var$SCAN_CODES_FOR_NON_WRITING_KEYS_THAT_VARY_PER_LOCALE.includes(scanCode)) {
        // Numpad comma and period which swap in some locales as decimal and thousands separator symbols
        if ($f03b4dcefd1c1439$var$NUMPAD_DECIMAL_AND_THOUSANDS_SEPARATORS.includes(scanCode)) switch(scanCode){
            case ".":
                return "NumpadDecimal";
            case ",":
                return "NumpadComma";
            default:
                return scanCode;
        }
        // The AltRight key changes from a key value of "Alt" to "AltGraph" on keyboards with an AltGraph key
        if (scanCode === "AltRight") return keyText === "Alt" ? "AltRight" : "AltGraph";
    }
    // Use good-enough-for-now heuristics on the writing system keys, which are commonly subject to change by locale
    // Number scan codes
    if (/^Digit[0-9]$/.test(scanCode)) // For now it's good enough to treat every digit key, regardless of locale, as just its digit from the standard US layout.
    // Even on a keyboard like the French AZERTY layout, where numbers are shifted, users still refer to those keys by their numbers.
    // This unfortunately means that any special symbols under these keys are overridden by their number, making it impossible to access some shortcuts that rely on those special symbols.
    // We'll have to deal with that for now, and find a way to upgrade or properly replace this system, or assign alternate keymaps based on locale, when people complain.
    return scanCode;
    // Letter scan codes
    if (/^Key([A-Z])$/.test(scanCode)) {
        // Get the uppercase letter, with any accents or discritics removed if possible
        const rawLetter = keyText.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase();
        // If the key letter is in the A-Z range, use the key code for that letter
        if (/^[A-Z]$/.test(rawLetter)) return `Key${rawLetter}`;
        // If the key text isn't one of the named attribute values, that means it must be the literal unicode value which we use directly
        // It is likely a weird symbol that isn't in the A-Z range even with accents removed.
        // It might be a symbol from an Option key combination on a Mac. Or it might be from a non-Latin alphabet like Cyrillic.
        if (!$f03b4dcefd1c1439$var$KEY_ATTRIBUTE_VALUES.has(keyText)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (navigator && "keyboard" in navigator && "getLayoutMap" in navigator.keyboard) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const layout = await navigator.keyboard.getLayoutMap();
                // Get all the keyboard mappings and transform the key symbols to uppercase
                const keyboardLayoutMap = [
                    ...layout.entries()
                ].map(([keyCode, keySymbol])=>[
                        keyCode,
                        keySymbol.toUpperCase()
                    ]);
                // If we match the uppercase version of the pressed key character, use the scan code that produces it
                const matchedEntry = keyboardLayoutMap.find(([_, keySymbol])=>keySymbol === keyText.toUpperCase());
                if (matchedEntry) return matchedEntry[0];
            }
            // If the keyboard layout API is unavailable, or it didn't match anything, just return the scan code that the user typed
            // This isn't perfect because alternate keyboard layouts may end up having the US QWERTY key,
            // but it's all we can do without a giant database of keyboard layouts and Mac Option key combinations
            return scanCode;
        }
        // If the key's named attribute value shares a name with a scan code, use that scan code
        if ($f03b4dcefd1c1439$var$KEY_CODE_NAMES.includes(keyText)) return $f03b4dcefd1c1439$var$scanCodeFromKeyText(keyText);
        if ($f03b4dcefd1c1439$var$KEY_ATTRIBUTE_VALUES_INVOLVING_HANDEDNESS.includes(keyText)) // Since for some reason we're in a situation where we are using the key instead of the scan code to
        // match one of the modifier keys which have both a Left and Right variant as part of the scan code names,
        // but no handedness as part of the key's named attribute values, we default to the left side as it's more common.
        return `${keyText}Left`;
        // All reasonable attempts to figure out what this key is has now failed, so we fall back on the US QWERTY layout scan code
        return scanCode;
    }
    // If the key text is the unicode character for one of the standard symbols on the US keyboard, use the symbol even though it's not located on the same scan code as on a US keyboard
    if ($f03b4dcefd1c1439$var$WRITING_SYSTEM_SPECIAL_CHARS.includes(keyText)) return $f03b4dcefd1c1439$var$scanCodeFromKeyText(keyText);
    // If the key is otherwise totally unrecognized, we ignore it
    if (keyText === "Unidentified" || scanCode === "Unidentified") return "Unidentified";
    // As a last resort, we just use the scan code
    return scanCode;
}
function $f03b4dcefd1c1439$var$scanCodeFromKeyText(keyText) {
    // There are many possible unicode symbols as well as named attribute values, but we only care about finding the equivalent scan code (based on the US keyboard) without regard for modifiers
    // Match any handed modifier keys by claiming it's the left-handed modifier
    if ($f03b4dcefd1c1439$var$KEY_ATTRIBUTE_VALUES_INVOLVING_HANDEDNESS.includes(keyText)) return `${keyText}Left`;
    // Match any named attribute keys to an identical key name
    const identicalName = $f03b4dcefd1c1439$var$KEY_CODE_NAMES.find((code)=>code === keyText);
    if (identicalName) return keyText;
    // Match the space character
    // Order matters because the next step assumes it can safely ignore the space character
    if (keyText === " ") return "Space";
    // Match individual characters by the scan code which produces that symbol on a US keyboard, either shifted or not
    // This also includes the `Digit*` and `Key*` codes
    const matchedScanCode = $f03b4dcefd1c1439$var$KEY_CODES.find((info)=>info.keys?.us?.includes(keyText));
    if (matchedScanCode) return matchedScanCode.code;
    return "Unidentified";
}
const $f03b4dcefd1c1439$var$KEY_CODES = [
    // Writing system keys
    // Codes produce different printed characters depending on locale
    // https://www.w3.org/TR/uievents-code/#key-alphanumeric-writing-system
    {
        code: "Digit0",
        category: "writing-system",
        keys: {
            us: "0 )"
        }
    },
    {
        code: "Digit1",
        category: "writing-system",
        keys: {
            us: "1 !"
        }
    },
    {
        code: "Digit2",
        category: "writing-system",
        keys: {
            us: "2 @"
        }
    },
    {
        code: "Digit3",
        category: "writing-system",
        keys: {
            us: "3 #"
        }
    },
    {
        code: "Digit4",
        category: "writing-system",
        keys: {
            us: "4 $"
        }
    },
    {
        code: "Digit5",
        category: "writing-system",
        keys: {
            us: "5 %"
        }
    },
    {
        code: "Digit6",
        category: "writing-system",
        keys: {
            us: "6 ^"
        }
    },
    {
        code: "Digit7",
        category: "writing-system",
        keys: {
            us: "7 &"
        }
    },
    {
        code: "Digit8",
        category: "writing-system",
        keys: {
            us: "8 *"
        }
    },
    {
        code: "Digit9",
        category: "writing-system",
        keys: {
            us: "9 ("
        }
    },
    {
        code: "KeyA",
        category: "writing-system",
        keys: {
            us: "a A"
        }
    },
    {
        code: "KeyB",
        category: "writing-system",
        keys: {
            us: "b B"
        }
    },
    {
        code: "KeyC",
        category: "writing-system",
        keys: {
            us: "c C"
        }
    },
    {
        code: "KeyD",
        category: "writing-system",
        keys: {
            us: "d D"
        }
    },
    {
        code: "KeyE",
        category: "writing-system",
        keys: {
            us: "e E"
        }
    },
    {
        code: "KeyF",
        category: "writing-system",
        keys: {
            us: "f F"
        }
    },
    {
        code: "KeyG",
        category: "writing-system",
        keys: {
            us: "g G"
        }
    },
    {
        code: "KeyH",
        category: "writing-system",
        keys: {
            us: "h H"
        }
    },
    {
        code: "KeyI",
        category: "writing-system",
        keys: {
            us: "i I"
        }
    },
    {
        code: "KeyJ",
        category: "writing-system",
        keys: {
            us: "j J"
        }
    },
    {
        code: "KeyK",
        category: "writing-system",
        keys: {
            us: "k K"
        }
    },
    {
        code: "KeyL",
        category: "writing-system",
        keys: {
            us: "l L"
        }
    },
    {
        code: "KeyM",
        category: "writing-system",
        keys: {
            us: "m M"
        }
    },
    {
        code: "KeyN",
        category: "writing-system",
        keys: {
            us: "n N"
        }
    },
    {
        code: "KeyO",
        category: "writing-system",
        keys: {
            us: "o O"
        }
    },
    {
        code: "KeyP",
        category: "writing-system",
        keys: {
            us: "p P"
        }
    },
    {
        code: "KeyQ",
        category: "writing-system",
        keys: {
            us: "q Q"
        }
    },
    {
        code: "KeyR",
        category: "writing-system",
        keys: {
            us: "r R"
        }
    },
    {
        code: "KeyS",
        category: "writing-system",
        keys: {
            us: "s S"
        }
    },
    {
        code: "KeyT",
        category: "writing-system",
        keys: {
            us: "t T"
        }
    },
    {
        code: "KeyU",
        category: "writing-system",
        keys: {
            us: "u U"
        }
    },
    {
        code: "KeyV",
        category: "writing-system",
        keys: {
            us: "v V"
        }
    },
    {
        code: "KeyW",
        category: "writing-system",
        keys: {
            us: "w W"
        }
    },
    {
        code: "KeyX",
        category: "writing-system",
        keys: {
            us: "x X"
        }
    },
    {
        code: "KeyY",
        category: "writing-system",
        keys: {
            us: "y Y"
        }
    },
    {
        code: "KeyZ",
        category: "writing-system",
        keys: {
            us: "z Z"
        }
    },
    {
        code: "Backquote",
        category: "writing-system",
        keys: {
            us: "` ~"
        }
    },
    {
        code: "Backslash",
        category: "writing-system",
        keys: {
            us: "\\ |"
        }
    },
    {
        code: "BracketLeft",
        category: "writing-system",
        keys: {
            us: "[ {"
        }
    },
    {
        code: "BracketRight",
        category: "writing-system",
        keys: {
            us: "] }"
        }
    },
    {
        code: "Comma",
        category: "writing-system",
        keys: {
            us: ", <"
        }
    },
    {
        code: "Equal",
        category: "writing-system",
        keys: {
            us: "= +"
        }
    },
    {
        code: "Minus",
        category: "writing-system",
        keys: {
            us: "- _"
        }
    },
    {
        code: "Period",
        category: "writing-system",
        keys: {
            us: ". >"
        }
    },
    {
        code: "Quote",
        category: "writing-system",
        keys: {
            us: "' \""
        }
    },
    {
        code: "Semicolon",
        category: "writing-system",
        keys: {
            us: "; :"
        }
    },
    {
        code: "Slash",
        category: "writing-system",
        keys: {
            us: "/ ?"
        }
    },
    {
        code: "IntlBackslash",
        category: "writing-system",
        keys: {
            us: undefined
        }
    },
    {
        code: "IntlRo",
        category: "writing-system",
        keys: {
            us: undefined
        }
    },
    {
        code: "IntlYen",
        category: "writing-system",
        keys: {
            us: undefined
        }
    },
    // Functional keys
    // https://www.w3.org/TR/uievents-code/#key-alphanumeric-functional
    // Codes have the same meaning regardless of locale, except for "AltRight"
    {
        code: "AltLeft",
        category: "functional"
    },
    {
        code: "AltRight",
        category: "functional"
    },
    // The W3C table includes this in the Writing System Keys table instead of the Functional Keys table, but its diagrams
    // and text describe it as a functional key, so it has been moved here under the assumption that the table is incorrect
    // https://github.com/w3c/uievents-code/issues/34
    {
        code: "Backspace",
        category: "writing-system"
    },
    {
        code: "CapsLock",
        category: "functional"
    },
    {
        code: "ContextMenu",
        category: "functional"
    },
    {
        code: "ControlLeft",
        category: "functional"
    },
    {
        code: "ControlRight",
        category: "functional"
    },
    {
        code: "Enter",
        category: "functional"
    },
    {
        code: "MetaLeft",
        category: "functional"
    },
    {
        code: "MetaRight",
        category: "functional"
    },
    {
        code: "ShiftLeft",
        category: "functional"
    },
    {
        code: "ShiftRight",
        category: "functional"
    },
    {
        code: "Space",
        category: "functional"
    },
    {
        code: "Tab",
        category: "functional"
    },
    // Functional Japanese/Korean keys
    {
        code: "Convert",
        category: "functional-jp-kr"
    },
    {
        code: "KanaMode",
        category: "functional-jp-kr"
    },
    {
        code: "Lang1",
        category: "functional-jp-kr"
    },
    {
        code: "Lang2",
        category: "functional-jp-kr"
    },
    {
        code: "Lang3",
        category: "functional-jp-kr"
    },
    {
        code: "Lang4",
        category: "functional-jp-kr"
    },
    {
        code: "Lang5",
        category: "functional-jp-kr"
    },
    {
        code: "NonConvert",
        category: "functional-jp-kr"
    },
    // Control pad keys
    {
        code: "Delete",
        category: "control-pad"
    },
    {
        code: "End",
        category: "control-pad"
    },
    {
        code: "Help",
        category: "control-pad"
    },
    {
        code: "Home",
        category: "control-pad"
    },
    {
        code: "Insert",
        category: "control-pad"
    },
    {
        code: "PageDown",
        category: "control-pad"
    },
    {
        code: "PageUp",
        category: "control-pad"
    },
    // Arrow pad keys
    {
        code: "ArrowDown",
        category: "arrow-pad"
    },
    {
        code: "ArrowLeft",
        category: "arrow-pad"
    },
    {
        code: "ArrowRight",
        category: "arrow-pad"
    },
    {
        code: "ArrowUp",
        category: "arrow-pad"
    },
    // Numpad keys
    {
        code: "Numpad0",
        category: "numpad"
    },
    {
        code: "Numpad1",
        category: "numpad"
    },
    {
        code: "Numpad2",
        category: "numpad"
    },
    {
        code: "Numpad3",
        category: "numpad"
    },
    {
        code: "Numpad4",
        category: "numpad"
    },
    {
        code: "Numpad5",
        category: "numpad"
    },
    {
        code: "Numpad6",
        category: "numpad"
    },
    {
        code: "Numpad7",
        category: "numpad"
    },
    {
        code: "Numpad8",
        category: "numpad"
    },
    {
        code: "Numpad9",
        category: "numpad"
    },
    {
        code: "NumLock",
        category: "numpad"
    },
    {
        code: "NumpadAdd",
        category: "numpad"
    },
    {
        code: "NumpadBackspace",
        category: "numpad"
    },
    {
        code: "NumpadClear",
        category: "numpad"
    },
    {
        code: "NumpadClearEntry",
        category: "numpad"
    },
    {
        code: "NumpadComma",
        category: "numpad"
    },
    {
        code: "NumpadDecimal",
        category: "numpad"
    },
    {
        code: "NumpadDivide",
        category: "numpad"
    },
    {
        code: "NumpadEnter",
        category: "numpad"
    },
    {
        code: "NumpadEqual",
        category: "numpad"
    },
    {
        code: "NumpadHash",
        category: "numpad"
    },
    {
        code: "NumpadMemoryAdd",
        category: "numpad"
    },
    {
        code: "NumpadMemoryClear",
        category: "numpad"
    },
    {
        code: "NumpadMemoryRecall",
        category: "numpad"
    },
    {
        code: "NumpadMemoryStore",
        category: "numpad"
    },
    {
        code: "NumpadMemorySubtract",
        category: "numpad"
    },
    {
        code: "NumpadMultiply",
        category: "numpad"
    },
    {
        code: "NumpadParenLeft",
        category: "numpad"
    },
    {
        code: "NumpadParenRight",
        category: "numpad"
    },
    {
        code: "NumpadStar",
        category: "numpad"
    },
    {
        code: "NumpadSubtract",
        category: "numpad"
    },
    // Function keys
    {
        code: "Escape",
        category: "function"
    },
    {
        code: "F1",
        category: "function"
    },
    {
        code: "F2",
        category: "function"
    },
    {
        code: "F3",
        category: "function"
    },
    {
        code: "F4",
        category: "function"
    },
    {
        code: "F5",
        category: "function"
    },
    {
        code: "F6",
        category: "function"
    },
    {
        code: "F7",
        category: "function"
    },
    {
        code: "F8",
        category: "function"
    },
    {
        code: "F9",
        category: "function"
    },
    {
        code: "F10",
        category: "function"
    },
    {
        code: "F11",
        category: "function"
    },
    {
        code: "F12",
        category: "function"
    },
    {
        code: "F13",
        category: "function"
    },
    {
        code: "F14",
        category: "function"
    },
    {
        code: "F15",
        category: "function"
    },
    {
        code: "F16",
        category: "function"
    },
    {
        code: "F17",
        category: "function"
    },
    {
        code: "F18",
        category: "function"
    },
    {
        code: "F19",
        category: "function"
    },
    {
        code: "F20",
        category: "function"
    },
    {
        code: "F21",
        category: "function"
    },
    {
        code: "F22",
        category: "function"
    },
    {
        code: "F23",
        category: "function"
    },
    {
        code: "F24",
        category: "function"
    },
    {
        code: "Fn",
        category: "function"
    },
    {
        code: "FnLock",
        category: "function"
    },
    {
        code: "PrintScreen",
        category: "function"
    },
    {
        code: "ScrollLock",
        category: "function"
    },
    {
        code: "Pause",
        category: "function"
    },
    // Media keys
    {
        code: "BrowserBack",
        category: "media"
    },
    {
        code: "BrowserFavorites",
        category: "media"
    },
    {
        code: "BrowserForward",
        category: "media"
    },
    {
        code: "BrowserHome",
        category: "media"
    },
    {
        code: "BrowserRefresh",
        category: "media"
    },
    {
        code: "BrowserSearch",
        category: "media"
    },
    {
        code: "BrowserStop",
        category: "media"
    },
    {
        code: "Eject",
        category: "media"
    },
    {
        code: "LaunchApp1",
        category: "media"
    },
    {
        code: "LaunchApp2",
        category: "media"
    },
    {
        code: "LaunchMail",
        category: "media"
    },
    {
        code: "MediaPlayPause",
        category: "media"
    },
    {
        code: "MediaSelect",
        category: "media"
    },
    {
        code: "MediaStop",
        category: "media"
    },
    {
        code: "MediaTrackNext",
        category: "media"
    },
    {
        code: "MediaTrackPrevious",
        category: "media"
    },
    {
        code: "Power",
        category: "media"
    },
    {
        code: "Sleep",
        category: "media"
    },
    {
        code: "AudioVolumeDown",
        category: "media"
    },
    {
        code: "AudioVolumeMute",
        category: "media"
    },
    {
        code: "AudioVolumeUp",
        category: "media"
    },
    {
        code: "WakeUp",
        category: "media"
    },
    // Unidentified keys
    {
        code: "Unidentified",
        category: "unidentified"
    }
];
const $f03b4dcefd1c1439$var$KEY_CODE_NAMES = Object.values($f03b4dcefd1c1439$var$KEY_CODES).map((info)=>info.code);
// const KEY_CODE_NAMES_WITHOUT_HANDEDNESS = KEY_CODE_NAMES.filter((code) => !(code.endsWith("Right") && HANDED_KEY_ATTRIBUTE_VALUES.some((modifier) => code === `${modifier}Right`))).map((code) =>
// code.endsWith("Left") && HANDED_KEY_ATTRIBUTE_VALUES.some((modifier) => code === `${modifier}Left`) ? code.replace("Left", "") : code
// );
const $f03b4dcefd1c1439$var$NUMPAD_DECIMAL_AND_THOUSANDS_SEPARATORS = [
    "NumpadComma",
    "NumpadDecimal"
];
const $f03b4dcefd1c1439$var$SCAN_CODES_FOR_NON_WRITING_KEYS_THAT_VARY_PER_LOCALE = [
    "AltRight",
    ...$f03b4dcefd1c1439$var$NUMPAD_DECIMAL_AND_THOUSANDS_SEPARATORS
];
const $f03b4dcefd1c1439$var$LOCALE_SPECIFIC_KEY_CODES_INFO = $f03b4dcefd1c1439$var$KEY_CODES.filter((key)=>key.category === "writing-system" || $f03b4dcefd1c1439$var$SCAN_CODES_FOR_NON_WRITING_KEYS_THAT_VARY_PER_LOCALE.includes(key.code));
const $f03b4dcefd1c1439$var$LOCALE_SPECIFIC_KEY_CODES = $f03b4dcefd1c1439$var$LOCALE_SPECIFIC_KEY_CODES_INFO.map((info)=>info.code);
const $f03b4dcefd1c1439$var$WRITING_SYSTEM_SPECIAL_CHARS = Object.values($f03b4dcefd1c1439$var$KEY_CODES).filter((info)=>info.category === "writing-system").flatMap((info)=>info.keys?.us?.split(" ")).filter((character)=>character && !/[a-zA-Z0-9]/.test(character));
const $f03b4dcefd1c1439$var$KEY_ATTRIBUTE_VALUES_INVOLVING_HANDEDNESS = [
    "Control",
    "Meta",
    "Shift"
];
const $f03b4dcefd1c1439$var$KEY_ATTRIBUTE_VALUES = new Set([
    // Modifier
    "Alt",
    "AltGraph",
    "CapsLock",
    "Control",
    "Fn",
    "FnLock",
    "Meta",
    "NumLock",
    "ScrollLock",
    "Shift",
    "Symbol",
    "SymbolLock",
    // Legacy modifier
    "Hyper",
    "Super",
    // White space
    "Enter",
    "Tab",
    // Navigation
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "End",
    "Home",
    "PageDown",
    "PageUp",
    // Editing
    "Backspace",
    "Clear",
    "Copy",
    "CrSel",
    "Cut",
    "Delete",
    "EraseEof",
    "ExSel",
    "Insert",
    "Paste",
    "Redo",
    "Undo",
    // UI
    "Accept",
    "Again",
    "Attn",
    "Cancel",
    "ContextMenu",
    "Escape",
    "Execute",
    "Find",
    "Help",
    "Pause",
    "Play",
    "Props",
    "Select",
    "ZoomIn",
    "ZoomOut",
    // Device
    "BrightnessDown",
    "BrightnessUp",
    "Eject",
    "LogOff",
    "Power",
    "PowerOff",
    "PrintScreen",
    "Hibernate",
    "Standby",
    "WakeUp",
    // IME composition keys
    "AllCandidates",
    "Alphanumeric",
    "CodeInput",
    "Compose",
    "Convert",
    "Dead",
    "FinalMode",
    "GroupFirst",
    "GroupLast",
    "GroupNext",
    "GroupPrevious",
    "ModeChange",
    "NextCandidate",
    "NonConvert",
    "PreviousCandidate",
    "Process",
    "SingleCandidate",
    // Korean-specific
    "HangulMode",
    "HanjaMode",
    "JunjaMode",
    // Japanese-specific
    "Eisu",
    "Hankaku",
    "Hiragana",
    "HiraganaKatakana",
    "KanaMode",
    "KanjiMode",
    "Katakana",
    "Romaji",
    "Zenkaku",
    "ZenkakuHankaku",
    // Common function
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "F10",
    "F11",
    "F12",
    "F13",
    "F14",
    "F15",
    "F16",
    "F17",
    "F18",
    "F19",
    "F20",
    "F21",
    "F22",
    "F23",
    "F24",
    "Soft1",
    "Soft2",
    "Soft3",
    "Soft4",
    "Soft5",
    "Soft6",
    "Soft7",
    "Soft8",
    "Soft9",
    "Soft10",
    "Soft11",
    "Soft12",
    "Soft13",
    "Soft14",
    "Soft15",
    "Soft16",
    "Soft17",
    "Soft18",
    "Soft19",
    "Soft20",
    "Soft21",
    "Soft22",
    "Soft23",
    "Soft24",
    // Multimedia
    "ChannelDown",
    "ChannelUp",
    "Close",
    "MailForward",
    "MailReply",
    "MailSend",
    "MediaClose",
    "MediaFastForward",
    "MediaPause",
    "MediaPlay",
    "MediaPlayPause",
    "MediaRecord",
    "MediaRewind",
    "MediaStop",
    "MediaTrackNext",
    "MediaTrackPrevious",
    "New",
    "Open",
    "Print",
    "Save",
    "SpellCheck",
    // Multimedia numpad
    "Digit11",
    "Digit12",
    // Audio
    "AudioBalanceLeft",
    "AudioBalanceRight",
    "AudioBassBoostDown",
    "AudioBassBoostToggle",
    "AudioBassBoostUp",
    "AudioFaderFront",
    "AudioFaderRear",
    "AudioSurroundModeNext",
    "AudioTrebleDown",
    "AudioTrebleUp",
    "AudioVolumeDown",
    "AudioVolumeUp",
    "AudioVolumeMute",
    "MicrophoneToggle",
    "MicrophoneVolumeDown",
    "MicrophoneVolumeUp",
    "MicrophoneVolumeMute",
    // Speech
    "SpeechCorrectionList",
    "SpeechInputToggle",
    // Application
    "LaunchApplication1",
    "LaunchApplication2",
    "LaunchCalendar",
    "LaunchContacts",
    "LaunchMail",
    "LaunchMediaPlayer",
    "LaunchMusicPlayer",
    "LaunchPhone",
    "LaunchScreenSaver",
    "LaunchSpreadsheet",
    "LaunchWebBrowser",
    "LaunchWebCam",
    "LaunchWordProcessor",
    // Browser
    "BrowserBack",
    "BrowserFavorites",
    "BrowserForward",
    "BrowserHome",
    "BrowserRefresh",
    "BrowserSearch",
    "BrowserStop",
    // Mobile phone
    "AppSwitch",
    "Call",
    "Camera",
    "CameraFocus",
    "EndCall",
    "GoBack",
    "GoHome",
    "HeadsetHook",
    "LastNumberRedial",
    "Notification",
    "MannerMode",
    "VoiceDial",
    // TV
    "TV",
    "TV3DMode",
    "TVAntennaCable",
    "TVAudioDescription",
    "TVAudioDescriptionMixDown",
    "TVAudioDescriptionMixUp",
    "TVContentsMenu",
    "TVDataService",
    "TVInput",
    "TVInputComponent1",
    "TVInputComponent2",
    "TVInputComposite1",
    "TVInputComposite2",
    "TVInputHDMI1",
    "TVInputHDMI2",
    "TVInputHDMI3",
    "TVInputHDMI4",
    "TVInputVGA1",
    "TVMediaContext",
    "TVNetwork",
    "TVNumberEntry",
    "TVPower",
    "TVRadioService",
    "TVSatellite",
    "TVSatelliteBS",
    "TVSatelliteCS",
    "TVSatelliteToggle",
    "TVTerrestrialAnalog",
    "TVTerrestrialDigital",
    "TVTimer",
    // Media controls
    "AVRInput",
    "AVRPower",
    "ColorF0Red",
    "ColorF1Green",
    "ColorF2Yellow",
    "ColorF3Blue",
    "ColorF4Grey",
    "ColorF5Brown",
    "ClosedCaptionToggle",
    "Dimmer",
    "DisplaySwap",
    "DVR",
    "Exit",
    "FavoriteClear0",
    "FavoriteClear1",
    "FavoriteClear2",
    "FavoriteClear3",
    "FavoriteRecall0",
    "FavoriteRecall1",
    "FavoriteRecall2",
    "FavoriteRecall3",
    "FavoriteStore0",
    "FavoriteStore1",
    "FavoriteStore2",
    "FavoriteStore3",
    "Guide",
    "GuideNextDay",
    "GuidePreviousDay",
    "Info",
    "InstantReplay",
    "Link",
    "ListProgram",
    "LiveContent",
    "Lock",
    "MediaApps",
    "MediaAudioTrack",
    "MediaLast",
    "MediaSkipBackward",
    "MediaSkipForward",
    "MediaStepBackward",
    "MediaStepForward",
    "MediaTopMenu",
    "NavigateIn",
    "NavigateNext",
    "NavigateOut",
    "NavigatePrevious",
    "NextFavoriteChannel",
    "NextUserProfile",
    "OnDemand",
    "Pairing",
    "PinPDown",
    "PinPMove",
    "PinPToggle",
    "PinPUp",
    "PlaySpeedDown",
    "PlaySpeedReset",
    "PlaySpeedUp",
    "RandomToggle",
    "RcLowBattery",
    "RecordSpeedNext",
    "RfBypass",
    "ScanChannelsToggle",
    "ScreenModeNext",
    "Settings",
    "SplitScreenToggle",
    "STBInput",
    "STBPower",
    "Subtitle",
    "Teletext",
    "VideoModeNext",
    "Wink",
    "ZoomToggle",
    // Unidentified
    "Unidentified"
]);




function $cdcd498cb09bc056$export$7a02ffac009727f6(stringPieces, ...substitutions) {
    const interleavedSubstitutions = stringPieces.flatMap((stringPiece, index)=>[
            stringPiece,
            substitutions[index] !== undefined ? substitutions[index] : ""
        ]);
    const stringLines = interleavedSubstitutions.join("").split("\n");
    const visibleLineTabPrefixLengths = stringLines.map((line)=>/\S/.test(line) ? (line.match(/^(\t*)/) || [])[1].length : Infinity);
    const commonTabPrefixLength = Math.min(...visibleLineTabPrefixLengths);
    const linesWithoutCommonTabPrefix = stringLines.map((line)=>line.substring(commonTabPrefixLength));
    const multiLineString = linesWithoutCommonTabPrefix.join("\n");
    return multiLineString.trim();
}



function $98dd458b1b9dd393$export$d3f50ec9ab1089ab(editor, dialog, portfolio, document, fullscreen) {
    const app = window.document.querySelector("[data-app-container]");
    app?.focus();
    let viewportPointerInteractionOngoing = false;
    let textToolInteractiveInputElement = undefined;
    let canvasFocused = true;
    // Event listeners
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listeners = [
        {
            target: window,
            eventName: "resize",
            action: ()=>onWindowResize(window.document.body)
        },
        {
            target: window,
            eventName: "beforeunload",
            action: (e)=>onBeforeUnload(e)
        },
        {
            target: window,
            eventName: "keyup",
            action: (e)=>onKeyUp(e)
        },
        {
            target: window,
            eventName: "keydown",
            action: (e)=>onKeyDown(e)
        },
        {
            target: window,
            eventName: "pointermove",
            action: (e)=>onPointerMove(e)
        },
        {
            target: window,
            eventName: "pointerdown",
            action: (e)=>onPointerDown(e)
        },
        {
            target: window,
            eventName: "pointerup",
            action: (e)=>onPointerUp(e)
        },
        {
            target: window,
            eventName: "mousedown",
            action: (e)=>onMouseDown(e)
        },
        {
            target: window,
            eventName: "mouseup",
            action: (e)=>onPotentialDoubleClick(e)
        },
        {
            target: window,
            eventName: "wheel",
            action: (e)=>onWheelScroll(e),
            options: {
                passive: false
            }
        },
        {
            target: window,
            eventName: "modifyinputfield",
            action: (e)=>onModifyInputField(e)
        },
        {
            target: window,
            eventName: "focusout",
            action: ()=>canvasFocused = false
        },
        {
            target: window.document,
            eventName: "contextmenu",
            action: (e)=>onContextMenu(e)
        },
        {
            target: window.document,
            eventName: "fullscreenchange",
            action: ()=>fullscreen.fullscreenModeChanged()
        },
        {
            target: window.document.body,
            eventName: "paste",
            action: (e)=>onPaste(e)
        }
    ];
    // Event bindings
    function bindListeners() {
        // Add event bindings for the lifetime of the application
        listeners.forEach(({ target: target, eventName: eventName, action: action, options: options })=>target.addEventListener(eventName, action, options));
    }
    function unbindListeners() {
        // Remove event bindings after the lifetime of the application (or on hot-module replacement during development)
        listeners.forEach(({ target: target, eventName: eventName, action: action, options: options })=>target.removeEventListener(eventName, action, options));
    }
    // Keyboard events
    async function shouldRedirectKeyboardEventToBackend(e) {
        // Don't redirect when a modal is covering the workspace
        if ((0, $1eb80e36873dc327$export$def9168ec19d7707)(dialog).visible) return false;
        const key = await (0, $f03b4dcefd1c1439$export$a614615e232c88d5)(e);
        // TODO: Switch to a system where everything is sent to the backend, then the input preprocessor makes decisions and kicks some inputs back to the frontend
        const accelKey = (0, $7ed52b8c7c886783$export$f205d53822e9a9a9)() ? e.metaKey : e.ctrlKey;
        // Don't redirect user input from text entry into HTML elements
        if ($98dd458b1b9dd393$var$targetIsTextField(e.target || undefined) && key !== "Escape" && !(accelKey && [
            "Enter",
            "NumpadEnter"
        ].includes(key))) return false;
        // Don't redirect paste
        if (key === "KeyV" && accelKey) return false;
        // Don't redirect a fullscreen request
        if (key === "F11" && e.type === "keydown" && !e.repeat) {
            e.preventDefault();
            fullscreen.toggleFullscreen();
            return false;
        }
        // Don't redirect a reload request
        if (key === "F5") return false;
        if (key === "KeyR" && accelKey) return false;
        // Don't redirect debugging tools
        if ([
            "F12",
            "F8"
        ].includes(key)) return false;
        if ([
            "KeyC",
            "KeyI",
            "KeyJ"
        ].includes(key) && accelKey && e.shiftKey) return false;
        // Don't redirect tab or enter if not in canvas (to allow navigating elements)
        if (!canvasFocused && !$98dd458b1b9dd393$var$targetIsTextField(e.target || undefined) && [
            "Tab",
            "Enter",
            "NumpadEnter",
            "Space",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp"
        ].includes(key)) return false;
        // Redirect to the backend
        return true;
    }
    async function onKeyDown(e) {
        const key = await (0, $f03b4dcefd1c1439$export$a614615e232c88d5)(e);
        const NO_KEY_REPEAT_MODIFIER_KEYS = [
            "ControlLeft",
            "ControlRight",
            "ShiftLeft",
            "ShiftRight",
            "MetaLeft",
            "MetaRight",
            "AltLeft",
            "AltRight",
            "AltGraph",
            "CapsLock",
            "Fn",
            "FnLock"
        ];
        if (e.repeat && NO_KEY_REPEAT_MODIFIER_KEYS.includes(key)) return;
        if (await shouldRedirectKeyboardEventToBackend(e)) {
            e.preventDefault();
            const modifiers = (0, $f03b4dcefd1c1439$export$ec5c813343f1cfd4)(e);
            editor.instance.onKeyDown(key, modifiers, e.repeat);
            return;
        }
        if ((0, $1eb80e36873dc327$export$def9168ec19d7707)(dialog).visible && key === "Escape") dialog.dismissDialog();
    }
    async function onKeyUp(e) {
        const key = await (0, $f03b4dcefd1c1439$export$a614615e232c88d5)(e);
        if (await shouldRedirectKeyboardEventToBackend(e)) {
            e.preventDefault();
            const modifiers = (0, $f03b4dcefd1c1439$export$ec5c813343f1cfd4)(e);
            editor.instance.onKeyUp(key, modifiers, e.repeat);
        }
    }
    // Pointer events
    // While any pointer button is already down, additional button down events are not reported, but they are sent as `pointermove` events and these are handled in the backend
    function onPointerMove(e) {
        if (!e.buttons) viewportPointerInteractionOngoing = false;
        // Don't redirect pointer movement to the backend if there's no ongoing interaction and it's over a floating menu, or the graph overlay, on top of the canvas
        // TODO: A better approach is to pass along a boolean to the backend's input preprocessor so it can know if it's being occluded by the GUI.
        // TODO: This would allow it to properly decide to act on removing hover focus from something that was hovered in the canvas before moving over the GUI.
        // TODO: Further explanation: https://github.com/GraphiteEditor/Graphite/pull/623#discussion_r866436197
        const inFloatingMenu = e.target instanceof Element && e.target.closest("[data-floating-menu-content]");
        const inGraphOverlay = (0, $1eb80e36873dc327$export$def9168ec19d7707)(document).graphViewOverlayOpen;
        if (!viewportPointerInteractionOngoing && (inFloatingMenu || inGraphOverlay)) return;
        const { target: target } = e;
        const newInCanvasArea = (target instanceof Element && target.closest("[data-viewport], [data-graph]")) instanceof Element && !$98dd458b1b9dd393$var$targetIsTextField(window.document.activeElement || undefined);
        if (newInCanvasArea && !canvasFocused) {
            canvasFocused = true;
            app?.focus();
        }
        const modifiers = (0, $f03b4dcefd1c1439$export$ec5c813343f1cfd4)(e);
        editor.instance.onMouseMove(e.clientX, e.clientY, e.buttons, modifiers);
    }
    function onMouseDown(e) {
        // Block middle mouse button auto-scroll mode (the circlar gizmo that appears and allows quick scrolling by moving the cursor above or below it)
        if (e.button === 1) e.preventDefault();
    }
    function onPointerDown(e) {
        const { target: target } = e;
        const isTargetingCanvas = target instanceof Element && target.closest("[data-viewport]");
        const inDialog = target instanceof Element && target.closest("[data-dialog-modal] [data-floating-menu-content]");
        const inTextInput = target === textToolInteractiveInputElement;
        if ((0, $1eb80e36873dc327$export$def9168ec19d7707)(dialog).visible && !inDialog) {
            dialog.dismissDialog();
            e.preventDefault();
            e.stopPropagation();
        }
        if (!inTextInput) {
            if (textToolInteractiveInputElement) editor.instance.onChangeText((0, $f03b4dcefd1c1439$export$6efdc3ca96c7aae5)(textToolInteractiveInputElement.innerText));
            else viewportPointerInteractionOngoing = isTargetingCanvas instanceof Element;
        }
        if (viewportPointerInteractionOngoing) {
            const modifiers = (0, $f03b4dcefd1c1439$export$ec5c813343f1cfd4)(e);
            editor.instance.onMouseDown(e.clientX, e.clientY, e.buttons, modifiers);
        }
    }
    function onPointerUp(e) {
        if (!e.buttons) viewportPointerInteractionOngoing = false;
        if (textToolInteractiveInputElement) return;
        const modifiers = (0, $f03b4dcefd1c1439$export$ec5c813343f1cfd4)(e);
        editor.instance.onMouseUp(e.clientX, e.clientY, e.buttons, modifiers);
    }
    function onPotentialDoubleClick(e) {
        if (textToolInteractiveInputElement) return;
        // Allow only double-clicks
        if (e.detail !== 2) return;
        // `e.buttons` is always 0 in the `mouseup` event, so we have to convert from `e.button` instead
        let buttons = 1;
        if (e.button === 0) buttons = 1; // LMB
        if (e.button === 1) buttons = 4; // MMB
        if (e.button === 2) buttons = 2; // RMB
        const modifiers = (0, $f03b4dcefd1c1439$export$ec5c813343f1cfd4)(e);
        editor.instance.onDoubleClick(e.clientX, e.clientY, buttons, modifiers);
    }
    // Mouse events
    function onWheelScroll(e) {
        const { target: target } = e;
        const isTargetingCanvas = target instanceof Element && target.closest("[data-viewport]");
        // Redirect vertical scroll wheel movement into a horizontal scroll on a horizontally scrollable element
        // There seems to be no possible way to properly employ the browser's smooth scrolling interpolation
        const horizontalScrollableElement = target instanceof Element && target.closest("[data-scrollable-x]");
        if (horizontalScrollableElement && e.deltaY !== 0) {
            horizontalScrollableElement.scrollTo(horizontalScrollableElement.scrollLeft + e.deltaY, 0);
            return;
        }
        if (isTargetingCanvas) {
            e.preventDefault();
            const modifiers = (0, $f03b4dcefd1c1439$export$ec5c813343f1cfd4)(e);
            editor.instance.onWheelScroll(e.clientX, e.clientY, e.buttons, e.deltaX, e.deltaY, e.deltaZ, modifiers);
        }
    }
    function onContextMenu(e) {
        if (!$98dd458b1b9dd393$var$targetIsTextField(e.target || undefined) && e.target !== textToolInteractiveInputElement) e.preventDefault();
    }
    // Receives a custom event dispatched when the user begins interactively editing with the text tool.
    // We keep a copy of the text input element to check against when it's active for text entry.
    function onModifyInputField(e) {
        textToolInteractiveInputElement = e.detail;
    }
    // Window events
    function onWindowResize(container) {
        const viewports = Array.from(container.querySelectorAll("[data-viewport]"));
        const boundsOfViewports = viewports.map((canvas)=>{
            const bounds = canvas.getBoundingClientRect();
            return [
                bounds.left,
                bounds.top,
                bounds.right,
                bounds.bottom
            ];
        });
        const flattened = boundsOfViewports.flat();
        const data = Float64Array.from(flattened);
        if (boundsOfViewports.length > 0) editor.instance.boundsOfViewports(data);
    }
    async function onBeforeUnload(e) {
        const activeDocument = (0, $1eb80e36873dc327$export$def9168ec19d7707)(portfolio).documents[(0, $1eb80e36873dc327$export$def9168ec19d7707)(portfolio).activeDocumentIndex];
        if (activeDocument && !activeDocument.isAutoSaved) editor.instance.triggerAutoSave(activeDocument.id);
        // Skip the message if the editor crashed, since work is already lost
        if (await editor.instance.hasCrashed()) return;
        // Skip the message during development, since it's annoying when testing
        if (await editor.instance.inDevelopmentMode()) return;
        const allDocumentsSaved = (0, $1eb80e36873dc327$export$def9168ec19d7707)(portfolio).documents.reduce((acc, doc)=>acc && doc.isSaved, true);
        if (!allDocumentsSaved) {
            e.returnValue = "Unsaved work will be lost if the web browser tab is closed. Close anyway?";
            e.preventDefault();
        }
    }
    function onPaste(e) {
        const dataTransfer = e.clipboardData;
        if (!dataTransfer || $98dd458b1b9dd393$var$targetIsTextField(e.target || undefined)) return;
        e.preventDefault();
        Array.from(dataTransfer.items).forEach((item)=>{
            if (item.type === "text/plain") item.getAsString((text)=>{
                if (text.startsWith("graphite/layer: ")) editor.instance.pasteSerializedData(text.substring(16, text.length));
                else if (text.startsWith("graphite/nodes: ")) editor.instance.pasteSerializedNodes(text.substring(16, text.length));
            });
            const file = item.getAsFile();
            if (file?.type.startsWith("image")) (0, $a169f2d3602aed86$export$6bd5bcc5a8099e6)(file).then((imageData)=>{
                editor.instance.pasteImage(new Uint8Array(imageData.data), imageData.width, imageData.height);
            });
        });
    }
    // Frontend message subscriptions
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$ad0333232682cac), async ()=>{
        // In the try block, attempt to read from the Clipboard API, which may not have permission and may not be supported in all browsers
        // In the catch block, explain to the user why the paste failed and how to fix or work around the problem
        try {
            // Attempt to check if the clipboard permission is denied, and throw an error if that is the case
            // In Firefox, the `clipboard-read` permission isn't supported, so attempting to query it throws an error
            // In Safari, the entire Permissions API isn't supported, so the query never occurs and this block is skipped without an error and we assume we might have permission
            const clipboardRead = "clipboard-read";
            const permission = await navigator.permissions?.query({
                name: clipboardRead
            });
            if (permission?.state === "denied") throw new Error("Permission denied");
            // Read the clipboard contents if the Clipboard API is available
            const clipboardItems = await navigator.clipboard.read();
            if (!clipboardItems) throw new Error("Clipboard API unsupported");
            // Read any layer data or images from the clipboard
            Array.from(clipboardItems).forEach(async (item)=>{
                // Read plain text and, if it is a layer, pass it to the editor
                if (item.types.includes("text/plain")) {
                    const blob = await item.getType("text/plain");
                    const reader = new FileReader();
                    reader.onload = ()=>{
                        const text = reader.result;
                        if (text.startsWith("graphite/layer: ")) editor.instance.pasteSerializedData(text.substring(16, text.length));
                    };
                    reader.readAsText(blob);
                }
                // Read an image from the clipboard and pass it to the editor to be loaded
                const imageType = item.types.find((type)=>type.startsWith("image/"));
                if (imageType) {
                    const blob = await item.getType(imageType);
                    const reader = new FileReader();
                    reader.onload = async ()=>{
                        if (reader.result instanceof ArrayBuffer) {
                            const imageData = await (0, $a169f2d3602aed86$export$6bd5bcc5a8099e6)(new Blob([
                                reader.result
                            ], {
                                type: imageType
                            }));
                            editor.instance.pasteImage(new Uint8Array(imageData.data), imageData.width, imageData.height);
                        }
                    };
                    reader.readAsArrayBuffer(blob);
                }
            });
        } catch (err) {
            const unsupported = (0, $cdcd498cb09bc056$export$7a02ffac009727f6)`
				This browser does not support reading from the clipboard.
				Use the keyboard shortcut to paste instead.
				`;
            const denied = (0, $cdcd498cb09bc056$export$7a02ffac009727f6)`
				The browser's clipboard permission has been denied.

				Open the browser's website settings (usually accessible
				just left of the URL) to allow this permission.
				`;
            const matchMessage = {
                "clipboard-read": unsupported,
                "Clipboard API unsupported": unsupported,
                "Permission denied": denied
            };
            const message = Object.entries(matchMessage).find(([key])=>String(err).includes(key))?.[1] || String(err);
            editor.instance.errorDialog("Cannot access clipboard", message);
        }
    });
    // Initialization
    // Bind the event listeners
    bindListeners();
    // Resize on creation
    onWindowResize(window.document.body);
    // Return the destructor
    return unbindListeners;
}
function $98dd458b1b9dd393$var$targetIsTextField(target) {
    return target instanceof HTMLElement && (target.nodeName === "INPUT" || target.nodeName === "TEXTAREA" || target.isContentEditable);
}



function $17af88b835efbc99$export$2eaa5ea2d1925364(editor) {
    function localizeTimestamp(utc) {
        // Timestamp
        const date = new Date(utc);
        if (Number.isNaN(date.getTime())) return {
            timestamp: utc,
            year: `${new Date().getFullYear()}`
        };
        const timezoneName = Intl.DateTimeFormat(undefined, {
            timeZoneName: "long"
        }).formatToParts(new Date()).find((part)=>part.type === "timeZoneName");
        const dateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        const timeString = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
        const timezoneNameString = timezoneName?.value;
        return {
            timestamp: `${dateString} ${timeString} ${timezoneNameString}`,
            year: `${date.getFullYear()}`
        };
    }
    // Subscribe to process backend event
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$db2a8420355239c0), (triggerAboutGraphiteLocalizedCommitDate)=>{
        const localized = localizeTimestamp(triggerAboutGraphiteLocalizedCommitDate.commitDate);
        editor.instance.requestAboutGraphiteDialogWithLocalizedCommitDate(localized.timestamp, localized.year);
    });
}





function $945a093b2ba443fe$export$a680f9ea2b1b4796(editor, dialogState) {
    // Code panic dialog and console error
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$b1e8b5daf8396760), (displayDialogPanic)=>{
        // `Error.stackTraceLimit` is only available in V8/Chromium
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Error.stackTraceLimit = Infinity;
        const stackTrace = new Error().stack || "";
        const panicDetails = `${displayDialogPanic.panicInfo}${stackTrace ? `\n\n${stackTrace}` : ""}`;
        // eslint-disable-next-line no-console
        console.error(panicDetails);
        dialogState.createCrashDialog(panicDetails);
    });
}
function $945a093b2ba443fe$export$1efe58927fe9d27a(panicDetails) {
    const url = new URL("https://github.com/GraphiteEditor/Graphite/issues/new");
    let body = (0, $cdcd498cb09bc056$export$7a02ffac009727f6)`
		**Describe the Crash**
		Explain clearly what you were doing when the crash occurred.

		**Steps To Reproduce**
		Describe precisely how the crash occurred, step by step, starting with a new editor window.
		1. Open the Graphite editor at https://editor.graphite.rs
		2. 
		3. 
		4. 
		5. 

		**Additional Details**
		Provide any further information or context that you think would be helpful in fixing the issue. Screenshots or video can be linked or attached to this issue.

		**Browser and OS**
		${(0, $7ed52b8c7c886783$export$61e3782b541bd28e)()}, ${(0, $7ed52b8c7c886783$export$2dc6e2a3a552baa5)(true).replace("Unknown", "YOUR OPERATING SYSTEM")}

		**Stack Trace**
		Copied from the crash dialog in the Graphite editor:
	`;
    body += "\n\n```\n";
    body += panicDetails.trimEnd();
    body += "\n```";
    const fields = {
        title: "[Crash Report] ",
        body: body,
        labels: [
            "Crash"
        ].join(","),
        projects: [].join(","),
        milestone: "",
        assignee: "",
        template: ""
    };
    Object.entries(fields).forEach(([field, value])=>{
        if (value) url.searchParams.set(field, value);
    });
    return url.toString();
}


function $ced5ead3c34b6f8d$var$_slicedToArray(arr, i) {
    return $ced5ead3c34b6f8d$var$_arrayWithHoles(arr) || $ced5ead3c34b6f8d$var$_iterableToArrayLimit(arr, i) || $ced5ead3c34b6f8d$var$_unsupportedIterableToArray(arr, i) || $ced5ead3c34b6f8d$var$_nonIterableRest();
}
function $ced5ead3c34b6f8d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ced5ead3c34b6f8d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ced5ead3c34b6f8d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ced5ead3c34b6f8d$var$_arrayLikeToArray(o, minLen);
}
function $ced5ead3c34b6f8d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ced5ead3c34b6f8d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ced5ead3c34b6f8d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ced5ead3c34b6f8d$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $ced5ead3c34b6f8d$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $ced5ead3c34b6f8d$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $ced5ead3c34b6f8d$var$defaultGetStoreFunc;
function $ced5ead3c34b6f8d$var$defaultGetStore() {
    if (!$ced5ead3c34b6f8d$var$defaultGetStoreFunc) $ced5ead3c34b6f8d$var$defaultGetStoreFunc = $ced5ead3c34b6f8d$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $ced5ead3c34b6f8d$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $ced5ead3c34b6f8d$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $ced5ead3c34b6f8d$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $ced5ead3c34b6f8d$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $ced5ead3c34b6f8d$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($ced5ead3c34b6f8d$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $ced5ead3c34b6f8d$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $ced5ead3c34b6f8d$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $ced5ead3c34b6f8d$export$b327150396135fe7(store.transaction);
    });
}
function $ced5ead3c34b6f8d$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $ced5ead3c34b6f8d$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $ced5ead3c34b6f8d$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $ced5ead3c34b6f8d$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $ced5ead3c34b6f8d$export$b327150396135fe7(store.getAll());
        var items = [];
        return $ced5ead3c34b6f8d$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $ced5ead3c34b6f8d$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ced5ead3c34b6f8d$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $ced5ead3c34b6f8d$export$b327150396135fe7(store.getAllKeys()),
            $ced5ead3c34b6f8d$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $ced5ead3c34b6f8d$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $ced5ead3c34b6f8d$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}




const $ed258b5c0b4a06bc$var$graphiteStore = (0, $ced5ead3c34b6f8d$export$f51a9068ac82ea43)("graphite", "store");
function $ed258b5c0b4a06bc$export$75f5a0288d359bdf(editor, portfolio) {
    // DOCUMENTS
    async function storeDocumentOrder() {
        const documentOrder = (0, $1eb80e36873dc327$export$def9168ec19d7707)(portfolio).documents.map((doc)=>String(doc.id));
        await (0, $ced5ead3c34b6f8d$export$adaa4cf7ef1b65be)("documents_tab_order", documentOrder, $ed258b5c0b4a06bc$var$graphiteStore);
    }
    async function storeDocument(autoSaveDocument) {
        await (0, $ced5ead3c34b6f8d$export$722fbec263ad908a)("documents", (old)=>{
            const documents = old || {};
            documents[autoSaveDocument.details.id] = autoSaveDocument;
            return documents;
        }, $ed258b5c0b4a06bc$var$graphiteStore);
        await storeDocumentOrder();
    }
    async function removeDocument(id) {
        await (0, $ced5ead3c34b6f8d$export$722fbec263ad908a)("documents", (old)=>{
            const documents = old || {};
            delete documents[id];
            return documents;
        }, $ed258b5c0b4a06bc$var$graphiteStore);
        await storeDocumentOrder();
    }
    async function loadDocuments() {
        const previouslySavedDocuments = await (0, $ced5ead3c34b6f8d$export$3988ae62b71be9a3)("documents", $ed258b5c0b4a06bc$var$graphiteStore);
        const documentOrder = await (0, $ced5ead3c34b6f8d$export$3988ae62b71be9a3)("documents_tab_order", $ed258b5c0b4a06bc$var$graphiteStore);
        if (!previouslySavedDocuments || !documentOrder) return;
        const orderedSavedDocuments = documentOrder.flatMap((id)=>previouslySavedDocuments[id] ? [
                previouslySavedDocuments[id]
            ] : []);
        const currentDocumentVersion = editor.instance.graphiteDocumentVersion();
        orderedSavedDocuments?.forEach(async (doc)=>{
            if (doc.version !== currentDocumentVersion) {
                await removeDocument(doc.details.id);
                return;
            }
            editor.instance.openAutoSavedDocument(BigInt(doc.details.id), doc.details.name, doc.details.isSaved, doc.document);
        });
    }
    // PREFERENCES
    async function savePreferences(preferences) {
        await (0, $ced5ead3c34b6f8d$export$adaa4cf7ef1b65be)("preferences", preferences, $ed258b5c0b4a06bc$var$graphiteStore);
    }
    async function loadPreferences() {
        const preferences = await (0, $ced5ead3c34b6f8d$export$3988ae62b71be9a3)("preferences", $ed258b5c0b4a06bc$var$graphiteStore);
        if (!preferences) return;
        editor.instance.loadPreferences(JSON.stringify(preferences));
    }
    // FRONTEND MESSAGE SUBSCRIPTIONS
    // Subscribe to process backend events
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$7ab3967777b94c66), async (preferences)=>{
        await savePreferences(preferences.preferences);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$f4cdd9700ca2a131), async ()=>{
        await loadPreferences();
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$6ee046007579e816), async (autoSaveDocument)=>{
        await storeDocument(autoSaveDocument);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$e49bdefb21e4ee79), async (removeAutoSaveDocument)=>{
        await removeDocument(removeAutoSaveDocument.documentId);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$e4645b5e9b7c4232), async ()=>{
        await loadDocuments();
    });
}
async function $ed258b5c0b4a06bc$export$958a88f5eb002229() {
    await (0, $ced5ead3c34b6f8d$export$1d2f21e549771e67)("documents_tab_order", $ed258b5c0b4a06bc$var$graphiteStore);
    await (0, $ced5ead3c34b6f8d$export$1d2f21e549771e67)("documents", $ed258b5c0b4a06bc$var$graphiteStore);
}




function $5a70f91b7dc0dff9$export$3a42832ec1ff7cee(editor) {
    const { subscribe: subscribe, update: update } = (0, $6c2f3afb15ad1449$export$e6d3eada50a007b1)({
        visible: false,
        title: "",
        icon: "",
        buttons: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        column1: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        column2: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        // Special case for the crash dialog because we cannot handle button widget callbacks from Rust once the editor instance has panicked
        panicDetails: ""
    });
    function dismissDialog() {
        update((state)=>{
            // Disallow dismissing the crash dialog since it can confuse users why the app stopped responding if they dismiss it without realizing what it means
            if (state.panicDetails === "") state.visible = false;
            return state;
        });
    }
    // Creates a crash dialog from JS once the editor has panicked.
    // Normal dialogs are created in the Rust backend, but for the crash dialog, the editor instance has panicked so it cannot respond to widget callbacks.
    function createCrashDialog(panicDetails) {
        update((state)=>{
            state.visible = true;
            state.icon = "Failure";
            state.title = "Crash";
            state.panicDetails = panicDetails;
            state.column1 = (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)();
            state.column2 = (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)();
            state.buttons = (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)();
            return state;
        });
    }
    // Subscribe to process backend events
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$90fee3ac057e6e0c), (displayDialog)=>{
        update((state)=>{
            state.visible = true;
            state.title = displayDialog.title;
            state.icon = displayDialog.icon;
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$dcf9c80e827f7972), (updateDialogButtons)=>{
        update((state)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.buttons, updateDialogButtons);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$f49a73e53ce910a9), (updateDialogColumn1)=>{
        update((state)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.column1, updateDialogColumn1);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$686f75900abec9c9), (updateDialogColumn2)=>{
        update((state)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.column2, updateDialogColumn2);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$acbb728739bb7d83), dismissDialog);
    return {
        subscribe: subscribe,
        dismissDialog: dismissDialog,
        createCrashDialog: createCrashDialog
    };
}





function $46c0d35e9a21e6fa$export$cefcfc6f5c5cac45(editor) {
    const state = (0, $6c2f3afb15ad1449$export$e6d3eada50a007b1)({
        // Layouts
        documentModeLayout: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        toolOptionsLayout: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        documentBarLayout: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        toolShelfLayout: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        graphViewOverlayButtonLayout: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        workingColorsLayout: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        nodeGraphBarLayout: (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)(),
        // Graph view overlay
        graphViewOverlayOpen: false
    });
    const { subscribe: subscribe, update: update } = state;
    // Update layouts
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$6ae1afef0ec15637), async (updateDocumentModeLayout)=>{
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        update((state)=>{
            // `state.documentModeLayout` is mutated in the function
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.documentModeLayout, updateDocumentModeLayout);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$a7c75961eb53f4c9), async (updateToolOptionsLayout)=>{
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        update((state)=>{
            // `state.documentModeLayout` is mutated in the function
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.toolOptionsLayout, updateToolOptionsLayout);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$6ecaa6f86c30f346), async (updateDocumentBarLayout)=>{
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        update((state)=>{
            // `state.documentModeLayout` is mutated in the function
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.documentBarLayout, updateDocumentBarLayout);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$870f7044c5c3c3e3), async (updateToolShelfLayout)=>{
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        update((state)=>{
            // `state.documentModeLayout` is mutated in the function
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.toolShelfLayout, updateToolShelfLayout);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$b43a1237b2186276), async (updateGraphViewOverlayButtonLayout)=>{
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        update((state)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.graphViewOverlayButtonLayout, updateGraphViewOverlayButtonLayout);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$831638e45dba82dc), async (updateWorkingColorsLayout)=>{
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        update((state)=>{
            // `state.documentModeLayout` is mutated in the function
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.workingColorsLayout, updateWorkingColorsLayout);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$d839cb726a3e3994), (updateNodeGraphBarLayout)=>{
        update((state)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(state.nodeGraphBarLayout, updateNodeGraphBarLayout);
            return state;
        });
    });
    // Other
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$4f5fda2bd70beb59), async ()=>{
        // Wait to display the unpopulated document panel (missing: tools, options bar content, scrollbar positioning, and canvas)
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        // Wait to display the populated document panel
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        // Request a resize event so the viewport gets measured now that the canvas is populated and positioned correctly
        window.dispatchEvent(new CustomEvent("resize"));
    });
    // Show or hide the graph view overlay
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$90cfb375d35400f3), (triggerGraphViewOverlay)=>{
        update((state)=>{
            state.graphViewOverlayOpen = triggerGraphViewOverlay.open;
            return state;
        });
    });
    return {
        subscribe: subscribe
    };
}




function $25c843ead59e69eb$export$1ca8f41f0e20cd69(editor) {
    // TODO: Do some code cleanup to remove the need for this empty store
    const { subscribe: subscribe } = (0, $6c2f3afb15ad1449$export$e6d3eada50a007b1)({});
    function createURL(font) {
        const url = new URL("https://fonts.googleapis.com/css2");
        url.searchParams.set("display", "swap");
        url.searchParams.set("family", font);
        url.searchParams.set("text", font);
        return url;
    }
    async function fontNames() {
        return (await fontList).map((font)=>({
                name: font.family,
                url: createURL(font.family)
            }));
    }
    async function getFontStyles(fontFamily) {
        const font = (await fontList).find((value)=>value.family === fontFamily);
        return font?.variants.map((variant)=>({
                name: variant,
                url: undefined
            })) || [];
    }
    async function getFontFileUrl(fontFamily, fontStyle) {
        const font = (await fontList).find((value)=>value.family === fontFamily);
        const fontFileUrl = font?.files.get(fontStyle);
        return fontFileUrl?.replace("http://", "https://");
    }
    function formatFontStyleName(fontStyle) {
        const isItalic = fontStyle.endsWith("italic");
        const weight = fontStyle === "regular" || fontStyle === "italic" ? 400 : parseInt(fontStyle, 10);
        let weightName = "";
        let bestWeight = Infinity;
        $25c843ead59e69eb$var$weightNameMapping.forEach((nameChecking, weightChecking)=>{
            if (Math.abs(weightChecking - weight) < bestWeight) {
                bestWeight = Math.abs(weightChecking - weight);
                weightName = nameChecking;
            }
        });
        return `${weightName}${isItalic ? " Italic" : ""} (${weight})`;
    }
    // Subscribe to process backend events
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$d22f34b01e740bcc), async (triggerFontLoad)=>{
        const url = await getFontFileUrl(triggerFontLoad.font.fontFamily, triggerFontLoad.font.fontStyle);
        if (url) {
            const response = await (await fetch(url)).arrayBuffer();
            editor.instance.onFontLoad(triggerFontLoad.font.fontFamily, triggerFontLoad.font.fontStyle, url, new Uint8Array(response), triggerFontLoad.isDefault);
        } else editor.instance.errorDialog("Failed to load font", `The font ${triggerFontLoad.font.fontFamily} with style ${triggerFontLoad.font.fontStyle} does not exist`);
    });
    const fontList = new Promise((resolve)=>{
        fetch($25c843ead59e69eb$var$fontListAPI).then((response)=>response.json()).then((fontListResponse)=>{
            const fontListData = fontListResponse.items;
            const result = fontListData.map((font)=>{
                const { family: family } = font;
                const variants = font.variants.map(formatFontStyleName);
                const files = new Map(font.variants.map((x)=>[
                        formatFontStyleName(x),
                        font.files[x]
                    ]));
                return {
                    family: family,
                    variants: variants,
                    files: files
                };
            });
            resolve(result);
        });
    });
    return {
        subscribe: subscribe,
        fontNames: fontNames,
        getFontStyles: getFontStyles,
        getFontFileUrl: getFontFileUrl
    };
}
const $25c843ead59e69eb$var$fontListAPI = "https://api.graphite.rs/font-list";
// From https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#common_weight_name_mapping
const $25c843ead59e69eb$var$weightNameMapping = new Map([
    [
        100,
        "Thin"
    ],
    [
        200,
        "Extra Light"
    ],
    [
        300,
        "Light"
    ],
    [
        400,
        "Normal"
    ],
    [
        500,
        "Medium"
    ],
    [
        600,
        "Semi Bold"
    ],
    [
        700,
        "Bold"
    ],
    [
        800,
        "Extra Bold"
    ],
    [
        900,
        "Black"
    ],
    [
        950,
        "Extra Black"
    ]
]);



function $919eb2f1f48ef86a$export$325355d6f159c7ef(_) {
    const { subscribe: subscribe, update: update } = (0, $6c2f3afb15ad1449$export$e6d3eada50a007b1)({
        windowFullscreen: false,
        keyboardLocked: false
    });
    function fullscreenModeChanged() {
        update((state)=>{
            state.windowFullscreen = Boolean(document.fullscreenElement);
            if (!state.windowFullscreen) state.keyboardLocked = false;
            return state;
        });
    }
    async function enterFullscreen() {
        await document.documentElement.requestFullscreen();
        if (keyboardLockApiSupported) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            await navigator.keyboard.lock([
                "ControlLeft",
                "ControlRight"
            ]);
            update((state)=>{
                state.keyboardLocked = true;
                return state;
            });
        }
    }
    async function exitFullscreen() {
        await document.exitFullscreen();
    }
    async function toggleFullscreen() {
        return new Promise((resolve, reject)=>{
            update((state)=>{
                if (state.windowFullscreen) exitFullscreen().then(resolve).catch(reject);
                else enterFullscreen().then(resolve).catch(reject);
                return state;
            });
        });
    }
    // Experimental Keyboard API: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/keyboard
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const keyboardLockApiSupported = "keyboard" in navigator && navigator.keyboard && "lock" in navigator.keyboard;
    return {
        subscribe: subscribe,
        fullscreenModeChanged: fullscreenModeChanged,
        enterFullscreen: enterFullscreen,
        exitFullscreen: exitFullscreen,
        toggleFullscreen: toggleFullscreen,
        keyboardLockApiSupported: keyboardLockApiSupported
    };
}




function $9914c471b719ce76$export$47cbb066836108c4(editor) {
    const { subscribe: subscribe, update: update } = (0, $6c2f3afb15ad1449$export$e6d3eada50a007b1)({
        nodes: [],
        links: [],
        nodeTypes: [],
        zoomWithScroll: false,
        thumbnails: new Map()
    });
    // Set up message subscriptions on creation
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$25559ab104f9af0b), (updateNodeGraph)=>{
        update((state)=>{
            state.nodes = updateNodeGraph.nodes;
            state.links = updateNodeGraph.links;
            let newThumbnails = new Map();
            state.nodes.forEach((node)=>{
                const thumbnail = state.thumbnails.get(node.id);
                if (thumbnail) newThumbnails.set(node.id, thumbnail);
            });
            state.thumbnails = newThumbnails;
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$82d84f4230431c53), (updateNodeTypes)=>{
        update((state)=>{
            state.nodeTypes = updateNodeTypes.nodeTypes;
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$a82de4785f98f0ee), (updateNodeThumbnail)=>{
        update((state)=>{
            state.thumbnails.set(updateNodeThumbnail.id, updateNodeThumbnail.value);
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$962e54e8f7bd1786), (updateZoomWithScroll)=>{
        update((state)=>{
            state.zoomWithScroll = updateZoomWithScroll.zoomWithScroll;
            return state;
        });
    });
    return {
        subscribe: subscribe
    };
}


/* eslint-disable max-classes-per-file */ 




function $92656e52d7465e90$export$6385be12e9d49165(editor) {
    const { subscribe: subscribe, update: update } = (0, $6c2f3afb15ad1449$export$e6d3eada50a007b1)({
        unsaved: false,
        documents: [],
        activeDocumentIndex: 0
    });
    // Set up message subscriptions on creation
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$bc1038db4c84c3e2), (updateOpenDocumentList)=>{
        update((state)=>{
            state.documents = updateOpenDocumentList.openDocuments;
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$3d6efe341ed16f), (updateActiveDocument)=>{
        update((state)=>{
            // Assume we receive a correct document id
            const activeId = state.documents.findIndex((doc)=>doc.id === updateActiveDocument.documentId);
            state.activeDocumentIndex = activeId;
            return state;
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$c53869e99500f3ff), async (triggerFetchAndOpenDocument)=>{
        try {
            const url = new URL(triggerFetchAndOpenDocument.url);
            const data = await fetch(url);
            const filename = url.pathname.split("/").pop() || "Untitled";
            const content = await data.text();
            editor.instance.openDocumentFile(filename, content);
        } catch  {
            editor.instance.errorDialog("Failed to open document", "The file could not be reached over the internet. You may be offline, or it may be missing.");
        }
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$f25eb5c81205b7fa), async ()=>{
        const extension = editor.instance.fileSaveSuffix();
        const data = await (0, $161093e588a77f28$export$a3c8e1472dc2ed84)(extension, "text");
        editor.instance.openDocumentFile(data.filename, data.content);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$53f77d4489bb1c34), async ()=>{
        const data = await (0, $161093e588a77f28$export$a3c8e1472dc2ed84)("image/*", "data");
        const imageData = await (0, $a169f2d3602aed86$export$6bd5bcc5a8099e6)(new Blob([
            data.content
        ], {
            type: data.type
        }));
        editor.instance.pasteImage(new Uint8Array(imageData.data), imageData.width, imageData.height);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$1e88bf4b8e1e0d8a), (triggerFileDownload)=>{
        (0, $161093e588a77f28$export$46bb9181f1d89c32)(triggerFileDownload.name, triggerFileDownload.document);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$28c7d626096abc12), async (triggerDownloadBlobUrl)=>{
        const data = await fetch(triggerDownloadBlobUrl.blobUrl);
        const blob = await data.blob();
        // TODO: Remove this if/when we end up returning PNG directly from the backend
        const pngBlob = await (0, $a169f2d3602aed86$export$32a51639b9f2083f)(blob);
        (0, $161093e588a77f28$export$439bad7921a8b6c8)(triggerDownloadBlobUrl.layerName, pngBlob);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$fb8722a4b873b954), (triggerDownloadBlobUrl)=>{
        (0, $5878622efbf463d1$export$8356caa654c4fd79)(triggerDownloadBlobUrl.blobUrl);
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$53c1006fe0e4f258), async (triggerRasterDownload)=>{
        const { svg: svg, name: name, mime: mime, size: size } = triggerRasterDownload;
        // Fill the canvas with white if it'll be a JPEG (which does not support transparency and defaults to black)
        const backgroundColor = mime.endsWith("jpeg") ? "white" : undefined;
        // Rasterize the SVG to an image file
        try {
            const blob = await (0, $a169f2d3602aed86$export$429b8f6aca987a21)(svg, size.x, size.y, mime, backgroundColor);
            // Have the browser download the file to the user's disk
            (0, $161093e588a77f28$export$439bad7921a8b6c8)(name, blob);
        } catch  {
        // Fail silently if there's an error rasterizing the SVG, such as a zero-sized image
        }
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$200c3286d72cacb8), (updateImageData)=>{
        updateImageData.imageData.forEach(async (element)=>{
            const buffer = new Uint8Array(element.imageData.values()).buffer;
            const blob = new Blob([
                buffer
            ], {
                type: element.mime
            });
            const blobURL = URL.createObjectURL(blob);
            // Pre-decode the image so it is ready to be drawn instantly once it's placed into the viewport SVG
            const image = new Image();
            image.src = blobURL;
            await image.decode();
            editor.instance.setImageBlobURL(updateImageData.documentId, element.path, element.nodeId, blobURL, image.naturalWidth, image.naturalHeight, element.transform);
        });
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$38b20bcd8aa2ec66), async (triggerRasterizeRegionBelowLayer)=>{
        const { documentId: documentId, layerPath: layerPath, svg: svg, size: size } = triggerRasterizeRegionBelowLayer;
        // Rasterize the SVG to an image file
        try {
            if (size[0] >= 1 && size[1] >= 1) {
                const imageData = (await (0, $a169f2d3602aed86$export$c3955ecdb816704b)(svg, size[0], size[1])).getContext("2d")?.getImageData(0, 0, size[0], size[1]);
                if (!imageData) return;
                editor.instance.renderGraphUsingRasterizedRegionBelowLayer(documentId, layerPath, new Uint8Array(imageData.data), imageData.width, imageData.height);
            }
        } // getImageData may throw an exception if the resolution is too high
        catch (e) {
            console.error("Failed to rasterize the SVG canvas in JS to be sent back to Rust:", e);
        }
    });
    editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$d2750cee179259b), async (triggerRevokeBlobUrl)=>{
        URL.revokeObjectURL(triggerRevokeBlobUrl.url);
    });
    return {
        subscribe: subscribe
    };
}


/* src/components/window/MainWindow.svelte generated by Svelte v3.58.0 */ 
/* src/components/layout/LayoutCol.svelte generated by Svelte v3.58.0 */ 
function $2cf38967565f222d$var$create_fragment(ctx) {
    let div_1;
    let div_1_class_value;
    let div_1_style_value;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[13].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[12], null);
    let div_1_levels = [
        {
            class: div_1_class_value = `layout-col ${ctx[0]} ${ctx[7]}`.trim()
        },
        {
            style: div_1_style_value = `${ctx[1]} ${ctx[6]}`.trim() || undefined
        },
        {
            title: /*tooltip*/ ctx[2]
        },
        /*$$restProps*/ ctx[8]
    ];
    let div_data = {};
    for(let i = 0; i < div_1_levels.length; i += 1)div_data = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(div_data, div_1_levels[i]);
    return {
        c () {
            div_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (default_slot) default_slot.c();
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(div_1, div_data);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-x", /*scrollableX*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-y", /*scrollableY*/ ctx[4]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div_1, anchor);
            if (default_slot) default_slot.m(div_1, null);
            /*div_1_binding*/ ctx[56](div_1);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "focus", /*focus_handler*/ ctx[14]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "blur", /*blur_handler*/ ctx[15]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "fullscreenchange", /*fullscreenchange_handler*/ ctx[16]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "fullscreenerror", /*fullscreenerror_handler*/ ctx[17]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "scroll", /*scroll_handler*/ ctx[18]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "cut", /*cut_handler*/ ctx[19]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "copy", /*copy_handler*/ ctx[20]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "paste", /*paste_handler*/ ctx[21]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "keydown", /*keydown_handler*/ ctx[22]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "keypress", /*keypress_handler*/ ctx[23]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "keyup", /*keyup_handler*/ ctx[24]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "auxclick", /*auxclick_handler*/ ctx[25]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "click", /*click_handler*/ ctx[26]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "contextmenu", /*contextmenu_handler*/ ctx[27]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dblclick", /*dblclick_handler*/ ctx[28]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mousedown", /*mousedown_handler*/ ctx[29]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseenter", /*mouseenter_handler*/ ctx[30]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseleave", /*mouseleave_handler*/ ctx[31]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mousemove", /*mousemove_handler*/ ctx[32]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseover", /*mouseover_handler*/ ctx[33]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseout", /*mouseout_handler*/ ctx[34]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseup", /*mouseup_handler*/ ctx[35]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "select", /*select_handler*/ ctx[36]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "drag", /*drag_handler*/ ctx[37]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragend", /*dragend_handler*/ ctx[38]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragenter", /*dragenter_handler*/ ctx[39]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragstart", /*dragstart_handler*/ ctx[40]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragleave", /*dragleave_handler*/ ctx[41]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragover", /*dragover_handler*/ ctx[42]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "drop", /*drop_handler*/ ctx[43]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "touchcancel", /*touchcancel_handler*/ ctx[44]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "touchend", /*touchend_handler*/ ctx[45]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerover", /*pointerover_handler*/ ctx[46]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerenter", /*pointerenter_handler*/ ctx[47]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerdown", /*pointerdown_handler*/ ctx[48]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointermove", /*pointermove_handler*/ ctx[49]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerup", /*pointerup_handler*/ ctx[50]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointercancel", /*pointercancel_handler*/ ctx[51]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerout", /*pointerout_handler*/ ctx[52]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerleave", /*pointerleave_handler*/ ctx[53]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "gotpointercapture", /*gotpointercapture_handler*/ ctx[54]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "lostpointercapture", /*lostpointercapture_handler*/ ctx[55])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty[0] & /*$$scope*/ 4096)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[12], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[12]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[12], dirty, null), null);
            }
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(div_1, div_data = (0, $1eb80e36873dc327$export$eea1060726e9ab6)(div_1_levels, [
                (!current || dirty[0] & /*className, extraClasses*/ 129 && div_1_class_value !== (div_1_class_value = `layout-col ${ctx[0]} ${ctx[7]}`.trim())) && {
                    class: div_1_class_value
                },
                (!current || dirty[0] & /*styleName, extraStyles*/ 66 && div_1_style_value !== (div_1_style_value = `${ctx[1]} ${ctx[6]}`.trim() || undefined)) && {
                    style: div_1_style_value
                },
                (!current || dirty[0] & /*tooltip*/ 4) && {
                    title: /*tooltip*/ ctx[2]
                },
                dirty[0] & /*$$restProps*/ 256 && /*$$restProps*/ ctx[8]
            ]));
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-x", /*scrollableX*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-y", /*scrollableY*/ ctx[4]);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div_1);
            if (default_slot) default_slot.d(detaching);
            /*div_1_binding*/ ctx[56](null);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
function $2cf38967565f222d$var$instance($$self, $$props, $$invalidate) {
    let extraClasses;
    let extraStyles;
    const omit_props_names = [
        "class",
        "classes",
        "style",
        "styles",
        "tooltip",
        "scrollableX",
        "scrollableY",
        "div"
    ];
    let $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names);
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    let { style: styleName = "" } = $$props;
    let { styles: styles = {} } = $$props;
    let { tooltip: tooltip } = $$props;
    let { scrollableX: scrollableX = false } = $$props;
    let { scrollableY: scrollableY = false } = $$props;
    let self;
    function div() {
        return self;
    }
    function focus_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function blur_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function fullscreenchange_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function fullscreenerror_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function scroll_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function cut_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function copy_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function paste_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function keydown_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function keypress_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function keyup_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function auxclick_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function click_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function contextmenu_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dblclick_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mousedown_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseenter_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseleave_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mousemove_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseover_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseout_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseup_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function select_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function drag_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragend_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragenter_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragstart_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragleave_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragover_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function drop_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function touchcancel_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function touchend_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerover_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerenter_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerdown_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointermove_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerup_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointercancel_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerout_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerleave_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function gotpointercapture_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function lostpointercapture_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function div_1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(5, self);
        });
    }
    $$self.$$set = ($$new_props)=>{
        $$props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)((0, $1eb80e36873dc327$export$e6e34fd1f2686227)({}, $$props), (0, $1eb80e36873dc327$export$1b59c714eb8e4c9f)($$new_props));
        $$invalidate(8, $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names));
        if ("class" in $$new_props) $$invalidate(0, className = $$new_props.class);
        if ("classes" in $$new_props) $$invalidate(9, classes = $$new_props.classes);
        if ("style" in $$new_props) $$invalidate(1, styleName = $$new_props.style);
        if ("styles" in $$new_props) $$invalidate(10, styles = $$new_props.styles);
        if ("tooltip" in $$new_props) $$invalidate(2, tooltip = $$new_props.tooltip);
        if ("scrollableX" in $$new_props) $$invalidate(3, scrollableX = $$new_props.scrollableX);
        if ("scrollableY" in $$new_props) $$invalidate(4, scrollableY = $$new_props.scrollableY);
        if ("$$scope" in $$new_props) $$invalidate(12, $$scope = $$new_props.$$scope);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*classes*/ 512) $: $$invalidate(7, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
        if ($$self.$$.dirty[0] & /*styles*/ 1024) $: $$invalidate(6, extraStyles = Object.entries(styles).flatMap((styleAndValue)=>styleAndValue[1] !== undefined ? [
                `${styleAndValue[0]}: ${styleAndValue[1]};`
            ] : []).join(" "));
    };
    return [
        className,
        styleName,
        tooltip,
        scrollableX,
        scrollableY,
        self,
        extraStyles,
        extraClasses,
        $$restProps,
        classes,
        styles,
        div,
        $$scope,
        slots,
        focus_handler,
        blur_handler,
        fullscreenchange_handler,
        fullscreenerror_handler,
        scroll_handler,
        cut_handler,
        copy_handler,
        paste_handler,
        keydown_handler,
        keypress_handler,
        keyup_handler,
        auxclick_handler,
        click_handler,
        contextmenu_handler,
        dblclick_handler,
        mousedown_handler,
        mouseenter_handler,
        mouseleave_handler,
        mousemove_handler,
        mouseover_handler,
        mouseout_handler,
        mouseup_handler,
        select_handler,
        drag_handler,
        dragend_handler,
        dragenter_handler,
        dragstart_handler,
        dragleave_handler,
        dragover_handler,
        drop_handler,
        touchcancel_handler,
        touchend_handler,
        pointerover_handler,
        pointerenter_handler,
        pointerdown_handler,
        pointermove_handler,
        pointerup_handler,
        pointercancel_handler,
        pointerout_handler,
        pointerleave_handler,
        gotpointercapture_handler,
        lostpointercapture_handler,
        div_1_binding
    ];
}
class $2cf38967565f222d$var$LayoutCol extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $2cf38967565f222d$var$instance, $2cf38967565f222d$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            class: 0,
            classes: 9,
            style: 1,
            styles: 10,
            tooltip: 2,
            scrollableX: 3,
            scrollableY: 4,
            div: 11
        }, null, [
            -1,
            -1
        ]);
    }
    get div() {
        return this.$$.ctx[11];
    }
}
var $2cf38967565f222d$export$2e2bcd8739ae039 = $2cf38967565f222d$var$LayoutCol;


/* src/components/window/status-bar/StatusBar.svelte generated by Svelte v3.58.0 */ 



/* src/components/layout/LayoutRow.svelte generated by Svelte v3.58.0 */ 
function $3c849e5e6ea41fd5$var$create_fragment(ctx) {
    let div_1;
    let div_1_class_value;
    let div_1_style_value;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[13].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[12], null);
    let div_1_levels = [
        {
            class: div_1_class_value = `layout-row ${ctx[0]} ${ctx[7]}`.trim()
        },
        {
            style: div_1_style_value = `${ctx[1]} ${ctx[6]}`.trim() || undefined
        },
        {
            title: /*tooltip*/ ctx[2]
        },
        /*$$restProps*/ ctx[8]
    ];
    let div_data = {};
    for(let i = 0; i < div_1_levels.length; i += 1)div_data = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(div_data, div_1_levels[i]);
    return {
        c () {
            div_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (default_slot) default_slot.c();
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(div_1, div_data);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-x", /*scrollableX*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-y", /*scrollableY*/ ctx[4]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div_1, anchor);
            if (default_slot) default_slot.m(div_1, null);
            /*div_1_binding*/ ctx[56](div_1);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "focus", /*focus_handler*/ ctx[14]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "blur", /*blur_handler*/ ctx[15]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "fullscreenchange", /*fullscreenchange_handler*/ ctx[16]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "fullscreenerror", /*fullscreenerror_handler*/ ctx[17]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "scroll", /*scroll_handler*/ ctx[18]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "cut", /*cut_handler*/ ctx[19]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "copy", /*copy_handler*/ ctx[20]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "paste", /*paste_handler*/ ctx[21]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "keydown", /*keydown_handler*/ ctx[22]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "keypress", /*keypress_handler*/ ctx[23]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "keyup", /*keyup_handler*/ ctx[24]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "auxclick", /*auxclick_handler*/ ctx[25]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "click", /*click_handler*/ ctx[26]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "contextmenu", /*contextmenu_handler*/ ctx[27]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dblclick", /*dblclick_handler*/ ctx[28]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mousedown", /*mousedown_handler*/ ctx[29]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseenter", /*mouseenter_handler*/ ctx[30]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseleave", /*mouseleave_handler*/ ctx[31]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mousemove", /*mousemove_handler*/ ctx[32]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseover", /*mouseover_handler*/ ctx[33]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseout", /*mouseout_handler*/ ctx[34]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "mouseup", /*mouseup_handler*/ ctx[35]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "select", /*select_handler*/ ctx[36]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "drag", /*drag_handler*/ ctx[37]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragend", /*dragend_handler*/ ctx[38]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragenter", /*dragenter_handler*/ ctx[39]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragstart", /*dragstart_handler*/ ctx[40]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragleave", /*dragleave_handler*/ ctx[41]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "dragover", /*dragover_handler*/ ctx[42]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "drop", /*drop_handler*/ ctx[43]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "touchcancel", /*touchcancel_handler*/ ctx[44]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "touchend", /*touchend_handler*/ ctx[45]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerover", /*pointerover_handler*/ ctx[46]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerenter", /*pointerenter_handler*/ ctx[47]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerdown", /*pointerdown_handler*/ ctx[48]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointermove", /*pointermove_handler*/ ctx[49]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerup", /*pointerup_handler*/ ctx[50]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointercancel", /*pointercancel_handler*/ ctx[51]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerout", /*pointerout_handler*/ ctx[52]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "pointerleave", /*pointerleave_handler*/ ctx[53]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "gotpointercapture", /*gotpointercapture_handler*/ ctx[54]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div_1, "lostpointercapture", /*lostpointercapture_handler*/ ctx[55])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty[0] & /*$$scope*/ 4096)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[12], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[12]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[12], dirty, null), null);
            }
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(div_1, div_data = (0, $1eb80e36873dc327$export$eea1060726e9ab6)(div_1_levels, [
                (!current || dirty[0] & /*className, extraClasses*/ 129 && div_1_class_value !== (div_1_class_value = `layout-row ${ctx[0]} ${ctx[7]}`.trim())) && {
                    class: div_1_class_value
                },
                (!current || dirty[0] & /*styleName, extraStyles*/ 66 && div_1_style_value !== (div_1_style_value = `${ctx[1]} ${ctx[6]}`.trim() || undefined)) && {
                    style: div_1_style_value
                },
                (!current || dirty[0] & /*tooltip*/ 4) && {
                    title: /*tooltip*/ ctx[2]
                },
                dirty[0] & /*$$restProps*/ 256 && /*$$restProps*/ ctx[8]
            ]));
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-x", /*scrollableX*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div_1, "scrollable-y", /*scrollableY*/ ctx[4]);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div_1);
            if (default_slot) default_slot.d(detaching);
            /*div_1_binding*/ ctx[56](null);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
function $3c849e5e6ea41fd5$var$instance($$self, $$props, $$invalidate) {
    let extraClasses;
    let extraStyles;
    const omit_props_names = [
        "class",
        "classes",
        "style",
        "styles",
        "tooltip",
        "scrollableX",
        "scrollableY",
        "div"
    ];
    let $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names);
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    let { style: styleName = "" } = $$props;
    let { styles: styles = {} } = $$props;
    let { tooltip: tooltip } = $$props;
    let { scrollableX: scrollableX = false } = $$props;
    let { scrollableY: scrollableY = false } = $$props;
    let self;
    function div() {
        return self;
    }
    function focus_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function blur_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function fullscreenchange_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function fullscreenerror_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function scroll_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function cut_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function copy_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function paste_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function keydown_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function keypress_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function keyup_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function auxclick_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function click_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function contextmenu_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dblclick_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mousedown_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseenter_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseleave_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mousemove_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseover_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseout_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function mouseup_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function select_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function drag_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragend_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragenter_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragstart_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragleave_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function dragover_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function drop_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function touchcancel_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function touchend_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerover_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerenter_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerdown_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointermove_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerup_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointercancel_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerout_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function pointerleave_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function gotpointercapture_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function lostpointercapture_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function div_1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(5, self);
        });
    }
    $$self.$$set = ($$new_props)=>{
        $$props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)((0, $1eb80e36873dc327$export$e6e34fd1f2686227)({}, $$props), (0, $1eb80e36873dc327$export$1b59c714eb8e4c9f)($$new_props));
        $$invalidate(8, $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names));
        if ("class" in $$new_props) $$invalidate(0, className = $$new_props.class);
        if ("classes" in $$new_props) $$invalidate(9, classes = $$new_props.classes);
        if ("style" in $$new_props) $$invalidate(1, styleName = $$new_props.style);
        if ("styles" in $$new_props) $$invalidate(10, styles = $$new_props.styles);
        if ("tooltip" in $$new_props) $$invalidate(2, tooltip = $$new_props.tooltip);
        if ("scrollableX" in $$new_props) $$invalidate(3, scrollableX = $$new_props.scrollableX);
        if ("scrollableY" in $$new_props) $$invalidate(4, scrollableY = $$new_props.scrollableY);
        if ("$$scope" in $$new_props) $$invalidate(12, $$scope = $$new_props.$$scope);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*classes*/ 512) $: $$invalidate(7, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
        if ($$self.$$.dirty[0] & /*styles*/ 1024) $: $$invalidate(6, extraStyles = Object.entries(styles).flatMap((styleAndValue)=>styleAndValue[1] !== undefined ? [
                `${styleAndValue[0]}: ${styleAndValue[1]};`
            ] : []).join(" "));
    };
    return [
        className,
        styleName,
        tooltip,
        scrollableX,
        scrollableY,
        self,
        extraStyles,
        extraClasses,
        $$restProps,
        classes,
        styles,
        div,
        $$scope,
        slots,
        focus_handler,
        blur_handler,
        fullscreenchange_handler,
        fullscreenerror_handler,
        scroll_handler,
        cut_handler,
        copy_handler,
        paste_handler,
        keydown_handler,
        keypress_handler,
        keyup_handler,
        auxclick_handler,
        click_handler,
        contextmenu_handler,
        dblclick_handler,
        mousedown_handler,
        mouseenter_handler,
        mouseleave_handler,
        mousemove_handler,
        mouseover_handler,
        mouseout_handler,
        mouseup_handler,
        select_handler,
        drag_handler,
        dragend_handler,
        dragenter_handler,
        dragstart_handler,
        dragleave_handler,
        dragover_handler,
        drop_handler,
        touchcancel_handler,
        touchend_handler,
        pointerover_handler,
        pointerenter_handler,
        pointerdown_handler,
        pointermove_handler,
        pointerup_handler,
        pointercancel_handler,
        pointerout_handler,
        pointerleave_handler,
        gotpointercapture_handler,
        lostpointercapture_handler,
        div_1_binding
    ];
}
class $3c849e5e6ea41fd5$var$LayoutRow extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $3c849e5e6ea41fd5$var$instance, $3c849e5e6ea41fd5$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            class: 0,
            classes: 9,
            style: 1,
            styles: 10,
            tooltip: 2,
            scrollableX: 3,
            scrollableY: 4,
            div: 11
        }, null, [
            -1,
            -1
        ]);
    }
    get div() {
        return this.$$.ctx[11];
    }
}
var $3c849e5e6ea41fd5$export$2e2bcd8739ae039 = $3c849e5e6ea41fd5$var$LayoutRow;


/* src/components/widgets/labels/Separator.svelte generated by Svelte v3.58.0 */ 
function $8f30dd58aa143a6c$var$create_if_block(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
function $8f30dd58aa143a6c$var$create_fragment(ctx) {
    let div;
    let show_if = [
        "Section",
        "List"
    ].includes(/*type*/ ctx[1]);
    let div_class_value;
    let if_block = show_if && $8f30dd58aa143a6c$var$create_if_block(ctx);
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block) if_block.c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value = `separator ${ctx[0].toLowerCase()} ${ctx[1].toLowerCase()}`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            if (if_block) if_block.m(div, null);
        },
        p (ctx, [dirty]) {
            if (dirty & /*type*/ 2) show_if = [
                "Section",
                "List"
            ].includes(/*type*/ ctx[1]);
            if (show_if) {
                if (if_block) ;
                else {
                    if_block = $8f30dd58aa143a6c$var$create_if_block(ctx);
                    if_block.c();
                    if_block.m(div, null);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            if (dirty & /*direction, type*/ 3 && div_class_value !== (div_class_value = `separator ${ctx[0].toLowerCase()} ${ctx[1].toLowerCase()}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value);
        },
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            if (if_block) if_block.d();
        }
    };
}
function $8f30dd58aa143a6c$var$instance($$self, $$props, $$invalidate) {
    let { direction: direction = "Horizontal" } = $$props;
    let { type: type = "Unrelated" } = $$props;
    $$self.$$set = ($$props)=>{
        if ("direction" in $$props) $$invalidate(0, direction = $$props.direction);
        if ("type" in $$props) $$invalidate(1, type = $$props.type);
    };
    return [
        direction,
        type
    ];
}
class $8f30dd58aa143a6c$var$Separator extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $8f30dd58aa143a6c$var$instance, $8f30dd58aa143a6c$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            direction: 0,
            type: 1
        });
    }
}
var $8f30dd58aa143a6c$export$2e2bcd8739ae039 = $8f30dd58aa143a6c$var$Separator;


/* src/components/widgets/labels/UserInputLabel.svelte generated by Svelte v3.58.0 */ 


/* src/components/widgets/labels/IconLabel.svelte generated by Svelte v3.58.0 */ 
/* eslint-disable import/first */ // Graphics
var $7805e46f840b2316$exports = {};
$7805e46f840b2316$exports = "<svg viewBox=\"0 0 937 240\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M934.29 139.3a26.39 26.39 0 0 1-10.91 6.27c-3.49 1.06-7.1 1.63-10.74 1.71a25 25 0 0 1-16.6-6.02c-4.78-4.01-7.49-10.63-8.14-19.86l48.01-6.02c0-8.68-2.58-15.71-7.73-21.08-5.16-5.37-12.72-8.06-22.7-8.06a46.74 46.74 0 0 0-20.75 4.72 37.892 37.892 0 0 0-15.54 13.83c-3.91 6.08-5.86 13.46-5.86 22.14 0 8.03 1.76 14.98 5.29 20.83a35.678 35.678 0 0 0 14.32 13.51 42.779 42.779 0 0 0 20.1 4.72c9.01 0 16.14-2.2 21.41-6.59a44.77 44.77 0 0 0 12.45-17.5l-2.61-2.6zm-42.65-40.29c2.28-3.85 5.26-5.78 8.95-5.78 3.79 0 6.48 1.84 8.06 5.53 1.68 4.2 2.59 8.66 2.69 13.18l-23.6 2.93c.32-6.72 1.63-12.01 3.9-15.86M844.61 151.33c-7.06 0-10.58-4.34-10.58-13.02v-34.5c0-4.34 2.17-6.51 6.51-6.51h14.65v-8.62h-21.16c0-4.12.05-8.19.16-12.21.11-4.01.59-11.63.91-15.76l-25.49 11.81v16.16h-9.77v8.62h9.77v44.27c0 7.16 2.01 13.02 6.02 17.58 4.01 4.56 9.87 6.83 17.58 6.84 4.07.13 8.11-.71 11.8-2.44 3.03-1.49 5.72-3.6 7.89-6.18 1.98-2.37 3.62-5 4.88-7.81l-2.6-2.6a14.373 14.373 0 0 1-10.57 4.37M783.25 154.67c-.64-2.97-.91-6-.81-9.03v-38.9c0-5.21.08-9.52.24-12.94s.3-5.94.41-7.57l-.98-.98-35.48 16.44 1.63 3.74c1.09-.4 2.2-.73 3.34-.98.94-.21 1.89-.31 2.85-.32.97-.07 1.92.22 2.69.81.59.54.89 1.63.9 3.26v37.43c.08 3.03-.14 6.05-.65 9.03-.44 2.01-1.2 3.34-2.28 3.99a9.5 9.5 0 0 1-4.39 1.14v3.74h41.5v-3.74c-2.06 0-4.1-.39-6.02-1.14a5.581 5.581 0 0 1-2.95-3.98m-12.21-77.39c3.74.07 7.35-1.44 9.93-4.15 2.64-2.59 4.11-6.15 4.07-9.85.03-3.72-1.44-7.3-4.07-9.93a13.282 13.282 0 0 0-9.93-4.23 13.41 13.41 0 0 0-10.09 4.23c-2.64 2.63-4.1 6.21-4.07 9.93.02 7.75 6.32 14.02 14.07 14 .03.01.06.01.09 0M732.15 154.68c-.64-2.97-.91-6-.81-9.03v-39.22c0-7.05-1.57-12.18-4.72-15.38-3.15-3.2-8.08-4.8-14.81-4.8-4.06.01-8.07.84-11.8 2.44a47.624 47.624 0 0 0-8.79 4.57 69.902 69.902 0 0 0-8.71 6.72V61.55c0-5.21.08-9.52.24-12.94.16-3.42.3-5.94.41-7.57L682.11 40l-35.45 16.42 1.66 3.82c1.09-.4 2.2-.73 3.34-.98.94-.21 1.89-.32 2.85-.33.96-.07 1.92.22 2.68.81.6.55.9 1.63.9 3.26v82.63c.08 3.03-.14 6.05-.65 9.03-.43 2.01-1.19 3.34-2.28 3.99a9.508 9.508 0 0 1-4.4 1.14v3.74h41.5v-3.74c-2.06 0-4.1-.38-6.02-1.14a5.645 5.645 0 0 1-2.93-3.99c-.64-2.97-.91-6-.82-9.03v-37.92a31.48 31.48 0 0 1 8.87-4.23c2.26-.61 4.58-.94 6.92-.98 3.79 0 6.18 1 7.16 3.01 1.06 2.43 1.56 5.08 1.46 7.73v32.39c.08 3.03-.14 6.05-.65 9.03-.43 2.01-1.19 3.34-2.28 3.99a9.508 9.508 0 0 1-4.4 1.14v3.74h41.5v-3.74c-2.06 0-4.1-.38-6.02-1.14a5.645 5.645 0 0 1-2.93-3.99M624.97 90.71a25.92 25.92 0 0 0-14.57-4.48 28.224 28.224 0 0 0-16.19 4.56 27.43 27.43 0 0 0-9.85 11.23h-.32c0-3.26.12-6.35.39-9.49.14-2.07.38-4.14.73-6.18l-.98-.98-33.84 15.68 1.63 3.74c1.49-.4 3.02-.62 4.56-.65.97-.07 1.92.22 2.69.81.6.54.9 1.63.9 3.25v73.9c.08 3.02-.14 6.05-.65 9.03-.43 2.01-1.19 3.34-2.28 3.99a9.75 9.75 0 0 1-4.39 1.14V200h43.12v-3.74c-2.46.01-4.9-.38-7.24-1.14a5.465 5.465 0 0 1-3.33-3.99c-.64-2.97-.91-6-.81-9.03v-16.76c1.52.22 3.17.38 4.96.49s3.77.16 5.94.16c5.18-.03 10.33-.8 15.3-2.28 5.21-1.52 10.1-4.01 14.4-7.32 4.5-3.5 8.15-7.98 10.66-13.1 2.71-5.37 4.07-11.96 4.07-19.78 0-7.81-1.36-14.49-4.07-20.02-2.4-5.16-6.14-9.57-10.83-12.78m-16.03 59.9c-3.26 5.04-7.27 7.57-12.04 7.57-5.21 0-9.33-2.39-12.37-7.16v-43.3c1.7-1.75 3.75-3.11 6.02-3.99 2.03-.79 4.18-1.2 6.35-1.22 4.77 0 8.79 2.31 12.04 6.92 3.26 4.61 4.88 11.64 4.88 21.08 0 8.35-1.63 15.06-4.88 20.1M541.31 150.61c-1.17.45-2.41.7-3.66.73-1.95 0-3.25-.68-3.91-2.03-.74-1.83-1.07-3.81-.98-5.78v-35.48c0-12.25-7.16-19.5-19.95-21.8-8.97-1.62-19.39-1.04-28.28.57-5.06.92-10.37 2.79-13.57 5.49v23.95h3.71c.91-5.48 3.36-10.58 7.07-14.72a16.43 16.43 0 0 1 12.94-5.86c3.8 0 6.75 1.11 8.87 3.34 2.12 2.23 3.17 5.89 3.17 10.99v8.63c-13.78 3.69-23.95 7.76-30.52 12.21s-9.85 10.25-9.85 17.42c-.06 4.5 1.47 8.88 4.31 12.36 2.87 3.58 7.29 5.37 13.27 5.37 4.5-.01 8.92-1.16 12.86-3.34 4.18-2.27 7.62-5.69 9.93-9.85h.33c.95 3.66 3.1 6.9 6.1 9.2 2.87 2.12 6.97 3.17 12.29 3.17 4.71.08 9.34-1.19 13.35-3.66 4.15-2.73 7.43-6.6 9.44-11.15l-2.6-2.6c-1.24 1.22-2.7 2.19-4.32 2.84m-34.58-4.31a20.156 20.156 0 0 1-4.31 3.5 10.786 10.786 0 0 1-5.78 1.54c-2.11.12-4.16-.75-5.53-2.36a8.728 8.728 0 0 1-1.95-5.78c.09-1.95.5-3.88 1.22-5.7 1.09-2.66 2.82-5.01 5.05-6.84 2.55-2.28 6.32-4.12 11.31-5.53l-.01 21.17zM440.68 91.63c-4.8 1.93-9.07 4.75-11.91 9.87h-.33c-.02-2.98.11-5.96.41-8.92.13-2.13.37-4.25.73-6.35l-.98-.98-33.85 15.79 1.63 3.74c1.49-.4 3.02-.62 4.56-.65.97-.07 1.92.22 2.69.82.59.54.89 1.63.9 3.25v37.44c.08 3.03-.14 6.05-.65 9.03-.43 2.01-1.19 3.34-2.28 3.99a9.508 9.508 0 0 1-4.4 1.14v3.74h43.13v-3.74c-2.46.01-4.9-.38-7.24-1.14a5.478 5.478 0 0 1-3.34-3.99c-.64-2.97-.91-6-.82-9.03v-36.29a20.79 20.79 0 0 1 7.16-3.99c2.49-.72 5.06-1.08 7.65-1.06 2.42.01 4.78.68 6.84 1.95 2.17 1.3 3.71 5.12 4.48 10h4.1V92.3c-3.86-3.27-12.55-3.05-18.48-.67M344.13 115.53c2.68.05 5.32.57 7.81 1.55 1.73.81 2.9 2.6 3.5 5.37.72 4.38 1.02 8.82.9 13.26 0 3.8-.04 6.29-.2 9.22-.16 2.93-.39 4.51-1.58 6.47-1.63 2.71-4.43 4-7.41 4.59-2.7.57-5.46.87-8.22.9-6.29 0-12.7-1.98-16.81-5.14-5.27-4.05-9.38-11.35-12.04-19.92a88.707 88.707 0 0 1-3.51-25.45c0-14.54 4.01-24.17 9.38-31.43 5.46-7.37 14.61-11.25 25-11.89 4.13-.21 8.27.21 12.28 1.25 3.63 1.12 7.4 2.65 10.43 6.07 3.03 3.42 4.67 7.11 6.85 13.4h3.74v-24.9a90.512 90.512 0 0 0-14.97-4.23 87.034 87.034 0 0 0-17.41-1.79 72.942 72.942 0 0 0-23.85 3.82 59.107 59.107 0 0 0-19.69 11.23 51.961 51.961 0 0 0-13.43 18.31 60.772 60.772 0 0 0-4.88 25.07c0 10.96 2.39 20.57 7.16 28.81 4.6 8.07 11.36 14.7 19.53 19.12a56.8 56.8 0 0 0 27.67 6.76c7.53.11 15.02-.97 22.22-3.18 5.71-1.74 11.2-4.14 16.36-7.16a53.22 53.22 0 0 0 9.11-6.59 44.7 44.7 0 0 1-1.14-8.14c-.11-2.61-.16-5.37-.16-8.3v-9.44c0-2.82.3-4.77.9-5.86a3.624 3.624 0 0 1 3.17-1.79v-3.74h-40.7v3.75zM231.18 218.98l-.07-.69c-.86-9.39-11.15-121.38-11.18-121.86-.23-2.84-1.07-5.6-2.45-8.09-.03-.09-.07-.17-.11-.25l-.06-.15-.03.03-.02-.01.04-.02-11.8-20.44L172.31 10c-3.58-6.19-10.18-10-17.33-10H64.99a20.01 20.01 0 0 0-17.32 10l-45 77.93a20.013 20.013 0 0 0 0 20l45 77.93c3.57 6.19 10.17 10 17.32 10h89.99a19.96 19.96 0 0 0 10.85-3.32l38.59 27.68a86.142 86.142 0 0 0-21.47-3.83c-18.11-.87-71.2-.28-131.42 4.63-24.71 2.01-36.39 7.88-35.03 9.03 3.49 2.98 7.62 4.16 28.2 4.08 18.32-.06 71.65 1.91 87.76 2.9 11.41.71 23.41 2.88 32.04 2.97 9.2-.12 18.37-.82 27.48-2.1 13.74-1.89 31.96-5.7 36.15-10.77a9.951 9.951 0 0 0 3.05-8.15zM62.49 24.32a9.603 9.603 0 0 1 7.5-4.33h79.99c3.04.17 5.81 1.77 7.49 4.31l33.26 57.61c-4.99 5.2-9.32 11-12.89 17.26l-24.77 2.75L138.3 122c-7.21-.04-14.4.82-21.4 2.54L60.77 27.31l1.72-2.99zm7.5 151.54a9.603 9.603 0 0 1-7.5-4.33l-40-69.27a9.637 9.637 0 0 1 0-8.66l26.73-46.28 59.6 103.24.04-.02a9.797 9.797 0 0 0 2.79 3.15l30.93 22.18-72.59-.01zm116.76 7.07-57.9-41.53a91.5 91.5 0 0 1 19.45-2.09l14.77-20.07 24.77-2.75a91.472 91.472 0 0 1 11.52-15.79l7.03 70.9c-8.32-.89-16.26 3.69-19.64 11.33zM81.64 154.71c1.49 2.33.8 5.42-1.52 6.91-2.33 1.49-5.42.8-6.91-1.52-.08-.12-.15-.25-.22-.38l-35-60.61a5.008 5.008 0 0 1 1.52-6.91c2.33-1.49 5.42-.8 6.91 1.52.08.12.15.25.22.38l35 60.61z\"/></svg>";


var $a8b75979ed12b1b2$exports = {};
$a8b75979ed12b1b2$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M2 5h8v2H2z\"/><path d=\"M5 2h2v8H5z\"/></svg>";


var $ea72a9bb4bc896f4$exports = {};
$ea72a9bb4bc896f4$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M5.19 11.83.18 7.44l1.64-1.88 2.99 2.61L10 1.25l2 1.5z\"/></svg>";


var $0604f2bc7d89b5a4$exports = {};
$0604f2bc7d89b5a4$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M10 3 9 2 6 5 3 2 2 3l3 3-3 3 1 1 3-3 3 3 1-1-3-3z\"/></svg>";


var $3bc12b4d003ab9bb$exports = {};
$3bc12b4d003ab9bb$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M6 1c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-1C2.68 0 0 2.69 0 6s2.68 6 6 6 6-2.68 6-6-2.69-6-6-6Zm2.47 8.47c.2-.2.2-.51 0-.71L6.5 5.79V3c0-.28-.22-.5-.5-.5s-.5.22-.5.5v3c0 .13.05.26.15.35l2.12 2.12a.485.485 0 0 0 .7 0z\"/></svg>";


var $442e5c12e9234e87$exports = {};
$442e5c12e9234e87$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M6 7 2.5 4v2L6 9l3.5-3V4z\"/></svg>";


var $a92bb5322ede3c62$exports = {};
$a92bb5322ede3c62$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M11.4 1.8 10.2.6C9.9.2 9.3 0 8.8 0s-1 .2-1.4.6L1.6 6.4c-.4.4-.7 1-.8 1.5L0 12l4.1-.8c.6-.1 1.1-.4 1.5-.8l5.8-5.8c.8-.8.8-2.1 0-2.8zM4.9 9.7c-.3.3-.6.5-1 .5h-.1l-2-2v-.1c.1-.4.3-.7.5-1l4-4 2.6 2.6-4 4zm5.8-5.8-1.1 1-2.5-2.5 1.1-1.1c.1-.2.4-.3.6-.3s.5.1.7.3l1.2 1.2c.4.4.4 1 0 1.4z\"/></svg>";


var $6e9004364e658539$exports = {};
$6e9004364e658539$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"/>";


var $7502ae824856c4ca$exports = {};
$7502ae824856c4ca$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M6 1c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-1C2.69 0 0 2.69 0 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6m2.83 3.88-.71-.71L6 5.29 3.88 3.17l-.71.71L5.29 6 3.17 8.12l.71.71L6 6.71l2.12 2.12.71-.71L6.71 6l2.12-2.12z\"/></svg>";


var $ab2878f016c0f0c4$exports = {};
$ab2878f016c0f0c4$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M11 8v3H8v1h4V8zM1 1h3V0H0v4h1zM4 11H1V8H0v4h4zM11 1v3h1V0H8v1z\"/></svg>";


var $9838db1a8548f9cb$exports = {};
$9838db1a8548f9cb$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M9 12V9h3V8H8v4zM3 3H0v1h4V0H3zM0 9h3v3h1V8H0zM9 3V0H8v4h4V3z\"/></svg>";


var $a69c981fb84a9d1b$exports = {};
$a69c981fb84a9d1b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M1 1h1v10H1zM4 1h1v10H4zM7 1h1v10H7zM10 1h1v10h-1z\"/><path d=\"M1 1h10v1H1zM1 4h10v1H1zM1 7h10v1H1zM1 10h10v1H1z\"/></svg>";


var $734513808e7994de$exports = {};
$734513808e7994de$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M6 0C2.69 0 0 2.69 0 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm.35 11A1.15 1.15 0 1 1 7.5 9.85c-.01.64-.52 1.15-1.15 1.15zm2.24-5.96c-.39.72-1.38.94-1.38 1.86v.99h-1.8V6.9c0-1.89 1.88-1.62 1.88-3.12 0-1.41-2.16-1.88-2.77.15L3 3.46C4.25-.96 10.66 1.2 8.59 5.04z\"/></svg>";


var $dbd989373cafb4e6$exports = {};
$dbd989373cafb4e6$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"m6 11 4-5H7V1H5v5H2z\"/></svg>";


var $66a13a440c22a944$exports = {};
$66a13a440c22a944$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"m1 6 5 4V7h5V5H6V2z\"/></svg>";


var $3c99e60d233ae733$exports = {};
$3c99e60d233ae733$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M11 6 6 2v3H1v2h5v3z\"/></svg>";


var $d00433192978bdb8$exports = {};
$d00433192978bdb8$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M6 1 2 6h3v5h2V6h3z\"/></svg>";


var $d3ac664d7594973e$exports = {};
$d3ac664d7594973e$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M11 3v6H4.41l-3-3 3-3H11m1-1H4L0 6l4 4h8V2z\"/><path class=\"bright\" d=\"m9.35 4.35-.7-.7L7 5.29 5.35 3.65l-.7.7L6.29 6 4.65 7.65l.7.7L7 6.71l1.65 1.64.7-.7L7.71 6z\"/></svg>";


var $99926fb9c7322980$exports = {};
$99926fb9c7322980$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M9 7H8V5h1c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2v1H5V3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2h1v2H3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2V8h2v1c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zM8 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1H8V3zM3 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1v1H3zm1 5c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1h1v1zm1-2V5h2v2H5zm4 3c-.55 0-1-.45-1-1V8h1c.55 0 1 .45 1 1s-.45 1-1 1z\"/></svg>";


var $2094fdc908f5406d$exports = {};
$2094fdc908f5406d$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M6 1 1 5l.6.8L6 2.3l4.4 3.5.6-.8z\"/></svg>";


var $ee6e4dda39f322bc$exports = {};
$ee6e4dda39f322bc$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M11 3v2c0 .55-.45 1-1 1H3V4L0 6.5 3 9V7h7c1.1 0 2-.9 2-2V3h-1z\"/></svg>";


var $f8da9817da7666a1$exports = {};
$f8da9817da7666a1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M6 3h5v1H6zM11 9H5.72l-3-5H1V3h2.28l3 5H11z\"/></svg>";


var $76331f1e556007f8$exports = {};
$76331f1e556007f8$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M6 0 0 6h3v6h6V6h3L6 0zm2 5v6H4V5H2.41L6 1.41 9.59 5H8z\"/></svg>";


var $e879f76f1ef7bf42$exports = {};
$e879f76f1ef7bf42$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M11 8v1c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V8H0v1c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V8h-1z\"/></svg>";


var $d187d177e2aa7809$exports = {};
$d187d177e2aa7809$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path class=\"bright\" d=\"M4 3V1L1 3.5 4 6V4h8V3zM0 1v5h1V1zM8 8H0v1h8v2l3-2.5L8 6zM11 8.5V11h1V6h-1z\"/></svg>";


var $a9e1311559e5db9c$exports = {};
$a9e1311559e5db9c$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M12 1.63C11.94.7 11.17 0 10.25 0H4C2.9 0 2 .9 2 2v6.5H0v1.75c0 .92.7 1.69 1.62 1.75h6.12c.95-.05 1.7-.8 1.75-1.75V4h2.5V1.63ZM1.63 11a.736.736 0 0 1-.62-.75V9.5h5v.75c0 .26.07.52.19.75H1.63Zm6.12 0a.87.87 0 0 1-.75-.75V8.5H3V2c0-.55.45-1 1-1h4.71c-.14.31-.21.66-.21 1v8.25a.87.87 0 0 1-.75.75M11 3H9.5V2c0-.3.07-1 .75-1 .37 0 .69.26.75.62v1.37Zm-3.75-.5h-3c-.14 0-.25.11-.25.25s.11.25.25.25h3c.14 0 .25-.11.25-.25s-.11-.25-.25-.25m0 2h-3c-.14 0-.25.11-.25.25s.11.25.25.25h3c.14 0 .25-.11.25-.25s-.11-.25-.25-.25m0 2h-3c-.14 0-.25.11-.25.25s.11.25.25.25h3c.14 0 .25-.11.25-.25s-.11-.25-.25-.25z\"/></svg>";


var $92dcb8ff452ce076$exports = {};
$92dcb8ff452ce076$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M4.68 9.32 4 10c-.53.53-1.47.53-2 0-.27-.27-.41-.62-.41-1s.14-.73.41-1l2.5-2.5c.27-.27.62-.41 1-.41s.73.15 1 .41l1-1c-1.07-1.07-2.93-1.07-4 0L1 7C.47 7.53.17 8.24.17 9s.3 1.47.83 2 1.24.83 2 .83 1.47-.3 2-.83l1.27-1.27c-.56-.03-1.1-.17-1.59-.41z\"/><path d=\"M11 1C9.93-.07 8.07-.07 7 1L5.7 2.3c.56.03 1.11.16 1.61.39L8 2c.27-.27.62-.41 1-.41s.73.14 1 .41.41.62.41 1-.14.73-.41 1L7.5 6.5c-.53.53-1.47.53-2 0l-1 1c.53.53 1.24.83 2 .83s1.47-.29 2-.83L11 5c.53-.53.83-1.24.83-2s-.3-1.47-.83-2z\"/></svg>";


var $f19a2eae8c6a4da1$exports = {};
$f19a2eae8c6a4da1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M0 0h3v3H0zM0 9h3v3H0zM0 4h1v4H0zM4 11h4v1H4zM11 4h1v4h-1zM9 0h3v3H9zM9 9h3v3H9zM4 0h4v1H4z\"/></svg>";


var $8d85eaea3af9e3fd$exports = {};
$8d85eaea3af9e3fd$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M2 5h8v2H2z\"/></svg>";


var $da042601de73ff57$exports = {};
$da042601de73ff57$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M7.5 7.5 6 9c-.83.83-2.17.83-3 0s-.83-2.17 0-3l1.5-1.5L3 3 1.5 4.5c-1.66 1.66-1.66 4.34 0 6s4.34 1.66 6 0L9 9 7.5 7.5zM4 2 5.5.5 7 2 5.5 3.5zM8.5 6.5 10 5l1.5 1.5L10 8zM12 0 8.29 1.21l1 2L7 4v1l3.71-1.21-1-2L12 1z\"/></svg>";


var $abb962379537d26a$exports = {};
$abb962379537d26a$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M7 3 4 0 1 3h2v4h2V3h2zm1 9 3-3H9V5H7v4H5l3 3z\"/></svg>";


var $23c7167183df148f$exports = {};
$23c7167183df148f$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><circle cx=\"6\" cy=\"2\" r=\"1.5\"/><circle cx=\"6\" cy=\"6\" r=\"1.5\"/><circle cx=\"6\" cy=\"10\" r=\"1.5\"/></svg>";


var $bf7294295c7a5604$exports = {};
$bf7294295c7a5604$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M11.9 9.79 6.96.58c-.41-.77-1.5-.77-1.92 0L.1 9.79c-.29.54.1 1.21.71 1.21H11.2c.6 0 .99-.67.7-1.21zm-5-7.29L6.67 7H5.33L5.1 2.5h1.8zM6 10.3a1.15 1.15 0 1 1 1.15-1.15c0 .63-.52 1.15-1.15 1.15z\"/></svg>";


var $adafe3d9b1c640c2$exports = {};
$adafe3d9b1c640c2$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"m11 1.7-.7-.7L6 5.3 1.7 1l-.7.7L5.3 6 1 10.3l.7.7L6 6.7l4.3 4.3.7-.7L6.7 6z\"/></svg>";


var $108207fe31c21b92$exports = {};
$108207fe31c21b92$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M11 1v10H1V1h10zm-1 1H2v8h8V2z\"/></svg>";


var $25378bdbf9950db8$exports = {};
$25378bdbf9950db8$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M1 5h10v1H1z\"/></svg>";


var $3d84be20c2b1927c$exports = {};
$3d84be20c2b1927c$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M11 9H9v2H1V3h2V1h8v8zM8 4H2v6h6V4zm2-2H4v1h5v5h1V2z\"/></svg>";


var $1f9606a8a14ac54b$exports = {};
$1f9606a8a14ac54b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M10 4c0-2.2-1.8-4-4-4S2 1.8 2 4c0 .7.2 1.4.6 2-.4.6-.6 1.3-.6 2 0 2.2 1.8 4 4 4s4-1.8 4-4c0-.7-.2-1.4-.6-2 .4-.6.6-1.3.6-2zM6 1c1.7 0 3 1.3 3 3S7.7 7 6 7 3 5.7 3 4s1.3-3 3-3z\"/></svg>";


var $278ebe6cf345dedb$exports = {};
$278ebe6cf345dedb$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M0 15h16v1H0zM9 6h5v7H9zM2 0h5v13H2z\"/></svg>";


var $8860ee1ac33cc3ad$exports = {};
$8860ee1ac33cc3ad$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 0h1v16H8z\"/><path d=\"M5 2h7v5H5zM2 9h13v5H2z\"/></svg>";


var $8db7e000fc4c5879$exports = {};
$8db7e000fc4c5879$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M0 0h1v16H0zM3 2h7v5H3zM3 9h13v5H3z\"/></svg>";


var $cf46e7246a378e1f$exports = {};
$cf46e7246a378e1f$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15 0h1v16h-1zM6 2h7v5H6zM0 9h13v5H0z\"/></svg>";


var $24a70cb1e6e21b18$exports = {};
$24a70cb1e6e21b18$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M0 0h16v1H0zM9 3h5v7H9zM2 3h5v13H2z\"/></svg>";


var $0ea51695a25ef8a4$exports = {};
$0ea51695a25ef8a4$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M0 8h16v1H0z\"/><path d=\"M9 5h5v7H9zM2 2h5v13H2z\"/></svg>";


var $eafe7a4fe6392749$exports = {};
$eafe7a4fe6392749$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12 4v8H4v4h12V4z\"/><path d=\"M12 4V0H0v12h4V4z\"/></svg>";


var $4966bb035dcd1930$exports = {};
$4966bb035dcd1930$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12 4V0H0v12h4v4h12V4h-4zM1 11V1h10v3H4v7H1zm14 4H5v-3h7V5h3v10z\"/></svg>";


var $e1d33367affd4739$exports = {};
$e1d33367affd4739$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12 4V0H0v12h4v4h12V4h-4zM1 1h10v10H1V1z\"/></svg>";


var $23cf378ea505fb4d$exports = {};
$23cf378ea505fb4d$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12 4V0H0v12h4v4h12V4h-4zm3 11H5V5h10v10z\"/></svg>";


var $28e0dc18751953f7$exports = {};
$28e0dc18751953f7$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12 4V0H0v12h4v4h12V4z\"/></svg>";


var $8c637eed31eb8426$exports = {};
$8c637eed31eb8426$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M7.19 13.83 2.18 9.44l1.64-1.88 2.99 2.61L12 3.25l2 1.5z\"/><path d=\"M14 16H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2ZM2 1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H2Z\"/></svg>";


var $d20a6d60f8c5a22e$exports = {};
$d20a6d60f8c5a22e$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M14 16H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2ZM2 1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H2Z\"/></svg>";


var $a9e21fc72c2d3e82$exports = {};
$a9e21fc72c2d3e82$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M9 5 5 9v7h9V5H9zm4 10H6v-5h4V6h3v9z\"/><path d=\"M5 1 2 4v9h2v-1H3V5h3V2h5v2h1V1z\"/></svg>";


var $b4b83b30ae59d280$exports = {};
$b4b83b30ae59d280$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M2 1h6v2H2V1Zm0 12h7v2H2v-2ZM1 5h3v2H1V5ZM0 9h5v2H0V9Zm7 0h4v2H7V9Zm3-8h4v2h-4V1Zm1 12h3v2h-3v-2ZM6 5h9v2H6V5Zm7 4h3v2h-3V9z\"/></svg>";


var $e4229ea672c0725a$exports = {};
$e4229ea672c0725a$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8.2 7.2 4.5 4.4l-.8 1c-.7.8-.5 2.1.4 2.8l.9.7c-1.1 1.1-3.3 3.2-3.7 3.7-.5.7-.4 1.6.3 2.1s1.6.4 2.1-.3c.4-.5 1.9-3.2 2.7-4.5l.9.7c.9.7 2.1.5 2.8-.4l.8-1-2.7-2zM11.7 8.1 16 2.5c-5.6.4-7.9-2.8-9.6-.6l-1 1.3 6.3 4.9z\"/></svg>";


var $ebff662b776a2657$exports = {};
$ebff662b776a2657$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15.2 2.3 13.6.7c-.5-.4-1.1-.7-1.8-.7s-1.4.3-1.9.8L2.2 8.5c-.6.6-.9 1.3-1.1 2L0 16l5.5-1.1c.8-.2 1.5-.5 2-1.1l7.7-7.7c1.1-1 1.1-2.7 0-3.8zM6.6 12.9c-.4.4-.8.6-1.4.7h-.1l-2.7-2.7v-.1c.1-.5.4-1 .7-1.4l5.3-5.3 3.4 3.4-5.2 5.4zm7.7-7.7-1.4 1.4-3.5-3.5 1.4-1.4c.3-.3.6-.4.9-.4s.7.1.9.4l1.6 1.6c.6.5.6 1.4.1 1.9z\"/></svg>";


var $8883597bd20b755f$exports = {};
$8883597bd20b755f$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"m13.2 5.2 1.7-1.7c.6-.6.7-1.6.1-2.3l-.1-.1c-.7-.7-1.7-.7-2.4 0l-1.7 1.7-.7-.7c-.2-.3-.7-.3-.9 0l-1 1 4.7 4.7 1-1c.3-.2.3-.7 0-.9l-.7-.7zM10.4 6.6l-6.5 6.5c-.1.1-.4.1-.6.1-.2 0-.5.1-.7.1.1-.3.1-.5.1-.7s.1-.5.1-.6l6.5-6.5-.6-.6-6.5 6.5c-.6.6-.2 1.9-1.1 2.9l.6.6c.9-.9 2.3-.5 2.9-1.1l6.5-6.5-.7-.7z\"/></svg>";


var $3cb49211dea4a3f8$exports = {};
$3cb49211dea4a3f8$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 4c3.5 0 5.9 2.8 6.8 4-.9 1.2-3.3 4-6.8 4S2.1 9.2 1.2 8C2.1 6.8 4.5 4 8 4m0-1C3 3 0 8 0 8s3 5 8 5 8-5 8-5-3-5-8-5z\"/></svg>";


var $bb3c35b5a46621c5$exports = {};
$bb3c35b5a46621c5$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 3C3 3 0 8 0 8s3 5 8 5 8-5 8-5-3-5-8-5zm0 9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z\"/><circle cx=\"9\" cy=\"7\" r=\"1.2\"/></svg>";


var $7b16567ceb69d1e2$exports = {};
$7b16567ceb69d1e2$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M7 0 2 5v11h12V0H7zm6 15H3V6h5V1h5v14z\"/></svg>";


var $1cd9328c42cf5c9a$exports = {};
$1cd9328c42cf5c9a$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15 4.6v6.8l-4-2V6.6l4-2M16 3l-6 3v4l6 3V3zM5 10l-5 3V3l5 3zM7 13h1v2H7zM7 9h1v2H7zM7 5h1v2H7zM7 1h1v2H7z\"/></svg>";


var $fc3eab1398305d7a$exports = {};
$fc3eab1398305d7a$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"m9.4 11 2 4H4.6l2-4h2.8m.6-1H6l-3 6h10l-3-6zM6 5 3 0h10l-3 5zM1 7h2v1H1zM5 7h2v1H5zM9 7h2v1H9zM13 7h2v1h-2z\"/></svg>";


var $bbb349e9ba5791c0$exports = {};
$bbb349e9ba5791c0$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 13H2c-.55 0-1-.45-1-1V6h5.42l1-1H15v7c0 .55-.45 1-1 1zM6 2H2c-.55 0-1 .45-1 1v2h5l1-1h8c0-.55-.45-1-1-1H7L6 2z\"/></svg>";


var $0f37ea84cef4b2c0$exports = {};
$0f37ea84cef4b2c0$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M5.15 10.65 2.82 6.61c-.1-.16-.05-.36.1-.46.16-.1.36-.05.46.1.01 0 .01.01.02.02l2.33 4.04c.1.16.05.36-.1.46-.16.1-.36.05-.46-.1l-.02-.02M15.7 14.6c.02.2-.06.4-.2.54-.28.34-1.49.59-2.41.72-.61.09-1.22.13-1.83.14-.58-.01-1.38-.15-2.14-.2-1.07-.07-4.63-.2-5.85-.19-1.37.01-1.65-.07-1.88-.27-.09-.08.69-.47 2.34-.6 4.01-.33 7.55-.37 8.76-.31.49.02.97.11 1.43.26l-2.57-1.85c-.21.14-.47.22-.72.22h-6a1.3 1.3 0 0 1-1.15-.67l-3-5.2c-.24-.41-.24-.92 0-1.33l3-5.2C3.7.25 4.14 0 4.62 0h6c.48 0 .92.25 1.16.67l2.21 3.83.79 1.36v.01c0 .01.01.01.01.02.09.17.15.35.16.54 0 .03.69 7.5.75 8.12v.05zM4.34 1.82 8.08 8.3c.47-.11.95-.17 1.43-.17l.98-1.34 1.65-.18c.24-.42.53-.8.86-1.15l-2.22-3.84a.641.641 0 0 0-.5-.29H4.95c-.2.01-.39.12-.5.29l-.11.2zm5.45 9.9-2.06-1.48a.756.756 0 0 1-.19-.21L3.57 3.15 1.79 6.24c-.09.18-.09.4 0 .58l2.67 4.62c.11.17.3.28.5.29h4.83zm4.26-.28-.47-4.73c-.29.32-.55.68-.77 1.05l-1.65.18-.98 1.34c-.44 0-.87.05-1.3.14l3.86 2.77c.22-.5.75-.81 1.31-.75\"/></svg>";


var $6360e977e364d34b$exports = {};
$6360e977e364d34b$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m6 9.5 4-2.4c0 .5.5.9 1 .9h3c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-3c-.6 0-1 .4-1 1H6c0-.6-.4-1-1-1H2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V4h4v1.9L5.8 8.4C5.6 8.2 5.3 8 5 8H2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h3c.4 0 .8-.2.9-.6L10 13v1c0 .6.4 1 1 1h3c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-3c-.5 0-1 .4-1 1l-4-1.6v-.9zM11 3h3v4h-3V3zM5 5H2V3h3v2zm0 6H2V9h3v2zm6 1h3v2h-3v-2z\"/></svg>";


var $e4f9c227cc246bbe$exports = {};
$e4f9c227cc246bbe$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m6 9.5 4-2.4c0 .5.5.9 1 .9h3c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-3c-.6 0-1 .4-1 1H6c0-.6-.4-1-1-1H2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V4h4v1.9L5.8 8.4C5.6 8.2 5.3 8 5 8H2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h3c.4 0 .8-.2.9-.6L10 13v1c0 .6.4 1 1 1h3c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-3c-.5 0-1 .4-1 1l-4-1.6v-.9z\"/></svg>";


var $a73c21e4b94c93ac$exports = {};
$a73c21e4b94c93ac$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M6 7H2c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1ZM2 2v4h4V2H2Zm4 13H2c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm-4-5v4h4v-4H2Zm12-3h-4c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm-4-5v4h4V2h-4Zm4 13h-4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm-4-5v4h4v-4h-4z\"/></svg>";


var $5190a60712de730a$exports = {};
$5190a60712de730a$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"4\" cy=\"6\" r=\"1.5\"/><path d=\"m14 6-2-2-1-1H1v10h14V7l-1-1zm-3-2v3h3v4L9.5 6.5l-3 4-2-2L2 12V4h9z\"/></svg>";


var $9476b05b16ec0caa$exports = {};
$9476b05b16ec0caa$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 2v7.3L4.7 14H16V2H0zm15 11H6V9H1V3h14v10z\"/></svg>";


var $8ae8f6afe3d9fc28$exports = {};
$8ae8f6afe3d9fc28$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M16 2c0-1.1-.9-2-2-2H5.5A2.5 2.5 0 0 0 3 2.5V12H0v2c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V5h3V2ZM2 15c-.55 0-1-.45-1-1v-1h8v1c0 .35.09.7.27 1H2Zm9 0c-.55 0-1-.45-1-1v-2H4V2.5C4 1.67 4.67 1 5.5 1h6.82c-.22.47-.33.98-.32 1.5V14c0 .55-.45 1-1 1m4-11h-2V2.5C13 1 13.75 1 14 1c.55 0 1 .45 1 1v2Zm-4.5-1h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5m0 3h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5m0 3h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z\"/></svg>";


var $5aa5d5b0d569ba57$exports = {};
$5aa5d5b0d569ba57$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 4H5v1h7v9h1V4z\"/><path d=\"M4 11V2H3v10h8v-1H4zM14 11h1v1h-1zM1 4h1v1H1z\"/><path d=\"M5 6h6v4H5z\"/></svg>";


var $346598c71833ec76$exports = {};
$346598c71833ec76$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.61 6.6C10.05 4.38 8.82 2.36 8 1c-.82 1.36-2.05 3.38-3.61 5.6s-1.81 4.74-.74 6.39A5.091 5.091 0 0 0 8 15c1.69.1 3.33-.66 4.35-2.01 1.07-1.65.82-4.09-.74-6.39M5.87 7.75c.49 4.67 2.95 5.74 2.95 5.74-6.56.36-2.95-5.74-2.95-5.74\"/></svg>";


var $3fd9d5e35da6382f$exports = {};
$3fd9d5e35da6382f$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.49 11.76c-.33.12-.67.22-1 .32a3.914 3.914 0 0 1-2.35 2.24c-.6.16-1.2.24-1.8.26.53.13 1.12.24 1.82.33 4.34.53 5.22-1.12 8.78-1.49 0 0-1.06-3.31-5.45-1.66zM7.79 10.64a2.093 2.093 0 0 0-2.06-1.96c-.96-.04-1.83.66-2.48 2.12-.48.93-1.28 1.65-2.25 2.03 1.47.79 3.2.99 4.81.55 1.17-.4 1.96-1.5 1.98-2.74M14.03 2.23c-.46-.5-2.68 1.25-5.11 3.49-.83.73-1.59 1.52-2.28 2.37.38.09.73.28 1.02.56.34.3.57.7.67 1.14.85-.69 1.63-1.46 2.33-2.31 2.19-2.6 3.88-4.75 3.37-5.25\"/></svg>";


var $3836b34872dbc963$exports = {};
$3836b34872dbc963$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.43 9.65C18.25 6.12 13.2.66 8.66 1.01S.83 4.86 1.62 9.34c.76 4.33 6.79 6.72 8.76 5.2 2.02-1.56-3.53-3.27.05-4.89m1.12-6.48c.59 0 1.07.47 1.08 1.06s-.47 1.07-1.06 1.07c-.59 0-1.07-.47-1.08-1.06 0-.59.47-1.07 1.06-1.07M4.06 9.91c-.59 0-1.07-.47-1.07-1.06 0-.59.47-1.07 1.06-1.07.59 0 1.07.47 1.07 1.06.01.58-.47 1.07-1.06 1.07m.76-3.4c-.59 0-1.07-.47-1.07-1.06s.47-1.07 1.06-1.07c.59 0 1.07.47 1.07 1.06.01.59-.47 1.07-1.06 1.07m3.05-2.04a1.071 1.071 0 0 1-.02-2.14c.59 0 1.07.47 1.08 1.06 0 .6-.47 1.08-1.06 1.08\"/></svg>";


var $56496e01c1ed6726$exports = {};
$56496e01c1ed6726$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 1h-1c.23.28.37.63.4 1 0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4.03-.37.17-.72.4-1H9.5c.2.29.31.64.3 1 0 .99-.81 1.8-1.8 1.8S6.2 2.99 6.2 2c.04-.35.14-.69.3-1h-.8c.2.22.31.5.3.8.11 1.1-.7 2.09-1.8 2.2 1.1.11 1.91 1.1 1.8 2.2-.1.95-.85 1.7-1.8 1.8 1.1.11 1.91 1.1 1.8 2.2-.1.95-.85 1.7-1.8 1.8.97.07 1.73.83 1.8 1.8 0 .42-.11.83-.3 1.2h.8c-.2-.29-.31-.64-.3-1v-.08c0-.94.76-1.71 1.7-1.72h.01c.99 0 1.79.81 1.79 1.8.01.36-.1.71-.3 1H11c-.23-.28-.37-.63-.4-1 0-.77.63-1.4 1.4-1.4.77 0 1.4.63 1.4 1.4-.03.37-.17.72-.4 1h1c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1m-4.2 9c0 .99-.81 1.79-1.8 1.79s-1.79-.81-1.79-1.8c.01-.99.81-1.79 1.8-1.79S9.8 9 9.8 9.99V10m0-4c0 .99-.81 1.79-1.8 1.79s-1.79-.81-1.79-1.8c.01-.99.81-1.79 1.8-1.79S9.8 5 9.8 5.99V6m3.6 4c0 .77-.63 1.4-1.4 1.4s-1.4-.63-1.4-1.4c0-.77.63-1.4 1.4-1.4.75-.02 1.38.58 1.4 1.33V10m0-4c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4 0-.77.63-1.4 1.4-1.4.75-.02 1.38.58 1.4 1.33V6M3.8 8c-.76.09-1.41.59-1.7 1.3C1.91 8.75 1.52 8.28 1 8c.52-.28.91-.75 1.1-1.3.29.71.94 1.21 1.7 1.3m0-4c-.75.12-1.39.61-1.7 1.3C1.91 4.75 1.52 4.28 1 4c.52-.28.91-.75 1.1-1.3.31.69.95 1.18 1.7 1.3m0 8c-.76.09-1.41.59-1.7 1.3-.22-.54-.61-.99-1.1-1.3.52-.28.91-.75 1.1-1.3.29.71.94 1.21 1.7 1.3\"/></svg>";


var $ffc6507a41574590$exports = {};
$ffc6507a41574590$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.6 13.6c-.1.9-.9 1.4-1.6 1.4-.5 0-1-.2-1.3-.6l2.9-.8zm-3.3-1.1c0 .3 0 .6.1 1v.1l3.3-.8c0-.5.1-.8.1-1.1l-3.5.8zM8 2c2.3 0 4.1 1.9 4.1 4.2 0 2.5-1.5 3.1-2.1 4.5v.1l-3.8.9c-.1-.4-.2-.7-.3-1-.5-1.4-2-2-2-4.5C3.9 3.9 5.7 2 8 2zm.2 6.9c-.2-.2-.9.3-1.1.6-.2.3-.2.7.1 1 .5.1.9 0 1.2-.4.2-.4.2-.9-.2-1.2zm0-.9c.3-.7 1.2-4.7 1.2-4.7-1.2-.6-2.3.9-2.3.9-.1 1.3 0 2.6.1 3.9.4.1.7 0 1-.1z\"/></svg>";


var $3c3a2f4f803db9cc$exports = {};
$3c3a2f4f803db9cc$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.08 4.08 8 3.5l-1.92-.58L5.5 1l-.58 1.92L3 3.5l1.92.58L5.5 6zM9.9 12.9l1.6-.4-1.6-.4-.4-1.6-.4 1.6-1.6.4 1.6.4.4 1.6zM12.98 9.98 15 9.5l-2.02-.48L12.5 7l-.48 2.02L10 9.5l2.02.48.48 2.02zM12.65 4.65l-1.29-1.29c-.2-.2-.51-.2-.71 0l-9.29 9.29c-.2.2-.2.51 0 .71l1.29 1.29c.2.2.51.2.71 0l9.29-9.29c.19-.2.19-.52 0-.71zm-.83.53L9.18 7.82c-.1.1-.26.1-.35 0l-.65-.64c-.1-.1-.1-.26 0-.35l2.65-2.65c.1-.1.26-.1.35 0l.65.65c.09.09.09.25-.01.35z\"/></svg>";


var $4da50eafa57b2315$exports = {};
$4da50eafa57b2315$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.391 5.529c-.414-.037-1.91-1.088-2.941-1.027S8.663 5.1 8 5.1s-1.418-.54-2.449-.6-2.527.99-2.941 1.027c-.721.065-.952-.246-1.61-.736a13.341 13.341 0 0 0 .459 3.454A4.249 4.249 0 0 0 4.5 11.389a3.063 3.063 0 0 0 2.2-.2A3.129 3.129 0 0 1 8 10.7a3.133 3.133 0 0 1 1.3.49 3.061 3.061 0 0 0 2.2.2 4.249 4.249 0 0 0 3.042-3.142A13.338 13.338 0 0 0 15 4.793c-.657.49-.888.8-1.609.736M6.94 9.232c-.486.438-2.157.257-2.7-.038-.652-.353-1.465-1.218-.881-1.7a2.646 2.646 0 0 1 2.876-.113c.869.719.928 1.651.707 1.85m4.823-.038c-.545.3-2.216.476-2.7.038-.221-.2-.162-1.131.707-1.85a2.645 2.645 0 0 1 2.875.113c.585.481-.229 1.346-.88 1.7\"/></svg>";


var $c5a3dd52400f1399$exports = {};
$c5a3dd52400f1399$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m8.06 4.18.87-2.19C4.14 1.43.05 6.67 2.9 11.07 1.32 7.09 4.37 2.89 8.06 4.18zM7.94 11.82l-.87 2.19c4.79.56 8.88-4.68 6.03-9.08 1.58 3.98-1.47 8.18-5.16 6.89zM10.04 2.72c-.49.75-1.37 2.46-1.8 3.3C8.16 6.01 8.08 6 8 6c-1.1 0-2 .9-2 2 0 .15.02.3.05.44-1.28 1.16-4.62 4.26-5.02 5.51-.42 1.32 3.38 1.68 4.93-.68.49-.75 1.37-2.46 1.8-3.3.08.02.16.03.24.03 1.1 0 2-.9 2-2 0-.15-.02-.3-.05-.44 1.28-1.16 4.62-4.26 5.02-5.51.42-1.33-3.38-1.69-4.93.67zM8 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z\"/></svg>";


var $81cb3a0787f47a0c$exports = {};
$81cb3a0787f47a0c$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 1H0v3h1V2h2zM15 1h-2v1h2v2h1V1zM1 14v-2H0v3h3v-1zM15 12v2h-2v1h3v-3zM11 7h2c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1h-2c-.5 0-1 .5-1 1v.5h-.2c-.7.3-1.2.8-1.9 1.3-.8.7-1.6 1.4-2.9 1.7V7c0-.5-.5-1-1-1H2c-.5 0-1 .5-1 1v2c0 .5.5 1 1 1h2c.5 0 1-.5 1-1v-.5c1.3.3 2.1 1 2.9 1.7.6.5 1.2 1 1.9 1.3l.2.1v.4c0 .5.5 1 1 1h2c.5 0 1-.5 1-1v-2c0-.5-.5-1-1-1h-2c-.5 0-1 .5-1 1v.5c-.5-.2-.9-.6-1.4-1C8 9 7.4 8.4 6.5 8c.9-.4 1.5-1 2.1-1.5.5-.4.9-.8 1.4-1V6c0 .5.5 1 1 1z\"/></svg>";


var $4d087d248b19be66$exports = {};
$4d087d248b19be66$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 2 3 6v8h10V2H7zm5 11H4V7h4V3h4v10z\"/></svg>";


var $cd26c41a56fae35b$exports = {};
$cd26c41a56fae35b$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.96 5.19a.99.99 0 0 0-1.25-.66c-.96.3-1.86.6-2.7.91V5H5v3.16c-2.36 1.31-3.56 2.32-3.65 2.4-.42.36-.46.99-.1 1.41.2.23.48.35.76.35.23 0 .46-.08.65-.24.02-.01.8-.67 2.34-1.6V11h6V7.59c1.01-.39 2.09-.78 3.29-1.15.53-.16.83-.72.67-1.25zM9 9H7V7h2v2z\"/></svg>";


var $94ec8efc41adbaba$exports = {};
$94ec8efc41adbaba$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 2v3h.5s0-2 2.29-2H7v8.79C7 12.48 6.89 13 5 13v1h6v-1c-1.89 0-2-.52-2-1.21V3h1.21c2.29 0 2.29 2 2.29 2h.5V2H3z\"/></svg>";


var $d589f8f105355e57$exports = {};
$d589f8f105355e57$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m15 12-5-3v2H6.95c-.2-.98-.97-1.75-1.95-1.95V6h2L4 1 1 6h2v3.51c-.6.46-1 1.17-1 1.99A2.5 2.5 0 0 0 4.5 14c.82 0 1.53-.4 1.99-1H10v2l5-3zm-10.5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z\"/></svg>";


var $9ae1d933a3aef234$exports = {};
$9ae1d933a3aef234$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12 1H8.72C8.38.4 7.74 0 7 0S5.62.4 5.28 1H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3v-1H2V2h2v1c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V2h2v2h1V2c0-.55-.45-1-1-1z\"/><path d=\"M10 5 6 9v7h9V5h-5zm4 10H7v-5h4V6h3v9z\"/></svg>";


var $7089a6537fdff724$exports = {};
$7089a6537fdff724$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15.9 9.6 14 2.7C13.5.8 11.5-.4 9.6.2L2.7 2C.7 2.5-.4 4.5.1 6.4L2 13.3c.5 1.9 2.5 3.1 4.4 2.5l6.9-1.9c2-.4 3.1-2.4 2.6-4.3zM2.3 5.9c-.2-.8.2-1.6 1-1.8.8-.2 1.6.3 1.8 1.1.3.7-.2 1.6-1 1.8-.8.2-1.6-.3-1.8-1.1zm3.6 7.8c-.8.2-1.6-.3-1.8-1.1-.2-.8.3-1.6 1.1-1.8.8-.2 1.6.3 1.8 1.1.2.8-.3 1.6-1.1 1.8zm2.5-4.3c-.8.3-1.6-.2-1.8-1-.3-.8.2-1.6 1-1.8.8-.2 1.6.3 1.8 1.1.3.7-.2 1.5-1 1.7zM9 4.1c-.2-.8.3-1.6 1.1-1.8.8-.2 1.6.3 1.8 1.1.2.8-.3 1.6-1.1 1.8-.7.2-1.6-.3-1.8-1.1zm3.7 7.8c-.8.2-1.6-.3-1.8-1.1-.2-.8.3-1.6 1.1-1.8.8-.2 1.6.3 1.8 1.1.1.8-.3 1.6-1.1 1.8z\"/></svg>";


var $5685f2f035db9c24$exports = {};
$5685f2f035db9c24$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"m12.6 0 2.9 5H9.7z\"/><path d=\"M2.2 8H.8C.8 4 4 .8 8 .8c2 0 3.9.8 5.3 2.3l-1 1C11.2 2.9 9.6 2.2 8 2.2 4.8 2.2 2.2 4.8 2.2 8zM8 15.2c-2 0-3.9-.8-5.3-2.3l1-1c1.1 1.2 2.6 1.9 4.3 1.9 3.2 0 5.8-2.6 5.8-5.8h1.4c0 4-3.2 7.2-7.2 7.2z\"/><path d=\"M3.4 16 .5 11h5.8z\"/></svg>";


var $15417cebad6733c2$exports = {};
$15417cebad6733c2$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 15.2C4 15.2.8 12 .8 8S4 .8 8 .8c2 0 3.9.8 5.3 2.3l-1 1C11.2 2.9 9.6 2.2 8 2.2 4.8 2.2 2.2 4.8 2.2 8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8h1.4c0 4-3.2 7.2-7.2 7.2z\"/><path d=\"m12.6 0 2.9 5H9.7z\"/></svg>";


var $bc7c6b3ee92421d9$exports = {};
$bc7c6b3ee92421d9$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M3 1H0v3h1V2h2zM15 1h-2v1h2v2h1V1zM1 14v-2H0v3h3v-1zM15 12v2h-2v1h3v-3zM12 5v6H4V5h8m1-1H3v8h10V4z\"/></svg>";


var $238b4a57c94aa574$exports = {};
$238b4a57c94aa574$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"m0 8 2.4 4.2L4.9 8z\"/><path d=\"M8.8 15.2c-1.2 0-2.5-.3-3.6-1l.7-1.2c2.8 1.6 6.3.6 7.9-2.1.8-1.3 1-2.9.6-4.4S13 3.8 11.7 3c-2.8-1.6-6.3-.7-7.9 2.1-.8 1.4-1 3.1-.5 4.6l-1.3.4c-.6-1.9-.4-4 .6-5.8C4.5 1 9-.2 12.4 1.8c1.7 1 2.9 2.5 3.4 4.4.4 1.8.2 3.7-.8 5.4-1.3 2.3-3.7 3.6-6.2 3.6z\"/></svg>";


var $be0f1cd4bfb134a9$exports = {};
$be0f1cd4bfb134a9$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M14 8c0-.3 0-.7-.1-1l1.8-1.7-1.5-2.6-2.4.7c-.5-.4-1.1-.8-1.7-1L9.5 0h-3l-.6 2.4c-.6.2-1.2.6-1.7 1l-2.4-.7L.3 5.3 2.1 7c-.1.3-.1.7-.1 1s0 .7.1 1L.3 10.7l1.5 2.6 2.4-.7c.5.4 1.1.8 1.7 1l.6 2.4h3l.6-2.4c.6-.2 1.2-.6 1.7-1l2.4.7 1.5-2.6L13.9 9c.1-.3.1-.7.1-1zm-6 3c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z\"/></svg>";


var $7e5674811eeda292$exports = {};
$7e5674811eeda292$exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 6v7c0 .5-.4 1-.9 1H4.9c-.5 0-.9-.5-.9-1V6h7zm1-1H3v8c0 1.1.8 1.9 1.8 2h5.3c1-.1 1.8-1 1.8-2V5zM12 3h-2c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2H3c-.6 0-1 .4-1 1h11c0-.6-.4-1-1-1M7 2h1c.6 0 1 .4 1 1H6c0-.6.4-1 1-1\"/><path d=\"M6 12.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5s.5.2.5.5v5zM8 12.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5s.5.2.5.5v5zM10 12.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5s.5.2.5.5v5z\"/></svg>";


var $aae649cdd16b935e$exports = {};
$aae649cdd16b935e$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><circle cx=\"8\" cy=\"8\" r=\"8\"/></svg>";


var $66116af55dae6a6c$exports = {};
$66116af55dae6a6c$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7m0-1C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z\"/></svg>";


var $028c5f70034f7106$exports = {};
$028c5f70034f7106$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M7 1h2v2H7zM13 4h2v2h-2zM13 7h2v2h-2zM13 10h2v2h-2zM7 13h2v2H7zM10 13h2v2h-2zM4 13h2v2H4zM1 10h2v2H1zM1 7h2v2H1zM1 4h2v2H1zM4 1h2v2H4zM10 10h2v2h-2zM4 10h2v2H4zM7 10h2v2H7zM10 7h2v2h-2zM4 7h2v2H4zM7 7h2v2H7zM10 4h2v2h-2zM4 4h2v2H4zM7 4h2v2H7zM10 1h2v2h-2z\"/></svg>";


var $3f6d7f493672ef36$exports = {};
$3f6d7f493672ef36$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15 6.06V15H9.69c-.22.36-.49.69-.79 1H16V4.46c-.29.5-.63 1.03-1 1.6zM5.57 9.4c-1.22.07-2.27 1.09-2.94 3.05C1.94 14.47 0 15.36 0 15.36c2.08.71 4.3.95 6.26.08 1.75-.78 2.38-2.35 2.22-3.76-.13-1.1-1.21-2.38-2.91-2.28zM15.42.08c-.69-.55-3.27 1.97-6.11 5.14-1 1.12-1.99 2.3-2.6 3.34.46.04.95.22 1.4.56.56.43.89.93 1.03 1.37.94-.86 1.75-1.96 2.68-3.3 2.47-3.54 4.29-6.57 3.6-7.11zM.74 11.81c.08-.24.17-.43.26-.65V1h9.52c.38-.38.72-.71 1.05-1H0v12.93c.29-.28.58-.65.74-1.12z\"/></svg>";


var $3bd906012ea828db$exports = {};
$3bd906012ea828db$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M11.85 0h-.7L0 11.15v1.7l1.5-1.5 1.08 1.07.84-.84-1.07-1.08L3.5 9.35l2.08 2.07.84-.84L4.35 8.5 5.5 7.35l1.08 1.07.84-.84L6.35 6.5 7.5 5.35l2.08 2.07.84-.84L8.35 4.5 9.5 3.35l1.08 1.07.84-.84-1.07-1.08 1.15-1.15 3.15 3.15L3.15 16h1.7L16 4.85v-.7zM14 0l2 2V0zM15 8.68V15H8.68l-1 1H16V7.68zM0 0v8.32l1-1V1h6.32l1-1z\"/></svg>";


var $8a8f1a77dbc655e8$exports = {};
$8a8f1a77dbc655e8$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15 1v1.85c.37.32.7.66 1 1.02V0H0v3.19c.24-.28.49-.55.78-.81.07-.06.15-.11.22-.17V1h14zM0 11.17v4.37l1-.66v-2.15c-.15-.28-.27-.58-.34-.89-.24-.22-.46-.45-.66-.67zM15 12.74V15H8.54c-.23.24-.41.52-.55.77l-.13.23H16v-4.11c-.3.31-.63.6-1 .85z\"/><path d=\"M2.54 10.76c-.01.49.12.96.41 1.33.35.45 1.02.93 2.29.93.03 0 .07-.01.1-.01-.15.77-.72 1.85-2.43 2.99h2.38c.4-.41.71-.81.94-1.19.87-1.57 2.19-2.48 3.72-2.54 3.31-.14 5.61-1.86 5.61-4.2 0-2.98-3.07-5.42-7.47-5.94-2.23-.26-4.46.39-5.98 1.75C1.03 4.84.44 6.02.44 7.22c0 1.35.76 2.61 2.1 3.54zm4.37 1.05-.09.06c-.04-.23-.1-.38-.12-.45-.33-.86-1.11-1.01-1.62-1.11-.15-.03-.31-.06-.45-.11l-.33-.15c.21-.3.55-.56 1-.62.85-.1 1.48.1 1.77.56.27.46.2 1.15-.16 1.82zM3.1 5c1.03-.92 2.49-1.42 4.01-1.42.27 0 .53.02.8.05 4.04.47 6.15 2.6 6.15 4.45 0 1.49-1.72 2.6-4.18 2.7-.4.02-.78.09-1.16.19.05-.63-.08-1.24-.39-1.75-.6-.97-1.78-1.43-3.22-1.26-.84.1-1.6.6-2.08 1.32-.71-.6-1.1-1.31-1.1-2.04.01-.77.43-1.58 1.17-2.24z\"/></svg>";


var $bc738c3d178138a6$exports = {};
$bc738c3d178138a6$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4.56 15.92c1.01.06 1.28.08 2.53.08 2.95 0 3.89.02 6.12-.08.23-1.32.23-2.68 0-4-.44-2.54.53-2.46 1.4-4.45C16.15 3.98 16 2.5 16 2.5c.07-.76-.48-1.43-1.24-1.51-.75.08-1.3.75-1.24 1.51a5.672 5.672 0 0 1-2.49 4.26c-2.36 1.66-5.5.45-8.39 2.83C.67 11.21.51 15.02.49 15.51c.82.19 1.65.29 2.49.32.08-1.09.35-2.16.8-3.16 0 0 .75.61.77 3.25ZM7.65 0a3.15 3.15 0 1 1 0 6.3 3.15 3.15 0 0 1 0-6.3z\"/></svg>";


var $d519bff6f355a798$exports = {};
$d519bff6f355a798$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 0C3.59 0 0 3.59 0 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Zm6.1 5h-2.39c-.26-1.33-.69-2.47-1.24-3.33 1.58.62 2.88 1.82 3.63 3.33Zm.7 3c0 .7-.11 1.37-.31 2h-2.62c.08-.64.12-1.31.12-2s-.04-1.36-.12-2h2.62c.2.63.31 1.3.31 2ZM1.2 8c0-.7.11-1.37.31-2h2.62c-.08.64-.12 1.31-.12 2s.04 1.36.12 2H1.51c-.2-.63-.31-1.3-.31-2Zm3.9 0c0-.71.06-1.37.14-2h5.52c.08.63.14 1.29.14 2s-.06 1.37-.14 2H5.24c-.08-.63-.14-1.29-.14-2Zm2.39-6.77c.17-.01.34-.03.51-.03s.34.01.51.03c.84.41 1.65 1.79 2.08 3.77H5.42c.43-1.98 1.24-3.37 2.08-3.77Zm-1.96.44c-.55.86-.98 2-1.24 3.33H1.9a6.875 6.875 0 0 1 3.63-3.33ZM1.9 11h2.39c.26 1.33.69 2.47 1.24 3.33A6.875 6.875 0 0 1 1.9 11Zm6.61 3.78c-.17.01-.34.03-.51.03s-.34-.01-.51-.03c-.84-.4-1.65-1.79-2.08-3.78h5.17c-.43 1.98-1.24 3.37-2.08 3.78Zm1.96-.44c.55-.86.98-2 1.24-3.33h2.39a6.875 6.875 0 0 1-3.63 3.33z\"/></svg>";


var $aa5ad32b524bbe33$exports = {};
$aa5ad32b524bbe33$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13 5c0-2.8-2.2-5-5-5S3 2.2 3 5c0 1.1.4 2.2 1 3-.6.8-1 1.9-1 3 0 2.8 2.2 5 5 5s5-2.2 5-5c0-1.1-.4-2.2-1-3 .6-.8 1-1.9 1-3zM8 1.4c2 0 3.6 1.6 3.6 3.6S10 8.6 8 8.6 4.4 7 4.4 5 6 1.4 8 1.4zM2 5 0 7V3l2 2zm14-2v4l-2-2 2-2z\"/></svg>";


var $24bcd77be8e15b7e$exports = {};
$24bcd77be8e15b7e$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13 5c0-2.8-2.2-5-5-5S3 2.2 3 5c0 1.1.4 2.2 1 3-.6.8-1 1.9-1 3 0 2.8 2.2 5 5 5s5-2.2 5-5c0-1.1-.4-2.2-1-3 .6-.8 1-1.9 1-3zM8 1.4c2 0 3.6 1.6 3.6 3.6S10 8.6 8 8.6 4.4 7 4.4 5 6 1.4 8 1.4zM2 11l-2 2V9l2 2zm14-2v4l-2-2 2-2z\"/></svg>";


var $73fcdeafb9c2a85c$exports = {};
$73fcdeafb9c2a85c$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"m15.7 14.2-4-4-1.5 1.5 4 4c.4.4 1.1.4 1.5 0 .4-.4.4-1.1 0-1.5z\"/><path d=\"M6.5 1.4c2.8 0 5.1 2.3 5.1 5.1s-2.3 5.1-5.1 5.1-5.1-2.3-5.1-5.1 2.3-5.1 5.1-5.1m0-1.4C2.9 0 0 2.9 0 6.5S2.9 13 6.5 13 13 10.1 13 6.5 10.1 0 6.5 0z\"/><path d=\"M3 5.8h7v1.5H3z\"/><path d=\"M5.8 3h1.5v7H5.8z\"/></svg>";


var $e6ccd6b598dada11$exports = {};
$e6ccd6b598dada11$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"m15.7 14.2-4-4-1.5 1.5 4 4c.4.4 1.1.4 1.5 0 .4-.4.4-1.1 0-1.5z\"/><path d=\"M6.5 1.4c2.8 0 5.1 2.3 5.1 5.1s-2.3 5.1-5.1 5.1-5.1-2.3-5.1-5.1 2.3-5.1 5.1-5.1m0-1.4C2.9 0 0 2.9 0 6.5S2.9 13 6.5 13 13 10.1 13 6.5 10.1 0 6.5 0z\"/><path d=\"M3 5.8h7v1.5H3z\"/></svg>";


var $c9796b2cd79166ce$exports = {};
$c9796b2cd79166ce$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"m0 6.5 2.9 5 2.8-5z\"/><path d=\"M8.2 12.6h-.6c-.9-.1-1.8-.4-2.6-.8l.7-1.2c.6.4 1.3.6 2 .6 1.3.1 2.6-.3 3.6-1.1s1.6-2 1.7-3.3c.2-2.7-1.8-5-4.4-5.3-1.3-.2-2.5.2-3.5 1.1-1 .8-1.6 2-1.7 3.3 0 .5 0 1 .1 1.5l-1.4.3c-.2-.7-.2-1.3-.2-2 .2-1.7.9-3.2 2.2-4.3C5.5.4 7.1-.1 8.8 0c3.5.3 6 3.3 5.7 6.8-.1 1.7-.9 3.2-2.2 4.3-1.2 1-2.6 1.5-4.1 1.5z\"/><path d=\"m15.8 14.4-3.3-4-1.5 1.3 3.3 4c.3.4 1 .5 1.4.1.4-.4.4-1 .1-1.4z\"/></svg>";


var $234e8d0d475d115b$exports = {};
$234e8d0d475d115b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"dim\" d=\"M8 7c0 .55-.45 1-1 1s-1-.45-1-1V4.5c0-.55.45-1 1-1s1 .45 1 1V7z\"/><path class=\"bright\" d=\"M11 16a.505.505 0 0 1-.23-.95c.1-.04 2.23-1.17 2.23-4.05V6c0-.28.22-.5.5-.5s.5.22.5.5v5c0 3.52-2.66 4.89-2.78 4.95-.07.03-.14.05-.22.05zM14.5 15a.47.47 0 0 1-.35-.15.492.492 0 0 1 0-.7c.02-.03.85-.95.85-3.15V8c0-.28.22-.5.5-.5s.5.22.5.5v3c0 2.68-1.1 3.81-1.15 3.85a.47.47 0 0 1-.35.15z\"/><path class=\"dim\" d=\"M9 2c1.1 0 2 .9 2 2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V4c0-1.1.9-2 2-2h4m0-1H5C3.35 1 2 2.35 2 4v6c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.65-1.35-3-3-3z\"/></svg>";


var $05d9dae1c28dc21d$exports = {};
$05d9dae1c28dc21d$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M6 1C4.3 1 3 2.3 3 4v4h5V1H6zm1 5v1H4s0-.6.2-1c.3-.6.8-1.1 1.3-1.4 1.1-.9.8-1.9.1-1.7-.6.1-.8.7-.7 1.2H4C3.9 2.9 4.7 2 5.8 2s1.5 1.2 1 2.3c-.4.8-1.3 1.2-1.4 1.7H7z\"/><path class=\"dim\" d=\"M10 1H9v1h1c1.1 0 2 .9 2 2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V9H3v1c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.65-1.35-3-3-3z\"/></svg>";


var $ae99bca8e748cf36$exports = {};
$ae99bca8e748cf36$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M11 16a.505.505 0 0 1-.23-.95c.1-.04 2.23-1.17 2.23-4.05V6c0-.28.22-.5.5-.5s.5.22.5.5v5c0 3.52-2.66 4.89-2.78 4.95-.07.03-.14.05-.22.05zM14.5 15a.47.47 0 0 1-.35-.15.492.492 0 0 1 0-.7c.02-.03.85-.95.85-3.15V8c0-.28.22-.5.5-.5s.5.22.5.5v3c0 2.68-1.1 3.81-1.15 3.85a.47.47 0 0 1-.35.15zM7 1H5C3.35 1 2 2.35 2 4v4h5V1z\"/><path class=\"dim\" d=\"M9 1H8v1h1c1.1 0 2 .9 2 2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V9H2v1c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.65-1.35-3-3-3z\"/></svg>";


var $673a65c4b09c2e51$exports = {};
$673a65c4b09c2e51$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M8 1H6C4.35 1 3 2.35 3 4v4h5V1z\"/><path class=\"dim\" d=\"M10 1H9v1h1c1.1 0 2 .9 2 2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V9H3v1c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.65-1.35-3-3-3z\"/></svg>";


var $4d5e9044b551bc7c$exports = {};
$4d5e9044b551bc7c$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M8 7c0 .55-.45 1-1 1s-1-.45-1-1V4.5c0-.55.45-1 1-1s1 .45 1 1V7zM11 16a.505.505 0 0 1-.23-.95c.1-.04 2.23-1.17 2.23-4.05V6c0-.28.22-.5.5-.5s.5.22.5.5v5c0 3.52-2.66 4.89-2.78 4.95-.07.03-.14.05-.22.05zM14.5 15a.47.47 0 0 1-.35-.15.492.492 0 0 1 0-.7c.02-.03.85-.95.85-3.15V8c0-.28.22-.5.5-.5s.5.22.5.5v3c0 2.68-1.1 3.81-1.15 3.85a.47.47 0 0 1-.35.15z\"/><path class=\"dim\" d=\"M9 2c1.1 0 2 .9 2 2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V4c0-1.1.9-2 2-2h4m0-1H5C3.35 1 2 2.35 2 4v6c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.65-1.35-3-3-3z\"/></svg>";


var $e904c585475bcaa2$exports = {};
$e904c585475bcaa2$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M9 7c0 .55-.45 1-1 1s-1-.45-1-1V4.5c0-.55.45-1 1-1s1 .45 1 1V7z\"/><path class=\"dim\" d=\"M10 2c1.1 0 2 .9 2 2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V4c0-1.1.9-2 2-2h4m0-1H6C4.35 1 3 2.35 3 4v6c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.65-1.35-3-3-3z\"/></svg>";


var $ff93eb72c3a8b1fb$exports = {};
$ff93eb72c3a8b1fb$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"dim\" d=\"M9 7c0 .55-.45 1-1 1s-1-.45-1-1V4.5c0-.55.45-1 1-1s1 .45 1 1V7z\"/><path class=\"dim\" d=\"M10 2c1.1 0 2 .9 2 2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V4c0-1.1.9-2 2-2h4m0-1H6C4.35 1 3 2.35 3 4v6c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.65-1.35-3-3-3z\"/></svg>";


var $426c6e65956b298f$exports = {};
$426c6e65956b298f$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M11 16a.505.505 0 0 1-.23-.95c.1-.04 2.23-1.17 2.23-4.05V6c0-.28.22-.5.5-.5s.5.22.5.5v5c0 3.52-2.66 4.89-2.78 4.95-.07.03-.14.05-.22.05zM14.5 15a.47.47 0 0 1-.35-.15.492.492 0 0 1 0-.7c.02-.03.85-.95.85-3.15V8c0-.28.22-.5.5-.5s.5.22.5.5v3c0 2.68-1.1 3.81-1.15 3.85a.47.47 0 0 1-.35.15zM7 1h2c1.65 0 3 1.35 3 3v4H7V1z\"/><path class=\"dim\" d=\"M5 1h1v1H5c-1.1 0-2 .9-2 2v6c0 2.21 1.79 4 4 4s4-1.79 4-4V9h1v1c0 2.76-2.24 5-5 5s-5-2.24-5-5V4c0-1.65 1.35-3 3-3z\"/></svg>";


var $13d3fee1d5b82cee$exports = {};
$13d3fee1d5b82cee$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M8 1h2c1.65 0 3 1.35 3 3v4H8V1z\"/><path class=\"dim\" d=\"M6 1h1v1H6c-1.1 0-2 .9-2 2v6c0 2.21 1.79 4 4 4s4-1.79 4-4V9h1v1c0 2.76-2.24 5-5 5s-5-2.24-5-5V4c0-1.65 1.35-3 3-3z\"/></svg>";


var $542899f7c9515af1$exports = {};
$542899f7c9515af1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M5.5 4 8 6l2.5-2v2L8 8 5.5 6zM5.5 0 8 2l2.5-2v2L8 4 5.5 2z\"/><path class=\"dim\" d=\"M11.5 1.42V2.7c.3.36.5.8.5 1.3v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V4c0-.5.2-.94.5-1.29V1.42C3.61 1.94 3 2.9 3 4v6c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.1-.61-2.06-1.5-2.58z\"/></svg>";


var $580544b3c267db0f$exports = {};
$580544b3c267db0f$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"bright\" d=\"M10.5 4 8 2 5.5 4V2L8 0l2.5 2zM10.5 8 8 6 5.5 8V6L8 4l2.5 2z\"/><path class=\"dim\" d=\"M11.5 1.42V2.7c.3.36.5.8.5 1.3v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V4c0-.5.2-.94.5-1.29V1.42C3.61 1.94 3 2.9 3 4v6c0 2.76 2.24 5 5 5s5-2.24 5-5V4c0-1.1-.61-2.06-1.5-2.58z\"/></svg>";


var $5465d846116585b1$exports = {};
$5465d846116585b1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M20 4H7v2h11v18h2V4z\"/><path d=\"M6 18V0H4v20h13v-2H6zM21 18h3v2h-3zM0 4h3v2H0z\"/><path class=\"color-general\" d=\"m21 5 3-3-1-1-2 2v2zM17 7 7 17h2l8-8V7z\"/></svg>";


var $511cdd29efea6a94$exports = {};
$511cdd29efea6a94$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-general\" d=\"m19.78 7.76 2.49-2.49a2.5 2.5 0 1 0-3.53-3.54l-2.49 2.49-1.06-1.06a.996.996 0 0 0-1.41 0l-1.46 1.46 7.07 7.07 1.46-1.46a.996.996 0 0 0 0-1.41l-1.07-1.06z\"/><path d=\"M15.63 9.93 5.9 19.65c-.12.08-.59.15-.9.2-.32.05-.68.1-1.05.2.09-.38.15-.73.2-1.05.05-.31.12-.78.18-.88l9.74-9.74-.99-.99-9.74 9.74c-.86.86-.24 2.89-1.66 4.31l.88.88c1.41-1.41 3.45-.8 4.31-1.66l9.74-9.74-.98-.99z\"/></svg>";


var $d7314287c911f21d$exports = {};
$d7314287c911f21d$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M17.32 6.6a17.93 17.93 0 0 0-6.01-3.89l-1.2 1.2C7.52.35 6.7-.07 5.93.37c-.45.26-1.2.69 1.11 6.62L0 14.02c.88 2.24 2.2 4.29 3.89 6.01a17.93 17.93 0 0 0 6.01 3.89l11.31-11.31a17.93 17.93 0 0 0-3.89-6.01zM7.08 2.49c.42.48 1.05 1.25 1.95 2.5l-.82.82c-.51-1.34-.91-2.5-1.13-3.32zm2.47 19.66c-1.7-.79-3.26-1.86-4.6-3.17-1.31-1.35-2.38-2.9-3.17-4.61l5.86-5.86c.45 1.08.97 2.32 1.6 3.72a1.746 1.746 0 0 0 1.33 2.88c.97 0 1.75-.78 1.75-1.75 0-.95-.76-1.72-1.71-1.75-.63-1.44-1.25-2.91-1.8-4.27l2.05-2.05c.87 1.65 1.98 3.16 3.29 4.49 1.33 1.31 2.84 2.42 4.49 3.29l-9.09 9.08zM15.2 8.72a17.973 17.973 0 0 1-3.3-4.67c1.74.81 3.34 1.92 4.72 3.26 1.34 1.38 2.45 2.97 3.26 4.71-1.73-.84-3.31-1.95-4.68-3.3z\"/><path class=\"color-general\" d=\"M23.18 17.45c-.32-.82-.82-2.09-1.47-3.32-1.21 1.18-2.28 2.43-3.06 3.58-3.64 5.33.79 6.29 1.87 6.29s5.21-.02 2.66-6.55z\"/></svg>";


var $e812b536a9d192d3$exports = {};
$e812b536a9d192d3$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-general\" d=\"M13.6 14c0-.77.63-1.4 1.4-1.4.75-.02 1.38.58 1.4 1.33V14c0 .77-.63 1.4-1.4 1.4s-1.4-.63-1.4-1.4zm1.4-2.6c.77 0 1.4-.63 1.4-1.4v-.07A1.37 1.37 0 0 0 15 8.6c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4zm5 6.6c0-.55-.45-1-1-1-.54.04-.96.46-1 1 0 .55.45 1 1 1 .54-.04.96-.46 1-1zm-3.6 0c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4c.03.37.17.72.4 1h2c.23-.28.37-.63.4-1zm-3.7 0c0-.99-.8-1.8-1.79-1.8h-.01c-.94 0-1.71.77-1.7 1.72V18c-.01.36.1.71.3 1h2.9c.2-.29.31-.64.3-1zM11 11.8c.99 0 1.8-.81 1.8-1.8v-.01c0-.99-.81-1.79-1.8-1.79s-1.8.81-1.8 1.8.81 1.8 1.8 1.8zm0 4c.99 0 1.8-.81 1.8-1.8v-.01c0-.99-.81-1.79-1.8-1.79s-1.8.81-1.8 1.8.81 1.8 1.8 1.8zm8-4.8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM9.2 6a1.799 1.799 0 1 0 3.6 0c.01-.36-.1-.71-.3-1h-3c-.16.31-.26.65-.3 1zM3 5h5.7c.2.22.31.5.3.8.11 1.1-.7 2.09-1.8 2.2.95.1 1.7.85 1.8 1.8.11 1.1-.7 2.09-1.8 2.2.95.1 1.7.85 1.8 1.8.11 1.1-.7 2.09-1.8 2.2.97.07 1.73.83 1.8 1.8 0 .42-.11.83-.3 1.2H3V5zm1 3c.52.28.91.75 1.1 1.3.31-.69.95-1.18 1.7-1.3-.75-.12-1.39-.61-1.7-1.3-.19.55-.58 1.02-1.1 1.3zm0 4c.52.28.91.75 1.1 1.3.29-.71.94-1.21 1.7-1.3-.76-.09-1.41-.59-1.7-1.3-.19.55-.58 1.02-1.1 1.3zm0 4c.49.31.88.76 1.1 1.3.29-.71.94-1.21 1.7-1.3-.76-.09-1.41-.59-1.7-1.3-.19.55-.58 1.02-1.1 1.3zm9.6-10c0 .77.63 1.4 1.4 1.4s1.4-.63 1.4-1.4c-.03-.37-.17-.72-.4-1h-2c-.23.28-.37.63-.4 1zM18 6c0 .55.45 1 1 1 .54-.04.96-.46 1-1 0-.55-.45-1-1-1-.54.04-.96.46-1 1zm1 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z\"/><path d=\"M20.5 20h-17c-.83 0-1.5-.67-1.5-1.5v-13C2 4.67 2.67 4 3.5 4h17c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5zM3.5 5c-.28 0-.5.22-.5.5v13c0 .28.22.5.5.5h17c.28 0 .5-.22.5-.5v-13c0-.28-.22-.5-.5-.5h-17z\"/></svg>";


var $1d79e288b1495a3d$exports = {};
$1d79e288b1495a3d$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"m23.56 21.45-6.68-6.69C15.64 16.7 13.47 18 11 18c-3.86 0-7-3.14-7-7 0-2.56 1.39-4.8 3.45-6.02l-.09-.04-2.11-.86A8.965 8.965 0 0 0 2 11a9 9 0 0 0 9 9c1.95 0 3.74-.63 5.21-1.68l5.23 5.24c.58.59 1.53.59 2.12 0 .59-.58.59-1.53 0-2.11z\"/><path class=\"color-general\" d=\"M19.92 9.97a8.964 8.964 0 0 0-2.56-5.33 8.964 8.964 0 0 0-5.33-2.56L11.83.6 7.89 3.65l4.61 1.89-.19-1.4c1.37.26 2.64.91 3.64 1.91 1 1 1.66 2.27 1.91 3.64l-1.4-.19 1.89 4.61 3.05-3.94-1.48-.2z\"/><path d=\"M7.82 14.88c-.18 0-.36-.07-.5-.21-.98-.98-1.52-2.28-1.52-3.67s.54-2.69 1.52-3.68c.27-.27.72-.27.99 0s.27.72 0 .99C7.6 9.03 7.2 9.98 7.2 11s.4 1.97 1.11 2.69c.27.27.27.72 0 .99-.13.13-.31.2-.49.2z\"/></svg>";


var $a907fed9db7b5edf$exports = {};
$a907fed9db7b5edf$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-general\" d=\"m23 18.5-2-2V18h-3v-3h1.5l-2-2-2 2H17v3h-3v-1.5l-2 2 2 2V19h3v3h-1.5l2 2 2-2H18v-3h3v1.5z\"/><path d=\"M7 4.83 12.17 10h-3l-.59.59L7 12.17V4.83M5 0v17l5-5h7L5 0z\"/></svg>";


var $a6457d158138bc9a$exports = {};
$a6457d158138bc9a$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-raster\" d=\"M12.96 17.06c-.18-1.51-1.66-3.27-4-3.14-1.68.1-3.12 1.49-4.04 4.2-.95 2.78-3.62 4-3.62 4 2.86.97 5.92 1.31 8.61.11 2.41-1.08 3.28-3.23 3.05-5.17z\"/><path d=\"M22.49 1.1C21.54.35 18 3.81 14.1 8.17c-1.38 1.54-2.74 3.16-3.57 4.59.62.07 1.3.31 1.92.77.78.59 1.23 1.29 1.42 1.9 1.29-1.18 2.4-2.69 3.68-4.53 3.39-4.88 5.9-9.04 4.94-9.8z\"/></svg>";


var $8c943ca951ece3c6$exports = {};
$8c943ca951ece3c6$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-raster\" d=\"M4 20h16v2H4z\"/><path d=\"M19.01 15.52c-1.29-.33-2.51-.57-3.93-.93-.62-.15-1.51-.55-1.58-1.59v-2.7c.12-.4.42-.7.56-.83C15.22 8.71 16 7.45 16 6c0-2.21-1.79-4-4-4S8 3.79 8 6c0 1.4.72 2.63 1.81 3.34H9.8s.69.52.69 1.22V13c-.06 1.04-.95 1.43-1.58 1.59-1.42.35-2.64.6-3.93.93C3.94 15.78 3 16.36 3 17v2h18v-2c0-.64-.94-1.22-1.99-1.48z\"/></svg>";


var $7e178e361414b792$exports = {};
$7e178e361414b792$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-raster\" d=\"M19.47 14.93c.06.95-.01 1.86-.21 2.7l1.48 2.97h-3c-.48.55-1.06 1.02-1.72 1.4H23l-3.53-7.07zM6.27 20.6h-3l1.48-2.97c-.21-.84-.27-1.75-.21-2.7L1 22h6.99c-.66-.38-1.24-.85-1.72-1.4z\"/><path d=\"M16.4 9.91C14.53 6.79 13 3.97 12 2.07c-1 1.9-2.53 4.72-4.4 7.84-1.88 3.15-2.23 6.57-.89 8.92C7.72 20.62 9.6 21.6 12 21.6s4.28-.98 5.29-2.77c1.33-2.35.99-5.77-.89-8.92zm-7 1.59c.6 6.5 3.6 8 3.6 8-8 .5-3.6-8-3.6-8z\"/></svg>";


var $c91c3ee29f976d3b$exports = {};
$c91c3ee29f976d3b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-raster\" d=\"M18 8v8H6V8h12m1-2H5c-.5 0-1 .4-1 1v10c0 .5.5 1 1 1h14c.5 0 1-.5 1-1V7c0-.6-.5-1-1-1z\"/><path d=\"M2 8V6c0-1.1.9-2 2-2h2v1H4c-.6 0-1 .4-1 1v2H2zm19 8v2c0 .6-.4 1-1 1h-2v1h2c1.1 0 2-.9 2-2v-2h-1zM18 5h2c.6 0 1 .4 1 1v2h1V6c0-1.1-.9-2-2-2h-2v1zM6 19H4c-.6 0-1-.4-1-1v-2H2v2c0 1.1.9 2 2 2h2v-1z\"/></svg>";


var $70fdc8c654e3c5d1$exports = {};
$70fdc8c654e3c5d1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"m12 6-6 6 6 6 6-6-6-6zm-3 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z\"/><path class=\"color-raster\" d=\"M1 17s-1 3 1 5 5 1 5 1l4-4-6-6-4 4zM22 2c-2-2-5-1-5-1l-4 4 6 6 4-4s1-3-1-5z\"/></svg>";


var $5df6d4c9873b4ac6$exports = {};
$5df6d4c9873b4ac6$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M10.1 22.1c.5.6 1.3.9 1.9.9 1 0 2.3-.7 2.4-2l-4.3 1.1zM9.5 19.4c0 .4 0 .9.1 1.5v.1l4.8-1.2c0-.7.1-1.2.2-1.6l-5.1 1.2z\"/><path class=\"color-raster\" d=\"M12 4c-3.3 0-6 2.8-6 6.1 0 3.6 2.2 4.5 3 6.6.2.5.3 1 .4 1.5l5.5-1.4v-.1c.8-2.1 3-3 3-6.6C18 6.8 15.3 4 12 4zm.5 11.8c-.4.6-1.1.9-1.7.7-.4-.4-.4-1-.1-1.5.3-.5 1.3-1.2 1.7-.9.4.4.5 1.2.1 1.7zm-.2-3.1c-.5.2-1 .3-1.5.2-.2-1.9-.3-3.8-.2-5.7 0 0 1.7-2.2 3.5-1.4.1 0-1.3 6-1.8 6.9z\"/><path d=\"m3.8 12.7-1.4.6c-.4.2-.6.6-.4 1 .1.3.4.5.7.5.1 0 .2 0 .3-.1l1.4-.6c.4-.2.6-.6.4-1s-.6-.6-1-.4zM4.3 6.1 3 5.5c-.4-.2-.8 0-1 .4-.2.4 0 .8.4 1l1.4.6c.1 0 .2.1.3.1.3 0 .6-.2.7-.5.1-.4-.1-.8-.5-1zM19.9 7.6c.1 0 .2 0 .3-.1l1.4-.6c.4-.2.6-.6.4-1-.2-.4-.6-.6-1-.4l-1.4.6c-.4.2-.6.6-.4 1 .2.3.4.5.7.5zM21.6 13.3l-1.4-.6c-.4-.2-.8 0-1 .4-.2.4 0 .8.4 1l1.4.6c.1 0 .2.1.3.1.3 0 .6-.2.7-.5.2-.4 0-.9-.4-1zM8.8.5c-.2-.4-.6-.6-1-.4-.4.2-.6.6-.4 1L8 2.4c.1.3.4.5.7.5.1 0 .2 0 .3-.1.4-.2.6-.6.4-1L8.8.5zM16.2.1c-.4-.2-.8 0-1 .4l-.6 1.4c-.2.4 0 .8.4 1 .1 0 .2.1.3.1.3 0 .6-.2.7-.5l.6-1.4c.1-.4-.1-.9-.4-1z\"/></svg>";


var $df23b310e22c2223$exports = {};
$df23b310e22c2223$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-raster\" d=\"m22.45 8.23-3.38 1.23c-.36.13-.55.54-.42.9.1.28.37.46.66.4.08 0 .16-.01.24-.04l3.38-1.23c.36-.13.55-.54.42-.9a.701.701 0 0 0-.66-.46c-.08.05-.16.07-.24.1zM19.55 16.77l3.38-1.23c.36-.13.55-.54.42-.9a.701.701 0 0 0-.66-.46c-.08 0-.16.01-.24.04l-3.38 1.23c-.36.13-.55.54-.42.9.1.28.37.46.66.46.08.01.16-.01.24-.04zM15.77 21.45l-1.23-3.38a.701.701 0 0 0-.66-.46c-.08 0-.16.01-.24.04-.36.13-.55.54-.42.9l1.23 3.38c.1.28.37.46.66.46a.693.693 0 0 0 .66-.94zM14.64 1.65c-.36.13-.55.54-.42.9l1.23 3.38c.1.28.37.46.66.46.08 0 .16-.01.24-.04.36-.13.55-.54.42-.9l-1.23-3.38a.701.701 0 0 0-.66-.46c-.08 0-.16.01-.24.04zM9.77 21.45l-1.23-3.38a.701.701 0 0 0-.66-.46c-.08 0-.16.01-.24.04-.36.13-.55.54-.42.9l1.23 3.38c.1.28.37.46.66.46a.693.693 0 0 0 .66-.94zM1.55 15.77l3.38-1.23c.36-.13.55-.54.42-.9a.701.701 0 0 0-.66-.46c-.08 0-.16.01-.24.04l-3.38 1.23c-.36.13-.55.54-.42.9.1.28.37.46.66.46.08.01.16-.01.24-.04zM8.64 1.65c-.36.13-.55.54-.42.9l1.23 3.38c.1.28.37.46.66.46.08 0 .16-.01.24-.04.36-.13.55-.54.42-.9L9.54 2.07a.701.701 0 0 0-.66-.46c-.08 0-.16.01-.24.04zM4.45 7.23 1.07 8.46c-.36.13-.55.54-.42.9.1.28.37.46.66.46.08 0 .16-.01.24-.04l3.38-1.23c.36-.13.55-.54.42-.9a.701.701 0 0 0-.66-.46.507.507 0 0 0-.24.04z\"/><path d=\"M20.03 18.09c-.23.08-.47.13-.72.13-.88 0-1.67-.56-1.98-1.38-.19-.53-.17-1.1.07-1.61.24-.51.66-.89 1.18-1.09l2.42-.87v-1.53l-.97.35c-.23.08-.47.13-.72.13-.88 0-1.67-.56-1.98-1.38-.4-1.09.17-2.3 1.26-2.69L21 7.27V6c0-1.1-.9-2-2-2h-1.27l.35.97c.4 1.09-.17 2.3-1.26 2.69-.23.08-.47.13-.72.13-.88 0-1.67-.56-1.98-1.38L13.27 4h-1.53l.35.97c.4 1.09-.17 2.3-1.26 2.69-.23.08-.47.13-.72.13-.88 0-1.67-.56-1.98-1.38L7.27 4H5c-1.1 0-2 .9-2 2v.27l.97-.35c.23-.09.47-.14.72-.14.88 0 1.67.56 1.98 1.38.19.53.17 1.1-.07 1.61-.24.51-.66.9-1.19 1.09L3 10.73v1.53l.97-.35c.23-.08.47-.13.72-.13.88 0 1.67.56 1.98 1.38.19.53.17 1.1-.07 1.61-.24.51-.66.89-1.18 1.09L3 16.73V18c0 1.1.9 2 2 2h1.27l-.35-.97c-.4-1.09.17-2.3 1.26-2.69.23-.08.47-.13.72-.13.88 0 1.67.56 1.98 1.38l.85 2.41h1.53l-.35-.97c-.4-1.09.17-2.3 1.26-2.69.23-.08.47-.13.72-.13.88 0 1.67.56 1.98 1.38l.86 2.41H19c1.1 0 2-.9 2-2v-.27l-.97.36z\"/></svg>";


var $0951d272ec2b0c2f$exports = {};
$0951d272ec2b0c2f$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-raster\" d=\"M13 11c-1.5-1.5-3.83-2.17-4.5-1.5l-2.48 2.48c1.16.27 2.49 1.08 3.71 2.29 1.26 1.26 2.04 2.56 2.29 3.71l2.48-2.48c.67-.67 0-3-1.5-4.5zM22.5 1.5c-1-1-2.5-1.5-3-1l-8 8c1.33 0 4 2.67 4 4l8-8c.5-.5 0-2-1-3zm-4.73 5.73-1.55 1.55c-.13.13-.33.13-.45 0l-.55-.55a.308.308 0 0 1 0-.45l1.55-1.55c.13-.13.33-.13.45 0l.55.55c.13.12.13.32 0 .45z\"/><path d=\"M8.74 15.26c-1.67-1.67-3.55-2.45-4.29-1.71-.73.73.04 2.61 1.71 4.29 1.67 1.67 3.55 2.45 4.29 1.71.74-.74-.04-2.62-1.71-4.29zM2.5 22.25c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l2-2c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-2 2c-.15.15-.34.22-.53.22zM7 23.75c-.06 0-.12-.01-.18-.02-.4-.1-.65-.51-.55-.91l.5-2a.75.75 0 1 1 1.46.36l-.5 2c-.09.34-.39.57-.73.57zM1 17.75c-.34 0-.64-.23-.73-.57-.1-.4.14-.81.55-.91l2-.5c.4-.1.81.14.91.55.1.4-.14.81-.55.91l-2 .5c-.06.01-.12.02-.18.02z\"/></svg>";


var $9871c4249ee1a347$exports = {};
$9871c4249ee1a347$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12 6c4.41 0 8 2.69 8 6s-3.59 6-8 6-8-2.69-8-6 3.59-6 8-6m0-2C6.48 4 2 7.58 2 12s4.48 8 10 8 10-3.58 10-8-4.48-8-10-8z\"/><ellipse class=\"color-vector\" cx=\"12\" cy=\"12\" rx=\"6.5\" ry=\"4.5\"/></svg>";


var $408f1b19254576db$exports = {};
$408f1b19254576db$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M21.98 15.79c-.12-.54-.65-.89-1.19-.77-.08.02-2.09.46-4.39 2.18-.77.57-1.4 1.09-1.99 1.57-1.21.99-2.17 1.78-3.69 2.47-.59.27-1.84.72-3.57.75l-3.61 1.55c1.14.3 2.27.46 3.4.46h.07c2.2-.01 3.8-.59 4.55-.94 1.75-.8 2.85-1.7 4.13-2.75.56-.46 1.17-.96 1.91-1.51 1.93-1.44 3.6-1.82 3.61-1.82.54-.12.88-.65.77-1.19z\"/><path class=\"color-vector\" d=\"M18.5 5.5c-1-1-2.5-1.5-3-1L5 15c.39.24 1.23.1 1.59.38.36.28.3 1.06.63 1.4.33.33 1.11.28 1.4.63.28.36.14 1.2.38 1.59L19.5 8.5c.5-.5 0-2-1-3zm-2 2-7 7c-.14.14-.32.21-.5.21s-.36-.07-.5-.21a.7.7 0 0 1 0-1l7-7a.7.7 0 0 1 1 0 .7.7 0 0 1 0 1z\"/><path d=\"m7.35 18.47-2.39 1.71c-.1-.27-.22-.51-.42-.71-.2-.2-.44-.32-.71-.42l1.71-2.39c-.4-.05-1.04-.24-1.54-.66l-3 7 7-3c-.42-.5-.61-1.14-.65-1.53zM21.99 2.01C21 1 19.5.5 19 1l-2 2c2 0 4 2 4 4l2-2c.5-.5-.02-1.98-1.01-2.99z\"/></svg>";


var $98e4e6e7a4576901$exports = {};
$98e4e6e7a4576901$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-vector\" d=\"M5.83 21.71h1.66c.75 0 1.47-.3 2-.83l11.4-11.4c.53-.53.83-1.25.83-2V5.83L5.83 21.71z\"/><path d=\"m20.29 2.29-18 18 1.42 1.42 18-18z\"/></svg>";


var $bf05bde51aa034cc$exports = {};
$bf05bde51aa034cc$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M5 0v17l5-5h7z\"/><path class=\"color-vector\" d=\"M20.77 14.36c-.35-.42-.98-.48-1.41-.13-1.04.87-2.19 1.6-3.36 2.24V16h-6v2.9c-2.88.84-5.07 1.1-5.11 1.11-.55.06-.94.56-.88 1.11.05.5.49.88.99.88.04 0 .07 0 .11-.01.17-.02 2.18-.26 4.89-1.01V22h6v-3.28c1.6-.79 3.2-1.75 4.64-2.95.42-.35.48-.99.13-1.41zM14 20h-2v-2h2v2z\"/></svg>";


var $cc44f86320dede86$exports = {};
$cc44f86320dede86$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"color-vector\" d=\"M22.47 4.86c-.56-1.72-3.24-3.71-5.21-3.86-3.4.35-6.56 2.34-6.32 4.93.14-.29.31-.57.53-.84.17-.21.39-.37.63-.46a5.24 5.24 0 0 1 1.86-.35c1.61 0 3.22.8 4.43 2.2 1.07 1.24 1.62 2.72 1.45 3.87-.04.26-.14.5-.3.7-.3.38-.68.68-1.11.91 4.24.05 4.16-5.33 4.04-7.1z\"/><path d=\"M12.63 6.03c-3.51 2.79-7.69 5.59-7.81 6.45C4.48 15 1 21 1 22l6.49-7.21c-.21-.55-.08-1.24.38-1.77.63-.73 1.65-.88 2.28-.34.63.54.62 1.58-.02 2.3-.41.47-.98.7-1.51.65L2 23c1 0 7.12-4.65 10.48-4.78.33-.01 3.71-4.64 5.87-8.09.24-1.66-2.54-5.39-5.72-4.1z\"/></svg>";


var $3fbfdd022a3ad3cf$exports = {};
$3fbfdd022a3ad3cf$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M20 6v12H4V6h16m2-2H2v16h20V4z\"/><path class=\"color-vector\" d=\"M5.5 7.5h13v9h-13z\"/></svg>";


var $bd9f38b070016686$exports = {};
$bd9f38b070016686$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"m12 4.47 7.65 5.55L16.73 19H7.27l-2.92-8.98L12 4.47M12 2 2 9.26 5.82 21h12.36L22 9.26 12 2z\"/><path class=\"color-vector\" d=\"M12 6.32 6.12 10.6l2.24 6.9h7.28l2.24-6.9z\"/></svg>";


var $eaae4173e5360d10$exports = {};
$eaae4173e5360d10$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12.94 5.12c1.37-.78 3.61-1.54 7.22-2.13l-.32-1.97c-3.88.63-6.69 1.54-8.5 2.76.67.27 1.22.74 1.6 1.34zM11.06 18.88c-1.37.78-3.61 1.54-7.22 2.13l.32 1.97c3.88-.63 6.69-1.54 8.5-2.76-.66-.27-1.22-.74-1.6-1.34zM11.8 9.99c-.53.32-1.14.51-1.8.51-.08 0-.16-.02-.24-.02.42.74.94 1.45 1.44 2.12.36.48.7.95 1 1.41.53-.32 1.14-.51 1.8-.51.08 0 .16.02.24.02-.42-.74-.94-1.45-1.44-2.12-.36-.48-.7-.95-1-1.41z\"/><circle class=\"color-vector\" cx=\"14\" cy=\"17\" r=\"2\"/><circle class=\"color-vector\" cx=\"10\" cy=\"7\" r=\"2\"/></svg>";


var $8fd9f36c28126ff9$exports = {};
$8fd9f36c28126ff9$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M4 3v5h1s0-3 4-3h2v13.5c0 1.1 0 2-3 2V22h9v-1.5c-3 0-3-.9-3-2V5h2c4 0 4 3 4 3h1V3H4z\"/><path class=\"color-vector\" d=\"M5 20H1v2h5v-1c0-.55-.45-1-1-1zM20 20c-.55 0-1 .45-1 1v1h5v-2h-4z\"/></svg>";


const $6f66b11978c98a13$var$GRAPHICS = {
    GraphiteLogotypeSolid: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7805e46f840b2316$exports))),
        size: undefined
    }
};
const $6f66b11978c98a13$var$SOLID_12PX = {
    Add: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a8b75979ed12b1b2$exports))),
        size: 12
    },
    Checkmark: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($ea72a9bb4bc896f4$exports))),
        size: 12
    },
    CloseX: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($0604f2bc7d89b5a4$exports))),
        size: 12
    },
    Delay: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3bc12b4d003ab9bb$exports))),
        size: 12
    },
    DropdownArrow: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($442e5c12e9234e87$exports))),
        size: 12
    },
    Edit12px: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a92bb5322ede3c62$exports))),
        size: 12
    },
    Empty12px: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($6e9004364e658539$exports))),
        size: 12
    },
    Failure: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7502ae824856c4ca$exports))),
        size: 12
    },
    FullscreenEnter: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($ab2878f016c0f0c4$exports))),
        size: 12
    },
    FullscreenExit: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($9838db1a8548f9cb$exports))),
        size: 12
    },
    Grid: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a69c981fb84a9d1b$exports))),
        size: 12
    },
    Info: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($734513808e7994de$exports))),
        size: 12
    },
    KeyboardArrowDown: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($dbd989373cafb4e6$exports))),
        size: 12
    },
    KeyboardArrowLeft: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($66a13a440c22a944$exports))),
        size: 12
    },
    KeyboardArrowRight: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3c99e60d233ae733$exports))),
        size: 12
    },
    KeyboardArrowUp: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($d00433192978bdb8$exports))),
        size: 12
    },
    KeyboardBackspace: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($d3ac664d7594973e$exports))),
        size: 12
    },
    KeyboardCommand: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($99926fb9c7322980$exports))),
        size: 12
    },
    KeyboardControl: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($2094fdc908f5406d$exports))),
        size: 12
    },
    KeyboardEnter: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($ee6e4dda39f322bc$exports))),
        size: 12
    },
    KeyboardOption: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($f8da9817da7666a1$exports))),
        size: 12
    },
    KeyboardShift: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($76331f1e556007f8$exports))),
        size: 12
    },
    KeyboardSpace: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($e879f76f1ef7bf42$exports))),
        size: 12
    },
    KeyboardTab: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($d187d177e2aa7809$exports))),
        size: 12
    },
    License12px: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a9e1311559e5db9c$exports))),
        size: 12
    },
    Link: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($92dcb8ff452ce076$exports))),
        size: 12
    },
    Overlays: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($f19a2eae8c6a4da1$exports))),
        size: 12
    },
    Remove: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8d85eaea3af9e3fd$exports))),
        size: 12
    },
    Snapping: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($da042601de73ff57$exports))),
        size: 12
    },
    Swap: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($abb962379537d26a$exports))),
        size: 12
    },
    VerticalEllipsis: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($23c7167183df148f$exports))),
        size: 12
    },
    Warning: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($bf7294295c7a5604$exports))),
        size: 12
    },
    WindowButtonWinClose: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($adafe3d9b1c640c2$exports))),
        size: 12
    },
    WindowButtonWinMaximize: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($108207fe31c21b92$exports))),
        size: 12
    },
    WindowButtonWinMinimize: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($25378bdbf9950db8$exports))),
        size: 12
    },
    WindowButtonWinRestoreDown: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3d84be20c2b1927c$exports))),
        size: 12
    },
    WorkingColors: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($1f9606a8a14ac54b$exports))),
        size: 12
    }
};
const $6f66b11978c98a13$var$SOLID_16PX = {
    AlignBottom: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($278ebe6cf345dedb$exports))),
        size: 16
    },
    AlignHorizontalCenter: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8860ee1ac33cc3ad$exports))),
        size: 16
    },
    AlignLeft: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8db7e000fc4c5879$exports))),
        size: 16
    },
    AlignRight: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($cf46e7246a378e1f$exports))),
        size: 16
    },
    AlignTop: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($24a70cb1e6e21b18$exports))),
        size: 16
    },
    AlignVerticalCenter: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($0ea51695a25ef8a4$exports))),
        size: 16
    },
    BooleanDifference: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($eafe7a4fe6392749$exports))),
        size: 16
    },
    BooleanIntersect: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($4966bb035dcd1930$exports))),
        size: 16
    },
    BooleanSubtractBack: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($e1d33367affd4739$exports))),
        size: 16
    },
    BooleanSubtractFront: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($23cf378ea505fb4d$exports))),
        size: 16
    },
    BooleanUnion: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($28e0dc18751953f7$exports))),
        size: 16
    },
    CheckboxChecked: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8c637eed31eb8426$exports))),
        size: 16
    },
    CheckboxUnchecked: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($d20a6d60f8c5a22e$exports))),
        size: 16
    },
    Copy: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a9e21fc72c2d3e82$exports))),
        size: 16
    },
    Credits: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($b4b83b30ae59d280$exports))),
        size: 16
    },
    CustomColor: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($e4229ea672c0725a$exports))),
        size: 16
    },
    Edit: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($ebff662b776a2657$exports))),
        size: 16
    },
    Eyedropper: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8883597bd20b755f$exports))),
        size: 16
    },
    EyeHidden: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3cb49211dea4a3f8$exports))),
        size: 16
    },
    EyeVisible: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($bb3c35b5a46621c5$exports))),
        size: 16
    },
    File: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7b16567ceb69d1e2$exports))),
        size: 16
    },
    FlipHorizontal: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($1cd9328c42cf5c9a$exports))),
        size: 16
    },
    FlipVertical: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($fc3eab1398305d7a$exports))),
        size: 16
    },
    Folder: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($bbb349e9ba5791c0$exports))),
        size: 16
    },
    GraphiteLogo: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($0f37ea84cef4b2c0$exports))),
        size: 16
    },
    GraphViewClosed: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($6360e977e364d34b$exports))),
        size: 16
    },
    GraphViewOpen: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($e4f9c227cc246bbe$exports))),
        size: 16
    },
    IconsGrid: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a73c21e4b94c93ac$exports))),
        size: 16
    },
    Image: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($5190a60712de730a$exports))),
        size: 16
    },
    Layer: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($9476b05b16ec0caa$exports))),
        size: 16
    },
    License: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8ae8f6afe3d9fc28$exports))),
        size: 16
    },
    NodeArtboard: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($5aa5d5b0d569ba57$exports))),
        size: 16
    },
    NodeBlur: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($346598c71833ec76$exports))),
        size: 16
    },
    NodeBrushwork: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3fd9d5e35da6382f$exports))),
        size: 16
    },
    NodeColorCorrection: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3836b34872dbc963$exports))),
        size: 16
    },
    NodeGradient: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($56496e01c1ed6726$exports))),
        size: 16
    },
    NodeImaginate: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($ffc6507a41574590$exports))),
        size: 16
    },
    NodeMagicWand: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3c3a2f4f803db9cc$exports))),
        size: 16
    },
    NodeMask: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($4da50eafa57b2315$exports))),
        size: 16
    },
    NodeMotionBlur: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($c5a3dd52400f1399$exports))),
        size: 16
    },
    NodeNodes: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($81cb3a0787f47a0c$exports))),
        size: 16
    },
    NodeOutput: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($4d087d248b19be66$exports))),
        size: 16
    },
    NodeShape: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($cd26c41a56fae35b$exports))),
        size: 16
    },
    NodeText: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($94ec8efc41adbaba$exports))),
        size: 16
    },
    NodeTransform: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($d589f8f105355e57$exports))),
        size: 16
    },
    Paste: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($9ae1d933a3aef234$exports))),
        size: 16
    },
    Random: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7089a6537fdff724$exports))),
        size: 16
    },
    Regenerate: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($5685f2f035db9c24$exports))),
        size: 16
    },
    Reload: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($15417cebad6733c2$exports))),
        size: 16
    },
    Rescale: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($bc7c6b3ee92421d9$exports))),
        size: 16
    },
    Reset: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($238b4a57c94aa574$exports))),
        size: 16
    },
    Settings: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($be0f1cd4bfb134a9$exports))),
        size: 16
    },
    Trash: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7e5674811eeda292$exports))),
        size: 16
    },
    ViewModeNormal: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($aae649cdd16b935e$exports))),
        size: 16
    },
    ViewModeOutline: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($66116af55dae6a6c$exports))),
        size: 16
    },
    ViewModePixels: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($028c5f70034f7106$exports))),
        size: 16
    },
    ViewportDesignMode: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3f6d7f493672ef36$exports))),
        size: 16
    },
    ViewportGuideMode: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3bd906012ea828db$exports))),
        size: 16
    },
    ViewportSelectMode: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8a8f1a77dbc655e8$exports))),
        size: 16
    },
    Volunteer: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($bc738c3d178138a6$exports))),
        size: 16
    },
    Website: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($d519bff6f355a798$exports))),
        size: 16
    },
    WorkingColorsPrimary: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($aa5ad32b524bbe33$exports))),
        size: 16
    },
    WorkingColorsSecondary: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($24bcd77be8e15b7e$exports))),
        size: 16
    },
    ZoomIn: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($73fcdeafb9c2a85c$exports))),
        size: 16
    },
    ZoomOut: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($e6ccd6b598dada11$exports))),
        size: 16
    },
    ZoomReset: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($c9796b2cd79166ce$exports))),
        size: 16
    }
};
const $6f66b11978c98a13$var$TWO_TONE_16PX = {
    MouseHintDrag: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($234e8d0d475d115b$exports))),
        size: 16
    },
    MouseHintLmb: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($673a65c4b09c2e51$exports))),
        size: 16
    },
    MouseHintLmbDouble: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($05d9dae1c28dc21d$exports))),
        size: 16
    },
    MouseHintLmbDrag: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($ae99bca8e748cf36$exports))),
        size: 16
    },
    MouseHintMmb: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($e904c585475bcaa2$exports))),
        size: 16
    },
    MouseHintMmbDrag: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($4d5e9044b551bc7c$exports))),
        size: 16
    },
    MouseHintNone: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($ff93eb72c3a8b1fb$exports))),
        size: 16
    },
    MouseHintRmb: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($13d3fee1d5b82cee$exports))),
        size: 16
    },
    MouseHintRmbDrag: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($426c6e65956b298f$exports))),
        size: 16
    },
    MouseHintScrollDown: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($542899f7c9515af1$exports))),
        size: 16
    },
    MouseHintScrollUp: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($580544b3c267db0f$exports))),
        size: 16
    }
};
const $6f66b11978c98a13$var$TWO_TONE_24PX = {
    GeneralArtboardTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($5465d846116585b1$exports))),
        size: 24
    },
    GeneralEyedropperTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($511cdd29efea6a94$exports))),
        size: 24
    },
    GeneralFillTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($d7314287c911f21d$exports))),
        size: 24
    },
    GeneralGradientTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($e812b536a9d192d3$exports))),
        size: 24
    },
    GeneralNavigateTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($1d79e288b1495a3d$exports))),
        size: 24
    },
    GeneralSelectTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a907fed9db7b5edf$exports))),
        size: 24
    },
    RasterBrushTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($a6457d158138bc9a$exports))),
        size: 24
    },
    RasterCloneTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8c943ca951ece3c6$exports))),
        size: 24
    },
    RasterDetailTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7e178e361414b792$exports))),
        size: 24
    },
    RasterFrameTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($c91c3ee29f976d3b$exports))),
        size: 24
    },
    RasterHealTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($70fdc8c654e3c5d1$exports))),
        size: 24
    },
    RasterImaginateTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($5df6d4c9873b4ac6$exports))),
        size: 24
    },
    RasterPatchTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($df23b310e22c2223$exports))),
        size: 24
    },
    RasterRelightTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($0951d272ec2b0c2f$exports))),
        size: 24
    },
    VectorEllipseTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($9871c4249ee1a347$exports))),
        size: 24
    },
    VectorFreehandTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($408f1b19254576db$exports))),
        size: 24
    },
    VectorLineTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($98e4e6e7a4576901$exports))),
        size: 24
    },
    VectorPathTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($bf05bde51aa034cc$exports))),
        size: 24
    },
    VectorPenTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($cc44f86320dede86$exports))),
        size: 24
    },
    VectorRectangleTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($3fbfdd022a3ad3cf$exports))),
        size: 24
    },
    VectorPolygonTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($bd9f38b070016686$exports))),
        size: 24
    },
    VectorSplineTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($eaae4173e5360d10$exports))),
        size: 24
    },
    VectorTextTool: {
        svg: (0, (/*@__PURE__*/$parcel$interopDefault($8fd9f36c28126ff9$exports))),
        size: 24
    }
};
// All icons
const $6f66b11978c98a13$var$ICON_LIST = {
    ...$6f66b11978c98a13$var$GRAPHICS,
    ...$6f66b11978c98a13$var$SOLID_12PX,
    ...$6f66b11978c98a13$var$SOLID_16PX,
    ...$6f66b11978c98a13$var$TWO_TONE_16PX,
    ...$6f66b11978c98a13$var$TWO_TONE_24PX
};
const $6f66b11978c98a13$export$fde44257752a9f60 = $6f66b11978c98a13$var$ICON_LIST;
const $6f66b11978c98a13$export$99b4cc88d8449aa8 = Object.fromEntries(Object.entries($6f66b11978c98a13$export$fde44257752a9f60).map(([name, data])=>[
        name,
        data.svg
    ]));



function $9b2fdfd965680fb8$var$create_default_slot(ctx) {
    let html_tag;
    let raw_value = (0, $6f66b11978c98a13$export$99b4cc88d8449aa8)[/*icon*/ ctx[1]] + "";
    let html_anchor;
    return {
        c () {
            html_tag = new (0, $1eb80e36873dc327$export$5b2cf11349dd7485)(false);
            html_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*icon*/ 2 && raw_value !== (raw_value = (0, $6f66b11978c98a13$export$99b4cc88d8449aa8)[/*icon*/ ctx[1]] + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
function $9b2fdfd965680fb8$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: `icon-label ${ctx[5]} ${ctx[0]} ${ctx[4]}`.trim(),
            classes: {
                disabled: /*disabled*/ ctx[2]
            },
            tooltip: /*tooltip*/ ctx[3],
            $$slots: {
                default: [
                    $9b2fdfd965680fb8$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*iconSizeClass, className, extraClasses*/ 49) layoutrow_changes.class = `icon-label ${ctx[5]} ${ctx[0]} ${ctx[4]}`.trim();
            if (dirty & /*disabled*/ 4) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[2]
            };
            if (dirty & /*tooltip*/ 8) layoutrow_changes.tooltip = /*tooltip*/ ctx[3];
            if (dirty & /*$$scope, icon*/ 130) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $9b2fdfd965680fb8$var$instance($$self, $$props, $$invalidate) {
    let iconSizeClass;
    let extraClasses;
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    let { icon: icon } = $$props;
    let { disabled: disabled = false } = $$props;
    let { tooltip: tooltip } = $$props;
    $$self.$$set = ($$props)=>{
        if ("class" in $$props) $$invalidate(0, className = $$props.class);
        if ("classes" in $$props) $$invalidate(6, classes = $$props.classes);
        if ("icon" in $$props) $$invalidate(1, icon = $$props.icon);
        if ("disabled" in $$props) $$invalidate(2, disabled = $$props.disabled);
        if ("tooltip" in $$props) $$invalidate(3, tooltip = $$props.tooltip);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*icon*/ 2) $: $$invalidate(5, iconSizeClass = ((icon)=>{
            return `size-${(0, $6f66b11978c98a13$export$fde44257752a9f60)[icon].size}`;
        })(icon));
        if ($$self.$$.dirty & /*classes*/ 64) $: $$invalidate(4, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
    };
    return [
        className,
        icon,
        disabled,
        tooltip,
        extraClasses,
        iconSizeClass,
        classes
    ];
}
class $9b2fdfd965680fb8$var$IconLabel extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $9b2fdfd965680fb8$var$instance, $9b2fdfd965680fb8$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            class: 0,
            classes: 6,
            icon: 1,
            disabled: 2,
            tooltip: 3
        });
    }
}
var $9b2fdfd965680fb8$export$2e2bcd8739ae039 = $9b2fdfd965680fb8$var$IconLabel;



/* src/components/widgets/labels/TextLabel.svelte generated by Svelte v3.58.0 */ 
function $84975b9c3b9bc8e2$var$create_fragment(ctx) {
    let span;
    let span_class_value;
    let span_style_value;
    let current;
    const default_slot_template = /*#slots*/ ctx[14].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[13], null);
    return {
        c () {
            span = (0, $1eb80e36873dc327$export$8454457683f90105)("span");
            if (default_slot) default_slot.c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(span, "class", span_class_value = `text-label ${ctx[0]} ${ctx[10]}`.trim());
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(span, "style", span_style_value = `${ctx[1]} ${ctx[9]}`.trim() || undefined);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(span, "title", /*tooltip*/ ctx[8]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "disabled", /*disabled*/ ctx[2]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "bold", /*bold*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "italic", /*italic*/ ctx[4]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "multiline", /*multiline*/ ctx[7]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "table-align", /*tableAlign*/ ctx[5]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(span, "min-width", /*minWidth*/ ctx[6] > 0 ? `${ctx[6]}px` : "");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, span, anchor);
            if (default_slot) default_slot.m(span, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 8192)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[13], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[13]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[13], dirty, null), null);
            }
            if (!current || dirty & /*className, extraClasses*/ 1025 && span_class_value !== (span_class_value = `text-label ${ctx[0]} ${ctx[10]}`.trim())) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(span, "class", span_class_value);
            if (!current || dirty & /*styleName, extraStyles*/ 514 && span_style_value !== (span_style_value = `${ctx[1]} ${ctx[9]}`.trim() || undefined)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(span, "style", span_style_value);
            if (!current || dirty & /*tooltip*/ 256) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(span, "title", /*tooltip*/ ctx[8]);
            if (!current || dirty & /*className, extraClasses, disabled*/ 1029) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "disabled", /*disabled*/ ctx[2]);
            if (!current || dirty & /*className, extraClasses, bold*/ 1033) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "bold", /*bold*/ ctx[3]);
            if (!current || dirty & /*className, extraClasses, italic*/ 1041) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "italic", /*italic*/ ctx[4]);
            if (!current || dirty & /*className, extraClasses, multiline*/ 1153) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "multiline", /*multiline*/ ctx[7]);
            if (!current || dirty & /*className, extraClasses, tableAlign*/ 1057) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(span, "table-align", /*tableAlign*/ ctx[5]);
            const style_changed = dirty & /*styleName, extraStyles*/ 514;
            if (style_changed || dirty & /*minWidth, styleName, extraStyles*/ 578) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(span, "min-width", /*minWidth*/ ctx[6] > 0 ? `${ctx[6]}px` : "");
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(span);
            if (default_slot) default_slot.d(detaching);
        }
    };
}
function $84975b9c3b9bc8e2$var$instance($$self, $$props, $$invalidate) {
    let extraClasses;
    let extraStyles;
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    let { style: styleName = "" } = $$props;
    let { styles: styles = {} } = $$props;
    let { disabled: disabled = false } = $$props;
    let { bold: bold = false } = $$props;
    let { italic: italic = false } = $$props;
    let { tableAlign: tableAlign = false } = $$props;
    let { minWidth: minWidth = 0 } = $$props;
    let { multiline: multiline = false } = $$props;
    let { tooltip: tooltip } = $$props;
    $$self.$$set = ($$props)=>{
        if ("class" in $$props) $$invalidate(0, className = $$props.class);
        if ("classes" in $$props) $$invalidate(11, classes = $$props.classes);
        if ("style" in $$props) $$invalidate(1, styleName = $$props.style);
        if ("styles" in $$props) $$invalidate(12, styles = $$props.styles);
        if ("disabled" in $$props) $$invalidate(2, disabled = $$props.disabled);
        if ("bold" in $$props) $$invalidate(3, bold = $$props.bold);
        if ("italic" in $$props) $$invalidate(4, italic = $$props.italic);
        if ("tableAlign" in $$props) $$invalidate(5, tableAlign = $$props.tableAlign);
        if ("minWidth" in $$props) $$invalidate(6, minWidth = $$props.minWidth);
        if ("multiline" in $$props) $$invalidate(7, multiline = $$props.multiline);
        if ("tooltip" in $$props) $$invalidate(8, tooltip = $$props.tooltip);
        if ("$$scope" in $$props) $$invalidate(13, $$scope = $$props.$$scope);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*classes*/ 2048) $: $$invalidate(10, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
        if ($$self.$$.dirty & /*styles*/ 4096) $: $$invalidate(9, extraStyles = Object.entries(styles).flatMap((styleAndValue)=>styleAndValue[1] !== undefined ? [
                `${styleAndValue[0]}: ${styleAndValue[1]};`
            ] : []).join(" "));
    };
    return [
        className,
        styleName,
        disabled,
        bold,
        italic,
        tableAlign,
        minWidth,
        multiline,
        tooltip,
        extraStyles,
        extraClasses,
        classes,
        styles,
        $$scope,
        slots
    ];
}
class $84975b9c3b9bc8e2$var$TextLabel extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $84975b9c3b9bc8e2$var$instance, $84975b9c3b9bc8e2$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            class: 0,
            classes: 11,
            style: 1,
            styles: 12,
            disabled: 2,
            bold: 3,
            italic: 4,
            tableAlign: 5,
            minWidth: 6,
            multiline: 7,
            tooltip: 8
        });
    }
}
var $84975b9c3b9bc8e2$export$2e2bcd8739ae039 = $84975b9c3b9bc8e2$var$TextLabel;



function $26bc4a854934ba73$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[15] = list[i];
    child_ctx[17] = i;
    return child_ctx;
}
function $26bc4a854934ba73$var$get_each_context_1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[18] = list[i];
    child_ctx[20] = i;
    return child_ctx;
}
// (105:0) {:else}
function $26bc4a854934ba73$var$create_else_block(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "user-input-label",
            classes: {
                "text-only": /*textOnly*/ ctx[2]
            },
            $$slots: {
                default: [
                    $26bc4a854934ba73$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*textOnly*/ 4) layoutrow_changes.classes = {
                "text-only": /*textOnly*/ ctx[2]
            };
            if (dirty & /*$$scope, $$slots, mouseMotion, keysWithLabelsGroups*/ 2179) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (103:0) {#if displayKeyboardLockNotice}
function $26bc4a854934ba73$var$create_if_block(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            class: "user-input-label keyboard-lock-notice",
            icon: "Info",
            tooltip: /*keyboardLockInfoMessage*/ ctx[4]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*keyboardLockInfoMessage*/ 16) iconlabel_changes.tooltip = /*keyboardLockInfoMessage*/ ctx[4];
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (108:3) {#if groupIndex > 0}
function $26bc4a854934ba73$var$create_if_block_5(ctx) {
    let separator;
    let current;
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Related"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
        }
    };
}
// (115:43) 
function $26bc4a854934ba73$var$create_if_block_4(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $26bc4a854934ba73$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, keysWithLabelsGroups*/ 2049) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (113:5) {#if keyInfo.icon}
function $26bc4a854934ba73$var$create_if_block_3(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*keyInfo*/ ctx[18].icon
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*keysWithLabelsGroups*/ 1) iconlabel_changes.icon = /*keyInfo*/ ctx[18].icon;
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (116:6) <TextLabel>
function $26bc4a854934ba73$var$create_default_slot_1(ctx) {
    let t_value = /*keyInfo*/ ctx[18].label + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*keysWithLabelsGroups*/ 1 && t_value !== (t_value = /*keyInfo*/ ctx[18].label + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (111:3) {#each keyTextOrIconList(keysWithLabels) as keyInfo, keyIndex (keyIndex)}
function $26bc4a854934ba73$var$create_each_block_1(key_1, ctx) {
    let div;
    let current_block_type_index;
    let if_block;
    let div_class_value;
    let current;
    const if_block_creators = [
        $26bc4a854934ba73$var$create_if_block_3,
        $26bc4a854934ba73$var$create_if_block_4
    ];
    const if_blocks = [];
    function select_block_type_1(ctx, dirty) {
        if (/*keyInfo*/ ctx[18].icon) return 0;
        if (/*keyInfo*/ ctx[18].label !== undefined) return 1;
        return -1;
    }
    if (~(current_block_type_index = select_block_type_1(ctx, -1))) if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        key: key_1,
        first: null,
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block) if_block.c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value = `input-key ${ctx[18].width}`);
            this.first = div;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            if (~current_block_type_index) if_blocks[current_block_type_index].m(div, null);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type_1(ctx, dirty);
            if (current_block_type_index === previous_block_index) {
                if (~current_block_type_index) if_blocks[current_block_type_index].p(ctx, dirty);
            } else {
                if (if_block) {
                    (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                    (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                        if_blocks[previous_block_index] = null;
                    });
                    (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                }
                if (~current_block_type_index) {
                    if_block = if_blocks[current_block_type_index];
                    if (!if_block) {
                        if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                        if_block.c();
                    } else if_block.p(ctx, dirty);
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(div, null);
                } else if_block = null;
            }
            if (!current || dirty & /*keysWithLabelsGroups*/ 1 && div_class_value !== (div_class_value = `input-key ${ctx[18].width}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            if (~current_block_type_index) if_blocks[current_block_type_index].d();
        }
    };
}
// (107:2) {#each keysWithLabelsGroups as keysWithLabels, groupIndex (groupIndex)}
function $26bc4a854934ba73$var$create_each_block(key_1, ctx) {
    let first;
    let t;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let if_block = /*groupIndex*/ ctx[17] > 0 && $26bc4a854934ba73$var$create_if_block_5(ctx);
    let each_value_1 = /*keyTextOrIconList*/ ctx[6](/*keysWithLabels*/ ctx[15]);
    const get_key = (ctx)=>/*keyIndex*/ ctx[20];
    for(let i = 0; i < each_value_1.length; i += 1){
        let child_ctx = $26bc4a854934ba73$var$get_each_context_1(ctx, each_value_1, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $26bc4a854934ba73$var$create_each_block_1(key, child_ctx));
    }
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*groupIndex*/ ctx[17] > 0) {
                if (if_block) {
                    if (dirty & /*keysWithLabelsGroups*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $26bc4a854934ba73$var$create_if_block_5(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (dirty & /*keyTextOrIconList, keysWithLabelsGroups, undefined*/ 65) {
                each_value_1 = /*keyTextOrIconList*/ ctx[6](/*keysWithLabels*/ ctx[15]);
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $26bc4a854934ba73$var$create_each_block_1, each_1_anchor, $26bc4a854934ba73$var$get_each_context_1);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            for(let i = 0; i < each_value_1.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (121:2) {#if mouseMotion}
function $26bc4a854934ba73$var$create_if_block_2(ctx) {
    let div;
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: $26bc4a854934ba73$var$mouseHintIcon(/*mouseMotion*/ ctx[1])
        }
    });
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "input-mouse");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*mouseMotion*/ 2) iconlabel_changes.icon = $26bc4a854934ba73$var$mouseHintIcon(/*mouseMotion*/ ctx[1]);
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel);
        }
    };
}
// (126:2) {#if $$slots.default}
function $26bc4a854934ba73$var$create_if_block_1(ctx) {
    let div;
    let current;
    const default_slot_template = /*#slots*/ ctx[10].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[11], null);
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (default_slot) default_slot.c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "hint-text");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            if (default_slot) default_slot.m(div, null);
            current = true;
        },
        p (ctx, dirty) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 2048)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[11], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[11]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[11], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            if (default_slot) default_slot.d(detaching);
        }
    };
}
// (106:1) <LayoutRow class="user-input-label" classes={{ "text-only": textOnly }}>
function $26bc4a854934ba73$var$create_default_slot(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let t0;
    let t1;
    let if_block1_anchor;
    let current;
    let each_value = /*keysWithLabelsGroups*/ ctx[0];
    const get_key = (ctx)=>/*groupIndex*/ ctx[17];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $26bc4a854934ba73$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $26bc4a854934ba73$var$create_each_block(key, child_ctx));
    }
    let if_block0 = /*mouseMotion*/ ctx[1] && $26bc4a854934ba73$var$create_if_block_2(ctx);
    let if_block1 = /*$$slots*/ ctx[7].default && $26bc4a854934ba73$var$create_if_block_1(ctx);
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block0) if_block0.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            if_block1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            if (if_block0) if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*keyTextOrIconList, keysWithLabelsGroups, undefined*/ 65) {
                each_value = /*keysWithLabelsGroups*/ ctx[0];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, t0.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $26bc4a854934ba73$var$create_each_block, t0, $26bc4a854934ba73$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*mouseMotion*/ ctx[1]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*mouseMotion*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $26bc4a854934ba73$var$create_if_block_2(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(t1.parentNode, t1);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*$$slots*/ ctx[7].default) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$$slots*/ 128) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $26bc4a854934ba73$var$create_if_block_1(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (if_block0) if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block1_anchor);
        }
    };
}
function $26bc4a854934ba73$var$create_fragment(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $26bc4a854934ba73$var$create_if_block,
        $26bc4a854934ba73$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*displayKeyboardLockNotice*/ ctx[3]) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
function $26bc4a854934ba73$var$watchKeyboardLockInfoMessage(keyboardLockApiSupported) {
    const RESERVED = "This hotkey is reserved by the browser. ";
    const USE_FULLSCREEN = "It is made available in fullscreen mode.";
    const USE_SECURE_CTX = "It is made available in fullscreen mode when this website is served from a secure context (https or localhost).";
    const SWITCH_BROWSER = "Use a Chromium-based browser (like Chrome or Edge) in fullscreen mode to directly use the shortcut.";
    if (keyboardLockApiSupported) return `${RESERVED} ${USE_FULLSCREEN}`;
    if (!("chrome" in window)) return `${RESERVED} ${SWITCH_BROWSER}`;
    if (!window.isSecureContext) return `${RESERVED} ${USE_SECURE_CTX}`;
    return RESERVED;
}
function $26bc4a854934ba73$var$mouseHintIcon(input) {
    return `MouseHint${input}`;
}
function $26bc4a854934ba73$var$keyboardHintIcon(input) {
    switch(input){
        case "ArrowDown":
            return "KeyboardArrowDown";
        case "ArrowLeft":
            return "KeyboardArrowLeft";
        case "ArrowRight":
            return "KeyboardArrowRight";
        case "ArrowUp":
            return "KeyboardArrowUp";
        case "Backspace":
            return "KeyboardBackspace";
        case "Command":
            return "KeyboardCommand";
        case "Control":
            return "KeyboardControl";
        case "Enter":
            return "KeyboardEnter";
        case "Option":
            return "KeyboardOption";
        case "Shift":
            return "KeyboardShift";
        case "Space":
            return "KeyboardSpace";
        case "Tab":
            return "KeyboardTab";
        default:
            return undefined;
    }
}
function $26bc4a854934ba73$var$instance($$self, $$props, $$invalidate) {
    let keyboardLockInfoMessage;
    let displayKeyboardLockNotice;
    let $fullscreen;
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    const $$slots = (0, $1eb80e36873dc327$export$3001519f1cb535ea)(slots);
    const ICON_WIDTHS_MAC = {
        Shift: 2,
        Control: 2,
        Option: 2,
        Command: 2
    };
    const ICON_WIDTHS = {
        ArrowUp: 1,
        ArrowRight: 1,
        ArrowDown: 1,
        ArrowLeft: 1,
        Backspace: 2,
        Enter: 2,
        Tab: 2,
        Space: 3,
        ...(0, $7ed52b8c7c886783$export$f205d53822e9a9a9)() ? ICON_WIDTHS_MAC : {}
    };
    const fullscreen = (0, $1eb80e36873dc327$export$31553aaa555c1514)("fullscreen");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, fullscreen, (value)=>$$invalidate(9, $fullscreen = value));
    let { keysWithLabelsGroups: keysWithLabelsGroups = [] } = $$props;
    let { mouseMotion: mouseMotion } = $$props;
    let { requiresLock: requiresLock = false } = $$props;
    let { textOnly: textOnly = false } = $$props;
    function keyTextOrIconList(keyGroup) {
        return keyGroup.map((key)=>keyTextOrIcon(key));
    }
    function keyTextOrIcon(keyWithLabel) {
        // `key` is the name of the `Key` enum in Rust, while `label` is the localized string to display (if it doesn't become an icon)
        let key = keyWithLabel.key;
        const label = keyWithLabel.label;
        // Replace Alt and Accel keys with their Mac-specific equivalents
        if ((0, $7ed52b8c7c886783$export$f205d53822e9a9a9)()) {
            if (key === "Alt") key = "Option";
            if (key === "Accel") key = "Command";
        }
        // Either display an icon...
        // @ts-expect-error We want undefined if it isn't in the object
        const iconWidth = ICON_WIDTHS[key];
        const icon = iconWidth !== undefined && iconWidth > 0 && ($26bc4a854934ba73$var$keyboardHintIcon(key) || false);
        if (icon) return {
            icon: icon,
            width: `width-${iconWidth}`
        };
        // ...or display text
        return {
            label: label,
            width: `width-${label.length}`
        };
    }
    $$self.$$set = ($$props)=>{
        if ("keysWithLabelsGroups" in $$props) $$invalidate(0, keysWithLabelsGroups = $$props.keysWithLabelsGroups);
        if ("mouseMotion" in $$props) $$invalidate(1, mouseMotion = $$props.mouseMotion);
        if ("requiresLock" in $$props) $$invalidate(8, requiresLock = $$props.requiresLock);
        if ("textOnly" in $$props) $$invalidate(2, textOnly = $$props.textOnly);
        if ("$$scope" in $$props) $$invalidate(11, $$scope = $$props.$$scope);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*requiresLock, $fullscreen*/ 768) $: $$invalidate(3, displayKeyboardLockNotice = requiresLock && !$fullscreen.keyboardLocked);
    };
    $: $$invalidate(4, keyboardLockInfoMessage = $26bc4a854934ba73$var$watchKeyboardLockInfoMessage(fullscreen.keyboardLockApiSupported));
    return [
        keysWithLabelsGroups,
        mouseMotion,
        textOnly,
        displayKeyboardLockNotice,
        keyboardLockInfoMessage,
        fullscreen,
        keyTextOrIconList,
        $$slots,
        requiresLock,
        $fullscreen,
        slots,
        $$scope
    ];
}
class $26bc4a854934ba73$var$UserInputLabel extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $26bc4a854934ba73$var$instance, $26bc4a854934ba73$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            keysWithLabelsGroups: 0,
            mouseMotion: 1,
            requiresLock: 8,
            textOnly: 2
        });
    }
}
var $26bc4a854934ba73$export$2e2bcd8739ae039 = $26bc4a854934ba73$var$UserInputLabel;


function $70425d4c951ba058$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[3] = list[i];
    child_ctx[5] = i;
    return child_ctx;
}
function $70425d4c951ba058$var$get_each_context_1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[6] = list[i];
    return child_ctx;
}
// (24:3) {#if index !== 0}
function $70425d4c951ba058$var$create_if_block_1(ctx) {
    let separator;
    let current;
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Section"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
        }
    };
}
// (28:4) {#if hint.plus}
function $70425d4c951ba058$var$create_if_block(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "plus",
            $$slots: {
                default: [
                    $70425d4c951ba058$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (29:5) <LayoutRow class="plus">
function $70425d4c951ba058$var$create_default_slot_3(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("+");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (31:4) <UserInputLabel mouseMotion={hint.mouse} keysWithLabelsGroups={inputKeysForPlatform(hint)}>
function $70425d4c951ba058$var$create_default_slot_2(ctx) {
    let t_value = /*hint*/ ctx[6].label + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*hintData*/ 1 && t_value !== (t_value = /*hint*/ ctx[6].label + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (27:3) {#each hintGroup as hint (hint)}
function $70425d4c951ba058$var$create_each_block_1(key_1, ctx) {
    let first;
    let t;
    let userinputlabel;
    let current;
    let if_block = /*hint*/ ctx[6].plus && $70425d4c951ba058$var$create_if_block(ctx);
    userinputlabel = new (0, $26bc4a854934ba73$export$2e2bcd8739ae039)({
        props: {
            mouseMotion: /*hint*/ ctx[6].mouse,
            keysWithLabelsGroups: /*inputKeysForPlatform*/ ctx[1](/*hint*/ ctx[6]),
            $$slots: {
                default: [
                    $70425d4c951ba058$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(userinputlabel.$$.fragment);
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(userinputlabel, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*hint*/ ctx[6].plus) {
                if (if_block) {
                    if (dirty & /*hintData*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $70425d4c951ba058$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            const userinputlabel_changes = {};
            if (dirty & /*hintData*/ 1) userinputlabel_changes.mouseMotion = /*hint*/ ctx[6].mouse;
            if (dirty & /*hintData*/ 1) userinputlabel_changes.keysWithLabelsGroups = /*inputKeysForPlatform*/ ctx[1](/*hint*/ ctx[6]);
            if (dirty & /*$$scope, hintData*/ 513) userinputlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            userinputlabel.$set(userinputlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(userinputlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(userinputlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(userinputlabel, detaching);
        }
    };
}
// (23:2) {#each hintData as hintGroup, index (hintGroup)}
function $70425d4c951ba058$var$create_each_block(key_1, ctx) {
    let first;
    let t;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let if_block = /*index*/ ctx[5] !== 0 && $70425d4c951ba058$var$create_if_block_1(ctx);
    let each_value_1 = /*hintGroup*/ ctx[3];
    const get_key = (ctx)=>/*hint*/ ctx[6];
    for(let i = 0; i < each_value_1.length; i += 1){
        let child_ctx = $70425d4c951ba058$var$get_each_context_1(ctx, each_value_1, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $70425d4c951ba058$var$create_each_block_1(key, child_ctx));
    }
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*index*/ ctx[5] !== 0) {
                if (if_block) {
                    if (dirty & /*hintData*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $70425d4c951ba058$var$create_if_block_1(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (dirty & /*hintData, inputKeysForPlatform*/ 3) {
                each_value_1 = /*hintGroup*/ ctx[3];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $70425d4c951ba058$var$create_each_block_1, each_1_anchor, $70425d4c951ba058$var$get_each_context_1);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            for(let i = 0; i < each_value_1.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (22:1) <LayoutRow class="hint-groups">
function $70425d4c951ba058$var$create_default_slot_1(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let each_value = /*hintData*/ ctx[0];
    const get_key = (ctx)=>/*hintGroup*/ ctx[3];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $70425d4c951ba058$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $70425d4c951ba058$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*hintData, inputKeysForPlatform*/ 3) {
                each_value = /*hintData*/ ctx[0];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $70425d4c951ba058$var$create_each_block, each_1_anchor, $70425d4c951ba058$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (21:0) <LayoutRow class="status-bar">
function $70425d4c951ba058$var$create_default_slot(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "hint-groups",
            $$slots: {
                default: [
                    $70425d4c951ba058$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, hintData*/ 513) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $70425d4c951ba058$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "status-bar",
            $$slots: {
                default: [
                    $70425d4c951ba058$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, hintData*/ 513) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $70425d4c951ba058$var$instance($$self, $$props, $$invalidate) {
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    let hintData = [];
    function inputKeysForPlatform(hint) {
        if ((0, $7ed52b8c7c886783$export$f205d53822e9a9a9)() && hint.keyGroupsMac) return hint.keyGroupsMac;
        return hint.keyGroups;
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$d1502aedd976985f), (data)=>{
            $$invalidate(0, hintData = data.hintData);
        });
    });
    return [
        hintData,
        inputKeysForPlatform
    ];
}
class $70425d4c951ba058$var$StatusBar extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $70425d4c951ba058$var$instance, $70425d4c951ba058$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $70425d4c951ba058$export$2e2bcd8739ae039 = $70425d4c951ba058$var$StatusBar;


/* src/components/window/title-bar/TitleBar.svelte generated by Svelte v3.58.0 */ 

/* src/components/widgets/inputs/MenuBarInput.svelte generated by Svelte v3.58.0 */ 



/* src/components/floating-menus/MenuList.svelte generated by Svelte v3.58.0 */ 

/* src/components/layout/FloatingMenu.svelte generated by Svelte v3.58.0 */ 


function $ef66a8e69d2c44ad$var$create_if_block_1(ctx) {
    let div_1;
    return {
        c () {
            div_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div_1, "class", "tail");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div_1, anchor);
            /*div_1_binding*/ ctx[27](div_1);
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div_1);
            /*div_1_binding*/ ctx[27](null);
        }
    };
}
// (382:1) {#if displayContainer}
function $ef66a8e69d2c44ad$var$create_if_block(ctx) {
    let div_1;
    let layoutcol;
    let current;
    let layoutcol_props = {
        class: "floating-menu-content",
        styles: {
            "min-width": /*minWidthStyleValue*/ ctx[13]
        },
        scrollableY: /*scrollableY*/ ctx[4],
        "data-floating-menu-content": true,
        $$slots: {
            default: [
                $ef66a8e69d2c44ad$var$create_default_slot
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: layoutcol_props
    });
    /*layoutcol_binding*/ ctx[28](layoutcol);
    return {
        c () {
            div_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div_1, "class", "floating-menu-container");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div_1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, div_1, null);
            /*div_1_binding_1*/ ctx[29](div_1);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty[0] & /*minWidthStyleValue*/ 8192) layoutcol_changes.styles = {
                "min-width": /*minWidthStyleValue*/ ctx[13]
            };
            if (dirty[0] & /*scrollableY*/ 16) layoutcol_changes.scrollableY = /*scrollableY*/ ctx[4];
            if (dirty[1] & /*$$scope*/ 1) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div_1);
            /*layoutcol_binding*/ ctx[28](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol);
            /*div_1_binding_1*/ ctx[29](null);
        }
    };
}
// (384:3) <LayoutCol class="floating-menu-content" styles={{ "min-width": minWidthStyleValue }} {scrollableY} bind:this={floatingMenuContent} data-floating-menu-content>
function $ef66a8e69d2c44ad$var$create_default_slot(ctx) {
    let current;
    const default_slot_template = /*#slots*/ ctx[26].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[31], null);
    return {
        c () {
            if (default_slot) default_slot.c();
        },
        m (target, anchor) {
            if (default_slot) default_slot.m(target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty[1] & /*$$scope*/ 1)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[31], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[31]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[31], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (default_slot) default_slot.d(detaching);
        }
    };
}
function $ef66a8e69d2c44ad$var$create_fragment(ctx) {
    let div_1;
    let t;
    let div_1_class_value;
    let div_1_style_value;
    let current;
    let if_block0 = /*displayTail*/ ctx[12] && $ef66a8e69d2c44ad$var$create_if_block_1(ctx);
    let if_block1 = /*displayContainer*/ ctx[11] && $ef66a8e69d2c44ad$var$create_if_block(ctx);
    let div_1_levels = [
        {
            class: div_1_class_value = `floating-menu ${ctx[3].toLowerCase()} ${ctx[2].toLowerCase()} ${ctx[0]} ${ctx[10]}`.trim()
        },
        {
            style: div_1_style_value = `${ctx[1]} ${ctx[9]}`.trim() || undefined
        },
        /*$$restProps*/ ctx[14]
    ];
    let div_data = {};
    for(let i = 0; i < div_1_levels.length; i += 1)div_data = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(div_data, div_1_levels[i]);
    return {
        c () {
            div_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block0) if_block0.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(div_1, div_data);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div_1, anchor);
            if (if_block0) if_block0.m(div_1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div_1, t);
            if (if_block1) if_block1.m(div_1, null);
            /*div_1_binding_2*/ ctx[30](div_1);
            current = true;
        },
        p (ctx, dirty) {
            if (/*displayTail*/ ctx[12]) {
                if (if_block0) if_block0.p(ctx, dirty);
                else {
                    if_block0 = $ef66a8e69d2c44ad$var$create_if_block_1(ctx);
                    if_block0.c();
                    if_block0.m(div_1, t);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (/*displayContainer*/ ctx[11]) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty[0] & /*displayContainer*/ 2048) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $ef66a8e69d2c44ad$var$create_if_block(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(div_1, null);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(div_1, div_data = (0, $1eb80e36873dc327$export$eea1060726e9ab6)(div_1_levels, [
                (!current || dirty[0] & /*direction, type, className, extraClasses*/ 1037 && div_1_class_value !== (div_1_class_value = `floating-menu ${ctx[3].toLowerCase()} ${ctx[2].toLowerCase()} ${ctx[0]} ${ctx[10]}`.trim())) && {
                    class: div_1_class_value
                },
                (!current || dirty[0] & /*styleName, extraStyles*/ 514 && div_1_style_value !== (div_1_style_value = `${ctx[1]} ${ctx[9]}`.trim() || undefined)) && {
                    style: div_1_style_value
                },
                dirty[0] & /*$$restProps*/ 16384 && /*$$restProps*/ ctx[14]
            ]));
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div_1);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            /*div_1_binding_2*/ ctx[30](null);
        }
    };
}
const $ef66a8e69d2c44ad$var$POINTER_STRAY_DISTANCE = 100;
function $ef66a8e69d2c44ad$var$clickHandlerCapture(e) {
    // Stop the click event from reopening this floating menu if the click event targets the floating menu's button
    e.stopPropagation();
    // Clean up self
    window.removeEventListener("click", $ef66a8e69d2c44ad$var$clickHandlerCapture, true);
}
function $ef66a8e69d2c44ad$var$isPointerEventOutsideMenuElement(e, element, extraDistanceAllowed = 0) {
    const floatingMenuBounds = element.getBoundingClientRect();
    if (floatingMenuBounds.left - e.clientX >= extraDistanceAllowed) return true;
    if (e.clientX - floatingMenuBounds.right >= extraDistanceAllowed) return true;
    if (floatingMenuBounds.top - e.clientY >= extraDistanceAllowed) return true;
    if (e.clientY - floatingMenuBounds.bottom >= extraDistanceAllowed) return true;
    return false;
}
function $ef66a8e69d2c44ad$var$instance($$self, $$props, $$invalidate) {
    let minWidthStyleValue;
    let displayTail;
    let displayContainer;
    let extraClasses;
    let extraStyles;
    const omit_props_names = [
        "class",
        "classes",
        "style",
        "styles",
        "open",
        "type",
        "direction",
        "windowEdgeMargin",
        "scrollableY",
        "minWidth",
        "escapeCloses",
        "strayCloses",
        "div",
        "measureAndEmitNaturalWidth"
    ];
    let $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names);
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    let { style: styleName = "" } = $$props;
    let { styles: styles = {} } = $$props;
    let { open: open } = $$props;
    let { type: type } = $$props;
    let { direction: direction = "Bottom" } = $$props;
    let { windowEdgeMargin: windowEdgeMargin = 6 } = $$props;
    let { scrollableY: scrollableY = false } = $$props;
    let { minWidth: minWidth = 0 } = $$props;
    let { escapeCloses: escapeCloses = true } = $$props;
    let { strayCloses: strayCloses = true } = $$props;
    let tail;
    let self;
    let floatingMenuContainer;
    let floatingMenuContent;
    // The resize observer is attached to the floating menu container, which is the zero-height div of the width of the parent element's floating menu spawner.
    // Since CSS doesn't let us make the floating menu (with `position: fixed`) have a 100% width of this container, we need to use JS to observe its size and
    // tell the floating menu content to use it as a min-width so the floating menu is at least the width of the parent element's floating menu spawner.
    // This is the opposite concern of the natural width measurement system, which gets the natural width of the floating menu content in order for the
    // spawner widget to optionally set its min-size to the floating menu's natural width.
    let containerResizeObserver = new ResizeObserver((entries)=>{
        resizeObserverCallback(entries);
    });
    let wasOpen = open;
    let measuringOngoing = false;
    let measuringOngoingGuard = false;
    let minWidthParentWidth = 0;
    let pointerStillDown = false;
    let workspaceBounds = new DOMRect();
    let floatingMenuBounds = new DOMRect();
    let floatingMenuContentBounds = new DOMRect();
    // Called only when `open` is changed from outside this component
    async function watchOpenChange(isOpen) {
        // Switching from closed to open
        if (isOpen && !wasOpen) {
            // TODO: Close any other floating menus that may already be open, which can happen using tab navigation and Enter/Space Bar to open
            // Close floating menu if pointer strays far enough away
            window.addEventListener("pointermove", pointerMoveHandler);
            // Close floating menu if esc is pressed
            window.addEventListener("keydown", keyDownHandler);
            // Close floating menu if pointer is outside (but within stray distance)
            window.addEventListener("pointerdown", pointerDownHandler);
            // Cancel the subsequent click event to prevent the floating menu from reopening if the floating menu's button is the click event target
            window.addEventListener("pointerup", pointerUpHandler);
            // Floating menu min-width resize observer
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            // Start a new observation of the now-open floating menu
            if (floatingMenuContainer) {
                containerResizeObserver.disconnect();
                containerResizeObserver.observe(floatingMenuContainer);
            }
        }
        // Switching from open to closed
        if (!isOpen && wasOpen) {
            // Clean up observation of the now-closed floating menu
            containerResizeObserver.disconnect();
            window.removeEventListener("pointermove", pointerMoveHandler);
            window.removeEventListener("keydown", keyDownHandler);
            window.removeEventListener("pointerdown", pointerDownHandler);
        } // The `pointerup` event is removed in `pointerMoveHandler()` and `pointerDownHandler()`
        // Now that we're done reading the old state, update it to the current state for next time
        wasOpen = isOpen;
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        // Measure the content and round up its width and height to the nearest even integer.
        // This solves antialiasing issues when the content isn't cleanly divisible by 2 and gets translated by (-50%, -50%) causing all its content to be blurry.
        const floatingMenuContentDiv = floatingMenuContent?.div();
        if (type === "Dialog" && floatingMenuContentDiv) {
            // TODO: Also use https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver to detect any changes which may affect the size of the content.
            // TODO: The current method only notices when the dialog size increases but can't detect when it decreases.
            const resizeObserver = new ResizeObserver((entries)=>{
                entries.forEach((entry)=>{
                    let { width: width, height: height } = entry.contentRect;
                    width = Math.ceil(width);
                    if (width % 2 === 1) width += 1;
                    height = Math.ceil(height);
                    if (height % 2 === 1) height += 1;
                    // We have to set the style properties directly because attempting to do it through a Svelte bound property results in `afterUpdate()` being triggered
                    floatingMenuContentDiv.style.setProperty("min-width", width === 0 ? "unset" : `${width}px`);
                    floatingMenuContentDiv.style.setProperty("min-height", height === 0 ? "unset" : `${height}px`);
                });
            });
            resizeObserver.observe(floatingMenuContentDiv);
        }
    });
    (0, $1eb80e36873dc327$export$f956f39b9a12cea8)(()=>{
        // Remove the size constraint after the content updates so the resize observer can measure the content and reapply a newly calculated one
        const floatingMenuContentDiv = floatingMenuContent?.div();
        if (type === "Dialog" && floatingMenuContentDiv) {
            // We have to set the style properties directly because attempting to do it through a Svelte bound property results in `afterUpdate()` being triggered
            floatingMenuContentDiv.style.setProperty("min-width", "unset");
            floatingMenuContentDiv.style.setProperty("min-height", "unset");
        }
        // Gets the client bounds of the elements and apply relevant styles to them
        // TODO: Use DOM attribute bindings more whilst not causing recursive updates
        // Turning measuring on and off both causes the component to change, which causes the `afterUpdate()` Svelte event to fire extraneous times (hurting performance and sometimes causing an infinite loop)
        if (!measuringOngoingGuard) positionAndStyleFloatingMenu();
    });
    function resizeObserverCallback(entries) {
        $$invalidate(25, minWidthParentWidth = entries[0].contentRect.width);
    }
    function positionAndStyleFloatingMenu() {
        if (type === "Cursor") return;
        const workspace = document.querySelector("[data-workspace]");
        const floatingMenuContentDiv = floatingMenuContent?.div();
        if (!workspace || !self || !floatingMenuContainer || !floatingMenuContent || !floatingMenuContentDiv) return;
        workspaceBounds = workspace.getBoundingClientRect();
        floatingMenuBounds = self.getBoundingClientRect();
        const floatingMenuContainerBounds = floatingMenuContainer.getBoundingClientRect();
        floatingMenuContentBounds = floatingMenuContentDiv.getBoundingClientRect();
        const inParentFloatingMenu = Boolean(floatingMenuContainer.closest("[data-floating-menu-content]"));
        if (!inParentFloatingMenu) {
            // Required to correctly position content when scrolled (it has a `position: fixed` to prevent clipping)
            // We use `.style` on a div (instead of a style DOM attribute binding) because the binding causes the `afterUpdate()` hook to call the function we're in recursively forever
            const tailOffset = type === "Popover" ? 10 : 0;
            if (direction === "Bottom") floatingMenuContentDiv.style.top = `${tailOffset + floatingMenuBounds.top}px`;
            if (direction === "Top") floatingMenuContentDiv.style.bottom = `${tailOffset + floatingMenuBounds.bottom}px`;
            if (direction === "Right") floatingMenuContentDiv.style.left = `${tailOffset + floatingMenuBounds.left}px`;
            if (direction === "Left") floatingMenuContentDiv.style.right = `${tailOffset + floatingMenuBounds.right}px`;
            // Required to correctly position tail when scrolled (it has a `position: fixed` to prevent clipping)
            // We use `.style` on a div (instead of a style DOM attribute binding) because the binding causes the `afterUpdate()` hook to call the function we're in recursively forever
            if (tail && direction === "Bottom") $$invalidate(5, tail.style.top = `${floatingMenuBounds.top}px`, tail);
            if (tail && direction === "Top") $$invalidate(5, tail.style.bottom = `${floatingMenuBounds.bottom}px`, tail);
            if (tail && direction === "Right") $$invalidate(5, tail.style.left = `${floatingMenuBounds.left}px`, tail);
            if (tail && direction === "Left") $$invalidate(5, tail.style.right = `${floatingMenuBounds.right}px`, tail);
        }
        let zeroedBorderVertical;
        let zeroedBorderHorizontal;
        if (direction === "Top" || direction === "Bottom") {
            zeroedBorderVertical = direction === "Top" ? "Bottom" : "Top";
            // We use `.style` on a div (instead of a style DOM attribute binding) because the binding causes the `afterUpdate()` hook to call the function we're in recursively forever
            if (floatingMenuContentBounds.left - windowEdgeMargin <= workspaceBounds.left) {
                floatingMenuContentDiv.style.left = `${windowEdgeMargin}px`;
                if (workspaceBounds.left + floatingMenuContainerBounds.left === 12) zeroedBorderHorizontal = "Left";
            }
            if (floatingMenuContentBounds.right + windowEdgeMargin >= workspaceBounds.right) {
                floatingMenuContentDiv.style.right = `${windowEdgeMargin}px`;
                if (workspaceBounds.right - floatingMenuContainerBounds.right === 12) zeroedBorderHorizontal = "Right";
            }
        }
        if (direction === "Left" || direction === "Right") {
            zeroedBorderHorizontal = direction === "Left" ? "Right" : "Left";
            // We use `.style` on a div (instead of a style DOM attribute binding) because the binding causes the `afterUpdate()` hook to call the function we're in recursively forever
            if (floatingMenuContentBounds.top - windowEdgeMargin <= workspaceBounds.top) {
                floatingMenuContentDiv.style.top = `${windowEdgeMargin}px`;
                if (workspaceBounds.top + floatingMenuContainerBounds.top === 12) zeroedBorderVertical = "Top";
            }
            if (floatingMenuContentBounds.bottom + windowEdgeMargin >= workspaceBounds.bottom) {
                floatingMenuContentDiv.style.bottom = `${windowEdgeMargin}px`;
                if (workspaceBounds.bottom - floatingMenuContainerBounds.bottom === 12) zeroedBorderVertical = "Bottom";
            }
        }
        // Remove the rounded corner from the content where the tail perfectly meets the corner
        if (type === "Popover" && windowEdgeMargin === 6 && zeroedBorderVertical && zeroedBorderHorizontal) // We use `.style` on a div (instead of a style DOM attribute binding) because the binding causes the `afterUpdate()` hook to call the function we're in recursively forever
        switch(`${zeroedBorderVertical}${zeroedBorderHorizontal}`){
            case "TopLeft":
                floatingMenuContentDiv.style.borderTopLeftRadius = "0";
                break;
            case "TopRight":
                floatingMenuContentDiv.style.borderTopRightRadius = "0";
                break;
            case "BottomLeft":
                floatingMenuContentDiv.style.borderBottomLeftRadius = "0";
                break;
            case "BottomRight":
                floatingMenuContentDiv.style.borderBottomRightRadius = "0";
                break;
            default:
                break;
        }
    }
    function div() {
        return self;
    }
    async function measureAndEmitNaturalWidth() {
        if (!measuringOngoingGuard) return;
        // Wait for the changed content which fired the `afterUpdate()` Svelte event to be put into the DOM
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        // Wait until all fonts have been loaded and rendered so measurements of content involving text are accurate
        await document.fonts.ready;
        // Make the component show itself with 0 min-width so it can be measured, and wait until the values have been updated to the DOM
        $$invalidate(24, measuringOngoing = true);
        measuringOngoingGuard = true;
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        // Measure the width of the floating menu content element, if it's currently visible
        // The result will be `undefined` if the menu is invisible, perhaps because an ancestor component is hidden with a falsy Svelte template if condition
        const naturalWidth = floatingMenuContent?.div()?.clientWidth;
        // Turn off measuring mode for the component, which triggers another call to the `afterUpdate()` Svelte event, so we can turn off the protection after that has happened
        $$invalidate(24, measuringOngoing = false);
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        measuringOngoingGuard = false;
        // Notify the parent about the measured natural width
        if (naturalWidth !== undefined && naturalWidth >= 0) dispatch("naturalWidth", naturalWidth);
    }
    function pointerMoveHandler(e) {
        // This element and the element being hovered over
        const target = e.target;
        // Get the spawner element (that which is clicked to spawn this floating menu)
        // Assumes the spawner is a sibling of this FloatingMenu component
        const ownSpawner = self?.parentElement?.querySelector(":scope > [data-floating-menu-spawner]") || undefined;
        // Get the spawner element containing whatever element the user is hovering over now, if there is one
        const targetSpawner = target?.closest("[data-floating-menu-spawner]") || undefined;
        // HOVER TRANSFER
        // Transfer from this open floating menu to a sibling floating menu if the pointer hovers to a valid neighboring floating menu spawner
        hoverTransfer(self, ownSpawner, targetSpawner);
        // POINTER STRAY
        // Close the floating menu if the pointer has strayed far enough from its bounds (and it's not hovering over its own spawner)
        const notHoveringOverOwnSpawner = ownSpawner !== targetSpawner;
        if (strayCloses && notHoveringOverOwnSpawner && isPointerEventOutsideFloatingMenu(e, $ef66a8e69d2c44ad$var$POINTER_STRAY_DISTANCE)) // TODO: Extend this rectangle bounds check to all submenu bounds up the DOM tree since currently submenus disappear
        // TODO: with zero stray distance if the cursor is further than the stray distance from only the top-level menu
        dispatch("open", false);
        // Clean up any messes from lost pointerup events
        const eventIncludesLmb = Boolean(e.buttons & 1);
        if (!open && !eventIncludesLmb) {
            pointerStillDown = false;
            window.removeEventListener("pointerup", pointerUpHandler);
        }
    }
    function hoverTransfer(self, ownSpawner, targetSpawner) {
        // Algorithm pseudo-code to detect and transfer to hover-transferrable floating menu spawners
        // Accompanying diagram: <https://files.keavon.com/-/SpringgreenKnownXantus/capture.png>
        //
        // Check our own parent for descendant spawners
        // Filter out ourself and our children
        // Filter out all with a different distance than our own distance from the currently-being-checked parent
        // How many left?
        //     None -> go up a level and repeat
        //     Some -> is one of them the target?
        //         Yes -> click it and terminate
        //         No -> do nothing and terminate
        // Helper function that gets used below
        const getDepthFromAncestor = (item, ancestor)=>{
            let depth = 1;
            let parent = item.parentElement || undefined;
            while(parent){
                if (parent === ancestor) return depth;
                parent = parent.parentElement || undefined;
                depth += 1;
            }
            return undefined;
        };
        // A list of all the descendant spawners: the spawner for this floating menu plus any spawners belonging to widgets inside this floating menu
        const ownDescendantMenuSpawners = Array.from(self?.parentElement?.querySelectorAll("[data-floating-menu-spawner]") || []);
        // Start with the parent of the spawner for this floating menu and keep widening the search for any other valid spawners that are hover-transferrable
        let currentAncestor = targetSpawner && ownSpawner?.parentElement || undefined;
        while(currentAncestor){
            const ownSpawnerDepthFromCurrentAncestor = ownSpawner && getDepthFromAncestor(ownSpawner, currentAncestor);
            const currentAncestor2 = currentAncestor; // This duplicate variable avoids an ESLint warning
            // Get the list of descendant spawners and filter out invalid possibilities for spawners that are hover-transferrable
            const listOfDescendantSpawners = Array.from(currentAncestor?.querySelectorAll("[data-floating-menu-spawner]") || []);
            const filteredListOfDescendantSpawners = listOfDescendantSpawners.filter((item)=>{
                // Filter away ourself and our descendants
                const notOurself = !ownDescendantMenuSpawners.includes(item);
                // And filter away unequal depths from the current ancestor
                const notUnequalDepths = notOurself && getDepthFromAncestor(item, currentAncestor2) === ownSpawnerDepthFromCurrentAncestor;
                // And filter away elements that explicitly disable hover transfer
                return notUnequalDepths && !item.getAttribute?.("data-floating-menu-spawner")?.includes("no-hover-transfer");
            });
            // If none were found, widen the search by a level and keep trying (or stop looping if the root was reached)
            if (filteredListOfDescendantSpawners.length === 0) currentAncestor = currentAncestor?.parentElement || undefined;
            else {
                const foundTarget = filteredListOfDescendantSpawners.find((item)=>item === targetSpawner);
                // If the currently hovered spawner is one of the found valid hover-transferrable spawners, swap to it by clicking on it
                if (foundTarget) {
                    dispatch("open", false);
                    foundTarget.click();
                }
                break;
            }
        }
    }
    function keyDownHandler(e) {
        if (escapeCloses && e.key.toLowerCase() === "escape") dispatch("open", false);
    }
    function pointerDownHandler(e) {
        // Close the floating menu if the pointer clicked outside the floating menu (but within stray distance)
        if (isPointerEventOutsideFloatingMenu(e)) {
            dispatch("open", false);
            // Track if the left pointer button is now down so its later click event can be canceled
            const eventIsForLmb = e.button === 0;
            if (eventIsForLmb) pointerStillDown = true;
        }
    }
    function pointerUpHandler(e) {
        const eventIsForLmb = e.button === 0;
        if (pointerStillDown && eventIsForLmb) {
            // Clean up self
            pointerStillDown = false;
            window.removeEventListener("pointerup", pointerUpHandler);
            // Prevent the click event from firing, which would normally occur right after this pointerup event
            window.addEventListener("click", $ef66a8e69d2c44ad$var$clickHandlerCapture, true);
        }
    }
    function isPointerEventOutsideFloatingMenu(e, extraDistanceAllowed = 0) {
        // Consider all child menus as well as the top-level one
        const allContainedFloatingMenus = [
            ...self?.querySelectorAll("[data-floating-menu-content]") || []
        ];
        return !allContainedFloatingMenus.find((element)=>!$ef66a8e69d2c44ad$var$isPointerEventOutsideMenuElement(e, element, extraDistanceAllowed));
    }
    function div_1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            tail = $$value;
            $$invalidate(5, tail);
        });
    }
    function layoutcol_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            floatingMenuContent = $$value;
            $$invalidate(8, floatingMenuContent);
        });
    }
    function div_1_binding_1($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            floatingMenuContainer = $$value;
            $$invalidate(7, floatingMenuContainer);
        });
    }
    function div_1_binding_2($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(6, self);
        });
    }
    $$self.$$set = ($$new_props)=>{
        $$props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)((0, $1eb80e36873dc327$export$e6e34fd1f2686227)({}, $$props), (0, $1eb80e36873dc327$export$1b59c714eb8e4c9f)($$new_props));
        $$invalidate(14, $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names));
        if ("class" in $$new_props) $$invalidate(0, className = $$new_props.class);
        if ("classes" in $$new_props) $$invalidate(15, classes = $$new_props.classes);
        if ("style" in $$new_props) $$invalidate(1, styleName = $$new_props.style);
        if ("styles" in $$new_props) $$invalidate(16, styles = $$new_props.styles);
        if ("open" in $$new_props) $$invalidate(17, open = $$new_props.open);
        if ("type" in $$new_props) $$invalidate(2, type = $$new_props.type);
        if ("direction" in $$new_props) $$invalidate(3, direction = $$new_props.direction);
        if ("windowEdgeMargin" in $$new_props) $$invalidate(18, windowEdgeMargin = $$new_props.windowEdgeMargin);
        if ("scrollableY" in $$new_props) $$invalidate(4, scrollableY = $$new_props.scrollableY);
        if ("minWidth" in $$new_props) $$invalidate(19, minWidth = $$new_props.minWidth);
        if ("escapeCloses" in $$new_props) $$invalidate(20, escapeCloses = $$new_props.escapeCloses);
        if ("strayCloses" in $$new_props) $$invalidate(21, strayCloses = $$new_props.strayCloses);
        if ("$$scope" in $$new_props) $$invalidate(31, $$scope = $$new_props.$$scope);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*open*/ 131072) $: watchOpenChange(open);
        if ($$self.$$.dirty[0] & /*measuringOngoing, minWidth, minWidthParentWidth*/ 50855936) $: $$invalidate(13, minWidthStyleValue = measuringOngoing ? "0" : `${Math.max(minWidth, minWidthParentWidth)}px`);
        if ($$self.$$.dirty[0] & /*open, type*/ 131076) $: $$invalidate(12, displayTail = open && type === "Popover");
        if ($$self.$$.dirty[0] & /*open, measuringOngoing*/ 16908288) $: $$invalidate(11, displayContainer = open || measuringOngoing);
        if ($$self.$$.dirty[0] & /*classes*/ 32768) $: $$invalidate(10, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
        if ($$self.$$.dirty[0] & /*styles*/ 65536) $: $$invalidate(9, extraStyles = Object.entries(styles).flatMap((styleAndValue)=>styleAndValue[1] !== undefined ? [
                `${styleAndValue[0]}: ${styleAndValue[1]};`
            ] : []).join(" "));
    };
    return [
        className,
        styleName,
        type,
        direction,
        scrollableY,
        tail,
        self,
        floatingMenuContainer,
        floatingMenuContent,
        extraStyles,
        extraClasses,
        displayContainer,
        displayTail,
        minWidthStyleValue,
        $$restProps,
        classes,
        styles,
        open,
        windowEdgeMargin,
        minWidth,
        escapeCloses,
        strayCloses,
        div,
        measureAndEmitNaturalWidth,
        measuringOngoing,
        minWidthParentWidth,
        slots,
        div_1_binding,
        layoutcol_binding,
        div_1_binding_1,
        div_1_binding_2,
        $$scope
    ];
}
class $ef66a8e69d2c44ad$var$FloatingMenu extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $ef66a8e69d2c44ad$var$instance, $ef66a8e69d2c44ad$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            class: 0,
            classes: 15,
            style: 1,
            styles: 16,
            open: 17,
            type: 2,
            direction: 3,
            windowEdgeMargin: 18,
            scrollableY: 4,
            minWidth: 19,
            escapeCloses: 20,
            strayCloses: 21,
            div: 22,
            measureAndEmitNaturalWidth: 23
        }, null, [
            -1,
            -1
        ]);
    }
    get div() {
        return this.$$.ctx[22];
    }
    get measureAndEmitNaturalWidth() {
        return this.$$.ctx[23];
    }
}
var $ef66a8e69d2c44ad$export$2e2bcd8739ae039 = $ef66a8e69d2c44ad$var$FloatingMenu;








function $c04ba9d0f104d9a2$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[36] = list[i];
    child_ctx[38] = i;
    return child_ctx;
}
function $c04ba9d0f104d9a2$var$get_each_context_1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[39] = list[i];
    child_ctx[40] = list;
    child_ctx[41] = i;
    return child_ctx;
}
// (195:2) {#if virtualScrollingEntryHeight}
function $c04ba9d0f104d9a2$var$create_if_block_8(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "scroll-spacer",
            styles: {
                height: `${ctx[8] * /*virtualScrollingEntryHeight*/ ctx[2]}px`
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty[0] & /*virtualScrollingStartIndex, virtualScrollingEntryHeight*/ 260) layoutrow_changes.styles = {
                height: `${ctx[8] * /*virtualScrollingEntryHeight*/ ctx[2]}px`
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (199:3) {#if sectionIndex > 0}
function $c04ba9d0f104d9a2$var$create_if_block_7(ctx) {
    let separator;
    let current;
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "List",
            direction: "Vertical"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
        }
    };
}
// (214:24) 
function $c04ba9d0f104d9a2$var$create_if_block_6(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "no-icon");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (212:5) {#if entry.icon && drawIcon}
function $c04ba9d0f104d9a2$var$create_if_block_5(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*entry*/ ctx[39].icon,
            class: "entry-icon"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) iconlabel_changes.icon = /*entry*/ ctx[39].icon;
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (218:5) {#if entry.font}
function $c04ba9d0f104d9a2$var$create_if_block_4(ctx) {
    let link;
    let link_href_value;
    return {
        c () {
            link = (0, $1eb80e36873dc327$export$8454457683f90105)("link");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(link, "rel", "stylesheet");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(link, "href", link_href_value = /*entry*/ ctx[39].font?.toString());
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, link, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357 && link_href_value !== (link_href_value = /*entry*/ ctx[39].font?.toString())) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(link, "href", link_href_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(link);
        }
    };
}
// (222:5) <TextLabel class="entry-label" styles={{ "font-family": `${!entry.font ? "inherit" : entry.value}` }}>
function $c04ba9d0f104d9a2$var$create_default_slot_3(ctx) {
    let t_value = /*entry*/ ctx[39].label + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357 && t_value !== (t_value = /*entry*/ ctx[39].label + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (224:5) {#if entry.shortcut?.keys.length}
function $c04ba9d0f104d9a2$var$create_if_block_3(ctx) {
    let userinputlabel;
    let current;
    userinputlabel = new (0, $26bc4a854934ba73$export$2e2bcd8739ae039)({
        props: {
            keysWithLabelsGroups: [
                /*entry*/ ctx[39].shortcut.keys
            ],
            requiresLock: /*entry*/ ctx[39].shortcutRequiresLock,
            textOnly: true
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(userinputlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(userinputlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const userinputlabel_changes = {};
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) userinputlabel_changes.keysWithLabelsGroups = [
                /*entry*/ ctx[39].shortcut.keys
            ];
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) userinputlabel_changes.requiresLock = /*entry*/ ctx[39].shortcutRequiresLock;
            userinputlabel.$set(userinputlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(userinputlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(userinputlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(userinputlabel, detaching);
        }
    };
}
// (230:5) {:else}
function $c04ba9d0f104d9a2$var$create_else_block(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "no-submenu-arrow");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (228:5) {#if entry.children?.length}
function $c04ba9d0f104d9a2$var$create_if_block_2(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            class: "submenu-arrow",
            icon: "DropdownArrow"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (234:5) {#if entry.children}
function $c04ba9d0f104d9a2$var$create_if_block_1(ctx) {
    let menulist;
    let each_value_1 = /*each_value_1*/ ctx[40];
    let entryIndex = /*entryIndex*/ ctx[41];
    let current;
    const assign_menulist = ()=>/*menulist_binding*/ ctx[24](menulist, each_value_1, entryIndex);
    const unassign_menulist = ()=>/*menulist_binding*/ ctx[24](null, each_value_1, entryIndex);
    let menulist_props = {
        open: /*entry*/ ctx[39].ref?.open || false,
        direction: "TopRight",
        entries: /*entry*/ ctx[39].children,
        minWidth: /*minWidth*/ ctx[4],
        drawIcon: /*drawIcon*/ ctx[5],
        scrollableY: /*scrollableY*/ ctx[6]
    };
    menulist = new $c04ba9d0f104d9a2$var$MenuList({
        props: menulist_props
    });
    assign_menulist();
    menulist.$on("naturalWidth", /*naturalWidth_handler_1*/ ctx[25]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(menulist.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(menulist, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (each_value_1 !== /*each_value_1*/ ctx[40] || entryIndex !== /*entryIndex*/ ctx[41]) {
                unassign_menulist();
                each_value_1 = /*each_value_1*/ ctx[40];
                entryIndex = /*entryIndex*/ ctx[41];
                assign_menulist();
            }
            const menulist_changes = {};
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) menulist_changes.open = /*entry*/ ctx[39].ref?.open || false;
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) menulist_changes.entries = /*entry*/ ctx[39].children;
            if (dirty[0] & /*minWidth*/ 16) menulist_changes.minWidth = /*minWidth*/ ctx[4];
            if (dirty[0] & /*drawIcon*/ 32) menulist_changes.drawIcon = /*drawIcon*/ ctx[5];
            if (dirty[0] & /*scrollableY*/ 64) menulist_changes.scrollableY = /*scrollableY*/ ctx[6];
            menulist.$set(menulist_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(menulist.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(menulist.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            unassign_menulist();
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(menulist, detaching);
        }
    };
}
// (203:4) <LayoutRow      class="row"      classes={{ open: isEntryOpen(entry), active: entry.label === highlighted?.label, disabled: Boolean(entry.disabled) }}      styles={{ height: virtualScrollingEntryHeight || "20px" }}      {tooltip}      on:click={() => !entry.disabled && onEntryClick(entry)}      on:pointerenter={() => !entry.disabled && onEntryPointerEnter(entry)}      on:pointerleave={() => !entry.disabled && onEntryPointerLeave(entry)}     >
function $c04ba9d0f104d9a2$var$create_default_slot_2(ctx) {
    let current_block_type_index;
    let if_block0;
    let t0;
    let t1;
    let textlabel;
    let t2;
    let t3;
    let current_block_type_index_1;
    let if_block3;
    let t4;
    let if_block4_anchor;
    let current;
    const if_block_creators = [
        $c04ba9d0f104d9a2$var$create_if_block_5,
        $c04ba9d0f104d9a2$var$create_if_block_6
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*entry*/ ctx[39].icon && /*drawIcon*/ ctx[5]) return 0;
        if (/*drawIcon*/ ctx[5]) return 1;
        return -1;
    }
    if (~(current_block_type_index = select_block_type(ctx, [
        -1,
        -1
    ]))) if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    let if_block1 = /*entry*/ ctx[39].font && $c04ba9d0f104d9a2$var$create_if_block_4(ctx);
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            class: "entry-label",
            styles: {
                "font-family": `${!/*entry*/ ctx[39].font ? "inherit" : /*entry*/ ctx[39].value}`
            },
            $$slots: {
                default: [
                    $c04ba9d0f104d9a2$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let if_block2 = /*entry*/ ctx[39].shortcut?.keys.length && $c04ba9d0f104d9a2$var$create_if_block_3(ctx);
    const if_block_creators_1 = [
        $c04ba9d0f104d9a2$var$create_if_block_2,
        $c04ba9d0f104d9a2$var$create_else_block
    ];
    const if_blocks_1 = [];
    function select_block_type_1(ctx, dirty) {
        if (/*entry*/ ctx[39].children?.length) return 0;
        return 1;
    }
    current_block_type_index_1 = select_block_type_1(ctx, [
        -1,
        -1
    ]);
    if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
    let if_block4 = /*entry*/ ctx[39].children && $c04ba9d0f104d9a2$var$create_if_block_1(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block2) if_block2.c();
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if_block3.c();
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block4) if_block4.c();
            if_block4_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (~current_block_type_index) if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t2, anchor);
            if (if_block2) if_block2.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t3, anchor);
            if_blocks_1[current_block_type_index_1].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t4, anchor);
            if (if_block4) if_block4.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block4_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) {
                if (~current_block_type_index) if_blocks[current_block_type_index].p(ctx, dirty);
            } else {
                if (if_block0) {
                    (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                    (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                        if_blocks[previous_block_index] = null;
                    });
                    (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                }
                if (~current_block_type_index) {
                    if_block0 = if_blocks[current_block_type_index];
                    if (!if_block0) {
                        if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                        if_block0.c();
                    } else if_block0.p(ctx, dirty);
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(t0.parentNode, t0);
                } else if_block0 = null;
            }
            if (/*entry*/ ctx[39].font) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $c04ba9d0f104d9a2$var$create_if_block_4(ctx);
                    if_block1.c();
                    if_block1.m(t1.parentNode, t1);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            const textlabel_changes = {};
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) textlabel_changes.styles = {
                "font-family": `${!/*entry*/ ctx[39].font ? "inherit" : /*entry*/ ctx[39].value}`
            };
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357 | dirty[1] & /*$$scope*/ 2048) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (/*entry*/ ctx[39].shortcut?.keys.length) {
                if (if_block2) {
                    if_block2.p(ctx, dirty);
                    if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2, 1);
                } else {
                    if_block2 = $c04ba9d0f104d9a2$var$create_if_block_3(ctx);
                    if_block2.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2, 1);
                    if_block2.m(t3.parentNode, t3);
                }
            } else if (if_block2) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            let previous_block_index_1 = current_block_type_index_1;
            current_block_type_index_1 = select_block_type_1(ctx, dirty);
            if (current_block_type_index_1 !== previous_block_index_1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks_1[previous_block_index_1], 1, 1, ()=>{
                    if_blocks_1[previous_block_index_1] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block3 = if_blocks_1[current_block_type_index_1];
                if (!if_block3) {
                    if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
                    if_block3.c();
                }
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block3, 1);
                if_block3.m(t4.parentNode, t4);
            }
            if (/*entry*/ ctx[39].children) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex*/ 4357) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block4, 1);
                } else {
                    if_block4 = $c04ba9d0f104d9a2$var$create_if_block_1(ctx);
                    if_block4.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block4, 1);
                    if_block4.m(if_block4_anchor.parentNode, if_block4_anchor);
                }
            } else if (if_block4) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block3);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block4);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block2);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block3);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block4);
            current = false;
        },
        d (detaching) {
            if (~current_block_type_index) if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t2);
            if (if_block2) if_block2.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t3);
            if_blocks_1[current_block_type_index_1].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t4);
            if (if_block4) if_block4.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block4_anchor);
        }
    };
}
// (202:3) {#each virtualScrollingEntryHeight ? section.slice(virtualScrollingStartIndex, virtualScrollingEndIndex) : section as entry, entryIndex (entryIndex + (virtualScrollingEntryHeight ? virtualScrollingStartIndex : 0))}
function $c04ba9d0f104d9a2$var$create_each_block_1(key_1, ctx) {
    let first;
    let layoutrow;
    let current;
    function click_handler() {
        return /*click_handler*/ ctx[26](/*entry*/ ctx[39]);
    }
    function pointerenter_handler() {
        return /*pointerenter_handler*/ ctx[27](/*entry*/ ctx[39]);
    }
    function pointerleave_handler() {
        return /*pointerleave_handler*/ ctx[28](/*entry*/ ctx[39]);
    }
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "row",
            classes: {
                open: $c04ba9d0f104d9a2$var$isEntryOpen(/*entry*/ ctx[39]),
                active: /*entry*/ ctx[39].label === /*highlighted*/ ctx[11]?.label,
                disabled: Boolean(/*entry*/ ctx[39].disabled)
            },
            styles: {
                height: /*virtualScrollingEntryHeight*/ ctx[2] || "20px"
            },
            tooltip: /*tooltip*/ ctx[7],
            $$slots: {
                default: [
                    $c04ba9d0f104d9a2$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow.$on("click", click_handler);
    layoutrow.$on("pointerenter", pointerenter_handler);
    layoutrow.$on("pointerleave", pointerleave_handler);
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const layoutrow_changes = {};
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex, highlighted*/ 6405) layoutrow_changes.classes = {
                open: $c04ba9d0f104d9a2$var$isEntryOpen(/*entry*/ ctx[39]),
                active: /*entry*/ ctx[39].label === /*highlighted*/ ctx[11]?.label,
                disabled: Boolean(/*entry*/ ctx[39].disabled)
            };
            if (dirty[0] & /*virtualScrollingEntryHeight*/ 4) layoutrow_changes.styles = {
                height: /*virtualScrollingEntryHeight*/ ctx[2] || "20px"
            };
            if (dirty[0] & /*tooltip*/ 128) layoutrow_changes.tooltip = /*tooltip*/ ctx[7];
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex, minWidth, drawIcon, scrollableY*/ 4469 | dirty[1] & /*$$scope*/ 2048) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (198:2) {#each entries as section, sectionIndex (sectionIndex)}
function $c04ba9d0f104d9a2$var$create_each_block(key_1, ctx) {
    let first;
    let t;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let if_block = /*sectionIndex*/ ctx[38] > 0 && $c04ba9d0f104d9a2$var$create_if_block_7(ctx);
    let each_value_1 = /*virtualScrollingEntryHeight*/ ctx[2] ? /*section*/ ctx[36].slice(/*virtualScrollingStartIndex*/ ctx[8], /*virtualScrollingEndIndex*/ ctx[12]) : /*section*/ ctx[36];
    const get_key = (ctx)=>/*entryIndex*/ ctx[41] + /*virtualScrollingEntryHeight*/ (ctx[2] ? /*virtualScrollingStartIndex*/ ctx[8] : 0);
    for(let i = 0; i < each_value_1.length; i += 1){
        let child_ctx = $c04ba9d0f104d9a2$var$get_each_context_1(ctx, each_value_1, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $c04ba9d0f104d9a2$var$create_each_block_1(key, child_ctx));
    }
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*sectionIndex*/ ctx[38] > 0) {
                if (if_block) {
                    if (dirty[0] & /*entries*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $c04ba9d0f104d9a2$var$create_if_block_7(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex, highlighted, tooltip, onEntryClick, onEntryPointerEnter, onEntryPointerLeave, minWidth, drawIcon, scrollableY*/ 236021) {
                each_value_1 = /*virtualScrollingEntryHeight*/ ctx[2] ? /*section*/ ctx[36].slice(/*virtualScrollingStartIndex*/ ctx[8], /*virtualScrollingEndIndex*/ ctx[12]) : /*section*/ ctx[36];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $c04ba9d0f104d9a2$var$create_each_block_1, each_1_anchor, $c04ba9d0f104d9a2$var$get_each_context_1);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            for(let i = 0; i < each_value_1.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (241:2) {#if virtualScrollingEntryHeight}
function $c04ba9d0f104d9a2$var$create_if_block(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "scroll-spacer",
            styles: {
                height: `${ctx[13] - /*virtualScrollingEndIndex*/ ctx[12] * /*virtualScrollingEntryHeight*/ ctx[2]}px`
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty[0] & /*virtualScrollingTotalHeight, virtualScrollingEndIndex, virtualScrollingEntryHeight*/ 12292) layoutrow_changes.styles = {
                height: `${ctx[13] - /*virtualScrollingEndIndex*/ ctx[12] * /*virtualScrollingEntryHeight*/ ctx[2]}px`
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (189:1) <LayoutCol   bind:this={scroller}   scrollableY={scrollableY && virtualScrollingEntryHeight !== 0}   on:scroll={onScroll}   styles={{ "min-width": virtualScrollingEntryHeight ? `${minWidth}px` : `inherit` }}  >
function $c04ba9d0f104d9a2$var$create_default_slot_1(ctx) {
    let t0;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let t1;
    let if_block1_anchor;
    let current;
    let if_block0 = /*virtualScrollingEntryHeight*/ ctx[2] && $c04ba9d0f104d9a2$var$create_if_block_8(ctx);
    let each_value = /*entries*/ ctx[0];
    const get_key = (ctx)=>/*sectionIndex*/ ctx[38];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $c04ba9d0f104d9a2$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $c04ba9d0f104d9a2$var$create_each_block(key, child_ctx));
    }
    let if_block1 = /*virtualScrollingEntryHeight*/ ctx[2] && $c04ba9d0f104d9a2$var$create_if_block(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            if_block1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*virtualScrollingEntryHeight*/ ctx[2]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty[0] & /*virtualScrollingEntryHeight*/ 4) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $c04ba9d0f104d9a2$var$create_if_block_8(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(t0.parentNode, t0);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (dirty[0] & /*virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, virtualScrollingEndIndex, highlighted, tooltip, onEntryClick, onEntryPointerEnter, onEntryPointerLeave, minWidth, drawIcon, scrollableY*/ 236021) {
                each_value = /*entries*/ ctx[0];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, t1.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $c04ba9d0f104d9a2$var$create_each_block, t1, $c04ba9d0f104d9a2$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*virtualScrollingEntryHeight*/ ctx[2]) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty[0] & /*virtualScrollingEntryHeight*/ 4) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $c04ba9d0f104d9a2$var$create_if_block(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            current = false;
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block1_anchor);
        }
    };
}
// (174:0) <FloatingMenu  class="menu-list"  {open}  on:open={({ detail }) => (open = detail)}  on:naturalWidth  type="Dropdown"  windowEdgeMargin={0}  escapeCloses={false}  {direction}  {minWidth}  scrollableY={scrollableY && virtualScrollingEntryHeight === 0}  bind:this={self} >
function $c04ba9d0f104d9a2$var$create_default_slot(ctx) {
    let layoutcol;
    let current;
    let layoutcol_props = {
        scrollableY: /*scrollableY*/ ctx[6] && /*virtualScrollingEntryHeight*/ ctx[2] !== 0,
        styles: {
            "min-width": /*virtualScrollingEntryHeight*/ ctx[2] ? `${ctx[4]}px` : `inherit`
        },
        $$slots: {
            default: [
                $c04ba9d0f104d9a2$var$create_default_slot_1
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: layoutcol_props
    });
    /*layoutcol_binding*/ ctx[29](layoutcol);
    layoutcol.$on("scroll", /*onScroll*/ ctx[14]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty[0] & /*scrollableY, virtualScrollingEntryHeight*/ 68) layoutcol_changes.scrollableY = /*scrollableY*/ ctx[6] && /*virtualScrollingEntryHeight*/ ctx[2] !== 0;
            if (dirty[0] & /*virtualScrollingEntryHeight, minWidth*/ 20) layoutcol_changes.styles = {
                "min-width": /*virtualScrollingEntryHeight*/ ctx[2] ? `${ctx[4]}px` : `inherit`
            };
            if (dirty[0] & /*virtualScrollingTotalHeight, virtualScrollingEndIndex, virtualScrollingEntryHeight, entries, virtualScrollingStartIndex, highlighted, tooltip, minWidth, drawIcon, scrollableY*/ 14837 | dirty[1] & /*$$scope*/ 2048) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*layoutcol_binding*/ ctx[29](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
function $c04ba9d0f104d9a2$var$create_fragment(ctx) {
    let floatingmenu;
    let current;
    let floatingmenu_props = {
        class: "menu-list",
        open: /*open*/ ctx[1],
        type: "Dropdown",
        windowEdgeMargin: 0,
        escapeCloses: false,
        direction: /*direction*/ ctx[3],
        minWidth: /*minWidth*/ ctx[4],
        scrollableY: /*scrollableY*/ ctx[6] && /*virtualScrollingEntryHeight*/ ctx[2] === 0,
        $$slots: {
            default: [
                $c04ba9d0f104d9a2$var$create_default_slot
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    floatingmenu = new (0, $ef66a8e69d2c44ad$export$2e2bcd8739ae039)({
        props: floatingmenu_props
    });
    /*floatingmenu_binding*/ ctx[30](floatingmenu);
    floatingmenu.$on("open", /*open_handler*/ ctx[31]);
    floatingmenu.$on("naturalWidth", /*naturalWidth_handler*/ ctx[32]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(floatingmenu.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(floatingmenu, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const floatingmenu_changes = {};
            if (dirty[0] & /*open*/ 2) floatingmenu_changes.open = /*open*/ ctx[1];
            if (dirty[0] & /*direction*/ 8) floatingmenu_changes.direction = /*direction*/ ctx[3];
            if (dirty[0] & /*minWidth*/ 16) floatingmenu_changes.minWidth = /*minWidth*/ ctx[4];
            if (dirty[0] & /*scrollableY, virtualScrollingEntryHeight*/ 68) floatingmenu_changes.scrollableY = /*scrollableY*/ ctx[6] && /*virtualScrollingEntryHeight*/ ctx[2] === 0;
            if (dirty[0] & /*scrollableY, virtualScrollingEntryHeight, minWidth, scroller, virtualScrollingTotalHeight, virtualScrollingEndIndex, entries, virtualScrollingStartIndex, highlighted, tooltip, drawIcon*/ 15861 | dirty[1] & /*$$scope*/ 2048) floatingmenu_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            floatingmenu.$set(floatingmenu_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(floatingmenu.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(floatingmenu.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*floatingmenu_binding*/ ctx[30](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(floatingmenu, detaching);
        }
    };
}
function $c04ba9d0f104d9a2$var$isEntryOpen(menuListEntry) {
    if (!menuListEntry.children?.length) return false;
    return menuListEntry.ref?.open || false;
}
function $c04ba9d0f104d9a2$var$instance($$self, $$props, $$invalidate) {
    let virtualScrollingTotalHeight;
    let virtualScrollingStartIndex;
    let virtualScrollingEndIndex;
    let self;
    let scroller;
    // emits: ["update:open", "update:activeEntry", "naturalWidth"],
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { entries: entries } = $$props;
    let { activeEntry: activeEntry } = $$props;
    let { open: open } = $$props;
    let { direction: direction = "Bottom" } = $$props;
    let { minWidth: minWidth = 0 } = $$props;
    let { drawIcon: drawIcon = false } = $$props;
    let { interactive: interactive = false } = $$props;
    let { scrollableY: scrollableY = false } = $$props;
    let { virtualScrollingEntryHeight: virtualScrollingEntryHeight = 0 } = $$props;
    let { tooltip: tooltip } = $$props;
    let highlighted = activeEntry;
    let virtualScrollingEntriesStart = 0;
    function watchOpen(open) {
        $$invalidate(11, highlighted = activeEntry);
        dispatch("open", open);
    }
    function watchRemeasureWidth(_, __) {
        self?.measureAndEmitNaturalWidth();
    }
    function onScroll(e) {
        if (!virtualScrollingEntryHeight) return;
        $$invalidate(23, virtualScrollingEntriesStart = e.target?.scrollTop || 0);
    }
    function onEntryClick(menuListEntry) {
        // Call the action if available
        if (menuListEntry.action) menuListEntry.action();
        // Notify the parent about the clicked entry as the new active entry
        dispatch("activeEntry", menuListEntry);
        // Close the containing menu
        if (menuListEntry.ref) {
            menuListEntry.ref.open = false;
            $$invalidate(0, entries);
        }
        dispatch("open", false);
        $$invalidate(1, open = false);
    }
    function onEntryPointerEnter(menuListEntry) {
        if (!menuListEntry.children?.length) return;
        if (menuListEntry.ref) {
            menuListEntry.ref.open = true;
            $$invalidate(0, entries);
        } else dispatch("open", true);
    }
    function onEntryPointerLeave(menuListEntry) {
        if (!menuListEntry.children?.length) return;
        if (menuListEntry.ref) {
            menuListEntry.ref.open = false;
            $$invalidate(0, entries);
        } else dispatch("open", false);
    }
    function keydown(e, submenu) {
        // Interactive menus should keep the active entry the same as the highlighted one
        if (interactive) $$invalidate(11, highlighted = activeEntry);
        const menuOpen = open;
        const flatEntries = entries.flat().filter((entry)=>!entry.disabled);
        const openChild = flatEntries.findIndex((entry)=>entry.children?.length && entry.ref?.open);
        const openSubmenu = (highlightedEntry)=>{
            if (highlightedEntry.ref && highlightedEntry.children?.length) {
                highlightedEntry.ref.open = true;
                // The reason we bother taking `highlightdEntry` as an argument is because, when this function is called, it can ensure `highlightedEntry` is not undefined.
                // But here we still have to set `highlighted` to itself so Svelte knows to reactively update it after we set its `.ref.open` property.
                $$invalidate(11, highlighted);
                // Highlight first item
                highlightedEntry.ref.setHighlighted(highlightedEntry.children[0][0]);
            }
        };
        if (!menuOpen && (e.key === " " || e.key === "Enter")) {
            // Allow opening menu with space or enter
            $$invalidate(1, open = true);
            $$invalidate(11, highlighted = activeEntry);
        } else if (menuOpen && openChild >= 0) {
            // Redirect the keyboard navigation to a submenu if one is open
            const shouldCloseStack = flatEntries[openChild].ref?.keydown(e, true);
            // Highlight the menu item in the parent list that corresponds with the open submenu
            if (e.key !== "Escape" && highlighted) setHighlighted(flatEntries[openChild]);
            // Handle the child closing the entire menu stack
            if (shouldCloseStack) {
                $$invalidate(1, open = false);
                return true;
            }
        } else if ((menuOpen || interactive) && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
            // Navigate to the next and previous entries with arrow keys
            let newIndex = e.key === "ArrowUp" ? flatEntries.length - 1 : 0;
            if (highlighted) {
                const index = highlighted ? flatEntries.map((entry)=>entry.label).indexOf(highlighted.label) : 0;
                newIndex = index + (e.key === "ArrowUp" ? -1 : 1);
                // Interactive dropdowns should lock at the end whereas other dropdowns should loop
                if (interactive) newIndex = Math.min(flatEntries.length - 1, Math.max(0, newIndex));
                else newIndex = (newIndex + flatEntries.length) % flatEntries.length;
            }
            const newEntry = flatEntries[newIndex];
            setHighlighted(newEntry);
        } else if (menuOpen && e.key === "Escape") {
            // Close menu with escape key
            $$invalidate(1, open = false);
            // Reset active to before open
            setHighlighted(activeEntry);
        } else if (menuOpen && highlighted && e.key === "Enter") {
            // Handle clicking on an option if enter is pressed
            if (!highlighted.children?.length) onEntryClick(highlighted);
            else openSubmenu(highlighted);
            // Stop the event from triggering a press on a new dialog
            e.preventDefault();
            // Enter should close the entire menu stack
            return true;
        } else if (menuOpen && highlighted && e.key === "ArrowRight") // Right arrow opens a submenu
        openSubmenu(highlighted);
        else if (menuOpen && e.key === "ArrowLeft") // Left arrow closes a submenu
        {
            if (submenu) $$invalidate(1, open = false);
        }
        // By default, keep the menu stack open
        return false;
    }
    function setHighlighted(newHighlight) {
        $$invalidate(11, highlighted = newHighlight);
        // Interactive menus should keep the active entry the same as the highlighted one
        if (interactive && newHighlight?.value !== activeEntry?.value && newHighlight) dispatch("activeEntry", newHighlight);
    }
    function scrollViewTo(distanceDown) {
        scroller?.div()?.scrollTo(0, distanceDown);
    }
    function menulist_binding($$value, each_value_1, entryIndex) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            each_value_1[entryIndex].ref = $$value;
            $$invalidate(2, virtualScrollingEntryHeight);
            $$invalidate(0, entries);
            $$invalidate(8, virtualScrollingStartIndex), $$invalidate(23, virtualScrollingEntriesStart), $$invalidate(2, virtualScrollingEntryHeight);
            $$invalidate(12, virtualScrollingEndIndex), $$invalidate(0, entries), $$invalidate(8, virtualScrollingStartIndex), $$invalidate(2, virtualScrollingEntryHeight), $$invalidate(23, virtualScrollingEntriesStart);
        });
    }
    function naturalWidth_handler_1(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    const click_handler = (entry)=>!entry.disabled && onEntryClick(entry);
    const pointerenter_handler = (entry)=>!entry.disabled && onEntryPointerEnter(entry);
    const pointerleave_handler = (entry)=>!entry.disabled && onEntryPointerLeave(entry);
    function layoutcol_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            scroller = $$value;
            $$invalidate(10, scroller);
        });
    }
    function floatingmenu_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(9, self);
        });
    }
    const open_handler = ({ detail: detail })=>$$invalidate(1, open = detail);
    function naturalWidth_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("entries" in $$props) $$invalidate(0, entries = $$props.entries);
        if ("activeEntry" in $$props) $$invalidate(18, activeEntry = $$props.activeEntry);
        if ("open" in $$props) $$invalidate(1, open = $$props.open);
        if ("direction" in $$props) $$invalidate(3, direction = $$props.direction);
        if ("minWidth" in $$props) $$invalidate(4, minWidth = $$props.minWidth);
        if ("drawIcon" in $$props) $$invalidate(5, drawIcon = $$props.drawIcon);
        if ("interactive" in $$props) $$invalidate(19, interactive = $$props.interactive);
        if ("scrollableY" in $$props) $$invalidate(6, scrollableY = $$props.scrollableY);
        if ("virtualScrollingEntryHeight" in $$props) $$invalidate(2, virtualScrollingEntryHeight = $$props.virtualScrollingEntryHeight);
        if ("tooltip" in $$props) $$invalidate(7, tooltip = $$props.tooltip);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*open*/ 2) // Called only when `open` is changed from outside this component
        $: watchOpen(open);
        if ($$self.$$.dirty[0] & /*entries, drawIcon*/ 33) $: watchRemeasureWidth(entries, drawIcon);
        if ($$self.$$.dirty[0] & /*entries, virtualScrollingEntryHeight*/ 5) $: $$invalidate(13, virtualScrollingTotalHeight = entries.length === 0 ? 0 : entries[0].length * virtualScrollingEntryHeight);
        if ($$self.$$.dirty[0] & /*virtualScrollingEntriesStart, virtualScrollingEntryHeight*/ 8388612) $: $$invalidate(8, virtualScrollingStartIndex = Math.floor(virtualScrollingEntriesStart / virtualScrollingEntryHeight) || 0);
        if ($$self.$$.dirty[0] & /*entries, virtualScrollingStartIndex, virtualScrollingEntryHeight*/ 261) $: $$invalidate(12, virtualScrollingEndIndex = entries.length === 0 ? 0 : Math.min(entries[0].length, virtualScrollingStartIndex + 1 + 400 / virtualScrollingEntryHeight));
    };
    return [
        entries,
        open,
        virtualScrollingEntryHeight,
        direction,
        minWidth,
        drawIcon,
        scrollableY,
        tooltip,
        virtualScrollingStartIndex,
        self,
        scroller,
        highlighted,
        virtualScrollingEndIndex,
        virtualScrollingTotalHeight,
        onScroll,
        onEntryClick,
        onEntryPointerEnter,
        onEntryPointerLeave,
        activeEntry,
        interactive,
        keydown,
        setHighlighted,
        scrollViewTo,
        virtualScrollingEntriesStart,
        menulist_binding,
        naturalWidth_handler_1,
        click_handler,
        pointerenter_handler,
        pointerleave_handler,
        layoutcol_binding,
        floatingmenu_binding,
        open_handler,
        naturalWidth_handler
    ];
}
class $c04ba9d0f104d9a2$var$MenuList extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $c04ba9d0f104d9a2$var$instance, $c04ba9d0f104d9a2$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            entries: 0,
            activeEntry: 18,
            open: 1,
            direction: 3,
            minWidth: 4,
            drawIcon: 5,
            interactive: 19,
            scrollableY: 6,
            virtualScrollingEntryHeight: 2,
            tooltip: 7,
            keydown: 20,
            setHighlighted: 21,
            scrollViewTo: 22
        }, null, [
            -1,
            -1
        ]);
    }
    get entries() {
        return this.$$.ctx[0];
    }
    set entries(entries) {
        this.$$set({
            entries: entries
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get activeEntry() {
        return this.$$.ctx[18];
    }
    set activeEntry(activeEntry) {
        this.$$set({
            activeEntry: activeEntry
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get open() {
        return this.$$.ctx[1];
    }
    set open(open) {
        this.$$set({
            open: open
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get direction() {
        return this.$$.ctx[3];
    }
    set direction(direction) {
        this.$$set({
            direction: direction
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get minWidth() {
        return this.$$.ctx[4];
    }
    set minWidth(minWidth) {
        this.$$set({
            minWidth: minWidth
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get drawIcon() {
        return this.$$.ctx[5];
    }
    set drawIcon(drawIcon) {
        this.$$set({
            drawIcon: drawIcon
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get interactive() {
        return this.$$.ctx[19];
    }
    set interactive(interactive) {
        this.$$set({
            interactive: interactive
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get scrollableY() {
        return this.$$.ctx[6];
    }
    set scrollableY(scrollableY) {
        this.$$set({
            scrollableY: scrollableY
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get virtualScrollingEntryHeight() {
        return this.$$.ctx[2];
    }
    set virtualScrollingEntryHeight(virtualScrollingEntryHeight) {
        this.$$set({
            virtualScrollingEntryHeight: virtualScrollingEntryHeight
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get tooltip() {
        return this.$$.ctx[7];
    }
    set tooltip(tooltip) {
        this.$$set({
            tooltip: tooltip
        });
        (0, $1eb80e36873dc327$export$4909b86c8034bf73)();
    }
    get keydown() {
        return this.$$.ctx[20];
    }
    get setHighlighted() {
        return this.$$.ctx[21];
    }
    get scrollViewTo() {
        return this.$$.ctx[22];
    }
}
var $c04ba9d0f104d9a2$export$2e2bcd8739ae039 = $c04ba9d0f104d9a2$var$MenuList;




function $72e2ca1f3b4dc315$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[9] = list[i];
    child_ctx[10] = list;
    child_ctx[11] = i;
    return child_ctx;
}
// (73:4) {#if entry.icon}
function $72e2ca1f3b4dc315$var$create_if_block_2(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*entry*/ ctx[9].icon
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*entries*/ 1) iconlabel_changes.icon = /*entry*/ ctx[9].icon;
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (76:4) {#if entry.label}
function $72e2ca1f3b4dc315$var$create_if_block_1(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $72e2ca1f3b4dc315$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, entries*/ 4097) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (77:5) <TextLabel>
function $72e2ca1f3b4dc315$var$create_default_slot(ctx) {
    let t_value = /*entry*/ ctx[9].label + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*entries*/ 1 && t_value !== (t_value = /*entry*/ ctx[9].label + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (80:3) {#if entry.children && entry.children.length > 0}
function $72e2ca1f3b4dc315$var$create_if_block(ctx) {
    let menulist;
    let each_value = /*each_value*/ ctx[10];
    let index = /*index*/ ctx[11];
    let current;
    const assign_menulist = ()=>/*menulist_binding*/ ctx[4](menulist, each_value, index);
    const unassign_menulist = ()=>/*menulist_binding*/ ctx[4](null, each_value, index);
    function open_handler(...args) {
        return /*open_handler*/ ctx[5](/*entry*/ ctx[9], /*each_value*/ ctx[10], /*index*/ ctx[11], ...args);
    }
    let menulist_props = {
        open: /*entry*/ ctx[9].ref?.open || false,
        entries: /*entry*/ ctx[9].children || [],
        direction: "Bottom",
        minWidth: 240,
        drawIcon: true
    };
    menulist = new (0, $c04ba9d0f104d9a2$export$2e2bcd8739ae039)({
        props: menulist_props
    });
    assign_menulist();
    menulist.$on("open", open_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(menulist.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(menulist, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (each_value !== /*each_value*/ ctx[10] || index !== /*index*/ ctx[11]) {
                unassign_menulist();
                each_value = /*each_value*/ ctx[10];
                index = /*index*/ ctx[11];
                assign_menulist();
            }
            const menulist_changes = {};
            if (dirty & /*entries*/ 1) menulist_changes.open = /*entry*/ ctx[9].ref?.open || false;
            if (dirty & /*entries*/ 1) menulist_changes.entries = /*entry*/ ctx[9].children || [];
            menulist.$set(menulist_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(menulist.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(menulist.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            unassign_menulist();
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(menulist, detaching);
        }
    };
}
// (62:1) {#each entries as entry, index (index)}
function $72e2ca1f3b4dc315$var$create_each_block(key_1, ctx) {
    let div1;
    let div0;
    let t0;
    let div0_data_floating_menu_spawner_value;
    let t1;
    let t2;
    let current;
    let mounted;
    let dispose;
    let if_block0 = /*entry*/ ctx[9].icon && $72e2ca1f3b4dc315$var$create_if_block_2(ctx);
    let if_block1 = /*entry*/ ctx[9].label && $72e2ca1f3b4dc315$var$create_if_block_1(ctx);
    function click_handler(...args) {
        return /*click_handler*/ ctx[2](/*entry*/ ctx[9], ...args);
    }
    function keydown_handler(...args) {
        return /*keydown_handler*/ ctx[3](/*entry*/ ctx[9], ...args);
    }
    let if_block2 = /*entry*/ ctx[9].children && /*entry*/ ctx[9].children.length > 0 && $72e2ca1f3b4dc315$var$create_if_block(ctx);
    return {
        key: key_1,
        first: null,
        c () {
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block0) if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block2) if_block2.c();
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "entry");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "tabindex", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "data-floating-menu-spawner", div0_data_floating_menu_spawner_value = /*entry*/ ctx[9].children && /*entry*/ ctx[9].children.length > 0 ? "" : "no-hover-transfer");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div0, "open", /*entry*/ ctx[9].ref?.open);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "entry-container");
            this.first = div1;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div1, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, div0);
            if (if_block0) if_block0.m(div0, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div0, t0);
            if (if_block1) if_block1.m(div0, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t1);
            if (if_block2) if_block2.m(div1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t2);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div0, "click", click_handler),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div0, "keydown", keydown_handler)
                ];
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*entry*/ ctx[9].icon) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*entries*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $72e2ca1f3b4dc315$var$create_if_block_2(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(div0, t0);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*entry*/ ctx[9].label) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*entries*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $72e2ca1f3b4dc315$var$create_if_block_1(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(div0, null);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (!current || dirty & /*entries*/ 1 && div0_data_floating_menu_spawner_value !== (div0_data_floating_menu_spawner_value = /*entry*/ ctx[9].children && /*entry*/ ctx[9].children.length > 0 ? "" : "no-hover-transfer")) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "data-floating-menu-spawner", div0_data_floating_menu_spawner_value);
            if (!current || dirty & /*entries*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div0, "open", /*entry*/ ctx[9].ref?.open);
            if (/*entry*/ ctx[9].children && /*entry*/ ctx[9].children.length > 0) {
                if (if_block2) {
                    if_block2.p(ctx, dirty);
                    if (dirty & /*entries*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2, 1);
                } else {
                    if_block2 = $72e2ca1f3b4dc315$var$create_if_block(ctx);
                    if_block2.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2, 1);
                    if_block2.m(div1, t2);
                }
            } else if (if_block2) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block2);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div1);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
function $72e2ca1f3b4dc315$var$create_fragment(ctx) {
    let div;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let current;
    let each_value = /*entries*/ ctx[0];
    const get_key = (ctx)=>/*index*/ ctx[11];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $72e2ca1f3b4dc315$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $72e2ca1f3b4dc315$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "menu-bar-input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "data-menu-bar-input", "");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (dirty & /*entries, clickEntry*/ 3) {
                each_value = /*entries*/ ctx[0];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $72e2ca1f3b4dc315$var$create_each_block, null, $72e2ca1f3b4dc315$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d();
        }
    };
}
function $72e2ca1f3b4dc315$var$instance($$self, $$props, $$invalidate) {
    const accelKey = (0, $7ed52b8c7c886783$export$f205d53822e9a9a9)() ? "Command" : "Control";
    const LOCK_REQUIRING_SHORTCUTS = [
        [
            accelKey,
            "KeyW"
        ],
        [
            accelKey,
            "KeyN"
        ],
        [
            accelKey,
            "Shift",
            "KeyN"
        ],
        [
            accelKey,
            "KeyT"
        ],
        [
            accelKey,
            "Shift",
            "KeyT"
        ]
    ];
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    let entries = [];
    function clickEntry(menuListEntry, e) {
        // If there's no menu to open, trigger the action but don't try to open its non-existant children
        if (!menuListEntry.children || menuListEntry.children.length === 0) {
            if (menuListEntry.action && !menuListEntry.disabled) menuListEntry.action();
            return;
        }
        // Focus the target so that keyboard inputs are sent to the dropdown
        e.target?.focus();
        if (menuListEntry.ref) {
            menuListEntry.ref.open = true;
            $$invalidate(0, entries);
        } else throw new Error("The menu bar floating menu has no associated ref");
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$b93b090e7b2f51fd), (updateMenuBarLayout)=>{
            const arraysEqual = (a, b)=>a.length === b.length && a.every((aValue, i)=>aValue === b[i]);
            const shortcutRequiresLock = (shortcut)=>{
                const shortcutKeys = shortcut.map((keyWithLabel)=>keyWithLabel.key);
                // If this shortcut matches any of the browser-reserved shortcuts
                return LOCK_REQUIRING_SHORTCUTS.some((lockKeyCombo)=>arraysEqual(shortcutKeys, lockKeyCombo));
            };
            const menuBarEntryToMenuListEntry = (entry)=>({
                    // From `MenuEntryCommon`
                    ...entry,
                    // Shared names with fields that need to be converted from the type used in `MenuBarEntry` to that of `MenuListEntry`
                    action: ()=>editor.instance.updateLayout(updateMenuBarLayout.layoutTarget, entry.action.widgetId, undefined),
                    children: entry.children ? entry.children.map((entries)=>entries.map((entry)=>menuBarEntryToMenuListEntry(entry))) : undefined,
                    // New fields in `MenuListEntry`
                    shortcutRequiresLock: entry.shortcut ? shortcutRequiresLock(entry.shortcut.keys) : undefined,
                    value: undefined,
                    disabled: entry.disabled ?? undefined,
                    font: undefined,
                    ref: undefined
                });
            $$invalidate(0, entries = updateMenuBarLayout.layout.map(menuBarEntryToMenuListEntry));
        });
    });
    const click_handler = (entry, e)=>clickEntry(entry, e);
    const keydown_handler = (entry, e)=>entry.ref?.keydown(e, false);
    function menulist_binding($$value, each_value, index) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            each_value[index].ref = $$value;
            $$invalidate(0, entries);
        });
    }
    const open_handler = (entry, each_value, index, { detail: detail })=>{
        if (entry.ref) {
            $$invalidate(0, each_value[index].ref.open = detail, entries);
            $$invalidate(0, entries);
        }
    };
    return [
        entries,
        clickEntry,
        click_handler,
        keydown_handler,
        menulist_binding,
        open_handler
    ];
}
class $72e2ca1f3b4dc315$var$MenuBarInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $72e2ca1f3b4dc315$var$instance, $72e2ca1f3b4dc315$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $72e2ca1f3b4dc315$export$2e2bcd8739ae039 = $72e2ca1f3b4dc315$var$MenuBarInput;


/* src/components/window/title-bar/WindowButtonsMac.svelte generated by Svelte v3.58.0 */ 

function $0f4e5b97f458411e$var$create_default_slot(ctx) {
    let div0;
    let t0;
    let div1;
    let div1_title_value;
    let t1;
    let div2;
    return {
        c () {
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "close");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "title", "Close");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "minimize");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "title", div1_title_value = /*maximized*/ ctx[0] ? "Minimize" : "Maximize");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", "zoom");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "title", "Zoom");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div1, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div2, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*maximized*/ 1 && div1_title_value !== (div1_title_value = /*maximized*/ ctx[0] ? "Minimize" : "Maximize")) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "title", div1_title_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div1);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div2);
        }
    };
}
function $0f4e5b97f458411e$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "window-buttons-mac",
            $$slots: {
                default: [
                    $0f4e5b97f458411e$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, maximized*/ 3) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $0f4e5b97f458411e$var$instance($$self, $$props, $$invalidate) {
    let { maximized: maximized = false } = $$props;
    $$self.$$set = ($$props)=>{
        if ("maximized" in $$props) $$invalidate(0, maximized = $$props.maximized);
    };
    return [
        maximized
    ];
}
class $0f4e5b97f458411e$var$WindowButtonsMac extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $0f4e5b97f458411e$var$instance, $0f4e5b97f458411e$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            maximized: 0
        });
    }
}
var $0f4e5b97f458411e$export$2e2bcd8739ae039 = $0f4e5b97f458411e$var$WindowButtonsMac;


/* src/components/window/title-bar/WindowButtonsWeb.svelte generated by Svelte v3.58.0 */ 




function $5d0625e9c448d24d$var$create_if_block(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            italic: true,
            $$slots: {
                default: [
                    $5d0625e9c448d24d$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (17:2) <TextLabel italic={true}>
function $5d0625e9c448d24d$var$create_default_slot_1(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Go fullscreen to access all hotkeys");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (15:0) <LayoutRow class="window-buttons-web" on:click={() => handleClick()} tooltip={($fullscreen.windowFullscreen ? "Exit" : "Enter") + " Fullscreen (F11)"}>
function $5d0625e9c448d24d$var$create_default_slot(ctx) {
    let t;
    let iconlabel;
    let current;
    let if_block = /*requestFullscreenHotkeys*/ ctx[1] && $5d0625e9c448d24d$var$create_if_block(ctx);
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*$fullscreen*/ ctx[0].windowFullscreen ? "FullscreenExit" : "FullscreenEnter"
        }
    });
    return {
        c () {
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*requestFullscreenHotkeys*/ ctx[1]) {
                if (if_block) {
                    if (dirty & /*requestFullscreenHotkeys*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $5d0625e9c448d24d$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            const iconlabel_changes = {};
            if (dirty & /*$fullscreen*/ 1) iconlabel_changes.icon = /*$fullscreen*/ ctx[0].windowFullscreen ? "FullscreenExit" : "FullscreenEnter";
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
function $5d0625e9c448d24d$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "window-buttons-web",
            tooltip: /*$fullscreen*/ (ctx[0].windowFullscreen ? "Exit" : "Enter") + " Fullscreen (F11)",
            $$slots: {
                default: [
                    $5d0625e9c448d24d$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow.$on("click", /*click_handler*/ ctx[4]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$fullscreen*/ 1) layoutrow_changes.tooltip = /*$fullscreen*/ (ctx[0].windowFullscreen ? "Exit" : "Enter") + " Fullscreen (F11)";
            if (dirty & /*$$scope, $fullscreen, requestFullscreenHotkeys*/ 35) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $5d0625e9c448d24d$var$instance($$self, $$props, $$invalidate) {
    let requestFullscreenHotkeys;
    let $fullscreen;
    const fullscreen = (0, $1eb80e36873dc327$export$31553aaa555c1514)("fullscreen");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, fullscreen, (value)=>$$invalidate(0, $fullscreen = value));
    async function handleClick() {
        if ($fullscreen.windowFullscreen) fullscreen.exitFullscreen();
        else fullscreen.enterFullscreen();
    }
    const click_handler = ()=>handleClick();
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*$fullscreen*/ 1) $: $$invalidate(1, requestFullscreenHotkeys = fullscreen.keyboardLockApiSupported && !$fullscreen.keyboardLocked);
    };
    return [
        $fullscreen,
        requestFullscreenHotkeys,
        fullscreen,
        handleClick,
        click_handler
    ];
}
class $5d0625e9c448d24d$var$WindowButtonsWeb extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $5d0625e9c448d24d$var$instance, $5d0625e9c448d24d$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $5d0625e9c448d24d$export$2e2bcd8739ae039 = $5d0625e9c448d24d$var$WindowButtonsWeb;


/* src/components/window/title-bar/WindowButtonsWindows.svelte generated by Svelte v3.58.0 */ 


function $1f61a1262bc8af90$var$create_default_slot_3(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: "WindowButtonWinMinimize"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (13:0) {:else}
function $1f61a1262bc8af90$var$create_else_block(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "window-button windows restore-down",
            tooltip: "Restore Down",
            $$slots: {
                default: [
                    $1f61a1262bc8af90$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (9:0) {#if !maximized}
function $1f61a1262bc8af90$var$create_if_block(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "window-button windows maximize",
            tooltip: "Maximize",
            $$slots: {
                default: [
                    $1f61a1262bc8af90$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (14:1) <LayoutRow class="window-button windows restore-down" tooltip="Restore Down">
function $1f61a1262bc8af90$var$create_default_slot_2(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: "WindowButtonWinRestoreDown"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (10:1) <LayoutRow class="window-button windows maximize" tooltip="Maximize">
function $1f61a1262bc8af90$var$create_default_slot_1(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: "WindowButtonWinMaximize"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (18:0) <LayoutRow class="window-button windows close" tooltip="Close">
function $1f61a1262bc8af90$var$create_default_slot(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: "WindowButtonWinClose"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
function $1f61a1262bc8af90$var$create_fragment(ctx) {
    let layoutrow0;
    let t0;
    let current_block_type_index;
    let if_block;
    let t1;
    let layoutrow1;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "window-button windows minimize",
            tooltip: "Minimize",
            $$slots: {
                default: [
                    $1f61a1262bc8af90$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    const if_block_creators = [
        $1f61a1262bc8af90$var$create_if_block,
        $1f61a1262bc8af90$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (!/*maximized*/ ctx[0]) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "window-button windows close",
            tooltip: "Close",
            $$slots: {
                default: [
                    $1f61a1262bc8af90$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if_block.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow0_changes = {};
            if (dirty & /*$$scope*/ 2) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index !== previous_block_index) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                }
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(t1.parentNode, t1);
            }
            const layoutrow1_changes = {};
            if (dirty & /*$$scope*/ 2) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
        }
    };
}
function $1f61a1262bc8af90$var$instance($$self, $$props, $$invalidate) {
    let { maximized: maximized = false } = $$props;
    $$self.$$set = ($$props)=>{
        if ("maximized" in $$props) $$invalidate(0, maximized = $$props.maximized);
    };
    return [
        maximized
    ];
}
class $1f61a1262bc8af90$var$WindowButtonsWindows extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $1f61a1262bc8af90$var$instance, $1f61a1262bc8af90$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            maximized: 0
        });
    }
}
var $1f61a1262bc8af90$export$2e2bcd8739ae039 = $1f61a1262bc8af90$var$WindowButtonsWindows;


/* src/components/window/title-bar/WindowTitle.svelte generated by Svelte v3.58.0 */ 


function $415572c7c1d3bd0e$var$create_default_slot_1(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(/*text*/ ctx[0]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*text*/ 1) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, /*text*/ ctx[0]);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (6:0) <LayoutRow class="window-title">
function $415572c7c1d3bd0e$var$create_default_slot(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $415572c7c1d3bd0e$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, text*/ 3) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
function $415572c7c1d3bd0e$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "window-title",
            $$slots: {
                default: [
                    $415572c7c1d3bd0e$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, text*/ 3) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $415572c7c1d3bd0e$var$instance($$self, $$props, $$invalidate) {
    let { text: text } = $$props;
    $$self.$$set = ($$props)=>{
        if ("text" in $$props) $$invalidate(0, text = $$props.text);
    };
    return [
        text
    ];
}
class $415572c7c1d3bd0e$var$WindowTitle extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $415572c7c1d3bd0e$var$instance, $415572c7c1d3bd0e$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            text: 0
        });
    }
}
var $415572c7c1d3bd0e$export$2e2bcd8739ae039 = $415572c7c1d3bd0e$var$WindowTitle;



function $b09475b3b41d5b9f$var$create_else_block(ctx) {
    let menubarinput;
    let current;
    menubarinput = new (0, $72e2ca1f3b4dc315$export$2e2bcd8739ae039)({});
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(menubarinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(menubarinput, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(menubarinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(menubarinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(menubarinput, detaching);
        }
    };
}
// (20:2) {#if platform === "Mac"}
function $b09475b3b41d5b9f$var$create_if_block_2(ctx) {
    let windowbuttonsmac;
    let current;
    windowbuttonsmac = new (0, $0f4e5b97f458411e$export$2e2bcd8739ae039)({
        props: {
            maximized: /*maximized*/ ctx[1]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(windowbuttonsmac.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(windowbuttonsmac, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const windowbuttonsmac_changes = {};
            if (dirty & /*maximized*/ 2) windowbuttonsmac_changes.maximized = /*maximized*/ ctx[1];
            windowbuttonsmac.$set(windowbuttonsmac_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(windowbuttonsmac.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(windowbuttonsmac.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(windowbuttonsmac, detaching);
        }
    };
}
// (19:1) <LayoutRow class="header-part">
function $b09475b3b41d5b9f$var$create_default_slot_3(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $b09475b3b41d5b9f$var$create_if_block_2,
        $b09475b3b41d5b9f$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*platform*/ ctx[0] === "Mac") return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (26:1) <LayoutRow class="header-part">
function $b09475b3b41d5b9f$var$create_default_slot_2(ctx) {
    let windowtitle;
    let current;
    windowtitle = new (0, $415572c7c1d3bd0e$export$2e2bcd8739ae039)({
        props: {
            text: /*windowTitle*/ ctx[2]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(windowtitle.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(windowtitle, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const windowtitle_changes = {};
            if (dirty & /*windowTitle*/ 4) windowtitle_changes.text = /*windowTitle*/ ctx[2];
            windowtitle.$set(windowtitle_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(windowtitle.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(windowtitle.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(windowtitle, detaching);
        }
    };
}
// (32:31) 
function $b09475b3b41d5b9f$var$create_if_block_1(ctx) {
    let windowbuttonsweb;
    let current;
    windowbuttonsweb = new (0, $5d0625e9c448d24d$export$2e2bcd8739ae039)({});
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(windowbuttonsweb.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(windowbuttonsweb, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(windowbuttonsweb.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(windowbuttonsweb.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(windowbuttonsweb, detaching);
        }
    };
}
// (30:2) {#if platform === "Windows" || platform === "Linux"}
function $b09475b3b41d5b9f$var$create_if_block(ctx) {
    let windowbuttonswindows;
    let current;
    windowbuttonswindows = new (0, $1f61a1262bc8af90$export$2e2bcd8739ae039)({
        props: {
            maximized: /*maximized*/ ctx[1]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(windowbuttonswindows.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(windowbuttonswindows, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const windowbuttonswindows_changes = {};
            if (dirty & /*maximized*/ 2) windowbuttonswindows_changes.maximized = /*maximized*/ ctx[1];
            windowbuttonswindows.$set(windowbuttonswindows_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(windowbuttonswindows.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(windowbuttonswindows.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(windowbuttonswindows, detaching);
        }
    };
}
// (29:1) <LayoutRow class="header-part">
function $b09475b3b41d5b9f$var$create_default_slot_1(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $b09475b3b41d5b9f$var$create_if_block,
        $b09475b3b41d5b9f$var$create_if_block_1
    ];
    const if_blocks = [];
    function select_block_type_1(ctx, dirty) {
        if (/*platform*/ ctx[0] === "Windows" || /*platform*/ ctx[0] === "Linux") return 0;
        if (/*platform*/ ctx[0] === "Web") return 1;
        return -1;
    }
    if (~(current_block_type_index = select_block_type_1(ctx, -1))) if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (~current_block_type_index) if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type_1(ctx, dirty);
            if (current_block_type_index === previous_block_index) {
                if (~current_block_type_index) if_blocks[current_block_type_index].p(ctx, dirty);
            } else {
                if (if_block) {
                    (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                    (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                        if_blocks[previous_block_index] = null;
                    });
                    (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                }
                if (~current_block_type_index) {
                    if_block = if_blocks[current_block_type_index];
                    if (!if_block) {
                        if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                        if_block.c();
                    } else if_block.p(ctx, dirty);
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                } else if_block = null;
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if (~current_block_type_index) if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (18:0) <LayoutRow class="title-bar">
function $b09475b3b41d5b9f$var$create_default_slot(ctx) {
    let layoutrow0;
    let t0;
    let layoutrow1;
    let t1;
    let layoutrow2;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "header-part",
            $$slots: {
                default: [
                    $b09475b3b41d5b9f$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "header-part",
            $$slots: {
                default: [
                    $b09475b3b41d5b9f$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow2 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "header-part",
            $$slots: {
                default: [
                    $b09475b3b41d5b9f$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow2.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow2, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty & /*$$scope, maximized, platform*/ 131) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty & /*$$scope, windowTitle*/ 132) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
            const layoutrow2_changes = {};
            if (dirty & /*$$scope, maximized, platform*/ 131) layoutrow2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow2.$set(layoutrow2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow2, detaching);
        }
    };
}
function $b09475b3b41d5b9f$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "title-bar",
            $$slots: {
                default: [
                    $b09475b3b41d5b9f$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, maximized, platform, windowTitle*/ 135) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $b09475b3b41d5b9f$var$instance($$self, $$props, $$invalidate) {
    let docIndex;
    let displayName;
    let windowTitle;
    let $portfolio;
    let { platform: platform } = $$props;
    let { maximized: maximized } = $$props;
    const portfolio = (0, $1eb80e36873dc327$export$31553aaa555c1514)("portfolio");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, portfolio, (value)=>$$invalidate(6, $portfolio = value));
    $$self.$$set = ($$props)=>{
        if ("platform" in $$props) $$invalidate(0, platform = $$props.platform);
        if ("maximized" in $$props) $$invalidate(1, maximized = $$props.maximized);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*$portfolio*/ 64) $: $$invalidate(5, docIndex = $portfolio.activeDocumentIndex);
        if ($$self.$$.dirty & /*$portfolio, docIndex*/ 96) $: $$invalidate(4, displayName = $portfolio.documents[docIndex]?.displayName || "");
        if ($$self.$$.dirty & /*displayName*/ 16) $: $$invalidate(2, windowTitle = `${displayName}${displayName && " - "}Graphite`);
    };
    return [
        platform,
        maximized,
        windowTitle,
        portfolio,
        displayName,
        docIndex,
        $portfolio
    ];
}
class $b09475b3b41d5b9f$var$TitleBar extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $b09475b3b41d5b9f$var$instance, $b09475b3b41d5b9f$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            platform: 0,
            maximized: 1
        });
    }
}
var $b09475b3b41d5b9f$export$2e2bcd8739ae039 = $b09475b3b41d5b9f$var$TitleBar;


/* src/components/window/workspace/Workspace.svelte generated by Svelte v3.58.0 */ 
/* src/components/floating-menus/DialogModal.svelte generated by Svelte v3.58.0 */ 






/* src/components/widgets/buttons/TextButton.svelte generated by Svelte v3.58.0 */ 


function $4dfb3170392f5493$var$create_if_block(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*icon*/ ctx[1]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*icon*/ 2) iconlabel_changes.icon = /*icon*/ ctx[1];
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (33:1) <TextLabel>
function $4dfb3170392f5493$var$create_default_slot(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(/*label*/ ctx[0]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*label*/ 1) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, /*label*/ ctx[0]);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
function $4dfb3170392f5493$var$create_fragment(ctx) {
    let button;
    let t;
    let textlabel;
    let button_data_emphasized_value;
    let button_data_disabled_value;
    let button_tabindex_value;
    let current;
    let mounted;
    let dispose;
    let if_block = /*icon*/ ctx[1] && $4dfb3170392f5493$var$create_if_block(ctx);
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $4dfb3170392f5493$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "class", "text-button");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "title", /*tooltip*/ ctx[6]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-emphasized", button_data_emphasized_value = /*emphasized*/ ctx[2] || undefined);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-disabled", button_data_disabled_value = /*disabled*/ ctx[5] || undefined);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-text-button", "");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", button_tabindex_value = /*disabled*/ ctx[5] ? -1 : 0);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "emphasized", /*emphasized*/ ctx[2]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "disabled", /*disabled*/ ctx[5]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "no-background", /*noBackground*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*sharpRightCorners*/ ctx[7]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "min-width", /*minWidth*/ ctx[4] > 0 ? `${ctx[4]}px` : "");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            if (if_block) if_block.m(button, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button, t);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, button, null);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", function() {
                    if ((0, $1eb80e36873dc327$export$b451353ebd749597)(/*action*/ ctx[8])) /*action*/ ctx[8].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            if (/*icon*/ ctx[1]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*icon*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $4dfb3170392f5493$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(button, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            const textlabel_changes = {};
            if (dirty & /*$$scope, label*/ 513) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (!current || dirty & /*tooltip*/ 64) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "title", /*tooltip*/ ctx[6]);
            if (!current || dirty & /*emphasized*/ 4 && button_data_emphasized_value !== (button_data_emphasized_value = /*emphasized*/ ctx[2] || undefined)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-emphasized", button_data_emphasized_value);
            if (!current || dirty & /*disabled*/ 32 && button_data_disabled_value !== (button_data_disabled_value = /*disabled*/ ctx[5] || undefined)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-disabled", button_data_disabled_value);
            if (!current || dirty & /*disabled*/ 32 && button_tabindex_value !== (button_tabindex_value = /*disabled*/ ctx[5] ? -1 : 0)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", button_tabindex_value);
            if (!current || dirty & /*emphasized*/ 4) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "emphasized", /*emphasized*/ ctx[2]);
            if (!current || dirty & /*disabled*/ 32) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "disabled", /*disabled*/ ctx[5]);
            if (!current || dirty & /*noBackground*/ 8) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "no-background", /*noBackground*/ ctx[3]);
            if (!current || dirty & /*sharpRightCorners*/ 128) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*sharpRightCorners*/ ctx[7]);
            if (dirty & /*minWidth*/ 16) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "min-width", /*minWidth*/ ctx[4] > 0 ? `${ctx[4]}px` : "");
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            if (if_block) if_block.d();
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel);
            mounted = false;
            dispose();
        }
    };
}
function $4dfb3170392f5493$var$instance($$self, $$props, $$invalidate) {
    let { label: label } = $$props;
    let { icon: icon } = $$props;
    let { emphasized: emphasized = false } = $$props;
    let { noBackground: noBackground = false } = $$props;
    let { minWidth: minWidth = 0 } = $$props;
    let { disabled: disabled = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let { action: action } = $$props;
    $$self.$$set = ($$props)=>{
        if ("label" in $$props) $$invalidate(0, label = $$props.label);
        if ("icon" in $$props) $$invalidate(1, icon = $$props.icon);
        if ("emphasized" in $$props) $$invalidate(2, emphasized = $$props.emphasized);
        if ("noBackground" in $$props) $$invalidate(3, noBackground = $$props.noBackground);
        if ("minWidth" in $$props) $$invalidate(4, minWidth = $$props.minWidth);
        if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
        if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
        if ("sharpRightCorners" in $$props) $$invalidate(7, sharpRightCorners = $$props.sharpRightCorners);
        if ("action" in $$props) $$invalidate(8, action = $$props.action);
    };
    return [
        label,
        icon,
        emphasized,
        noBackground,
        minWidth,
        disabled,
        tooltip,
        sharpRightCorners,
        action
    ];
}
class $4dfb3170392f5493$var$TextButton extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $4dfb3170392f5493$var$instance, $4dfb3170392f5493$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            label: 0,
            icon: 1,
            emphasized: 2,
            noBackground: 3,
            minWidth: 4,
            disabled: 5,
            tooltip: 6,
            sharpRightCorners: 7,
            action: 8
        });
    }
}
var $4dfb3170392f5493$export$2e2bcd8739ae039 = $4dfb3170392f5493$var$TextButton;




/* src/components/widgets/WidgetLayout.svelte generated by Svelte v3.58.0 */ 

/* src/components/widgets/groups/WidgetSection.svelte generated by Svelte v3.58.0 */ 



/* src/components/widgets/WidgetRow.svelte generated by Svelte v3.58.0 */ 
function $e752f026ddda25a8$export$12bf26cb720cb002(callFn, { debounceTime: debounceTime = 60 } = {}) {
    let currentValue;
    let recentlyUpdated = false;
    const emitValue = ()=>{
        recentlyUpdated = false;
        if (currentValue === undefined) return;
        updateValue(currentValue);
    };
    const updateValue = (newValue)=>{
        if (recentlyUpdated) {
            currentValue = newValue;
            return;
        }
        callFn(newValue);
        recentlyUpdated = true;
        currentValue = undefined;
        setTimeout(emitValue, debounceTime);
    };
    return {
        updateValue: updateValue
    };
}



/* src/components/widgets/assists/PivotAssist.svelte generated by Svelte v3.58.0 */ 

function $6f3fd08d16181ba6$var$create_fragment(ctx) {
    let div9;
    let button0;
    let div0;
    let t0;
    let button1;
    let div1;
    let t1;
    let button2;
    let div2;
    let t2;
    let button3;
    let div3;
    let t3;
    let button4;
    let div4;
    let t4;
    let button5;
    let div5;
    let t5;
    let button6;
    let div6;
    let t6;
    let button7;
    let div7;
    let t7;
    let button8;
    let div8;
    let mounted;
    let dispose;
    return {
        c () {
            div9 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            button0 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button1 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button2 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button3 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div3 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button4 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div4 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button5 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div5 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t5 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button6 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div6 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t6 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button7 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div7 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t7 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button8 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div8 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "class", "row-1 col-1");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "tabindex", "-1");
            button0.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button0, "active", /*position*/ ctx[0] === "TopLeft");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "class", "row-1 col-2");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "tabindex", "-1");
            button1.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button1, "active", /*position*/ ctx[0] === "TopCenter");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button2, "class", "row-1 col-3");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button2, "tabindex", "-1");
            button2.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button2, "active", /*position*/ ctx[0] === "TopRight");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button3, "class", "row-2 col-1");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button3, "tabindex", "-1");
            button3.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button3, "active", /*position*/ ctx[0] === "CenterLeft");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button4, "class", "row-2 col-2");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button4, "tabindex", "-1");
            button4.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button4, "active", /*position*/ ctx[0] === "Center");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button5, "class", "row-2 col-3");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button5, "tabindex", "-1");
            button5.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button5, "active", /*position*/ ctx[0] === "CenterRight");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button6, "class", "row-3 col-1");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button6, "tabindex", "-1");
            button6.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button6, "active", /*position*/ ctx[0] === "BottomLeft");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button7, "class", "row-3 col-2");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button7, "tabindex", "-1");
            button7.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button7, "active", /*position*/ ctx[0] === "BottomCenter");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button8, "class", "row-3 col-3");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button8, "tabindex", "-1");
            button8.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button8, "active", /*position*/ ctx[0] === "BottomRight");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div9, "class", "pivot-assist");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div9, "disabled", /*disabled*/ ctx[1]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div9, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button0, div0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button1, div1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button2, div2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button3);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button3, div3);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t3);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button4);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button4, div4);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t4);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button5);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button5, div5);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t5);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button6);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button6, div6);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t6);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button7);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button7, div7);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, t7);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div9, button8);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button8, div8);
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button0, "click", /*click_handler*/ ctx[3]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button1, "click", /*click_handler_1*/ ctx[4]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button2, "click", /*click_handler_2*/ ctx[5]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button3, "click", /*click_handler_3*/ ctx[6]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button4, "click", /*click_handler_4*/ ctx[7]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button5, "click", /*click_handler_5*/ ctx[8]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button6, "click", /*click_handler_6*/ ctx[9]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button7, "click", /*click_handler_7*/ ctx[10]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button8, "click", /*click_handler_8*/ ctx[11])
                ];
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*disabled*/ 2) button0.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button0, "active", /*position*/ ctx[0] === "TopLeft");
            if (dirty & /*disabled*/ 2) button1.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button1, "active", /*position*/ ctx[0] === "TopCenter");
            if (dirty & /*disabled*/ 2) button2.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button2, "active", /*position*/ ctx[0] === "TopRight");
            if (dirty & /*disabled*/ 2) button3.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button3, "active", /*position*/ ctx[0] === "CenterLeft");
            if (dirty & /*disabled*/ 2) button4.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button4, "active", /*position*/ ctx[0] === "Center");
            if (dirty & /*disabled*/ 2) button5.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button5, "active", /*position*/ ctx[0] === "CenterRight");
            if (dirty & /*disabled*/ 2) button6.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button6, "active", /*position*/ ctx[0] === "BottomLeft");
            if (dirty & /*disabled*/ 2) button7.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button7, "active", /*position*/ ctx[0] === "BottomCenter");
            if (dirty & /*disabled*/ 2) button8.disabled = /*disabled*/ ctx[1];
            if (dirty & /*position*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button8, "active", /*position*/ ctx[0] === "BottomRight");
            if (dirty & /*disabled*/ 2) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div9, "disabled", /*disabled*/ ctx[1]);
        },
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div9);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
function $6f3fd08d16181ba6$var$instance($$self, $$props, $$invalidate) {
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { position: position } = $$props;
    let { disabled: disabled = false } = $$props;
    function setPosition(newPosition) {
        dispatch("position", newPosition);
    }
    const click_handler = ()=>setPosition("TopLeft");
    const click_handler_1 = ()=>setPosition("TopCenter");
    const click_handler_2 = ()=>setPosition("TopRight");
    const click_handler_3 = ()=>setPosition("CenterLeft");
    const click_handler_4 = ()=>setPosition("Center");
    const click_handler_5 = ()=>setPosition("CenterRight");
    const click_handler_6 = ()=>setPosition("BottomLeft");
    const click_handler_7 = ()=>setPosition("BottomCenter");
    const click_handler_8 = ()=>setPosition("BottomRight");
    $$self.$$set = ($$props)=>{
        if ("position" in $$props) $$invalidate(0, position = $$props.position);
        if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
    };
    return [
        position,
        disabled,
        setPosition,
        click_handler,
        click_handler_1,
        click_handler_2,
        click_handler_3,
        click_handler_4,
        click_handler_5,
        click_handler_6,
        click_handler_7,
        click_handler_8
    ];
}
class $6f3fd08d16181ba6$var$PivotAssist extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $6f3fd08d16181ba6$var$instance, $6f3fd08d16181ba6$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            position: 0,
            disabled: 1
        });
    }
}
var $6f3fd08d16181ba6$export$2e2bcd8739ae039 = $6f3fd08d16181ba6$var$PivotAssist;



/* src/components/widgets/buttons/BreadcrumbTrailButtons.svelte generated by Svelte v3.58.0 */ 


function $cb89be9f6aef8b42$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[5] = list[i];
    child_ctx[7] = i;
    return child_ctx;
}
// (11:1) {#each labels as label, index (index)}
function $cb89be9f6aef8b42$var$create_each_block(key_1, ctx) {
    let first;
    let textbutton;
    let current;
    function func() {
        return /*func*/ ctx[4](/*index*/ ctx[7]);
    }
    textbutton = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: /*label*/ ctx[5],
            emphasized: /*index*/ ctx[7] === /*labels*/ ctx[0].length - 1,
            disabled: /*disabled*/ ctx[1],
            action: func
        }
    });
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton.$$.fragment);
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const textbutton_changes = {};
            if (dirty & /*labels*/ 1) textbutton_changes.label = /*label*/ ctx[5];
            if (dirty & /*labels*/ 1) textbutton_changes.emphasized = /*index*/ ctx[7] === /*labels*/ ctx[0].length - 1;
            if (dirty & /*disabled*/ 2) textbutton_changes.disabled = /*disabled*/ ctx[1];
            if (dirty & /*disabled, labels, action*/ 11) textbutton_changes.action = func;
            textbutton.$set(textbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton, detaching);
        }
    };
}
// (10:0) <LayoutRow class="breadcrumb-trail-buttons" {tooltip}>
function $cb89be9f6aef8b42$var$create_default_slot(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let each_value = /*labels*/ ctx[0];
    const get_key = (ctx)=>/*index*/ ctx[7];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $cb89be9f6aef8b42$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $cb89be9f6aef8b42$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*labels, disabled, action*/ 11) {
                each_value = /*labels*/ ctx[0];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $cb89be9f6aef8b42$var$create_each_block, each_1_anchor, $cb89be9f6aef8b42$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
function $cb89be9f6aef8b42$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "breadcrumb-trail-buttons",
            tooltip: /*tooltip*/ ctx[2],
            $$slots: {
                default: [
                    $cb89be9f6aef8b42$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*tooltip*/ 4) layoutrow_changes.tooltip = /*tooltip*/ ctx[2];
            if (dirty & /*$$scope, labels, disabled, action*/ 267) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $cb89be9f6aef8b42$var$instance($$self, $$props, $$invalidate) {
    let { labels: labels } = $$props;
    let { disabled: disabled = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { action: action } = $$props;
    const func = (index)=>!disabled && index !== labels.length - 1 && action(index);
    $$self.$$set = ($$props)=>{
        if ("labels" in $$props) $$invalidate(0, labels = $$props.labels);
        if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
        if ("tooltip" in $$props) $$invalidate(2, tooltip = $$props.tooltip);
        if ("action" in $$props) $$invalidate(3, action = $$props.action);
    };
    return [
        labels,
        disabled,
        tooltip,
        action,
        func
    ];
}
class $cb89be9f6aef8b42$var$BreadcrumbTrailButtons extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $cb89be9f6aef8b42$var$instance, $cb89be9f6aef8b42$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            labels: 0,
            disabled: 1,
            tooltip: 2,
            action: 3
        });
    }
}
var $cb89be9f6aef8b42$export$2e2bcd8739ae039 = $cb89be9f6aef8b42$var$BreadcrumbTrailButtons;


/* src/components/widgets/buttons/IconButton.svelte generated by Svelte v3.58.0 */ 

function $47cbcd4715b3f848$var$create_fragment(ctx) {
    let button;
    let iconlabel;
    let button_class_value;
    let button_tabindex_value;
    let current;
    let mounted;
    let dispose;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*icon*/ ctx[0]
        }
    });
    let button_levels = [
        {
            class: button_class_value = `icon-button size-${ctx[1]} ${ctx[7]} ${ctx[8]}`.trim()
        },
        {
            disabled: /*disabled*/ ctx[2]
        },
        {
            title: /*tooltip*/ ctx[4]
        },
        {
            tabindex: button_tabindex_value = /*active*/ ctx[3] ? -1 : 0
        },
        /*$$restProps*/ ctx[9]
    ];
    let button_data = {};
    for(let i = 0; i < button_levels.length; i += 1)button_data = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(button_data, button_levels[i]);
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(button, button_data);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "disabled", /*disabled*/ ctx[2]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "active", /*active*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*sharpRightCorners*/ ctx[5]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, button, null);
            if (button.autofocus) button.focus();
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", function() {
                    if ((0, $1eb80e36873dc327$export$b451353ebd749597)(/*action*/ ctx[6])) /*action*/ ctx[6].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            const iconlabel_changes = {};
            if (dirty & /*icon*/ 1) iconlabel_changes.icon = /*icon*/ ctx[0];
            iconlabel.$set(iconlabel_changes);
            (0, $1eb80e36873dc327$export$d7952e694819cff8)(button, button_data = (0, $1eb80e36873dc327$export$eea1060726e9ab6)(button_levels, [
                (!current || dirty & /*size, className, extraClasses*/ 386 && button_class_value !== (button_class_value = `icon-button size-${ctx[1]} ${ctx[7]} ${ctx[8]}`.trim())) && {
                    class: button_class_value
                },
                (!current || dirty & /*disabled*/ 4) && {
                    disabled: /*disabled*/ ctx[2]
                },
                (!current || dirty & /*tooltip*/ 16) && {
                    title: /*tooltip*/ ctx[4]
                },
                (!current || dirty & /*active*/ 8 && button_tabindex_value !== (button_tabindex_value = /*active*/ ctx[3] ? -1 : 0)) && {
                    tabindex: button_tabindex_value
                },
                dirty & /*$$restProps*/ 512 && /*$$restProps*/ ctx[9]
            ]));
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "disabled", /*disabled*/ ctx[2]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "active", /*active*/ ctx[3]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*sharpRightCorners*/ ctx[5]);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel);
            mounted = false;
            dispose();
        }
    };
}
function $47cbcd4715b3f848$var$instance($$self, $$props, $$invalidate) {
    let extraClasses;
    const omit_props_names = [
        "icon",
        "size",
        "disabled",
        "active",
        "tooltip",
        "sharpRightCorners",
        "action",
        "class",
        "classes"
    ];
    let $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names);
    let { icon: icon } = $$props;
    let { size: size } = $$props;
    let { disabled: disabled = false } = $$props;
    let { active: active = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let { action: action } = $$props;
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    $$self.$$set = ($$new_props)=>{
        $$props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)((0, $1eb80e36873dc327$export$e6e34fd1f2686227)({}, $$props), (0, $1eb80e36873dc327$export$1b59c714eb8e4c9f)($$new_props));
        $$invalidate(9, $$restProps = (0, $1eb80e36873dc327$export$3086903c15858881)($$props, omit_props_names));
        if ("icon" in $$new_props) $$invalidate(0, icon = $$new_props.icon);
        if ("size" in $$new_props) $$invalidate(1, size = $$new_props.size);
        if ("disabled" in $$new_props) $$invalidate(2, disabled = $$new_props.disabled);
        if ("active" in $$new_props) $$invalidate(3, active = $$new_props.active);
        if ("tooltip" in $$new_props) $$invalidate(4, tooltip = $$new_props.tooltip);
        if ("sharpRightCorners" in $$new_props) $$invalidate(5, sharpRightCorners = $$new_props.sharpRightCorners);
        if ("action" in $$new_props) $$invalidate(6, action = $$new_props.action);
        if ("class" in $$new_props) $$invalidate(7, className = $$new_props.class);
        if ("classes" in $$new_props) $$invalidate(10, classes = $$new_props.classes);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*classes*/ 1024) $: $$invalidate(8, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
    };
    return [
        icon,
        size,
        disabled,
        active,
        tooltip,
        sharpRightCorners,
        action,
        className,
        extraClasses,
        $$restProps,
        classes
    ];
}
class $47cbcd4715b3f848$var$IconButton extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $47cbcd4715b3f848$var$instance, $47cbcd4715b3f848$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            icon: 0,
            size: 1,
            disabled: 2,
            active: 3,
            tooltip: 4,
            sharpRightCorners: 5,
            action: 6,
            class: 7,
            classes: 10
        });
    }
}
var $47cbcd4715b3f848$export$2e2bcd8739ae039 = $47cbcd4715b3f848$var$IconButton;


/* src/components/widgets/buttons/ParameterExposeButton.svelte generated by Svelte v3.58.0 */ 

function $98a10f494f962df2$var$create_default_slot(ctx) {
    let button;
    let mounted;
    let dispose;
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "title", /*tooltip*/ ctx[2]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", "-1");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "exposed", /*exposed*/ ctx[0]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--data-type-color", `var(--color-data-${ctx[1]})`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", function() {
                    if ((0, $1eb80e36873dc327$export$b451353ebd749597)(/*action*/ ctx[3])) /*action*/ ctx[3].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*tooltip*/ 4) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "title", /*tooltip*/ ctx[2]);
            if (dirty & /*exposed*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "exposed", /*exposed*/ ctx[0]);
            if (dirty & /*dataType*/ 2) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--data-type-color", `var(--color-data-${ctx[1]})`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            mounted = false;
            dispose();
        }
    };
}
function $98a10f494f962df2$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "parameter-expose-button",
            $$slots: {
                default: [
                    $98a10f494f962df2$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, tooltip, exposed, dataType, action*/ 31) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $98a10f494f962df2$var$instance($$self, $$props, $$invalidate) {
    let { exposed: exposed } = $$props;
    let { dataType: dataType } = $$props;
    let { tooltip: tooltip } = $$props;
    let { action: action } = $$props;
    $$self.$$set = ($$props)=>{
        if ("exposed" in $$props) $$invalidate(0, exposed = $$props.exposed);
        if ("dataType" in $$props) $$invalidate(1, dataType = $$props.dataType);
        if ("tooltip" in $$props) $$invalidate(2, tooltip = $$props.tooltip);
        if ("action" in $$props) $$invalidate(3, action = $$props.action);
    };
    return [
        exposed,
        dataType,
        tooltip,
        action
    ];
}
class $98a10f494f962df2$var$ParameterExposeButton extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $98a10f494f962df2$var$instance, $98a10f494f962df2$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            exposed: 0,
            dataType: 1,
            tooltip: 2,
            action: 3
        });
    }
}
var $98a10f494f962df2$export$2e2bcd8739ae039 = $98a10f494f962df2$var$ParameterExposeButton;


/* src/components/widgets/buttons/PopoverButton.svelte generated by Svelte v3.58.0 */ 



function $68f47e5b62fe7f2d$var$create_default_slot_1(ctx) {
    let current;
    const default_slot_template = /*#slots*/ ctx[6].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[9], null);
    return {
        c () {
            if (default_slot) default_slot.c();
        },
        m (target, anchor) {
            if (default_slot) default_slot.m(target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 512)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[9], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[9]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[9], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (default_slot) default_slot.d(detaching);
        }
    };
}
// (16:0) <LayoutRow class="popover-button">
function $68f47e5b62fe7f2d$var$create_default_slot(ctx) {
    let iconbutton;
    let t;
    let floatingmenu;
    let current;
    iconbutton = new (0, $47cbcd4715b3f848$export$2e2bcd8739ae039)({
        props: {
            classes: {
                open: /*open*/ ctx[3]
            },
            disabled: /*disabled*/ ctx[2],
            action: /*func*/ ctx[7],
            icon: /*icon*/ ctx[0] || "DropdownArrow",
            size: 16,
            tooltip: /*tooltip*/ ctx[1],
            "data-floating-menu-spawner": true
        }
    });
    floatingmenu = new (0, $ef66a8e69d2c44ad$export$2e2bcd8739ae039)({
        props: {
            open: /*open*/ ctx[3],
            type: "Popover",
            direction: "Bottom",
            $$slots: {
                default: [
                    $68f47e5b62fe7f2d$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    floatingmenu.$on("open", /*open_handler*/ ctx[8]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconbutton.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(floatingmenu.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconbutton, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(floatingmenu, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconbutton_changes = {};
            if (dirty & /*open*/ 8) iconbutton_changes.classes = {
                open: /*open*/ ctx[3]
            };
            if (dirty & /*disabled*/ 4) iconbutton_changes.disabled = /*disabled*/ ctx[2];
            if (dirty & /*icon*/ 1) iconbutton_changes.icon = /*icon*/ ctx[0] || "DropdownArrow";
            if (dirty & /*tooltip*/ 2) iconbutton_changes.tooltip = /*tooltip*/ ctx[1];
            iconbutton.$set(iconbutton_changes);
            const floatingmenu_changes = {};
            if (dirty & /*open*/ 8) floatingmenu_changes.open = /*open*/ ctx[3];
            if (dirty & /*$$scope*/ 512) floatingmenu_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            floatingmenu.$set(floatingmenu_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconbutton.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(floatingmenu.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconbutton.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(floatingmenu.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconbutton, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(floatingmenu, detaching);
        }
    };
}
function $68f47e5b62fe7f2d$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "popover-button",
            $$slots: {
                default: [
                    $68f47e5b62fe7f2d$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, open, disabled, icon, tooltip*/ 527) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $68f47e5b62fe7f2d$var$instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    let { icon: icon = "DropdownArrow" } = $$props;
    let { tooltip: tooltip } = $$props;
    let { disabled: disabled = false } = $$props;
    let { action: action } = $$props;
    let open = false;
    function onClick() {
        $$invalidate(3, open = true);
        action?.();
    }
    const func = ()=>onClick();
    const open_handler = ({ detail: detail })=>$$invalidate(3, open = detail);
    $$self.$$set = ($$props)=>{
        if ("icon" in $$props) $$invalidate(0, icon = $$props.icon);
        if ("tooltip" in $$props) $$invalidate(1, tooltip = $$props.tooltip);
        if ("disabled" in $$props) $$invalidate(2, disabled = $$props.disabled);
        if ("action" in $$props) $$invalidate(5, action = $$props.action);
        if ("$$scope" in $$props) $$invalidate(9, $$scope = $$props.$$scope);
    };
    return [
        icon,
        tooltip,
        disabled,
        open,
        onClick,
        action,
        slots,
        func,
        open_handler,
        $$scope
    ];
}
class $68f47e5b62fe7f2d$var$PopoverButton extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $68f47e5b62fe7f2d$var$instance, $68f47e5b62fe7f2d$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            icon: 0,
            tooltip: 1,
            disabled: 2,
            action: 5
        });
    }
}
var $68f47e5b62fe7f2d$export$2e2bcd8739ae039 = $68f47e5b62fe7f2d$var$PopoverButton;



/* src/components/widgets/inputs/CheckboxInput.svelte generated by Svelte v3.58.0 */ 



function $2ea65ba9293d21a6$var$create_default_slot_1(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*displayIcon*/ ctx[4]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*displayIcon*/ 16) iconlabel_changes.icon = /*displayIcon*/ ctx[4];
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (26:0) <LayoutRow class="checkbox-input">
function $2ea65ba9293d21a6$var$create_default_slot(ctx) {
    let input_1;
    let input_1_id_value;
    let input_1_tabindex_value;
    let t;
    let label;
    let layoutrow;
    let label_for_value;
    let current;
    let mounted;
    let dispose;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "checkbox-box",
            $$slots: {
                default: [
                    $2ea65ba9293d21a6$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            input_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("input");
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            label = (0, $1eb80e36873dc327$export$8454457683f90105)("label");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input_1, "type", "checkbox");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input_1, "id", input_1_id_value = `checkbox-input-${ctx[6]}`);
            input_1.checked = /*checked*/ ctx[0];
            input_1.disabled = /*disabled*/ ctx[1];
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input_1, "tabindex", input_1_tabindex_value = /*disabled*/ ctx[1] ? -1 : 0);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(label, "for", label_for_value = `checkbox-input-${ctx[6]}`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(label, "title", /*tooltip*/ ctx[2]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(label, "disabled", /*disabled*/ ctx[1]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(label, "checked", /*checked*/ ctx[0]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, input_1, anchor);
            /*input_1_binding*/ ctx[11](input_1);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, label, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, label, null);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input_1, "change", /*change_handler*/ ctx[10]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(label, "keydown", /*keydown_handler*/ ctx[12])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (!current || dirty & /*checked*/ 1) input_1.checked = /*checked*/ ctx[0];
            if (!current || dirty & /*disabled*/ 2) input_1.disabled = /*disabled*/ ctx[1];
            if (!current || dirty & /*disabled*/ 2 && input_1_tabindex_value !== (input_1_tabindex_value = /*disabled*/ ctx[1] ? -1 : 0)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input_1, "tabindex", input_1_tabindex_value);
            const layoutrow_changes = {};
            if (dirty & /*$$scope, displayIcon*/ 8208) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
            if (!current || dirty & /*tooltip*/ 4) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(label, "title", /*tooltip*/ ctx[2]);
            if (!current || dirty & /*disabled*/ 2) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(label, "disabled", /*disabled*/ ctx[1]);
            if (!current || dirty & /*checked*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(label, "checked", /*checked*/ ctx[0]);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(input_1);
            /*input_1_binding*/ ctx[11](null);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(label);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
function $2ea65ba9293d21a6$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "checkbox-input",
            $$slots: {
                default: [
                    $2ea65ba9293d21a6$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, tooltip, disabled, checked, displayIcon, inputElement*/ 8223) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $2ea65ba9293d21a6$var$toggleCheckboxFromLabel(e) {
    const target = e.target || undefined;
    const previousSibling = target?.previousSibling || undefined;
    previousSibling?.click();
}
function $2ea65ba9293d21a6$var$instance($$self, $$props, $$invalidate) {
    let displayIcon;
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { checked: checked = false } = $$props;
    let { disabled: disabled = false } = $$props;
    let { icon: icon = "Checkmark" } = $$props;
    let { tooltip: tooltip } = $$props;
    let inputElement;
    let id = `${Math.random()}`.substring(2);
    function isChecked() {
        return checked;
    }
    function input() {
        return inputElement;
    }
    const change_handler = (e)=>dispatch("checked", inputElement?.checked);
    function input_1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            inputElement = $$value;
            $$invalidate(3, inputElement);
        });
    }
    const keydown_handler = (e)=>e.key === "Enter" && $2ea65ba9293d21a6$var$toggleCheckboxFromLabel(e);
    $$self.$$set = ($$props)=>{
        if ("checked" in $$props) $$invalidate(0, checked = $$props.checked);
        if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
        if ("icon" in $$props) $$invalidate(7, icon = $$props.icon);
        if ("tooltip" in $$props) $$invalidate(2, tooltip = $$props.tooltip);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*checked, icon*/ 129) $: $$invalidate(4, displayIcon = !checked && icon === "Checkmark" ? "Empty12px" : icon);
    };
    return [
        checked,
        disabled,
        tooltip,
        inputElement,
        displayIcon,
        dispatch,
        id,
        icon,
        isChecked,
        input,
        change_handler,
        input_1_binding,
        keydown_handler
    ];
}
class $2ea65ba9293d21a6$var$CheckboxInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $2ea65ba9293d21a6$var$instance, $2ea65ba9293d21a6$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            checked: 0,
            disabled: 1,
            icon: 7,
            tooltip: 2,
            isChecked: 8,
            input: 9
        });
    }
    get isChecked() {
        return this.$$.ctx[8];
    }
    get input() {
        return this.$$.ctx[9];
    }
}
var $2ea65ba9293d21a6$export$2e2bcd8739ae039 = $2ea65ba9293d21a6$var$CheckboxInput;


/* src/components/widgets/inputs/ColorInput.svelte generated by Svelte v3.58.0 */ 

/* src/components/floating-menus/ColorPicker.svelte generated by Svelte v3.58.0 */ 

function $0772c00bcca44bc9$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}







/* src/components/widgets/inputs/DropdownInput.svelte generated by Svelte v3.58.0 */ 





function $b773e3d2fa9c5172$var$create_if_block(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            class: "dropdown-icon",
            icon: /*activeEntry*/ ctx[6].icon
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*activeEntry*/ 64) iconlabel_changes.icon = /*activeEntry*/ ctx[6].icon;
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (67:2) <TextLabel class="dropdown-label">
function $b773e3d2fa9c5172$var$create_default_slot_2(ctx) {
    let t_value = /*activeEntry*/ ctx[6].label + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*activeEntry*/ 64 && t_value !== (t_value = /*activeEntry*/ ctx[6].label + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (53:1) <LayoutRow   class="dropdown-box"   classes={{ disabled, open, "sharp-right-corners": sharpRightCorners }}   styles={{ "min-width": `${minWidth}px` }}   {tooltip}   on:click={() => !disabled && (open = true)}   on:blur={unFocusDropdownBox}   on:keydown={(e) => menuList?.keydown(e, false)}   tabindex={disabled ? -1 : 0}   data-floating-menu-spawner  >
function $b773e3d2fa9c5172$var$create_default_slot_1(ctx) {
    let t0;
    let textlabel;
    let t1;
    let iconlabel;
    let current;
    let if_block = /*activeEntry*/ ctx[6].icon && $b773e3d2fa9c5172$var$create_if_block(ctx);
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            class: "dropdown-label",
            $$slots: {
                default: [
                    $b773e3d2fa9c5172$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            class: "dropdown-arrow",
            icon: "DropdownArrow"
        }
    });
    return {
        c () {
            if (if_block) if_block.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*activeEntry*/ ctx[6].icon) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*activeEntry*/ 64) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $b773e3d2fa9c5172$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t0.parentNode, t0);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            const textlabel_changes = {};
            if (dirty & /*$$scope, activeEntry*/ 67108928) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (52:0) <LayoutRow class="dropdown-input" bind:this={self} data-dropdown-input>
function $b773e3d2fa9c5172$var$create_default_slot(ctx) {
    let layoutrow;
    let t;
    let menulist;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "dropdown-box",
            classes: {
                disabled: /*disabled*/ ctx[3],
                open: /*open*/ ctx[9],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[5]
            },
            styles: {
                "min-width": `${ctx[10]}px`
            },
            tooltip: /*tooltip*/ ctx[4],
            tabindex: /*disabled*/ ctx[3] ? -1 : 0,
            "data-floating-menu-spawner": true,
            $$slots: {
                default: [
                    $b773e3d2fa9c5172$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow.$on("click", /*click_handler*/ ctx[13]);
    layoutrow.$on("blur", /*unFocusDropdownBox*/ ctx[11]);
    layoutrow.$on("keydown", /*keydown_handler*/ ctx[14]);
    let menulist_props = {
        activeEntry: /*activeEntry*/ ctx[6],
        open: /*open*/ ctx[9],
        entries: /*entries*/ ctx[0],
        drawIcon: /*drawIcon*/ ctx[1],
        interactive: /*interactive*/ ctx[2],
        direction: "Bottom",
        scrollableY: true
    };
    menulist = new (0, $c04ba9d0f104d9a2$export$2e2bcd8739ae039)({
        props: menulist_props
    });
    /*menulist_binding*/ ctx[15](menulist);
    menulist.$on("naturalWidth", /*naturalWidth_handler*/ ctx[16]);
    menulist.$on("activeEntry", /*activeEntry_handler*/ ctx[17]);
    menulist.$on("open", /*open_handler*/ ctx[18]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(menulist.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(menulist, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*disabled, open, sharpRightCorners*/ 552) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[3],
                open: /*open*/ ctx[9],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[5]
            };
            if (dirty & /*minWidth*/ 1024) layoutrow_changes.styles = {
                "min-width": `${ctx[10]}px`
            };
            if (dirty & /*tooltip*/ 16) layoutrow_changes.tooltip = /*tooltip*/ ctx[4];
            if (dirty & /*disabled*/ 8) layoutrow_changes.tabindex = /*disabled*/ ctx[3] ? -1 : 0;
            if (dirty & /*$$scope, activeEntry*/ 67108928) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
            const menulist_changes = {};
            if (dirty & /*activeEntry*/ 64) menulist_changes.activeEntry = /*activeEntry*/ ctx[6];
            if (dirty & /*open*/ 512) menulist_changes.open = /*open*/ ctx[9];
            if (dirty & /*entries*/ 1) menulist_changes.entries = /*entries*/ ctx[0];
            if (dirty & /*drawIcon*/ 2) menulist_changes.drawIcon = /*drawIcon*/ ctx[1];
            if (dirty & /*interactive*/ 4) menulist_changes.interactive = /*interactive*/ ctx[2];
            menulist.$set(menulist_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(menulist.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(menulist.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            /*menulist_binding*/ ctx[15](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(menulist, detaching);
        }
    };
}
function $b773e3d2fa9c5172$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    let layoutrow_props = {
        class: "dropdown-input",
        "data-dropdown-input": true,
        $$slots: {
            default: [
                $b773e3d2fa9c5172$var$create_default_slot
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: layoutrow_props
    });
    /*layoutrow_binding*/ ctx[19](layoutrow);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, activeEntry, open, entries, drawIcon, interactive, menuList, minWidth, disabled, sharpRightCorners, tooltip*/ 67110655) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*layoutrow_binding*/ ctx[19](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $b773e3d2fa9c5172$var$instance($$self, $$props, $$invalidate) {
    const DASH_ENTRY = {
        label: "-"
    };
    // emits: ["update:selectedIndex"],
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let menuList;
    let self;
    let { entries: entries } = $$props;
    let { selectedIndex: selectedIndex } = $$props;
    let { drawIcon: drawIcon = false } = $$props;
    let { interactive: interactive = true } = $$props;
    let { disabled: disabled = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let activeEntry = makeActiveEntry();
    let activeEntrySkipWatcher = false;
    let open = false;
    let minWidth = 0;
    // Called only when `selectedIndex` is changed from outside this component
    function watchSelectedIndex(_) {
        activeEntrySkipWatcher = true;
        $$invalidate(6, activeEntry = makeActiveEntry());
    }
    // Called when the `activeEntry` two-way binding on this component's MenuList component is changed, or by the `selectedIndex()` watcher above (but we want to skip that case)
    function watchActiveEntry(activeEntry) {
        if (activeEntrySkipWatcher) activeEntrySkipWatcher = false;
        else if (activeEntry !== DASH_ENTRY) dispatch("selectedIndex", entries.flat().indexOf(activeEntry));
    }
    function makeActiveEntry() {
        const allEntries = entries.flat();
        if (selectedIndex !== undefined && selectedIndex >= 0 && selectedIndex < allEntries.length) return allEntries[selectedIndex];
        return DASH_ENTRY;
    }
    function unFocusDropdownBox(e) {
        const blurTarget = e.target?.closest("[data-dropdown-input]") || undefined;
        if (blurTarget !== self?.div()) $$invalidate(9, open = false);
    }
    const click_handler = ()=>!disabled && $$invalidate(9, open = true);
    const keydown_handler = (e)=>menuList?.keydown(e, false);
    function menulist_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            menuList = $$value;
            $$invalidate(7, menuList);
        });
    }
    const naturalWidth_handler = ({ detail: detail })=>$$invalidate(10, minWidth = detail);
    const activeEntry_handler = ({ detail: detail })=>$$invalidate(6, activeEntry = detail);
    const open_handler = ({ detail: detail })=>$$invalidate(9, open = detail);
    function layoutrow_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(8, self);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("entries" in $$props) $$invalidate(0, entries = $$props.entries);
        if ("selectedIndex" in $$props) $$invalidate(12, selectedIndex = $$props.selectedIndex);
        if ("drawIcon" in $$props) $$invalidate(1, drawIcon = $$props.drawIcon);
        if ("interactive" in $$props) $$invalidate(2, interactive = $$props.interactive);
        if ("disabled" in $$props) $$invalidate(3, disabled = $$props.disabled);
        if ("tooltip" in $$props) $$invalidate(4, tooltip = $$props.tooltip);
        if ("sharpRightCorners" in $$props) $$invalidate(5, sharpRightCorners = $$props.sharpRightCorners);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*selectedIndex*/ 4096) $: watchSelectedIndex(selectedIndex);
        if ($$self.$$.dirty & /*activeEntry*/ 64) $: watchActiveEntry(activeEntry);
    };
    return [
        entries,
        drawIcon,
        interactive,
        disabled,
        tooltip,
        sharpRightCorners,
        activeEntry,
        menuList,
        self,
        open,
        minWidth,
        unFocusDropdownBox,
        selectedIndex,
        click_handler,
        keydown_handler,
        menulist_binding,
        naturalWidth_handler,
        activeEntry_handler,
        open_handler,
        layoutrow_binding
    ];
}
class $b773e3d2fa9c5172$var$DropdownInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $b773e3d2fa9c5172$var$instance, $b773e3d2fa9c5172$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            entries: 0,
            selectedIndex: 12,
            drawIcon: 1,
            interactive: 2,
            disabled: 3,
            tooltip: 4,
            sharpRightCorners: 5
        });
    }
}
var $b773e3d2fa9c5172$export$2e2bcd8739ae039 = $b773e3d2fa9c5172$var$DropdownInput;


/* src/components/widgets/inputs/NumberInput.svelte generated by Svelte v3.58.0 */ 

/* src/components/widgets/inputs/FieldInput.svelte generated by Svelte v3.58.0 */ 



function $2641f5944a8728bd$var$create_else_block(ctx) {
    let textarea_1;
    let textarea_1_id_value;
    let mounted;
    let dispose;
    return {
        c () {
            textarea_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("textarea");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(textarea_1, "id", textarea_1_id_value = `field-input-${ctx[14]}`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(textarea_1, "class", "scrollable-y");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(textarea_1, "data-scrollable-y", "");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(textarea_1, "spellcheck", /*spellcheck*/ ctx[5]);
            textarea_1.disabled = /*disabled*/ ctx[6];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(textarea_1, "has-label", /*label*/ ctx[4]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, textarea_1, anchor);
            (0, $1eb80e36873dc327$export$aee788c6eadfac08)(textarea_1, /*inputValue*/ ctx[11]);
            /*textarea_1_binding*/ ctx[32](textarea_1);
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(textarea_1, "input", /*textarea_1_input_handler*/ ctx[31]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(textarea_1, "focus", /*focus_handler_1*/ ctx[33]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(textarea_1, "blur", /*blur_handler_1*/ ctx[34]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(textarea_1, "change", /*change_handler_1*/ ctx[35]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(textarea_1, "keydown", /*keydown_handler_2*/ ctx[36]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(textarea_1, "keydown", /*keydown_handler_3*/ ctx[37])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty[0] & /*spellcheck*/ 32) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(textarea_1, "spellcheck", /*spellcheck*/ ctx[5]);
            if (dirty[0] & /*disabled*/ 64) textarea_1.disabled = /*disabled*/ ctx[6];
            if (dirty[0] & /*inputValue*/ 2048) (0, $1eb80e36873dc327$export$aee788c6eadfac08)(textarea_1, /*inputValue*/ ctx[11]);
            if (dirty[0] & /*label*/ 16) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(textarea_1, "has-label", /*label*/ ctx[4]);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(textarea_1);
            /*textarea_1_binding*/ ctx[32](null);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
// (54:1) {#if !textarea}
function $2641f5944a8728bd$var$create_if_block_1(ctx) {
    let input;
    let input_id_value;
    let mounted;
    let dispose;
    return {
        c () {
            input = (0, $1eb80e36873dc327$export$8454457683f90105)("input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "type", "text");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "id", input_id_value = `field-input-${ctx[14]}`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "spellcheck", /*spellcheck*/ ctx[5]);
            input.disabled = /*disabled*/ ctx[6];
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "placeholder", /*placeholder*/ ctx[10]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "data-input-element", "");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(input, "has-label", /*label*/ ctx[4]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, input, anchor);
            (0, $1eb80e36873dc327$export$aee788c6eadfac08)(input, /*inputValue*/ ctx[11]);
            /*input_binding*/ ctx[25](input);
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "input", /*input_input_handler*/ ctx[24]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "focus", /*focus_handler*/ ctx[26]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "blur", /*blur_handler*/ ctx[27]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "change", /*change_handler*/ ctx[28]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "keydown", /*keydown_handler*/ ctx[29]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "keydown", /*keydown_handler_1*/ ctx[30])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty[0] & /*spellcheck*/ 32) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "spellcheck", /*spellcheck*/ ctx[5]);
            if (dirty[0] & /*disabled*/ 64) input.disabled = /*disabled*/ ctx[6];
            if (dirty[0] & /*placeholder*/ 1024) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "placeholder", /*placeholder*/ ctx[10]);
            if (dirty[0] & /*inputValue*/ 2048 && input.value !== /*inputValue*/ ctx[11]) (0, $1eb80e36873dc327$export$aee788c6eadfac08)(input, /*inputValue*/ ctx[11]);
            if (dirty[0] & /*label*/ 16) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(input, "has-label", /*label*/ ctx[4]);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(input);
            /*input_binding*/ ctx[25](null);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
// (88:1) {#if label}
function $2641f5944a8728bd$var$create_if_block(ctx) {
    let label_1;
    let t;
    let label_1_for_value;
    return {
        c () {
            label_1 = (0, $1eb80e36873dc327$export$8454457683f90105)("label");
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(/*label*/ ctx[4]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(label_1, "for", label_1_for_value = `field-input-${ctx[14]}`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, label_1, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(label_1, t);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*label*/ 16) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, /*label*/ ctx[4]);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(label_1);
        }
    };
}
// (53:0) <LayoutRow class={`field-input ${className}`} classes={{ disabled, "sharp-right-corners": sharpRightCorners, ...classes }} style={styleName} {styles} {tooltip}>
function $2641f5944a8728bd$var$create_default_slot(ctx) {
    let t0;
    let t1;
    let current;
    function select_block_type(ctx, dirty) {
        if (!/*textarea*/ ctx[7]) return $2641f5944a8728bd$var$create_if_block_1;
        return $2641f5944a8728bd$var$create_else_block;
    }
    let current_block_type = select_block_type(ctx, [
        -1,
        -1
    ]);
    let if_block0 = current_block_type(ctx);
    let if_block1 = /*label*/ ctx[4] && $2641f5944a8728bd$var$create_if_block(ctx);
    const default_slot_template = /*#slots*/ ctx[23].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[38], null);
    return {
        c () {
            if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (default_slot) default_slot.c();
        },
        m (target, anchor) {
            if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            if (default_slot) default_slot.m(target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block0) if_block0.p(ctx, dirty);
            else {
                if_block0.d(1);
                if_block0 = current_block_type(ctx);
                if (if_block0) {
                    if_block0.c();
                    if_block0.m(t0.parentNode, t0);
                }
            }
            if (/*label*/ ctx[4]) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $2641f5944a8728bd$var$create_if_block(ctx);
                    if_block1.c();
                    if_block1.m(t1.parentNode, t1);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            if (default_slot) {
                if (default_slot.p && (!current || dirty[1] & /*$$scope*/ 128)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[38], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[38]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[38], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (default_slot) default_slot.d(detaching);
        }
    };
}
function $2641f5944a8728bd$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: `field-input ${ctx[0]}`,
            classes: {
                disabled: /*disabled*/ ctx[6],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[9],
                .../*classes*/ ctx[1]
            },
            style: /*styleName*/ ctx[2],
            styles: /*styles*/ ctx[3],
            tooltip: /*tooltip*/ ctx[8],
            $$slots: {
                default: [
                    $2641f5944a8728bd$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty[0] & /*className*/ 1) layoutrow_changes.class = `field-input ${ctx[0]}`;
            if (dirty[0] & /*disabled, sharpRightCorners, classes*/ 578) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[6],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[9],
                .../*classes*/ ctx[1]
            };
            if (dirty[0] & /*styleName*/ 4) layoutrow_changes.style = /*styleName*/ ctx[2];
            if (dirty[0] & /*styles*/ 8) layoutrow_changes.styles = /*styles*/ ctx[3];
            if (dirty[0] & /*tooltip*/ 256) layoutrow_changes.tooltip = /*tooltip*/ ctx[8];
            if (dirty[0] & /*label, spellcheck, disabled, placeholder, inputValue, inputOrTextarea, textarea*/ 7408 | dirty[1] & /*$$scope*/ 128) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $2641f5944a8728bd$var$instance($$self, $$props, $$invalidate) {
    let inputValue;
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    let { style: styleName = "" } = $$props;
    let { styles: styles = {} } = $$props;
    let { value: value } = $$props;
    let { label: label } = $$props;
    let { spellcheck: spellcheck = false } = $$props;
    let { disabled: disabled = false } = $$props;
    let { textarea: textarea = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let { placeholder: placeholder } = $$props;
    let inputOrTextarea;
    let id = `${Math.random()}`.substring(2);
    let macKeyboardLayout = (0, $7ed52b8c7c886783$export$f205d53822e9a9a9)();
    function selectAllText(currentText) {
        if (!inputOrTextarea) return;
        // Setting the value directly is required to make the following `select()` call work
        $$invalidate(12, inputOrTextarea.value = currentText, inputOrTextarea);
        inputOrTextarea.select();
    }
    function focus() {
        inputOrTextarea?.focus();
    }
    function unFocus() {
        inputOrTextarea?.blur();
    }
    function getValue() {
        return inputOrTextarea?.value || "";
    }
    function setInputElementValue(value) {
        if (!inputOrTextarea) return;
        $$invalidate(12, inputOrTextarea.value = value, inputOrTextarea);
    }
    function element() {
        return inputOrTextarea;
    }
    function input_input_handler() {
        inputValue = this.value;
        $$invalidate(11, inputValue), $$invalidate(16, value);
    }
    function input_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            inputOrTextarea = $$value;
            $$invalidate(12, inputOrTextarea);
        });
    }
    const focus_handler = ()=>dispatch("textFocused");
    const blur_handler = ()=>dispatch("textChanged");
    const change_handler = ()=>dispatch("textChanged");
    const keydown_handler = (e)=>e.key === "Enter" && dispatch("textChanged");
    const keydown_handler_1 = (e)=>e.key === "Escape" && dispatch("cancelTextChange");
    function textarea_1_input_handler() {
        inputValue = this.value;
        $$invalidate(11, inputValue), $$invalidate(16, value);
    }
    function textarea_1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            inputOrTextarea = $$value;
            $$invalidate(12, inputOrTextarea);
        });
    }
    const focus_handler_1 = ()=>dispatch("textFocused");
    const blur_handler_1 = ()=>dispatch("textChanged");
    const change_handler_1 = ()=>dispatch("textChanged");
    const keydown_handler_2 = (e)=>(macKeyboardLayout ? e.metaKey : e.ctrlKey) && e.key === "Enter" && dispatch("textChanged");
    const keydown_handler_3 = (e)=>e.key === "Escape" && dispatch("cancelTextChange");
    $$self.$$set = ($$props)=>{
        if ("class" in $$props) $$invalidate(0, className = $$props.class);
        if ("classes" in $$props) $$invalidate(1, classes = $$props.classes);
        if ("style" in $$props) $$invalidate(2, styleName = $$props.style);
        if ("styles" in $$props) $$invalidate(3, styles = $$props.styles);
        if ("value" in $$props) $$invalidate(16, value = $$props.value);
        if ("label" in $$props) $$invalidate(4, label = $$props.label);
        if ("spellcheck" in $$props) $$invalidate(5, spellcheck = $$props.spellcheck);
        if ("disabled" in $$props) $$invalidate(6, disabled = $$props.disabled);
        if ("textarea" in $$props) $$invalidate(7, textarea = $$props.textarea);
        if ("tooltip" in $$props) $$invalidate(8, tooltip = $$props.tooltip);
        if ("sharpRightCorners" in $$props) $$invalidate(9, sharpRightCorners = $$props.sharpRightCorners);
        if ("placeholder" in $$props) $$invalidate(10, placeholder = $$props.placeholder);
        if ("$$scope" in $$props) $$invalidate(38, $$scope = $$props.$$scope);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*value*/ 65536) $: $$invalidate(11, inputValue = value);
        if ($$self.$$.dirty[0] & /*inputValue*/ 2048) $: dispatch("value", inputValue);
    };
    return [
        className,
        classes,
        styleName,
        styles,
        label,
        spellcheck,
        disabled,
        textarea,
        tooltip,
        sharpRightCorners,
        placeholder,
        inputValue,
        inputOrTextarea,
        dispatch,
        id,
        macKeyboardLayout,
        value,
        selectAllText,
        focus,
        unFocus,
        getValue,
        setInputElementValue,
        element,
        slots,
        input_input_handler,
        input_binding,
        focus_handler,
        blur_handler,
        change_handler,
        keydown_handler,
        keydown_handler_1,
        textarea_1_input_handler,
        textarea_1_binding,
        focus_handler_1,
        blur_handler_1,
        change_handler_1,
        keydown_handler_2,
        keydown_handler_3,
        $$scope
    ];
}
class $2641f5944a8728bd$var$FieldInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $2641f5944a8728bd$var$instance, $2641f5944a8728bd$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            class: 0,
            classes: 1,
            style: 2,
            styles: 3,
            value: 16,
            label: 4,
            spellcheck: 5,
            disabled: 6,
            textarea: 7,
            tooltip: 8,
            sharpRightCorners: 9,
            placeholder: 10,
            selectAllText: 17,
            focus: 18,
            unFocus: 19,
            getValue: 20,
            setInputElementValue: 21,
            element: 22
        }, null, [
            -1,
            -1
        ]);
    }
    get selectAllText() {
        return this.$$.ctx[17];
    }
    get focus() {
        return this.$$.ctx[18];
    }
    get unFocus() {
        return this.$$.ctx[19];
    }
    get getValue() {
        return this.$$.ctx[20];
    }
    get setInputElementValue() {
        return this.$$.ctx[21];
    }
    get element() {
        return this.$$.ctx[22];
    }
}
var $2641f5944a8728bd$export$2e2bcd8739ae039 = $2641f5944a8728bd$var$FieldInput;


function $4f662fa3f52169e2$var$create_if_block_3(ctx) {
    let button0;
    let t;
    let button1;
    let mounted;
    let dispose;
    return {
        c () {
            button0 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button1 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "class", "arrow left");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "tabindex", "-1");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "class", "arrow right");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "tabindex", "-1");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button1, anchor);
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button0, "click", /*click_handler*/ ctx[32]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button1, "click", /*click_handler_1*/ ctx[33])
                ];
                mounted = true;
            }
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button1);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
// (226:1) {#if mode === "Range" && value !== undefined}
function $4f662fa3f52169e2$var$create_if_block_2(ctx) {
    let input;
    let mounted;
    let dispose;
    return {
        c () {
            input = (0, $1eb80e36873dc327$export$8454457683f90105)("input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "type", "range");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "class", "slider");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "min", /*rangeMin*/ ctx[6]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "max", /*rangeMax*/ ctx[7]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "step", /*sliderStepValue*/ ctx[15]);
            input.disabled = /*disabled*/ ctx[2];
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "tabindex", "-1");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(input, "hidden", /*rangeSliderClickDragState*/ ctx[14] === "mousedown");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, input, anchor);
            (0, $1eb80e36873dc327$export$aee788c6eadfac08)(input, /*rangeSliderValue*/ ctx[12]);
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "change", /*input_change_input_handler*/ ctx[34]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "input", /*input_change_input_handler*/ ctx[34]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "input", /*onSliderInput*/ ctx[16]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "pointerdown", /*onSliderPointerDown*/ ctx[17]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "pointerup", /*onSliderPointerUp*/ ctx[18])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty[0] & /*rangeMin*/ 64) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "min", /*rangeMin*/ ctx[6]);
            if (dirty[0] & /*rangeMax*/ 128) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "max", /*rangeMax*/ ctx[7]);
            if (dirty[0] & /*sliderStepValue*/ 32768) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "step", /*sliderStepValue*/ ctx[15]);
            if (dirty[0] & /*disabled*/ 4) input.disabled = /*disabled*/ ctx[2];
            if (dirty[0] & /*rangeSliderValue*/ 4096) (0, $1eb80e36873dc327$export$aee788c6eadfac08)(input, /*rangeSliderValue*/ ctx[12]);
            if (dirty[0] & /*rangeSliderClickDragState*/ 16384) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(input, "hidden", /*rangeSliderClickDragState*/ ctx[14] === "mousedown");
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(input);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
// (242:1) {#if value !== undefined}
function $4f662fa3f52169e2$var$create_if_block(ctx) {
    let t;
    let div;
    let if_block = /*value*/ ctx[3] !== undefined && /*rangeSliderClickDragState*/ ctx[14] === "mousedown" && $4f662fa3f52169e2$var$create_if_block_1(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "slider-progress");
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        p (ctx, dirty) {
            if (/*value*/ ctx[3] !== undefined && /*rangeSliderClickDragState*/ ctx[14] === "mousedown") {
                if (if_block) ;
                else {
                    if_block = $4f662fa3f52169e2$var$create_if_block_1(ctx);
                    if_block.c();
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (243:2) {#if value !== undefined && rangeSliderClickDragState === "mousedown"}
function $4f662fa3f52169e2$var$create_if_block_1(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "fake-slider-thumb");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (207:0) <FieldInput  class={`number-input ${mode.toLocaleLowerCase()}`}  value={text}  on:value={({ detail }) => (text = detail)}  on:textFocused={onTextFocused}  on:textChanged={onTextChanged}  on:cancelTextChange={onCancelTextChange}  {label}  {disabled}  {tooltip}  {sharpRightCorners}  spellcheck={false}  styles={{ "min-width": minWidth > 0 ? `${minWidth}px` : undefined, "--progress-factor": (rangeSliderValueAsRendered - rangeMin) / (rangeMax - rangeMin) }}  bind:this={self} >
function $4f662fa3f52169e2$var$create_default_slot(ctx) {
    let t0;
    let t1;
    let if_block2_anchor;
    let if_block0 = /*value*/ ctx[3] !== undefined && /*mode*/ ctx[4] === "Increment" && /*incrementBehavior*/ ctx[5] !== "None" && $4f662fa3f52169e2$var$create_if_block_3(ctx);
    let if_block1 = /*mode*/ ctx[4] === "Range" && /*value*/ ctx[3] !== undefined && $4f662fa3f52169e2$var$create_if_block_2(ctx);
    let if_block2 = /*value*/ ctx[3] !== undefined && $4f662fa3f52169e2$var$create_if_block(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block2) if_block2.c();
            if_block2_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            if (if_block2) if_block2.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block2_anchor, anchor);
        },
        p (ctx, dirty) {
            if (/*value*/ ctx[3] !== undefined && /*mode*/ ctx[4] === "Increment" && /*incrementBehavior*/ ctx[5] !== "None") {
                if (if_block0) if_block0.p(ctx, dirty);
                else {
                    if_block0 = $4f662fa3f52169e2$var$create_if_block_3(ctx);
                    if_block0.c();
                    if_block0.m(t0.parentNode, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (/*mode*/ ctx[4] === "Range" && /*value*/ ctx[3] !== undefined) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $4f662fa3f52169e2$var$create_if_block_2(ctx);
                    if_block1.c();
                    if_block1.m(t1.parentNode, t1);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            if (/*value*/ ctx[3] !== undefined) {
                if (if_block2) if_block2.p(ctx, dirty);
                else {
                    if_block2 = $4f662fa3f52169e2$var$create_if_block(ctx);
                    if_block2.c();
                    if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (if_block2) if_block2.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block2_anchor);
        }
    };
}
function $4f662fa3f52169e2$var$create_fragment(ctx) {
    let fieldinput;
    let current;
    let fieldinput_props = {
        class: `number-input ${ctx[4].toLocaleLowerCase()}`,
        value: /*text*/ ctx[11],
        label: /*label*/ ctx[0],
        disabled: /*disabled*/ ctx[2],
        tooltip: /*tooltip*/ ctx[1],
        sharpRightCorners: /*sharpRightCorners*/ ctx[9],
        spellcheck: false,
        styles: {
            "min-width": /*minWidth*/ ctx[8] > 0 ? `${ctx[8]}px` : undefined,
            "--progress-factor": /*rangeSliderValueAsRendered*/ (ctx[13] - /*rangeMin*/ ctx[6]) / /*rangeMax*/ (ctx[7] - /*rangeMin*/ ctx[6])
        },
        $$slots: {
            default: [
                $4f662fa3f52169e2$var$create_default_slot
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    fieldinput = new (0, $2641f5944a8728bd$export$2e2bcd8739ae039)({
        props: fieldinput_props
    });
    /*fieldinput_binding*/ ctx[35](fieldinput);
    fieldinput.$on("value", /*value_handler*/ ctx[36]);
    fieldinput.$on("textFocused", /*onTextFocused*/ ctx[19]);
    fieldinput.$on("textChanged", /*onTextChanged*/ ctx[20]);
    fieldinput.$on("cancelTextChange", /*onCancelTextChange*/ ctx[21]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(fieldinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(fieldinput, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const fieldinput_changes = {};
            if (dirty[0] & /*mode*/ 16) fieldinput_changes.class = `number-input ${ctx[4].toLocaleLowerCase()}`;
            if (dirty[0] & /*text*/ 2048) fieldinput_changes.value = /*text*/ ctx[11];
            if (dirty[0] & /*label*/ 1) fieldinput_changes.label = /*label*/ ctx[0];
            if (dirty[0] & /*disabled*/ 4) fieldinput_changes.disabled = /*disabled*/ ctx[2];
            if (dirty[0] & /*tooltip*/ 2) fieldinput_changes.tooltip = /*tooltip*/ ctx[1];
            if (dirty[0] & /*sharpRightCorners*/ 512) fieldinput_changes.sharpRightCorners = /*sharpRightCorners*/ ctx[9];
            if (dirty[0] & /*minWidth, rangeSliderValueAsRendered, rangeMin, rangeMax*/ 8640) fieldinput_changes.styles = {
                "min-width": /*minWidth*/ ctx[8] > 0 ? `${ctx[8]}px` : undefined,
                "--progress-factor": /*rangeSliderValueAsRendered*/ (ctx[13] - /*rangeMin*/ ctx[6]) / /*rangeMax*/ (ctx[7] - /*rangeMin*/ ctx[6])
            };
            if (dirty[0] & /*value, rangeSliderClickDragState, rangeMin, rangeMax, sliderStepValue, disabled, rangeSliderValue, mode, incrementBehavior*/ 53500 | dirty[1] & /*$$scope*/ 1024) fieldinput_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            fieldinput.$set(fieldinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(fieldinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(fieldinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*fieldinput_binding*/ ctx[35](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(fieldinput, detaching);
        }
    };
}
function $4f662fa3f52169e2$var$displayText(value, displayDecimalPlaces, unit) {
    if (value === undefined) return "-";
    // Find the amount of digits on the left side of the decimal
    // 10.25 == 2
    // 1.23 == 1
    // 0.23 == 0 (Reason for the slightly more complicated code)
    const absValueInt = Math.floor(Math.abs(value));
    const leftSideDigits = absValueInt === 0 ? 0 : absValueInt.toString().length;
    const roundingPower = 10 ** Math.max(displayDecimalPlaces - leftSideDigits, 0);
    const displayValue = Math.round(value * roundingPower) / roundingPower;
    return `${displayValue}${$4f662fa3f52169e2$var$unPluralize(unit, value)}`;
}
function $4f662fa3f52169e2$var$unPluralize(unit, value) {
    if (value === 1 && unit.endsWith("s")) return unit.slice(0, -1);
    return unit;
}
function $4f662fa3f52169e2$var$instance($$self, $$props, $$invalidate) {
    let sliderStepValue;
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { label: label } = $$props;
    let { tooltip: tooltip } = $$props;
    let { disabled: disabled = false } = $$props;
    let { value: value } = $$props;
    let { min: min } = $$props;
    let { max: max } = $$props;
    let { isInteger: isInteger = false } = $$props;
    let { displayDecimalPlaces: displayDecimalPlaces = 3 } = $$props;
    let { unit: unit = "" } = $$props;
    let { unitIsHiddenWhenEditing: unitIsHiddenWhenEditing = true } = $$props;
    let { mode: mode = "Increment" } = $$props;
    let { step: step = 1 } = $$props;
    let { incrementBehavior: incrementBehavior = "Add" } = $$props;
    let { rangeMin: rangeMin = 0 } = $$props;
    let { rangeMax: rangeMax = 1 } = $$props;
    let { minWidth: minWidth = 0 } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let { incrementCallbackIncrease: incrementCallbackIncrease } = $$props;
    let { incrementCallbackDecrease: incrementCallbackDecrease } = $$props;
    let self;
    let text = $4f662fa3f52169e2$var$displayText(value, displayDecimalPlaces, unit);
    let editing = false;
    // Stays in sync with a binding to the actual input range slider element.
    let rangeSliderValue = value !== undefined ? value : 0;
    // Value used to render the position of the fake slider when applicable, and length of the progress colored region to the slider's left.
    // This is the same as `rangeSliderValue` except in the "mousedown" state, when it has the previous location before the user's mousedown.
    let rangeSliderValueAsRendered = value !== undefined ? value : 0;
    // "default": no interaction is happening.
    // "mousedown": the user has pressed down the mouse and might next decide to either drag left/right or release without dragging.
    // "dragging": the user is dragging the slider left/right.
    let rangeSliderClickDragState = "default";
    // Called only when `value` is changed from outside this component
    function watchValue(value) {
        // Don't update if the slider is currently being dragged (we don't want the backend fighting with the user's drag)
        if (rangeSliderClickDragState === "dragging") return;
        // Draw a dash if the value is undefined
        if (value === undefined) {
            $$invalidate(11, text = "-");
            return;
        }
        // Update the range slider with the new value
        $$invalidate(12, rangeSliderValue = value);
        $$invalidate(13, rangeSliderValueAsRendered = value);
        // The simple `clamp()` function can't be used here since `undefined` values need to be boundless
        let sanitized = value;
        if (typeof min === "number") sanitized = Math.max(sanitized, min);
        if (typeof max === "number") sanitized = Math.min(sanitized, max);
        $$invalidate(11, text = $4f662fa3f52169e2$var$displayText(sanitized, displayDecimalPlaces, unit));
    }
    function onSliderInput() {
        // Keep only 4 digits after the decimal point
        const ROUNDING_EXPONENT = 4;
        const ROUNDING_MAGNITUDE = 10 ** ROUNDING_EXPONENT;
        const roundedValue = Math.round(rangeSliderValue * ROUNDING_MAGNITUDE) / ROUNDING_MAGNITUDE;
        // Exit if this is an extraneous event invocation that occurred after mouseup, which happens in Firefox
        if (value !== undefined && Math.abs(value - roundedValue) < 1 / ROUNDING_MAGNITUDE) return;
        // The first event upon mousedown means we transition to a "mousedown" state
        if (rangeSliderClickDragState === "default") {
            $$invalidate(14, rangeSliderClickDragState = "mousedown");
            // Exit early because we don't want to use the value set by where on the track the user pressed
            return;
        }
        // The second event upon mousedown that occurs by moving left or right means the user has committed to dragging the slider
        if (rangeSliderClickDragState === "mousedown") $$invalidate(14, rangeSliderClickDragState = "dragging");
        // If we're in a dragging state, we want to use the new slider value
        $$invalidate(13, rangeSliderValueAsRendered = roundedValue);
        updateValue(roundedValue, min, max, displayDecimalPlaces, unit);
    }
    function onSliderPointerDown() {
        // We want to render the fake slider thumb at the old position, which is still the number held by `value`
        $$invalidate(13, rangeSliderValueAsRendered = value || 0);
    } // Because an `input` event is fired right before or after this (depending on browser), that first
    // invocation will transition the state machine to `mousedown`. That's why we don't do it here.
    function onSliderPointerUp() {
        // User clicked but didn't drag, so we focus the text input element
        if (rangeSliderClickDragState === "mousedown") {
            const inputElement = self?.element();
            if (!inputElement) return;
            // Set the slider position back to the original position to undo the user moving it
            $$invalidate(12, rangeSliderValue = rangeSliderValueAsRendered);
            // Begin editing the number text field
            inputElement.focus();
        }
        // Releasing the mouse means we can reset the state machine
        $$invalidate(14, rangeSliderClickDragState = "default");
    }
    function onTextFocused() {
        if (value === undefined) $$invalidate(11, text = "");
        else if (unitIsHiddenWhenEditing) $$invalidate(11, text = `${value}`);
        else $$invalidate(11, text = `${value}${$4f662fa3f52169e2$var$unPluralize(unit, value)}`);
        editing = true;
        self?.selectAllText(text);
    }
    // Called only when `value` is changed from the <input> element via user input and committed, either with the
    // enter key (via the `change` event) or when the <input> element is unfocused (with the `blur` event binding)
    function onTextChanged() {
        // The `unFocus()` call at the bottom of this function and in `onCancelTextChange()` causes this function to be run again, so this check skips a second run
        if (!editing) return;
        const parsed = parseFloat(text);
        const newValue = Number.isNaN(parsed) ? undefined : parsed;
        updateValue(newValue, min, max, displayDecimalPlaces, unit);
        editing = false;
        self?.unFocus();
    }
    function onCancelTextChange() {
        updateValue(undefined, min, max, displayDecimalPlaces, unit);
        $$invalidate(12, rangeSliderValue = value);
        $$invalidate(13, rangeSliderValueAsRendered = value);
        editing = false;
        self?.unFocus();
    }
    function onIncrement(direction) {
        if (value === undefined) return;
        const actions = {
            Add: ()=>{
                const directionAddend = direction === "Increase" ? step : -step;
                updateValue(value !== undefined ? value + directionAddend : undefined, min, max, displayDecimalPlaces, unit);
            },
            Multiply: ()=>{
                const directionMultiplier = direction === "Increase" ? step : 1 / step;
                updateValue(value !== undefined ? value * directionMultiplier : undefined, min, max, displayDecimalPlaces, unit);
            },
            Callback: ()=>{
                if (direction === "Increase") incrementCallbackIncrease?.();
                if (direction === "Decrease") incrementCallbackDecrease?.();
            },
            None: ()=>{}
        };
        const action = actions[incrementBehavior];
        action();
    }
    function updateValue(newValue, min, max, displayDecimalPlaces, unit) {
        // Check if the new value is valid, otherwise we use the old value (rounded if it's an integer)
        const oldValue = value !== undefined && isInteger ? Math.round(value) : value;
        let cleaned = newValue !== undefined ? newValue : oldValue;
        if (cleaned !== undefined) {
            if (typeof min === "number" && !Number.isNaN(min)) cleaned = Math.max(cleaned, min);
            if (typeof max === "number" && !Number.isNaN(max)) cleaned = Math.min(cleaned, max);
            $$invalidate(12, rangeSliderValue = cleaned);
            $$invalidate(13, rangeSliderValueAsRendered = cleaned);
        }
        $$invalidate(11, text = $4f662fa3f52169e2$var$displayText(cleaned, displayDecimalPlaces, unit));
        if (newValue !== undefined) dispatch("value", cleaned);
    }
    const click_handler = ()=>onIncrement("Decrease");
    const click_handler_1 = ()=>onIncrement("Increase");
    function input_change_input_handler() {
        rangeSliderValue = (0, $1eb80e36873dc327$export$5ba91aa2ee2bd813)(this.value);
        $$invalidate(12, rangeSliderValue);
    }
    function fieldinput_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(10, self);
        });
    }
    const value_handler = ({ detail: detail })=>$$invalidate(11, text = detail);
    $$self.$$set = ($$props)=>{
        if ("label" in $$props) $$invalidate(0, label = $$props.label);
        if ("tooltip" in $$props) $$invalidate(1, tooltip = $$props.tooltip);
        if ("disabled" in $$props) $$invalidate(2, disabled = $$props.disabled);
        if ("value" in $$props) $$invalidate(3, value = $$props.value);
        if ("min" in $$props) $$invalidate(23, min = $$props.min);
        if ("max" in $$props) $$invalidate(24, max = $$props.max);
        if ("isInteger" in $$props) $$invalidate(25, isInteger = $$props.isInteger);
        if ("displayDecimalPlaces" in $$props) $$invalidate(26, displayDecimalPlaces = $$props.displayDecimalPlaces);
        if ("unit" in $$props) $$invalidate(27, unit = $$props.unit);
        if ("unitIsHiddenWhenEditing" in $$props) $$invalidate(28, unitIsHiddenWhenEditing = $$props.unitIsHiddenWhenEditing);
        if ("mode" in $$props) $$invalidate(4, mode = $$props.mode);
        if ("step" in $$props) $$invalidate(29, step = $$props.step);
        if ("incrementBehavior" in $$props) $$invalidate(5, incrementBehavior = $$props.incrementBehavior);
        if ("rangeMin" in $$props) $$invalidate(6, rangeMin = $$props.rangeMin);
        if ("rangeMax" in $$props) $$invalidate(7, rangeMax = $$props.rangeMax);
        if ("minWidth" in $$props) $$invalidate(8, minWidth = $$props.minWidth);
        if ("sharpRightCorners" in $$props) $$invalidate(9, sharpRightCorners = $$props.sharpRightCorners);
        if ("incrementCallbackIncrease" in $$props) $$invalidate(30, incrementCallbackIncrease = $$props.incrementCallbackIncrease);
        if ("incrementCallbackDecrease" in $$props) $$invalidate(31, incrementCallbackDecrease = $$props.incrementCallbackDecrease);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*value*/ 8) $: watchValue(value);
        if ($$self.$$.dirty[0] & /*isInteger, step*/ 570425344) $: $$invalidate(15, sliderStepValue = isInteger ? step === undefined ? 1 : step : "any");
    };
    return [
        label,
        tooltip,
        disabled,
        value,
        mode,
        incrementBehavior,
        rangeMin,
        rangeMax,
        minWidth,
        sharpRightCorners,
        self,
        text,
        rangeSliderValue,
        rangeSliderValueAsRendered,
        rangeSliderClickDragState,
        sliderStepValue,
        onSliderInput,
        onSliderPointerDown,
        onSliderPointerUp,
        onTextFocused,
        onTextChanged,
        onCancelTextChange,
        onIncrement,
        min,
        max,
        isInteger,
        displayDecimalPlaces,
        unit,
        unitIsHiddenWhenEditing,
        step,
        incrementCallbackIncrease,
        incrementCallbackDecrease,
        click_handler,
        click_handler_1,
        input_change_input_handler,
        fieldinput_binding,
        value_handler
    ];
}
class $4f662fa3f52169e2$var$NumberInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $4f662fa3f52169e2$var$instance, $4f662fa3f52169e2$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            label: 0,
            tooltip: 1,
            disabled: 2,
            value: 3,
            min: 23,
            max: 24,
            isInteger: 25,
            displayDecimalPlaces: 26,
            unit: 27,
            unitIsHiddenWhenEditing: 28,
            mode: 4,
            step: 29,
            incrementBehavior: 5,
            rangeMin: 6,
            rangeMax: 7,
            minWidth: 8,
            sharpRightCorners: 9,
            incrementCallbackIncrease: 30,
            incrementCallbackDecrease: 31
        }, null, [
            -1,
            -1
        ]);
    }
}
var $4f662fa3f52169e2$export$2e2bcd8739ae039 = $4f662fa3f52169e2$var$NumberInput;


/* src/components/widgets/inputs/TextInput.svelte generated by Svelte v3.58.0 */ 


function $13b5dd8e132143df$var$create_fragment(ctx) {
    let fieldinput;
    let current;
    let fieldinput_props = {
        class: "text-input",
        classes: {
            centered: /*centered*/ ctx[5]
        },
        styles: {
            "min-width": /*minWidth*/ ctx[6] > 0 ? `${ctx[6]}px` : undefined
        },
        value: /*value*/ ctx[4],
        spellcheck: true,
        label: /*label*/ ctx[0],
        disabled: /*disabled*/ ctx[3],
        tooltip: /*tooltip*/ ctx[1],
        placeholder: /*placeholder*/ ctx[2],
        sharpRightCorners: /*sharpRightCorners*/ ctx[7]
    };
    fieldinput = new (0, $2641f5944a8728bd$export$2e2bcd8739ae039)({
        props: fieldinput_props
    });
    /*fieldinput_binding*/ ctx[13](fieldinput);
    fieldinput.$on("value", /*value_handler*/ ctx[14]);
    fieldinput.$on("textFocused", /*onTextFocused*/ ctx[9]);
    fieldinput.$on("textChanged", /*onTextChanged*/ ctx[10]);
    fieldinput.$on("cancelTextChange", /*onCancelTextChange*/ ctx[11]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(fieldinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(fieldinput, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const fieldinput_changes = {};
            if (dirty & /*centered*/ 32) fieldinput_changes.classes = {
                centered: /*centered*/ ctx[5]
            };
            if (dirty & /*minWidth*/ 64) fieldinput_changes.styles = {
                "min-width": /*minWidth*/ ctx[6] > 0 ? `${ctx[6]}px` : undefined
            };
            if (dirty & /*value*/ 16) fieldinput_changes.value = /*value*/ ctx[4];
            if (dirty & /*label*/ 1) fieldinput_changes.label = /*label*/ ctx[0];
            if (dirty & /*disabled*/ 8) fieldinput_changes.disabled = /*disabled*/ ctx[3];
            if (dirty & /*tooltip*/ 2) fieldinput_changes.tooltip = /*tooltip*/ ctx[1];
            if (dirty & /*placeholder*/ 4) fieldinput_changes.placeholder = /*placeholder*/ ctx[2];
            if (dirty & /*sharpRightCorners*/ 128) fieldinput_changes.sharpRightCorners = /*sharpRightCorners*/ ctx[7];
            fieldinput.$set(fieldinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(fieldinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(fieldinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*fieldinput_binding*/ ctx[13](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(fieldinput, detaching);
        }
    };
}
function $13b5dd8e132143df$var$instance($$self, $$props, $$invalidate) {
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { label: label } = $$props;
    let { tooltip: tooltip } = $$props;
    let { placeholder: placeholder } = $$props;
    let { disabled: disabled = false } = $$props;
    let { value: value } = $$props;
    let { centered: centered = false } = $$props;
    let { minWidth: minWidth = 0 } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let self;
    let editing = false;
    function onTextFocused() {
        editing = true;
        self?.selectAllText(value);
    }
    // Called only when `value` is changed from the <input> element via user input and committed, either with the
    // enter key (via the `change` event) or when the <input> element is unfocused (with the `blur` event binding)
    function onTextChanged() {
        // The `unFocus()` call in `onCancelTextChange()` causes itself to be run again, so this if statement skips a second run
        if (!editing) return;
        onCancelTextChange();
        // TODO: Find a less hacky way to do this
        if (self) dispatch("commitText", self.getValue());
        // Required if value is not changed by the parent component upon update:value event
        self?.setInputElementValue(self.getValue());
    }
    function onCancelTextChange() {
        editing = false;
        self?.unFocus();
    }
    function focus() {
        self?.focus();
    }
    function fieldinput_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(8, self);
        });
    }
    function value_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("label" in $$props) $$invalidate(0, label = $$props.label);
        if ("tooltip" in $$props) $$invalidate(1, tooltip = $$props.tooltip);
        if ("placeholder" in $$props) $$invalidate(2, placeholder = $$props.placeholder);
        if ("disabled" in $$props) $$invalidate(3, disabled = $$props.disabled);
        if ("value" in $$props) $$invalidate(4, value = $$props.value);
        if ("centered" in $$props) $$invalidate(5, centered = $$props.centered);
        if ("minWidth" in $$props) $$invalidate(6, minWidth = $$props.minWidth);
        if ("sharpRightCorners" in $$props) $$invalidate(7, sharpRightCorners = $$props.sharpRightCorners);
    };
    return [
        label,
        tooltip,
        placeholder,
        disabled,
        value,
        centered,
        minWidth,
        sharpRightCorners,
        self,
        onTextFocused,
        onTextChanged,
        onCancelTextChange,
        focus,
        fieldinput_binding,
        value_handler
    ];
}
class $13b5dd8e132143df$var$TextInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $13b5dd8e132143df$var$instance, $13b5dd8e132143df$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            label: 0,
            tooltip: 1,
            placeholder: 2,
            disabled: 3,
            value: 4,
            centered: 5,
            minWidth: 6,
            sharpRightCorners: 7,
            focus: 12
        });
    }
    get focus() {
        return this.$$.ctx[12];
    }
}
var $13b5dd8e132143df$export$2e2bcd8739ae039 = $13b5dd8e132143df$var$TextInput;




function $130a5ee3db98888b$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[54] = list[i][0];
    child_ctx[55] = list[i][1];
    child_ctx[56] = list;
    child_ctx[57] = i;
    return child_ctx;
}
function $130a5ee3db98888b$var$get_each_context_1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[54] = list[i][0];
    child_ctx[55] = list[i][1];
    child_ctx[58] = list;
    child_ctx[57] = i;
    return child_ctx;
}
// (248:3) {#if !isNone}
function $130a5ee3db98888b$var$create_if_block_5(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "selection-circle");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", `${(1 - /*value*/ ctx[5]) * 100}%`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "left", `${ctx[4] * 100}%`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*value*/ 32) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", `${(1 - /*value*/ ctx[5]) * 100}%`);
            if (dirty[0] & /*saturation*/ 16) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "left", `${ctx[4] * 100}%`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (247:2) <LayoutCol class="saturation-value-picker" on:pointerdown={onPointerDown} data-saturation-value-picker>
function $130a5ee3db98888b$var$create_default_slot_20(ctx) {
    let if_block_anchor;
    let if_block = !/*isNone*/ ctx[7] && $130a5ee3db98888b$var$create_if_block_5(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (!/*isNone*/ ctx[7]) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $130a5ee3db98888b$var$create_if_block_5(ctx);
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (253:3) {#if !isNone}
function $130a5ee3db98888b$var$create_if_block_4(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "selection-needle");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", `${(1 - /*hue*/ ctx[3]) * 100}%`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*hue*/ 8) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", `${(1 - /*hue*/ ctx[3]) * 100}%`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (252:2) <LayoutCol class="hue-picker" on:pointerdown={onPointerDown} data-hue-picker>
function $130a5ee3db98888b$var$create_default_slot_19(ctx) {
    let if_block_anchor;
    let if_block = !/*isNone*/ ctx[7] && $130a5ee3db98888b$var$create_if_block_4(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (!/*isNone*/ ctx[7]) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $130a5ee3db98888b$var$create_if_block_4(ctx);
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (258:3) {#if !isNone}
function $130a5ee3db98888b$var$create_if_block_3(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "selection-needle");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", `${(1 - /*alpha*/ ctx[6]) * 100}%`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*alpha*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", `${(1 - /*alpha*/ ctx[6]) * 100}%`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (257:2) <LayoutCol class="alpha-picker" on:pointerdown={onPointerDown} data-alpha-picker>
function $130a5ee3db98888b$var$create_default_slot_18(ctx) {
    let if_block_anchor;
    let if_block = !/*isNone*/ ctx[7] && $130a5ee3db98888b$var$create_if_block_3(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (!/*isNone*/ ctx[7]) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $130a5ee3db98888b$var$create_if_block_3(ctx);
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (265:5) <TextLabel>
function $130a5ee3db98888b$var$create_default_slot_17(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("New");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (264:4) <LayoutCol class="new-color" classes={{ none: isNone }}>
function $130a5ee3db98888b$var$create_default_slot_16(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_17
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[1] & /*$$scope*/ 268435456) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (268:5) <TextLabel>
function $130a5ee3db98888b$var$create_default_slot_15(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Initial");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (267:4) <LayoutCol class="initial-color" classes={{ none: initialIsNone }}>
function $130a5ee3db98888b$var$create_default_slot_14(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_15
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[1] & /*$$scope*/ 268435456) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (263:3) <LayoutRow class="choice-preview" on:click={swapNewWithInitial} tooltip="Comparison views of the present color choice (left) and the color before any change (right). Click to swap sides.">
function $130a5ee3db98888b$var$create_default_slot_13(ctx) {
    let layoutcol0;
    let t;
    let layoutcol1;
    let current;
    layoutcol0 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "new-color",
            classes: {
                none: /*isNone*/ ctx[7]
            },
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_16
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol1 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "initial-color",
            classes: {
                none: /*initialIsNone*/ ctx[8]
            },
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_14
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol0_changes = {};
            if (dirty[0] & /*isNone*/ 128) layoutcol0_changes.classes = {
                none: /*isNone*/ ctx[7]
            };
            if (dirty[1] & /*$$scope*/ 268435456) layoutcol0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol0.$set(layoutcol0_changes);
            const layoutcol1_changes = {};
            if (dirty[0] & /*initialIsNone*/ 256) layoutcol1_changes.classes = {
                none: /*initialIsNone*/ ctx[8]
            };
            if (dirty[1] & /*$$scope*/ 268435456) layoutcol1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol1.$set(layoutcol1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol1, detaching);
        }
    };
}
// (273:4) <TextLabel tooltip="Color code in hexadecimal format">
function $130a5ee3db98888b$var$create_default_slot_12(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Hex");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (275:4) <LayoutRow>
function $130a5ee3db98888b$var$create_default_slot_11(ctx) {
    let textinput;
    let current;
    textinput = new (0, $13b5dd8e132143df$export$2e2bcd8739ae039)({
        props: {
            value: /*newColor*/ ctx[9].toHexOptionalAlpha() || "-",
            centered: true,
            tooltip: "Color code in hexadecimal format. 6 digits if opaque, 8 with alpha.\nAccepts input of CSS color values including named colors."
        }
    });
    textinput.$on("commitText", /*commitText_handler*/ ctx[30]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textinput, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textinput_changes = {};
            if (dirty[0] & /*newColor*/ 512) textinput_changes.value = /*newColor*/ ctx[9].toHexOptionalAlpha() || "-";
            textinput.$set(textinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textinput, detaching);
        }
    };
}
// (272:3) <LayoutRow>
function $130a5ee3db98888b$var$create_default_slot_10(ctx) {
    let textlabel;
    let t0;
    let separator;
    let t1;
    let layoutrow;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            tooltip: "Color code in hexadecimal format",
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_12
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({});
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_11
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[1] & /*$$scope*/ 268435456) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            const layoutrow_changes = {};
            if (dirty[0] & /*newColor*/ 512 | dirty[1] & /*$$scope*/ 268435456) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (285:4) <TextLabel tooltip="Red/Green/Blue channels of the color, integers 0–255">
function $130a5ee3db98888b$var$create_default_slot_9(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("RGB");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (289:6) {#if index > 0}
function $130a5ee3db98888b$var$create_if_block_2(ctx) {
    let separator;
    let current;
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Related"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
        }
    };
}
// (288:5) {#each rgbChannels as [channel, strength], index (channel)}
function $130a5ee3db98888b$var$create_each_block_1(key_1, ctx) {
    let first;
    let t;
    let numberinput;
    let current;
    let if_block = /*index*/ ctx[57] > 0 && $130a5ee3db98888b$var$create_if_block_2(ctx);
    function value_handler(...args) {
        return /*value_handler*/ ctx[31](/*strength*/ ctx[55], /*each_value_1*/ ctx[58], /*index*/ ctx[57], /*channel*/ ctx[54], ...args);
    }
    numberinput = new (0, $4f662fa3f52169e2$export$2e2bcd8739ae039)({
        props: {
            value: /*strength*/ ctx[55],
            min: 0,
            max: 255,
            minWidth: 56,
            tooltip: `${{
                r: "Red",
                g: "Green",
                b: "Blue"
            }[/*channel*/ ctx[54]]} channel, integers 0–255`
        }
    });
    numberinput.$on("value", value_handler);
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(numberinput.$$.fragment);
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(numberinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*index*/ ctx[57] > 0) {
                if (if_block) {
                    if (dirty[0] & /*rgbChannels*/ 16384) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $130a5ee3db98888b$var$create_if_block_2(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            const numberinput_changes = {};
            if (dirty[0] & /*rgbChannels*/ 16384) numberinput_changes.value = /*strength*/ ctx[55];
            if (dirty[0] & /*rgbChannels*/ 16384) numberinput_changes.tooltip = `${({
                r: "Red",
                g: "Green",
                b: "Blue"
            })[/*channel*/ ctx[54]]} channel, integers 0–255`;
            numberinput.$set(numberinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(numberinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(numberinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(numberinput, detaching);
        }
    };
}
// (287:4) <LayoutRow>
function $130a5ee3db98888b$var$create_default_slot_8(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let each_value_1 = /*rgbChannels*/ ctx[14];
    const get_key = (ctx)=>/*channel*/ ctx[54];
    for(let i = 0; i < each_value_1.length; i += 1){
        let child_ctx = $130a5ee3db98888b$var$get_each_context_1(ctx, each_value_1, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $130a5ee3db98888b$var$create_each_block_1(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty[0] & /*rgbChannels, setColorRGB*/ 540672) {
                each_value_1 = /*rgbChannels*/ ctx[14];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $130a5ee3db98888b$var$create_each_block_1, each_1_anchor, $130a5ee3db98888b$var$get_each_context_1);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value_1.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (284:3) <LayoutRow>
function $130a5ee3db98888b$var$create_default_slot_7(ctx) {
    let textlabel;
    let t0;
    let separator;
    let t1;
    let layoutrow;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            tooltip: "Red/Green/Blue channels of the color, integers 0–255",
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_9
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({});
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_8
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[1] & /*$$scope*/ 268435456) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            const layoutrow_changes = {};
            if (dirty[0] & /*rgbChannels*/ 16384 | dirty[1] & /*$$scope*/ 268435456) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (307:4) <TextLabel tooltip={"Hue/Saturation/Value, also known as Hue/Saturation/Brightness (HSB).\nNot to be confused with Hue/Saturation/Lightness (HSL), a different color model."}      >
function $130a5ee3db98888b$var$create_default_slot_6(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("HSV");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (313:6) {#if index > 0}
function $130a5ee3db98888b$var$create_if_block_1(ctx) {
    let separator;
    let current;
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Related"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
        }
    };
}
// (312:5) {#each hsvChannels as [channel, strength], index (channel)}
function $130a5ee3db98888b$var$create_each_block(key_1, ctx) {
    let first;
    let t;
    let numberinput;
    let current;
    let if_block = /*index*/ ctx[57] > 0 && $130a5ee3db98888b$var$create_if_block_1(ctx);
    function value_handler_1(...args) {
        return /*value_handler_1*/ ctx[32](/*strength*/ ctx[55], /*each_value*/ ctx[56], /*index*/ ctx[57], /*channel*/ ctx[54], ...args);
    }
    numberinput = new (0, $4f662fa3f52169e2$export$2e2bcd8739ae039)({
        props: {
            value: /*strength*/ ctx[55],
            min: 0,
            max: /*channel*/ ctx[54] === "h" ? 360 : 100,
            unit: /*channel*/ ctx[54] === "h" ? "\xb0" : "%",
            minWidth: 56,
            tooltip: {
                h: `Hue component, the "color" along the rainbow`,
                s: `Saturation component, the "colorfulness" from gray to vivid`,
                v: "Value (or Brightness), the distance away from being darkened to black"
            }[/*channel*/ ctx[54]]
        }
    });
    numberinput.$on("value", value_handler_1);
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(numberinput.$$.fragment);
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(numberinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*index*/ ctx[57] > 0) {
                if (if_block) {
                    if (dirty[0] & /*hsvChannels*/ 8192) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $130a5ee3db98888b$var$create_if_block_1(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t.parentNode, t);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            const numberinput_changes = {};
            if (dirty[0] & /*hsvChannels*/ 8192) numberinput_changes.value = /*strength*/ ctx[55];
            if (dirty[0] & /*hsvChannels*/ 8192) numberinput_changes.max = /*channel*/ ctx[54] === "h" ? 360 : 100;
            if (dirty[0] & /*hsvChannels*/ 8192) numberinput_changes.unit = /*channel*/ ctx[54] === "h" ? "\xb0" : "%";
            if (dirty[0] & /*hsvChannels*/ 8192) numberinput_changes.tooltip = ({
                h: `Hue component, the "color" along the rainbow`,
                s: `Saturation component, the "colorfulness" from gray to vivid`,
                v: "Value (or Brightness), the distance away from being darkened to black"
            })[/*channel*/ ctx[54]];
            numberinput.$set(numberinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(numberinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(numberinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(numberinput, detaching);
        }
    };
}
// (311:4) <LayoutRow>
function $130a5ee3db98888b$var$create_default_slot_5(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let each_value = /*hsvChannels*/ ctx[13];
    const get_key = (ctx)=>/*channel*/ ctx[54];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $130a5ee3db98888b$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $130a5ee3db98888b$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty[0] & /*hsvChannels, setColorHSV*/ 1056768) {
                each_value = /*hsvChannels*/ ctx[13];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $130a5ee3db98888b$var$create_each_block, each_1_anchor, $130a5ee3db98888b$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (306:3) <LayoutRow>
function $130a5ee3db98888b$var$create_default_slot_4(ctx) {
    let textlabel;
    let t0;
    let separator;
    let t1;
    let layoutrow;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            tooltip: "Hue/Saturation/Value, also known as Hue/Saturation/Brightness (HSB).\nNot to be confused with Hue/Saturation/Lightness (HSL), a different color model.",
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_6
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({});
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_5
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[1] & /*$$scope*/ 268435456) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            const layoutrow_changes = {};
            if (dirty[0] & /*hsvChannels*/ 8192 | dirty[1] & /*$$scope*/ 268435456) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (352:4) {#if allowNone}
function $130a5ee3db98888b$var$create_if_block(ctx) {
    let button;
    let t;
    let separator;
    let current;
    let mounted;
    let dispose;
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Related"
        }
    });
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "class", "preset-color none");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "title", "Set none");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", "0");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", /*click_handler*/ ctx[34]);
                mounted = true;
            }
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
            mounted = false;
            dispose();
        }
    };
}
// (351:3) <LayoutRow>
function $130a5ee3db98888b$var$create_default_slot_3(ctx) {
    let t0;
    let button0;
    let t1;
    let separator0;
    let t2;
    let button1;
    let t3;
    let separator1;
    let t4;
    let button2;
    let t10;
    let separator2;
    let t11;
    let iconbutton;
    let current;
    let mounted;
    let dispose;
    let if_block = /*allowNone*/ ctx[0] && $130a5ee3db98888b$var$create_if_block(ctx);
    separator0 = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Related"
        }
    });
    separator1 = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Related"
        }
    });
    separator2 = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: {
            type: "Related"
        }
    });
    iconbutton = new (0, $47cbcd4715b3f848$export$2e2bcd8739ae039)({
        props: {
            icon: "Eyedropper",
            size: 24,
            action: /*activateEyedropperSample*/ ctx[24],
            tooltip: "Sample a pixel color from the document"
        }
    });
    return {
        c () {
            if (if_block) if_block.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button0 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator0.$$.fragment);
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button1 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator1.$$.fragment);
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button2 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            button2.innerHTML = `<div data-pure-tile="red" style="--pure-color: #ff0000; --pure-color-gray: #4c4c4c" title="Set red"></div> 
					<div data-pure-tile="yellow" style="--pure-color: #ffff00; --pure-color-gray: #e3e3e3" title="Set yellow"></div> 
					<div data-pure-tile="green" style="--pure-color: #00ff00; --pure-color-gray: #969696" title="Set green"></div> 
					<div data-pure-tile="cyan" style="--pure-color: #00ffff; --pure-color-gray: #b2b2b2" title="Set cyan"></div> 
					<div data-pure-tile="blue" style="--pure-color: #0000ff; --pure-color-gray: #1c1c1c" title="Set blue"></div> 
					<div data-pure-tile="magenta" style="--pure-color: #ff00ff; --pure-color-gray: #696969" title="Set magenta"></div>`;
            t10 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator2.$$.fragment);
            t11 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconbutton.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "class", "preset-color black");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "title", "Set black");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "tabindex", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "class", "preset-color white");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "title", "Set white");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "tabindex", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button2, "class", "preset-color pure");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button2, "tabindex", "-1");
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t2, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button1, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t3, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t4, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button2, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t10, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator2, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t11, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconbutton, target, anchor);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button0, "click", /*click_handler_1*/ ctx[35]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button1, "click", /*click_handler_2*/ ctx[36]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button2, "click", /*setColorPresetSubtile*/ ctx[22])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (/*allowNone*/ ctx[0]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty[0] & /*allowNone*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $130a5ee3db98888b$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t0.parentNode, t0);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t2);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button1);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t3);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t4);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button2);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t10);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator2, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t11);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconbutton, detaching);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
// (262:2) <LayoutCol class="details">
function $130a5ee3db98888b$var$create_default_slot_2(ctx) {
    let layoutrow0;
    let t0;
    let dropdowninput;
    let t1;
    let layoutrow1;
    let t2;
    let layoutrow2;
    let t3;
    let layoutrow3;
    let t4;
    let numberinput;
    let t5;
    let layoutrow4;
    let t6;
    let layoutrow5;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "choice-preview",
            tooltip: "Comparison views of the present color choice (left) and the color before any change (right). Click to swap sides.",
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_13
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow0.$on("click", /*swapNewWithInitial*/ ctx[17]);
    dropdowninput = new (0, $b773e3d2fa9c5172$export$2e2bcd8739ae039)({
        props: {
            entries: /*COLOR_SPACE_CHOICES*/ ctx[15],
            selectedIndex: 0,
            disabled: true,
            tooltip: "Color Space and HDR (coming soon)"
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_10
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow2 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_7
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow3 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    numberinput = new (0, $4f662fa3f52169e2$export$2e2bcd8739ae039)({
        props: {
            label: "Alpha",
            value: !/*isNone*/ ctx[7] ? /*alpha*/ ctx[6] * 100 : undefined,
            min: 0,
            max: 100,
            rangeMin: 0,
            rangeMax: 100,
            unit: "%",
            mode: "Range",
            tooltip: `Scale from transparent (0%) to opaque (100%) for the color's alpha channel`
        }
    });
    numberinput.$on("value", /*value_handler_2*/ ctx[33]);
    layoutrow4 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "leftover-space"
        }
    });
    layoutrow5 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(dropdowninput.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow2.$$.fragment);
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow3.$$.fragment);
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(numberinput.$$.fragment);
            t5 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow4.$$.fragment);
            t6 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow5.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(dropdowninput, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t2, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow2, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t3, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow3, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t4, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(numberinput, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t5, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow4, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t6, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow5, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty[0] & /*initialIsNone, isNone*/ 384 | dirty[1] & /*$$scope*/ 268435456) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty[0] & /*newColor*/ 512 | dirty[1] & /*$$scope*/ 268435456) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
            const layoutrow2_changes = {};
            if (dirty[0] & /*rgbChannels*/ 16384 | dirty[1] & /*$$scope*/ 268435456) layoutrow2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow2.$set(layoutrow2_changes);
            const layoutrow3_changes = {};
            if (dirty[0] & /*hsvChannels*/ 8192 | dirty[1] & /*$$scope*/ 268435456) layoutrow3_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow3.$set(layoutrow3_changes);
            const numberinput_changes = {};
            if (dirty[0] & /*isNone, alpha*/ 192) numberinput_changes.value = !/*isNone*/ ctx[7] ? /*alpha*/ ctx[6] * 100 : undefined;
            numberinput.$set(numberinput_changes);
            const layoutrow5_changes = {};
            if (dirty[0] & /*allowNone*/ 1 | dirty[1] & /*$$scope*/ 268435456) layoutrow5_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow5.$set(layoutrow5_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(dropdowninput.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow3.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(numberinput.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow4.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow5.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(dropdowninput.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow3.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(numberinput.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow4.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow5.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(dropdowninput, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t2);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow2, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t3);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow3, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t4);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(numberinput, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t5);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow4, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t6);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow5, detaching);
        }
    };
}
// (235:1) <LayoutRow   styles={{    "--new-color": newColor.toHexOptionalAlpha(),    "--new-color-contrasting": newColor.contrastingColor(),    "--initial-color": initialColor.toHexOptionalAlpha(),    "--initial-color-contrasting": initialColor.contrastingColor(),    "--hue-color": opaqueHueColor.toRgbCSS(),    "--hue-color-contrasting": opaqueHueColor.contrastingColor(),    "--opaque-color": (newColor.opaque() || new Color(0, 0, 0, 1)).toHexNoAlpha(),    "--opaque-color-contrasting": (newColor.opaque() || new Color(0, 0, 0, 1)).contrastingColor(),   }}  >
function $130a5ee3db98888b$var$create_default_slot_1(ctx) {
    let layoutcol0;
    let t0;
    let layoutcol1;
    let t1;
    let layoutcol2;
    let t2;
    let layoutcol3;
    let current;
    layoutcol0 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "saturation-value-picker",
            "data-saturation-value-picker": true,
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_20
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol0.$on("pointerdown", /*onPointerDown*/ ctx[16]);
    layoutcol1 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "hue-picker",
            "data-hue-picker": true,
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_19
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol1.$on("pointerdown", /*onPointerDown*/ ctx[16]);
    layoutcol2 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "alpha-picker",
            "data-alpha-picker": true,
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_18
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol2.$on("pointerdown", /*onPointerDown*/ ctx[16]);
    layoutcol3 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "details",
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol2.$$.fragment);
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol3.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol2, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t2, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol3, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol0_changes = {};
            if (dirty[0] & /*value, saturation, isNone*/ 176 | dirty[1] & /*$$scope*/ 268435456) layoutcol0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol0.$set(layoutcol0_changes);
            const layoutcol1_changes = {};
            if (dirty[0] & /*hue, isNone*/ 136 | dirty[1] & /*$$scope*/ 268435456) layoutcol1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol1.$set(layoutcol1_changes);
            const layoutcol2_changes = {};
            if (dirty[0] & /*alpha, isNone*/ 192 | dirty[1] & /*$$scope*/ 268435456) layoutcol2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol2.$set(layoutcol2_changes);
            const layoutcol3_changes = {};
            if (dirty[0] & /*allowNone, isNone, alpha, hsvChannels, rgbChannels, newColor, initialIsNone*/ 25537 | dirty[1] & /*$$scope*/ 268435456) layoutcol3_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol3.$set(layoutcol3_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol3.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol3.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol2, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t2);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol3, detaching);
        }
    };
}
// (234:0) <FloatingMenu class="color-picker" {open} on:open {strayCloses} {direction} type="Popover">
function $130a5ee3db98888b$var$create_default_slot(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            styles: {
                "--new-color": /*newColor*/ ctx[9].toHexOptionalAlpha(),
                "--new-color-contrasting": /*newColor*/ ctx[9].contrastingColor(),
                "--initial-color": /*initialColor*/ ctx[11].toHexOptionalAlpha(),
                "--initial-color-contrasting": /*initialColor*/ ctx[11].contrastingColor(),
                "--hue-color": /*opaqueHueColor*/ ctx[12].toRgbCSS(),
                "--hue-color-contrasting": /*opaqueHueColor*/ ctx[12].contrastingColor(),
                "--opaque-color": /*newColor*/ (ctx[9].opaque() || new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(0, 0, 0, 1)).toHexNoAlpha(),
                "--opaque-color-contrasting": /*newColor*/ (ctx[9].opaque() || new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(0, 0, 0, 1)).contrastingColor()
            },
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty[0] & /*newColor, initialColor, opaqueHueColor*/ 6656) layoutrow_changes.styles = {
                "--new-color": /*newColor*/ ctx[9].toHexOptionalAlpha(),
                "--new-color-contrasting": /*newColor*/ ctx[9].contrastingColor(),
                "--initial-color": /*initialColor*/ ctx[11].toHexOptionalAlpha(),
                "--initial-color-contrasting": /*initialColor*/ ctx[11].contrastingColor(),
                "--hue-color": /*opaqueHueColor*/ ctx[12].toRgbCSS(),
                "--hue-color-contrasting": /*opaqueHueColor*/ ctx[12].contrastingColor(),
                "--opaque-color": /*newColor*/ (ctx[9].opaque() || new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(0, 0, 0, 1)).toHexNoAlpha(),
                "--opaque-color-contrasting": /*newColor*/ (ctx[9].opaque() || new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(0, 0, 0, 1)).contrastingColor()
            };
            if (dirty[0] & /*allowNone, isNone, alpha, hsvChannels, rgbChannels, newColor, initialIsNone, hue, value, saturation*/ 25593 | dirty[1] & /*$$scope*/ 268435456) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $130a5ee3db98888b$var$create_fragment(ctx) {
    let floatingmenu;
    let current;
    floatingmenu = new (0, $ef66a8e69d2c44ad$export$2e2bcd8739ae039)({
        props: {
            class: "color-picker",
            open: /*open*/ ctx[2],
            strayCloses: /*strayCloses*/ ctx[10],
            direction: /*direction*/ ctx[1],
            type: "Popover",
            $$slots: {
                default: [
                    $130a5ee3db98888b$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    floatingmenu.$on("open", /*open_handler*/ ctx[37]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(floatingmenu.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(floatingmenu, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const floatingmenu_changes = {};
            if (dirty[0] & /*open*/ 4) floatingmenu_changes.open = /*open*/ ctx[2];
            if (dirty[0] & /*strayCloses*/ 1024) floatingmenu_changes.strayCloses = /*strayCloses*/ ctx[10];
            if (dirty[0] & /*direction*/ 2) floatingmenu_changes.direction = /*direction*/ ctx[1];
            if (dirty[0] & /*newColor, initialColor, opaqueHueColor, allowNone, isNone, alpha, hsvChannels, rgbChannels, initialIsNone, hue, value, saturation*/ 31737 | dirty[1] & /*$$scope*/ 268435456) floatingmenu_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            floatingmenu.$set(floatingmenu_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(floatingmenu.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(floatingmenu.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(floatingmenu, detaching);
        }
    };
}
function $130a5ee3db98888b$var$instance($$self, $$props, $$invalidate) {
    let initialColor;
    let newColor;
    let rgbChannels;
    let hsvChannels;
    let opaqueHueColor;
    const PURE_COLORS = {
        none: [
            0,
            0,
            0
        ],
        black: [
            0,
            0,
            0
        ],
        white: [
            1,
            1,
            1
        ],
        red: [
            1,
            0,
            0
        ],
        yellow: [
            1,
            1,
            0
        ],
        green: [
            0,
            1,
            0
        ],
        cyan: [
            0,
            1,
            1
        ],
        blue: [
            0,
            0,
            1
        ],
        magenta: [
            1,
            0,
            1
        ]
    };
    const COLOR_SPACE_CHOICES = [
        [
            {
                label: "sRGB"
            }
        ]
    ];
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    // emits: ["update:color", "update:open"],
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { color: color } = $$props;
    let { allowNone: allowNone = false } = $$props;
    let { direction: direction = "Bottom" } = $$props;
    let { open: open } = $$props;
    const hsvaOrNone = color.toHSVA();
    const hsva = hsvaOrNone || {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    // New color components
    let hue = hsva.h;
    let saturation = hsva.s;
    let value = hsva.v;
    let alpha = hsva.a;
    let isNone = hsvaOrNone === undefined;
    // Initial color components
    let initialHue = hsva.h;
    let initialSaturation = hsva.s;
    let initialValue = hsva.v;
    let initialAlpha = hsva.a;
    let initialIsNone = hsvaOrNone === undefined;
    // Transient state
    let draggingPickerTrack = undefined;
    let strayCloses = true;
    function generateColor(h, s, v, a, none, ..._) {
        if (none) return new (0, $f7aa31b9879f1252$export$892596cec99bc70e)("none");
        return new (0, $f7aa31b9879f1252$export$892596cec99bc70e)({
            h: h,
            s: s,
            v: v,
            a: a
        });
    }
    function watchOpen(open) {
        if (!open) setInitialHSVA(hue, saturation, value, alpha, isNone);
    }
    function watchColor(color) {
        const hsva = color.toHSVA();
        if (hsva === undefined) {
            setNewHSVA(0, 0, 0, 1, true);
            return;
        }
        // Update the hue, but only if it is necessary so we don't:
        // - ...jump the user's hue from 360° (top) to the equivalent 0° (bottom)
        // - ...reset the hue to 0° if the color is fully desaturated, where all hues are equivalent
        // - ...reset the hue to 0° if the color's value is black, where all hues are equivalent
        if (!(hsva.h === 0 && hue === 1) && hsva.s > 0 && hsva.v > 0) $$invalidate(3, hue = hsva.h);
        // Update the saturation, but only if it is necessary so we don't:
        // - ...reset the saturation to the left if the color's value is black along the bottom edge, where all saturations are equivalent
        if (hsva.v !== 0) $$invalidate(4, saturation = hsva.s);
        // Update the value
        $$invalidate(5, value = hsva.v);
        // Update the alpha
        $$invalidate(6, alpha = hsva.a);
        // Update the status of this not being a color
        $$invalidate(7, isNone = false);
    }
    function onPointerDown(e) {
        const target = e.target || undefined;
        draggingPickerTrack = target?.closest("[data-saturation-value-picker], [data-hue-picker], [data-alpha-picker]") || undefined;
        addEvents();
        onPointerMove(e);
    }
    function onPointerMove(e) {
        // Just in case the mouseup event is lost
        if (e.buttons === 0) removeEvents();
        if (draggingPickerTrack?.hasAttribute("data-saturation-value-picker")) {
            const rectangle = draggingPickerTrack.getBoundingClientRect();
            $$invalidate(4, saturation = (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)((e.clientX - rectangle.left) / rectangle.width, 0, 1));
            $$invalidate(5, value = (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(1 - (e.clientY - rectangle.top) / rectangle.height, 0, 1));
            $$invalidate(10, strayCloses = false);
        } else if (draggingPickerTrack?.hasAttribute("data-hue-picker")) {
            const rectangle = draggingPickerTrack.getBoundingClientRect();
            $$invalidate(3, hue = (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(1 - (e.clientY - rectangle.top) / rectangle.height, 0, 1));
            $$invalidate(10, strayCloses = false);
        } else if (draggingPickerTrack?.hasAttribute("data-alpha-picker")) {
            const rectangle = draggingPickerTrack.getBoundingClientRect();
            $$invalidate(6, alpha = (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(1 - (e.clientY - rectangle.top) / rectangle.height, 0, 1));
            $$invalidate(10, strayCloses = false);
        }
        const color = new (0, $f7aa31b9879f1252$export$892596cec99bc70e)({
            h: hue,
            s: saturation,
            v: value,
            a: alpha
        });
        setColor(color);
    }
    function onPointerUp() {
        removeEvents();
    }
    function addEvents() {
        document.addEventListener("pointermove", onPointerMove);
        document.addEventListener("pointerup", onPointerUp);
    }
    function removeEvents() {
        draggingPickerTrack = undefined;
        $$invalidate(10, strayCloses = true);
        document.removeEventListener("pointermove", onPointerMove);
        document.removeEventListener("pointerup", onPointerUp);
    }
    function setColor(color) {
        const colorToEmit = color || new (0, $f7aa31b9879f1252$export$892596cec99bc70e)({
            h: hue,
            s: saturation,
            v: value,
            a: alpha
        });
        dispatch("color", colorToEmit);
    }
    function swapNewWithInitial() {
        const initial = initialColor;
        const tempHue = hue;
        const tempSaturation = saturation;
        const tempValue = value;
        const tempAlpha = alpha;
        const tempIsNone = isNone;
        setNewHSVA(initialHue, initialSaturation, initialValue, initialAlpha, initialIsNone);
        setInitialHSVA(tempHue, tempSaturation, tempValue, tempAlpha, tempIsNone);
        setColor(initial);
    }
    function setColorCode(colorCode) {
        const color = (0, $f7aa31b9879f1252$export$892596cec99bc70e).fromCSS(colorCode);
        if (color) setColor(color);
    }
    function setColorRGB(channel, strength) {
        // Do nothing if the given value is undefined
        if (strength === undefined) undefined;
        else if (channel === "r") setColor(new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(strength / 255, newColor.green, newColor.blue, newColor.alpha));
        else if (channel === "g") setColor(new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(newColor.red, strength / 255, newColor.blue, newColor.alpha));
        else if (channel === "b") setColor(new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(newColor.red, newColor.green, strength / 255, newColor.alpha));
    }
    function setColorHSV(channel, strength) {
        // Do nothing if the given value is undefined
        if (strength === undefined) undefined;
        else if (channel === "h") $$invalidate(3, hue = strength / 360);
        else if (channel === "s") $$invalidate(4, saturation = strength / 100);
        else if (channel === "v") $$invalidate(5, value = strength / 100);
        setColor();
    }
    function setColorAlphaPercent(strength) {
        if (strength !== undefined) $$invalidate(6, alpha = strength / 100);
        setColor();
    }
    function setColorPresetSubtile(e) {
        const clickedTile = e.target;
        const tileColor = clickedTile?.getAttribute("data-pure-tile") || undefined;
        if (tileColor) setColorPreset(tileColor);
    }
    function setColorPreset(preset) {
        if (preset === "none") {
            setNewHSVA(0, 0, 0, 1, true);
            setColor(new (0, $f7aa31b9879f1252$export$892596cec99bc70e)("none"));
            return;
        }
        const presetColor = new (0, $f7aa31b9879f1252$export$892596cec99bc70e)(...PURE_COLORS[preset], 1);
        const hsva = presetColor.toHSVA() || {
            h: 0,
            s: 0,
            v: 0,
            a: 0
        };
        setNewHSVA(hsva.h, hsva.s, hsva.v, hsva.a, false);
        setColor(presetColor);
    }
    function setNewHSVA(h, s, v, a, none) {
        $$invalidate(3, hue = h);
        $$invalidate(4, saturation = s);
        $$invalidate(5, value = v);
        $$invalidate(6, alpha = a);
        $$invalidate(7, isNone = none);
    }
    function setInitialHSVA(h, s, v, a, none) {
        $$invalidate(26, initialHue = h);
        $$invalidate(27, initialSaturation = s);
        $$invalidate(28, initialValue = v);
        $$invalidate(29, initialAlpha = a);
        $$invalidate(8, initialIsNone = none);
    }
    async function activateEyedropperSample() {
        // TODO: Replace this temporary solution that only works in Chromium-based browsers with the custom color sampler used by the Eyedropper tool
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!window.EyeDropper) {
            editor.instance.eyedropperSampleForColorPicker();
            return;
        }
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const result = await new window.EyeDropper().open();
            setColorCode(result.sRGBHex);
        } catch  {} // Do nothing
    }
    (0, $1eb80e36873dc327$export$f1238fd06ad9b453)(()=>{
        removeEvents();
    });
    const commitText_handler = ({ detail: detail })=>setColorCode(detail);
    const value_handler = (strength, each_value_1, index, channel, { detail: detail })=>{
        $$invalidate(14, each_value_1[index][1] = detail, rgbChannels);
        setColorRGB(channel, detail);
    };
    const value_handler_1 = (strength, each_value, index, channel, { detail: detail })=>{
        $$invalidate(13, each_value[index][1] = detail, hsvChannels);
        setColorHSV(channel, detail);
    };
    const value_handler_2 = ({ detail: detail })=>{
        if (detail !== undefined) $$invalidate(6, alpha = detail / 100);
        setColorAlphaPercent(detail);
    };
    const click_handler = ()=>setColorPreset("none");
    const click_handler_1 = ()=>setColorPreset("black");
    const click_handler_2 = ()=>setColorPreset("white");
    function open_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("color" in $$props) $$invalidate(25, color = $$props.color);
        if ("allowNone" in $$props) $$invalidate(0, allowNone = $$props.allowNone);
        if ("direction" in $$props) $$invalidate(1, direction = $$props.direction);
        if ("open" in $$props) $$invalidate(2, open = $$props.open);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*open*/ 4) $: watchOpen(open);
        if ($$self.$$.dirty[0] & /*color*/ 33554432) $: watchColor(color);
        if ($$self.$$.dirty[0] & /*initialHue, initialSaturation, initialValue, initialAlpha, initialIsNone*/ 1006633216) $: $$invalidate(11, initialColor = generateColor(initialHue, initialSaturation, initialValue, initialAlpha, initialIsNone));
        if ($$self.$$.dirty[0] & /*hue, saturation, value, alpha, isNone*/ 248) $: $$invalidate(9, newColor = generateColor(hue, saturation, value, alpha, isNone));
        if ($$self.$$.dirty[0] & /*newColor*/ 512) $: $$invalidate(14, rgbChannels = Object.entries(newColor.toRgb255() || {
            r: undefined,
            g: undefined,
            b: undefined
        }));
        if ($$self.$$.dirty[0] & /*isNone, hue, saturation, value*/ 184) $: $$invalidate(13, hsvChannels = Object.entries(!isNone ? {
            h: hue * 360,
            s: saturation * 100,
            v: value * 100
        } : {
            h: undefined,
            s: undefined,
            v: undefined
        }));
        if ($$self.$$.dirty[0] & /*hue*/ 8) $: $$invalidate(12, opaqueHueColor = new (0, $f7aa31b9879f1252$export$892596cec99bc70e)({
            h: hue,
            s: 1,
            v: 1,
            a: 1
        }));
    };
    return [
        allowNone,
        direction,
        open,
        hue,
        saturation,
        value,
        alpha,
        isNone,
        initialIsNone,
        newColor,
        strayCloses,
        initialColor,
        opaqueHueColor,
        hsvChannels,
        rgbChannels,
        COLOR_SPACE_CHOICES,
        onPointerDown,
        swapNewWithInitial,
        setColorCode,
        setColorRGB,
        setColorHSV,
        setColorAlphaPercent,
        setColorPresetSubtile,
        setColorPreset,
        activateEyedropperSample,
        color,
        initialHue,
        initialSaturation,
        initialValue,
        initialAlpha,
        commitText_handler,
        value_handler,
        value_handler_1,
        value_handler_2,
        click_handler,
        click_handler_1,
        click_handler_2,
        open_handler
    ];
}
class $130a5ee3db98888b$var$ColorPicker extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $130a5ee3db98888b$var$instance, $130a5ee3db98888b$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            color: 25,
            allowNone: 0,
            direction: 1,
            open: 2
        }, null, [
            -1,
            -1
        ]);
    }
}
var $130a5ee3db98888b$export$2e2bcd8739ae039 = $130a5ee3db98888b$var$ColorPicker;




function $694467b9b6acaa8a$var$create_if_block(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            class: "chip",
            bold: true,
            $$slots: {
                default: [
                    $694467b9b6acaa8a$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, chip*/ 1056) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (29:3) <TextLabel class="chip" bold={true}>
function $694467b9b6acaa8a$var$create_default_slot_1(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(/*chip*/ ctx[5]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*chip*/ 32) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, /*chip*/ ctx[5]);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (19:0) <LayoutRow class="color-input" classes={{ "sharp-right-corners": sharpRightCorners }} {tooltip}>
function $694467b9b6acaa8a$var$create_default_slot(ctx) {
    let button;
    let t;
    let colorpicker;
    let current;
    let mounted;
    let dispose;
    let if_block = /*chip*/ ctx[5] && $694467b9b6acaa8a$var$create_if_block(ctx);
    colorpicker = new (0, $130a5ee3db98888b$export$2e2bcd8739ae039)({
        props: {
            open: /*open*/ ctx[4],
            color: /*value*/ ctx[0],
            allowNone: /*allowNone*/ ctx[1]
        }
    });
    colorpicker.$on("open", /*open_handler*/ ctx[8]);
    colorpicker.$on("color", /*color_handler*/ ctx[9]);
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            if (if_block) if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(colorpicker.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-floating-menu-spawner", "");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "none", /*value*/ ctx[0].none);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*sharpRightCorners*/ ctx[3]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--chosen-color", /*value*/ ctx[0].toHexOptionalAlpha());
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            if (if_block) if_block.m(button, null);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(colorpicker, target, anchor);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", /*click_handler*/ ctx[7]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (/*chip*/ ctx[5]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*chip*/ 32) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $694467b9b6acaa8a$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(button, null);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (!current || dirty & /*value*/ 1) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "none", /*value*/ ctx[0].none);
            if (!current || dirty & /*sharpRightCorners*/ 8) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*sharpRightCorners*/ ctx[3]);
            if (dirty & /*value*/ 1) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--chosen-color", /*value*/ ctx[0].toHexOptionalAlpha());
            const colorpicker_changes = {};
            if (dirty & /*open*/ 16) colorpicker_changes.open = /*open*/ ctx[4];
            if (dirty & /*value*/ 1) colorpicker_changes.color = /*value*/ ctx[0];
            if (dirty & /*allowNone*/ 2) colorpicker_changes.allowNone = /*allowNone*/ ctx[1];
            colorpicker.$set(colorpicker_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(colorpicker.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(colorpicker.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            if (if_block) if_block.d();
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(colorpicker, detaching);
            mounted = false;
            dispose();
        }
    };
}
function $694467b9b6acaa8a$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "color-input",
            classes: {
                "sharp-right-corners": /*sharpRightCorners*/ ctx[3]
            },
            tooltip: /*tooltip*/ ctx[2],
            $$slots: {
                default: [
                    $694467b9b6acaa8a$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*sharpRightCorners*/ 8) layoutrow_changes.classes = {
                "sharp-right-corners": /*sharpRightCorners*/ ctx[3]
            };
            if (dirty & /*tooltip*/ 4) layoutrow_changes.tooltip = /*tooltip*/ ctx[2];
            if (dirty & /*$$scope, open, value, allowNone, sharpRightCorners, chip*/ 1083) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $694467b9b6acaa8a$var$instance($$self, $$props, $$invalidate) {
    let chip;
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let open = false;
    let { value: value } = $$props;
    let { allowNone: allowNone = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    const click_handler = ()=>$$invalidate(4, open = true);
    const open_handler = ({ detail: detail })=>$$invalidate(4, open = detail);
    const color_handler = ({ detail: detail })=>{
        $$invalidate(0, value = detail);
        dispatch("value", detail);
    };
    $$self.$$set = ($$props)=>{
        if ("value" in $$props) $$invalidate(0, value = $$props.value);
        if ("allowNone" in $$props) $$invalidate(1, allowNone = $$props.allowNone);
        if ("tooltip" in $$props) $$invalidate(2, tooltip = $$props.tooltip);
        if ("sharpRightCorners" in $$props) $$invalidate(3, sharpRightCorners = $$props.sharpRightCorners);
    };
    $: $$invalidate(5, chip = undefined);
    return [
        value,
        allowNone,
        tooltip,
        sharpRightCorners,
        open,
        chip,
        dispatch,
        click_handler,
        open_handler,
        color_handler
    ];
}
class $694467b9b6acaa8a$var$ColorInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $694467b9b6acaa8a$var$instance, $694467b9b6acaa8a$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            value: 0,
            allowNone: 1,
            tooltip: 2,
            sharpRightCorners: 3
        });
    }
}
var $694467b9b6acaa8a$export$2e2bcd8739ae039 = $694467b9b6acaa8a$var$ColorInput;


/* src/components/widgets/inputs/CurveInput.svelte generated by Svelte v3.58.0 */ 



function $07a0c3d99da4c418$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[23] = list[i];
    child_ctx[25] = i;
    return child_ctx;
}
function $07a0c3d99da4c418$var$get_each_context_1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[25] = list[i];
    return child_ctx;
}
function $07a0c3d99da4c418$var$get_if_ctx(ctx) {
    const child_ctx = ctx.slice();
    const constants_0 = /*groups*/ child_ctx[5][/*selectedNodeIndex*/ child_ctx[6]];
    child_ctx[23] = constants_0;
    return child_ctx;
}
function $07a0c3d99da4c418$var$get_each_context_2(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[28] = list[i];
    child_ctx[25] = i;
    return child_ctx;
}
// (167:2) {#each { length: GRID_SIZE - 1 } as _, i}
function $07a0c3d99da4c418$var$create_each_block_2(ctx) {
    let path0;
    let path0_d_value;
    let path1;
    let path1_d_value;
    return {
        c () {
            path0 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            path1 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path0, "class", "grid");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path0, "d", path0_d_value = `M 0 ${/*i*/ (ctx[25] + 1) / $07a0c3d99da4c418$var$GRID_SIZE} L 1 ${/*i*/ (ctx[25] + 1) / $07a0c3d99da4c418$var$GRID_SIZE}`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path1, "class", "grid");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path1, "d", path1_d_value = `M ${/*i*/ (ctx[25] + 1) / $07a0c3d99da4c418$var$GRID_SIZE} 0 L ${/*i*/ (ctx[25] + 1) / $07a0c3d99da4c418$var$GRID_SIZE} 1`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, path0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, path1, anchor);
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(path0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(path1);
        }
    };
}
// (172:2) {#if selectedNodeIndex !== undefined}
function $07a0c3d99da4c418$var$create_if_block(ctx) {
    let each_1_anchor;
    let each_value_1 = [
        0,
        1
    ];
    let each_blocks = [];
    for(let i = 0; i < 2; i += 1)each_blocks[i] = $07a0c3d99da4c418$var$create_each_block_1($07a0c3d99da4c418$var$get_each_context_1(ctx, each_value_1, i));
    return {
        c () {
            for(let i = 0; i < 2; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < 2; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*groups, selectedNodeIndex, handleManipulatorPointerDown*/ 352) {
                each_value_1 = [
                    0,
                    1
                ];
                let i;
                for(i = 0; i < 2; i += 1){
                    const child_ctx = $07a0c3d99da4c418$var$get_each_context_1(ctx, each_value_1, i);
                    if (each_blocks[i]) each_blocks[i].p(child_ctx, dirty);
                    else {
                        each_blocks[i] = $07a0c3d99da4c418$var$create_each_block_1(child_ctx);
                        each_blocks[i].c();
                        each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
                    }
                }
                for(; i < 2; i += 1)each_blocks[i].d(1);
            }
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (174:3) {#each [0, 1] as i}
function $07a0c3d99da4c418$var$create_each_block_1(ctx) {
    let path;
    let path_d_value;
    let circle;
    let circle_cx_value;
    let circle_cy_value;
    let mounted;
    let dispose;
    function pointerdown_handler(...args) {
        return /*pointerdown_handler*/ ctx[13](/*i*/ ctx[25], ...args);
    }
    return {
        c () {
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            circle = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("circle");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", path_d_value = `M ${ctx[23].anchor[0]} ${1 - /*group*/ ctx[23].anchor[1]} L ${ctx[23].handles[/*i*/ ctx[25]][0]} ${1 - /*group*/ ctx[23].handles[/*i*/ ctx[25]][1]}`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "class", "handle-line");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cx", circle_cx_value = /*group*/ ctx[23].handles[/*i*/ ctx[25]][0]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cy", circle_cy_value = 1 - /*group*/ ctx[23].handles[/*i*/ ctx[25]][1]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "class", "manipulator handle");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "r", "0.02");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, path, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, circle, anchor);
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(circle, "pointerdown", pointerdown_handler);
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*groups, selectedNodeIndex*/ 96 && path_d_value !== (path_d_value = `M ${ctx[23].anchor[0]} ${1 - /*group*/ ctx[23].anchor[1]} L ${ctx[23].handles[/*i*/ ctx[25]][0]} ${1 - /*group*/ ctx[23].handles[/*i*/ ctx[25]][1]}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", path_d_value);
            if (dirty & /*groups, selectedNodeIndex*/ 96 && circle_cx_value !== (circle_cx_value = /*group*/ ctx[23].handles[/*i*/ ctx[25]][0])) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cx", circle_cx_value);
            if (dirty & /*groups, selectedNodeIndex*/ 96 && circle_cy_value !== (circle_cy_value = 1 - /*group*/ ctx[23].handles[/*i*/ ctx[25]][1])) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cy", circle_cy_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(path);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(circle);
            mounted = false;
            dispose();
        }
    };
}
// (179:2) {#each groups as group, i}
function $07a0c3d99da4c418$var$create_each_block(ctx) {
    let circle;
    let circle_cx_value;
    let circle_cy_value;
    let mounted;
    let dispose;
    function pointerdown_handler_1(...args) {
        return /*pointerdown_handler_1*/ ctx[14](/*i*/ ctx[25], ...args);
    }
    return {
        c () {
            circle = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("circle");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cx", circle_cx_value = /*group*/ ctx[23].anchor[0]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cy", circle_cy_value = 1 - /*group*/ ctx[23].anchor[1]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "class", "manipulator");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "r", "0.02");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, circle, anchor);
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(circle, "pointerdown", pointerdown_handler_1);
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*groups*/ 32 && circle_cx_value !== (circle_cx_value = /*group*/ ctx[23].anchor[0])) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cx", circle_cx_value);
            if (dirty & /*groups*/ 32 && circle_cy_value !== (circle_cy_value = 1 - /*group*/ ctx[23].anchor[1])) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(circle, "cy", circle_cy_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(circle);
            mounted = false;
            dispose();
        }
    };
}
// (165:0) <LayoutRow class={"curve-input"} classes={{ disabled, ...classes }} style={styleName} {styles} {tooltip}>
function $07a0c3d99da4c418$var$create_default_slot(ctx) {
    let svg;
    let path;
    let if_block_anchor;
    let t;
    let current;
    let mounted;
    let dispose;
    let each_value_2 = {
        length: $07a0c3d99da4c418$var$GRID_SIZE - 1
    };
    let each_blocks_1 = [];
    for(let i = 0; i < each_value_2.length; i += 1)each_blocks_1[i] = $07a0c3d99da4c418$var$create_each_block_2($07a0c3d99da4c418$var$get_each_context_2(ctx, each_value_2, i));
    let if_block = /*selectedNodeIndex*/ ctx[6] !== undefined && $07a0c3d99da4c418$var$create_if_block($07a0c3d99da4c418$var$get_if_ctx(ctx));
    let each_value = /*groups*/ ctx[5];
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $07a0c3d99da4c418$var$create_each_block($07a0c3d99da4c418$var$get_each_context(ctx, each_value, i));
    const default_slot_template = /*#slots*/ ctx[12].default;
    const default_slot = (0, $1eb80e36873dc327$export$2d30ef90c9114b44)(default_slot_template, ctx, /*$$scope*/ ctx[15], null);
    return {
        c () {
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            for(let i = 0; i < each_blocks_1.length; i += 1)each_blocks_1[i].c();
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (default_slot) default_slot.c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "class", "curve");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", /*dAttribute*/ ctx[7]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "viewBox", "0 0 1 1");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, svg, anchor);
            for(let i = 0; i < each_blocks_1.length; i += 1)if (each_blocks_1[i]) each_blocks_1[i].m(svg, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, path);
            if (if_block) if_block.m(svg, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, if_block_anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(svg, null);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            if (default_slot) default_slot.m(target, anchor);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(svg, "pointermove", /*handlePointerMove*/ ctx[10]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(svg, "pointerup", /*handlePointerUp*/ ctx[9])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (!current || dirty & /*dAttribute*/ 128) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", /*dAttribute*/ ctx[7]);
            if (/*selectedNodeIndex*/ ctx[6] !== undefined) {
                if (if_block) if_block.p($07a0c3d99da4c418$var$get_if_ctx(ctx), dirty);
                else {
                    if_block = $07a0c3d99da4c418$var$create_if_block($07a0c3d99da4c418$var$get_if_ctx(ctx));
                    if_block.c();
                    if_block.m(svg, if_block_anchor);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            if (dirty & /*groups, handleManipulatorPointerDown*/ 288) {
                each_value = /*groups*/ ctx[5];
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $07a0c3d99da4c418$var$get_each_context(ctx, each_value, i);
                    if (each_blocks[i]) each_blocks[i].p(child_ctx, dirty);
                    else {
                        each_blocks[i] = $07a0c3d99da4c418$var$create_each_block(child_ctx);
                        each_blocks[i].c();
                        each_blocks[i].m(svg, null);
                    }
                }
                for(; i < each_blocks.length; i += 1)each_blocks[i].d(1);
                each_blocks.length = each_value.length;
            }
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 32768)) (0, $1eb80e36873dc327$export$320f2dc7816567d9)(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[15], !current ? (0, $1eb80e36873dc327$export$a15c6a804dce25b7)(/*$$scope*/ ctx[15]) : (0, $1eb80e36873dc327$export$37743db7f61eb37b)(default_slot_template, /*$$scope*/ ctx[15], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(default_slot, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(svg);
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks_1, detaching);
            if (if_block) if_block.d();
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (default_slot) default_slot.d(detaching);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
function $07a0c3d99da4c418$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "curve-input",
            classes: {
                disabled: /*disabled*/ ctx[3],
                .../*classes*/ ctx[0]
            },
            style: /*styleName*/ ctx[1],
            styles: /*styles*/ ctx[2],
            tooltip: /*tooltip*/ ctx[4],
            $$slots: {
                default: [
                    $07a0c3d99da4c418$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*disabled, classes*/ 9) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[3],
                .../*classes*/ ctx[0]
            };
            if (dirty & /*styleName*/ 2) layoutrow_changes.style = /*styleName*/ ctx[1];
            if (dirty & /*styles*/ 4) layoutrow_changes.styles = /*styles*/ ctx[2];
            if (dirty & /*tooltip*/ 16) layoutrow_changes.tooltip = /*tooltip*/ ctx[4];
            if (dirty & /*$$scope, groups, selectedNodeIndex, dAttribute*/ 32992) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
const $07a0c3d99da4c418$var$GRID_SIZE = 4;
function $07a0c3d99da4c418$var$instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { classes: classes = {} } = $$props;
    let { style: styleName = "" } = $$props;
    let { styles: styles = {} } = $$props;
    let { value: value } = $$props;
    let { disabled: disabled = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let groups = [
        {
            anchor: [
                0,
                0
            ],
            handles: [
                [
                    -1,
                    -1
                ],
                [
                    0.25,
                    0.25
                ]
            ]
        },
        {
            anchor: [
                0.5,
                0.5
            ],
            handles: [
                [
                    0.25,
                    0.25
                ],
                [
                    0.75,
                    0.75
                ]
            ]
        },
        {
            anchor: [
                1,
                1
            ],
            handles: [
                [
                    0.75,
                    0.75
                ],
                [
                    2,
                    2
                ]
            ]
        }
    ];
    let selectedNodeIndex = undefined;
    let draggedNodeIndex = undefined;
    let dAttribute = recalculateSvgPath();
    function updateCurve() {
        dispatch("value", {
            manipulatorGroups: groups.slice(1, groups.length - 1),
            firstHandle: groups[0].handles[1],
            lastHandle: groups[groups.length - 1].handles[0]
        });
    }
    function recalculateSvgPath() {
        let dAttribute = "";
        let anchor = groups[0].anchor;
        let handle = groups[0].handles[1];
        groups.slice(1).forEach((group)=>{
            dAttribute += `M${anchor[0]} ${1 - anchor[1]} C${handle[0]} ${1 - handle[1]}, ${group.handles[0][0]} ${1 - group.handles[0][1]}, ${group.anchor[0]} ${1 - group.anchor[1]} `;
            anchor = group.anchor;
            handle = group.handles[1];
        });
        return dAttribute;
    }
    function handleManipulatorPointerDown(e, i) {
        // Delete an anchor with RMB or MMB
        if (e.button > 0 && i > 0 && i < groups.length - 1) {
            draggedNodeIndex = undefined;
            $$invalidate(6, selectedNodeIndex = undefined);
            groups.splice(i, 1);
            $$invalidate(5, groups), $$invalidate(11, value);
            $$invalidate(7, dAttribute = recalculateSvgPath());
            updateCurve();
            return;
        }
        draggedNodeIndex = i;
        if (i >= 0) $$invalidate(6, selectedNodeIndex = i);
    }
    function getSvgPositionFromPointerEvent(e) {
        if (!(e.target instanceof SVGElement)) return undefined;
        const target = e.target?.closest("svg") || undefined;
        if (!target) return undefined;
        const rect = target.getBoundingClientRect();
        const x = (e.x - rect.x) / rect.width;
        const y = 1 - (e.y - rect.y) / rect.height;
        return [
            (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(x),
            (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(y)
        ];
    }
    function clampHandles() {
        for(let i = 0; i < groups.length - 1; i++){
            const [min, max] = [
                groups[i].anchor[0],
                groups[i + 1].anchor[0]
            ];
            for(let j = 0; j < 2; j++){
                $$invalidate(5, groups[i + j].handles[1 - j][0] = (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(groups[i + j].handles[1 - j][0], min, max), groups);
                $$invalidate(5, groups[i + j].handles[1 - j][1] = (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(groups[i + j].handles[1 - j][1]), groups);
            }
        }
    }
    function handlePointerUp(e) {
        if (draggedNodeIndex !== undefined) {
            draggedNodeIndex = undefined;
            return;
        }
        if (e.button !== 0) return;
        const anchor = getSvgPositionFromPointerEvent(e);
        if (!anchor) return;
        let nodeIndex = groups.findIndex((group)=>group.anchor[0] > anchor[0]);
        if (nodeIndex === -1) nodeIndex = groups.length;
        groups.splice(nodeIndex, 0, {
            anchor: anchor,
            handles: [
                [
                    anchor[0] - 0.05,
                    anchor[1]
                ],
                [
                    anchor[0] + 0.05,
                    anchor[1]
                ]
            ]
        });
        $$invalidate(6, selectedNodeIndex = nodeIndex);
        clampHandles();
        $$invalidate(7, dAttribute = recalculateSvgPath());
        updateCurve();
    }
    function setHandlePosition(anchorIndex, handleIndex, position) {
        const { anchor: anchor, handles: handles } = groups[anchorIndex];
        const otherHandle = handles[1 - handleIndex];
        const handleVector = [
            anchor[0] - position[0],
            anchor[1] - position[1]
        ];
        const handleVectorLength = Math.hypot(...handleVector);
        const handleVectorNormalized = [
            handleVector[0] / handleVectorLength,
            handleVector[1] / handleVectorLength
        ];
        const otherHandleVectorLength = Math.hypot(anchor[0] - otherHandle[0], anchor[1] - otherHandle[1]);
        handles[handleIndex] = position;
        handles[1 - handleIndex] = [
            anchor[0] + handleVectorNormalized[0] * otherHandleVectorLength,
            anchor[1] + handleVectorNormalized[1] * otherHandleVectorLength
        ];
    }
    function handlePointerMove(e) {
        if (draggedNodeIndex === undefined || draggedNodeIndex === 0 || draggedNodeIndex === groups.length - 1) return;
        const position = getSvgPositionFromPointerEvent(e);
        if (!position) return;
        if (draggedNodeIndex > 0) {
            position[0] = (0, $0772c00bcca44bc9$export$7d15b64cf5a3a4c4)(position[0], groups[draggedNodeIndex - 1].anchor[0], groups[draggedNodeIndex + 1].anchor[0]);
            const group = groups[draggedNodeIndex];
            group.handles = [
                [
                    group.handles[0][0] + position[0] - group.anchor[0],
                    group.handles[0][1] + position[1] - group.anchor[1]
                ],
                [
                    group.handles[1][0] + position[0] - group.anchor[0],
                    group.handles[1][1] + position[1] - group.anchor[1]
                ]
            ];
            group.anchor = position;
        } else {
            if (selectedNodeIndex === undefined) return;
            setHandlePosition(selectedNodeIndex, -draggedNodeIndex - 1, position);
            const group = groups[selectedNodeIndex];
            if (group.handles[0][0] > group.anchor[0]) {
                group.handles = [
                    group.handles[1],
                    group.handles[0]
                ];
                draggedNodeIndex = -3 - draggedNodeIndex;
            }
        }
        clampHandles();
        $$invalidate(7, dAttribute = recalculateSvgPath());
        updateCurve();
    }
    const pointerdown_handler = (i, e)=>handleManipulatorPointerDown(e, -i - 1);
    const pointerdown_handler_1 = (i, e)=>handleManipulatorPointerDown(e, i);
    $$self.$$set = ($$props)=>{
        if ("classes" in $$props) $$invalidate(0, classes = $$props.classes);
        if ("style" in $$props) $$invalidate(1, styleName = $$props.style);
        if ("styles" in $$props) $$invalidate(2, styles = $$props.styles);
        if ("value" in $$props) $$invalidate(11, value = $$props.value);
        if ("disabled" in $$props) $$invalidate(3, disabled = $$props.disabled);
        if ("tooltip" in $$props) $$invalidate(4, tooltip = $$props.tooltip);
        if ("$$scope" in $$props) $$invalidate(15, $$scope = $$props.$$scope);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*groups, value*/ 2080) $: {
            $$invalidate(5, groups = [
                groups[0]
            ].concat(value.manipulatorGroups).concat([
                groups[groups.length - 1]
            ]));
            $$invalidate(5, groups[0].handles[1] = value.firstHandle, groups);
            $$invalidate(5, groups[groups.length - 1].handles[0] = value.lastHandle, groups);
            $$invalidate(7, dAttribute = recalculateSvgPath());
        }
    };
    return [
        classes,
        styleName,
        styles,
        disabled,
        tooltip,
        groups,
        selectedNodeIndex,
        dAttribute,
        handleManipulatorPointerDown,
        handlePointerUp,
        handlePointerMove,
        value,
        slots,
        pointerdown_handler,
        pointerdown_handler_1,
        $$scope
    ];
}
class $07a0c3d99da4c418$var$CurveInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $07a0c3d99da4c418$var$instance, $07a0c3d99da4c418$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            classes: 0,
            style: 1,
            styles: 2,
            value: 11,
            disabled: 3,
            tooltip: 4
        });
    }
}
var $07a0c3d99da4c418$export$2e2bcd8739ae039 = $07a0c3d99da4c418$var$CurveInput;



/* src/components/widgets/inputs/FontInput.svelte generated by Svelte v3.58.0 */ 





function $e331a3068b7f502d$var$create_default_slot_2(ctx) {
    let t_value = /*activeEntry*/ (ctx[7]?.value || "") + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*activeEntry*/ 128 && t_value !== (t_value = /*activeEntry*/ (ctx[7]?.value || "") + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (80:1) <LayoutRow   class="dropdown-box"   classes={{ disabled, "sharp-right-corners": sharpRightCorners }}   styles={{ "min-width": `${minWidth}px` }}   {tooltip}   tabindex={disabled ? -1 : 0}   on:click={toggleOpen}   on:keydown={(e) => menuList?.keydown(e, false)}   data-floating-menu-spawner  >
function $e331a3068b7f502d$var$create_default_slot_1(ctx) {
    let textlabel;
    let t;
    let iconlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            class: "dropdown-label",
            $$slots: {
                default: [
                    $e331a3068b7f502d$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            class: "dropdown-arrow",
            icon: "DropdownArrow"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, activeEntry*/ 16777344) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (79:0) <LayoutRow class="font-input">
function $e331a3068b7f502d$var$create_default_slot(ctx) {
    let layoutrow;
    let t;
    let menulist;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "dropdown-box",
            classes: {
                disabled: /*disabled*/ ctx[1],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[3]
            },
            styles: {
                "min-width": `${ctx[8]}px`
            },
            tooltip: /*tooltip*/ ctx[2],
            tabindex: /*disabled*/ ctx[1] ? -1 : 0,
            "data-floating-menu-spawner": true,
            $$slots: {
                default: [
                    $e331a3068b7f502d$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow.$on("click", /*toggleOpen*/ ctx[9]);
    layoutrow.$on("keydown", /*keydown_handler*/ ctx[12]);
    let menulist_props = {
        activeEntry: /*activeEntry*/ ctx[7],
        open: /*open*/ ctx[5],
        entries: [
            /*entries*/ ctx[6]
        ],
        minWidth: /*isStyle*/ ctx[0] ? 0 : /*minWidth*/ ctx[8],
        virtualScrollingEntryHeight: /*isStyle*/ ctx[0] ? 0 : 20,
        scrollableY: true
    };
    menulist = new (0, $c04ba9d0f104d9a2$export$2e2bcd8739ae039)({
        props: menulist_props
    });
    /*menulist_binding*/ ctx[13](menulist);
    menulist.$on("naturalWidth", /*naturalWidth_handler*/ ctx[14]);
    menulist.$on("activeEntry", /*activeEntry_handler*/ ctx[15]);
    menulist.$on("open", /*open_handler*/ ctx[16]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(menulist.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(menulist, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*disabled, sharpRightCorners*/ 10) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[1],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[3]
            };
            if (dirty & /*minWidth*/ 256) layoutrow_changes.styles = {
                "min-width": `${ctx[8]}px`
            };
            if (dirty & /*tooltip*/ 4) layoutrow_changes.tooltip = /*tooltip*/ ctx[2];
            if (dirty & /*disabled*/ 2) layoutrow_changes.tabindex = /*disabled*/ ctx[1] ? -1 : 0;
            if (dirty & /*$$scope, activeEntry*/ 16777344) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
            const menulist_changes = {};
            if (dirty & /*activeEntry*/ 128) menulist_changes.activeEntry = /*activeEntry*/ ctx[7];
            if (dirty & /*open*/ 32) menulist_changes.open = /*open*/ ctx[5];
            if (dirty & /*entries*/ 64) menulist_changes.entries = [
                /*entries*/ ctx[6]
            ];
            if (dirty & /*isStyle, minWidth*/ 257) menulist_changes.minWidth = /*isStyle*/ ctx[0] ? 0 : /*minWidth*/ ctx[8];
            if (dirty & /*isStyle*/ 1) menulist_changes.virtualScrollingEntryHeight = /*isStyle*/ ctx[0] ? 0 : 20;
            menulist.$set(menulist_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(menulist.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(menulist.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            /*menulist_binding*/ ctx[13](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(menulist, detaching);
        }
    };
}
function $e331a3068b7f502d$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "font-input",
            $$slots: {
                default: [
                    $e331a3068b7f502d$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, activeEntry, open, entries, isStyle, minWidth, menuList, disabled, sharpRightCorners, tooltip*/ 16777727) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $e331a3068b7f502d$var$instance($$self, $$props, $$invalidate) {
    const fonts = (0, $1eb80e36873dc327$export$31553aaa555c1514)("fonts");
    // emits: ["update:fontFamily", "update:fontStyle", "changeFont"],
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let menuList;
    let { fontFamily: fontFamily } = $$props;
    let { fontStyle: fontStyle } = $$props;
    let { isStyle: isStyle = false } = $$props;
    let { disabled: disabled = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let open = false;
    let entries = [];
    let activeEntry = undefined;
    let minWidth = isStyle ? 0 : 300;
    async function watchFont(..._) {
        // We set this function's result to a local variable to avoid reading from `entries` which causes Svelte to trigger an update that results in an infinite loop
        const newEntries = await getEntries();
        $$invalidate(6, entries = newEntries);
        $$invalidate(7, activeEntry = getActiveEntry(newEntries));
    }
    async function setOpen() {
        $$invalidate(5, open = true);
        // Scroll to the active entry (the scroller div does not yet exist so we must wait for the component to render)
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        if (activeEntry) {
            const index = entries.indexOf(activeEntry);
            menuList?.scrollViewTo(Math.max(0, index * 20 - 190));
        }
    }
    function toggleOpen() {
        if (!disabled) {
            $$invalidate(5, open = !open);
            if (open) setOpen();
        }
    }
    async function selectFont(newName) {
        let family;
        let style;
        if (isStyle) {
            dispatch("fontStyle", newName);
            family = fontFamily;
            style = newName;
        } else {
            dispatch("fontFamily", newName);
            family = newName;
            style = "Normal (400)";
        }
        const fontFileUrl = await fonts.getFontFileUrl(family, style);
        dispatch("changeFont", {
            fontFamily: family,
            fontStyle: style,
            fontFileUrl: fontFileUrl
        });
    }
    async function getEntries() {
        const x = isStyle ? fonts.getFontStyles(fontFamily) : fonts.fontNames();
        return (await x).map((entry)=>({
                label: entry.name,
                value: entry.name,
                font: entry.url,
                action: ()=>selectFont(entry.name)
            }));
    }
    function getActiveEntry(entries) {
        const selectedChoice = isStyle ? fontStyle : fontFamily;
        return entries.find((entry)=>entry.value === selectedChoice);
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(async ()=>{
        $$invalidate(6, entries = await getEntries());
        $$invalidate(7, activeEntry = getActiveEntry(entries));
    });
    const keydown_handler = (e)=>menuList?.keydown(e, false);
    function menulist_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            menuList = $$value;
            $$invalidate(4, menuList);
        });
    }
    const naturalWidth_handler = ({ detail: detail })=>isStyle && $$invalidate(8, minWidth = detail);
    const activeEntry_handler = ({ detail: detail })=>$$invalidate(7, activeEntry = detail);
    const open_handler = ({ detail: detail })=>$$invalidate(5, open = detail);
    $$self.$$set = ($$props)=>{
        if ("fontFamily" in $$props) $$invalidate(10, fontFamily = $$props.fontFamily);
        if ("fontStyle" in $$props) $$invalidate(11, fontStyle = $$props.fontStyle);
        if ("isStyle" in $$props) $$invalidate(0, isStyle = $$props.isStyle);
        if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
        if ("tooltip" in $$props) $$invalidate(2, tooltip = $$props.tooltip);
        if ("sharpRightCorners" in $$props) $$invalidate(3, sharpRightCorners = $$props.sharpRightCorners);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*fontFamily, fontStyle*/ 3072) $: watchFont(fontFamily, fontStyle);
    };
    return [
        isStyle,
        disabled,
        tooltip,
        sharpRightCorners,
        menuList,
        open,
        entries,
        activeEntry,
        minWidth,
        toggleOpen,
        fontFamily,
        fontStyle,
        keydown_handler,
        menulist_binding,
        naturalWidth_handler,
        activeEntry_handler,
        open_handler
    ];
}
class $e331a3068b7f502d$var$FontInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $e331a3068b7f502d$var$instance, $e331a3068b7f502d$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            fontFamily: 10,
            fontStyle: 11,
            isStyle: 0,
            disabled: 1,
            tooltip: 2,
            sharpRightCorners: 3
        });
    }
}
var $e331a3068b7f502d$export$2e2bcd8739ae039 = $e331a3068b7f502d$var$FontInput;


/* src/components/widgets/inputs/LayerReferenceInput.svelte generated by Svelte v3.58.0 */ 






function $515682188911046d$var$create_else_block(ctx) {
    let current_block_type_index;
    let if_block;
    let t;
    let iconbutton;
    let current;
    const if_block_creators = [
        $515682188911046d$var$create_if_block_1,
        $515682188911046d$var$create_else_block_1
    ];
    const if_blocks = [];
    function select_block_type_1(ctx, dirty) {
        if (/*layerName*/ ctx[1] !== undefined && /*layerType*/ ctx[2]) return 0;
        return 1;
    }
    current_block_type_index = select_block_type_1(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    iconbutton = new (0, $47cbcd4715b3f848$export$2e2bcd8739ae039)({
        props: {
            icon: "CloseX",
            size: 16,
            disabled: /*disabled*/ ctx[3],
            action: /*func*/ ctx[11]
        }
    });
    return {
        c () {
            if_block.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconbutton.$$.fragment);
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconbutton, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type_1(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(t.parentNode, t);
            }
            const iconbutton_changes = {};
            if (dirty & /*disabled*/ 8) iconbutton_changes.disabled = /*disabled*/ ctx[3];
            iconbutton.$set(iconbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconbutton, detaching);
        }
    };
}
// (40:1) {#if value === undefined || droppable}
function $515682188911046d$var$create_if_block(ctx) {
    let layoutrow;
    let t;
    let textlabel;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "drop-zone"
        }
    });
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            italic: true,
            $$slots: {
                default: [
                    $515682188911046d$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, droppable*/ 32896) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (47:2) {:else}
function $515682188911046d$var$create_else_block_1(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            bold: true,
            italic: true,
            class: "missing",
            $$slots: {
                default: [
                    $515682188911046d$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope*/ 32768) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (44:2) {#if layerName !== undefined && layerType}
function $515682188911046d$var$create_if_block_1(ctx) {
    let iconlabel;
    let t;
    let textlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*layerType*/ ctx[2],
            class: "layer-icon"
        }
    });
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            italic: /*layerName*/ ctx[1] === "",
            class: "layer-name",
            $$slots: {
                default: [
                    $515682188911046d$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*layerType*/ 4) iconlabel_changes.icon = /*layerType*/ ctx[2];
            iconlabel.$set(iconlabel_changes);
            const textlabel_changes = {};
            if (dirty & /*layerName*/ 2) textlabel_changes.italic = /*layerName*/ ctx[1] === "";
            if (dirty & /*$$scope, layerName, layerType*/ 32774) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (48:3) <TextLabel bold={true} italic={true} class="missing">
function $515682188911046d$var$create_default_slot_3(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Layer Missing");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (46:3) <TextLabel italic={layerName === ""} class="layer-name">
function $515682188911046d$var$create_default_slot_2(ctx) {
    let t_value = /*layerName*/ (ctx[1] || `Untitled ${ctx[2] || "[Unknown Layer Type]"}`) + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*layerName, layerType*/ 6 && t_value !== (t_value = /*layerName*/ (ctx[1] || `Untitled ${ctx[2] || "[Unknown Layer Type]"}`) + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (42:2) <TextLabel italic={true}>
function $515682188911046d$var$create_default_slot_1(ctx) {
    let t0_value = /*droppable*/ (ctx[7] ? "Drop" : "Drag") + "";
    let t0;
    let t1;
    return {
        c () {
            t0 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t0_value);
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" Layer Here");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*droppable*/ 128 && t0_value !== (t0_value = /*droppable*/ (ctx[7] ? "Drop" : "Drag") + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t0, t0_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
        }
    };
}
// (32:0) <LayoutRow  class="layer-reference-input"  classes={{ disabled, droppable, "sharp-right-corners": sharpRightCorners }}  {tooltip}  on:dragover={(e) => !disabled && dragOver(e)}  on:dragleave={() => !disabled && (hoveringDrop = false)}  on:drop={(e) => !disabled && drop(e)} >
function $515682188911046d$var$create_default_slot(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $515682188911046d$var$create_if_block,
        $515682188911046d$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*value*/ ctx[0] === undefined || /*droppable*/ ctx[7]) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
function $515682188911046d$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "layer-reference-input",
            classes: {
                disabled: /*disabled*/ ctx[3],
                droppable: /*droppable*/ ctx[7],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[5]
            },
            tooltip: /*tooltip*/ ctx[4],
            $$slots: {
                default: [
                    $515682188911046d$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow.$on("dragover", /*dragover_handler*/ ctx[12]);
    layoutrow.$on("dragleave", /*dragleave_handler*/ ctx[13]);
    layoutrow.$on("drop", /*drop_handler*/ ctx[14]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*disabled, droppable, sharpRightCorners*/ 168) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[3],
                droppable: /*droppable*/ ctx[7],
                "sharp-right-corners": /*sharpRightCorners*/ ctx[5]
            };
            if (dirty & /*tooltip*/ 16) layoutrow_changes.tooltip = /*tooltip*/ ctx[4];
            if (dirty & /*$$scope, droppable, value, disabled, layerName, layerType*/ 32911) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $515682188911046d$var$instance($$self, $$props, $$invalidate) {
    let droppable;
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { value: value } = $$props;
    let { layerName: layerName } = $$props;
    let { layerType: layerType } = $$props;
    let { disabled: disabled = false } = $$props;
    let { tooltip: tooltip } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    let hoveringDrop = false;
    function dragOver(e) {
        $$invalidate(6, hoveringDrop = true);
        e.preventDefault();
    }
    function drop(e) {
        $$invalidate(6, hoveringDrop = false);
        const element = (0, $b6b56b6b4021e3fb$export$aa4e4c5c63297384)();
        const layerPath = element?.getAttribute("data-layer") || undefined;
        if (layerPath) {
            e.preventDefault();
            dispatch("value", layerPath);
        }
    }
    const func = ()=>dispatch("value", undefined);
    const dragover_handler = (e)=>!disabled && dragOver(e);
    const dragleave_handler = ()=>!disabled && $$invalidate(6, hoveringDrop = false);
    const drop_handler = (e)=>!disabled && drop(e);
    $$self.$$set = ($$props)=>{
        if ("value" in $$props) $$invalidate(0, value = $$props.value);
        if ("layerName" in $$props) $$invalidate(1, layerName = $$props.layerName);
        if ("layerType" in $$props) $$invalidate(2, layerType = $$props.layerType);
        if ("disabled" in $$props) $$invalidate(3, disabled = $$props.disabled);
        if ("tooltip" in $$props) $$invalidate(4, tooltip = $$props.tooltip);
        if ("sharpRightCorners" in $$props) $$invalidate(5, sharpRightCorners = $$props.sharpRightCorners);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*hoveringDrop*/ 64) $: $$invalidate(7, droppable = hoveringDrop && Boolean((0, $b6b56b6b4021e3fb$export$aa4e4c5c63297384)()));
    };
    return [
        value,
        layerName,
        layerType,
        disabled,
        tooltip,
        sharpRightCorners,
        hoveringDrop,
        droppable,
        dispatch,
        dragOver,
        drop,
        func,
        dragover_handler,
        dragleave_handler,
        drop_handler
    ];
}
class $515682188911046d$var$LayerReferenceInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $515682188911046d$var$instance, $515682188911046d$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            value: 0,
            layerName: 1,
            layerType: 2,
            disabled: 3,
            tooltip: 4,
            sharpRightCorners: 5
        });
    }
}
var $515682188911046d$export$2e2bcd8739ae039 = $515682188911046d$var$LayerReferenceInput;



/* src/components/widgets/inputs/OptionalInput.svelte generated by Svelte v3.58.0 */ 


function $5559ef6e76d6699f$var$create_default_slot(ctx) {
    let checkboxinput;
    let current;
    checkboxinput = new (0, $2ea65ba9293d21a6$export$2e2bcd8739ae039)({
        props: {
            checked: /*checked*/ ctx[0],
            disabled: /*disabled*/ ctx[1],
            icon: /*icon*/ ctx[2],
            tooltip: /*tooltip*/ ctx[3]
        }
    });
    checkboxinput.$on("checked", /*checked_handler*/ ctx[4]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(checkboxinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(checkboxinput, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const checkboxinput_changes = {};
            if (dirty & /*checked*/ 1) checkboxinput_changes.checked = /*checked*/ ctx[0];
            if (dirty & /*disabled*/ 2) checkboxinput_changes.disabled = /*disabled*/ ctx[1];
            if (dirty & /*icon*/ 4) checkboxinput_changes.icon = /*icon*/ ctx[2];
            if (dirty & /*tooltip*/ 8) checkboxinput_changes.tooltip = /*tooltip*/ ctx[3];
            checkboxinput.$set(checkboxinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(checkboxinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(checkboxinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(checkboxinput, detaching);
        }
    };
}
function $5559ef6e76d6699f$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "optional-input",
            classes: {
                disabled: /*disabled*/ ctx[1]
            },
            $$slots: {
                default: [
                    $5559ef6e76d6699f$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*disabled*/ 2) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[1]
            };
            if (dirty & /*$$scope, checked, disabled, icon, tooltip*/ 47) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $5559ef6e76d6699f$var$instance($$self, $$props, $$invalidate) {
    let { checked: checked } = $$props;
    let { disabled: disabled = false } = $$props;
    let { icon: icon = "Checkmark" } = $$props;
    let { tooltip: tooltip } = $$props;
    function checked_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("checked" in $$props) $$invalidate(0, checked = $$props.checked);
        if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
        if ("icon" in $$props) $$invalidate(2, icon = $$props.icon);
        if ("tooltip" in $$props) $$invalidate(3, tooltip = $$props.tooltip);
    };
    return [
        checked,
        disabled,
        icon,
        tooltip,
        checked_handler
    ];
}
class $5559ef6e76d6699f$var$OptionalInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $5559ef6e76d6699f$var$instance, $5559ef6e76d6699f$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            checked: 0,
            disabled: 1,
            icon: 2,
            tooltip: 3
        });
    }
}
var $5559ef6e76d6699f$export$2e2bcd8739ae039 = $5559ef6e76d6699f$var$OptionalInput;


/* src/components/widgets/inputs/RadioInput.svelte generated by Svelte v3.58.0 */ 




function $7c1716396f035b0a$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[7] = list[i];
    child_ctx[9] = i;
    return child_ctx;
}
// (30:3) {#if entry.icon}
function $7c1716396f035b0a$var$create_if_block_1(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*entry*/ ctx[7].icon
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*entries*/ 1) iconlabel_changes.icon = /*entry*/ ctx[7].icon;
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (33:3) {#if entry.label}
function $7c1716396f035b0a$var$create_if_block(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $7c1716396f035b0a$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, entries*/ 1025) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (34:4) <TextLabel>
function $7c1716396f035b0a$var$create_default_slot_1(ctx) {
    let t_value = /*entry*/ ctx[7].label + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*entries*/ 1 && t_value !== (t_value = /*entry*/ ctx[7].label + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (19:1) {#each entries as entry, index (index)}
function $7c1716396f035b0a$var$create_each_block(key_1, ctx) {
    let button;
    let t0;
    let t1;
    let button_title_value;
    let button_tabindex_value;
    let current;
    let mounted;
    let dispose;
    let if_block0 = /*entry*/ ctx[7].icon && $7c1716396f035b0a$var$create_if_block_1(ctx);
    let if_block1 = /*entry*/ ctx[7].label && $7c1716396f035b0a$var$create_if_block(ctx);
    function click_handler() {
        return /*click_handler*/ ctx[5](/*entry*/ ctx[7]);
    }
    return {
        key: key_1,
        first: null,
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            if (if_block0) if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "title", button_title_value = /*entry*/ ctx[7].tooltip);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", button_tabindex_value = /*index*/ ctx[9] === /*selectedIndex*/ ctx[1] ? -1 : 0);
            button.disabled = /*disabled*/ ctx[2];
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "active", /*index*/ ctx[9] === /*selectedIndex*/ ctx[1]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "mixed", /*selectedIndex*/ ctx[1] === undefined);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "disabled", /*disabled*/ ctx[2]);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*index*/ ctx[9] === /*entries*/ ctx[0].length - 1 && /*sharpRightCorners*/ ctx[3]);
            this.first = button;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            if (if_block0) if_block0.m(button, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button, t0);
            if (if_block1) if_block1.m(button, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button, t1);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", click_handler);
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*entry*/ ctx[7].icon) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*entries*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $7c1716396f035b0a$var$create_if_block_1(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(button, t0);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*entry*/ ctx[7].label) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*entries*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $7c1716396f035b0a$var$create_if_block(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(button, t1);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (!current || dirty & /*entries*/ 1 && button_title_value !== (button_title_value = /*entry*/ ctx[7].tooltip)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "title", button_title_value);
            if (!current || dirty & /*entries, selectedIndex*/ 3 && button_tabindex_value !== (button_tabindex_value = /*index*/ ctx[9] === /*selectedIndex*/ ctx[1] ? -1 : 0)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", button_tabindex_value);
            if (!current || dirty & /*disabled*/ 4) button.disabled = /*disabled*/ ctx[2];
            if (!current || dirty & /*entries, selectedIndex*/ 3) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "active", /*index*/ ctx[9] === /*selectedIndex*/ ctx[1]);
            if (!current || dirty & /*selectedIndex, undefined*/ 2) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "mixed", /*selectedIndex*/ ctx[1] === undefined);
            if (!current || dirty & /*disabled*/ 4) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "disabled", /*disabled*/ ctx[2]);
            if (!current || dirty & /*entries, sharpRightCorners*/ 9) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "sharp-right-corners", /*index*/ ctx[9] === /*entries*/ ctx[0].length - 1 && /*sharpRightCorners*/ ctx[3]);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            mounted = false;
            dispose();
        }
    };
}
// (18:0) <LayoutRow class="radio-input" classes={{ disabled }}>
function $7c1716396f035b0a$var$create_default_slot(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let each_value = /*entries*/ ctx[0];
    const get_key = (ctx)=>/*index*/ ctx[9];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $7c1716396f035b0a$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $7c1716396f035b0a$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*entries, selectedIndex, disabled, undefined, sharpRightCorners, handleEntryClick*/ 31) {
                each_value = /*entries*/ ctx[0];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $7c1716396f035b0a$var$create_each_block, each_1_anchor, $7c1716396f035b0a$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
function $7c1716396f035b0a$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "radio-input",
            classes: {
                disabled: /*disabled*/ ctx[2]
            },
            $$slots: {
                default: [
                    $7c1716396f035b0a$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*disabled*/ 4) layoutrow_changes.classes = {
                disabled: /*disabled*/ ctx[2]
            };
            if (dirty & /*$$scope, entries, selectedIndex, disabled, sharpRightCorners*/ 1039) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
function $7c1716396f035b0a$var$instance($$self, $$props, $$invalidate) {
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { entries: entries } = $$props;
    let { selectedIndex: selectedIndex } = $$props;
    let { disabled: disabled = false } = $$props;
    let { sharpRightCorners: sharpRightCorners = false } = $$props;
    function handleEntryClick(radioEntryData) {
        const index = entries.indexOf(radioEntryData);
        dispatch("selectedIndex", index);
        radioEntryData.action?.();
    }
    const click_handler = (entry)=>handleEntryClick(entry);
    $$self.$$set = ($$props)=>{
        if ("entries" in $$props) $$invalidate(0, entries = $$props.entries);
        if ("selectedIndex" in $$props) $$invalidate(1, selectedIndex = $$props.selectedIndex);
        if ("disabled" in $$props) $$invalidate(2, disabled = $$props.disabled);
        if ("sharpRightCorners" in $$props) $$invalidate(3, sharpRightCorners = $$props.sharpRightCorners);
    };
    return [
        entries,
        selectedIndex,
        disabled,
        sharpRightCorners,
        handleEntryClick,
        click_handler
    ];
}
class $7c1716396f035b0a$var$RadioInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $7c1716396f035b0a$var$instance, $7c1716396f035b0a$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            entries: 0,
            selectedIndex: 1,
            disabled: 2,
            sharpRightCorners: 3
        });
    }
}
var $7c1716396f035b0a$export$2e2bcd8739ae039 = $7c1716396f035b0a$var$RadioInput;


/* src/components/widgets/inputs/SwatchPairInput.svelte generated by Svelte v3.58.0 */ 




function $2681143206e86d5b$var$create_default_slot_2(ctx) {
    let button;
    let t;
    let colorpicker;
    let current;
    let mounted;
    let dispose;
    colorpicker = new (0, $130a5ee3db98888b$export$2e2bcd8739ae039)({
        props: {
            open: /*primaryOpen*/ ctx[2],
            color: /*primary*/ ctx[0],
            direction: "Right"
        }
    });
    colorpicker.$on("open", /*open_handler*/ ctx[8]);
    colorpicker.$on("color", /*color_handler*/ ctx[9]);
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(colorpicker.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-floating-menu-spawner", "no-hover-transfer");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", "0");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--swatch-color", /*primary*/ ctx[0].toRgbaCSS());
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(colorpicker, target, anchor);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", /*clickPrimarySwatch*/ ctx[4]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty & /*primary*/ 1) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--swatch-color", /*primary*/ ctx[0].toRgbaCSS());
            const colorpicker_changes = {};
            if (dirty & /*primaryOpen*/ 4) colorpicker_changes.open = /*primaryOpen*/ ctx[2];
            if (dirty & /*primary*/ 1) colorpicker_changes.color = /*primary*/ ctx[0];
            colorpicker.$set(colorpicker_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(colorpicker.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(colorpicker.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(colorpicker, detaching);
            mounted = false;
            dispose();
        }
    };
}
// (31:1) <LayoutRow class="secondary swatch">
function $2681143206e86d5b$var$create_default_slot_1(ctx) {
    let button;
    let t;
    let colorpicker;
    let current;
    let mounted;
    let dispose;
    colorpicker = new (0, $130a5ee3db98888b$export$2e2bcd8739ae039)({
        props: {
            open: /*secondaryOpen*/ ctx[3],
            color: /*secondary*/ ctx[1],
            direction: "Right"
        }
    });
    colorpicker.$on("open", /*open_handler_1*/ ctx[10]);
    colorpicker.$on("color", /*color_handler_1*/ ctx[11]);
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(colorpicker.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "data-floating-menu-spawner", "no-hover-transfer");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", "0");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--swatch-color", /*secondary*/ ctx[1].toRgbaCSS());
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(colorpicker, target, anchor);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", /*clickSecondarySwatch*/ ctx[5]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty & /*secondary*/ 2) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(button, "--swatch-color", /*secondary*/ ctx[1].toRgbaCSS());
            const colorpicker_changes = {};
            if (dirty & /*secondaryOpen*/ 8) colorpicker_changes.open = /*secondaryOpen*/ ctx[3];
            if (dirty & /*secondary*/ 2) colorpicker_changes.color = /*secondary*/ ctx[1];
            colorpicker.$set(colorpicker_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(colorpicker.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(colorpicker.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(colorpicker, detaching);
            mounted = false;
            dispose();
        }
    };
}
// (26:0) <LayoutCol class="swatch-pair">
function $2681143206e86d5b$var$create_default_slot(ctx) {
    let layoutrow0;
    let t;
    let layoutrow1;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "primary swatch",
            $$slots: {
                default: [
                    $2681143206e86d5b$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "secondary swatch",
            $$slots: {
                default: [
                    $2681143206e86d5b$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty & /*$$scope, primaryOpen, primary*/ 8197) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty & /*$$scope, secondaryOpen, secondary*/ 8202) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
        }
    };
}
function $2681143206e86d5b$var$create_fragment(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "swatch-pair",
            $$slots: {
                default: [
                    $2681143206e86d5b$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope, secondaryOpen, secondary, primaryOpen, primary*/ 8207) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
function $2681143206e86d5b$var$instance($$self, $$props, $$invalidate) {
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    let { primary: primary } = $$props;
    let { secondary: secondary } = $$props;
    let primaryOpen = false;
    let secondaryOpen = false;
    function clickPrimarySwatch() {
        $$invalidate(2, primaryOpen = true);
        $$invalidate(3, secondaryOpen = false);
    }
    function clickSecondarySwatch() {
        $$invalidate(2, primaryOpen = false);
        $$invalidate(3, secondaryOpen = true);
    }
    function primaryColorChanged(color) {
        editor.instance.updatePrimaryColor(color.red, color.green, color.blue, color.alpha);
    }
    function secondaryColorChanged(color) {
        editor.instance.updateSecondaryColor(color.red, color.green, color.blue, color.alpha);
    }
    const open_handler = ({ detail: detail })=>$$invalidate(2, primaryOpen = detail);
    const color_handler = ({ detail: detail })=>primaryColorChanged(detail);
    const open_handler_1 = ({ detail: detail })=>$$invalidate(3, secondaryOpen = detail);
    const color_handler_1 = ({ detail: detail })=>secondaryColorChanged(detail);
    $$self.$$set = ($$props)=>{
        if ("primary" in $$props) $$invalidate(0, primary = $$props.primary);
        if ("secondary" in $$props) $$invalidate(1, secondary = $$props.secondary);
    };
    return [
        primary,
        secondary,
        primaryOpen,
        secondaryOpen,
        clickPrimarySwatch,
        clickSecondarySwatch,
        primaryColorChanged,
        secondaryColorChanged,
        open_handler,
        color_handler,
        open_handler_1,
        color_handler_1
    ];
}
class $2681143206e86d5b$var$SwatchPairInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $2681143206e86d5b$var$instance, $2681143206e86d5b$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            primary: 0,
            secondary: 1
        });
    }
}
var $2681143206e86d5b$export$2e2bcd8739ae039 = $2681143206e86d5b$var$SwatchPairInput;


/* src/components/widgets/inputs/TextAreaInput.svelte generated by Svelte v3.58.0 */ 


function $7c5f804e4d426b5c$var$create_fragment(ctx) {
    let fieldinput;
    let current;
    let fieldinput_props = {
        class: "text-area-input",
        classes: {
            "has-label": Boolean(/*label*/ ctx[1])
        },
        value: /*value*/ ctx[0],
        textarea: true,
        spellcheck: true,
        label: /*label*/ ctx[1],
        disabled: /*disabled*/ ctx[3],
        tooltip: /*tooltip*/ ctx[2]
    };
    fieldinput = new (0, $2641f5944a8728bd$export$2e2bcd8739ae039)({
        props: fieldinput_props
    });
    /*fieldinput_binding*/ ctx[9](fieldinput);
    fieldinput.$on("value", /*value_handler*/ ctx[10]);
    fieldinput.$on("textFocused", /*onTextFocused*/ ctx[5]);
    fieldinput.$on("textChanged", /*onTextChanged*/ ctx[6]);
    fieldinput.$on("cancelTextChange", /*onCancelTextChange*/ ctx[7]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(fieldinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(fieldinput, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const fieldinput_changes = {};
            if (dirty & /*label*/ 2) fieldinput_changes.classes = {
                "has-label": Boolean(/*label*/ ctx[1])
            };
            if (dirty & /*value*/ 1) fieldinput_changes.value = /*value*/ ctx[0];
            if (dirty & /*label*/ 2) fieldinput_changes.label = /*label*/ ctx[1];
            if (dirty & /*disabled*/ 8) fieldinput_changes.disabled = /*disabled*/ ctx[3];
            if (dirty & /*tooltip*/ 4) fieldinput_changes.tooltip = /*tooltip*/ ctx[2];
            fieldinput.$set(fieldinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(fieldinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(fieldinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*fieldinput_binding*/ ctx[9](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(fieldinput, detaching);
        }
    };
}
function $7c5f804e4d426b5c$var$instance($$self, $$props, $$invalidate) {
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { value: value } = $$props;
    let { label: label } = $$props;
    let { tooltip: tooltip } = $$props;
    let { disabled: disabled = false } = $$props;
    let self;
    let editing = false;
    function onTextFocused() {
        editing = true;
    }
    // Called only when `value` is changed from the <textarea> element via user input and committed, either
    // via the `change` event or when the <input> element is unfocused (with the `blur` event binding)
    function onTextChanged() {
        // The `unFocus()` call in `onCancelTextChange()` causes itself to be run again, so this if statement skips a second run
        if (!editing) return;
        onCancelTextChange();
        // TODO: Find a less hacky way to do this
        if (self) dispatch("commitText", self.getValue());
        // Required if value is not changed by the parent component upon update:value event
        self?.setInputElementValue(self.getValue());
    }
    function onCancelTextChange() {
        editing = false;
        self?.unFocus();
    }
    function focus() {
        self?.focus();
    }
    function fieldinput_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(4, self);
        });
    }
    function value_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("value" in $$props) $$invalidate(0, value = $$props.value);
        if ("label" in $$props) $$invalidate(1, label = $$props.label);
        if ("tooltip" in $$props) $$invalidate(2, tooltip = $$props.tooltip);
        if ("disabled" in $$props) $$invalidate(3, disabled = $$props.disabled);
    };
    return [
        value,
        label,
        tooltip,
        disabled,
        self,
        onTextFocused,
        onTextChanged,
        onCancelTextChange,
        focus,
        fieldinput_binding,
        value_handler
    ];
}
class $7c5f804e4d426b5c$var$TextAreaInput extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $7c5f804e4d426b5c$var$instance, $7c5f804e4d426b5c$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            value: 0,
            label: 1,
            tooltip: 2,
            disabled: 3,
            focus: 8
        });
    }
    get focus() {
        return this.$$.ctx[8];
    }
}
var $7c5f804e4d426b5c$export$2e2bcd8739ae039 = $7c5f804e4d426b5c$var$TextAreaInput;




/* src/components/widgets/labels/ImageLabel.svelte generated by Svelte v3.58.0 */ 
/* eslint-disable import/first */ // Demo artwork
var $e855d5fa07cfe379$exports = {};

$e855d5fa07cfe379$exports = new URL((parcelRequire("ji6vK")).resolve("fs6JN"), import.meta.url).toString();


var $bba8966833a2a8ff$exports = {};

$bba8966833a2a8ff$exports = new URL((parcelRequire("ji6vK")).resolve("f0UtT"), import.meta.url).toString();


const $de7d535881b8f0e9$var$DEMO_ARTWORK = {
    ThumbnailJustAPottedCactus: (/*@__PURE__*/$parcel$interopDefault($e855d5fa07cfe379$exports)),
    ThumbnailValleyOfSpires: (/*@__PURE__*/$parcel$interopDefault($bba8966833a2a8ff$exports))
};
// All images
const $de7d535881b8f0e9$var$IMAGE_LIST = {
    ...$de7d535881b8f0e9$var$DEMO_ARTWORK
};
const $de7d535881b8f0e9$export$8aea4feaa2f1bcf7 = $de7d535881b8f0e9$var$IMAGE_LIST;
const $de7d535881b8f0e9$export$4c7cb30bb3b5e054 = Object.fromEntries(Object.entries($de7d535881b8f0e9$export$8aea4feaa2f1bcf7).map(([name, data])=>[
        name,
        data
    ]));


function $26f2bc5517710aa2$var$create_fragment(ctx) {
    let img;
    let img_src_value;
    let img_class_value;
    return {
        c () {
            img = (0, $1eb80e36873dc327$export$8454457683f90105)("img");
            if (!(0, $1eb80e36873dc327$export$49b3f9828235af7b)(img.src, img_src_value = (0, $de7d535881b8f0e9$export$4c7cb30bb3b5e054)[/*image*/ ctx[1]])) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(img, "src", img_src_value);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(img, "class", img_class_value = `image-label ${ctx[0]} ${ctx[5]}`.trim());
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(img, "title", /*tooltip*/ ctx[4]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(img, "alt", "");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(img, "width", /*width*/ ctx[2]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(img, "height", /*height*/ ctx[3]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, img, anchor);
        },
        p (ctx, [dirty]) {
            if (dirty & /*image*/ 2 && !(0, $1eb80e36873dc327$export$49b3f9828235af7b)(img.src, img_src_value = (0, $de7d535881b8f0e9$export$4c7cb30bb3b5e054)[/*image*/ ctx[1]])) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(img, "src", img_src_value);
            if (dirty & /*className, extraClasses*/ 33 && img_class_value !== (img_class_value = `image-label ${ctx[0]} ${ctx[5]}`.trim())) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(img, "class", img_class_value);
            if (dirty & /*tooltip*/ 16) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(img, "title", /*tooltip*/ ctx[4]);
            if (dirty & /*width*/ 4) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(img, "width", /*width*/ ctx[2]);
            if (dirty & /*height*/ 8) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(img, "height", /*height*/ ctx[3]);
        },
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(img);
        }
    };
}
function $26f2bc5517710aa2$var$instance($$self, $$props, $$invalidate) {
    let extraClasses;
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    let { image: image } = $$props;
    let { width: width } = $$props;
    let { height: height } = $$props;
    let { tooltip: tooltip } = $$props;
    $$self.$$set = ($$props)=>{
        if ("class" in $$props) $$invalidate(0, className = $$props.class);
        if ("classes" in $$props) $$invalidate(6, classes = $$props.classes);
        if ("image" in $$props) $$invalidate(1, image = $$props.image);
        if ("width" in $$props) $$invalidate(2, width = $$props.width);
        if ("height" in $$props) $$invalidate(3, height = $$props.height);
        if ("tooltip" in $$props) $$invalidate(4, tooltip = $$props.tooltip);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*classes*/ 64) $: $$invalidate(5, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
    };
    return [
        className,
        image,
        width,
        height,
        tooltip,
        extraClasses,
        classes
    ];
}
class $26f2bc5517710aa2$var$ImageLabel extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $26f2bc5517710aa2$var$instance, $26f2bc5517710aa2$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            class: 0,
            classes: 6,
            image: 1,
            width: 2,
            height: 3,
            tooltip: 4
        });
    }
}
var $26f2bc5517710aa2$export$2e2bcd8739ae039 = $26f2bc5517710aa2$var$ImageLabel;





function $d2a3b2ec06ee963b$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[29] = list[i][0];
    child_ctx[30] = list[i][1];
    child_ctx[54] = i;
    const constants_0 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "CheckboxInput");
    child_ctx[31] = constants_0;
    const constants_1 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "ColorInput");
    child_ctx[32] = constants_1;
    const constants_2 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "CurveInput");
    child_ctx[33] = constants_2;
    const constants_3 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "DropdownInput");
    child_ctx[34] = constants_3;
    const constants_4 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "FontInput");
    child_ctx[35] = constants_4;
    const constants_5 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "ParameterExposeButton");
    child_ctx[36] = constants_5;
    const constants_6 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "IconButton");
    child_ctx[37] = constants_6;
    const constants_7 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "IconLabel");
    child_ctx[38] = constants_7;
    const constants_8 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "ImageLabel");
    child_ctx[39] = constants_8;
    const constants_9 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "LayerReferenceInput");
    child_ctx[40] = constants_9;
    const constants_10 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "NumberInput");
    child_ctx[41] = constants_10;
    const constants_11 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "OptionalInput");
    child_ctx[42] = constants_11;
    const constants_12 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "PivotAssist");
    child_ctx[43] = constants_12;
    const constants_13 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "PopoverButton");
    child_ctx[44] = constants_13;
    const constants_14 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "RadioInput");
    child_ctx[45] = constants_14;
    const constants_15 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "Separator");
    child_ctx[46] = constants_15;
    const constants_16 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "SwatchPairInput");
    child_ctx[47] = constants_16;
    const constants_17 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "TextAreaInput");
    child_ctx[48] = constants_17;
    const constants_18 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "TextButton");
    child_ctx[49] = constants_18;
    const constants_19 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "BreadcrumbTrailButtons");
    child_ctx[50] = constants_19;
    const constants_20 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "TextInput");
    child_ctx[51] = constants_20;
    const constants_21 = (0, $f7aa31b9879f1252$export$6cb27e51251341c5)(/*component*/ child_ctx[29].props, "TextLabel");
    child_ctx[52] = constants_21;
    return child_ctx;
}
// (75:2) {#if checkboxInput}
function $d2a3b2ec06ee963b$var$create_if_block_22(ctx) {
    let checkboxinput;
    let current;
    const checkboxinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*checkboxInput*/ ctx[31])
    ];
    function checked_handler(...args) {
        return /*checked_handler*/ ctx[6](/*index*/ ctx[54], ...args);
    }
    let checkboxinput_props = {};
    for(let i = 0; i < checkboxinput_spread_levels.length; i += 1)checkboxinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(checkboxinput_props, checkboxinput_spread_levels[i]);
    checkboxinput = new (0, $2ea65ba9293d21a6$export$2e2bcd8739ae039)({
        props: checkboxinput_props
    });
    checkboxinput.$on("checked", checked_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(checkboxinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(checkboxinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const checkboxinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(checkboxinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*checkboxInput*/ ctx[31]))
            ]) : {};
            checkboxinput.$set(checkboxinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(checkboxinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(checkboxinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(checkboxinput, detaching);
        }
    };
}
// (79:2) {#if colorInput}
function $d2a3b2ec06ee963b$var$create_if_block_21(ctx) {
    let colorinput;
    let current;
    const colorinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*colorInput*/ ctx[32]),
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    function value_handler(...args) {
        return /*value_handler*/ ctx[7](/*index*/ ctx[54], ...args);
    }
    let colorinput_props = {};
    for(let i = 0; i < colorinput_spread_levels.length; i += 1)colorinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(colorinput_props, colorinput_spread_levels[i]);
    colorinput = new (0, $694467b9b6acaa8a$export$2e2bcd8739ae039)({
        props: colorinput_props
    });
    colorinput.$on("value", value_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(colorinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(colorinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const colorinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(colorinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*colorInput*/ ctx[32])),
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            colorinput.$set(colorinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(colorinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(colorinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(colorinput, detaching);
        }
    };
}
// (83:2) {#if curvesInput}
function $d2a3b2ec06ee963b$var$create_if_block_20(ctx) {
    let curveinput;
    let current;
    const curveinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*curvesInput*/ ctx[33])
    ];
    function value_handler_1(...args) {
        return /*value_handler_1*/ ctx[8](/*index*/ ctx[54], ...args);
    }
    let curveinput_props = {};
    for(let i = 0; i < curveinput_spread_levels.length; i += 1)curveinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(curveinput_props, curveinput_spread_levels[i]);
    curveinput = new (0, $07a0c3d99da4c418$export$2e2bcd8739ae039)({
        props: curveinput_props
    });
    curveinput.$on("value", value_handler_1);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(curveinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(curveinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const curveinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(curveinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*curvesInput*/ ctx[33]))
            ]) : {};
            curveinput.$set(curveinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(curveinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(curveinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(curveinput, detaching);
        }
    };
}
// (87:2) {#if dropdownInput}
function $d2a3b2ec06ee963b$var$create_if_block_19(ctx) {
    let dropdowninput;
    let current;
    const dropdowninput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*dropdownInput*/ ctx[34]),
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    function selectedIndex_handler(...args) {
        return /*selectedIndex_handler*/ ctx[9](/*index*/ ctx[54], ...args);
    }
    let dropdowninput_props = {};
    for(let i = 0; i < dropdowninput_spread_levels.length; i += 1)dropdowninput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(dropdowninput_props, dropdowninput_spread_levels[i]);
    dropdowninput = new (0, $b773e3d2fa9c5172$export$2e2bcd8739ae039)({
        props: dropdowninput_props
    });
    dropdowninput.$on("selectedIndex", selectedIndex_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(dropdowninput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(dropdowninput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const dropdowninput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(dropdowninput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*dropdownInput*/ ctx[34])),
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            dropdowninput.$set(dropdowninput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(dropdowninput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(dropdowninput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(dropdowninput, detaching);
        }
    };
}
// (91:2) {#if fontInput}
function $d2a3b2ec06ee963b$var$create_if_block_18(ctx) {
    let fontinput;
    let current;
    const fontinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*fontInput*/ ctx[35]),
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    function changeFont_handler(...args) {
        return /*changeFont_handler*/ ctx[10](/*index*/ ctx[54], ...args);
    }
    let fontinput_props = {};
    for(let i = 0; i < fontinput_spread_levels.length; i += 1)fontinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(fontinput_props, fontinput_spread_levels[i]);
    fontinput = new (0, $e331a3068b7f502d$export$2e2bcd8739ae039)({
        props: fontinput_props
    });
    fontinput.$on("changeFont", changeFont_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(fontinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(fontinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const fontinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(fontinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*fontInput*/ ctx[35])),
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            fontinput.$set(fontinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(fontinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(fontinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(fontinput, detaching);
        }
    };
}
// (95:2) {#if parameterExposeButton}
function $d2a3b2ec06ee963b$var$create_if_block_17(ctx) {
    let parameterexposebutton;
    let current;
    function func() {
        return /*func*/ ctx[11](/*index*/ ctx[54]);
    }
    const parameterexposebutton_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*parameterExposeButton*/ ctx[36]),
        {
            action: func
        }
    ];
    let parameterexposebutton_props = {};
    for(let i = 0; i < parameterexposebutton_spread_levels.length; i += 1)parameterexposebutton_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(parameterexposebutton_props, parameterexposebutton_spread_levels[i]);
    parameterexposebutton = new (0, $98a10f494f962df2$export$2e2bcd8739ae039)({
        props: parameterexposebutton_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(parameterexposebutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(parameterexposebutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const parameterexposebutton_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix, updateLayout*/ 10 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(parameterexposebutton_spread_levels, [
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*parameterExposeButton*/ ctx[36])),
                dirty[0] & /*updateLayout, widgetsAndNextSiblingIsSuffix*/ 10 && {
                    action: func
                }
            ]) : {};
            parameterexposebutton.$set(parameterexposebutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(parameterexposebutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(parameterexposebutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(parameterexposebutton, detaching);
        }
    };
}
// (99:2) {#if iconButton}
function $d2a3b2ec06ee963b$var$create_if_block_16(ctx) {
    let iconbutton;
    let current;
    function func_1() {
        return /*func_1*/ ctx[12](/*index*/ ctx[54]);
    }
    const iconbutton_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*iconButton*/ ctx[37]),
        {
            action: func_1
        },
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    let iconbutton_props = {};
    for(let i = 0; i < iconbutton_spread_levels.length; i += 1)iconbutton_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(iconbutton_props, iconbutton_spread_levels[i]);
    iconbutton = new (0, $47cbcd4715b3f848$export$2e2bcd8739ae039)({
        props: iconbutton_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconbutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const iconbutton_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix, updateLayout*/ 10 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(iconbutton_spread_levels, [
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*iconButton*/ ctx[37])),
                dirty[0] & /*updateLayout, widgetsAndNextSiblingIsSuffix*/ 10 && {
                    action: func_1
                },
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            iconbutton.$set(iconbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconbutton, detaching);
        }
    };
}
// (103:2) {#if iconLabel}
function $d2a3b2ec06ee963b$var$create_if_block_15(ctx) {
    let iconlabel;
    let current;
    const iconlabel_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*iconLabel*/ ctx[38])
    ];
    let iconlabel_props = {};
    for(let i = 0; i < iconlabel_spread_levels.length; i += 1)iconlabel_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(iconlabel_props, iconlabel_spread_levels[i]);
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: iconlabel_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(iconlabel_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*iconLabel*/ ctx[38]))
            ]) : {};
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (107:2) {#if imageLabel}
function $d2a3b2ec06ee963b$var$create_if_block_14(ctx) {
    let imagelabel;
    let current;
    const imagelabel_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*imageLabel*/ ctx[39])
    ];
    let imagelabel_props = {};
    for(let i = 0; i < imagelabel_spread_levels.length; i += 1)imagelabel_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(imagelabel_props, imagelabel_spread_levels[i]);
    imagelabel = new (0, $26f2bc5517710aa2$export$2e2bcd8739ae039)({
        props: imagelabel_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(imagelabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(imagelabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const imagelabel_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(imagelabel_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*imageLabel*/ ctx[39]))
            ]) : {};
            imagelabel.$set(imagelabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(imagelabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(imagelabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(imagelabel, detaching);
        }
    };
}
// (111:2) {#if layerReferenceInput}
function $d2a3b2ec06ee963b$var$create_if_block_13(ctx) {
    let layerreferenceinput;
    let current;
    const layerreferenceinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*layerReferenceInput*/ ctx[40])
    ];
    function value_handler_2(...args) {
        return /*value_handler_2*/ ctx[13](/*index*/ ctx[54], ...args);
    }
    let layerreferenceinput_props = {};
    for(let i = 0; i < layerreferenceinput_spread_levels.length; i += 1)layerreferenceinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(layerreferenceinput_props, layerreferenceinput_spread_levels[i]);
    layerreferenceinput = new (0, $515682188911046d$export$2e2bcd8739ae039)({
        props: layerreferenceinput_props
    });
    layerreferenceinput.$on("value", value_handler_2);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layerreferenceinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layerreferenceinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const layerreferenceinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(layerreferenceinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*layerReferenceInput*/ ctx[40]))
            ]) : {};
            layerreferenceinput.$set(layerreferenceinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layerreferenceinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layerreferenceinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layerreferenceinput, detaching);
        }
    };
}
// (115:2) {#if numberInput}
function $d2a3b2ec06ee963b$var$create_if_block_12(ctx) {
    let numberinput;
    let current;
    function func_2() {
        return /*func_2*/ ctx[14](/*index*/ ctx[54]);
    }
    function func_3() {
        return /*func_3*/ ctx[15](/*index*/ ctx[54]);
    }
    const numberinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*numberInput*/ ctx[41]),
        {
            incrementCallbackIncrease: func_2
        },
        {
            incrementCallbackDecrease: func_3
        },
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    function value_handler_3(...args) {
        return /*value_handler_3*/ ctx[16](/*index*/ ctx[54], ...args);
    }
    let numberinput_props = {};
    for(let i = 0; i < numberinput_spread_levels.length; i += 1)numberinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(numberinput_props, numberinput_spread_levels[i]);
    numberinput = new (0, $4f662fa3f52169e2$export$2e2bcd8739ae039)({
        props: numberinput_props
    });
    numberinput.$on("value", value_handler_3);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(numberinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(numberinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const numberinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix, updateLayout*/ 10 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(numberinput_spread_levels, [
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*numberInput*/ ctx[41])),
                dirty[0] & /*updateLayout, widgetsAndNextSiblingIsSuffix*/ 10 && {
                    incrementCallbackIncrease: func_2
                },
                dirty[0] & /*updateLayout, widgetsAndNextSiblingIsSuffix*/ 10 && {
                    incrementCallbackDecrease: func_3
                },
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            numberinput.$set(numberinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(numberinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(numberinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(numberinput, detaching);
        }
    };
}
// (125:2) {#if optionalInput}
function $d2a3b2ec06ee963b$var$create_if_block_11(ctx) {
    let optionalinput;
    let current;
    const optionalinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*optionalInput*/ ctx[42])
    ];
    function checked_handler_1(...args) {
        return /*checked_handler_1*/ ctx[17](/*index*/ ctx[54], ...args);
    }
    let optionalinput_props = {};
    for(let i = 0; i < optionalinput_spread_levels.length; i += 1)optionalinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(optionalinput_props, optionalinput_spread_levels[i]);
    optionalinput = new (0, $5559ef6e76d6699f$export$2e2bcd8739ae039)({
        props: optionalinput_props
    });
    optionalinput.$on("checked", checked_handler_1);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(optionalinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(optionalinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const optionalinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(optionalinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*optionalInput*/ ctx[42]))
            ]) : {};
            optionalinput.$set(optionalinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(optionalinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(optionalinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(optionalinput, detaching);
        }
    };
}
// (129:2) {#if pivotAssist}
function $d2a3b2ec06ee963b$var$create_if_block_10(ctx) {
    let pivotassist;
    let current;
    const pivotassist_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*pivotAssist*/ ctx[43])
    ];
    function position_handler(...args) {
        return /*position_handler*/ ctx[18](/*index*/ ctx[54], ...args);
    }
    let pivotassist_props = {};
    for(let i = 0; i < pivotassist_spread_levels.length; i += 1)pivotassist_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(pivotassist_props, pivotassist_spread_levels[i]);
    pivotassist = new (0, $6f3fd08d16181ba6$export$2e2bcd8739ae039)({
        props: pivotassist_props
    });
    pivotassist.$on("position", position_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(pivotassist.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(pivotassist, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const pivotassist_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(pivotassist_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*pivotAssist*/ ctx[43]))
            ]) : {};
            pivotassist.$set(pivotassist_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(pivotassist.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(pivotassist.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(pivotassist, detaching);
        }
    };
}
// (133:2) {#if popoverButton}
function $d2a3b2ec06ee963b$var$create_if_block_8(ctx) {
    let popoverbutton;
    let current;
    const popoverbutton_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*popoverButton*/ ctx[44], [
            "header",
            "text",
            "optionsWidget"
        ])
    ];
    let popoverbutton_props = {
        $$slots: {
            default: [
                $d2a3b2ec06ee963b$var$create_default_slot_1
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    for(let i = 0; i < popoverbutton_spread_levels.length; i += 1)popoverbutton_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(popoverbutton_props, popoverbutton_spread_levels[i]);
    popoverbutton = new (0, $68f47e5b62fe7f2d$export$2e2bcd8739ae039)({
        props: popoverbutton_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(popoverbutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(popoverbutton, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const popoverbutton_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(popoverbutton_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*popoverButton*/ ctx[44], [
                    "header",
                    "text",
                    "optionsWidget"
                ]))
            ]) : {};
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix, layoutTarget*/ 3 | dirty[1] & /*$$scope*/ 16777216) popoverbutton_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            popoverbutton.$set(popoverbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(popoverbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(popoverbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(popoverbutton, detaching);
        }
    };
}
// (135:4) <TextLabel bold={true}>
function $d2a3b2ec06ee963b$var$create_default_slot_3(ctx) {
    let t_value = /*popoverButton*/ ctx[44].header + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && t_value !== (t_value = /*popoverButton*/ ctx[44].header + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (138:4) {:else}
function $d2a3b2ec06ee963b$var$create_else_block(ctx) {
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            multiline: true,
            $$slots: {
                default: [
                    $d2a3b2ec06ee963b$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 | dirty[1] & /*$$scope*/ 16777216) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (136:4) {#if popoverButton.optionsWidget?.length}
function $d2a3b2ec06ee963b$var$create_if_block_9(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: {
                layout: /*popoverButton*/ ctx[44].optionsWidget,
                layoutTarget: /*layoutTarget*/ ctx[0]
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix, layoutTarget*/ 3) widgetlayout_changes.layout = {
                layout: /*popoverButton*/ ctx[44].optionsWidget,
                layoutTarget: /*layoutTarget*/ ctx[0]
            };
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (139:5) <TextLabel multiline={true}>
function $d2a3b2ec06ee963b$var$create_default_slot_2(ctx) {
    let t_value = /*popoverButton*/ ctx[44].text + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && t_value !== (t_value = /*popoverButton*/ ctx[44].text + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (134:3) <PopoverButton {...exclude(popoverButton, ["header", "text", "optionsWidget"])}>
function $d2a3b2ec06ee963b$var$create_default_slot_1(ctx) {
    let textlabel;
    let t;
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            bold: true,
            $$slots: {
                default: [
                    $d2a3b2ec06ee963b$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    const if_block_creators = [
        $d2a3b2ec06ee963b$var$create_if_block_9,
        $d2a3b2ec06ee963b$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*popoverButton*/ ctx[44].optionsWidget?.length) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, [
        -1,
        -1
    ]);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 | dirty[1] & /*$$scope*/ 16777216) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (144:2) {#if radioInput}
function $d2a3b2ec06ee963b$var$create_if_block_7(ctx) {
    let radioinput;
    let current;
    const radioinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*radioInput*/ ctx[45]),
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    function selectedIndex_handler_1(...args) {
        return /*selectedIndex_handler_1*/ ctx[19](/*index*/ ctx[54], ...args);
    }
    let radioinput_props = {};
    for(let i = 0; i < radioinput_spread_levels.length; i += 1)radioinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(radioinput_props, radioinput_spread_levels[i]);
    radioinput = new (0, $7c1716396f035b0a$export$2e2bcd8739ae039)({
        props: radioinput_props
    });
    radioinput.$on("selectedIndex", selectedIndex_handler_1);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(radioinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(radioinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const radioinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(radioinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*radioInput*/ ctx[45])),
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            radioinput.$set(radioinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(radioinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(radioinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(radioinput, detaching);
        }
    };
}
// (148:2) {#if separator}
function $d2a3b2ec06ee963b$var$create_if_block_6(ctx) {
    let separator;
    let current;
    const separator_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*separator*/ ctx[46])
    ];
    let separator_props = {};
    for(let i = 0; i < separator_spread_levels.length; i += 1)separator_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(separator_props, separator_spread_levels[i]);
    separator = new (0, $8f30dd58aa143a6c$export$2e2bcd8739ae039)({
        props: separator_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(separator.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(separator, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const separator_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(separator_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*separator*/ ctx[46]))
            ]) : {};
            separator.$set(separator_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(separator.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(separator.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(separator, detaching);
        }
    };
}
// (152:2) {#if swatchPairInput}
function $d2a3b2ec06ee963b$var$create_if_block_5(ctx) {
    let swatchpairinput;
    let current;
    const swatchpairinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*swatchPairInput*/ ctx[47])
    ];
    let swatchpairinput_props = {};
    for(let i = 0; i < swatchpairinput_spread_levels.length; i += 1)swatchpairinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(swatchpairinput_props, swatchpairinput_spread_levels[i]);
    swatchpairinput = new (0, $2681143206e86d5b$export$2e2bcd8739ae039)({
        props: swatchpairinput_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(swatchpairinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(swatchpairinput, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const swatchpairinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(swatchpairinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*swatchPairInput*/ ctx[47]))
            ]) : {};
            swatchpairinput.$set(swatchpairinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(swatchpairinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(swatchpairinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(swatchpairinput, detaching);
        }
    };
}
// (156:2) {#if textAreaInput}
function $d2a3b2ec06ee963b$var$create_if_block_4(ctx) {
    let textareainput;
    let current;
    const textareainput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*textAreaInput*/ ctx[48])
    ];
    function commitText_handler(...args) {
        return /*commitText_handler*/ ctx[20](/*index*/ ctx[54], ...args);
    }
    let textareainput_props = {};
    for(let i = 0; i < textareainput_spread_levels.length; i += 1)textareainput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(textareainput_props, textareainput_spread_levels[i]);
    textareainput = new (0, $7c5f804e4d426b5c$export$2e2bcd8739ae039)({
        props: textareainput_props
    });
    textareainput.$on("commitText", commitText_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textareainput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textareainput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const textareainput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(textareainput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*textAreaInput*/ ctx[48]))
            ]) : {};
            textareainput.$set(textareainput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textareainput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textareainput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textareainput, detaching);
        }
    };
}
// (160:2) {#if textButton}
function $d2a3b2ec06ee963b$var$create_if_block_3(ctx) {
    let textbutton;
    let current;
    function func_4() {
        return /*func_4*/ ctx[21](/*index*/ ctx[54]);
    }
    const textbutton_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*textButton*/ ctx[49]),
        {
            action: func_4
        },
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    let textbutton_props = {};
    for(let i = 0; i < textbutton_spread_levels.length; i += 1)textbutton_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(textbutton_props, textbutton_spread_levels[i]);
    textbutton = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: textbutton_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const textbutton_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix, updateLayout*/ 10 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(textbutton_spread_levels, [
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*textButton*/ ctx[49])),
                dirty[0] & /*updateLayout, widgetsAndNextSiblingIsSuffix*/ 10 && {
                    action: func_4
                },
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            textbutton.$set(textbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton, detaching);
        }
    };
}
// (164:2) {#if breadcrumbTrailButtons}
function $d2a3b2ec06ee963b$var$create_if_block_2(ctx) {
    let breadcrumbtrailbuttons;
    let current;
    const breadcrumbtrailbuttons_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*breadcrumbTrailButtons*/ ctx[50]),
        {
            action: /*func_5*/ ctx[22]
        }
    ];
    let breadcrumbtrailbuttons_props = {};
    for(let i = 0; i < breadcrumbtrailbuttons_spread_levels.length; i += 1)breadcrumbtrailbuttons_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(breadcrumbtrailbuttons_props, breadcrumbtrailbuttons_spread_levels[i]);
    breadcrumbtrailbuttons = new (0, $cb89be9f6aef8b42$export$2e2bcd8739ae039)({
        props: breadcrumbtrailbuttons_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(breadcrumbtrailbuttons.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(breadcrumbtrailbuttons, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const breadcrumbtrailbuttons_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix, updateLayout*/ 10 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(breadcrumbtrailbuttons_spread_levels, [
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*breadcrumbTrailButtons*/ ctx[50])),
                dirty[0] & /*updateLayout*/ 8 && {
                    action: /*func_5*/ ctx[22]
                }
            ]) : {};
            breadcrumbtrailbuttons.$set(breadcrumbtrailbuttons_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(breadcrumbtrailbuttons.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(breadcrumbtrailbuttons.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(breadcrumbtrailbuttons, detaching);
        }
    };
}
// (168:2) {#if textInput}
function $d2a3b2ec06ee963b$var$create_if_block_1(ctx) {
    let textinput;
    let current;
    const textinput_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*textInput*/ ctx[51]),
        {
            sharpRightCorners: /*nextIsSuffix*/ ctx[30]
        }
    ];
    function commitText_handler_1(...args) {
        return /*commitText_handler_1*/ ctx[23](/*index*/ ctx[54], ...args);
    }
    let textinput_props = {};
    for(let i = 0; i < textinput_spread_levels.length; i += 1)textinput_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(textinput_props, textinput_spread_levels[i]);
    textinput = new (0, $13b5dd8e132143df$export$2e2bcd8739ae039)({
        props: textinput_props
    });
    textinput.$on("commitText", commitText_handler_1);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textinput.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textinput, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const textinput_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(textinput_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*textInput*/ ctx[51])),
                dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && {
                    sharpRightCorners: /*nextIsSuffix*/ ctx[30]
                }
            ]) : {};
            textinput.$set(textinput_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textinput.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textinput.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textinput, detaching);
        }
    };
}
// (172:2) {#if textLabel}
function $d2a3b2ec06ee963b$var$create_if_block(ctx) {
    let textlabel;
    let current;
    const textlabel_spread_levels = [
        $d2a3b2ec06ee963b$var$exclude(/*textLabel*/ ctx[52], [
            "value"
        ])
    ];
    let textlabel_props = {
        $$slots: {
            default: [
                $d2a3b2ec06ee963b$var$create_default_slot
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    for(let i = 0; i < textlabel_spread_levels.length; i += 1)textlabel_props = (0, $1eb80e36873dc327$export$e6e34fd1f2686227)(textlabel_props, textlabel_spread_levels[i]);
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: textlabel_props
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 ? (0, $1eb80e36873dc327$export$eea1060726e9ab6)(textlabel_spread_levels, [
                (0, $1eb80e36873dc327$export$19fac21209f8779d)($d2a3b2ec06ee963b$var$exclude(/*textLabel*/ ctx[52], [
                    "value"
                ]))
            ]) : {};
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 | dirty[1] & /*$$scope*/ 16777216) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (173:3) <TextLabel {...exclude(textLabel, ["value"])}>
function $d2a3b2ec06ee963b$var$create_default_slot(ctx) {
    let t_value = /*textLabel*/ ctx[52].value + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2 && t_value !== (t_value = /*textLabel*/ ctx[52].value + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (73:1) {#each widgetsAndNextSiblingIsSuffix as [component, nextIsSuffix], index (index)}
function $d2a3b2ec06ee963b$var$create_each_block(key_1, ctx) {
    let first;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let if_block21_anchor;
    let current;
    let if_block0 = /*checkboxInput*/ ctx[31] && $d2a3b2ec06ee963b$var$create_if_block_22(ctx);
    let if_block1 = /*colorInput*/ ctx[32] && $d2a3b2ec06ee963b$var$create_if_block_21(ctx);
    let if_block2 = /*curvesInput*/ ctx[33] && $d2a3b2ec06ee963b$var$create_if_block_20(ctx);
    let if_block3 = /*dropdownInput*/ ctx[34] && $d2a3b2ec06ee963b$var$create_if_block_19(ctx);
    let if_block4 = /*fontInput*/ ctx[35] && $d2a3b2ec06ee963b$var$create_if_block_18(ctx);
    let if_block5 = /*parameterExposeButton*/ ctx[36] && $d2a3b2ec06ee963b$var$create_if_block_17(ctx);
    let if_block6 = /*iconButton*/ ctx[37] && $d2a3b2ec06ee963b$var$create_if_block_16(ctx);
    let if_block7 = /*iconLabel*/ ctx[38] && $d2a3b2ec06ee963b$var$create_if_block_15(ctx);
    let if_block8 = /*imageLabel*/ ctx[39] && $d2a3b2ec06ee963b$var$create_if_block_14(ctx);
    let if_block9 = /*layerReferenceInput*/ ctx[40] && $d2a3b2ec06ee963b$var$create_if_block_13(ctx);
    let if_block10 = /*numberInput*/ ctx[41] && $d2a3b2ec06ee963b$var$create_if_block_12(ctx);
    let if_block11 = /*optionalInput*/ ctx[42] && $d2a3b2ec06ee963b$var$create_if_block_11(ctx);
    let if_block12 = /*pivotAssist*/ ctx[43] && $d2a3b2ec06ee963b$var$create_if_block_10(ctx);
    let if_block13 = /*popoverButton*/ ctx[44] && $d2a3b2ec06ee963b$var$create_if_block_8(ctx);
    let if_block14 = /*radioInput*/ ctx[45] && $d2a3b2ec06ee963b$var$create_if_block_7(ctx);
    let if_block15 = /*separator*/ ctx[46] && $d2a3b2ec06ee963b$var$create_if_block_6(ctx);
    let if_block16 = /*swatchPairInput*/ ctx[47] && $d2a3b2ec06ee963b$var$create_if_block_5(ctx);
    let if_block17 = /*textAreaInput*/ ctx[48] && $d2a3b2ec06ee963b$var$create_if_block_4(ctx);
    let if_block18 = /*textButton*/ ctx[49] && $d2a3b2ec06ee963b$var$create_if_block_3(ctx);
    let if_block19 = /*breadcrumbTrailButtons*/ ctx[50] && $d2a3b2ec06ee963b$var$create_if_block_2(ctx);
    let if_block20 = /*textInput*/ ctx[51] && $d2a3b2ec06ee963b$var$create_if_block_1(ctx);
    let if_block21 = /*textLabel*/ ctx[52] && $d2a3b2ec06ee963b$var$create_if_block(ctx);
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if (if_block0) if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block2) if_block2.c();
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block3) if_block3.c();
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block4) if_block4.c();
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block5) if_block5.c();
            t5 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block6) if_block6.c();
            t6 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block7) if_block7.c();
            t7 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block8) if_block8.c();
            t8 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block9) if_block9.c();
            t9 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block10) if_block10.c();
            t10 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block11) if_block11.c();
            t11 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block12) if_block12.c();
            t12 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block13) if_block13.c();
            t13 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block14) if_block14.c();
            t14 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block15) if_block15.c();
            t15 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block16) if_block16.c();
            t16 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block17) if_block17.c();
            t17 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block18) if_block18.c();
            t18 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block19) if_block19.c();
            t19 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block20) if_block20.c();
            t20 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block21) if_block21.c();
            if_block21_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if (if_block0) if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            if (if_block2) if_block2.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t2, anchor);
            if (if_block3) if_block3.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t3, anchor);
            if (if_block4) if_block4.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t4, anchor);
            if (if_block5) if_block5.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t5, anchor);
            if (if_block6) if_block6.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t6, anchor);
            if (if_block7) if_block7.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t7, anchor);
            if (if_block8) if_block8.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t8, anchor);
            if (if_block9) if_block9.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t9, anchor);
            if (if_block10) if_block10.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t10, anchor);
            if (if_block11) if_block11.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t11, anchor);
            if (if_block12) if_block12.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t12, anchor);
            if (if_block13) if_block13.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t13, anchor);
            if (if_block14) if_block14.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t14, anchor);
            if (if_block15) if_block15.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t15, anchor);
            if (if_block16) if_block16.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t16, anchor);
            if (if_block17) if_block17.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t17, anchor);
            if (if_block18) if_block18.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t18, anchor);
            if (if_block19) if_block19.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t19, anchor);
            if (if_block20) if_block20.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t20, anchor);
            if (if_block21) if_block21.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block21_anchor, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (/*checkboxInput*/ ctx[31]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $d2a3b2ec06ee963b$var$create_if_block_22(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(t0.parentNode, t0);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*colorInput*/ ctx[32]) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $d2a3b2ec06ee963b$var$create_if_block_21(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(t1.parentNode, t1);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*curvesInput*/ ctx[33]) {
                if (if_block2) {
                    if_block2.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2, 1);
                } else {
                    if_block2 = $d2a3b2ec06ee963b$var$create_if_block_20(ctx);
                    if_block2.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2, 1);
                    if_block2.m(t2.parentNode, t2);
                }
            } else if (if_block2) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*dropdownInput*/ ctx[34]) {
                if (if_block3) {
                    if_block3.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block3, 1);
                } else {
                    if_block3 = $d2a3b2ec06ee963b$var$create_if_block_19(ctx);
                    if_block3.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block3, 1);
                    if_block3.m(t3.parentNode, t3);
                }
            } else if (if_block3) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block3, 1, 1, ()=>{
                    if_block3 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*fontInput*/ ctx[35]) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block4, 1);
                } else {
                    if_block4 = $d2a3b2ec06ee963b$var$create_if_block_18(ctx);
                    if_block4.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block4, 1);
                    if_block4.m(t4.parentNode, t4);
                }
            } else if (if_block4) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*parameterExposeButton*/ ctx[36]) {
                if (if_block5) {
                    if_block5.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block5, 1);
                } else {
                    if_block5 = $d2a3b2ec06ee963b$var$create_if_block_17(ctx);
                    if_block5.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block5, 1);
                    if_block5.m(t5.parentNode, t5);
                }
            } else if (if_block5) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block5, 1, 1, ()=>{
                    if_block5 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*iconButton*/ ctx[37]) {
                if (if_block6) {
                    if_block6.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block6, 1);
                } else {
                    if_block6 = $d2a3b2ec06ee963b$var$create_if_block_16(ctx);
                    if_block6.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block6, 1);
                    if_block6.m(t6.parentNode, t6);
                }
            } else if (if_block6) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block6, 1, 1, ()=>{
                    if_block6 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*iconLabel*/ ctx[38]) {
                if (if_block7) {
                    if_block7.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block7, 1);
                } else {
                    if_block7 = $d2a3b2ec06ee963b$var$create_if_block_15(ctx);
                    if_block7.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block7, 1);
                    if_block7.m(t7.parentNode, t7);
                }
            } else if (if_block7) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block7, 1, 1, ()=>{
                    if_block7 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*imageLabel*/ ctx[39]) {
                if (if_block8) {
                    if_block8.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block8, 1);
                } else {
                    if_block8 = $d2a3b2ec06ee963b$var$create_if_block_14(ctx);
                    if_block8.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block8, 1);
                    if_block8.m(t8.parentNode, t8);
                }
            } else if (if_block8) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block8, 1, 1, ()=>{
                    if_block8 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*layerReferenceInput*/ ctx[40]) {
                if (if_block9) {
                    if_block9.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block9, 1);
                } else {
                    if_block9 = $d2a3b2ec06ee963b$var$create_if_block_13(ctx);
                    if_block9.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block9, 1);
                    if_block9.m(t9.parentNode, t9);
                }
            } else if (if_block9) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block9, 1, 1, ()=>{
                    if_block9 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*numberInput*/ ctx[41]) {
                if (if_block10) {
                    if_block10.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block10, 1);
                } else {
                    if_block10 = $d2a3b2ec06ee963b$var$create_if_block_12(ctx);
                    if_block10.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block10, 1);
                    if_block10.m(t10.parentNode, t10);
                }
            } else if (if_block10) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block10, 1, 1, ()=>{
                    if_block10 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*optionalInput*/ ctx[42]) {
                if (if_block11) {
                    if_block11.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block11, 1);
                } else {
                    if_block11 = $d2a3b2ec06ee963b$var$create_if_block_11(ctx);
                    if_block11.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block11, 1);
                    if_block11.m(t11.parentNode, t11);
                }
            } else if (if_block11) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block11, 1, 1, ()=>{
                    if_block11 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*pivotAssist*/ ctx[43]) {
                if (if_block12) {
                    if_block12.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block12, 1);
                } else {
                    if_block12 = $d2a3b2ec06ee963b$var$create_if_block_10(ctx);
                    if_block12.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block12, 1);
                    if_block12.m(t12.parentNode, t12);
                }
            } else if (if_block12) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block12, 1, 1, ()=>{
                    if_block12 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*popoverButton*/ ctx[44]) {
                if (if_block13) {
                    if_block13.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block13, 1);
                } else {
                    if_block13 = $d2a3b2ec06ee963b$var$create_if_block_8(ctx);
                    if_block13.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block13, 1);
                    if_block13.m(t13.parentNode, t13);
                }
            } else if (if_block13) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block13, 1, 1, ()=>{
                    if_block13 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*radioInput*/ ctx[45]) {
                if (if_block14) {
                    if_block14.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block14, 1);
                } else {
                    if_block14 = $d2a3b2ec06ee963b$var$create_if_block_7(ctx);
                    if_block14.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block14, 1);
                    if_block14.m(t14.parentNode, t14);
                }
            } else if (if_block14) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block14, 1, 1, ()=>{
                    if_block14 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*separator*/ ctx[46]) {
                if (if_block15) {
                    if_block15.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block15, 1);
                } else {
                    if_block15 = $d2a3b2ec06ee963b$var$create_if_block_6(ctx);
                    if_block15.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block15, 1);
                    if_block15.m(t15.parentNode, t15);
                }
            } else if (if_block15) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block15, 1, 1, ()=>{
                    if_block15 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*swatchPairInput*/ ctx[47]) {
                if (if_block16) {
                    if_block16.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block16, 1);
                } else {
                    if_block16 = $d2a3b2ec06ee963b$var$create_if_block_5(ctx);
                    if_block16.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block16, 1);
                    if_block16.m(t16.parentNode, t16);
                }
            } else if (if_block16) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block16, 1, 1, ()=>{
                    if_block16 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*textAreaInput*/ ctx[48]) {
                if (if_block17) {
                    if_block17.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block17, 1);
                } else {
                    if_block17 = $d2a3b2ec06ee963b$var$create_if_block_4(ctx);
                    if_block17.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block17, 1);
                    if_block17.m(t17.parentNode, t17);
                }
            } else if (if_block17) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block17, 1, 1, ()=>{
                    if_block17 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*textButton*/ ctx[49]) {
                if (if_block18) {
                    if_block18.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block18, 1);
                } else {
                    if_block18 = $d2a3b2ec06ee963b$var$create_if_block_3(ctx);
                    if_block18.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block18, 1);
                    if_block18.m(t18.parentNode, t18);
                }
            } else if (if_block18) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block18, 1, 1, ()=>{
                    if_block18 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*breadcrumbTrailButtons*/ ctx[50]) {
                if (if_block19) {
                    if_block19.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block19, 1);
                } else {
                    if_block19 = $d2a3b2ec06ee963b$var$create_if_block_2(ctx);
                    if_block19.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block19, 1);
                    if_block19.m(t19.parentNode, t19);
                }
            } else if (if_block19) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block19, 1, 1, ()=>{
                    if_block19 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*textInput*/ ctx[51]) {
                if (if_block20) {
                    if_block20.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block20, 1);
                } else {
                    if_block20 = $d2a3b2ec06ee963b$var$create_if_block_1(ctx);
                    if_block20.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block20, 1);
                    if_block20.m(t20.parentNode, t20);
                }
            } else if (if_block20) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block20, 1, 1, ()=>{
                    if_block20 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*textLabel*/ ctx[52]) {
                if (if_block21) {
                    if_block21.p(ctx, dirty);
                    if (dirty[0] & /*widgetsAndNextSiblingIsSuffix*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block21, 1);
                } else {
                    if_block21 = $d2a3b2ec06ee963b$var$create_if_block(ctx);
                    if_block21.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block21, 1);
                    if_block21.m(if_block21_anchor.parentNode, if_block21_anchor);
                }
            } else if (if_block21) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block21, 1, 1, ()=>{
                    if_block21 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block2);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block3);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block4);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block5);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block6);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block7);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block8);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block9);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block10);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block11);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block12);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block13);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block14);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block15);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block16);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block17);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block18);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block19);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block20);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block21);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block2);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block3);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block4);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block5);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block6);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block7);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block8);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block9);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block10);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block11);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block12);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block13);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block14);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block15);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block16);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block17);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block18);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block19);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block20);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block21);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if (if_block0) if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (if_block2) if_block2.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t2);
            if (if_block3) if_block3.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t3);
            if (if_block4) if_block4.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t4);
            if (if_block5) if_block5.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t5);
            if (if_block6) if_block6.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t6);
            if (if_block7) if_block7.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t7);
            if (if_block8) if_block8.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t8);
            if (if_block9) if_block9.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t9);
            if (if_block10) if_block10.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t10);
            if (if_block11) if_block11.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t11);
            if (if_block12) if_block12.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t12);
            if (if_block13) if_block13.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t13);
            if (if_block14) if_block14.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t14);
            if (if_block15) if_block15.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t15);
            if (if_block16) if_block16.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t16);
            if (if_block17) if_block17.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t17);
            if (if_block18) if_block18.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t18);
            if (if_block19) if_block19.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t19);
            if (if_block20) if_block20.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t20);
            if (if_block21) if_block21.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block21_anchor);
        }
    };
}
function $d2a3b2ec06ee963b$var$create_fragment(ctx) {
    let div;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let div_class_value;
    let current;
    let each_value = /*widgetsAndNextSiblingIsSuffix*/ ctx[1];
    const get_key = (ctx)=>/*index*/ ctx[54];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $d2a3b2ec06ee963b$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $d2a3b2ec06ee963b$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value = `widget-${ctx[2]}`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div, null);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty[0] & /*widgetsAndNextSiblingIsSuffix, updateLayout, layoutTarget*/ 11) {
                each_value = /*widgetsAndNextSiblingIsSuffix*/ ctx[1];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $d2a3b2ec06ee963b$var$create_each_block, null, $d2a3b2ec06ee963b$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (!current || dirty[0] & /*direction*/ 4 && div_class_value !== (div_class_value = `widget-${ctx[2]}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value);
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d();
        }
    };
}
function $d2a3b2ec06ee963b$var$exclude(props, additional) {
    const exclusions = [
        "kind",
        ...additional || []
    ];
    return Object.fromEntries(Object.entries(props).filter((entry)=>!exclusions.includes(entry[0])));
}
function $d2a3b2ec06ee963b$var$instance($$self, $$props, $$invalidate) {
    let direction;
    let widgets;
    let widgetsAndNextSiblingIsSuffix;
    const SUFFIX_WIDGETS = [
        "PopoverButton"
    ];
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    let { widgetData: widgetData } = $$props;
    let { layoutTarget: layoutTarget } = $$props;
    function watchDirection(widgetData) {
        if ((0, $f7aa31b9879f1252$export$377d9cd95e2858ff)(widgetData)) return "row";
        if ((0, $f7aa31b9879f1252$export$b6705411aec0409b)(widgetData)) return "column";
        return "ERROR";
    }
    function watchWidgets(widgetData) {
        let widgets = [];
        if ((0, $f7aa31b9879f1252$export$377d9cd95e2858ff)(widgetData)) widgets = widgetData.rowWidgets;
        else if ((0, $f7aa31b9879f1252$export$b6705411aec0409b)(widgetData)) widgets = widgetData.columnWidgets;
        return widgets;
    }
    function watchWidgetsAndNextSiblingIsSuffix(widgets) {
        return widgets.map((widget, index)=>{
            // A suffix widget is one that joins up with this widget at the end with only a 1px gap.
            // It uses the CSS sibling selector to give its own left edge corners zero radius.
            // But this JS is needed to set its preceding sibling widget's right edge corners to zero radius.
            const nextSiblingIsSuffix = SUFFIX_WIDGETS.includes(widgets[index + 1]?.props.kind);
            return [
                widget,
                nextSiblingIsSuffix
            ];
        });
    }
    function updateLayout(index, value) {
        editor.instance.updateLayout(layoutTarget, widgets[index].widgetId, value);
    }
    const checked_handler = (index, { detail: detail })=>updateLayout(index, detail);
    const value_handler = (index, { detail: detail })=>updateLayout(index, detail);
    const value_handler_1 = (index, { detail: detail })=>(0, $e752f026ddda25a8$export$12bf26cb720cb002)((value)=>updateLayout(index, value), {
            debounceTime: 120
        }).updateValue(detail);
    const selectedIndex_handler = (index, { detail: detail })=>updateLayout(index, detail);
    const changeFont_handler = (index, { detail: detail })=>updateLayout(index, detail);
    const func = (index)=>updateLayout(index, undefined);
    const func_1 = (index)=>updateLayout(index, undefined);
    const value_handler_2 = (index, { detail: detail })=>updateLayout(index, detail);
    const func_2 = (index)=>updateLayout(index, "Increment");
    const func_3 = (index)=>updateLayout(index, "Decrement");
    const value_handler_3 = (index, { detail: detail })=>(0, $e752f026ddda25a8$export$12bf26cb720cb002)((value)=>updateLayout(index, value)).updateValue(detail);
    const checked_handler_1 = (index, { detail: detail })=>updateLayout(index, detail);
    const position_handler = (index, { detail: detail })=>updateLayout(index, detail);
    const selectedIndex_handler_1 = (index, { detail: detail })=>updateLayout(index, detail);
    const commitText_handler = (index, { detail: detail })=>updateLayout(index, detail);
    const func_4 = (index)=>updateLayout(index, undefined);
    const func_5 = (index)=>updateLayout(index, index);
    const commitText_handler_1 = (index, { detail: detail })=>updateLayout(index, detail);
    $$self.$$set = ($$props)=>{
        if ("widgetData" in $$props) $$invalidate(4, widgetData = $$props.widgetData);
        if ("layoutTarget" in $$props) $$invalidate(0, layoutTarget = $$props.layoutTarget);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*widgetData*/ 16) $: $$invalidate(2, direction = watchDirection(widgetData));
        if ($$self.$$.dirty[0] & /*widgetData*/ 16) $: $$invalidate(5, widgets = watchWidgets(widgetData));
        if ($$self.$$.dirty[0] & /*widgets*/ 32) $: $$invalidate(1, widgetsAndNextSiblingIsSuffix = watchWidgetsAndNextSiblingIsSuffix(widgets));
    };
    return [
        layoutTarget,
        widgetsAndNextSiblingIsSuffix,
        direction,
        updateLayout,
        widgetData,
        widgets,
        checked_handler,
        value_handler,
        value_handler_1,
        selectedIndex_handler,
        changeFont_handler,
        func,
        func_1,
        value_handler_2,
        func_2,
        func_3,
        value_handler_3,
        checked_handler_1,
        position_handler,
        selectedIndex_handler_1,
        commitText_handler,
        func_4,
        func_5,
        commitText_handler_1
    ];
}
class $d2a3b2ec06ee963b$var$WidgetRow extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $d2a3b2ec06ee963b$var$instance, $d2a3b2ec06ee963b$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            widgetData: 4,
            layoutTarget: 0
        }, null, [
            -1,
            -1
        ]);
    }
}
var $d2a3b2ec06ee963b$export$2e2bcd8739ae039 = $d2a3b2ec06ee963b$var$WidgetRow;



function $cdc0d4690fab42ec$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[5] = list[i];
    child_ctx[7] = i;
    return child_ctx;
}
// (16:2) <TextLabel bold={true}>
function $cdc0d4690fab42ec$var$create_default_slot_2(ctx) {
    let t_value = /*widgetData*/ ctx[0].name + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*widgetData*/ 1 && t_value !== (t_value = /*widgetData*/ ctx[0].name + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (18:1) {#if expanded}
function $cdc0d4690fab42ec$var$create_if_block(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "body",
            $$slots: {
                default: [
                    $cdc0d4690fab42ec$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope, widgetData, layoutTarget*/ 259) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
// (25:4) {:else}
function $cdc0d4690fab42ec$var$create_else_block(ctx) {
    let span;
    return {
        c () {
            span = (0, $1eb80e36873dc327$export$8454457683f90105)("span");
            span.textContent = "Error: The widget that belongs here has an invalid layout group type";
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(span, "color", "#d6536e");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, span, anchor);
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(span);
        }
    };
}
// (23:43) 
function $cdc0d4690fab42ec$var$create_if_block_2(ctx) {
    let widgetsection;
    let current;
    widgetsection = new $cdc0d4690fab42ec$var$WidgetSection({
        props: {
            widgetData: /*layoutGroup*/ ctx[5],
            layoutTarget: /*layoutTarget*/ ctx[1]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetsection.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetsection, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetsection_changes = {};
            if (dirty & /*widgetData*/ 1) widgetsection_changes.widgetData = /*layoutGroup*/ ctx[5];
            if (dirty & /*layoutTarget*/ 2) widgetsection_changes.layoutTarget = /*layoutTarget*/ ctx[1];
            widgetsection.$set(widgetsection_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetsection.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetsection.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetsection, detaching);
        }
    };
}
// (21:4) {#if isWidgetRow(layoutGroup)}
function $cdc0d4690fab42ec$var$create_if_block_1(ctx) {
    let widgetrow;
    let current;
    widgetrow = new (0, $d2a3b2ec06ee963b$export$2e2bcd8739ae039)({
        props: {
            widgetData: /*layoutGroup*/ ctx[5],
            layoutTarget: /*layoutTarget*/ ctx[1]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetrow_changes = {};
            if (dirty & /*widgetData*/ 1) widgetrow_changes.widgetData = /*layoutGroup*/ ctx[5];
            if (dirty & /*layoutTarget*/ 2) widgetrow_changes.layoutTarget = /*layoutTarget*/ ctx[1];
            widgetrow.$set(widgetrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetrow, detaching);
        }
    };
}
// (20:3) {#each widgetData.layout as layoutGroup, index (index)}
function $cdc0d4690fab42ec$var$create_each_block(key_1, ctx) {
    let first;
    let show_if;
    let show_if_1;
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $cdc0d4690fab42ec$var$create_if_block_1,
        $cdc0d4690fab42ec$var$create_if_block_2,
        $cdc0d4690fab42ec$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (dirty & /*widgetData*/ 1) show_if = null;
        if (dirty & /*widgetData*/ 1) show_if_1 = null;
        if (show_if == null) show_if = !!(0, $f7aa31b9879f1252$export$377d9cd95e2858ff)(/*layoutGroup*/ ctx[5]);
        if (show_if) return 0;
        if (show_if_1 == null) show_if_1 = !!(0, $f7aa31b9879f1252$export$aaa5b87bdb9bc054)(/*layoutGroup*/ ctx[5]);
        if (show_if_1) return 1;
        return 2;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (19:2) <LayoutCol class="body">
function $cdc0d4690fab42ec$var$create_default_slot_1(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let each_value = /*widgetData*/ ctx[0].layout;
    const get_key = (ctx)=>/*index*/ ctx[7];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $cdc0d4690fab42ec$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $cdc0d4690fab42ec$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*widgetData, layoutTarget, isWidgetRow, isWidgetSection*/ 3) {
                each_value = /*widgetData*/ ctx[0].layout;
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $cdc0d4690fab42ec$var$create_each_block, each_1_anchor, $cdc0d4690fab42ec$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (13:0) <LayoutCol class="widget-section">
function $cdc0d4690fab42ec$var$create_default_slot(ctx) {
    let button;
    let div;
    let t0;
    let textlabel;
    let t1;
    let if_block_anchor;
    let current;
    let mounted;
    let dispose;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            bold: true,
            $$slots: {
                default: [
                    $cdc0d4690fab42ec$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let if_block = /*expanded*/ ctx[2] && $cdc0d4690fab42ec$var$create_if_block(ctx);
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "expand-arrow");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "class", "header");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", "0");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "expanded", /*expanded*/ ctx[2]);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button, div);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(button, t0);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, button, null);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", (0, $1eb80e36873dc327$export$52770bb39e602159)(/*click_handler*/ ctx[3]));
                mounted = true;
            }
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, widgetData*/ 257) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (!current || dirty & /*expanded*/ 4) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "expanded", /*expanded*/ ctx[2]);
            if (/*expanded*/ ctx[2]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*expanded*/ 4) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $cdc0d4690fab42ec$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
            mounted = false;
            dispose();
        }
    };
}
function $cdc0d4690fab42ec$var$create_fragment(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "widget-section",
            $$slots: {
                default: [
                    $cdc0d4690fab42ec$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope, widgetData, layoutTarget, expanded*/ 263) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
function $cdc0d4690fab42ec$var$instance($$self, $$props, $$invalidate) {
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    let { widgetData: widgetData } = $$props;
    let { layoutTarget: layoutTarget } = $$props;
    let expanded = true;
    const click_handler = ()=>$$invalidate(2, expanded = !expanded);
    $$self.$$set = ($$props)=>{
        if ("widgetData" in $$props) $$invalidate(0, widgetData = $$props.widgetData);
        if ("layoutTarget" in $$props) $$invalidate(1, layoutTarget = $$props.layoutTarget);
    };
    return [
        widgetData,
        layoutTarget,
        expanded,
        click_handler
    ];
}
class $cdc0d4690fab42ec$var$WidgetSection extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $cdc0d4690fab42ec$var$instance, $cdc0d4690fab42ec$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            widgetData: 0,
            layoutTarget: 1
        });
    }
}
var $cdc0d4690fab42ec$export$2e2bcd8739ae039 = $cdc0d4690fab42ec$var$WidgetSection;



function $48763e60decd937b$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[4] = list[i];
    child_ctx[6] = i;
    return child_ctx;
}
// (20:2) {:else}
function $48763e60decd937b$var$create_else_block(ctx) {
    let span;
    return {
        c () {
            span = (0, $1eb80e36873dc327$export$8454457683f90105)("span");
            span.textContent = "Error: The widget row that belongs here has an invalid layout group type";
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(span, "color", "#d6536e");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, span, anchor);
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(span);
        }
    };
}
// (18:41) 
function $48763e60decd937b$var$create_if_block_1(ctx) {
    let widgetsection;
    let current;
    widgetsection = new (0, $cdc0d4690fab42ec$export$2e2bcd8739ae039)({
        props: {
            widgetData: /*layoutGroup*/ ctx[4],
            layoutTarget: /*layout*/ ctx[0].layoutTarget
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetsection.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetsection, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetsection_changes = {};
            if (dirty & /*layout*/ 1) widgetsection_changes.widgetData = /*layoutGroup*/ ctx[4];
            if (dirty & /*layout*/ 1) widgetsection_changes.layoutTarget = /*layout*/ ctx[0].layoutTarget;
            widgetsection.$set(widgetsection_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetsection.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetsection.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetsection, detaching);
        }
    };
}
// (16:2) {#if isWidgetColumn(layoutGroup) || isWidgetRow(layoutGroup)}
function $48763e60decd937b$var$create_if_block(ctx) {
    let widgetrow;
    let current;
    widgetrow = new (0, $d2a3b2ec06ee963b$export$2e2bcd8739ae039)({
        props: {
            widgetData: /*layoutGroup*/ ctx[4],
            layoutTarget: /*layout*/ ctx[0].layoutTarget
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetrow_changes = {};
            if (dirty & /*layout*/ 1) widgetrow_changes.widgetData = /*layoutGroup*/ ctx[4];
            if (dirty & /*layout*/ 1) widgetrow_changes.layoutTarget = /*layout*/ ctx[0].layoutTarget;
            widgetrow.$set(widgetrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetrow, detaching);
        }
    };
}
// (15:1) {#each layout.layout as layoutGroup, index (index)}
function $48763e60decd937b$var$create_each_block(key_1, ctx) {
    let first;
    let show_if;
    let show_if_1;
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $48763e60decd937b$var$create_if_block,
        $48763e60decd937b$var$create_if_block_1,
        $48763e60decd937b$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (dirty & /*layout*/ 1) show_if = null;
        if (dirty & /*layout*/ 1) show_if_1 = null;
        if (show_if == null) show_if = !!((0, $f7aa31b9879f1252$export$b6705411aec0409b)(/*layoutGroup*/ ctx[4]) || (0, $f7aa31b9879f1252$export$377d9cd95e2858ff)(/*layoutGroup*/ ctx[4]));
        if (show_if) return 0;
        if (show_if_1 == null) show_if_1 = !!(0, $f7aa31b9879f1252$export$aaa5b87bdb9bc054)(/*layoutGroup*/ ctx[4]);
        if (show_if_1) return 1;
        return 2;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
function $48763e60decd937b$var$create_fragment(ctx) {
    let div;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let div_class_value;
    let current;
    let each_value = /*layout*/ ctx[0].layout;
    const get_key = (ctx)=>/*index*/ ctx[6];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $48763e60decd937b$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $48763e60decd937b$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value = `widget-layout ${ctx[1]} ${ctx[2]}`.trim());
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (dirty & /*layout, isWidgetColumn, isWidgetRow, isWidgetSection*/ 1) {
                each_value = /*layout*/ ctx[0].layout;
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $48763e60decd937b$var$create_each_block, null, $48763e60decd937b$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (!current || dirty & /*className, extraClasses*/ 6 && div_class_value !== (div_class_value = `widget-layout ${ctx[1]} ${ctx[2]}`.trim())) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value);
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d();
        }
    };
}
function $48763e60decd937b$var$instance($$self, $$props, $$invalidate) {
    let extraClasses;
    let { layout: layout } = $$props;
    let { class: className = "" } = $$props;
    let { classes: classes = {} } = $$props;
    $$self.$$set = ($$props)=>{
        if ("layout" in $$props) $$invalidate(0, layout = $$props.layout);
        if ("class" in $$props) $$invalidate(1, className = $$props.class);
        if ("classes" in $$props) $$invalidate(3, classes = $$props.classes);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*classes*/ 8) $: $$invalidate(2, extraClasses = Object.entries(classes).flatMap((classAndState)=>classAndState[1] ? [
                classAndState[0]
            ] : []).join(" "));
    };
    return [
        layout,
        className,
        extraClasses,
        classes
    ];
}
class $48763e60decd937b$var$WidgetLayout extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $48763e60decd937b$var$instance, $48763e60decd937b$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            layout: 0,
            class: 1,
            classes: 3
        });
    }
}
var $48763e60decd937b$export$2e2bcd8739ae039 = $48763e60decd937b$var$WidgetLayout;


function $f2ca0cbe4ea5b85a$var$create_default_slot_9(ctx) {
    let t_value = /*$dialog*/ ctx[1].title + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$dialog*/ 2 && t_value !== (t_value = /*$dialog*/ ctx[1].title + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (22:1) <LayoutRow class="header-area">
function $f2ca0cbe4ea5b85a$var$create_default_slot_8(ctx) {
    let iconlabel;
    let t;
    let textlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*$dialog*/ ctx[1].icon,
            class: /*$dialog*/ ctx[1].icon.toLowerCase()
        }
    });
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_9
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty & /*$dialog*/ 2) iconlabel_changes.icon = /*$dialog*/ ctx[1].icon;
            if (dirty & /*$dialog*/ 2) iconlabel_changes.class = /*$dialog*/ ctx[1].icon.toLowerCase();
            iconlabel.$set(iconlabel_changes);
            const textlabel_changes = {};
            if (dirty & /*$$scope, $dialog*/ 258) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
        }
    };
}
// (29:3) {#if $dialog.column1.layout.length > 0}
function $f2ca0cbe4ea5b85a$var$create_if_block_4(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$dialog*/ ctx[1].column1,
            class: "details"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty & /*$dialog*/ 2) widgetlayout_changes.layout = /*$dialog*/ ctx[1].column1;
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (32:3) {#if $dialog.panicDetails}
function $f2ca0cbe4ea5b85a$var$create_if_block_3(ctx) {
    let div5;
    let div0;
    let textlabel0;
    let t0;
    let div1;
    let textlabel1;
    let t1;
    let div2;
    let textbutton0;
    let t2;
    let div3;
    let textlabel2;
    let t3;
    let div4;
    let textbutton1;
    let current;
    textlabel0 = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            bold: true,
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_7
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    textlabel1 = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_6
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    textbutton0 = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: "Report Bug",
            icon: "Warning",
            noBackground: true,
            action: /*func*/ ctx[3]
        }
    });
    textlabel2 = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            multiline: true,
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_5
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    textbutton1 = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: "Clear Saved Documents",
            icon: "Trash",
            noBackground: true,
            action: /*func_1*/ ctx[4]
        }
    });
    return {
        c () {
            div5 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton0.$$.fragment);
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div3 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel2.$$.fragment);
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div4 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton1.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "widget-row");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "widget-row");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", "widget-row");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div3, "class", "widget-row");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div4, "class", "widget-row");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div5, "class", "widget-layout details");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div5, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, div0);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel0, div0, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, div1);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel1, div1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, div2);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton0, div2, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, t2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, div3);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel2, div3, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, t3);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div5, div4);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton1, div4, null);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel0_changes = {};
            if (dirty & /*$$scope*/ 256) textlabel0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel0.$set(textlabel0_changes);
            const textlabel1_changes = {};
            if (dirty & /*$$scope*/ 256) textlabel1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel1.$set(textlabel1_changes);
            const textbutton0_changes = {};
            if (dirty & /*$dialog*/ 2) textbutton0_changes.action = /*func*/ ctx[3];
            textbutton0.$set(textbutton0_changes);
            const textlabel2_changes = {};
            if (dirty & /*$$scope*/ 256) textlabel2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel2.$set(textlabel2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel2.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div5);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel2);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton1);
        }
    };
}
// (34:29) <TextLabel bold={true}>
function $f2ca0cbe4ea5b85a$var$create_default_slot_7(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("The editor crashed — sorry about that");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (35:29) <TextLabel>
function $f2ca0cbe4ea5b85a$var$create_default_slot_6(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Please report this by filing an issue on GitHub:");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (37:29) <TextLabel multiline={true}>
function $f2ca0cbe4ea5b85a$var$create_default_slot_5(ctx) {
    let t0;
    let br;
    let t1;
    return {
        c () {
            t0 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Reload the editor to continue. If this occurs");
            br = (0, $1eb80e36873dc327$export$8454457683f90105)("br");
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("immediately on repeated reloads, clear storage:");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, br, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(br);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
        }
    };
}
// (28:2) <LayoutCol class="column-1">
function $f2ca0cbe4ea5b85a$var$create_default_slot_4(ctx) {
    let t;
    let if_block1_anchor;
    let current;
    let if_block0 = /*$dialog*/ ctx[1].column1.layout.length > 0 && $f2ca0cbe4ea5b85a$var$create_if_block_4(ctx);
    let if_block1 = /*$dialog*/ ctx[1].panicDetails && $f2ca0cbe4ea5b85a$var$create_if_block_3(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            if_block1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*$dialog*/ ctx[1].column1.layout.length > 0) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$dialog*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $f2ca0cbe4ea5b85a$var$create_if_block_4(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(t.parentNode, t);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*$dialog*/ ctx[1].panicDetails) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$dialog*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $f2ca0cbe4ea5b85a$var$create_if_block_3(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            current = false;
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block1_anchor);
        }
    };
}
// (52:2) {#if $dialog.column2.layout.length > 0}
function $f2ca0cbe4ea5b85a$var$create_if_block_2(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "column-2",
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope, $dialog*/ 258) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
// (53:3) <LayoutCol class="column-2">
function $f2ca0cbe4ea5b85a$var$create_default_slot_3(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$dialog*/ ctx[1].column2,
            class: "details"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty & /*$dialog*/ 2) widgetlayout_changes.layout = /*$dialog*/ ctx[1].column2;
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (27:1) <LayoutRow class="content">
function $f2ca0cbe4ea5b85a$var$create_default_slot_2(ctx) {
    let layoutcol;
    let t;
    let if_block_anchor;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "column-1",
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let if_block = /*$dialog*/ ctx[1].column2.layout.length > 0 && $f2ca0cbe4ea5b85a$var$create_if_block_2(ctx);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope, $dialog*/ 258) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
            if (/*$dialog*/ ctx[1].column2.layout.length > 0) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*$dialog*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $f2ca0cbe4ea5b85a$var$create_if_block_2(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (59:2) {#if $dialog.buttons.layout.length > 0}
function $f2ca0cbe4ea5b85a$var$create_if_block_1(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$dialog*/ ctx[1].buttons,
            class: "details"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty & /*$dialog*/ 2) widgetlayout_changes.layout = /*$dialog*/ ctx[1].buttons;
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (62:2) {#if $dialog.panicDetails}
function $f2ca0cbe4ea5b85a$var$create_if_block(ctx) {
    let textbutton0;
    let t;
    let textbutton1;
    let current;
    textbutton0 = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: "Copy Error Log",
            action: /*func_2*/ ctx[5]
        }
    });
    textbutton1 = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: "Reload",
            emphasized: true,
            action: /*func_3*/ ctx[6]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textbutton0_changes = {};
            if (dirty & /*$dialog*/ 2) textbutton0_changes.action = /*func_2*/ ctx[5];
            textbutton0.$set(textbutton0_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton1, detaching);
        }
    };
}
// (58:1) <LayoutRow class="footer-area">
function $f2ca0cbe4ea5b85a$var$create_default_slot_1(ctx) {
    let t;
    let if_block1_anchor;
    let current;
    let if_block0 = /*$dialog*/ ctx[1].buttons.layout.length > 0 && $f2ca0cbe4ea5b85a$var$create_if_block_1(ctx);
    let if_block1 = /*$dialog*/ ctx[1].panicDetails && $f2ca0cbe4ea5b85a$var$create_if_block(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            if_block1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*$dialog*/ ctx[1].buttons.layout.length > 0) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$dialog*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $f2ca0cbe4ea5b85a$var$create_if_block_1(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(t.parentNode, t);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*$dialog*/ ctx[1].panicDetails) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$dialog*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                } else {
                    if_block1 = $f2ca0cbe4ea5b85a$var$create_if_block(ctx);
                    if_block1.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1, 1);
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block1);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block1);
            current = false;
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block1_anchor);
        }
    };
}
// (21:0) <FloatingMenu open={true} class="dialog-modal" type="Dialog" direction="Center" bind:this={self} data-dialog-modal>
function $f2ca0cbe4ea5b85a$var$create_default_slot(ctx) {
    let layoutrow0;
    let t0;
    let layoutrow1;
    let t1;
    let layoutrow2;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "header-area",
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_8
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "content",
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow2 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "footer-area",
            $$slots: {
                default: [
                    $f2ca0cbe4ea5b85a$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow2.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow2, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty & /*$$scope, $dialog*/ 258) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty & /*$$scope, $dialog*/ 258) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
            const layoutrow2_changes = {};
            if (dirty & /*$$scope, $dialog*/ 258) layoutrow2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow2.$set(layoutrow2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow2, detaching);
        }
    };
}
function $f2ca0cbe4ea5b85a$var$create_fragment(ctx) {
    let floatingmenu;
    let current;
    let floatingmenu_props = {
        open: true,
        class: "dialog-modal",
        type: "Dialog",
        direction: "Center",
        "data-dialog-modal": true,
        $$slots: {
            default: [
                $f2ca0cbe4ea5b85a$var$create_default_slot
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    floatingmenu = new (0, $ef66a8e69d2c44ad$export$2e2bcd8739ae039)({
        props: floatingmenu_props
    });
    /*floatingmenu_binding*/ ctx[7](floatingmenu);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(floatingmenu.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(floatingmenu, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const floatingmenu_changes = {};
            if (dirty & /*$$scope, $dialog*/ 258) floatingmenu_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            floatingmenu.$set(floatingmenu_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(floatingmenu.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(floatingmenu.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*floatingmenu_binding*/ ctx[7](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(floatingmenu, detaching);
        }
    };
}
function $f2ca0cbe4ea5b85a$var$instance($$self, $$props, $$invalidate) {
    let $dialog;
    const dialog = (0, $1eb80e36873dc327$export$31553aaa555c1514)("dialog");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, dialog, (value)=>$$invalidate(1, $dialog = value));
    let self;
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        // Focus the button which is marked as emphasized, or otherwise the first button, in the popup
        const emphasizedOrFirstButton = self?.div()?.querySelector("[data-emphasized]") || self?.div()?.querySelector("[data-text-button]") || undefined;
        emphasizedOrFirstButton?.focus();
    });
    const func = ()=>window.open((0, $945a093b2ba443fe$export$1efe58927fe9d27a)($dialog.panicDetails), "_blank");
    const func_1 = async ()=>{
        await (0, $ed258b5c0b4a06bc$export$958a88f5eb002229)();
        window.location.reload();
    };
    const func_2 = ()=>navigator.clipboard.writeText($dialog.panicDetails);
    const func_3 = ()=>window.location.reload();
    function floatingmenu_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            self = $$value;
            $$invalidate(0, self);
        });
    }
    return [
        self,
        $dialog,
        dialog,
        func,
        func_1,
        func_2,
        func_3,
        floatingmenu_binding
    ];
}
class $f2ca0cbe4ea5b85a$var$DialogModal extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $f2ca0cbe4ea5b85a$var$instance, $f2ca0cbe4ea5b85a$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $f2ca0cbe4ea5b85a$export$2e2bcd8739ae039 = $f2ca0cbe4ea5b85a$var$DialogModal;




/* src/components/window/workspace/Panel.svelte generated by Svelte v3.58.0 */ 

/* src/components/panels/Properties.svelte generated by Svelte v3.58.0 */ 





function $402556087db61ff7$var$create_default_slot_2(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*propertiesOptionsLayout*/ ctx[0]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty & /*propertiesOptionsLayout*/ 1) widgetlayout_changes.layout = /*propertiesOptionsLayout*/ ctx[0];
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (25:1) <LayoutRow class="sections" scrollableY={true}>
function $402556087db61ff7$var$create_default_slot_1(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*propertiesSectionsLayout*/ ctx[1]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty & /*propertiesSectionsLayout*/ 2) widgetlayout_changes.layout = /*propertiesSectionsLayout*/ ctx[1];
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (21:0) <LayoutCol class="properties">
function $402556087db61ff7$var$create_default_slot(ctx) {
    let layoutrow0;
    let t;
    let layoutrow1;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "options-bar",
            $$slots: {
                default: [
                    $402556087db61ff7$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "sections",
            scrollableY: true,
            $$slots: {
                default: [
                    $402556087db61ff7$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty & /*$$scope, propertiesOptionsLayout*/ 9) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty & /*$$scope, propertiesSectionsLayout*/ 10) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
        }
    };
}
function $402556087db61ff7$var$create_fragment(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "properties",
            $$slots: {
                default: [
                    $402556087db61ff7$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope, propertiesSectionsLayout, propertiesOptionsLayout*/ 11) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
function $402556087db61ff7$var$instance($$self, $$props, $$invalidate) {
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    let propertiesOptionsLayout = (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)();
    let propertiesSectionsLayout = (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)();
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$3032c74f2970310c), (updatePropertyPanelOptionsLayout)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(propertiesOptionsLayout, updatePropertyPanelOptionsLayout);
            $$invalidate(0, propertiesOptionsLayout);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$256d73496980c381), (updatePropertyPanelSectionsLayout)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(propertiesSectionsLayout, updatePropertyPanelSectionsLayout);
            $$invalidate(1, propertiesSectionsLayout);
        });
    });
    return [
        propertiesOptionsLayout,
        propertiesSectionsLayout
    ];
}
class $402556087db61ff7$var$Properties extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $402556087db61ff7$var$instance, $402556087db61ff7$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $402556087db61ff7$export$2e2bcd8739ae039 = $402556087db61ff7$var$Properties;



/* src/components/panels/LayerTree.svelte generated by Svelte v3.58.0 */ 









const { Map: $9704670796641993$var$Map_1 } = (0, $1eb80e36873dc327$export$816be348776d53c1);
function $9704670796641993$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[39] = list[i];
    child_ctx[41] = i;
    return child_ctx;
}
// (246:1) <LayoutRow class="options-bar" scrollableX={true}>
function $9704670796641993$var$create_default_slot_8(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*layerTreeOptionsLayout*/ ctx[6]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty[0] & /*layerTreeOptionsLayout*/ 64) widgetlayout_changes.layout = /*layerTreeOptionsLayout*/ ctx[6];
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (258:5) <LayoutRow class="visibility">
function $9704670796641993$var$create_default_slot_7(ctx) {
    let iconbutton;
    let current;
    function func(...args) {
        return /*func*/ ctx[18](/*listing*/ ctx[39], ...args);
    }
    iconbutton = new (0, $47cbcd4715b3f848$export$2e2bcd8739ae039)({
        props: {
            action: func,
            size: 24,
            icon: /*listing*/ ctx[39].entry.visible ? "EyeVisible" : "EyeHidden",
            tooltip: /*listing*/ ctx[39].entry.visible ? "Visible" : "Hidden"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconbutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const iconbutton_changes = {};
            if (dirty[0] & /*layers*/ 2) iconbutton_changes.action = func;
            if (dirty[0] & /*layers*/ 2) iconbutton_changes.icon = /*listing*/ ctx[39].entry.visible ? "EyeVisible" : "EyeHidden";
            if (dirty[0] & /*layers*/ 2) iconbutton_changes.tooltip = /*listing*/ ctx[39].entry.visible ? "Visible" : "Hidden";
            iconbutton.$set(iconbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconbutton, detaching);
        }
    };
}
// (269:5) {#if listing.entry.layerType === "Folder"}
function $9704670796641993$var$create_if_block_1(ctx) {
    let button;
    let mounted;
    let dispose;
    function click_handler() {
        return /*click_handler*/ ctx[19](/*listing*/ ctx[39]);
    }
    return {
        c () {
            button = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "class", "expand-arrow");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button, "tabindex", "0");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "expanded", /*listing*/ ctx[39].entry.layerMetadata.expanded);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, button, anchor);
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button, "click", (0, $1eb80e36873dc327$export$52770bb39e602159)(click_handler));
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty[0] & /*layers*/ 2) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(button, "expanded", /*listing*/ ctx[39].entry.layerMetadata.expanded);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(button);
            mounted = false;
            dispose();
        }
    };
}
// (284:6) <LayoutRow class="layer-type-icon">
function $9704670796641993$var$create_default_slot_6(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: /*listing*/ ctx[39].entry.layerType || "Info"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const iconlabel_changes = {};
            if (dirty[0] & /*layers*/ 2) iconlabel_changes.icon = /*listing*/ ctx[39].entry.layerType || "Info";
            iconlabel.$set(iconlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (287:6) <LayoutRow class="layer-name" on:dblclick={() => onEditLayerName(listing)}>
function $9704670796641993$var$create_default_slot_5(ctx) {
    let input;
    let input_value_value;
    let input_placeholder_value;
    let input_disabled_value;
    let mounted;
    let dispose;
    function blur_handler() {
        return /*blur_handler*/ ctx[20](/*listing*/ ctx[39]);
    }
    function keydown_handler(...args) {
        return /*keydown_handler*/ ctx[21](/*listing*/ ctx[39], ...args);
    }
    function keydown_handler_1(...args) {
        return /*keydown_handler_1*/ ctx[22](/*listing*/ ctx[39], ...args);
    }
    function change_handler(...args) {
        return /*change_handler*/ ctx[23](/*listing*/ ctx[39], ...args);
    }
    return {
        c () {
            input = (0, $1eb80e36873dc327$export$8454457683f90105)("input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "data-text-input", "");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "type", "text");
            input.value = input_value_value = /*listing*/ ctx[39].entry.name;
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "placeholder", input_placeholder_value = `Untitled ${ctx[39].entry.layerType || "[Unknown Layer Type]"}`);
            input.disabled = input_disabled_value = !/*listing*/ ctx[39].editingName;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, input, anchor);
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "blur", blur_handler),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "keydown", keydown_handler),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "keydown", keydown_handler_1),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(input, "change", change_handler)
                ];
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty[0] & /*layers*/ 2 && input_value_value !== (input_value_value = /*listing*/ ctx[39].entry.name) && input.value !== input_value_value) input.value = input_value_value;
            if (dirty[0] & /*layers*/ 2 && input_placeholder_value !== (input_placeholder_value = `Untitled ${ctx[39].entry.layerType || "[Unknown Layer Type]"}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(input, "placeholder", input_placeholder_value);
            if (dirty[0] & /*layers*/ 2 && input_disabled_value !== (input_disabled_value = !/*listing*/ ctx[39].editingName)) input.disabled = input_disabled_value;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(input);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
// (272:5) <LayoutRow       class="layer"       classes={{        selected: fakeHighlight ? fakeHighlight.includes(listing.entry.path) : listing.entry.layerMetadata.selected,       }}       data-layer={String(listing.entry.path)}       data-index={index}       tooltip={listing.entry.tooltip}       {draggable}       on:dragstart={(e) => draggable && dragStart(e, listing)}       on:click={(e) => selectLayerWithModifiers(e, listing)}      >
function $9704670796641993$var$create_default_slot_4(ctx) {
    let layoutrow0;
    let t0;
    let layoutrow1;
    let t1;
    let div;
    let raw_value = /*listing*/ ctx[39].entry.thumbnail + "";
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "layer-type-icon",
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot_6
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    function dblclick_handler() {
        return /*dblclick_handler*/ ctx[24](/*listing*/ ctx[39]);
    }
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "layer-name",
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot_5
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1.$on("dblclick", dblclick_handler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "thumbnail");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            div.innerHTML = raw_value;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const layoutrow0_changes = {};
            if (dirty[0] & /*layers*/ 2 | dirty[1] & /*$$scope*/ 2048) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty[0] & /*layers*/ 2 | dirty[1] & /*$$scope*/ 2048) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
            if ((!current || dirty[0] & /*layers*/ 2) && raw_value !== (raw_value = /*listing*/ ctx[39].entry.thumbnail + "")) div.innerHTML = raw_value;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (252:4) <LayoutRow      class="layer-row"      classes={{       "insert-folder": (draggingData?.highlightFolder || false) && draggingData?.insertFolder === listing.entry.path,      }}     >
function $9704670796641993$var$create_default_slot_3(ctx) {
    let layoutrow0;
    let t0;
    let div;
    let t1;
    let t2;
    let layoutrow1;
    let t3;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "visibility",
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot_7
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let if_block = /*listing*/ ctx[39].entry.layerType === "Folder" && $9704670796641993$var$create_if_block_1(ctx);
    function dragstart_handler(...args) {
        return /*dragstart_handler*/ ctx[25](/*listing*/ ctx[39], ...args);
    }
    function click_handler_1(...args) {
        return /*click_handler_1*/ ctx[26](/*listing*/ ctx[39], ...args);
    }
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "layer",
            classes: {
                selected: /*fakeHighlight*/ ctx[4] ? /*fakeHighlight*/ ctx[4].includes(/*listing*/ ctx[39].entry.path) : /*listing*/ ctx[39].entry.layerMetadata.selected
            },
            "data-layer": String(/*listing*/ ctx[39].entry.path),
            "data-index": /*index*/ ctx[41],
            tooltip: /*listing*/ ctx[39].entry.tooltip,
            draggable: /*draggable*/ ctx[2],
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot_4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1.$on("dragstart", dragstart_handler);
    layoutrow1.$on("click", click_handler_1);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block) if_block.c();
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "indent");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "margin-left", $9704670796641993$var$layerIndent(/*listing*/ ctx[39].entry));
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t2, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t3, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const layoutrow0_changes = {};
            if (dirty[0] & /*layers*/ 2 | dirty[1] & /*$$scope*/ 2048) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            if (dirty[0] & /*layers*/ 2) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "margin-left", $9704670796641993$var$layerIndent(/*listing*/ ctx[39].entry));
            if (/*listing*/ ctx[39].entry.layerType === "Folder") {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $9704670796641993$var$create_if_block_1(ctx);
                    if_block.c();
                    if_block.m(t2.parentNode, t2);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            const layoutrow1_changes = {};
            if (dirty[0] & /*fakeHighlight, layers*/ 18) layoutrow1_changes.classes = {
                selected: /*fakeHighlight*/ ctx[4] ? /*fakeHighlight*/ ctx[4].includes(/*listing*/ ctx[39].entry.path) : /*listing*/ ctx[39].entry.layerMetadata.selected
            };
            if (dirty[0] & /*layers*/ 2) layoutrow1_changes["data-layer"] = String(/*listing*/ ctx[39].entry.path);
            if (dirty[0] & /*layers*/ 2) layoutrow1_changes["data-index"] = /*index*/ ctx[41];
            if (dirty[0] & /*layers*/ 2) layoutrow1_changes.tooltip = /*listing*/ ctx[39].entry.tooltip;
            if (dirty[0] & /*draggable*/ 4) layoutrow1_changes.draggable = /*draggable*/ ctx[2];
            if (dirty[0] & /*layers*/ 2 | dirty[1] & /*$$scope*/ 2048) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t2);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t3);
        }
    };
}
// (251:3) {#each layers as listing, index (String(listing.entry.path.slice(-1)))}
function $9704670796641993$var$create_each_block(key_1, ctx) {
    let first;
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "layer-row",
            classes: {
                "insert-folder": /*draggingData*/ (ctx[3]?.highlightFolder || false) && /*draggingData*/ ctx[3]?.insertFolder === /*listing*/ ctx[39].entry.path
            },
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const layoutrow_changes = {};
            if (dirty[0] & /*draggingData, layers*/ 10) layoutrow_changes.classes = {
                "insert-folder": /*draggingData*/ (ctx[3]?.highlightFolder || false) && /*draggingData*/ ctx[3]?.insertFolder === /*listing*/ ctx[39].entry.path
            };
            if (dirty[0] & /*fakeHighlight, layers, draggable*/ 22 | dirty[1] & /*$$scope*/ 2048) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (250:2) <LayoutCol class="list" bind:this={list} on:click={() => deselectAllLayers()} on:dragover={(e) => draggable && updateInsertLine(e)} on:dragend={() => draggable && drop()}>
function $9704670796641993$var$create_default_slot_2(ctx) {
    let each_blocks = [];
    let each_1_lookup = new $9704670796641993$var$Map_1();
    let each_1_anchor;
    let current;
    let each_value = /*layers*/ ctx[1];
    const get_key = (ctx)=>String(/*listing*/ ctx[39].entry.path.slice(-1));
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $9704670796641993$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $9704670796641993$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty[0] & /*draggingData, layers, fakeHighlight, draggable, dragStart, selectLayerWithModifiers, onEditLayerName, onEditLayerNameDeselect, onEditLayerNameChange, handleExpandArrowClick, toggleLayerVisibility*/ 48926) {
                each_value = /*layers*/ ctx[1];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $9704670796641993$var$create_each_block, each_1_anchor, $9704670796641993$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (307:2) {#if draggingData && !draggingData.highlightFolder && dragInPanel}
function $9704670796641993$var$create_if_block(ctx) {
    let div;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "insert-mark");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "left", /*markIndent*/ ctx[7](/*draggingData*/ ctx[3].insertFolder));
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", $9704670796641993$var$markTopOffset(/*draggingData*/ ctx[3].markerHeight));
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*draggingData*/ 8) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "left", /*markIndent*/ ctx[7](/*draggingData*/ ctx[3].insertFolder));
            if (dirty[0] & /*draggingData*/ 8) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "top", $9704670796641993$var$markTopOffset(/*draggingData*/ ctx[3].markerHeight));
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
        }
    };
}
// (249:1) <LayoutRow class="layer-tree-rows" scrollableY={true}>
function $9704670796641993$var$create_default_slot_1(ctx) {
    let layoutcol;
    let t;
    let if_block_anchor;
    let current;
    let layoutcol_props = {
        class: "list",
        $$slots: {
            default: [
                $9704670796641993$var$create_default_slot_2
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: layoutcol_props
    });
    /*layoutcol_binding*/ ctx[27](layoutcol);
    layoutcol.$on("click", /*click_handler_2*/ ctx[28]);
    layoutcol.$on("dragover", /*dragover_handler*/ ctx[29]);
    layoutcol.$on("dragend", /*dragend_handler*/ ctx[30]);
    let if_block = /*draggingData*/ ctx[3] && !/*draggingData*/ ctx[3].highlightFolder && /*dragInPanel*/ ctx[5] && $9704670796641993$var$create_if_block(ctx);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty[0] & /*layers, draggingData, fakeHighlight, draggable*/ 30 | dirty[1] & /*$$scope*/ 2048) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
            if (/*draggingData*/ ctx[3] && !/*draggingData*/ ctx[3].highlightFolder && /*dragInPanel*/ ctx[5]) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $9704670796641993$var$create_if_block(ctx);
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*layoutcol_binding*/ ctx[27](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (245:0) <LayoutCol class="layer-tree" on:dragleave={() => (dragInPanel = false)}>
function $9704670796641993$var$create_default_slot(ctx) {
    let layoutrow0;
    let t;
    let layoutrow1;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "options-bar",
            scrollableX: true,
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot_8
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "layer-tree-rows",
            scrollableY: true,
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty[0] & /*layerTreeOptionsLayout*/ 64 | dirty[1] & /*$$scope*/ 2048) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty[0] & /*draggingData, dragInPanel, list, draggable, layers, fakeHighlight*/ 63 | dirty[1] & /*$$scope*/ 2048) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
        }
    };
}
function $9704670796641993$var$create_fragment(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "layer-tree",
            $$slots: {
                default: [
                    $9704670796641993$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol.$on("dragleave", /*dragleave_handler*/ ctx[31]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty[0] & /*draggingData, dragInPanel, list, draggable, layers, fakeHighlight, layerTreeOptionsLayout*/ 127 | dirty[1] & /*$$scope*/ 2048) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
const $9704670796641993$var$RANGE_TO_INSERT_WITHIN_BOTTOM_FOLDER_NOT_ROOT = 20;
const $9704670796641993$var$LAYER_INDENT = 16;
const $9704670796641993$var$INSERT_MARK_OFFSET = 2;
function $9704670796641993$var$layerIndent(layer) {
    return `${layer.path.length * $9704670796641993$var$LAYER_INDENT}px`;
}
function $9704670796641993$var$markTopOffset(height) {
    return `${height}px`;
}
function $9704670796641993$var$instance($$self, $$props, $$invalidate) {
    let list;
    const INSERT_MARK_MARGIN_LEFT = 36 + $9704670796641993$var$LAYER_INDENT;
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    // Layer data
    let layerCache = new Map(); // TODO: replace with BigUint64Array as index
    let layers = [];
    // Interactive dragging
    let draggable = true;
    let draggingData = undefined;
    let fakeHighlight = undefined;
    let dragInPanel = false;
    // Layouts
    let layerTreeOptionsLayout = (0, $f7aa31b9879f1252$export$16fc69c1586bf13b)();
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$d18082b89eeb3cd), (updateLayerTreeOptionsLayout)=>{
            (0, $f7aa31b9879f1252$export$34fe634dd7362991)(layerTreeOptionsLayout, updateLayerTreeOptionsLayout);
            $$invalidate(6, layerTreeOptionsLayout);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$2a896f077f253590), (updateDocumentLayerTreeStructure)=>{
            rebuildLayerTree(updateDocumentLayerTreeStructure);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$52bcad66918d81d4), (updateDocumentLayerDetails)=>{
            const targetLayer = updateDocumentLayerDetails.data;
            const targetPath = targetLayer.path;
            updateLayerInTree(targetPath, targetLayer);
        });
    });
    function markIndent(path) {
        return `${INSERT_MARK_MARGIN_LEFT + path.length * $9704670796641993$var$LAYER_INDENT}px`;
    }
    function toggleLayerVisibility(path) {
        editor.instance.toggleLayerVisibility(path);
    }
    function handleExpandArrowClick(path) {
        editor.instance.toggleLayerExpansion(path);
    }
    async function onEditLayerName(listing) {
        if (listing.editingName) return;
        $$invalidate(2, draggable = false);
        listing.editingName = true;
        $$invalidate(1, layers);
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        const textInput = list?.div()?.querySelector("[data-text-input]:not([disabled])") || undefined;
        textInput?.select();
    }
    function onEditLayerNameChange(listing, e) {
        // Eliminate duplicate events
        if (!listing.editingName) return;
        $$invalidate(2, draggable = true);
        const name = e.target?.value;
        listing.editingName = false;
        $$invalidate(1, layers);
        if (name) editor.instance.setLayerName(listing.entry.path, name);
    }
    async function onEditLayerNameDeselect(listing) {
        $$invalidate(2, draggable = true);
        listing.editingName = false;
        $$invalidate(1, layers);
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        window.getSelection()?.removeAllRanges();
    }
    function selectLayerWithModifiers(e, listing) {
        // Get the pressed state of the modifier keys
        const [ctrl, meta, shift, alt] = [
            e.ctrlKey,
            e.metaKey,
            e.shiftKey,
            e.altKey
        ];
        // Get the state of the platform's accel key and its opposite platform's accel key
        const [accel, oppositeAccel] = (0, $7ed52b8c7c886783$export$f205d53822e9a9a9)() ? [
            meta,
            ctrl
        ] : [
            ctrl,
            meta
        ];
        // Select the layer only if the accel and/or shift keys are pressed
        if (!oppositeAccel && !alt) selectLayer(accel, shift, listing);
        e.stopPropagation();
    }
    function selectLayer(accel, shift, listing) {
        // Don't select while we are entering text to rename the layer
        if (listing.editingName) return;
        editor.instance.selectLayer(listing.entry.path, accel, shift);
    }
    async function deselectAllLayers() {
        editor.instance.deselectAllLayers();
    }
    function calculateDragIndex(tree, clientY, select) {
        const treeChildren = tree.div()?.children;
        const treeOffset = tree.div()?.getBoundingClientRect().top;
        // Closest distance to the middle of the row along the Y axis
        let closest = Infinity;
        // Folder to insert into
        let insertFolder = new BigUint64Array();
        // Insert index
        let insertIndex = -1;
        // Whether you are inserting into a folder and should show the folder outline
        let highlightFolder = false;
        let markerHeight = 0;
        let previousHeight = undefined;
        if (treeChildren !== undefined && treeOffset !== undefined) Array.from(treeChildren).forEach((treeChild, index)=>{
            const layerComponents = treeChild.getElementsByClassName("layer");
            if (layerComponents.length !== 1) return;
            const child = layerComponents[0];
            const indexAttribute = child.getAttribute("data-index");
            if (!indexAttribute) return;
            const { folderIndex: folderIndex, entry: layer } = layers[parseInt(indexAttribute, 10)];
            const rect = child.getBoundingClientRect();
            const position = rect.top + rect.height / 2;
            const distance = position - clientY;
            // Inserting above current row
            if (distance > 0 && distance < closest) {
                insertFolder = layer.path.slice(0, layer.path.length - 1);
                insertIndex = folderIndex;
                highlightFolder = false;
                closest = distance;
                markerHeight = previousHeight || treeOffset + $9704670796641993$var$INSERT_MARK_OFFSET;
            } else if (distance > -closest && distance > -$9704670796641993$var$RANGE_TO_INSERT_WITHIN_BOTTOM_FOLDER_NOT_ROOT && distance < 0) {
                insertFolder = layer.layerType === "Folder" ? layer.path : layer.path.slice(0, layer.path.length - 1);
                insertIndex = layer.layerType === "Folder" ? 0 : folderIndex + 1;
                highlightFolder = layer.layerType === "Folder";
                closest = -distance;
                markerHeight = index === treeChildren.length - 1 ? rect.bottom - $9704670796641993$var$INSERT_MARK_OFFSET : rect.bottom;
            } else if (closest === Infinity) {
                if (layer.path.length === 1) insertIndex = folderIndex + 1;
                markerHeight = rect.bottom - $9704670796641993$var$INSERT_MARK_OFFSET;
            }
            previousHeight = rect.bottom;
        });
        markerHeight -= treeOffset || 0;
        return {
            select: select,
            insertFolder: insertFolder,
            insertIndex: insertIndex,
            highlightFolder: highlightFolder,
            markerHeight: markerHeight
        };
    }
    async function dragStart(event, listing) {
        const layer = listing.entry;
        $$invalidate(5, dragInPanel = true);
        if (!layer.layerMetadata.selected) $$invalidate(4, fakeHighlight = [
            layer.path
        ]);
        const select = ()=>{
            if (!layer.layerMetadata.selected) selectLayer(false, false, listing);
        };
        const target = event.target || undefined;
        const draggingELement = target?.closest("[data-layer]") || undefined;
        if (draggingELement) (0, $b6b56b6b4021e3fb$export$915caa8a10b5a3da)(draggingELement);
        // Set style of cursor for drag
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = "move";
            event.dataTransfer.effectAllowed = "move";
        }
        if (list) $$invalidate(3, draggingData = calculateDragIndex(list, event.clientY, select));
    }
    function updateInsertLine(event) {
        // Stop the drag from being shown as cancelled
        event.preventDefault();
        $$invalidate(5, dragInPanel = true);
        if (list) $$invalidate(3, draggingData = calculateDragIndex(list, event.clientY, draggingData?.select));
    }
    async function drop() {
        if (draggingData && dragInPanel) {
            const { select: select, insertFolder: insertFolder, insertIndex: insertIndex } = draggingData;
            select?.();
            editor.instance.moveLayerInTree(insertFolder, insertIndex);
        }
        $$invalidate(3, draggingData = undefined);
        $$invalidate(4, fakeHighlight = undefined);
        $$invalidate(5, dragInPanel = false);
    }
    function rebuildLayerTree(updateDocumentLayerTreeStructure) {
        const layerWithNameBeingEdited = layers.find((layer)=>layer.editingName);
        const layerPathWithNameBeingEdited = layerWithNameBeingEdited?.entry.path;
        const layerIdWithNameBeingEdited = layerPathWithNameBeingEdited?.slice(-1)[0];
        const path = [];
        // Clear the layer tree before rebuilding it
        $$invalidate(1, layers = []);
        // Build the new layer tree
        const recurse = (folder)=>{
            folder.children.forEach((item, index)=>{
                // TODO: fix toString
                const layerId = BigInt(item.layerId.toString());
                path.push(layerId);
                const mapping = layerCache.get([
                    path[path.length - 1]
                ].toString());
                if (mapping) {
                    mapping.layerType = item.children.length >= 1 ? "Folder" : "Layer";
                    mapping.path = new BigUint64Array(path);
                    layers.push({
                        folderIndex: index,
                        bottomLayer: index === folder.children.length - 1,
                        entry: mapping,
                        editingName: layerIdWithNameBeingEdited === layerId
                    });
                }
                // Call self recursively if there are any children
                if (item.children.length >= 1) recurse(item);
                path.pop();
            });
        };
        recurse(updateDocumentLayerTreeStructure);
        $$invalidate(1, layers);
    }
    function updateLayerInTree(targetPath, targetLayer) {
        const path = targetPath.toString();
        layerCache.set(path, targetLayer);
        const layer = layers.find((layer)=>layer.entry.path.toString() === path);
        if (layer) {
            layer.entry = targetLayer;
            $$invalidate(1, layers);
        }
    }
    const func = (listing, e)=>(toggleLayerVisibility(listing.entry.path), e?.stopPropagation());
    const click_handler = (listing)=>handleExpandArrowClick(listing.entry.path);
    const blur_handler = (listing)=>onEditLayerNameDeselect(listing);
    const keydown_handler = (listing, e)=>e.key === "Escape" && onEditLayerNameDeselect(listing);
    const keydown_handler_1 = (listing, e)=>e.key === "Enter" && onEditLayerNameChange(listing, e);
    const change_handler = (listing, e)=>onEditLayerNameChange(listing, e);
    const dblclick_handler = (listing)=>onEditLayerName(listing);
    const dragstart_handler = (listing, e)=>draggable && dragStart(e, listing);
    const click_handler_1 = (listing, e)=>selectLayerWithModifiers(e, listing);
    function layoutcol_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            list = $$value;
            $$invalidate(0, list);
        });
    }
    const click_handler_2 = ()=>deselectAllLayers();
    const dragover_handler = (e)=>draggable && updateInsertLine(e);
    const dragend_handler = ()=>draggable && drop();
    const dragleave_handler = ()=>$$invalidate(5, dragInPanel = false);
    return [
        list,
        layers,
        draggable,
        draggingData,
        fakeHighlight,
        dragInPanel,
        layerTreeOptionsLayout,
        markIndent,
        toggleLayerVisibility,
        handleExpandArrowClick,
        onEditLayerName,
        onEditLayerNameChange,
        onEditLayerNameDeselect,
        selectLayerWithModifiers,
        deselectAllLayers,
        dragStart,
        updateInsertLine,
        drop,
        func,
        click_handler,
        blur_handler,
        keydown_handler,
        keydown_handler_1,
        change_handler,
        dblclick_handler,
        dragstart_handler,
        click_handler_1,
        layoutcol_binding,
        click_handler_2,
        dragover_handler,
        dragend_handler,
        dragleave_handler
    ];
}
class $9704670796641993$var$LayerTree extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $9704670796641993$var$instance, $9704670796641993$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {}, null, [
            -1,
            -1
        ]);
    }
}
var $9704670796641993$export$2e2bcd8739ae039 = $9704670796641993$var$LayerTree;



/* src/components/panels/Document.svelte generated by Svelte v3.58.0 */ 




/* src/components/floating-menus/EyedropperPreview.svelte generated by Svelte v3.58.0 */ 


function $a442d3020821b0e2$var$create_default_slot(ctx) {
    let div2;
    let div1;
    let canvas;
    let t;
    let div0;
    return {
        c () {
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            canvas = (0, $1eb80e36873dc327$export$8454457683f90105)("canvas");
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(canvas, "width", $a442d3020821b0e2$export$37b1deb98cc11f7b);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(canvas, "height", $a442d3020821b0e2$export$37b1deb98cc11f7b);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "pixel-outline");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "canvas-container");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", "ring");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div2, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, div1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, canvas);
            /*canvas_binding*/ ctx[7](canvas);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, div0);
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div2);
            /*canvas_binding*/ ctx[7](null);
        }
    };
}
function $a442d3020821b0e2$var$create_fragment(ctx) {
    let floatingmenu;
    let current;
    floatingmenu = new (0, $ef66a8e69d2c44ad$export$2e2bcd8739ae039)({
        props: {
            open: true,
            class: "eyedropper-preview",
            type: "Cursor",
            styles: {
                "--ring-color-primary": /*primaryColor*/ ctx[1],
                "--ring-color-secondary": /*secondaryColor*/ ctx[2],
                "--ring-color-choice": /*colorChoice*/ ctx[0],
                left: /*x*/ ctx[3] + "px",
                top: /*y*/ ctx[4] + "px"
            },
            $$slots: {
                default: [
                    $a442d3020821b0e2$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(floatingmenu.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(floatingmenu, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const floatingmenu_changes = {};
            if (dirty & /*primaryColor, secondaryColor, colorChoice, x, y*/ 31) floatingmenu_changes.styles = {
                "--ring-color-primary": /*primaryColor*/ ctx[1],
                "--ring-color-secondary": /*secondaryColor*/ ctx[2],
                "--ring-color-choice": /*colorChoice*/ ctx[0],
                left: /*x*/ ctx[3] + "px",
                top: /*y*/ ctx[4] + "px"
            };
            if (dirty & /*$$scope, zoomPreviewCanvas*/ 1056) floatingmenu_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            floatingmenu.$set(floatingmenu_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(floatingmenu.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(floatingmenu.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(floatingmenu, detaching);
        }
    };
}
const $a442d3020821b0e2$var$ZOOM_WINDOW_DIMENSIONS_EXPANDED = 110;
// Should be equal to the width and height of the `.pixel-outline` div in the CSS, and should be evenly divisible into the number above
const $a442d3020821b0e2$var$UPSCALE_FACTOR = 10;
const $a442d3020821b0e2$export$37b1deb98cc11f7b = $a442d3020821b0e2$var$ZOOM_WINDOW_DIMENSIONS_EXPANDED / $a442d3020821b0e2$var$UPSCALE_FACTOR;
function $a442d3020821b0e2$var$instance($$self, $$props, $$invalidate) {
    const temporaryCanvas = document.createElement("canvas");
    temporaryCanvas.width = $a442d3020821b0e2$export$37b1deb98cc11f7b;
    temporaryCanvas.height = $a442d3020821b0e2$export$37b1deb98cc11f7b;
    let zoomPreviewCanvas;
    let { imageData: imageData } = $$props;
    let { colorChoice: colorChoice } = $$props;
    let { primaryColor: primaryColor } = $$props;
    let { secondaryColor: secondaryColor } = $$props;
    let { x: x } = $$props;
    let { y: y } = $$props;
    function displayImageDataPreview(imageData) {
        if (!zoomPreviewCanvas) return;
        const context = zoomPreviewCanvas.getContext("2d");
        const temporaryContext = temporaryCanvas.getContext("2d");
        if (!imageData || !context || !temporaryContext) return;
        temporaryContext.putImageData(imageData, 0, 0, 0, 0, $a442d3020821b0e2$export$37b1deb98cc11f7b, $a442d3020821b0e2$export$37b1deb98cc11f7b);
        context.fillStyle = "black";
        context.fillRect(0, 0, $a442d3020821b0e2$export$37b1deb98cc11f7b, $a442d3020821b0e2$export$37b1deb98cc11f7b);
        context.drawImage(temporaryCanvas, 0, 0);
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        displayImageDataPreview(imageData);
    });
    function canvas_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            zoomPreviewCanvas = $$value;
            $$invalidate(5, zoomPreviewCanvas);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("imageData" in $$props) $$invalidate(6, imageData = $$props.imageData);
        if ("colorChoice" in $$props) $$invalidate(0, colorChoice = $$props.colorChoice);
        if ("primaryColor" in $$props) $$invalidate(1, primaryColor = $$props.primaryColor);
        if ("secondaryColor" in $$props) $$invalidate(2, secondaryColor = $$props.secondaryColor);
        if ("x" in $$props) $$invalidate(3, x = $$props.x);
        if ("y" in $$props) $$invalidate(4, y = $$props.y);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*imageData*/ 64) $: displayImageDataPreview(imageData);
    };
    return [
        colorChoice,
        primaryColor,
        secondaryColor,
        x,
        y,
        zoomPreviewCanvas,
        imageData,
        canvas_binding
    ];
}
class $a442d3020821b0e2$var$EyedropperPreview extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $a442d3020821b0e2$var$instance, $a442d3020821b0e2$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            imageData: 6,
            colorChoice: 0,
            primaryColor: 1,
            secondaryColor: 2,
            x: 3,
            y: 4
        });
    }
}
var $a442d3020821b0e2$export$2e2bcd8739ae039 = $a442d3020821b0e2$var$EyedropperPreview;




/* src/components/views/Graph.svelte generated by Svelte v3.58.0 */ 







const { Boolean: $2af2864a5b707c5b$var$Boolean_1, Map: $2af2864a5b707c5b$var$Map_1 } = (0, $1eb80e36873dc327$export$816be348776d53c1);
function $2af2864a5b707c5b$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[48] = list[i];
    const constants_0 = [
        .../*node*/ child_ctx[48].exposedInputs,
        .../*node*/ child_ctx[48].exposedOutputs
    ];
    child_ctx[49] = constants_0;
    const constants_1 = `${Math.random()}`.substring(2);
    child_ctx[50] = constants_1;
    return child_ctx;
}
function $2af2864a5b707c5b$var$get_each_context_1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[53] = list[i];
    return child_ctx;
}
function $2af2864a5b707c5b$var$get_each_context_2(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[53] = list[i];
    child_ctx[57] = i;
    return child_ctx;
}
function $2af2864a5b707c5b$var$get_each_context_3(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[53] = list[i];
    child_ctx[57] = i;
    return child_ctx;
}
function $2af2864a5b707c5b$var$get_each_context_4(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[48] = list[i];
    const constants_0 = [
        .../*node*/ child_ctx[48].exposedInputs,
        .../*node*/ child_ctx[48].exposedOutputs
    ];
    child_ctx[49] = constants_0;
    const constants_1 = `${Math.random()}`.substring(2);
    child_ctx[50] = constants_1;
    const constants_2 = /*node*/ child_ctx[48].exposedInputs[0];
    child_ctx[59] = constants_2;
    return child_ctx;
}
function $2af2864a5b707c5b$var$get_each_context_5(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[62] = list[i].pathString;
    child_ctx[63] = list[i].dataType;
    child_ctx[64] = list[i].thick;
    return child_ctx;
}
function $2af2864a5b707c5b$var$get_each_context_6(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[67] = list[i];
    return child_ctx;
}
function $2af2864a5b707c5b$var$get_each_context_7(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[70] = list[i];
    return child_ctx;
}
// (518:1) {#if nodeListLocation}
function $2af2864a5b707c5b$var$create_if_block_6(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "node-list",
            "data-node-list": true,
            styles: {
                left: `${ctx[5]}px`,
                top: `${ctx[4]}px`,
                transform: `translate(${ctx[12] ? -100 : 0}%, ${ctx[11] ? -100 : 0}%)`,
                width: `${$2af2864a5b707c5b$var$ADD_NODE_MENU_WIDTH}px`
            },
            $$slots: {
                default: [
                    $2af2864a5b707c5b$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty[0] & /*nodeListX, nodeListY, appearRightOfMouse, appearAboveMouse*/ 6192) layoutcol_changes.styles = {
                left: `${ctx[5]}px`,
                top: `${ctx[4]}px`,
                transform: `translate(${ctx[12] ? -100 : 0}%, ${ctx[11] ? -100 : 0}%)`,
                width: `${$2af2864a5b707c5b$var$ADD_NODE_MENU_WIDTH}px`
            };
            if (dirty[0] & /*nodeCategories, searchTerm, nodeSearchInput*/ 16644 | dirty[2] & /*$$scope*/ 2048) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
// (541:4) {:else}
function $2af2864a5b707c5b$var$create_else_block(ctx) {
    let div;
    let textlabel;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $2af2864a5b707c5b$var$create_default_slot_5
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "margin-right", "4px");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[2] & /*$$scope*/ 2048) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel);
        }
    };
}
// (542:37) <TextLabel>
function $2af2864a5b707c5b$var$create_default_slot_5(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("No search results");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (535:7) <TextLabel>
function $2af2864a5b707c5b$var$create_default_slot_4(ctx) {
    let t_value = /*nodeCategory*/ ctx[67][0] + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*nodeCategories*/ 16384 && t_value !== (t_value = /*nodeCategory*/ ctx[67][0] + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (537:6) {#each nodeCategory[1].nodes as nodeType}
function $2af2864a5b707c5b$var$create_each_block_7(ctx) {
    let textbutton;
    let current;
    function func() {
        return /*func*/ ctx[30](/*nodeType*/ ctx[70]);
    }
    textbutton = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: /*nodeType*/ ctx[70].name,
            action: func
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const textbutton_changes = {};
            if (dirty[0] & /*nodeCategories*/ 16384) textbutton_changes.label = /*nodeType*/ ctx[70].name;
            if (dirty[0] & /*nodeCategories*/ 16384) textbutton_changes.action = func;
            textbutton.$set(textbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton, detaching);
        }
    };
}
// (531:4) {#each nodeCategories as nodeCategory}
function $2af2864a5b707c5b$var$create_each_block_6(ctx) {
    let details;
    let summary;
    let iconlabel;
    let t0;
    let textlabel;
    let t1;
    let t2;
    let details_open_value;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: "DropdownArrow"
        }
    });
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $2af2864a5b707c5b$var$create_default_slot_4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let each_value_7 = /*nodeCategory*/ ctx[67][1].nodes;
    let each_blocks = [];
    for(let i = 0; i < each_value_7.length; i += 1)each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_7($2af2864a5b707c5b$var$get_each_context_7(ctx, each_value_7, i));
    const out = (i)=>(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    return {
        c () {
            details = (0, $1eb80e36873dc327$export$8454457683f90105)("details");
            summary = (0, $1eb80e36873dc327$export$8454457683f90105)("summary");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(details, "display", "flex");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(details, "flex-direction", "column");
            details.open = details_open_value = /*nodeCategory*/ ctx[67][1].open;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, details, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(details, summary);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, summary, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(summary, t0);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, summary, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(details, t1);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(details, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(details, t2);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[0] & /*nodeCategories*/ 16384 | dirty[2] & /*$$scope*/ 2048) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (dirty[0] & /*nodeCategories, createNode*/ 4210688) {
                each_value_7 = /*nodeCategory*/ ctx[67][1].nodes;
                let i;
                for(i = 0; i < each_value_7.length; i += 1){
                    const child_ctx = $2af2864a5b707c5b$var$get_each_context_7(ctx, each_value_7, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_7(child_ctx);
                        each_blocks[i].c();
                        (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i], 1);
                        each_blocks[i].m(details, t2);
                    }
                }
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                for(i = each_value_7.length; i < each_blocks.length; i += 1)out(i);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (!current || dirty[0] & /*nodeCategories*/ 16384 && details_open_value !== (details_open_value = /*nodeCategory*/ ctx[67][1].open)) details.open = details_open_value;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            for(let i = 0; i < each_value_7.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            each_blocks = each_blocks.filter($2af2864a5b707c5b$var$Boolean_1);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(details);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel);
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks, detaching);
        }
    };
}
// (519:2) <LayoutCol    class="node-list"    data-node-list    styles={{     left: `${nodeListX}px`,     top: `${nodeListY}px`,     transform: `translate(${appearRightOfMouse ? -100 : 0}%, ${appearAboveMouse ? -100 : 0}%)`,     width: `${ADD_NODE_MENU_WIDTH}px`,    }}   >
function $2af2864a5b707c5b$var$create_default_slot_3(ctx) {
    let textinput;
    let t;
    let div;
    let div_style_value;
    let current;
    let mounted;
    let dispose;
    let textinput_props = {
        placeholder: "Search Nodes...",
        value: /*searchTerm*/ ctx[2]
    };
    textinput = new (0, $13b5dd8e132143df$export$2e2bcd8739ae039)({
        props: textinput_props
    });
    /*textinput_binding*/ ctx[28](textinput);
    textinput.$on("value", /*value_handler*/ ctx[29]);
    let each_value_6 = /*nodeCategories*/ ctx[14];
    let each_blocks = [];
    for(let i = 0; i < each_value_6.length; i += 1)each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_6($2af2864a5b707c5b$var$get_each_context_6(ctx, each_value_6, i));
    const out = (i)=>(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    let each_1_else = null;
    if (!each_value_6.length) each_1_else = $2af2864a5b707c5b$var$create_else_block(ctx);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textinput.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            if (each_1_else) each_1_else.c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "list-nodes");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "style", div_style_value = `height: ${$2af2864a5b707c5b$var$ADD_NODE_MENU_HEIGHT}px;`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textinput, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div, null);
            if (each_1_else) each_1_else.m(div, null);
            current = true;
            if (!mounted) {
                dispose = (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div, "wheel", (0, $1eb80e36873dc327$export$52770bb39e602159)(/*wheel_handler*/ ctx[27]), {
                    passive: true
                });
                mounted = true;
            }
        },
        p (ctx, dirty) {
            const textinput_changes = {};
            if (dirty[0] & /*searchTerm*/ 4) textinput_changes.value = /*searchTerm*/ ctx[2];
            textinput.$set(textinput_changes);
            if (dirty[0] & /*nodeCategories, createNode*/ 4210688) {
                each_value_6 = /*nodeCategories*/ ctx[14];
                let i;
                for(i = 0; i < each_value_6.length; i += 1){
                    const child_ctx = $2af2864a5b707c5b$var$get_each_context_6(ctx, each_value_6, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_6(child_ctx);
                        each_blocks[i].c();
                        (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i], 1);
                        each_blocks[i].m(div, null);
                    }
                }
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                for(i = each_value_6.length; i < each_blocks.length; i += 1)out(i);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if (!each_value_6.length && each_1_else) each_1_else.p(ctx, dirty);
                else if (!each_value_6.length) {
                    each_1_else = $2af2864a5b707c5b$var$create_else_block(ctx);
                    each_1_else.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_1_else, 1);
                    each_1_else.m(div, null);
                } else if (each_1_else) {
                    (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                    (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_1_else, 1, 1, ()=>{
                        each_1_else = null;
                    });
                    (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                }
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textinput.$$.fragment, local);
            for(let i = 0; i < each_value_6.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textinput.$$.fragment, local);
            each_blocks = each_blocks.filter($2af2864a5b707c5b$var$Boolean_1);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            /*textinput_binding*/ ctx[28](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textinput, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks, detaching);
            if (each_1_else) each_1_else.d();
            mounted = false;
            dispose();
        }
    };
}
// (550:3) {#each linkPaths as { pathString, dataType, thick }}
function $2af2864a5b707c5b$var$create_each_block_5(ctx) {
    let path;
    let path_d_value;
    return {
        c () {
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", path_d_value = /*pathString*/ ctx[62]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(path, "--data-line-width", `${ctx[64] ? 8 : 2}px`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(path, "--data-color", `var(--color-data-${ctx[63]})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(path, "--data-color-dim", `var(--color-data-${ctx[63]}-dim)`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, path, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*linkPaths*/ 8192 && path_d_value !== (path_d_value = /*pathString*/ ctx[62])) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", path_d_value);
            if (dirty[0] & /*linkPaths*/ 8192) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(path, "--data-line-width", `${ctx[64] ? 8 : 2}px`);
            if (dirty[0] & /*linkPaths*/ 8192) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(path, "--data-color", `var(--color-data-${ctx[63]})`);
            if (dirty[0] & /*linkPaths*/ 8192) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(path, "--data-color-dim", `var(--color-data-${ctx[63]}-dim)`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(path);
        }
    };
}
// (591:5) {#if $nodeGraph.thumbnails.has(node.id)}
function $2af2864a5b707c5b$var$create_if_block_5(ctx) {
    let html_tag;
    let raw_value = /*$nodeGraph*/ ctx[6].thumbnails.get(/*node*/ ctx[48].id) + "";
    let html_anchor;
    return {
        c () {
            html_tag = new (0, $1eb80e36873dc327$export$5b2cf11349dd7485)(false);
            html_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && raw_value !== (raw_value = /*$nodeGraph*/ ctx[6].thumbnails.get(/*node*/ ctx[48].id) + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (594:5) {#if node.primaryOutput}
function $2af2864a5b707c5b$var$create_if_block_4(ctx) {
    let svg;
    let title;
    let t0_value = /*node*/ ctx[48].primaryOutput.dataType + "";
    let t0;
    let t1;
    let path;
    let svg_data_datatype_value;
    return {
        c () {
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            title = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("title");
            t0 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t0_value);
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" data");
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", "M0,2.953,2.521,1.259a2.649,2.649,0,0,1,2.959,0L8,2.953V8H0Z");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "viewBox", "0 0 8 8");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "class", "port top");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-port", "output");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value = /*node*/ ctx[48].primaryOutput.dataType);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[48].primaryOutput.dataType})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput.dataType}-dim)`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, svg, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, title);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, path);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t0_value !== (t0_value = /*node*/ ctx[48].primaryOutput.dataType + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t0, t0_value);
            if (dirty[0] & /*$nodeGraph*/ 64 && svg_data_datatype_value !== (svg_data_datatype_value = /*node*/ ctx[48].primaryOutput.dataType)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[48].primaryOutput.dataType})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput.dataType}-dim)`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(svg);
        }
    };
}
// (622:5) <TextLabel tooltip={`${node.displayName} node with id: ${node.id}`}>
function $2af2864a5b707c5b$var$create_default_slot_2(ctx) {
    let t_value = /*node*/ ctx[48].displayName + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t_value !== (t_value = /*node*/ ctx[48].displayName + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (558:2) {#each $nodeGraph.nodes.filter((node) => node.displayName === "Layer") as node (String(node.id))}
function $2af2864a5b707c5b$var$create_each_block_4(key_1, ctx) {
    let div4;
    let div0;
    let t0;
    let div1;
    let svg0;
    let title0;
    let t1_value = /*node*/ ctx[48].primaryInput + "";
    let t1;
    let t2;
    let path0;
    let svg0_data_datatype_value;
    let t3;
    let div2;
    let show_if = /*$nodeGraph*/ ctx[6].thumbnails.has(/*node*/ ctx[48].id);
    let t4;
    let t5;
    let svg1;
    let title1;
    let t6_value = /*stackDatainput*/ ctx[59].dataType + "";
    let t6;
    let t7;
    let path1;
    let svg1_data_datatype_value;
    let t8;
    let div3;
    let textlabel;
    let t9;
    let svg2;
    let defs;
    let clipPath;
    let path2;
    let path2_d_value;
    let clipPath_id_value;
    let t10;
    let div4_data_node_value;
    let current;
    let if_block0 = show_if && $2af2864a5b707c5b$var$create_if_block_5(ctx);
    let if_block1 = /*node*/ ctx[48].primaryOutput && $2af2864a5b707c5b$var$create_if_block_4(ctx);
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            tooltip: `${ctx[48].displayName} node with id: ${ctx[48].id}`,
            $$slots: {
                default: [
                    $2af2864a5b707c5b$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        key: key_1,
        first: null,
        c () {
            div4 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            svg0 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            title0 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("title");
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t1_value);
            t2 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" data");
            path0 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block0) if_block0.c();
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block1) if_block1.c();
            t5 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            svg1 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            title1 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("title");
            t6 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t6_value);
            t7 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" data");
            path1 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            t8 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div3 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t9 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            svg2 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            defs = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("defs");
            clipPath = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("clipPath");
            path2 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            t10 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "node-chain");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path0, "d", "M0,6.306A1.474,1.474,0,0,0,2.356,7.724L7.028,5.248c1.3-.687,1.3-1.809,0-2.5L2.356.276A1.474,1.474,0,0,0,0,1.694Z");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg0, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg0, "viewBox", "0 0 8 8");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg0, "class", "port");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg0, "data-port", "input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg0, "data-datatype", svg0_data_datatype_value = /*node*/ ctx[48].primaryInput?.dataType);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "--data-color", `var(--color-data-${ctx[48].primaryInput?.dataType})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "--data-color-dim", `var(--color-data-${ctx[48].primaryInput?.dataType}-dim)`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "input ports");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path1, "d", "M0,0H8V8L5.479,6.319a2.666,2.666,0,0,0-2.959,0L0,8Z");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg1, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg1, "viewBox", "0 0 8 8");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg1, "class", "port bottom");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg1, "data-port", "input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg1, "data-datatype", svg1_data_datatype_value = /*stackDatainput*/ ctx[59].dataType);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "--data-color", `var(--color-data-${ctx[59].dataType})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "--data-color-dim", `var(--color-data-${ctx[59].dataType}-dim)`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", "thumbnail");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div3, "class", "details");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path2, "clip-rule", "evenodd");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path2, "d", path2_d_value = $2af2864a5b707c5b$var$layerBorderMask(216));
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(clipPath, "id", clipPath_id_value = /*clipPathId*/ ctx[50]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg2, "class", "border-mask");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg2, "width", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg2, "height", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div4, "class", "layer");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div4, "data-node", div4_data_node_value = /*node*/ ctx[48].id);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div4, "selected", /*selected*/ ctx[9].includes(/*node*/ ctx[48].id));
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div4, "previewed", /*node*/ ctx[48].previewed);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div4, "disabled", /*node*/ ctx[48].disabled);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--offset-left", /*node*/ (ctx[48].position?.x || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundX || 0 : 0));
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--offset-top", /*node*/ (ctx[48].position?.y || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundY || 0 : 0));
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--clip-path-id", `url(#${ctx[50]})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--data-color", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"}-dim)`);
            this.first = div4;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div4, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, div0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, div1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, svg0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg0, title0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title0, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title0, t2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg0, path0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, t3);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, div2);
            if (if_block0) if_block0.m(div2, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, t4);
            if (if_block1) if_block1.m(div2, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, t5);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, svg1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg1, title1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title1, t6);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title1, t7);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg1, path1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, t8);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, div3);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, div3, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, t9);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, svg2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg2, defs);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(defs, clipPath);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(clipPath, path2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div4, t10);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if ((!current || dirty[0] & /*$nodeGraph*/ 64) && t1_value !== (t1_value = /*node*/ ctx[48].primaryInput + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t1, t1_value);
            if (!current || dirty[0] & /*$nodeGraph*/ 64 && svg0_data_datatype_value !== (svg0_data_datatype_value = /*node*/ ctx[48].primaryInput?.dataType)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg0, "data-datatype", svg0_data_datatype_value);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "--data-color", `var(--color-data-${ctx[48].primaryInput?.dataType})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "--data-color-dim", `var(--color-data-${ctx[48].primaryInput?.dataType}-dim)`);
            if (dirty[0] & /*$nodeGraph*/ 64) show_if = /*$nodeGraph*/ ctx[6].thumbnails.has(/*node*/ ctx[48].id);
            if (show_if) {
                if (if_block0) if_block0.p(ctx, dirty);
                else {
                    if_block0 = $2af2864a5b707c5b$var$create_if_block_5(ctx);
                    if_block0.c();
                    if_block0.m(div2, t4);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (/*node*/ ctx[48].primaryOutput) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $2af2864a5b707c5b$var$create_if_block_4(ctx);
                    if_block1.c();
                    if_block1.m(div2, t5);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            if ((!current || dirty[0] & /*$nodeGraph*/ 64) && t6_value !== (t6_value = /*stackDatainput*/ ctx[59].dataType + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t6, t6_value);
            if (!current || dirty[0] & /*$nodeGraph*/ 64 && svg1_data_datatype_value !== (svg1_data_datatype_value = /*stackDatainput*/ ctx[59].dataType)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg1, "data-datatype", svg1_data_datatype_value);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "--data-color", `var(--color-data-${ctx[59].dataType})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "--data-color-dim", `var(--color-data-${ctx[59].dataType}-dim)`);
            const textlabel_changes = {};
            if (dirty[0] & /*$nodeGraph*/ 64) textlabel_changes.tooltip = `${ctx[48].displayName} node with id: ${ctx[48].id}`;
            if (dirty[0] & /*$nodeGraph*/ 64 | dirty[2] & /*$$scope*/ 2048) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (!current || dirty[0] & /*$nodeGraph*/ 64 && div4_data_node_value !== (div4_data_node_value = /*node*/ ctx[48].id)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div4, "data-node", div4_data_node_value);
            if (!current || dirty[0] & /*selected, $nodeGraph*/ 576) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div4, "selected", /*selected*/ ctx[9].includes(/*node*/ ctx[48].id));
            if (!current || dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div4, "previewed", /*node*/ ctx[48].previewed);
            if (!current || dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div4, "disabled", /*node*/ ctx[48].disabled);
            if (dirty[0] & /*$nodeGraph, selected, draggingNodes*/ 1600) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--offset-left", /*node*/ (ctx[48].position?.x || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundX || 0 : 0));
            if (dirty[0] & /*$nodeGraph, selected, draggingNodes*/ 1600) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--offset-top", /*node*/ (ctx[48].position?.y || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundY || 0 : 0));
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--data-color", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div4, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"}-dim)`);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div4);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel);
        }
    };
}
// (654:5) <TextLabel tooltip={node.displayName}>
function $2af2864a5b707c5b$var$create_default_slot_1(ctx) {
    let t_value = /*node*/ ctx[48].displayName + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t_value !== (t_value = /*node*/ ctx[48].displayName + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (657:4) {#if exposedInputsOutputs.length > 0}
function $2af2864a5b707c5b$var$create_if_block_3(ctx) {
    let div;
    let current;
    let each_value_3 = /*exposedInputsOutputs*/ ctx[49];
    let each_blocks = [];
    for(let i = 0; i < each_value_3.length; i += 1)each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_3($2af2864a5b707c5b$var$get_each_context_3(ctx, each_value_3, i));
    const out = (i)=>(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", "parameters");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div, null);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64) {
                each_value_3 = /*exposedInputsOutputs*/ ctx[49];
                let i;
                for(i = 0; i < each_value_3.length; i += 1){
                    const child_ctx = $2af2864a5b707c5b$var$get_each_context_3(ctx, each_value_3, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_3(child_ctx);
                        each_blocks[i].c();
                        (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i], 1);
                        each_blocks[i].m(div, null);
                    }
                }
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                for(i = each_value_3.length; i < each_blocks.length; i += 1)out(i);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value_3.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            each_blocks = each_blocks.filter($2af2864a5b707c5b$var$Boolean_1);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks, detaching);
        }
    };
}
// (662:8) <TextLabel tooltip={parameter.name}>
function $2af2864a5b707c5b$var$create_default_slot(ctx) {
    let t_value = /*parameter*/ ctx[53].name + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t_value !== (t_value = /*parameter*/ ctx[53].name + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (659:6) {#each exposedInputsOutputs as parameter, index}
function $2af2864a5b707c5b$var$create_each_block_3(ctx) {
    let div1;
    let div0;
    let t0;
    let textlabel;
    let t1;
    let div1_class_value;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            tooltip: /*parameter*/ ctx[53].name,
            $$slots: {
                default: [
                    $2af2864a5b707c5b$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "expand-arrow");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", div1_class_value = `parameter expanded ${ctx[57] < /*node*/ ctx[48].exposedInputs.length ? "input" : "output"}`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div1, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, div0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t0);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, div1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t1);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty[0] & /*$nodeGraph*/ 64) textlabel_changes.tooltip = /*parameter*/ ctx[53].name;
            if (dirty[0] & /*$nodeGraph*/ 64 | dirty[2] & /*$$scope*/ 2048) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (!current || dirty[0] & /*$nodeGraph*/ 64 && div1_class_value !== (div1_class_value = `parameter expanded ${ctx[57] < /*node*/ ctx[48].exposedInputs.length ? "input" : "output"}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", div1_class_value);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel);
        }
    };
}
// (669:5) {#if node.primaryInput?.dataType}
function $2af2864a5b707c5b$var$create_if_block_2(ctx) {
    let svg;
    let title;
    let t0_value = /*node*/ ctx[48].primaryInput + "";
    let t0;
    let t1;
    let path;
    let svg_data_datatype_value;
    return {
        c () {
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            title = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("title");
            t0 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t0_value);
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" data");
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", "M0,6.306A1.474,1.474,0,0,0,2.356,7.724L7.028,5.248c1.3-.687,1.3-1.809,0-2.5L2.356.276A1.474,1.474,0,0,0,0,1.694Z");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "viewBox", "0 0 8 8");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "class", "port primary-port");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-port", "input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value = /*node*/ ctx[48].primaryInput?.dataType);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[48].primaryInput?.dataType})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[48].primaryInput?.dataType}-dim)`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, svg, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, title);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, path);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t0_value !== (t0_value = /*node*/ ctx[48].primaryInput + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t0, t0_value);
            if (dirty[0] & /*$nodeGraph*/ 64 && svg_data_datatype_value !== (svg_data_datatype_value = /*node*/ ctx[48].primaryInput?.dataType)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[48].primaryInput?.dataType})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[48].primaryInput?.dataType}-dim)`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(svg);
        }
    };
}
// (684:6) {#if index < node.exposedInputs.length}
function $2af2864a5b707c5b$var$create_if_block_1(ctx) {
    let svg;
    let title;
    let t0_value = /*parameter*/ ctx[53].dataType + "";
    let t0;
    let t1;
    let path;
    let svg_data_datatype_value;
    return {
        c () {
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            title = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("title");
            t0 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t0_value);
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" data");
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", "M0,6.306A1.474,1.474,0,0,0,2.356,7.724L7.028,5.248c1.3-.687,1.3-1.809,0-2.5L2.356.276A1.474,1.474,0,0,0,0,1.694Z");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "viewBox", "0 0 8 8");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "class", "port");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-port", "input");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value = /*parameter*/ ctx[53].dataType);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[53].dataType})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[53].dataType}-dim)`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, svg, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, title);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, path);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t0_value !== (t0_value = /*parameter*/ ctx[53].dataType + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t0, t0_value);
            if (dirty[0] & /*$nodeGraph*/ 64 && svg_data_datatype_value !== (svg_data_datatype_value = /*parameter*/ ctx[53].dataType)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[53].dataType})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[53].dataType}-dim)`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(svg);
        }
    };
}
// (683:5) {#each node.exposedInputs as parameter, index}
function $2af2864a5b707c5b$var$create_each_block_2(ctx) {
    let if_block_anchor;
    let if_block = /*index*/ ctx[57] < /*node*/ ctx[48].exposedInputs.length && $2af2864a5b707c5b$var$create_if_block_1(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (/*index*/ ctx[57] < /*node*/ ctx[48].exposedInputs.length) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $2af2864a5b707c5b$var$create_if_block_1(ctx);
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (702:5) {#if node.primaryOutput}
function $2af2864a5b707c5b$var$create_if_block(ctx) {
    let svg;
    let title;
    let t0_value = /*node*/ ctx[48].primaryOutput.dataType + "";
    let t0;
    let t1;
    let path;
    let svg_data_datatype_value;
    return {
        c () {
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            title = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("title");
            t0 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t0_value);
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" data");
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", "M0,6.306A1.474,1.474,0,0,0,2.356,7.724L7.028,5.248c1.3-.687,1.3-1.809,0-2.5L2.356.276A1.474,1.474,0,0,0,0,1.694Z");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "viewBox", "0 0 8 8");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "class", "port primary-port");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-port", "output");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value = /*node*/ ctx[48].primaryOutput.dataType);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[48].primaryOutput.dataType})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput.dataType}-dim)`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, svg, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, title);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, path);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t0_value !== (t0_value = /*node*/ ctx[48].primaryOutput.dataType + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t0, t0_value);
            if (dirty[0] & /*$nodeGraph*/ 64 && svg_data_datatype_value !== (svg_data_datatype_value = /*node*/ ctx[48].primaryOutput.dataType)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[48].primaryOutput.dataType})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput.dataType}-dim)`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(svg);
        }
    };
}
// (716:5) {#each node.exposedOutputs as parameter}
function $2af2864a5b707c5b$var$create_each_block_1(ctx) {
    let svg;
    let title;
    let t0_value = /*parameter*/ ctx[53].dataType + "";
    let t0;
    let t1;
    let path;
    let svg_data_datatype_value;
    return {
        c () {
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            title = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("title");
            t0 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t0_value);
            t1 = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(" data");
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", "M0,6.306A1.474,1.474,0,0,0,2.356,7.724L7.028,5.248c1.3-.687,1.3-1.809,0-2.5L2.356.276A1.474,1.474,0,0,0,0,1.694Z");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "viewBox", "0 0 8 8");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "class", "port");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-port", "output");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value = /*parameter*/ ctx[53].dataType);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[53].dataType})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[53].dataType}-dim)`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, svg, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, title);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(title, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, path);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$nodeGraph*/ 64 && t0_value !== (t0_value = /*parameter*/ ctx[53].dataType + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t0, t0_value);
            if (dirty[0] & /*$nodeGraph*/ 64 && svg_data_datatype_value !== (svg_data_datatype_value = /*parameter*/ ctx[53].dataType)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "data-datatype", svg_data_datatype_value);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color", `var(--color-data-${ctx[53].dataType})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "--data-color-dim", `var(--color-data-${ctx[53].dataType}-dim)`);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(svg);
        }
    };
}
// (635:2) {#each $nodeGraph.nodes.filter((node) => node.displayName !== "Layer") as node (String(node.id))}
function $2af2864a5b707c5b$var$create_each_block(key_1, ctx) {
    let div3;
    let div0;
    let iconlabel;
    let t0;
    let textlabel;
    let t1;
    let t2;
    let div1;
    let t3;
    let t4;
    let div2;
    let t5;
    let t6;
    let svg;
    let defs;
    let clipPath;
    let path;
    let path_d_value;
    let clipPath_id_value;
    let t7;
    let div3_data_node_value;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: $2af2864a5b707c5b$var$nodeIcon(/*node*/ ctx[48].displayName)
        }
    });
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            tooltip: /*node*/ ctx[48].displayName,
            $$slots: {
                default: [
                    $2af2864a5b707c5b$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let if_block0 = /*exposedInputsOutputs*/ ctx[49].length > 0 && $2af2864a5b707c5b$var$create_if_block_3(ctx);
    let if_block1 = /*node*/ ctx[48].primaryInput?.dataType && $2af2864a5b707c5b$var$create_if_block_2(ctx);
    let each_value_2 = /*node*/ ctx[48].exposedInputs;
    let each_blocks_1 = [];
    for(let i = 0; i < each_value_2.length; i += 1)each_blocks_1[i] = $2af2864a5b707c5b$var$create_each_block_2($2af2864a5b707c5b$var$get_each_context_2(ctx, each_value_2, i));
    let if_block2 = /*node*/ ctx[48].primaryOutput && $2af2864a5b707c5b$var$create_if_block(ctx);
    let each_value_1 = /*node*/ ctx[48].exposedOutputs;
    let each_blocks = [];
    for(let i = 0; i < each_value_1.length; i += 1)each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_1($2af2864a5b707c5b$var$get_each_context_1(ctx, each_value_1, i));
    return {
        key: key_1,
        first: null,
        c () {
            div3 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block0) if_block0.c();
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block1) if_block1.c();
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks_1.length; i += 1)each_blocks_1[i].c();
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block2) if_block2.c();
            t5 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t6 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            defs = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("defs");
            clipPath = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("clipPath");
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            t7 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "primary");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div0, "no-parameter-section", /*exposedInputsOutputs*/ ctx[49].length === 0);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "input ports");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", "output ports");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "clip-rule", "evenodd");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", path_d_value = $2af2864a5b707c5b$var$nodeBorderMask(120, /*node*/ ctx[48].primaryInput?.dataType !== undefined, /*node*/ ctx[48].exposedInputs.length, /*node*/ ctx[48].primaryOutput !== undefined, /*node*/ ctx[48].exposedOutputs.length));
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(clipPath, "id", clipPath_id_value = /*clipPathId*/ ctx[50]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "class", "border-mask");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "width", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg, "height", "0");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div3, "class", "node");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div3, "data-node", div3_data_node_value = /*node*/ ctx[48].id);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "selected", /*selected*/ ctx[9].includes(/*node*/ ctx[48].id));
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "previewed", /*node*/ ctx[48].previewed);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "disabled", /*node*/ ctx[48].disabled);
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "is-layer", /*node*/ ctx[48].displayName === "Layer");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--offset-left", /*node*/ (ctx[48].position?.x || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundX || 0 : 0));
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--offset-top", /*node*/ (ctx[48].position?.y || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundY || 0 : 0));
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--clip-path-id", `url(#${ctx[50]})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--data-color", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"})`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"}-dim)`);
            this.first = div3;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div3, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, div0);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, div0, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div0, t0);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, div0, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, t1);
            if (if_block0) if_block0.m(div3, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, t2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, div1);
            if (if_block1) if_block1.m(div1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t3);
            for(let i = 0; i < each_blocks_1.length; i += 1)if (each_blocks_1[i]) each_blocks_1[i].m(div1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, t4);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, div2);
            if (if_block2) if_block2.m(div2, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, t5);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div2, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, t6);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, svg);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, defs);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(defs, clipPath);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(clipPath, path);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div3, t7);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const iconlabel_changes = {};
            if (dirty[0] & /*$nodeGraph*/ 64) iconlabel_changes.icon = $2af2864a5b707c5b$var$nodeIcon(/*node*/ ctx[48].displayName);
            iconlabel.$set(iconlabel_changes);
            const textlabel_changes = {};
            if (dirty[0] & /*$nodeGraph*/ 64) textlabel_changes.tooltip = /*node*/ ctx[48].displayName;
            if (dirty[0] & /*$nodeGraph*/ 64 | dirty[2] & /*$$scope*/ 2048) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (!current || dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div0, "no-parameter-section", /*exposedInputsOutputs*/ ctx[49].length === 0);
            if (/*exposedInputsOutputs*/ ctx[49].length > 0) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $2af2864a5b707c5b$var$create_if_block_3(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(div3, t2);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (/*node*/ ctx[48].primaryInput?.dataType) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $2af2864a5b707c5b$var$create_if_block_2(ctx);
                    if_block1.c();
                    if_block1.m(div1, t3);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            if (dirty[0] & /*$nodeGraph*/ 64) {
                each_value_2 = /*node*/ ctx[48].exposedInputs;
                let i;
                for(i = 0; i < each_value_2.length; i += 1){
                    const child_ctx = $2af2864a5b707c5b$var$get_each_context_2(ctx, each_value_2, i);
                    if (each_blocks_1[i]) each_blocks_1[i].p(child_ctx, dirty);
                    else {
                        each_blocks_1[i] = $2af2864a5b707c5b$var$create_each_block_2(child_ctx);
                        each_blocks_1[i].c();
                        each_blocks_1[i].m(div1, null);
                    }
                }
                for(; i < each_blocks_1.length; i += 1)each_blocks_1[i].d(1);
                each_blocks_1.length = each_value_2.length;
            }
            if (/*node*/ ctx[48].primaryOutput) {
                if (if_block2) if_block2.p(ctx, dirty);
                else {
                    if_block2 = $2af2864a5b707c5b$var$create_if_block(ctx);
                    if_block2.c();
                    if_block2.m(div2, t5);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (dirty[0] & /*$nodeGraph*/ 64) {
                each_value_1 = /*node*/ ctx[48].exposedOutputs;
                let i;
                for(i = 0; i < each_value_1.length; i += 1){
                    const child_ctx = $2af2864a5b707c5b$var$get_each_context_1(ctx, each_value_1, i);
                    if (each_blocks[i]) each_blocks[i].p(child_ctx, dirty);
                    else {
                        each_blocks[i] = $2af2864a5b707c5b$var$create_each_block_1(child_ctx);
                        each_blocks[i].c();
                        each_blocks[i].m(div2, null);
                    }
                }
                for(; i < each_blocks.length; i += 1)each_blocks[i].d(1);
                each_blocks.length = each_value_1.length;
            }
            if (!current || dirty[0] & /*$nodeGraph*/ 64 && path_d_value !== (path_d_value = $2af2864a5b707c5b$var$nodeBorderMask(120, /*node*/ ctx[48].primaryInput?.dataType !== undefined, /*node*/ ctx[48].exposedInputs.length, /*node*/ ctx[48].primaryOutput !== undefined, /*node*/ ctx[48].exposedOutputs.length))) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", path_d_value);
            if (!current || dirty[0] & /*$nodeGraph*/ 64 && div3_data_node_value !== (div3_data_node_value = /*node*/ ctx[48].id)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div3, "data-node", div3_data_node_value);
            if (!current || dirty[0] & /*selected, $nodeGraph*/ 576) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "selected", /*selected*/ ctx[9].includes(/*node*/ ctx[48].id));
            if (!current || dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "previewed", /*node*/ ctx[48].previewed);
            if (!current || dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "disabled", /*node*/ ctx[48].disabled);
            if (!current || dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div3, "is-layer", /*node*/ ctx[48].displayName === "Layer");
            if (dirty[0] & /*$nodeGraph, selected, draggingNodes*/ 1600) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--offset-left", /*node*/ (ctx[48].position?.x || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundX || 0 : 0));
            if (dirty[0] & /*$nodeGraph, selected, draggingNodes*/ 1600) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--offset-top", /*node*/ (ctx[48].position?.y || 0) + /*selected*/ (ctx[9].includes(/*node*/ ctx[48].id) ? /*draggingNodes*/ ctx[10]?.roundY || 0 : 0));
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--data-color", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"})`);
            if (dirty[0] & /*$nodeGraph*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div3, "--data-color-dim", `var(--color-data-${ctx[48].primaryOutput?.dataType || "general"}-dim)`);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div3);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks_1, detaching);
            if (if_block2) if_block2.d();
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks, detaching);
        }
    };
}
function $2af2864a5b707c5b$var$create_fragment(ctx) {
    let div2;
    let t0;
    let div0;
    let svg;
    let t1;
    let div1;
    let each_blocks_1 = [];
    let each1_lookup = new $2af2864a5b707c5b$var$Map_1();
    let t2;
    let each_blocks = [];
    let each2_lookup = new $2af2864a5b707c5b$var$Map_1();
    let current;
    let mounted;
    let dispose;
    let if_block = /*nodeListLocation*/ ctx[3] && $2af2864a5b707c5b$var$create_if_block_6(ctx);
    let each_value_5 = /*linkPaths*/ ctx[13];
    let each_blocks_2 = [];
    for(let i = 0; i < each_value_5.length; i += 1)each_blocks_2[i] = $2af2864a5b707c5b$var$create_each_block_5($2af2864a5b707c5b$var$get_each_context_5(ctx, each_value_5, i));
    let each_value_4 = /*$nodeGraph*/ ctx[6].nodes.filter($2af2864a5b707c5b$var$func_1);
    const get_key = (ctx)=>String(/*node*/ ctx[48].id);
    for(let i = 0; i < each_value_4.length; i += 1){
        let child_ctx = $2af2864a5b707c5b$var$get_each_context_4(ctx, each_value_4, i);
        let key = get_key(child_ctx);
        each1_lookup.set(key, each_blocks_1[i] = $2af2864a5b707c5b$var$create_each_block_4(key, child_ctx));
    }
    let each_value = /*$nodeGraph*/ ctx[6].nodes.filter($2af2864a5b707c5b$var$func_2);
    const get_key_1 = (ctx)=>String(/*node*/ ctx[48].id);
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $2af2864a5b707c5b$var$get_each_context(ctx, each_value, i);
        let key = get_key_1(child_ctx);
        each2_lookup.set(key, each_blocks[i] = $2af2864a5b707c5b$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block) if_block.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            for(let i = 0; i < each_blocks_2.length; i += 1)each_blocks_2[i].c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            for(let i = 0; i < each_blocks_1.length; i += 1)each_blocks_1[i].c();
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "wires");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "transform", `scale(${ctx[1].scale}) translate(${ctx[1].x}px, ${ctx[1].y}px)`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "transform-origin", `0 0`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "layers-and-nodes");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div1, "transform", `scale(${ctx[1].scale}) translate(${ctx[1].x}px, ${ctx[1].y}px)`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div1, "transform-origin", `0 0`);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", "graph");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--grid-spacing", `${ctx[16]}px`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--grid-offset-x", `${ctx[1].x * /*transform*/ ctx[1].scale}px`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--grid-offset-y", `${ctx[1].y * /*transform*/ ctx[1].scale}px`);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--dot-radius", `${ctx[15]}px`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div2, anchor);
            if (if_block) if_block.m(div2, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, div0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div0, svg);
            for(let i = 0; i < each_blocks_2.length; i += 1)if (each_blocks_2[i]) each_blocks_2[i].m(svg, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, div1);
            for(let i = 0; i < each_blocks_1.length; i += 1)if (each_blocks_1[i]) each_blocks_1[i].m(div1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t2);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div1, null);
            /*div1_binding*/ ctx[31](div1);
            /*div2_binding*/ ctx[32](div2);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div2, "wheel", /*scroll*/ ctx[18], {
                        passive: false
                    }),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div2, "pointerdown", /*pointerDown*/ ctx[19]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div2, "pointermove", /*pointerMove*/ ctx[20]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div2, "pointerup", /*pointerUp*/ ctx[21]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div2, "dblclick", $2af2864a5b707c5b$var$doubleClick)
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (/*nodeListLocation*/ ctx[3]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty[0] & /*nodeListLocation*/ 8) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $2af2864a5b707c5b$var$create_if_block_6(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(div2, t0);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (dirty[0] & /*linkPaths*/ 8192) {
                each_value_5 = /*linkPaths*/ ctx[13];
                let i;
                for(i = 0; i < each_value_5.length; i += 1){
                    const child_ctx = $2af2864a5b707c5b$var$get_each_context_5(ctx, each_value_5, i);
                    if (each_blocks_2[i]) each_blocks_2[i].p(child_ctx, dirty);
                    else {
                        each_blocks_2[i] = $2af2864a5b707c5b$var$create_each_block_5(child_ctx);
                        each_blocks_2[i].c();
                        each_blocks_2[i].m(svg, null);
                    }
                }
                for(; i < each_blocks_2.length; i += 1)each_blocks_2[i].d(1);
                each_blocks_2.length = each_value_5.length;
            }
            if (dirty[0] & /*transform*/ 2) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "transform", `scale(${ctx[1].scale}) translate(${ctx[1].x}px, ${ctx[1].y}px)`);
            if (dirty[0] & /*$nodeGraph, selected, draggingNodes*/ 1600) {
                each_value_4 = /*$nodeGraph*/ ctx[6].nodes.filter($2af2864a5b707c5b$var$func_1);
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks_1 = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks_1, dirty, get_key, 1, ctx, each_value_4, each1_lookup, div1, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $2af2864a5b707c5b$var$create_each_block_4, t2, $2af2864a5b707c5b$var$get_each_context_4);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (dirty[0] & /*$nodeGraph, selected, draggingNodes*/ 1600) {
                each_value = /*$nodeGraph*/ ctx[6].nodes.filter($2af2864a5b707c5b$var$func_2);
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key_1, 1, ctx, each_value, each2_lookup, div1, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $2af2864a5b707c5b$var$create_each_block, null, $2af2864a5b707c5b$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (dirty[0] & /*transform*/ 2) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div1, "transform", `scale(${ctx[1].scale}) translate(${ctx[1].x}px, ${ctx[1].y}px)`);
            if (dirty[0] & /*gridSpacing*/ 65536) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--grid-spacing", `${ctx[16]}px`);
            if (dirty[0] & /*transform*/ 2) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--grid-offset-x", `${ctx[1].x * /*transform*/ ctx[1].scale}px`);
            if (dirty[0] & /*transform*/ 2) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--grid-offset-y", `${ctx[1].y * /*transform*/ ctx[1].scale}px`);
            if (dirty[0] & /*dotRadius*/ 32768) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--dot-radius", `${ctx[15]}px`);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            for(let i = 0; i < each_value_4.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks_1[i]);
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            for(let i = 0; i < each_blocks_1.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks_1[i]);
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div2);
            if (if_block) if_block.d();
            (0, $1eb80e36873dc327$export$7ddc7a4fd25b2662)(each_blocks_2, detaching);
            for(let i = 0; i < each_blocks_1.length; i += 1)each_blocks_1[i].d();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d();
            /*div1_binding*/ ctx[31](null);
            /*div2_binding*/ ctx[32](null);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
const $2af2864a5b707c5b$var$GRID_COLLAPSE_SPACING = 10;
const $2af2864a5b707c5b$var$GRID_SIZE = 24;
const $2af2864a5b707c5b$var$ADD_NODE_MENU_WIDTH = 180;
const $2af2864a5b707c5b$var$ADD_NODE_MENU_HEIGHT = 200;
function $2af2864a5b707c5b$var$calculateGridSpacing(scale) {
    const dense = scale * $2af2864a5b707c5b$var$GRID_SIZE;
    let sparse = dense;
    while(sparse > 0 && sparse < $2af2864a5b707c5b$var$GRID_COLLAPSE_SPACING)sparse *= 2;
    return sparse;
}
function $2af2864a5b707c5b$var$buildNodeCategories(nodeTypes, searchTerm) {
    const categories = new Map();
    nodeTypes.forEach((node)=>{
        const nameIncludesSearchTerm = node.name.toLowerCase().includes(searchTerm.toLowerCase());
        if (searchTerm.length > 0 && !nameIncludesSearchTerm && !node.category.toLowerCase().includes(searchTerm.toLowerCase())) return;
        const category = categories.get(node.category);
        let open = nameIncludesSearchTerm;
        if (searchTerm.length === 0) open = false;
        if (category) {
            category.open = open;
            category.nodes.push(node);
        } else categories.set(node.category, {
            open: open,
            nodes: [
                node
            ]
        });
    });
    return Array.from(categories);
}
function $2af2864a5b707c5b$var$resolveLink(link, containerBounds) {
    const outputIndex = Number(link.linkStartOutputIndex);
    const inputIndex = Number(link.linkEndInputIndex);
    const nodeOutputConnectors = containerBounds.querySelectorAll(`[data-node="${String(link.linkStart)}"] [data-port="output"]`) || undefined;
    const nodeInputConnectors = containerBounds.querySelectorAll(`[data-node="${String(link.linkEnd)}"] [data-port="input"]`) || undefined;
    const nodeOutput = nodeOutputConnectors?.[outputIndex];
    const nodeInput = nodeInputConnectors?.[inputIndex];
    return {
        nodeOutput: nodeOutput,
        nodeInput: nodeInput
    };
}
function $2af2864a5b707c5b$var$nodeIcon(nodeName) {
    const iconMap = {
        Output: "NodeOutput"
    };
    return iconMap[nodeName] || "NodeNodes";
}
function $2af2864a5b707c5b$var$doubleClick(e) {} // const node = (e.target as HTMLElement).closest("[data-node]") as HTMLElement | undefined;
// const nodeId = node?.getAttribute("data-node") || undefined;
function $2af2864a5b707c5b$var$connectorToNodeIndex(svg) {
    const node = svg.closest("[data-node]");
    if (!node) return undefined;
    const nodeIdAttribute = node.getAttribute("data-node");
    if (!nodeIdAttribute) return undefined;
    const nodeId = BigInt(nodeIdAttribute);
    const inputPortElements = Array.from(node.querySelectorAll(`[data-port="input"]`));
    const outputPortElements = Array.from(node.querySelectorAll(`[data-port="output"]`));
    const inputNodeConnectionIndexSearch = inputPortElements.includes(svg) ? inputPortElements.indexOf(svg) : outputPortElements.indexOf(svg);
    const index = inputNodeConnectionIndexSearch > -1 ? inputNodeConnectionIndexSearch : undefined;
    if (nodeId !== undefined && index !== undefined) return {
        nodeId: nodeId,
        index: index
    };
    else return undefined;
}
function $2af2864a5b707c5b$var$nodeBorderMask(nodeWidth, primaryInputExists, parameters, primaryOutputExists, exposedOutputs) {
    const nodeHeight = Math.max(1 + parameters, 1 + exposedOutputs) * 24;
    const boxes = [];
    // Primary input
    if (primaryInputExists) boxes.push({
        x: -8,
        y: 4,
        width: 16,
        height: 16
    });
    // Parameter inputs
    for(let i = 0; i < parameters; i++)boxes.push({
        x: -8,
        y: 4 + (i + 1) * 24,
        width: 16,
        height: 16
    });
    // Primary output
    if (primaryOutputExists) boxes.push({
        x: nodeWidth - 8,
        y: 4,
        width: 16,
        height: 16
    });
    // Exposed outputs
    for(let i = 0; i < exposedOutputs; i++)boxes.push({
        x: nodeWidth - 8,
        y: 4 + (i + 1) * 24,
        width: 16,
        height: 16
    });
    return $2af2864a5b707c5b$var$borderMask(boxes, nodeWidth, nodeHeight);
}
function $2af2864a5b707c5b$var$layerBorderMask(nodeWidth) {
    const NODE_HEIGHT = 48;
    const THUMBNAIL_WIDTH = 96;
    const FUDGE = 2;
    const boxes = [];
    // Left input
    boxes.push({
        x: -8,
        y: 16,
        width: 16,
        height: 16
    });
    // Thumbnail
    boxes.push({
        x: 24,
        y: -FUDGE,
        width: THUMBNAIL_WIDTH,
        height: NODE_HEIGHT + FUDGE * 2
    });
    return $2af2864a5b707c5b$var$borderMask(boxes, nodeWidth, NODE_HEIGHT);
}
function $2af2864a5b707c5b$var$borderMask(boxes, nodeWidth, nodeHeight) {
    const rectangles = boxes.map((box)=>`M${box.x},${box.y} L${box.x + box.width},${box.y} L${box.x + box.width},${box.y + box.height} L${box.x},${box.y + box.height}z`);
    return `M-2,-2 L${nodeWidth + 2},-2 L${nodeWidth + 2},${nodeHeight + 2} L-2,${nodeHeight + 2}z ${rectangles.join(" ")}`;
}
const $2af2864a5b707c5b$var$func_1 = (node)=>node.displayName === "Layer";
const $2af2864a5b707c5b$var$func_2 = (node)=>node.displayName !== "Layer";
function $2af2864a5b707c5b$var$instance($$self, $$props, $$invalidate) {
    let gridSpacing;
    let dotRadius;
    let nodeCategories;
    let nodeListX;
    let nodeListY;
    let linkPathInProgress;
    let linkPaths;
    let $nodeGraph;
    const WHEEL_RATE = 1 / 600 * 3;
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    const nodeGraph = (0, $1eb80e36873dc327$export$31553aaa555c1514)("nodeGraph");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, nodeGraph, (value)=>$$invalidate(6, $nodeGraph = value));
    let graph;
    let nodesContainer;
    let nodeSearchInput;
    let transform = {
        scale: 1,
        x: 0,
        y: 0
    };
    let panning = false;
    let selected = [];
    let draggingNodes = undefined;
    let selectIfNotDragged = undefined;
    let linkInProgressFromConnector = undefined;
    let linkInProgressToConnector = undefined;
    let disconnecting = undefined;
    let nodeLinkPaths = [];
    let searchTerm = "";
    let nodeListLocation = undefined;
    let appearAboveMouse = false;
    let appearRightOfMouse = false;
    function createLinkPathInProgress(linkInProgressFromConnector, linkInProgressToConnector) {
        if (linkInProgressFromConnector && linkInProgressToConnector && nodesContainer) {
            const from = $2af2864a5b707c5b$var$connectorToNodeIndex(linkInProgressFromConnector);
            const to = linkInProgressToConnector instanceof SVGSVGElement ? $2af2864a5b707c5b$var$connectorToNodeIndex(linkInProgressToConnector) : undefined;
            const linkStart = $nodeGraph.nodes.find((node)=>node.id === from?.nodeId)?.displayName === "Layer";
            const linkEnd = $nodeGraph.nodes.find((node)=>node.id === to?.nodeId)?.displayName === "Layer" && to?.index !== 0;
            return createWirePath(linkInProgressFromConnector, linkInProgressToConnector, linkStart, linkEnd);
        }
        return undefined;
    }
    function createLinkPaths(linkPathInProgress, nodeLinkPaths) {
        const optionalTuple = linkPathInProgress ? [
            linkPathInProgress
        ] : [];
        return [
            ...optionalTuple,
            ...nodeLinkPaths
        ];
    }
    async function watchNodes(nodes) {
        $$invalidate(9, selected = selected.filter((id)=>nodes.find((node)=>node.id === id)));
        await refreshLinks();
    }
    async function refreshLinks() {
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        if (!nodesContainer) return;
        const theNodesContainer = nodesContainer;
        const links = $nodeGraph.links;
        $$invalidate(25, nodeLinkPaths = links.flatMap((link, index)=>{
            const { nodeInput: nodeInput, nodeOutput: nodeOutput } = $2af2864a5b707c5b$var$resolveLink(link, theNodesContainer);
            if (!nodeInput || !nodeOutput) return [];
            if (disconnecting?.linkIndex === index) return [];
            const linkStart = $nodeGraph.nodes.find((node)=>node.id === link.linkStart)?.displayName === "Layer";
            const linkEnd = $nodeGraph.nodes.find((node)=>node.id === link.linkEnd)?.displayName === "Layer" && link.linkEndInputIndex !== 0n;
            return [
                createWirePath(nodeOutput, nodeInput.getBoundingClientRect(), linkStart, linkEnd)
            ];
        }));
    }
    function buildWirePathLocations(outputBounds, inputBounds, verticalOut, verticalIn) {
        if (!nodesContainer) return [];
        const containerBounds = nodesContainer.getBoundingClientRect();
        const outX = verticalOut ? outputBounds.x + outputBounds.width / 2 : outputBounds.x + outputBounds.width - 1;
        const outY = verticalOut ? outputBounds.y - 1 : outputBounds.y + outputBounds.height / 2;
        const outConnectorX = (outX - containerBounds.x) / transform.scale;
        const outConnectorY = (outY - containerBounds.y) / transform.scale;
        const inX = verticalIn ? inputBounds.x + inputBounds.width / 2 : inputBounds.x + 1;
        const inY = verticalIn ? inputBounds.y + inputBounds.height + 2 : inputBounds.y + inputBounds.height / 2;
        const inConnectorX = (inX - containerBounds.x) / transform.scale;
        const inConnectorY = (inY - containerBounds.y) / transform.scale;
        const horizontalGap = Math.abs(outConnectorX - inConnectorX);
        const verticalGap = Math.abs(outConnectorY - inConnectorY);
        const curveLength = 200;
        const curveFalloffRate = curveLength * Math.PI * 2;
        const horizontalCurveAmount = -(2 ** (-10 * horizontalGap / curveFalloffRate)) + 1;
        const verticalCurveAmount = -(2 ** (-10 * verticalGap / curveFalloffRate)) + 1;
        const horizontalCurve = horizontalCurveAmount * curveLength;
        const verticalCurve = verticalCurveAmount * curveLength;
        return [
            {
                x: outConnectorX,
                y: outConnectorY
            },
            {
                x: verticalOut ? outConnectorX : outConnectorX + horizontalCurve,
                y: verticalOut ? outConnectorY - verticalCurve : outConnectorY
            },
            {
                x: verticalIn ? inConnectorX : inConnectorX - horizontalCurve,
                y: verticalIn ? inConnectorY + verticalCurve : inConnectorY
            },
            {
                x: inConnectorX,
                y: inConnectorY
            }
        ];
    }
    function buildWirePathString(outputBounds, inputBounds, verticalOut, verticalIn) {
        const locations = buildWirePathLocations(outputBounds, inputBounds, verticalOut, verticalIn);
        if (locations.length === 0) return "[error]";
        return `M${locations[0].x},${locations[0].y} C${locations[1].x},${locations[1].y} ${locations[2].x},${locations[2].y} ${locations[3].x},${locations[3].y}`;
    }
    function createWirePath(outputPort, inputPort, verticalOut, verticalIn) {
        const inputPortRect = inputPort instanceof DOMRect ? inputPort : inputPort.getBoundingClientRect();
        const pathString = buildWirePathString(outputPort.getBoundingClientRect(), inputPortRect, verticalOut, verticalIn);
        const dataType = outputPort.getAttribute("data-datatype") || "general";
        return {
            pathString: pathString,
            dataType: dataType,
            thick: verticalIn && verticalOut
        };
    }
    function scroll(e) {
        const [scrollX, scrollY] = [
            e.deltaX,
            e.deltaY
        ];
        // If zoom with scroll is enabled: horizontal pan with Ctrl, vertical pan with Shift
        const zoomWithScroll = $nodeGraph.zoomWithScroll;
        const zoom = zoomWithScroll ? !e.ctrlKey && !e.shiftKey : e.ctrlKey;
        const horizontalPan = zoomWithScroll ? e.ctrlKey : !e.ctrlKey && e.shiftKey;
        // Prevent the web page from being zoomed
        if (e.ctrlKey) e.preventDefault();
        // Always pan horizontally in response to a horizontal scroll wheel movement
        $$invalidate(1, transform.x -= scrollX / transform.scale, transform);
        // Zoom
        if (zoom) {
            let zoomFactor = 1 + Math.abs(scrollY) * WHEEL_RATE;
            if (scrollY > 0) zoomFactor = 1 / zoomFactor;
            const bounds = graph?.getBoundingClientRect();
            if (!bounds) return;
            const { x: x, y: y, width: width, height: height } = bounds;
            $$invalidate(1, transform.scale *= zoomFactor, transform);
            const newViewportX = width / zoomFactor;
            const newViewportY = height / zoomFactor;
            const deltaSizeX = width - newViewportX;
            const deltaSizeY = height - newViewportY;
            const deltaX = deltaSizeX * ((e.x - x) / width);
            const deltaY = deltaSizeY * ((e.y - y) / height);
            $$invalidate(1, transform.x -= deltaX / transform.scale * zoomFactor, transform);
            $$invalidate(1, transform.y -= deltaY / transform.scale * zoomFactor, transform);
            return;
        }
        // Pan
        if (horizontalPan) $$invalidate(1, transform.x -= scrollY / transform.scale, transform);
        else $$invalidate(1, transform.y -= scrollY / transform.scale, transform);
    }
    function keydown(e) {
        if (e.key.toLowerCase() === "escape") {
            $$invalidate(3, nodeListLocation = undefined);
            document.removeEventListener("keydown", keydown);
            $$invalidate(23, linkInProgressFromConnector = undefined);
        }
    }
    function loadNodeList(e, graphBounds) {
        $$invalidate(3, nodeListLocation = {
            x: Math.round(((e.clientX - graphBounds.x) / transform.scale - transform.x) / $2af2864a5b707c5b$var$GRID_SIZE),
            y: Math.round(((e.clientY - graphBounds.y) / transform.scale - transform.y) / $2af2864a5b707c5b$var$GRID_SIZE)
        });
        // Find actual relevant child and focus it (setTimeout is required to actually focus the input element)
        setTimeout(()=>nodeSearchInput?.focus(), 0);
        document.addEventListener("keydown", keydown);
    }
    // TODO: Move the event listener from the graph to the window so dragging outside the graph area (or even the whole browser window) works
    function pointerDown(e) {
        const [lmb, rmb] = [
            e.button === 0,
            e.button === 2
        ];
        const port = e.target.closest("[data-port]");
        const node = e.target.closest("[data-node]");
        const nodeId = node?.getAttribute("data-node") || undefined;
        const nodeList = e.target.closest("[data-node-list]");
        // Create the add node popup on right click, then exit
        if (rmb) {
            const graphBounds = graph?.getBoundingClientRect();
            if (!graphBounds) return;
            loadNodeList(e, graphBounds);
            return;
        }
        // If the user is clicking on the add nodes list, exit here
        if (lmb && nodeList) return;
        // Since the user is clicking elsewhere in the graph, ensure the add nodes list is closed
        if (lmb) {
            $$invalidate(3, nodeListLocation = undefined);
            $$invalidate(23, linkInProgressFromConnector = undefined);
        }
        // Alt-click sets the clicked node as previewed
        if (lmb && e.altKey && nodeId) editor.instance.togglePreview(BigInt(nodeId));
        // Clicked on a port dot
        if (lmb && port && node) {
            const isOutput = Boolean(port.getAttribute("data-port") === "output");
            if (isOutput) $$invalidate(23, linkInProgressFromConnector = port);
            else {
                const inputNodeInPorts = Array.from(node.querySelectorAll(`[data-port="input"]`));
                const inputNodeConnectionIndexSearch = inputNodeInPorts.indexOf(port);
                const inputIndex = inputNodeConnectionIndexSearch > -1 ? inputNodeConnectionIndexSearch : undefined;
                // Set the link to draw from the input that a previous link was on
                if (inputIndex !== undefined && nodeId !== undefined) {
                    const nodeIdInt = BigInt(nodeId);
                    const inputIndexInt = BigInt(inputIndex);
                    const links = $nodeGraph.links;
                    const linkIndex = links.findIndex((value)=>value.linkEnd === nodeIdInt && value.linkEndInputIndex === inputIndexInt);
                    if (linkIndex !== -1) {
                        const nodeOutputConnectors = nodesContainer?.querySelectorAll(`[data-node="${String(links[linkIndex].linkStart)}"] [data-port="output"]`) || undefined;
                        $$invalidate(23, linkInProgressFromConnector = nodeOutputConnectors?.[Number(links[linkIndex].linkStartOutputIndex)]);
                        const nodeInputConnectors = nodesContainer?.querySelectorAll(`[data-node="${String(links[linkIndex].linkEnd)}"] [data-port="input"]`) || undefined;
                        $$invalidate(24, linkInProgressToConnector = nodeInputConnectors?.[Number(links[linkIndex].linkEndInputIndex)]);
                        disconnecting = {
                            nodeId: nodeIdInt,
                            inputIndex: inputIndex,
                            linkIndex: linkIndex
                        };
                        refreshLinks();
                    }
                }
            }
            return;
        }
        // Clicked on a node
        if (lmb && nodeId) {
            let modifiedSelected = false;
            const id = BigInt(nodeId);
            if (e.shiftKey || e.ctrlKey) {
                modifiedSelected = true;
                if (selected.includes(id)) selected.splice(selected.lastIndexOf(id), 1);
                else selected.push(id);
            } else if (!selected.includes(id)) {
                modifiedSelected = true;
                $$invalidate(9, selected = [
                    id
                ]);
            } else selectIfNotDragged = id;
            if (selected.includes(id)) $$invalidate(10, draggingNodes = {
                startX: e.x,
                startY: e.y,
                roundX: 0,
                roundY: 0
            });
            if (modifiedSelected) editor.instance.selectNodes(selected.length > 0 ? new BigUint64Array(selected) : undefined);
            return;
        }
        // Clicked on the graph background
        if (lmb && selected.length !== 0) {
            $$invalidate(9, selected = []);
            editor.instance.selectNodes(undefined);
        }
        // LMB clicked on the graph background or MMB clicked anywhere
        panning = true;
    }
    // if (nodeId) {
    // 	const id = BigInt(nodeId);
    // 	editor.instance.doubleClickNode(id);
    // }
    function pointerMove(e) {
        if (panning) {
            $$invalidate(1, transform.x += e.movementX / transform.scale, transform);
            $$invalidate(1, transform.y += e.movementY / transform.scale, transform);
        } else if (linkInProgressFromConnector && !nodeListLocation) {
            const target = e.target;
            const dot = target?.closest(`[data-port="input"]`) || undefined;
            if (dot) $$invalidate(24, linkInProgressToConnector = dot);
            else $$invalidate(24, linkInProgressToConnector = new DOMRect(e.x, e.y));
        } else if (draggingNodes) {
            const deltaX = Math.round((e.x - draggingNodes.startX) / transform.scale / $2af2864a5b707c5b$var$GRID_SIZE);
            const deltaY = Math.round((e.y - draggingNodes.startY) / transform.scale / $2af2864a5b707c5b$var$GRID_SIZE);
            if (draggingNodes.roundX !== deltaX || draggingNodes.roundY !== deltaY) {
                $$invalidate(10, draggingNodes.roundX = deltaX, draggingNodes);
                $$invalidate(10, draggingNodes.roundY = deltaY, draggingNodes);
                let stop = false;
                const refresh = ()=>{
                    if (!stop) refreshLinks();
                    requestAnimationFrame(refresh);
                };
                refresh();
                // const DRAG_SMOOTHING_TIME = 0.1;
                const DRAG_SMOOTHING_TIME = 0; // TODO: Reenable this after fixing the bugs with the wires, see the CSS `transition` attribute todo for other info
                setTimeout(()=>{
                    stop = true;
                }, DRAG_SMOOTHING_TIME * 1000 + 10);
            }
        }
    }
    // Check if this node should be inserted between two other nodes
    function checkInsertBetween() {
        if (selected.length !== 1) return;
        const selectedNodeId = selected[0];
        const selectedNode = nodesContainer?.querySelector(`[data-node="${String(selectedNodeId)}"]`) || undefined;
        // Check that neither the input or output of the selected node are already connected.
        const notConnected = $nodeGraph.links.findIndex((link)=>link.linkStart === selectedNodeId || link.linkEnd === selectedNodeId && link.linkEndInputIndex === BigInt(0)) === -1;
        const input = selectedNode?.querySelector(`[data-port="input"]`) || undefined;
        const output = selectedNode?.querySelector(`[data-port="output"]`) || undefined;
        // TODO: Make sure inputs are correctly typed
        if (!selectedNode || !notConnected || !input || !output || !nodesContainer) return;
        // Fixes typing for some reason?
        const theNodesContainer = nodesContainer;
        // Find the link that the node has been dragged on top of
        const link = $nodeGraph.links.find((link)=>{
            const { nodeInput: nodeInput, nodeOutput: nodeOutput } = $2af2864a5b707c5b$var$resolveLink(link, theNodesContainer);
            if (!nodeInput || !nodeOutput) return false;
            const wireCurveLocations = buildWirePathLocations(nodeOutput.getBoundingClientRect(), nodeInput.getBoundingClientRect(), false, false);
            const selectedNodeBounds = selectedNode.getBoundingClientRect();
            const containerBoundsBounds = theNodesContainer.getBoundingClientRect();
            return editor.instance.rectangleIntersects(new Float64Array(wireCurveLocations.map((loc)=>loc.x)), new Float64Array(wireCurveLocations.map((loc)=>loc.y)), selectedNodeBounds.top - containerBoundsBounds.y, selectedNodeBounds.left - containerBoundsBounds.x, selectedNodeBounds.bottom - containerBoundsBounds.y, selectedNodeBounds.right - containerBoundsBounds.x);
        });
        // If the node has been dragged on top of the link then connect it into the middle.
        if (link) {
            editor.instance.connectNodesByLink(link.linkStart, 0, selectedNodeId, 0);
            editor.instance.connectNodesByLink(selectedNodeId, 0, link.linkEnd, Number(link.linkEndInputIndex));
            editor.instance.shiftNode(selectedNodeId);
        }
    }
    function pointerUp(e) {
        panning = false;
        const initialDisconnecting = disconnecting;
        if (disconnecting) editor.instance.disconnectNodes(BigInt(disconnecting.nodeId), disconnecting.inputIndex);
        disconnecting = undefined;
        if (linkInProgressToConnector instanceof SVGSVGElement && linkInProgressFromConnector) {
            const from = $2af2864a5b707c5b$var$connectorToNodeIndex(linkInProgressFromConnector);
            const to = $2af2864a5b707c5b$var$connectorToNodeIndex(linkInProgressToConnector);
            if (from !== undefined && to !== undefined) {
                const { nodeId: outputConnectedNodeID, index: outputNodeConnectionIndex } = from;
                const { nodeId: inputConnectedNodeID, index: inputNodeConnectionIndex } = to;
                editor.instance.connectNodesByLink(outputConnectedNodeID, outputNodeConnectionIndex, inputConnectedNodeID, inputNodeConnectionIndex);
            }
        } else if (linkInProgressFromConnector && !initialDisconnecting) {
            // If the add node menu is already open, we don't want to open it again
            if (nodeListLocation) return;
            const graphBounds = graph?.getBoundingClientRect();
            if (!graphBounds) return;
            // Create the node list, which should set nodeListLocation to a valid value
            loadNodeList(e, graphBounds);
            if (!nodeListLocation) return;
            let nodeListLocation2 = nodeListLocation;
            $$invalidate(24, linkInProgressToConnector = new DOMRect((nodeListLocation2.x * $2af2864a5b707c5b$var$GRID_SIZE + transform.x) * transform.scale + graphBounds.x, (nodeListLocation2.y * $2af2864a5b707c5b$var$GRID_SIZE + transform.y) * transform.scale + graphBounds.y));
            return;
        } else if (draggingNodes) {
            if (draggingNodes.startX === e.x || draggingNodes.startY === e.y) {
                if (selectIfNotDragged !== undefined && (selected.length !== 1 || selected[0] !== selectIfNotDragged)) {
                    $$invalidate(9, selected = [
                        selectIfNotDragged
                    ]);
                    editor.instance.selectNodes(new BigUint64Array(selected));
                }
            }
            if (selected.length > 0 && (draggingNodes.roundX !== 0 || draggingNodes.roundY !== 0)) editor.instance.moveSelectedNodes(draggingNodes.roundX, draggingNodes.roundY);
            checkInsertBetween();
            $$invalidate(10, draggingNodes = undefined);
            selectIfNotDragged = undefined;
        }
        $$invalidate(23, linkInProgressFromConnector = undefined);
        $$invalidate(24, linkInProgressToConnector = undefined);
    }
    function createNode(nodeType) {
        if (!nodeListLocation) return;
        const inputNodeConnectionIndex = 0;
        const inputConnectedNodeID = editor.instance.createNode(nodeType, nodeListLocation.x, nodeListLocation.y - 1);
        $$invalidate(3, nodeListLocation = undefined);
        if (!linkInProgressFromConnector) return;
        const from = $2af2864a5b707c5b$var$connectorToNodeIndex(linkInProgressFromConnector);
        if (from !== undefined) {
            const { nodeId: outputConnectedNodeID, index: outputNodeConnectionIndex } = from;
            editor.instance.connectNodesByLink(outputConnectedNodeID, outputNodeConnectionIndex, inputConnectedNodeID, inputNodeConnectionIndex);
        }
        $$invalidate(23, linkInProgressFromConnector = undefined);
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$a0a41f40ae7c5072), (updateNodeGraphSelection)=>{
            $$invalidate(9, selected = updateNodeGraphSelection.selected);
        });
    });
    function wheel_handler(event) {
        (0, $1eb80e36873dc327$export$f5dbf5ce556e97fb).call(this, $$self, event);
    }
    function textinput_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            nodeSearchInput = $$value;
            $$invalidate(8, nodeSearchInput);
        });
    }
    const value_handler = ({ detail: detail })=>$$invalidate(2, searchTerm = detail);
    const func = (nodeType)=>createNode(nodeType.name);
    function div1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            nodesContainer = $$value;
            $$invalidate(7, nodesContainer);
        });
    }
    function div2_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            graph = $$value;
            $$invalidate(0, graph);
        });
    }
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*$nodeGraph*/ 64) $: watchNodes($nodeGraph.nodes);
        if ($$self.$$.dirty[0] & /*transform*/ 2) $: $$invalidate(16, gridSpacing = $2af2864a5b707c5b$var$calculateGridSpacing(transform.scale));
        if ($$self.$$.dirty[0] & /*transform*/ 2) $: $$invalidate(15, dotRadius = 1 + Math.floor(transform.scale - 0.5 + 0.001) / 2);
        if ($$self.$$.dirty[0] & /*$nodeGraph, searchTerm*/ 68) $: $$invalidate(14, nodeCategories = $2af2864a5b707c5b$var$buildNodeCategories($nodeGraph.nodeTypes, searchTerm));
        if ($$self.$$.dirty[0] & /*nodeListLocation, transform*/ 10) $: $$invalidate(5, nodeListX = ((nodeListLocation?.x || 0) * $2af2864a5b707c5b$var$GRID_SIZE + transform.x) * transform.scale);
        if ($$self.$$.dirty[0] & /*nodeListLocation, transform*/ 10) $: $$invalidate(4, nodeListY = ((nodeListLocation?.y || 0) * $2af2864a5b707c5b$var$GRID_SIZE + transform.y) * transform.scale);
        if ($$self.$$.dirty[0] & /*graph, nodeListX, nodeListY*/ 49) $: (()=>{
            const bounds = graph?.getBoundingClientRect();
            if (!bounds) return;
            const { width: width, height: height } = bounds;
            $$invalidate(12, appearRightOfMouse = nodeListX > width - $2af2864a5b707c5b$var$ADD_NODE_MENU_WIDTH / 2);
            $$invalidate(11, appearAboveMouse = nodeListY > height - $2af2864a5b707c5b$var$ADD_NODE_MENU_HEIGHT / 2);
        })();
        if ($$self.$$.dirty[0] & /*linkInProgressFromConnector, linkInProgressToConnector*/ 25165824) $: $$invalidate(26, linkPathInProgress = createLinkPathInProgress(linkInProgressFromConnector, linkInProgressToConnector));
        if ($$self.$$.dirty[0] & /*linkPathInProgress, nodeLinkPaths*/ 100663296) $: $$invalidate(13, linkPaths = createLinkPaths(linkPathInProgress, nodeLinkPaths));
    };
    return [
        graph,
        transform,
        searchTerm,
        nodeListLocation,
        nodeListY,
        nodeListX,
        $nodeGraph,
        nodesContainer,
        nodeSearchInput,
        selected,
        draggingNodes,
        appearAboveMouse,
        appearRightOfMouse,
        linkPaths,
        nodeCategories,
        dotRadius,
        gridSpacing,
        nodeGraph,
        scroll,
        pointerDown,
        pointerMove,
        pointerUp,
        createNode,
        linkInProgressFromConnector,
        linkInProgressToConnector,
        nodeLinkPaths,
        linkPathInProgress,
        wheel_handler,
        textinput_binding,
        value_handler,
        func,
        div1_binding,
        div2_binding
    ];
}
class $2af2864a5b707c5b$var$Graph extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $2af2864a5b707c5b$var$instance, $2af2864a5b707c5b$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {}, null, [
            -1,
            -1,
            -1
        ]);
    }
}
var $2af2864a5b707c5b$export$2e2bcd8739ae039 = $2af2864a5b707c5b$var$Graph;


/* src/components/widgets/metrics/CanvasRuler.svelte generated by Svelte v3.58.0 */ 
function $2a9368162c41e49c$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[13] = list[i];
    child_ctx[15] = i;
    return child_ctx;
}
// (83:2) {#each svgTexts as svgText, index (index)}
function $2a9368162c41e49c$var$create_each_block(key_1, ctx) {
    let text_1;
    let t_value = /*svgText*/ ctx[13].text + "";
    let t;
    let text_1_transform_value;
    return {
        key: key_1,
        first: null,
        c () {
            text_1 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("text");
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(text_1, "transform", text_1_transform_value = /*svgText*/ ctx[13].transform);
            this.first = text_1;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, text_1, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(text_1, t);
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*svgTexts*/ 8 && t_value !== (t_value = /*svgText*/ ctx[13].text + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
            if (dirty & /*svgTexts*/ 8 && text_1_transform_value !== (text_1_transform_value = /*svgText*/ ctx[13].transform)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(text_1, "transform", text_1_transform_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(text_1);
        }
    };
}
function $2a9368162c41e49c$var$create_fragment(ctx) {
    let div;
    let svg;
    let path;
    let each_blocks = [];
    let each_1_lookup = new Map();
    let div_class_value;
    let each_value = /*svgTexts*/ ctx[3];
    const get_key = (ctx)=>/*index*/ ctx[15];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $2a9368162c41e49c$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $2a9368162c41e49c$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            svg = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            path = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("path");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", /*svgPath*/ ctx[4]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "width", /*svgBounds*/ ctx[2].width);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "height", /*svgBounds*/ ctx[2].height);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value = `canvas-ruler ${ctx[0].toLowerCase()}`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div, svg);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(svg, path);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(svg, null);
            /*div_binding*/ ctx[12](div);
        },
        p (ctx, [dirty]) {
            if (dirty & /*svgPath*/ 16) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(path, "d", /*svgPath*/ ctx[4]);
            if (dirty & /*svgTexts*/ 8) {
                each_value = /*svgTexts*/ ctx[3];
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, svg, (0, $1eb80e36873dc327$export$75442db144d4e64e), $2a9368162c41e49c$var$create_each_block, null, $2a9368162c41e49c$var$get_each_context);
            }
            if (dirty & /*svgBounds*/ 4) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "width", /*svgBounds*/ ctx[2].width);
            if (dirty & /*svgBounds*/ 4) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg, "height", /*svgBounds*/ ctx[2].height);
            if (dirty & /*direction*/ 1 && div_class_value !== (div_class_value = `canvas-ruler ${ctx[0].toLowerCase()}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div, "class", div_class_value);
        },
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d();
            /*div_binding*/ ctx[12](null);
        }
    };
}
const $2a9368162c41e49c$var$RULER_THICKNESS = 16;
const $2a9368162c41e49c$var$MAJOR_MARK_THICKNESS = 16;
const $2a9368162c41e49c$var$MEDIUM_MARK_THICKNESS = 6;
const $2a9368162c41e49c$var$MINOR_MARK_THICKNESS = 3;
function $2a9368162c41e49c$var$computeSvgPath(direction, origin, majorMarkSpacing, mediumDivisions, minorDivisions, rulerLength) {
    const isVertical = direction === "Vertical";
    const lineDirection = isVertical ? "H" : "V";
    const offsetStart = $2a9368162c41e49c$var$mod(origin, majorMarkSpacing);
    const shiftedOffsetStart = offsetStart - majorMarkSpacing;
    const divisions = majorMarkSpacing / mediumDivisions / minorDivisions;
    const majorMarksFrequency = mediumDivisions * minorDivisions;
    let dPathAttribute = "";
    let i = 0;
    for(let location = shiftedOffsetStart; location < rulerLength; location += divisions){
        let length;
        if (i % majorMarksFrequency === 0) length = $2a9368162c41e49c$var$MAJOR_MARK_THICKNESS;
        else if (i % minorDivisions === 0) length = $2a9368162c41e49c$var$MEDIUM_MARK_THICKNESS;
        else length = $2a9368162c41e49c$var$MINOR_MARK_THICKNESS;
        i += 1;
        const destination = Math.round(location) + 0.5;
        const startPoint = isVertical ? `${$2a9368162c41e49c$var$RULER_THICKNESS - length},${destination}` : `${destination},${$2a9368162c41e49c$var$RULER_THICKNESS - length}`;
        dPathAttribute += `M${startPoint}${lineDirection}${$2a9368162c41e49c$var$RULER_THICKNESS} `;
    }
    return dPathAttribute;
}
function $2a9368162c41e49c$var$computeSvgTexts(direction, origin, majorMarkSpacing, numberInterval, rulerLength) {
    const isVertical = direction === "Vertical";
    const offsetStart = $2a9368162c41e49c$var$mod(origin, majorMarkSpacing);
    const shiftedOffsetStart = offsetStart - majorMarkSpacing;
    const svgTextCoordinates = [];
    let text = (Math.ceil(-origin / majorMarkSpacing) - 1) * numberInterval;
    for(let location = shiftedOffsetStart; location < rulerLength; location += majorMarkSpacing){
        const destination = Math.round(location);
        const x = isVertical ? 9 : destination + 2;
        const y = isVertical ? destination + 1 : 9;
        let transform = `translate(${x} ${y})`;
        if (isVertical) transform += " rotate(270)";
        svgTextCoordinates.push({
            transform: transform,
            text: text
        });
        text += numberInterval;
    }
    return svgTextCoordinates;
}
// Modulo function that works for negative numbers, unlike the JS `%` operator
function $2a9368162c41e49c$var$mod(n, m) {
    const remainder = n % m;
    return Math.floor(remainder >= 0 ? remainder : remainder + m);
}
function $2a9368162c41e49c$var$instance($$self, $$props, $$invalidate) {
    let svgPath;
    let svgTexts;
    let { direction: direction = "Vertical" } = $$props;
    let { origin: origin } = $$props;
    let { numberInterval: numberInterval } = $$props;
    let { majorMarkSpacing: majorMarkSpacing } = $$props;
    let { mediumDivisions: mediumDivisions = 5 } = $$props;
    let { minorDivisions: minorDivisions = 2 } = $$props;
    let canvasRuler;
    let rulerLength = 0;
    let svgBounds = {
        width: "0px",
        height: "0px"
    };
    function resize() {
        if (!canvasRuler) return;
        const isVertical = direction === "Vertical";
        const newLength = isVertical ? canvasRuler.clientHeight : canvasRuler.clientWidth;
        const roundedUp = (Math.floor(newLength / majorMarkSpacing) + 1) * majorMarkSpacing;
        if (roundedUp !== rulerLength) {
            $$invalidate(11, rulerLength = roundedUp);
            const thickness = `${$2a9368162c41e49c$var$RULER_THICKNESS}px`;
            const length = `${roundedUp}px`;
            $$invalidate(2, svgBounds = isVertical ? {
                width: thickness,
                height: length
            } : {
                width: length,
                height: thickness
            });
        }
    }
    function div_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            canvasRuler = $$value;
            $$invalidate(1, canvasRuler);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("direction" in $$props) $$invalidate(0, direction = $$props.direction);
        if ("origin" in $$props) $$invalidate(5, origin = $$props.origin);
        if ("numberInterval" in $$props) $$invalidate(6, numberInterval = $$props.numberInterval);
        if ("majorMarkSpacing" in $$props) $$invalidate(7, majorMarkSpacing = $$props.majorMarkSpacing);
        if ("mediumDivisions" in $$props) $$invalidate(8, mediumDivisions = $$props.mediumDivisions);
        if ("minorDivisions" in $$props) $$invalidate(9, minorDivisions = $$props.minorDivisions);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*direction, origin, majorMarkSpacing, mediumDivisions, minorDivisions, rulerLength*/ 2977) $: $$invalidate(4, svgPath = $2a9368162c41e49c$var$computeSvgPath(direction, origin, majorMarkSpacing, mediumDivisions, minorDivisions, rulerLength));
        if ($$self.$$.dirty & /*direction, origin, majorMarkSpacing, numberInterval, rulerLength*/ 2273) $: $$invalidate(3, svgTexts = $2a9368162c41e49c$var$computeSvgTexts(direction, origin, majorMarkSpacing, numberInterval, rulerLength));
    };
    return [
        direction,
        canvasRuler,
        svgBounds,
        svgTexts,
        svgPath,
        origin,
        numberInterval,
        majorMarkSpacing,
        mediumDivisions,
        minorDivisions,
        resize,
        rulerLength,
        div_binding
    ];
}
class $2a9368162c41e49c$var$CanvasRuler extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $2a9368162c41e49c$var$instance, $2a9368162c41e49c$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            direction: 0,
            origin: 5,
            numberInterval: 6,
            majorMarkSpacing: 7,
            mediumDivisions: 8,
            minorDivisions: 9,
            resize: 10
        });
    }
    get resize() {
        return this.$$.ctx[10];
    }
}
var $2a9368162c41e49c$export$2e2bcd8739ae039 = $2a9368162c41e49c$var$CanvasRuler;


/* src/components/widgets/metrics/PersistentScrollbar.svelte generated by Svelte v3.58.0 */ 

function $a5a04a9eed68a344$var$create_fragment(ctx) {
    let div2;
    let button0;
    let t0;
    let div1;
    let div0;
    let t1;
    let button1;
    let div2_class_value;
    let mounted;
    let dispose;
    return {
        c () {
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            button0 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            button1 = (0, $1eb80e36873dc327$export$8454457683f90105)("button");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "class", "arrow decrease");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button0, "tabindex", "-1");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "scroll-thumb");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div0, "dragging", /*dragging*/ ctx[2]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "top", /*thumbTop*/ ctx[3]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "bottom", /*thumbBottom*/ ctx[4]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "left", /*thumbLeft*/ ctx[5]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "right", /*thumbRight*/ ctx[6]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "scroll-track");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "class", "arrow increase");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(button1, "tabindex", "-1");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", div2_class_value = `persistent-scrollbar ${ctx[0].toLowerCase()}`);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div2, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, button0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, div1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, div0);
            /*div1_binding*/ ctx[15](div1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div2, button1);
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button0, "pointerdown", /*pointerdown_handler*/ ctx[14]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div0, "pointerdown", /*grabHandle*/ ctx[7]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div1, "pointerdown", /*grabArea*/ ctx[8]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(button1, "click", /*click_handler*/ ctx[16])
                ];
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*dragging*/ 4) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div0, "dragging", /*dragging*/ ctx[2]);
            if (dirty & /*thumbTop*/ 8) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "top", /*thumbTop*/ ctx[3]);
            if (dirty & /*thumbBottom*/ 16) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "bottom", /*thumbBottom*/ ctx[4]);
            if (dirty & /*thumbLeft*/ 32) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "left", /*thumbLeft*/ ctx[5]);
            if (dirty & /*thumbRight*/ 64) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "right", /*thumbRight*/ ctx[6]);
            if (dirty & /*direction*/ 1 && div2_class_value !== (div2_class_value = `persistent-scrollbar ${ctx[0].toLowerCase()}`)) (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", div2_class_value);
        },
        i: (0, $1eb80e36873dc327$export$8793edee2d425525),
        o: (0, $1eb80e36873dc327$export$8793edee2d425525),
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div2);
            /*div1_binding*/ ctx[15](null);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
function $a5a04a9eed68a344$var$instance($$self, $$props, $$invalidate) {
    let start;
    let end;
    const lerp = (x, y, a)=>x * (1 - a) + y * a;
    // Convert the position of the handle (0-1) to the position on the track (0-1).
    // This includes the 1/2 handle length gap of the possible handle positionson each side so the end of the handle doesn't go off the track.
    const handleToTrack = (handleLen, handlePos)=>lerp(handleLen / 2, 1 - handleLen / 2, handlePos);
    const pointerPosition = (direction, e)=>direction === "Vertical" ? e.clientY : e.clientX;
    // emits: { "update:handlePosition": null, pressTrack: (pointerOffset: number) => typeof pointerOffset === "number" }
    const dispatch = (0, $1eb80e36873dc327$export$2a380c922b2bd2b3)();
    let { direction: direction = "Vertical" } = $$props;
    let { handlePosition: handlePosition = 0.5 } = $$props;
    let { handleLength: handleLength = 0.5 } = $$props;
    let scrollTrack;
    let dragging = false;
    let pointerPos = 0;
    let thumbTop = undefined;
    let thumbBottom = undefined;
    let thumbLeft = undefined;
    let thumbRight = undefined;
    function trackLength() {
        if (scrollTrack === undefined) return undefined;
        return direction === "Vertical" ? scrollTrack.clientHeight - handleLength : scrollTrack.clientWidth;
    }
    function trackOffset() {
        if (scrollTrack === undefined) return undefined;
        return direction === "Vertical" ? scrollTrack.getBoundingClientRect().top : scrollTrack.getBoundingClientRect().left;
    }
    function clampHandlePosition(newPos) {
        const clampedPosition = Math.min(Math.max(newPos, 0), 1);
        dispatch("handlePosition", clampedPosition);
    }
    function updateHandlePosition(e) {
        const length = trackLength();
        if (length === undefined) return;
        const position = pointerPosition(direction, e);
        clampHandlePosition(handlePosition + (position - pointerPos) / (length * (1 - handleLength)));
        pointerPos = position;
    }
    function grabHandle(e) {
        if (!dragging) {
            $$invalidate(2, dragging = true);
            pointerPos = pointerPosition(direction, e);
        }
    }
    function grabArea(e) {
        if (!dragging) {
            const length = trackLength();
            const offset = trackOffset();
            if (length === undefined || offset === undefined) return;
            const oldPointer = handleToTrack(handleLength, handlePosition) * length + offset;
            const pointerPos = pointerPosition(direction, e);
            dispatch("pressTrack", pointerPos - oldPointer);
        }
    }
    function pointerUp() {
        $$invalidate(2, dragging = false);
    }
    function pointerMove(e) {
        if (dragging) updateHandlePosition(e);
    }
    function changePosition(difference) {
        const length = trackLength();
        if (length === undefined) return;
        clampHandlePosition(handlePosition + difference / length);
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        window.addEventListener("pointerup", pointerUp);
        window.addEventListener("pointermove", pointerMove);
    });
    (0, $1eb80e36873dc327$export$f1238fd06ad9b453)(()=>{
        window.removeEventListener("pointerup", pointerUp);
        window.removeEventListener("pointermove", pointerMove);
    });
    const pointerdown_handler = ()=>changePosition(-50);
    function div1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            scrollTrack = $$value;
            $$invalidate(1, scrollTrack);
        });
    }
    const click_handler = ()=>changePosition(50);
    $$self.$$set = ($$props)=>{
        if ("direction" in $$props) $$invalidate(0, direction = $$props.direction);
        if ("handlePosition" in $$props) $$invalidate(10, handlePosition = $$props.handlePosition);
        if ("handleLength" in $$props) $$invalidate(11, handleLength = $$props.handleLength);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*handleLength, handlePosition*/ 3072) $: $$invalidate(13, start = handleToTrack(handleLength, handlePosition) - handleLength / 2);
        if ($$self.$$.dirty & /*handleLength, handlePosition*/ 3072) $: $$invalidate(12, end = 1 - handleToTrack(handleLength, handlePosition) - handleLength / 2);
        if ($$self.$$.dirty & /*direction, start, end*/ 12289) $: $$invalidate(3, [thumbTop, thumbBottom, thumbLeft, thumbRight] = direction === "Vertical" ? [
            `${start * 100}%`,
            `${end * 100}%`,
            "0%",
            "0%"
        ] : [
            "0%",
            "0%",
            `${start * 100}%`,
            `${end * 100}%`
        ], thumbTop, ((((($$invalidate(4, thumbBottom), $$invalidate(0, direction)), $$invalidate(13, start)), $$invalidate(12, end)), $$invalidate(11, handleLength)), $$invalidate(10, handlePosition)), ((((($$invalidate(5, thumbLeft), $$invalidate(0, direction)), $$invalidate(13, start)), $$invalidate(12, end)), $$invalidate(11, handleLength)), $$invalidate(10, handlePosition)), ((((($$invalidate(6, thumbRight), $$invalidate(0, direction)), $$invalidate(13, start)), $$invalidate(12, end)), $$invalidate(11, handleLength)), $$invalidate(10, handlePosition)));
    };
    return [
        direction,
        scrollTrack,
        dragging,
        thumbTop,
        thumbBottom,
        thumbLeft,
        thumbRight,
        grabHandle,
        grabArea,
        changePosition,
        handlePosition,
        handleLength,
        end,
        start,
        pointerdown_handler,
        div1_binding,
        click_handler
    ];
}
class $a5a04a9eed68a344$var$PersistentScrollbar extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $a5a04a9eed68a344$var$instance, $a5a04a9eed68a344$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            direction: 0,
            handlePosition: 10,
            handleLength: 11
        });
    }
}
var $a5a04a9eed68a344$export$2e2bcd8739ae039 = $a5a04a9eed68a344$var$PersistentScrollbar;



function $9241e0ea152cacb3$var$create_else_block(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$document*/ ctx[25].nodeGraphBarLayout
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty[0] & /*$document*/ 33554432) widgetlayout_changes.layout = /*$document*/ ctx[25].nodeGraphBarLayout;
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (326:2) {#if !$document.graphViewOverlayOpen}
function $9241e0ea152cacb3$var$create_if_block_3(ctx) {
    let widgetlayout0;
    let t0;
    let widgetlayout1;
    let t1;
    let layoutrow;
    let t2;
    let widgetlayout2;
    let current;
    widgetlayout0 = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$document*/ ctx[25].documentModeLayout
        }
    });
    widgetlayout1 = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$document*/ ctx[25].toolOptionsLayout
        }
    });
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "spacer"
        }
    });
    widgetlayout2 = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$document*/ ctx[25].documentBarLayout
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout2.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t2, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout2, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout0_changes = {};
            if (dirty[0] & /*$document*/ 33554432) widgetlayout0_changes.layout = /*$document*/ ctx[25].documentModeLayout;
            widgetlayout0.$set(widgetlayout0_changes);
            const widgetlayout1_changes = {};
            if (dirty[0] & /*$document*/ 33554432) widgetlayout1_changes.layout = /*$document*/ ctx[25].toolOptionsLayout;
            widgetlayout1.$set(widgetlayout1_changes);
            const widgetlayout2_changes = {};
            if (dirty[0] & /*$document*/ 33554432) widgetlayout2_changes.layout = /*$document*/ ctx[25].documentBarLayout;
            widgetlayout2.$set(widgetlayout2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t2);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout2, detaching);
        }
    };
}
// (325:1) <LayoutRow class="options-bar" classes={{ "for-graph": $document.graphViewOverlayOpen }} scrollableX={true}>
function $9241e0ea152cacb3$var$create_default_slot_12(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $9241e0ea152cacb3$var$create_if_block_3,
        $9241e0ea152cacb3$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (!/*$document*/ ctx[25].graphViewOverlayOpen) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, [
        -1,
        -1
    ]);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (337:3) {#if !$document.graphViewOverlayOpen}
function $9241e0ea152cacb3$var$create_if_block_2(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "tools",
            scrollableY: true,
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_11
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty[0] & /*$document*/ 33554432 | dirty[1] & /*$$scope*/ 1073741824) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
// (338:4) <LayoutCol class="tools" scrollableY={true}>
function $9241e0ea152cacb3$var$create_default_slot_11(ctx) {
    let widgetlayout;
    let current;
    widgetlayout = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$document*/ ctx[25].toolShelfLayout
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout_changes = {};
            if (dirty[0] & /*$document*/ 33554432) widgetlayout_changes.layout = /*$document*/ ctx[25].toolShelfLayout;
            widgetlayout.$set(widgetlayout_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout, detaching);
        }
    };
}
// (343:3) <LayoutCol class="shelf-bottom-widgets">
function $9241e0ea152cacb3$var$create_default_slot_10(ctx) {
    let widgetlayout0;
    let t;
    let widgetlayout1;
    let current;
    widgetlayout0 = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$document*/ ctx[25].graphViewOverlayButtonLayout
        }
    });
    widgetlayout1 = new (0, $48763e60decd937b$export$2e2bcd8739ae039)({
        props: {
            layout: /*$document*/ ctx[25].workingColorsLayout
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(widgetlayout1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(widgetlayout1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const widgetlayout0_changes = {};
            if (dirty[0] & /*$document*/ 33554432) widgetlayout0_changes.layout = /*$document*/ ctx[25].graphViewOverlayButtonLayout;
            widgetlayout0.$set(widgetlayout0_changes);
            const widgetlayout1_changes = {};
            if (dirty[0] & /*$document*/ 33554432) widgetlayout1_changes.layout = /*$document*/ ctx[25].workingColorsLayout;
            widgetlayout1.$set(widgetlayout1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(widgetlayout1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(widgetlayout1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(widgetlayout1, detaching);
        }
    };
}
// (336:2) <LayoutCol class="shelf">
function $9241e0ea152cacb3$var$create_default_slot_9(ctx) {
    let t0;
    let layoutcol0;
    let t1;
    let layoutcol1;
    let current;
    let if_block = !/*$document*/ ctx[25].graphViewOverlayOpen && $9241e0ea152cacb3$var$create_if_block_2(ctx);
    layoutcol0 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "spacer"
        }
    });
    layoutcol1 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "shelf-bottom-widgets",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_10
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            if (if_block) if_block.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol0.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol1.$$.fragment);
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (!/*$document*/ ctx[25].graphViewOverlayOpen) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty[0] & /*$document*/ 33554432) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $9241e0ea152cacb3$var$create_if_block_2(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t0.parentNode, t0);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            const layoutcol1_changes = {};
            if (dirty[0] & /*$document*/ 33554432 | dirty[1] & /*$$scope*/ 1073741824) layoutcol1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol1.$set(layoutcol1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol1, detaching);
        }
    };
}
// (349:3) <LayoutRow class="ruler-or-scrollbar top-ruler">
function $9241e0ea152cacb3$var$create_default_slot_8(ctx) {
    let canvasruler;
    let current;
    let canvasruler_props = {
        origin: /*rulerOrigin*/ ctx[9].x,
        majorMarkSpacing: /*rulerSpacing*/ ctx[10],
        numberInterval: /*rulerInterval*/ ctx[11],
        direction: "Horizontal"
    };
    canvasruler = new (0, $2a9368162c41e49c$export$2e2bcd8739ae039)({
        props: canvasruler_props
    });
    /*canvasruler_binding*/ ctx[47](canvasruler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(canvasruler.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(canvasruler, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const canvasruler_changes = {};
            if (dirty[0] & /*rulerOrigin*/ 512) canvasruler_changes.origin = /*rulerOrigin*/ ctx[9].x;
            if (dirty[0] & /*rulerSpacing*/ 1024) canvasruler_changes.majorMarkSpacing = /*rulerSpacing*/ ctx[10];
            if (dirty[0] & /*rulerInterval*/ 2048) canvasruler_changes.numberInterval = /*rulerInterval*/ ctx[11];
            canvasruler.$set(canvasruler_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(canvasruler.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(canvasruler.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*canvasruler_binding*/ ctx[47](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(canvasruler, detaching);
        }
    };
}
// (353:4) <LayoutCol class="ruler-or-scrollbar">
function $9241e0ea152cacb3$var$create_default_slot_7(ctx) {
    let canvasruler;
    let current;
    let canvasruler_props = {
        origin: /*rulerOrigin*/ ctx[9].y,
        majorMarkSpacing: /*rulerSpacing*/ ctx[10],
        numberInterval: /*rulerInterval*/ ctx[11],
        direction: "Vertical"
    };
    canvasruler = new (0, $2a9368162c41e49c$export$2e2bcd8739ae039)({
        props: canvasruler_props
    });
    /*canvasruler_binding_1*/ ctx[48](canvasruler);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(canvasruler.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(canvasruler, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const canvasruler_changes = {};
            if (dirty[0] & /*rulerOrigin*/ 512) canvasruler_changes.origin = /*rulerOrigin*/ ctx[9].y;
            if (dirty[0] & /*rulerSpacing*/ 1024) canvasruler_changes.majorMarkSpacing = /*rulerSpacing*/ ctx[10];
            if (dirty[0] & /*rulerInterval*/ 2048) canvasruler_changes.numberInterval = /*rulerInterval*/ ctx[11];
            canvasruler.$set(canvasruler_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(canvasruler.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(canvasruler.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*canvasruler_binding_1*/ ctx[48](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(canvasruler, detaching);
        }
    };
}
// (357:5) {#if cursorEyedropper}
function $9241e0ea152cacb3$var$create_if_block_1(ctx) {
    let eyedropperpreview;
    let current;
    eyedropperpreview = new (0, $a442d3020821b0e2$export$2e2bcd8739ae039)({
        props: {
            colorChoice: /*cursorEyedropperPreviewColorChoice*/ ctx[20],
            primaryColor: /*cursorEyedropperPreviewColorPrimary*/ ctx[21],
            secondaryColor: /*cursorEyedropperPreviewColorSecondary*/ ctx[22],
            imageData: /*cursorEyedropperPreviewImageData*/ ctx[19],
            x: /*cursorLeft*/ ctx[16],
            y: /*cursorTop*/ ctx[17]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(eyedropperpreview.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(eyedropperpreview, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const eyedropperpreview_changes = {};
            if (dirty[0] & /*cursorEyedropperPreviewColorChoice*/ 1048576) eyedropperpreview_changes.colorChoice = /*cursorEyedropperPreviewColorChoice*/ ctx[20];
            if (dirty[0] & /*cursorEyedropperPreviewColorPrimary*/ 2097152) eyedropperpreview_changes.primaryColor = /*cursorEyedropperPreviewColorPrimary*/ ctx[21];
            if (dirty[0] & /*cursorEyedropperPreviewColorSecondary*/ 4194304) eyedropperpreview_changes.secondaryColor = /*cursorEyedropperPreviewColorSecondary*/ ctx[22];
            if (dirty[0] & /*cursorEyedropperPreviewImageData*/ 524288) eyedropperpreview_changes.imageData = /*cursorEyedropperPreviewImageData*/ ctx[19];
            if (dirty[0] & /*cursorLeft*/ 65536) eyedropperpreview_changes.x = /*cursorLeft*/ ctx[16];
            if (dirty[0] & /*cursorTop*/ 131072) eyedropperpreview_changes.y = /*cursorTop*/ ctx[17];
            eyedropperpreview.$set(eyedropperpreview_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(eyedropperpreview.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(eyedropperpreview.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(eyedropperpreview, detaching);
        }
    };
}
// (381:7) {#if showTextInput}
function $9241e0ea152cacb3$var$create_if_block(ctx) {
    let div;
    let style_transform = `matrix(${ctx[5]})`;
    return {
        c () {
            div = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "transform", style_transform);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div, anchor);
            /*div_binding*/ ctx[49](div);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*textInputMatrix*/ 32 && style_transform !== (style_transform = `matrix(${ctx[5]})`)) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div, "transform", style_transform);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div);
            /*div_binding*/ ctx[49](null);
        }
    };
}
// (356:4) <LayoutCol class="viewport-container" styles={{ cursor: canvasCursor }}>
function $9241e0ea152cacb3$var$create_default_slot_6(ctx) {
    let t0;
    let div1;
    let svg0;
    let t1;
    let svg1;
    let t2;
    let svg2;
    let t3;
    let svg3;
    let t4;
    let div0;
    let t5;
    let div2;
    let graph;
    let current;
    let mounted;
    let dispose;
    let if_block0 = /*cursorEyedropper*/ ctx[18] && $9241e0ea152cacb3$var$create_if_block_1(ctx);
    let if_block1 = /*showTextInput*/ ctx[4] && $9241e0ea152cacb3$var$create_if_block(ctx);
    graph = new (0, $2af2864a5b707c5b$export$2e2bcd8739ae039)({});
    return {
        c () {
            if (if_block0) if_block0.c();
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div1 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            svg0 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            svg1 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            svg2 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            svg3 = (0, $1eb80e36873dc327$export$3967a3bb66708d71)("svg");
            t4 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div0 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            if (if_block1) if_block1.c();
            t5 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            div2 = (0, $1eb80e36873dc327$export$8454457683f90105)("div");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(graph.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg0, "class", "artboards");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "width", /*canvasWidthCSS*/ ctx[24]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "height", /*canvasHeightCSS*/ ctx[23]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg1, "class", "artboards");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "width", /*canvasWidthCSS*/ ctx[24]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "height", /*canvasHeightCSS*/ ctx[23]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg2, "class", "artwork");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg2, "xmlns", "http://www.w3.org/2000/svg");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg2, "xmlns:xlink", "http://www.w3.org/1999/xlink");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg2, "width", /*canvasWidthCSS*/ ctx[24]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg2, "height", /*canvasHeightCSS*/ ctx[23]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(svg3, "class", "overlays");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg3, "width", /*canvasWidthCSS*/ ctx[24]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg3, "height", /*canvasHeightCSS*/ ctx[23]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div0, "class", "text-input");
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "width", /*canvasWidthCSS*/ ctx[24]);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "height", /*canvasHeightCSS*/ ctx[23]);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "class", "viewport");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div1, "data-viewport", "");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "class", "graph-view");
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(div2, "data-graph", "");
            (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div2, "open", /*$document*/ ctx[25].graphViewOverlayOpen);
            (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div2, "--fade-artwork", `80%`);
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div1, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, svg0);
            svg0.innerHTML = /*artboardSvg*/ ctx[14];
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, svg1);
            svg1.innerHTML = /*nodeRenderSvg*/ ctx[13];
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, svg2);
            svg2.innerHTML = /*artworkSvg*/ ctx[12];
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t3);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, svg3);
            svg3.innerHTML = /*overlaysSvg*/ ctx[15];
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, t4);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(div1, div0);
            if (if_block1) if_block1.m(div0, null);
            /*div1_binding*/ ctx[52](div1);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t5, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, div2, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(graph, div2, null);
            current = true;
            if (!mounted) {
                dispose = [
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div1, "pointerdown", /*pointerdown_handler*/ ctx[50]),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div1, "dragover", $9241e0ea152cacb3$var$dragover_handler),
                    (0, $1eb80e36873dc327$export$63174c828edd6ff8)(div1, "drop", /*drop_handler*/ ctx[51])
                ];
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (/*cursorEyedropper*/ ctx[18]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty[0] & /*cursorEyedropper*/ 262144) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                } else {
                    if_block0 = $9241e0ea152cacb3$var$create_if_block_1(ctx);
                    if_block0.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0, 1);
                    if_block0.m(t0.parentNode, t0);
                }
            } else if (if_block0) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
            if (!current || dirty[0] & /*artboardSvg*/ 16384) svg0.innerHTML = /*artboardSvg*/ ctx[14];
            if (dirty[0] & /*canvasWidthCSS*/ 16777216) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "width", /*canvasWidthCSS*/ ctx[24]);
            if (dirty[0] & /*canvasHeightCSS*/ 8388608) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg0, "height", /*canvasHeightCSS*/ ctx[23]);
            if (!current || dirty[0] & /*nodeRenderSvg*/ 8192) svg1.innerHTML = /*nodeRenderSvg*/ ctx[13];
            if (dirty[0] & /*canvasWidthCSS*/ 16777216) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "width", /*canvasWidthCSS*/ ctx[24]);
            if (dirty[0] & /*canvasHeightCSS*/ 8388608) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg1, "height", /*canvasHeightCSS*/ ctx[23]);
            if (!current || dirty[0] & /*artworkSvg*/ 4096) svg2.innerHTML = /*artworkSvg*/ ctx[12];
            if (dirty[0] & /*canvasWidthCSS*/ 16777216) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg2, "width", /*canvasWidthCSS*/ ctx[24]);
            if (dirty[0] & /*canvasHeightCSS*/ 8388608) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg2, "height", /*canvasHeightCSS*/ ctx[23]);
            if (!current || dirty[0] & /*overlaysSvg*/ 32768) svg3.innerHTML = /*overlaysSvg*/ ctx[15];
            if (dirty[0] & /*canvasWidthCSS*/ 16777216) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg3, "width", /*canvasWidthCSS*/ ctx[24]);
            if (dirty[0] & /*canvasHeightCSS*/ 8388608) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(svg3, "height", /*canvasHeightCSS*/ ctx[23]);
            if (/*showTextInput*/ ctx[4]) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $9241e0ea152cacb3$var$create_if_block(ctx);
                    if_block1.c();
                    if_block1.m(div0, null);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            if (dirty[0] & /*canvasWidthCSS*/ 16777216) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "width", /*canvasWidthCSS*/ ctx[24]);
            if (dirty[0] & /*canvasHeightCSS*/ 8388608) (0, $1eb80e36873dc327$export$4bb9c9f436517f16)(div0, "height", /*canvasHeightCSS*/ ctx[23]);
            if (!current || dirty[0] & /*$document*/ 33554432) (0, $1eb80e36873dc327$export$d546e2fde02d30d6)(div2, "open", /*$document*/ ctx[25].graphViewOverlayOpen);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block0);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(graph.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block0);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(graph.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div1);
            if (if_block1) if_block1.d();
            /*div1_binding*/ ctx[52](null);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t5);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(div2);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(graph);
            mounted = false;
            (0, $1eb80e36873dc327$export$3f1fcd837f99a9ab)(dispose);
        }
    };
}
// (390:4) <LayoutCol class="ruler-or-scrollbar right-scrollbar">
function $9241e0ea152cacb3$var$create_default_slot_5(ctx) {
    let persistentscrollbar;
    let current;
    persistentscrollbar = new (0, $a5a04a9eed68a344$export$2e2bcd8739ae039)({
        props: {
            direction: "Vertical",
            handleLength: /*scrollbarSize*/ ctx[8].y,
            handlePosition: /*scrollbarPos*/ ctx[7].y
        }
    });
    persistentscrollbar.$on("handlePosition", /*handlePosition_handler*/ ctx[53]);
    persistentscrollbar.$on("pressTrack", /*pressTrack_handler*/ ctx[54]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(persistentscrollbar.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(persistentscrollbar, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const persistentscrollbar_changes = {};
            if (dirty[0] & /*scrollbarSize*/ 256) persistentscrollbar_changes.handleLength = /*scrollbarSize*/ ctx[8].y;
            if (dirty[0] & /*scrollbarPos*/ 128) persistentscrollbar_changes.handlePosition = /*scrollbarPos*/ ctx[7].y;
            persistentscrollbar.$set(persistentscrollbar_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(persistentscrollbar.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(persistentscrollbar.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(persistentscrollbar, detaching);
        }
    };
}
// (352:3) <LayoutRow class="viewport-container">
function $9241e0ea152cacb3$var$create_default_slot_4(ctx) {
    let layoutcol0;
    let t0;
    let layoutcol1;
    let t1;
    let layoutcol2;
    let current;
    layoutcol0 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "ruler-or-scrollbar",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_7
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol1 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "viewport-container",
            styles: {
                cursor: /*canvasCursor*/ ctx[6]
            },
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_6
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol2 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "ruler-or-scrollbar right-scrollbar",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_5
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol2.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol2, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol0_changes = {};
            if (dirty[0] & /*rulerOrigin, rulerSpacing, rulerInterval, rulerVertical*/ 3586 | dirty[1] & /*$$scope*/ 1073741824) layoutcol0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol0.$set(layoutcol0_changes);
            const layoutcol1_changes = {};
            if (dirty[0] & /*canvasCursor*/ 64) layoutcol1_changes.styles = {
                cursor: /*canvasCursor*/ ctx[6]
            };
            if (dirty[0] & /*$document, viewport, canvasWidthCSS, canvasHeightCSS, textInput, textInputMatrix, showTextInput, overlaysSvg, artworkSvg, nodeRenderSvg, artboardSvg, cursorEyedropperPreviewColorChoice, cursorEyedropperPreviewColorPrimary, cursorEyedropperPreviewColorSecondary, cursorEyedropperPreviewImageData, cursorLeft, cursorTop, cursorEyedropper*/ 67104828 | dirty[1] & /*$$scope*/ 1073741824) layoutcol1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol1.$set(layoutcol1_changes);
            const layoutcol2_changes = {};
            if (dirty[0] & /*scrollbarSize, scrollbarPos*/ 384 | dirty[1] & /*$$scope*/ 1073741824) layoutcol2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol2.$set(layoutcol2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol2, detaching);
        }
    };
}
// (400:3) <LayoutRow class="ruler-or-scrollbar bottom-scrollbar">
function $9241e0ea152cacb3$var$create_default_slot_3(ctx) {
    let persistentscrollbar;
    let current;
    persistentscrollbar = new (0, $a5a04a9eed68a344$export$2e2bcd8739ae039)({
        props: {
            direction: "Horizontal",
            handleLength: /*scrollbarSize*/ ctx[8].x,
            handlePosition: /*scrollbarPos*/ ctx[7].x
        }
    });
    persistentscrollbar.$on("handlePosition", /*handlePosition_handler_1*/ ctx[55]);
    persistentscrollbar.$on("pressTrack", /*pressTrack_handler_1*/ ctx[56]);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(persistentscrollbar.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(persistentscrollbar, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const persistentscrollbar_changes = {};
            if (dirty[0] & /*scrollbarSize*/ 256) persistentscrollbar_changes.handleLength = /*scrollbarSize*/ ctx[8].x;
            if (dirty[0] & /*scrollbarPos*/ 128) persistentscrollbar_changes.handlePosition = /*scrollbarPos*/ ctx[7].x;
            persistentscrollbar.$set(persistentscrollbar_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(persistentscrollbar.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(persistentscrollbar.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(persistentscrollbar, detaching);
        }
    };
}
// (348:2) <LayoutCol class="table">
function $9241e0ea152cacb3$var$create_default_slot_2(ctx) {
    let layoutrow0;
    let t0;
    let layoutrow1;
    let t1;
    let layoutrow2;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "ruler-or-scrollbar top-ruler",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_8
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "viewport-container",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow2 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "ruler-or-scrollbar bottom-scrollbar",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow2.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow2, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty[0] & /*rulerOrigin, rulerSpacing, rulerInterval, rulerHorizontal*/ 3585 | dirty[1] & /*$$scope*/ 1073741824) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty[0] & /*scrollbarSize, scrollbarPos, canvasCursor, $document, viewport, canvasWidthCSS, canvasHeightCSS, textInput, textInputMatrix, showTextInput, overlaysSvg, artworkSvg, nodeRenderSvg, artboardSvg, cursorEyedropperPreviewColorChoice, cursorEyedropperPreviewColorPrimary, cursorEyedropperPreviewColorSecondary, cursorEyedropperPreviewImageData, cursorLeft, cursorTop, cursorEyedropper, rulerOrigin, rulerSpacing, rulerInterval, rulerVertical*/ 67108862 | dirty[1] & /*$$scope*/ 1073741824) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
            const layoutrow2_changes = {};
            if (dirty[0] & /*scrollbarSize, scrollbarPos*/ 384 | dirty[1] & /*$$scope*/ 1073741824) layoutrow2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow2.$set(layoutrow2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow2, detaching);
        }
    };
}
// (335:1) <LayoutRow class="shelf-and-table">
function $9241e0ea152cacb3$var$create_default_slot_1(ctx) {
    let layoutcol0;
    let t;
    let layoutcol1;
    let current;
    layoutcol0 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "shelf",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_9
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol1 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "table",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol0_changes = {};
            if (dirty[0] & /*$document*/ 33554432 | dirty[1] & /*$$scope*/ 1073741824) layoutcol0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol0.$set(layoutcol0_changes);
            const layoutcol1_changes = {};
            if (dirty[0] & /*scrollbarSize, scrollbarPos, canvasCursor, $document, viewport, canvasWidthCSS, canvasHeightCSS, textInput, textInputMatrix, showTextInput, overlaysSvg, artworkSvg, nodeRenderSvg, artboardSvg, cursorEyedropperPreviewColorChoice, cursorEyedropperPreviewColorPrimary, cursorEyedropperPreviewColorSecondary, cursorEyedropperPreviewImageData, cursorLeft, cursorTop, cursorEyedropper, rulerOrigin, rulerSpacing, rulerInterval, rulerVertical, rulerHorizontal*/ 67108863 | dirty[1] & /*$$scope*/ 1073741824) layoutcol1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol1.$set(layoutcol1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol1, detaching);
        }
    };
}
// (324:0) <LayoutCol class="document">
function $9241e0ea152cacb3$var$create_default_slot(ctx) {
    let layoutrow0;
    let t;
    let layoutrow1;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "options-bar",
            classes: {
                "for-graph": /*$document*/ ctx[25].graphViewOverlayOpen
            },
            scrollableX: true,
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_12
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "shelf-and-table",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty[0] & /*$document*/ 33554432) layoutrow0_changes.classes = {
                "for-graph": /*$document*/ ctx[25].graphViewOverlayOpen
            };
            if (dirty[0] & /*$document*/ 33554432 | dirty[1] & /*$$scope*/ 1073741824) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty[0] & /*scrollbarSize, scrollbarPos, canvasCursor, $document, viewport, canvasWidthCSS, canvasHeightCSS, textInput, textInputMatrix, showTextInput, overlaysSvg, artworkSvg, nodeRenderSvg, artboardSvg, cursorEyedropperPreviewColorChoice, cursorEyedropperPreviewColorPrimary, cursorEyedropperPreviewColorSecondary, cursorEyedropperPreviewImageData, cursorLeft, cursorTop, cursorEyedropper, rulerOrigin, rulerSpacing, rulerInterval, rulerVertical, rulerHorizontal*/ 67108863 | dirty[1] & /*$$scope*/ 1073741824) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
        }
    };
}
function $9241e0ea152cacb3$var$create_fragment(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "document",
            $$slots: {
                default: [
                    $9241e0ea152cacb3$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty[0] & /*scrollbarSize, scrollbarPos, canvasCursor, $document, viewport, canvasWidthCSS, canvasHeightCSS, textInput, textInputMatrix, showTextInput, overlaysSvg, artworkSvg, nodeRenderSvg, artboardSvg, cursorEyedropperPreviewColorChoice, cursorEyedropperPreviewColorPrimary, cursorEyedropperPreviewColorSecondary, cursorEyedropperPreviewImageData, cursorLeft, cursorTop, cursorEyedropper, rulerOrigin, rulerSpacing, rulerInterval, rulerVertical, rulerHorizontal*/ 67108863 | dirty[1] & /*$$scope*/ 1073741824) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
function $9241e0ea152cacb3$var$canvasDimensionCSS(dimension) {
    // Temporary placeholder until the first actual value is populated
    // This at least gets close to the correct value but an actual number is required to prevent CSS from causing non-integer sizing making the SVG render with anti-aliasing
    if (dimension === undefined) return "100%";
    // Dimension is rounded up to the nearest even number because resizing is centered, and dividing an odd number by 2 for centering causes antialiasing
    return `${dimension % 2 === 1 ? dimension + 1 : dimension}px`;
}
const $9241e0ea152cacb3$var$dragover_handler = (e)=>e.preventDefault();
function $9241e0ea152cacb3$var$instance($$self, $$props, $$invalidate) {
    let canvasWidthCSS;
    let canvasHeightCSS;
    let $document;
    let rulerHorizontal;
    let rulerVertical;
    let viewport;
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    const document = (0, $1eb80e36873dc327$export$31553aaa555c1514)("document");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, document, (value)=>$$invalidate(25, $document = value));
    // Interactive text editing
    let textInput = undefined;
    let showTextInput;
    let textInputMatrix;
    // CSS properties
    let canvasSvgWidth = undefined;
    let canvasSvgHeight = undefined;
    let canvasCursor = "default";
    // Scrollbars
    let scrollbarPos = {
        x: 0.5,
        y: 0.5
    };
    let scrollbarSize = {
        x: 0.5,
        y: 0.5
    };
    let scrollbarMultiplier = {
        x: 0,
        y: 0
    };
    // Rulers
    let rulerOrigin = {
        x: 0,
        y: 0
    };
    let rulerSpacing = 100;
    let rulerInterval = 100;
    // Rendered SVG viewport data
    let artworkSvg = "";
    let nodeRenderSvg = "";
    let artboardSvg = "";
    let overlaysSvg = "";
    // Rasterized SVG viewport data, or none if it's not up-to-date
    let rasterizedCanvas = undefined;
    let rasterizedContext = undefined;
    // Cursor position for cursor floating menus like the Eyedropper tool zoom
    let cursorLeft = 0;
    let cursorTop = 0;
    let cursorEyedropper = false;
    let cursorEyedropperPreviewImageData = undefined;
    let cursorEyedropperPreviewColorChoice = "";
    let cursorEyedropperPreviewColorPrimary = "";
    let cursorEyedropperPreviewColorSecondary = "";
    function pasteFile(e) {
        const { dataTransfer: dataTransfer } = e;
        if (!dataTransfer) return;
        e.preventDefault();
        Array.from(dataTransfer.items).forEach(async (item)=>{
            const file = item.getAsFile();
            if (file?.type.startsWith("image")) {
                const imageData = await (0, $a169f2d3602aed86$export$6bd5bcc5a8099e6)(file);
                editor.instance.pasteImage(new Uint8Array(imageData.data), imageData.width, imageData.height, e.clientX, e.clientY);
            }
        });
    }
    function translateCanvasX(newValue) {
        const delta = newValue - scrollbarPos.x;
        $$invalidate(7, scrollbarPos.x = newValue, scrollbarPos);
        editor.instance.translateCanvas(-delta * scrollbarMultiplier.x, 0);
    }
    function translateCanvasY(newValue) {
        const delta = newValue - scrollbarPos.y;
        $$invalidate(7, scrollbarPos.y = newValue, scrollbarPos);
        editor.instance.translateCanvas(0, -delta * scrollbarMultiplier.y);
    }
    function pageX(delta) {
        const move = delta < 0 ? 1 : -1;
        editor.instance.translateCanvasByFraction(move, 0);
    }
    function pageY(delta) {
        const move = delta < 0 ? 1 : -1;
        editor.instance.translateCanvasByFraction(0, move);
    }
    function canvasPointerDown(e) {
        const onEditbox = e.target instanceof HTMLDivElement && e.target.contentEditable;
        if (!onEditbox) viewport?.setPointerCapture(e.pointerId);
    }
    async function updateDocumentArtwork(svg) {
        $$invalidate(12, artworkSvg = svg);
        rasterizedCanvas = undefined;
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        const placeholders = window.document.querySelectorAll("[data-viewport] [data-canvas-placeholder]");
        // Replace the placeholders with the actual canvas elements
        placeholders.forEach((placeholder)=>{
            const canvasName = placeholder.getAttribute("data-canvas-placeholder");
            if (!canvasName) return;
            // Get the canvas element from the global storage
            const canvas = window.imageCanvases[canvasName];
            placeholder.replaceWith(canvas);
        });
    }
    function updateDocumentOverlays(svg) {
        $$invalidate(15, overlaysSvg = svg);
    }
    function updateDocumentArtboards(svg) {
        $$invalidate(14, artboardSvg = svg);
        rasterizedCanvas = undefined;
    }
    function updateDocumentNodeRender(svg) {
        $$invalidate(13, nodeRenderSvg = svg);
        rasterizedCanvas = undefined;
    }
    async function updateEyedropperSamplingState(mousePosition, colorPrimary, colorSecondary) {
        if (mousePosition === undefined) {
            $$invalidate(18, cursorEyedropper = false);
            return undefined;
        }
        $$invalidate(18, cursorEyedropper = true);
        if (canvasSvgWidth === undefined || canvasSvgHeight === undefined) return undefined;
        $$invalidate(16, cursorLeft = mousePosition.x);
        $$invalidate(17, cursorTop = mousePosition.y);
        // This works nearly perfectly, but sometimes at odd DPI scale factors like 1.25, the anti-aliasing color can yield slightly incorrect colors (potential room for future improvement)
        const dpiFactor = window.devicePixelRatio;
        const [width, height] = [
            canvasSvgWidth,
            canvasSvgHeight
        ];
        const outsideArtboardsColor = getComputedStyle(window.document.documentElement).getPropertyValue("--color-2-mildblack");
        const outsideArtboards = `<rect x="0" y="0" width="100%" height="100%" fill="${outsideArtboardsColor}" />`;
        const svg = `
			<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">${outsideArtboards}${artboardSvg}${nodeRenderSvg}</svg>
			`.trim();
        if (!rasterizedCanvas) {
            rasterizedCanvas = await (0, $a169f2d3602aed86$export$c3955ecdb816704b)(svg, width * dpiFactor, height * dpiFactor, "image/png");
            rasterizedContext = rasterizedCanvas.getContext("2d") || undefined;
        }
        if (!rasterizedContext) return undefined;
        const rgbToHex = (r, g, b)=>`#${[
                r,
                g,
                b
            ].map((x)=>x.toString(16).padStart(2, "0")).join("")}`;
        const pixel = rasterizedContext.getImageData(mousePosition.x * dpiFactor, mousePosition.y * dpiFactor, 1, 1).data;
        const hex = rgbToHex(pixel[0], pixel[1], pixel[2]);
        const rgb = [
            pixel[0] / 255,
            pixel[1] / 255,
            pixel[2] / 255
        ];
        $$invalidate(20, cursorEyedropperPreviewColorChoice = hex);
        $$invalidate(21, cursorEyedropperPreviewColorPrimary = colorPrimary);
        $$invalidate(22, cursorEyedropperPreviewColorSecondary = colorSecondary);
        const previewRegion = rasterizedContext.getImageData(mousePosition.x * dpiFactor - ((0, $a442d3020821b0e2$export$37b1deb98cc11f7b) - 1) / 2, mousePosition.y * dpiFactor - ((0, $a442d3020821b0e2$export$37b1deb98cc11f7b) - 1) / 2, (0, $a442d3020821b0e2$export$37b1deb98cc11f7b), (0, $a442d3020821b0e2$export$37b1deb98cc11f7b));
        $$invalidate(19, cursorEyedropperPreviewImageData = previewRegion);
        return rgb;
    }
    function updateDocumentScrollbars(position, size, multiplier) {
        $$invalidate(7, scrollbarPos = position);
        $$invalidate(8, scrollbarSize = size);
        scrollbarMultiplier = multiplier;
    }
    function updateDocumentRulers(origin, spacing, interval) {
        $$invalidate(9, rulerOrigin = origin);
        $$invalidate(10, rulerSpacing = spacing);
        $$invalidate(11, rulerInterval = interval);
    }
    function updateMouseCursor(cursor) {
        let cursorString = cursor;
        // This isn't very clean but it's good enough for now until we need more icons, then we can build something more robust (consider blob URLs)
        if (cursor === "custom-rotate") {
            const svg = `
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
						<path transform="translate(2 2)" fill="black" stroke="black" stroke-width="2px" d="
						M8,15.2C4,15.2,0.8,12,0.8,8C0.8,4,4,0.8,8,0.8c2,0,3.9,0.8,5.3,2.3l-1,1C11.2,2.9,9.6,2.2,8,2.2C4.8,2.2,2.2,4.8,2.2,8s2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8h1.4C15.2,12,12,15.2,8,15.2z
						" />
						<polygon transform="translate(2 2)" fill="black" stroke="black" stroke-width="2px" points="12.6,0 15.5,5 9.7,5" />
						<path transform="translate(2 2)" fill="white" d="
						M8,15.2C4,15.2,0.8,12,0.8,8C0.8,4,4,0.8,8,0.8c2,0,3.9,0.8,5.3,2.3l-1,1C11.2,2.9,9.6,2.2,8,2.2C4.8,2.2,2.2,4.8,2.2,8s2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8h1.4C15.2,12,12,15.2,8,15.2z
						" />
						<polygon transform="translate(2 2)" fill="white" points="12.6,0 15.5,5 9.7,5" />
					</svg>
					`.split("\n").map((line)=>line.trim()).join("");
            cursorString = `url('data:image/svg+xml;utf8,${svg}') 8 8, alias`;
        }
        $$invalidate(6, canvasCursor = cursorString);
    }
    function triggerTextCommit() {
        if (!textInput) return;
        const textCleaned = (0, $f03b4dcefd1c1439$export$6efdc3ca96c7aae5)(textInput.innerText);
        editor.instance.onChangeText(textCleaned);
    }
    async function displayEditableTextbox(displayEditableTextbox) {
        $$invalidate(4, showTextInput = true);
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        if (!textInput) return;
        if (displayEditableTextbox.text === "") $$invalidate(3, textInput.textContent = "", textInput);
        else $$invalidate(3, textInput.textContent = `${displayEditableTextbox.text}\n`, textInput);
        $$invalidate(3, textInput.contentEditable = "true", textInput);
        $$invalidate(3, textInput.style.transformOrigin = "0 0", textInput);
        $$invalidate(3, textInput.style.width = displayEditableTextbox.lineWidth ? `${displayEditableTextbox.lineWidth}px` : "max-content", textInput);
        $$invalidate(3, textInput.style.height = "auto", textInput);
        $$invalidate(3, textInput.style.fontSize = `${displayEditableTextbox.fontSize}px`, textInput);
        $$invalidate(3, textInput.style.color = displayEditableTextbox.color.toHexOptionalAlpha() || "transparent", textInput);
        $$invalidate(3, textInput.oninput = ()=>{
            if (!textInput) return;
            editor.instance.updateBounds((0, $f03b4dcefd1c1439$export$6efdc3ca96c7aae5)(textInput.innerText));
        }, textInput);
        $$invalidate(5, textInputMatrix = displayEditableTextbox.transform);
        const new_font = new FontFace("text-font", `url(${displayEditableTextbox.url})`);
        window.document.fonts.add(new_font);
        $$invalidate(3, textInput.style.fontFamily = "text-font", textInput);
        // Necessary to select contenteditable: https://stackoverflow.com/questions/6139107/programmatically-select-text-in-a-contenteditable-html-element/6150060#6150060
        const range = window.document.createRange();
        range.selectNodeContents(textInput);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        textInput.focus();
        textInput.click();
        // Sends the text input element used for interactively editing with the text tool in a custom event
        window.dispatchEvent(new CustomEvent("modifyinputfield", {
            detail: textInput
        }));
    }
    function displayRemoveEditableTextbox() {
        window.dispatchEvent(new CustomEvent("modifyinputfield", {
            detail: undefined
        }));
        $$invalidate(4, showTextInput = false);
    }
    function viewportResize() {
        if (!viewport) return;
        // Resize the canvas
        $$invalidate(45, canvasSvgWidth = Math.ceil(parseFloat(getComputedStyle(viewport).width)));
        $$invalidate(46, canvasSvgHeight = Math.ceil(parseFloat(getComputedStyle(viewport).height)));
        // Resize the rulers
        rulerHorizontal?.resize();
        rulerVertical?.resize();
    }
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        // Update rendered SVGs
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$e6b230c6603d5a10), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            updateDocumentArtwork(data.svg);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$bfe3aaa687983ce0), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            updateDocumentOverlays(data.svg);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$49d0c233dd75cf0f), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            updateDocumentArtboards(data.svg);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$ff5df6c5561f8a9f), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            updateDocumentNodeRender(data.svg);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$905b4e85a33f6d2b), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            const { mousePosition: mousePosition, primaryColor: primaryColor, secondaryColor: secondaryColor, setColorChoice: setColorChoice } = data;
            const rgb = await updateEyedropperSamplingState(mousePosition, primaryColor, secondaryColor);
            if (setColorChoice && rgb) {
                if (setColorChoice === "Primary") editor.instance.updatePrimaryColor(...rgb, 1);
                if (setColorChoice === "Secondary") editor.instance.updateSecondaryColor(...rgb, 1);
            }
        });
        // Update scrollbars and rulers
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$afb8aa162f5c524d), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            const { position: position, size: size, multiplier: multiplier } = data;
            updateDocumentScrollbars(position, size, multiplier);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$67e326410c009161), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            const { origin: origin, spacing: spacing, interval: interval } = data;
            updateDocumentRulers(origin, spacing, interval);
        });
        // Update mouse cursor icon
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$71833d69925d8667), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            const { cursor: cursor } = data;
            updateMouseCursor(cursor);
        });
        // Text entry
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$8d7c81ea685522cb), async ()=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            triggerTextCommit();
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$a56dab01700fb7e1), async (data)=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            displayEditableTextbox(data);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$eac219e540e468b8), async (data)=>{
            $$invalidate(5, textInputMatrix = data.transform);
        });
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$98edad53d4312d93), async ()=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            displayRemoveEditableTextbox();
        });
        // Resize elements to render the new viewport size
        editor.subscriptions.subscribeJsMessage((0, $f7aa31b9879f1252$export$2208223fe002fa87), async ()=>{
            await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
            viewportResize();
        });
        // Once this component is mounted, we want to resend the document bounds to the backend via the resize event handler which does that
        window.dispatchEvent(new Event("resize"));
    });
    function canvasruler_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            rulerHorizontal = $$value;
            $$invalidate(0, rulerHorizontal);
        });
    }
    function canvasruler_binding_1($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            rulerVertical = $$value;
            $$invalidate(1, rulerVertical);
        });
    }
    function div_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            textInput = $$value;
            $$invalidate(3, textInput);
        });
    }
    const pointerdown_handler = (e)=>canvasPointerDown(e);
    const drop_handler = (e)=>pasteFile(e);
    function div1_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            viewport = $$value;
            $$invalidate(2, viewport);
        });
    }
    const handlePosition_handler = ({ detail: detail })=>translateCanvasY(detail);
    const pressTrack_handler = ({ detail: detail })=>pageY(detail);
    const handlePosition_handler_1 = ({ detail: detail })=>translateCanvasX(detail);
    const pressTrack_handler_1 = ({ detail: detail })=>pageX(detail);
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[1] & /*canvasSvgWidth*/ 16384) $: $$invalidate(24, canvasWidthCSS = $9241e0ea152cacb3$var$canvasDimensionCSS(canvasSvgWidth));
        if ($$self.$$.dirty[1] & /*canvasSvgHeight*/ 32768) $: $$invalidate(23, canvasHeightCSS = $9241e0ea152cacb3$var$canvasDimensionCSS(canvasSvgHeight));
    };
    return [
        rulerHorizontal,
        rulerVertical,
        viewport,
        textInput,
        showTextInput,
        textInputMatrix,
        canvasCursor,
        scrollbarPos,
        scrollbarSize,
        rulerOrigin,
        rulerSpacing,
        rulerInterval,
        artworkSvg,
        nodeRenderSvg,
        artboardSvg,
        overlaysSvg,
        cursorLeft,
        cursorTop,
        cursorEyedropper,
        cursorEyedropperPreviewImageData,
        cursorEyedropperPreviewColorChoice,
        cursorEyedropperPreviewColorPrimary,
        cursorEyedropperPreviewColorSecondary,
        canvasHeightCSS,
        canvasWidthCSS,
        $document,
        document,
        pasteFile,
        translateCanvasX,
        translateCanvasY,
        pageX,
        pageY,
        canvasPointerDown,
        updateDocumentArtwork,
        updateDocumentOverlays,
        updateDocumentArtboards,
        updateDocumentNodeRender,
        updateEyedropperSamplingState,
        updateDocumentScrollbars,
        updateDocumentRulers,
        updateMouseCursor,
        triggerTextCommit,
        displayEditableTextbox,
        displayRemoveEditableTextbox,
        viewportResize,
        canvasSvgWidth,
        canvasSvgHeight,
        canvasruler_binding,
        canvasruler_binding_1,
        div_binding,
        pointerdown_handler,
        drop_handler,
        div1_binding,
        handlePosition_handler,
        pressTrack_handler,
        handlePosition_handler_1,
        pressTrack_handler_1
    ];
}
class $9241e0ea152cacb3$var$Document extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $9241e0ea152cacb3$var$instance, $9241e0ea152cacb3$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            updateDocumentArtwork: 33,
            updateDocumentOverlays: 34,
            updateDocumentArtboards: 35,
            updateDocumentNodeRender: 36,
            updateEyedropperSamplingState: 37,
            updateDocumentScrollbars: 38,
            updateDocumentRulers: 39,
            updateMouseCursor: 40,
            triggerTextCommit: 41,
            displayEditableTextbox: 42,
            displayRemoveEditableTextbox: 43,
            viewportResize: 44
        }, null, [
            -1,
            -1
        ]);
    }
    get updateDocumentArtwork() {
        return this.$$.ctx[33];
    }
    get updateDocumentOverlays() {
        return this.$$.ctx[34];
    }
    get updateDocumentArtboards() {
        return this.$$.ctx[35];
    }
    get updateDocumentNodeRender() {
        return this.$$.ctx[36];
    }
    get updateEyedropperSamplingState() {
        return this.$$.ctx[37];
    }
    get updateDocumentScrollbars() {
        return this.$$.ctx[38];
    }
    get updateDocumentRulers() {
        return this.$$.ctx[39];
    }
    get updateMouseCursor() {
        return this.$$.ctx[40];
    }
    get triggerTextCommit() {
        return this.$$.ctx[41];
    }
    get displayEditableTextbox() {
        return this.$$.ctx[42];
    }
    get displayRemoveEditableTextbox() {
        return this.$$.ctx[43];
    }
    get viewportResize() {
        return this.$$.ctx[44];
    }
}
var $9241e0ea152cacb3$export$2e2bcd8739ae039 = $9241e0ea152cacb3$var$Document;









function $57883b4a6ea1dcee$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[19] = list[i];
    child_ctx[20] = list;
    child_ctx[21] = i;
    return child_ctx;
}
// (76:5) <TextLabel>
function $57883b4a6ea1dcee$var$create_default_slot_12(ctx) {
    let t_value = /*tabLabel*/ ctx[19].name + "";
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)(t_value);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*tabLabels*/ 4 && t_value !== (t_value = /*tabLabel*/ ctx[19].name + "")) (0, $1eb80e36873dc327$export$c31d24e2793e6a58)(t, t_value);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (77:5) {#if tabCloseButtons}
function $57883b4a6ea1dcee$var$create_if_block_1(ctx) {
    let iconbutton;
    let current;
    function func(...args) {
        return /*func*/ ctx[11](/*tabIndex*/ ctx[21], ...args);
    }
    iconbutton = new (0, $47cbcd4715b3f848$export$2e2bcd8739ae039)({
        props: {
            action: func,
            icon: "CloseX",
            size: 16
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconbutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const iconbutton_changes = {};
            if (dirty & /*closeAction, tabLabels*/ 68) iconbutton_changes.action = func;
            iconbutton.$set(iconbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconbutton, detaching);
        }
    };
}
// (49:4) <LayoutRow      class="tab"      classes={{ active: tabIndex === tabActiveIndex }}      tooltip={tabLabel.tooltip || undefined}      on:click={(e) => {       e.stopPropagation();       clickAction?.(tabIndex);      }}      on:auxclick={(e) => {       // Middle mouse button click       if (e.button === 1) {        e.stopPropagation();        closeAction?.(tabIndex);       }      }}      on:mouseup={(e) => {       // Fallback for Safari:       // https://developer.mozilla.org/en-US/docs/Web/API/Element/auxclick_event#browser_compatibility       // The downside of using mouseup is that the mousedown didn't have to originate in the same element.       // A possible future improvement could save the target element during mousedown and check if it's the same here.       if (!isEventSupported("auxclick") && e.button === 1) {        e.stopPropagation();        closeAction?.(tabIndex);       }      }}      bind:this={tabElements[tabIndex]}     >
function $57883b4a6ea1dcee$var$create_default_slot_11(ctx) {
    let textlabel;
    let t0;
    let t1;
    let current;
    textlabel = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_12
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let if_block = /*tabCloseButtons*/ ctx[1] && $57883b4a6ea1dcee$var$create_if_block_1(ctx);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block) if_block.c();
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel_changes = {};
            if (dirty & /*$$scope, tabLabels*/ 4194308) textlabel_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel.$set(textlabel_changes);
            if (/*tabCloseButtons*/ ctx[1]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*tabCloseButtons*/ 2) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $57883b4a6ea1dcee$var$create_if_block_1(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(t1.parentNode, t1);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
        }
    };
}
// (48:3) {#each tabLabels as tabLabel, tabIndex (tabIndex)}
function $57883b4a6ea1dcee$var$create_each_block(key_1, ctx) {
    let first;
    let layoutrow;
    let tabIndex = /*tabIndex*/ ctx[21];
    let current;
    const assign_layoutrow = ()=>/*layoutrow_binding*/ ctx[12](layoutrow, tabIndex);
    const unassign_layoutrow = ()=>/*layoutrow_binding*/ ctx[12](null, tabIndex);
    function click_handler(...args) {
        return /*click_handler*/ ctx[13](/*tabIndex*/ ctx[21], ...args);
    }
    function auxclick_handler(...args) {
        return /*auxclick_handler*/ ctx[14](/*tabIndex*/ ctx[21], ...args);
    }
    function mouseup_handler(...args) {
        return /*mouseup_handler*/ ctx[15](/*tabIndex*/ ctx[21], ...args);
    }
    let layoutrow_props = {
        class: "tab",
        classes: {
            active: /*tabIndex*/ ctx[21] === /*tabActiveIndex*/ ctx[3]
        },
        tooltip: /*tabLabel*/ ctx[19].tooltip || undefined,
        $$slots: {
            default: [
                $57883b4a6ea1dcee$var$create_default_slot_11
            ]
        },
        $$scope: {
            ctx: ctx
        }
    };
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: layoutrow_props
    });
    assign_layoutrow();
    layoutrow.$on("click", click_handler);
    layoutrow.$on("auxclick", auxclick_handler);
    layoutrow.$on("mouseup", mouseup_handler);
    return {
        key: key_1,
        first: null,
        c () {
            first = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            this.first = first;
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, first, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (tabIndex !== /*tabIndex*/ ctx[21]) {
                unassign_layoutrow();
                tabIndex = /*tabIndex*/ ctx[21];
                assign_layoutrow();
            }
            const layoutrow_changes = {};
            if (dirty & /*tabLabels, tabActiveIndex*/ 12) layoutrow_changes.classes = {
                active: /*tabIndex*/ ctx[21] === /*tabActiveIndex*/ ctx[3]
            };
            if (dirty & /*tabLabels*/ 4) layoutrow_changes.tooltip = /*tabLabel*/ ctx[19].tooltip || undefined;
            if (dirty & /*$$scope, closeAction, tabLabels, tabCloseButtons*/ 4194374) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(first);
            unassign_layoutrow();
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (47:2) <LayoutRow class="tab-group" scrollableX={true}>
function $57883b4a6ea1dcee$var$create_default_slot_10(ctx) {
    let each_blocks = [];
    let each_1_lookup = new Map();
    let each_1_anchor;
    let current;
    let each_value = /*tabLabels*/ ctx[2];
    const get_key = (ctx)=>/*tabIndex*/ ctx[21];
    for(let i = 0; i < each_value.length; i += 1){
        let child_ctx = $57883b4a6ea1dcee$var$get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = $57883b4a6ea1dcee$var$create_each_block(key, child_ctx));
    }
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*tabLabels, tabActiveIndex, undefined, tabElements, clickAction, closeAction, isEventSupported, tabCloseButtons*/ 238) {
                each_value = /*tabLabels*/ ctx[2];
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                each_blocks = (0, $1eb80e36873dc327$export$1c17fe0cd58c4da7)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, (0, $1eb80e36873dc327$export$34db5f5dc4992cab), $57883b4a6ea1dcee$var$create_each_block, each_1_anchor, $57883b4a6ea1dcee$var$get_each_context);
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)(0, $1eb80e36873dc327$export$9e951caa2db2b1da)(each_blocks[i]);
            current = true;
        },
        o (local) {
            for(let i = 0; i < each_blocks.length; i += 1)(0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(each_1_anchor);
        }
    };
}
// (91:3) <TextLabel bold={true}>
function $57883b4a6ea1dcee$var$create_default_slot_9(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Panel Options");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (92:3) <TextLabel multiline={true}>
function $57883b4a6ea1dcee$var$create_default_slot_8(ctx) {
    let t;
    return {
        c () {
            t = (0, $1eb80e36873dc327$export$6f093cfa640b7166)("Coming soon");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
        }
    };
}
// (90:2) <PopoverButton icon="VerticalEllipsis">
function $57883b4a6ea1dcee$var$create_default_slot_7(ctx) {
    let textlabel0;
    let t;
    let textlabel1;
    let current;
    textlabel0 = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            bold: true,
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_9
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    textlabel1 = new (0, $84975b9c3b9bc8e2$export$2e2bcd8739ae039)({
        props: {
            multiline: true,
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_8
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textlabel1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textlabel1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const textlabel0_changes = {};
            if (dirty & /*$$scope*/ 4194304) textlabel0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel0.$set(textlabel0_changes);
            const textlabel1_changes = {};
            if (dirty & /*$$scope*/ 4194304) textlabel1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            textlabel1.$set(textlabel1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textlabel1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textlabel1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textlabel1, detaching);
        }
    };
}
// (46:1) <LayoutRow class="tab-bar" classes={{ "min-widths": tabMinWidths }}>
function $57883b4a6ea1dcee$var$create_default_slot_6(ctx) {
    let layoutrow;
    let t;
    let popoverbutton;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "tab-group",
            scrollableX: true,
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_10
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    popoverbutton = new (0, $68f47e5b62fe7f2d$export$2e2bcd8739ae039)({
        props: {
            icon: "VerticalEllipsis",
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_7
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(popoverbutton.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(popoverbutton, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, tabLabels, tabActiveIndex, tabElements, clickAction, closeAction, tabCloseButtons*/ 4194542) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
            const popoverbutton_changes = {};
            if (dirty & /*$$scope*/ 4194304) popoverbutton_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            popoverbutton.$set(popoverbutton_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(popoverbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(popoverbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(popoverbutton, detaching);
        }
    };
}
// (98:2) {:else}
function $57883b4a6ea1dcee$var$create_else_block(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "empty-panel",
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope*/ 4194304) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
// (96:2) {#if panelType}
function $57883b4a6ea1dcee$var$create_if_block(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = $57883b4a6ea1dcee$var$PANEL_COMPONENTS[/*panelType*/ ctx[4]];
    function switch_props(ctx) {
        return {};
    }
    if (switch_value) switch_instance = (0, $1eb80e36873dc327$export$203be6b617b8723)(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(switch_instance.$$.fragment);
            switch_instance_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (switch_instance) (0, $1eb80e36873dc327$export$18b26e9aca35251)(switch_instance, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*panelType*/ 16 && switch_value !== (switch_value = $57883b4a6ea1dcee$var$PANEL_COMPONENTS[/*panelType*/ ctx[4]])) {
                if (switch_instance) {
                    (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                    const old_component = switch_instance;
                    (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(old_component.$$.fragment, 1, 0, ()=>{
                        (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(old_component, 1);
                    });
                    (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                }
                if (switch_value) {
                    switch_instance = (0, $1eb80e36873dc327$export$203be6b617b8723)(switch_value, switch_props(ctx));
                    (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(switch_instance.$$.fragment);
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(switch_instance.$$.fragment, 1);
                    (0, $1eb80e36873dc327$export$18b26e9aca35251)(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else switch_value;
        },
        i (local) {
            if (current) return;
            if (switch_instance) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(switch_instance_anchor);
            if (switch_instance) (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(switch_instance, detaching);
        }
    };
}
// (101:5) <LayoutRow class="logotype">
function $57883b4a6ea1dcee$var$create_default_slot_5(ctx) {
    let iconlabel;
    let current;
    iconlabel = new (0, $9b2fdfd965680fb8$export$2e2bcd8739ae039)({
        props: {
            icon: "GraphiteLogotypeSolid"
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(iconlabel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(iconlabel, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(iconlabel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(iconlabel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(iconlabel, detaching);
        }
    };
}
// (104:5) <LayoutRow class="actions">
function $57883b4a6ea1dcee$var$create_default_slot_4(ctx) {
    let table;
    let tr0;
    let td0;
    let textbutton0;
    let t0;
    let td1;
    let userinputlabel0;
    let t1;
    let tr1;
    let td2;
    let textbutton1;
    let t2;
    let td3;
    let userinputlabel1;
    let t3;
    let tr2;
    let td4;
    let textbutton2;
    let current;
    textbutton0 = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: "New Document",
            icon: "File",
            noBackground: true,
            action: /*func_1*/ ctx[16]
        }
    });
    userinputlabel0 = new (0, $26bc4a854934ba73$export$2e2bcd8739ae039)({
        props: {
            keysWithLabelsGroups: [
                [
                    .../*platformModifiers*/ ctx[9](true),
                    {
                        key: "KeyN",
                        label: "N"
                    }
                ]
            ]
        }
    });
    textbutton1 = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: "Open Document",
            icon: "Folder",
            noBackground: true,
            action: /*func_2*/ ctx[17]
        }
    });
    userinputlabel1 = new (0, $26bc4a854934ba73$export$2e2bcd8739ae039)({
        props: {
            keysWithLabelsGroups: [
                [
                    .../*platformModifiers*/ ctx[9](false),
                    {
                        key: "KeyO",
                        label: "O"
                    }
                ]
            ]
        }
    });
    textbutton2 = new (0, $4dfb3170392f5493$export$2e2bcd8739ae039)({
        props: {
            label: "Open Demo Artwork",
            icon: "Image",
            noBackground: true,
            action: /*func_3*/ ctx[18]
        }
    });
    return {
        c () {
            table = (0, $1eb80e36873dc327$export$8454457683f90105)("table");
            tr0 = (0, $1eb80e36873dc327$export$8454457683f90105)("tr");
            td0 = (0, $1eb80e36873dc327$export$8454457683f90105)("td");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            td1 = (0, $1eb80e36873dc327$export$8454457683f90105)("td");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(userinputlabel0.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            tr1 = (0, $1eb80e36873dc327$export$8454457683f90105)("tr");
            td2 = (0, $1eb80e36873dc327$export$8454457683f90105)("td");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton1.$$.fragment);
            t2 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            td3 = (0, $1eb80e36873dc327$export$8454457683f90105)("td");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(userinputlabel1.$$.fragment);
            t3 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            tr2 = (0, $1eb80e36873dc327$export$8454457683f90105)("tr");
            td4 = (0, $1eb80e36873dc327$export$8454457683f90105)("td");
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(textbutton2.$$.fragment);
            (0, $1eb80e36873dc327$export$7aabe8b3a840d2fd)(td4, "colspan", "2");
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, table, anchor);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(table, tr0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(tr0, td0);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton0, td0, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(tr0, t0);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(tr0, td1);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(userinputlabel0, td1, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(table, t1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(table, tr1);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(tr1, td2);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton1, td2, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(tr1, t2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(tr1, td3);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(userinputlabel1, td3, null);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(table, t3);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(table, tr2);
            (0, $1eb80e36873dc327$export$10d8903dec122b9d)(tr2, td4);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(textbutton2, td4, null);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(userinputlabel0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(userinputlabel1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(textbutton2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(userinputlabel0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(userinputlabel1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(textbutton2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(table);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(userinputlabel0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(userinputlabel1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(textbutton2);
        }
    };
}
// (100:4) <LayoutCol class="content">
function $57883b4a6ea1dcee$var$create_default_slot_3(ctx) {
    let layoutrow0;
    let t;
    let layoutrow1;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "logotype",
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_5
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "actions",
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty & /*$$scope*/ 4194304) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow1_changes = {};
            if (dirty & /*$$scope*/ 4194304) layoutrow1_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow1.$set(layoutrow1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
        }
    };
}
// (99:3) <LayoutCol class="empty-panel">
function $57883b4a6ea1dcee$var$create_default_slot_2(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "content",
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope*/ 4194304) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
// (95:1) <LayoutCol class="panel-body">
function $57883b4a6ea1dcee$var$create_default_slot_1(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $57883b4a6ea1dcee$var$create_if_block,
        $57883b4a6ea1dcee$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*panelType*/ ctx[4]) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
// (45:0) <LayoutCol class="panel">
function $57883b4a6ea1dcee$var$create_default_slot(ctx) {
    let layoutrow;
    let t;
    let layoutcol;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "tab-bar",
            classes: {
                "min-widths": /*tabMinWidths*/ ctx[0]
            },
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_6
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "panel-body",
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*tabMinWidths*/ 1) layoutrow_changes.classes = {
                "min-widths": /*tabMinWidths*/ ctx[0]
            };
            if (dirty & /*$$scope, tabLabels, tabActiveIndex, tabElements, clickAction, closeAction, tabCloseButtons*/ 4194542) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
            const layoutcol_changes = {};
            if (dirty & /*$$scope, panelType*/ 4194320) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
function $57883b4a6ea1dcee$var$create_fragment(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "panel",
            $$slots: {
                default: [
                    $57883b4a6ea1dcee$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope, panelType, tabMinWidths, tabLabels, tabActiveIndex, tabElements, clickAction, closeAction, tabCloseButtons*/ 4194559) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
const $57883b4a6ea1dcee$var$PANEL_COMPONENTS = {
    Document: $9241e0ea152cacb3$export$2e2bcd8739ae039,
    LayerTree: $9704670796641993$export$2e2bcd8739ae039,
    Properties: $402556087db61ff7$export$2e2bcd8739ae039
};
function $57883b4a6ea1dcee$var$instance($$self, $$props, $$invalidate) {
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    let { tabMinWidths: tabMinWidths = false } = $$props;
    let { tabCloseButtons: tabCloseButtons = false } = $$props;
    let { tabLabels: tabLabels } = $$props;
    let { tabActiveIndex: tabActiveIndex } = $$props;
    let { panelType: panelType } = $$props;
    let { clickAction: clickAction } = $$props;
    let { closeAction: closeAction } = $$props;
    let tabElements = [];
    function platformModifiers(reservedKey) {
        // TODO: Remove this by properly feeding these keys from a layout provided by the backend
        const ALT = {
            key: "Alt",
            label: "Alt"
        };
        const COMMAND = {
            key: "Command",
            label: "Command"
        };
        const CONTROL = {
            key: "Control",
            label: "Ctrl"
        };
        if ((0, $7ed52b8c7c886783$export$f205d53822e9a9a9)()) return reservedKey ? [
            ALT,
            COMMAND
        ] : [
            COMMAND
        ];
        return reservedKey ? [
            CONTROL,
            ALT
        ] : [
            CONTROL
        ];
    }
    async function scrollTabIntoView(newIndex) {
        await (0, $1eb80e36873dc327$export$55d7f61db91b7b70)();
        tabElements[newIndex]?.div()?.scrollIntoView();
    }
    const func = (tabIndex, e)=>{
        e?.stopPropagation();
        closeAction?.(tabIndex);
    };
    function layoutrow_binding($$value, tabIndex) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            tabElements[tabIndex] = $$value;
            $$invalidate(7, tabElements);
        });
    }
    const click_handler = (tabIndex, e)=>{
        e.stopPropagation();
        clickAction?.(tabIndex);
    };
    const auxclick_handler = (tabIndex, e)=>{
        // Middle mouse button click
        if (e.button === 1) {
            e.stopPropagation();
            closeAction?.(tabIndex);
        }
    };
    const mouseup_handler = (tabIndex, e)=>{
        // Fallback for Safari:
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/auxclick_event#browser_compatibility
        // The downside of using mouseup is that the mousedown didn't have to originate in the same element.
        // A possible future improvement could save the target element during mousedown and check if it's the same here.
        if (!(0, $7ed52b8c7c886783$export$83c7bfedfc35d3c2)("auxclick") && e.button === 1) {
            e.stopPropagation();
            closeAction?.(tabIndex);
        }
    };
    const func_1 = ()=>editor.instance.newDocumentDialog();
    const func_2 = ()=>editor.instance.openDocument();
    const func_3 = ()=>editor.instance.demoArtworkDialog();
    $$self.$$set = ($$props)=>{
        if ("tabMinWidths" in $$props) $$invalidate(0, tabMinWidths = $$props.tabMinWidths);
        if ("tabCloseButtons" in $$props) $$invalidate(1, tabCloseButtons = $$props.tabCloseButtons);
        if ("tabLabels" in $$props) $$invalidate(2, tabLabels = $$props.tabLabels);
        if ("tabActiveIndex" in $$props) $$invalidate(3, tabActiveIndex = $$props.tabActiveIndex);
        if ("panelType" in $$props) $$invalidate(4, panelType = $$props.panelType);
        if ("clickAction" in $$props) $$invalidate(5, clickAction = $$props.clickAction);
        if ("closeAction" in $$props) $$invalidate(6, closeAction = $$props.closeAction);
    };
    return [
        tabMinWidths,
        tabCloseButtons,
        tabLabels,
        tabActiveIndex,
        panelType,
        clickAction,
        closeAction,
        tabElements,
        editor,
        platformModifiers,
        scrollTabIntoView,
        func,
        layoutrow_binding,
        click_handler,
        auxclick_handler,
        mouseup_handler,
        func_1,
        func_2,
        func_3
    ];
}
class $57883b4a6ea1dcee$var$Panel extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $57883b4a6ea1dcee$var$instance, $57883b4a6ea1dcee$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            tabMinWidths: 0,
            tabCloseButtons: 1,
            tabLabels: 2,
            tabActiveIndex: 3,
            panelType: 4,
            clickAction: 5,
            closeAction: 6,
            scrollTabIntoView: 10
        });
    }
    get scrollTabIntoView() {
        return this.$$.ctx[10];
    }
}
var $57883b4a6ea1dcee$export$2e2bcd8739ae039 = $57883b4a6ea1dcee$var$Panel;



function $a55f7490e11c7616$var$create_default_slot_6(ctx) {
    let panel;
    let current;
    let panel_props = {
        panelType: /*$portfolio*/ ctx[1].documents.length > 0 ? "Document" : undefined,
        tabCloseButtons: true,
        tabMinWidths: true,
        tabLabels: /*documentTabLabels*/ ctx[3],
        clickAction: /*func*/ ctx[9],
        closeAction: /*func_1*/ ctx[10],
        tabActiveIndex: /*$portfolio*/ ctx[1].activeDocumentIndex
    };
    panel = new (0, $57883b4a6ea1dcee$export$2e2bcd8739ae039)({
        props: panel_props
    });
    /*panel_binding*/ ctx[11](panel);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(panel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(panel, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const panel_changes = {};
            if (dirty & /*$portfolio*/ 2) panel_changes.panelType = /*$portfolio*/ ctx[1].documents.length > 0 ? "Document" : undefined;
            if (dirty & /*documentTabLabels*/ 8) panel_changes.tabLabels = /*documentTabLabels*/ ctx[3];
            if (dirty & /*$portfolio*/ 2) panel_changes.clickAction = /*func*/ ctx[9];
            if (dirty & /*$portfolio*/ 2) panel_changes.closeAction = /*func_1*/ ctx[10];
            if (dirty & /*$portfolio*/ 2) panel_changes.tabActiveIndex = /*$portfolio*/ ctx[1].activeDocumentIndex;
            panel.$set(panel_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(panel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(panel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            /*panel_binding*/ ctx[11](null);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(panel, detaching);
        }
    };
}
// (73:2) <LayoutCol class="workspace-grid-subdivision" styles={{ "flex-grow": panelSizes["content"] }} data-subdivision-name="content">
function $a55f7490e11c7616$var$create_default_slot_5(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-subdivision",
            styles: {
                "flex-grow": /*panelSizes*/ ctx[2]["document"]
            },
            "data-subdivision-name": "document",
            $$slots: {
                default: [
                    $a55f7490e11c7616$var$create_default_slot_6
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*panelSizes*/ 4) layoutrow_changes.styles = {
                "flex-grow": /*panelSizes*/ ctx[2]["document"]
            };
            if (dirty & /*$$scope, $portfolio, documentTabLabels, documentPanel*/ 32779) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
// (89:3) <LayoutRow class="workspace-grid-subdivision" styles={{ "flex-grow": panelSizes["properties"] }} data-subdivision-name="properties">
function $a55f7490e11c7616$var$create_default_slot_4(ctx) {
    let panel;
    let current;
    panel = new (0, $57883b4a6ea1dcee$export$2e2bcd8739ae039)({
        props: {
            panelType: "Properties",
            tabLabels: [
                {
                    name: "Properties"
                }
            ],
            tabActiveIndex: 0
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(panel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(panel, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(panel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(panel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(panel, detaching);
        }
    };
}
// (93:3) <LayoutRow class="workspace-grid-subdivision" styles={{ "flex-grow": panelSizes["layers"] }} data-subdivision-name="layers">
function $a55f7490e11c7616$var$create_default_slot_3(ctx) {
    let panel;
    let current;
    panel = new (0, $57883b4a6ea1dcee$export$2e2bcd8739ae039)({
        props: {
            panelType: "LayerTree",
            tabLabels: [
                {
                    name: "Layers"
                }
            ],
            tabActiveIndex: 0
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(panel.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(panel, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(panel.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(panel.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(panel, detaching);
        }
    };
}
// (88:2) <LayoutCol class="workspace-grid-subdivision" styles={{ "flex-grow": panelSizes["details"] }} data-subdivision-name="details">
function $a55f7490e11c7616$var$create_default_slot_2(ctx) {
    let layoutrow0;
    let t0;
    let layoutrow1;
    let t1;
    let layoutrow2;
    let current;
    layoutrow0 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-subdivision",
            styles: {
                "flex-grow": /*panelSizes*/ ctx[2]["properties"]
            },
            "data-subdivision-name": "properties",
            $$slots: {
                default: [
                    $a55f7490e11c7616$var$create_default_slot_4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutrow1 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-resize-gutter",
            "data-gutter-vertical": true
        }
    });
    layoutrow1.$on("pointerdown", /*pointerdown_handler_1*/ ctx[13]);
    layoutrow2 = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-subdivision",
            styles: {
                "flex-grow": /*panelSizes*/ ctx[2]["layers"]
            },
            "data-subdivision-name": "layers",
            $$slots: {
                default: [
                    $a55f7490e11c7616$var$create_default_slot_3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow2.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow2, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow0_changes = {};
            if (dirty & /*panelSizes*/ 4) layoutrow0_changes.styles = {
                "flex-grow": /*panelSizes*/ ctx[2]["properties"]
            };
            if (dirty & /*$$scope*/ 32768) layoutrow0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow0.$set(layoutrow0_changes);
            const layoutrow2_changes = {};
            if (dirty & /*panelSizes*/ 4) layoutrow2_changes.styles = {
                "flex-grow": /*panelSizes*/ ctx[2]["layers"]
            };
            if (dirty & /*$$scope*/ 32768) layoutrow2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow2.$set(layoutrow2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow2, detaching);
        }
    };
}
// (72:1) <LayoutRow class="workspace-grid-subdivision" styles={{ "flex-grow": panelSizes["root"] }} data-subdivision-name="root">
function $a55f7490e11c7616$var$create_default_slot_1(ctx) {
    let layoutcol0;
    let t0;
    let layoutcol1;
    let t1;
    let layoutcol2;
    let current;
    layoutcol0 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-subdivision",
            styles: {
                "flex-grow": /*panelSizes*/ ctx[2]["content"]
            },
            "data-subdivision-name": "content",
            $$slots: {
                default: [
                    $a55f7490e11c7616$var$create_default_slot_5
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    layoutcol1 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-resize-gutter",
            "data-gutter-horizontal": true
        }
    });
    layoutcol1.$on("pointerdown", /*pointerdown_handler*/ ctx[12]);
    layoutcol2 = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-subdivision",
            styles: {
                "flex-grow": /*panelSizes*/ ctx[2]["details"]
            },
            "data-subdivision-name": "details",
            $$slots: {
                default: [
                    $a55f7490e11c7616$var$create_default_slot_2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol0.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol1.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol2.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol0, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol1, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol2, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutcol0_changes = {};
            if (dirty & /*panelSizes*/ 4) layoutcol0_changes.styles = {
                "flex-grow": /*panelSizes*/ ctx[2]["content"]
            };
            if (dirty & /*$$scope, panelSizes, $portfolio, documentTabLabels, documentPanel*/ 32783) layoutcol0_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol0.$set(layoutcol0_changes);
            const layoutcol2_changes = {};
            if (dirty & /*panelSizes*/ 4) layoutcol2_changes.styles = {
                "flex-grow": /*panelSizes*/ ctx[2]["details"]
            };
            if (dirty & /*$$scope, panelSizes*/ 32772) layoutcol2_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol2.$set(layoutcol2_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol2.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol0.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol1.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol2.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol0, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol1, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol2, detaching);
        }
    };
}
// (98:1) {#if $dialog.visible}
function $a55f7490e11c7616$var$create_if_block(ctx) {
    let dialogmodal;
    let current;
    dialogmodal = new (0, $f2ca0cbe4ea5b85a$export$2e2bcd8739ae039)({});
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(dialogmodal.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(dialogmodal, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(dialogmodal.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(dialogmodal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(dialogmodal, detaching);
        }
    };
}
// (71:0) <LayoutRow class="workspace" data-workspace>
function $a55f7490e11c7616$var$create_default_slot(ctx) {
    let layoutrow;
    let t;
    let if_block_anchor;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "workspace-grid-subdivision",
            styles: {
                "flex-grow": /*panelSizes*/ ctx[2]["root"]
            },
            "data-subdivision-name": "root",
            $$slots: {
                default: [
                    $a55f7490e11c7616$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    let if_block = /*$dialog*/ ctx[4].visible && $a55f7490e11c7616$var$create_if_block(ctx);
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
            t = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t, anchor);
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const layoutrow_changes = {};
            if (dirty & /*panelSizes*/ 4) layoutrow_changes.styles = {
                "flex-grow": /*panelSizes*/ ctx[2]["root"]
            };
            if (dirty & /*$$scope, panelSizes, $portfolio, documentTabLabels, documentPanel*/ 32783) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
            if (/*$dialog*/ ctx[4].visible) {
                if (if_block) {
                    if (dirty & /*$dialog*/ 16) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $a55f7490e11c7616$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t);
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
function $a55f7490e11c7616$var$create_fragment(ctx) {
    let layoutrow;
    let current;
    layoutrow = new (0, $3c849e5e6ea41fd5$export$2e2bcd8739ae039)({
        props: {
            class: "workspace",
            "data-workspace": true,
            $$slots: {
                default: [
                    $a55f7490e11c7616$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutrow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutrow, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutrow_changes = {};
            if (dirty & /*$$scope, $dialog, panelSizes, $portfolio, documentTabLabels, documentPanel*/ 32799) layoutrow_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutrow.$set(layoutrow_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutrow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutrow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutrow, detaching);
        }
    };
}
const $a55f7490e11c7616$var$MIN_PANEL_SIZE = 100;
function $a55f7490e11c7616$var$instance($$self, $$props, $$invalidate) {
    let documentTabLabels;
    let $portfolio;
    let $dialog;
    const PANEL_SIZES = {
        /**/ root: 100,
        /*   ├── */ content: 80,
        /*   │      ├── */ document: 100,
        /*   └── */ details: 20,
        /*          ├── */ properties: 45,
        /*          └── */ layers: 55
    };
    let panelSizes = PANEL_SIZES;
    let documentPanel;
    const editor = (0, $1eb80e36873dc327$export$31553aaa555c1514)("editor");
    const portfolio = (0, $1eb80e36873dc327$export$31553aaa555c1514)("portfolio");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, portfolio, (value)=>$$invalidate(1, $portfolio = value));
    const dialog = (0, $1eb80e36873dc327$export$31553aaa555c1514)("dialog");
    (0, $1eb80e36873dc327$export$e9b69a2eee9b6cbe)($$self, dialog, (value)=>$$invalidate(4, $dialog = value));
    function resizePanel(e) {
        const gutter = e.target || undefined;
        const nextSibling = gutter?.nextElementSibling || undefined;
        const prevSibling = gutter?.previousElementSibling || undefined;
        const parentElement = gutter?.parentElement || undefined;
        const nextSiblingName = nextSibling?.getAttribute("data-subdivision-name") || undefined;
        const prevSiblingName = prevSibling?.getAttribute("data-subdivision-name") || undefined;
        if (!gutter || !nextSibling || !prevSibling || !parentElement || !nextSiblingName || !prevSiblingName) return;
        // Are we resizing horizontally?
        const isHorizontal = gutter.getAttribute("data-gutter-horizontal") !== null;
        // Get the current size in px of the panels being resized and the gutter
        const gutterSize = isHorizontal ? gutter.getBoundingClientRect().width : gutter.getBoundingClientRect().height;
        const nextSiblingSize = isHorizontal ? nextSibling.getBoundingClientRect().width : nextSibling.getBoundingClientRect().height;
        const prevSiblingSize = isHorizontal ? prevSibling.getBoundingClientRect().width : prevSibling.getBoundingClientRect().height;
        const parentElementSize = isHorizontal ? parentElement.getBoundingClientRect().width : parentElement.getBoundingClientRect().height;
        // Measure the resizing panels as a percentage of all sibling panels
        const totalResizingSpaceOccupied = gutterSize + nextSiblingSize + prevSiblingSize;
        const proportionBeingResized = totalResizingSpaceOccupied / parentElementSize;
        // Prevent cursor flicker as mouse temporarily leaves the gutter
        gutter.setPointerCapture(e.pointerId);
        const mouseStart = isHorizontal ? e.clientX : e.clientY;
        const updatePosition = (e)=>{
            const mouseCurrent = isHorizontal ? e.clientX : e.clientY;
            let mouseDelta = mouseStart - mouseCurrent;
            mouseDelta = Math.max(nextSiblingSize + mouseDelta, $a55f7490e11c7616$var$MIN_PANEL_SIZE) - nextSiblingSize;
            mouseDelta = prevSiblingSize - Math.max(prevSiblingSize - mouseDelta, $a55f7490e11c7616$var$MIN_PANEL_SIZE);
            $$invalidate(2, panelSizes[nextSiblingName] = (nextSiblingSize + mouseDelta) / totalResizingSpaceOccupied * proportionBeingResized * 100, panelSizes);
            $$invalidate(2, panelSizes[prevSiblingName] = (prevSiblingSize - mouseDelta) / totalResizingSpaceOccupied * proportionBeingResized * 100, panelSizes);
            window.dispatchEvent(new CustomEvent("resize"));
        };
        const cleanup = (e)=>{
            gutter.releasePointerCapture(e.pointerId);
            document.removeEventListener("pointermove", updatePosition);
            document.removeEventListener("pointerleave", cleanup);
            document.removeEventListener("pointerup", cleanup);
        };
        document.addEventListener("pointermove", updatePosition);
        document.addEventListener("pointerleave", cleanup);
        document.addEventListener("pointerup", cleanup);
    }
    const func = (tabIndex)=>editor.instance.selectDocument($portfolio.documents[tabIndex].id);
    const func_1 = (tabIndex)=>editor.instance.closeDocumentWithConfirmation($portfolio.documents[tabIndex].id);
    function panel_binding($$value) {
        (0, $1eb80e36873dc327$export$de8cb20e97391842)[$$value ? "unshift" : "push"](()=>{
            documentPanel = $$value;
            $$invalidate(0, documentPanel);
        });
    }
    const pointerdown_handler = (e)=>resizePanel(e);
    const pointerdown_handler_1 = (e)=>resizePanel(e);
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*documentPanel, $portfolio*/ 3) $: documentPanel?.scrollTabIntoView($portfolio.activeDocumentIndex);
        if ($$self.$$.dirty & /*$portfolio*/ 2) $: $$invalidate(3, documentTabLabels = $portfolio.documents.map((doc)=>{
            const name = doc.displayName;
            if (!editor.instance.inDevelopmentMode()) return {
                name: name
            };
            const tooltip = `Document ID ${doc.id}`;
            return {
                name: name,
                tooltip: tooltip
            };
        }));
    };
    return [
        documentPanel,
        $portfolio,
        panelSizes,
        documentTabLabels,
        $dialog,
        editor,
        portfolio,
        dialog,
        resizePanel,
        func,
        func_1,
        panel_binding,
        pointerdown_handler,
        pointerdown_handler_1
    ];
}
class $a55f7490e11c7616$var$Workspace extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $a55f7490e11c7616$var$instance, $a55f7490e11c7616$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $a55f7490e11c7616$export$2e2bcd8739ae039 = $a55f7490e11c7616$var$Workspace;


function $3e7c73b43e5eda72$var$create_default_slot(ctx) {
    let titlebar;
    let t0;
    let workspace;
    let t1;
    let statusbar;
    let current;
    titlebar = new (0, $b09475b3b41d5b9f$export$2e2bcd8739ae039)({
        props: {
            platform: $3e7c73b43e5eda72$var$platform,
            maximized: /*maximized*/ ctx[0]
        }
    });
    workspace = new (0, $a55f7490e11c7616$export$2e2bcd8739ae039)({});
    statusbar = new (0, $70425d4c951ba058$export$2e2bcd8739ae039)({});
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(titlebar.$$.fragment);
            t0 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(workspace.$$.fragment);
            t1 = (0, $1eb80e36873dc327$export$a941ed4b947d12f8)();
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(statusbar.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(titlebar, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t0, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(workspace, target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, t1, anchor);
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(statusbar, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(titlebar.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(workspace.$$.fragment, local);
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(statusbar.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(titlebar.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(workspace.$$.fragment, local);
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(statusbar.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(titlebar, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t0);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(workspace, detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(t1);
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(statusbar, detaching);
        }
    };
}
function $3e7c73b43e5eda72$var$create_fragment(ctx) {
    let layoutcol;
    let current;
    layoutcol = new (0, $2cf38967565f222d$export$2e2bcd8739ae039)({
        props: {
            class: "main-window",
            $$slots: {
                default: [
                    $3e7c73b43e5eda72$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(layoutcol.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(layoutcol, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const layoutcol_changes = {};
            if (dirty & /*$$scope*/ 2) layoutcol_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            layoutcol.$set(layoutcol_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(layoutcol.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(layoutcol.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(layoutcol, detaching);
        }
    };
}
let $3e7c73b43e5eda72$var$platform = "Web";
function $3e7c73b43e5eda72$var$instance($$self) {
    let maximized;
    return [
        maximized
    ];
}
class $3e7c73b43e5eda72$var$MainWindow extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $3e7c73b43e5eda72$var$instance, $3e7c73b43e5eda72$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $3e7c73b43e5eda72$export$2e2bcd8739ae039 = $3e7c73b43e5eda72$var$MainWindow;


function $9ac8690d256a9cda$var$create_fragment(ctx) {
    let mainwindow;
    let current;
    mainwindow = new (0, $3e7c73b43e5eda72$export$2e2bcd8739ae039)({});
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(mainwindow.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(mainwindow, target, anchor);
            current = true;
        },
        p: (0, $1eb80e36873dc327$export$8793edee2d425525),
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(mainwindow.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(mainwindow.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(mainwindow, detaching);
        }
    };
}
function $9ac8690d256a9cda$var$instance($$self, $$props, $$invalidate) {
    let { editor: editor } = $$props;
    (0, $1eb80e36873dc327$export$2f04de43fe27971a)("editor", editor);
    // State provider systems
    let dialog = (0, $5a70f91b7dc0dff9$export$3a42832ec1ff7cee)(editor);
    (0, $1eb80e36873dc327$export$2f04de43fe27971a)("dialog", dialog);
    let document = (0, $46c0d35e9a21e6fa$export$cefcfc6f5c5cac45)(editor);
    (0, $1eb80e36873dc327$export$2f04de43fe27971a)("document", document);
    let fonts = (0, $25c843ead59e69eb$export$1ca8f41f0e20cd69)(editor);
    (0, $1eb80e36873dc327$export$2f04de43fe27971a)("fonts", fonts);
    let fullscreen = (0, $919eb2f1f48ef86a$export$325355d6f159c7ef)(editor);
    (0, $1eb80e36873dc327$export$2f04de43fe27971a)("fullscreen", fullscreen);
    let nodeGraph = (0, $9914c471b719ce76$export$47cbb066836108c4)(editor);
    (0, $1eb80e36873dc327$export$2f04de43fe27971a)("nodeGraph", nodeGraph);
    let portfolio = (0, $92656e52d7465e90$export$6385be12e9d49165)(editor);
    (0, $1eb80e36873dc327$export$2f04de43fe27971a)("portfolio", portfolio);
    // Initialize managers, which are isolated systems that subscribe to backend messages to link them to browser API functionality (like JS events, IndexedDB, etc.)
    (0, $5878622efbf463d1$export$a99063a3de5d2240)(editor);
    (0, $dbf29c43aa374ccc$export$61ac97ad36b72342)(editor);
    (0, $17af88b835efbc99$export$2eaa5ea2d1925364)(editor);
    (0, $945a093b2ba443fe$export$a680f9ea2b1b4796)(editor, dialog);
    (0, $ed258b5c0b4a06bc$export$75f5a0288d359bdf)(editor, portfolio);
    let dragManagerDestructor = (0, $b6b56b6b4021e3fb$export$7905c3a9e557239e)();
    let inputManagerDestructor = (0, $98dd458b1b9dd393$export$d3f50ec9ab1089ab)(editor, dialog, portfolio, document, fullscreen);
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(()=>{
        // Initialize certain setup tasks required by the editor backend to be ready for the user now that the frontend is ready
        editor.instance.initAfterFrontendReady((0, $7ed52b8c7c886783$export$2dc6e2a3a552baa5)());
    });
    (0, $1eb80e36873dc327$export$f1238fd06ad9b453)(()=>{
        // Call the destructor for each manager
        dragManagerDestructor();
        inputManagerDestructor();
    });
    $$self.$$set = ($$props)=>{
        if ("editor" in $$props) $$invalidate(0, editor = $$props.editor);
    };
    return [
        editor
    ];
}
class $9ac8690d256a9cda$var$Editor extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $9ac8690d256a9cda$var$instance, $9ac8690d256a9cda$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {
            editor: 0
        });
    }
}
var $9ac8690d256a9cda$export$2e2bcd8739ae039 = $9ac8690d256a9cda$var$Editor;


function $c1e4c1b02d30f3d4$var$create_if_block(ctx) {
    let editor_1;
    let current;
    editor_1 = new (0, $9ac8690d256a9cda$export$2e2bcd8739ae039)({
        props: {
            editor: /*editor*/ ctx[0]
        }
    });
    return {
        c () {
            (0, $1eb80e36873dc327$export$3dac9ce53bfc6012)(editor_1.$$.fragment);
        },
        m (target, anchor) {
            (0, $1eb80e36873dc327$export$18b26e9aca35251)(editor_1, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const editor_1_changes = {};
            if (dirty & /*editor*/ 1) editor_1_changes.editor = /*editor*/ ctx[0];
            editor_1.$set(editor_1_changes);
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(editor_1.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(editor_1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $1eb80e36873dc327$export$ddd2890b29e5aebe)(editor_1, detaching);
        }
    };
}
function $c1e4c1b02d30f3d4$var$create_fragment(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*editor*/ ctx[0] !== undefined && $c1e4c1b02d30f3d4$var$create_if_block(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = (0, $1eb80e36873dc327$export$6e22c362a0406a2c)();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            (0, $1eb80e36873dc327$export$21a5ca8aa77d35ff)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*editor*/ ctx[0] !== undefined) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*editor*/ 1) (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                } else {
                    if_block = $c1e4c1b02d30f3d4$var$create_if_block(ctx);
                    if_block.c();
                    (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                (0, $1eb80e36873dc327$export$b074532eec6b252c)();
                (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                (0, $1eb80e36873dc327$export$e7d251cf909c6ab9)();
            }
        },
        i (local) {
            if (current) return;
            (0, $1eb80e36873dc327$export$9e951caa2db2b1da)(if_block);
            current = true;
        },
        o (local) {
            (0, $1eb80e36873dc327$export$fdd20dba65b2c00e)(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) (0, $1eb80e36873dc327$export$3f780019ff766da6)(if_block_anchor);
        }
    };
}
function $c1e4c1b02d30f3d4$var$instance($$self, $$props, $$invalidate) {
    let editor = undefined;
    (0, $1eb80e36873dc327$export$1e848a9e87980bd5)(async ()=>{
        await (0, $2b6974fc18d331b1$export$3b24329f2e9107b6)();
        $$invalidate(0, editor = (0, $2b6974fc18d331b1$export$eb02d1ee0d3cac30)());
    });
    (0, $1eb80e36873dc327$export$f1238fd06ad9b453)(()=>{
        // Destroy the WASM editor instance
        editor?.instance.free();
    });
    return [
        editor
    ];
}
class $c1e4c1b02d30f3d4$var$App extends (0, $1eb80e36873dc327$export$a9dbe146ce5e8823) {
    constructor(options){
        super();
        (0, $1eb80e36873dc327$export$2cd8252107eb640b)(this, options, $c1e4c1b02d30f3d4$var$instance, $c1e4c1b02d30f3d4$var$create_fragment, (0, $1eb80e36873dc327$export$170eaf694b129a16), {});
    }
}
var $c1e4c1b02d30f3d4$export$2e2bcd8739ae039 = $c1e4c1b02d30f3d4$var$App;


document.body.setAttribute("data-app-container", "");
var $5409e5f466efd2d4$export$2e2bcd8739ae039 = new (0, $c1e4c1b02d30f3d4$export$2e2bcd8739ae039)({
    target: document.body
});


//# sourceMappingURL=index.e2f29232.js.map
